//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ArchivingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    index(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Archiving";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    preview(filters: PreviewFiltersDTO): Promise<ResponseWithValueDTOOfListOfPreviewResultRowDTO> {
        let url_ = this.baseUrl + "/api/Archiving/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: Response): Promise<ResponseWithValueDTOOfListOfPreviewResultRowDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfPreviewResultRowDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfPreviewResultRowDTO>(null as any);
    }

    run(request: RunArchivingDTO): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        let url_ = this.baseUrl + "/api/Archiving/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRun(_response);
        });
    }

    protected processRun(response: Response): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO>(null as any);
    }

    unarchive(request: RunUnarchiveDTO): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        let url_ = this.baseUrl + "/api/Archiving/unarchive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnarchive(_response);
        });
    }

    protected processUnarchive(response: Response): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO>(null as any);
    }

    getActiveJobResults(jobId: number | null | undefined): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        let url_ = this.baseUrl + "/api/Archiving/activeJob/results?";
        if (jobId !== undefined && jobId !== null)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveJobResults(_response);
        });
    }

    protected processGetActiveJobResults(response: Response): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO>(null as any);
    }

    getUndismissedResults(): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        let url_ = this.baseUrl + "/api/Archiving/undismissedResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUndismissedResults(_response);
        });
    }

    protected processGetUndismissedResults(response: Response): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO>(null as any);
    }

    getUndismissedUnarchiveResults(): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        let url_ = this.baseUrl + "/api/Archiving/undismissedUnarchiveResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUndismissedUnarchiveResults(_response);
        });
    }

    protected processGetUndismissedUnarchiveResults(response: Response): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO>(null as any);
    }

    pause(): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Archiving/pause";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPause(_response);
        });
    }

    protected processPause(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    resume(): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Archiving/resume";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResume(_response);
        });
    }

    protected processResume(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    startOver(includeArchivedFiles: boolean | undefined): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Archiving/startOver?";
        if (includeArchivedFiles === null)
            throw new globalThis.Error("The parameter 'includeArchivedFiles' cannot be null.");
        else if (includeArchivedFiles !== undefined)
            url_ += "includeArchivedFiles=" + encodeURIComponent("" + includeArchivedFiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartOver(_response);
        });
    }

    protected processStartOver(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    getNames(): Promise<ResponseWithValueDTOOfListOfString> {
        let url_ = this.baseUrl + "/api/Archiving/names";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNames(_response);
        });
    }

    protected processGetNames(response: Response): Promise<ResponseWithValueDTOOfListOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfString>(null as any);
    }

    getLocation(): Promise<ResponseWithValueDTOOfArchivingLocationDTO> {
        let url_ = this.baseUrl + "/api/Archiving/location";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocation(_response);
        });
    }

    protected processGetLocation(response: Response): Promise<ResponseWithValueDTOOfArchivingLocationDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfArchivingLocationDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfArchivingLocationDTO>(null as any);
    }

    getArchivedTasks(): Promise<ResponseWithValueDTOOfListOfArchivedTaskDTO> {
        let url_ = this.baseUrl + "/api/Archiving/archivedTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArchivedTasks(_response);
        });
    }

    protected processGetArchivedTasks(response: Response): Promise<ResponseWithValueDTOOfListOfArchivedTaskDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfArchivedTaskDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfArchivedTaskDTO>(null as any);
    }

    getArchivedExperiments(jobIds: number[] | null | undefined): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        let url_ = this.baseUrl + "/api/Archiving/archivedExperiments?";
        if (jobIds !== undefined && jobIds !== null)
            jobIds && jobIds.forEach(item => { url_ += "jobIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArchivedExperiments(_response);
        });
    }

    protected processGetArchivedExperiments(response: Response): Promise<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO>(null as any);
    }

    dismissResults(request: DismissArchivingResultsDTO): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Archiving/results/dismiss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDismissResults(_response);
        });
    }

    protected processDismissResults(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }
}

export class AuthenticationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    authenticate(userCred: UserCredentialDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Authentication/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCred);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    refreshToken(refreshUser: AuthenticationDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Authentication/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(refreshUser);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAccessControl(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Authentication/accesscontrol";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccessControl(_response);
        });
    }

    protected processGetAccessControl(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    isAccessControlEnabled(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Authentication/isAccessControlEnabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsAccessControlEnabled(_response);
        });
    }

    protected processIsAccessControlEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isAccessControlInitialized(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Authentication/isAccessControlInitialized";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsAccessControlInitialized(_response);
        });
    }

    protected processIsAccessControlInitialized(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    initializeAccessControl(grantAccessToAll: boolean | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Authentication/initializeAccessControl?";
        if (grantAccessToAll === null)
            throw new globalThis.Error("The parameter 'grantAccessToAll' cannot be null.");
        else if (grantAccessToAll !== undefined)
            url_ += "grantAccessToAll=" + encodeURIComponent("" + grantAccessToAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitializeAccessControl(_response);
        });
    }

    protected processInitializeAccessControl(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    isValidToken(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Authentication/isValidToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsValidToken(_response);
        });
    }

    protected processIsValidToken(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    resetPasswordRequest(username: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Authentication/reset-password?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPasswordRequest(_response);
        });
    }

    protected processResetPasswordRequest(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    forgotPasswordRequest(username: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Authentication/forgot-password?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPasswordRequest(_response);
        });
    }

    protected processForgotPasswordRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    changePasswordRequest(otpDetails: UserOtpDTO): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Authentication/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(otpDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePasswordRequest(_response);
        });
    }

    protected processChangePasswordRequest(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    logout(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Authentication/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class BatchLoadExperimentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    validateInputCsvFile(request: BatchLoadExperimentRequest): Promise<BatchLoadExperimentsDTO> {
        let url_ = this.baseUrl + "/api/BatchLoadExperiment/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateInputCsvFile(_response);
        });
    }

    protected processValidateInputCsvFile(response: Response): Promise<BatchLoadExperimentsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchLoadExperimentsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatchLoadExperimentsDTO>(null as any);
    }

    createBatchLoadExperiments(data: BatchLoadExperimentsData): Promise<BatchloadExperimentInfoDTO> {
        let url_ = this.baseUrl + "/api/BatchLoadExperiment/createbatchloadexperiments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBatchLoadExperiments(_response);
        });
    }

    protected processCreateBatchLoadExperiments(response: Response): Promise<BatchloadExperimentInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchloadExperimentInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatchloadExperimentInfoDTO>(null as any);
    }

    getProteinFormulationList(): Promise<ProteinFormulationDTO[]> {
        let url_ = this.baseUrl + "/api/BatchLoadExperiment/GetProteinFormulationList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinFormulationList(_response);
        });
    }

    protected processGetProteinFormulationList(response: Response): Promise<ProteinFormulationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProteinFormulationDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProteinFormulationDTO[]>(null as any);
    }
}

export class CaptureProfileClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getCaptureProfile(): Promise<CaptureProfileDTO> {
        let url_ = this.baseUrl + "/api/CaptureProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptureProfile(_response);
        });
    }

    protected processGetCaptureProfile(response: Response): Promise<CaptureProfileDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaptureProfileDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaptureProfileDTO>(null as any);
    }

    getAllCaptureProfiles(): Promise<CaptureProfileDTO[]> {
        let url_ = this.baseUrl + "/api/CaptureProfile/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCaptureProfiles(_response);
        });
    }

    protected processGetAllCaptureProfiles(response: Response): Promise<CaptureProfileDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaptureProfileDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaptureProfileDTO[]>(null as any);
    }

    getAllCaptureProfilesWithImageSettings(): Promise<SaveCaptureProfilesDTO> {
        let url_ = this.baseUrl + "/api/CaptureProfile/allImgSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCaptureProfilesWithImageSettings(_response);
        });
    }

    protected processGetAllCaptureProfilesWithImageSettings(response: Response): Promise<SaveCaptureProfilesDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCaptureProfilesDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCaptureProfilesDTO>(null as any);
    }

    saveCaptureProfiles(saveCaptureProfiles: SaveCaptureProfilesDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CaptureProfile/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveCaptureProfiles);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveCaptureProfiles(_response);
        });
    }

    protected processSaveCaptureProfiles(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getRegionCaptureProfilesByRegionID(regionId: number | undefined): Promise<RegionCaptureProfile[]> {
        let url_ = this.baseUrl + "/api/CaptureProfile/getRegionCaptureProfilesByRegionIDAsync?";
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegionCaptureProfilesByRegionID(_response);
        });
    }

    protected processGetRegionCaptureProfilesByRegionID(response: Response): Promise<RegionCaptureProfile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionCaptureProfile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionCaptureProfile[]>(null as any);
    }

    saveRegionCaptureProfiles(saveRegionCaptureProfilesDTO: SaveRegionCaptureProfilesDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CaptureProfile/saveRegionCaptureProfiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveRegionCaptureProfilesDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveRegionCaptureProfiles(_response);
        });
    }

    protected processSaveRegionCaptureProfiles(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateRegionCaptureProfile(dropImageSettingDTOList: DropImageSettingsDTO[]): Promise<RegionCaptureProfileDTO[]> {
        let url_ = this.baseUrl + "/api/CaptureProfile/UpdateRegionCaptureProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dropImageSettingDTOList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRegionCaptureProfile(_response);
        });
    }

    protected processUpdateRegionCaptureProfile(response: Response): Promise<RegionCaptureProfileDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionCaptureProfileDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionCaptureProfileDTO[]>(null as any);
    }

    getCaptureProfileById(cpId: number | undefined): Promise<CaptureProfile> {
        let url_ = this.baseUrl + "/api/CaptureProfile/getcaptureprofile?";
        if (cpId === null)
            throw new globalThis.Error("The parameter 'cpId' cannot be null.");
        else if (cpId !== undefined)
            url_ += "cpId=" + encodeURIComponent("" + cpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptureProfileById(_response);
        });
    }

    protected processGetCaptureProfileById(response: Response): Promise<CaptureProfile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaptureProfile.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaptureProfile>(null as any);
    }

    getIsFrapCaptureProfile(cpId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CaptureProfile/getisfrapcaptureprofile?";
        if (cpId === null)
            throw new globalThis.Error("The parameter 'cpId' cannot be null.");
        else if (cpId !== undefined)
            url_ += "cpId=" + encodeURIComponent("" + cpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIsFrapCaptureProfile(_response);
        });
    }

    protected processGetIsFrapCaptureProfile(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ContainerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getAll(): Promise<SavePlateTypeDTO> {
        let url_ = this.baseUrl + "/api/Container/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SavePlateTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavePlateTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavePlateTypeDTO>(null as any);
    }

    save(savePlateTypeDTO: SavePlateTypeDTO): Promise<SavePlateTypeDTO> {
        let url_ = this.baseUrl + "/api/Container/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(savePlateTypeDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<SavePlateTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavePlateTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavePlateTypeDTO>(null as any);
    }
}

export class CryoprotectantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getAllCryoprotectantsOfCurrentUser(): Promise<CryoDTO[]> {
        let url_ = this.baseUrl + "/api/Cryoprotectant/GetAllCryoprotectantsOfCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCryoprotectantsOfCurrentUser(_response);
        });
    }

    protected processGetAllCryoprotectantsOfCurrentUser(response: Response): Promise<CryoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CryoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CryoDTO[]>(null as any);
    }

    saveCryoprotectants(cryoList: CryoDTO[]): Promise<CryoDTO[]> {
        let url_ = this.baseUrl + "/api/Cryoprotectant/SaveCryoprotectants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cryoList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveCryoprotectants(_response);
        });
    }

    protected processSaveCryoprotectants(response: Response): Promise<CryoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CryoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CryoDTO[]>(null as any);
    }

    deleteCryoprotectants(cryoList: CryoDTO[]): Promise<CryoDTO[]> {
        let url_ = this.baseUrl + "/api/Cryoprotectant/DeleteCryoprotectants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cryoList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCryoprotectants(_response);
        });
    }

    protected processDeleteCryoprotectants(response: Response): Promise<CryoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CryoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CryoDTO[]>(null as any);
    }

    assignCryoToCrystals(crystalCryoList: CrystalCryoDTO[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Cryoprotectant/AssignCryoprotectants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crystalCryoList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignCryoToCrystals(_response);
        });
    }

    protected processAssignCryoToCrystals(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getInUseCryoprotectantsByIds(cryoIds: number[]): Promise<CryoDTO[]> {
        let url_ = this.baseUrl + "/api/Cryoprotectant/GetInUseCryoprotectantsByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cryoIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInUseCryoprotectantsByIds(_response);
        });
    }

    protected processGetInUseCryoprotectantsByIds(response: Response): Promise<CryoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CryoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CryoDTO[]>(null as any);
    }
}

export class CrystalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    save(crystal: CrystalDTO): Promise<CrystalDTO> {
        let url_ = this.baseUrl + "/api/Crystal/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crystal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<CrystalDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrystalDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalDTO>(null as any);
    }

    getCrystal(id: number | undefined): Promise<CrystalDTO> {
        let url_ = this.baseUrl + "/api/Crystal/get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCrystal(_response);
        });
    }

    protected processGetCrystal(response: Response): Promise<CrystalDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrystalDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalDTO>(null as any);
    }

    getCrystalDetails(id: number | undefined): Promise<CrystalDTO> {
        let url_ = this.baseUrl + "/api/Crystal/getcrystaldetails?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCrystalDetails(_response);
        });
    }

    protected processGetCrystalDetails(response: Response): Promise<CrystalDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrystalDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalDTO>(null as any);
    }

    getCrystalImage(id: number | undefined): Promise<CrystalImageDTO> {
        let url_ = this.baseUrl + "/api/Crystal/getcrystalimage?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCrystalImage(_response);
        });
    }

    protected processGetCrystalImage(response: Response): Promise<CrystalImageDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrystalImageDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalImageDTO>(null as any);
    }

    getAllUnassignedCrystals(): Promise<CrystalDTO[]> {
        let url_ = this.baseUrl + "/api/Crystal/getallunassignedcrystals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllUnassignedCrystals(_response);
        });
    }

    protected processGetAllUnassignedCrystals(response: Response): Promise<CrystalDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CrystalDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalDTO[]>(null as any);
    }

    updateCrystal(crystal: CrystalDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/Crystal/updatecrystal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crystal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCrystal(_response);
        });
    }

    protected processUpdateCrystal(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteCrystal(crystalIds: number[]): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Crystal/deletecrystal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crystalIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCrystal(_response);
        });
    }

    protected processDeleteCrystal(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    uploadCrystalAttachments(files: CrystalFilesUploadDTO): Promise<CrystalFilesv4[]> {
        let url_ = this.baseUrl + "/api/Crystal/uploadfiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(files);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadCrystalAttachments(_response);
        });
    }

    protected processUploadCrystalAttachments(response: Response): Promise<CrystalFilesv4[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CrystalFilesv4.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalFilesv4[]>(null as any);
    }

    downloadCrystalAttachment(fileId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Crystal/downloadfile?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadCrystalAttachment(_response);
        });
    }

    protected processDownloadCrystalAttachment(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    toggleCrystalDataCollected(crystalId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Crystal/updatecollected?";
        if (crystalId === null)
            throw new globalThis.Error("The parameter 'crystalId' cannot be null.");
        else if (crystalId !== undefined)
            url_ += "crystalId=" + encodeURIComponent("" + crystalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggleCrystalDataCollected(_response);
        });
    }

    protected processToggleCrystalDataCollected(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    assignCrystalsToTrip(crystalTrips: CrystalTripDTO[]): Promise<ResponseWithValueDTOOfCrystalTripAssignmentResponseDTO> {
        let url_ = this.baseUrl + "/api/Crystal/assignCrystals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crystalTrips);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignCrystalsToTrip(_response);
        });
    }

    protected processAssignCrystalsToTrip(response: Response): Promise<ResponseWithValueDTOOfCrystalTripAssignmentResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfCrystalTripAssignmentResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfCrystalTripAssignmentResponseDTO>(null as any);
    }

    getCrystalTrips(regionId: number | undefined): Promise<CrystalTripDTO[]> {
        let url_ = this.baseUrl + "/api/Crystal/getCrystalTrips?";
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCrystalTrips(_response);
        });
    }

    protected processGetCrystalTrips(response: Response): Promise<CrystalTripDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CrystalTripDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalTripDTO[]>(null as any);
    }

    unAssignCrystal(crystalId: number | undefined): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Crystal/UnAssignCrystals?";
        if (crystalId === null)
            throw new globalThis.Error("The parameter 'crystalId' cannot be null.");
        else if (crystalId !== undefined)
            url_ += "crystalId=" + encodeURIComponent("" + crystalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnAssignCrystal(_response);
        });
    }

    protected processUnAssignCrystal(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    getCrystalPuckDewar(crystalId: number | undefined): Promise<CrystalPuckDewarDTO> {
        let url_ = this.baseUrl + "/api/Crystal/getcrystalpuckdewar?";
        if (crystalId === null)
            throw new globalThis.Error("The parameter 'crystalId' cannot be null.");
        else if (crystalId !== undefined)
            url_ += "crystalId=" + encodeURIComponent("" + crystalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCrystalPuckDewar(_response);
        });
    }

    protected processGetCrystalPuckDewar(response: Response): Promise<CrystalPuckDewarDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrystalPuckDewarDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalPuckDewarDTO>(null as any);
    }

    getCollectedCrystalsByTripId(tripId: number | undefined): Promise<CrystalWithResultDTO[]> {
        let url_ = this.baseUrl + "/api/Crystal/getcollectedcrystals?";
        if (tripId === null)
            throw new globalThis.Error("The parameter 'tripId' cannot be null.");
        else if (tripId !== undefined)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCollectedCrystalsByTripId(_response);
        });
    }

    protected processGetCollectedCrystalsByTripId(response: Response): Promise<CrystalWithResultDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CrystalWithResultDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalWithResultDTO[]>(null as any);
    }

    updateCrystalResult(crystalsWithResultsDTO: CrystalWithResultDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Crystal/updateresult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crystalsWithResultsDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCrystalResult(_response);
        });
    }

    protected processUpdateCrystalResult(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCrystals(regionId: number): Promise<CrystalDTO[]> {
        let url_ = this.baseUrl + "/api/Crystal/crystals/{regionId}";
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCrystals(_response);
        });
    }

    protected processGetCrystals(response: Response): Promise<CrystalDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CrystalDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrystalDTO[]>(null as any);
    }
}

export class CrystalTrakClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    importIngredients(): Promise<number> {
        let url_ = this.baseUrl + "/api/CrystalTrak/importingredients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportIngredients(_response);
        });
    }

    protected processImportIngredients(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DewarClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getAllDewars(): Promise<DewarDTO[]> {
        let url_ = this.baseUrl + "/api/Dewar/getall";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDewars(_response);
        });
    }

    protected processGetAllDewars(response: Response): Promise<DewarDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DewarDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DewarDTO[]>(null as any);
    }

    getDewarById(id: number): Promise<DewarDTO> {
        let url_ = this.baseUrl + "/api/Dewar/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDewarById(_response);
        });
    }

    protected processGetDewarById(response: Response): Promise<DewarDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DewarDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DewarDTO>(null as any);
    }

    createDewar(dewarList: DewarDTO[]): Promise<Dewarv4[]> {
        let url_ = this.baseUrl + "/api/Dewar/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dewarList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDewar(_response);
        });
    }

    protected processCreateDewar(response: Response): Promise<Dewarv4[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dewarv4.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Dewarv4[]>(null as any);
    }

    updateDewar(dewarList: DewarDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Dewar/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dewarList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDewar(_response);
        });
    }

    protected processUpdateDewar(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteDewar(ids: number[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Dewar/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDewar(_response);
        });
    }

    protected processDeleteDewar(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    save(saveData: SaveDewarDTO): Promise<Dewarv4[]> {
        let url_ = this.baseUrl + "/api/Dewar/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<Dewarv4[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dewarv4.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Dewarv4[]>(null as any);
    }
}

export class DropsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getDropScoresByDropIds(ids: number[]): Promise<ScoresOfWellDropsDTO[]> {
        let url_ = this.baseUrl + "/api/Drops/scores2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDropScoresByDropIds(_response);
        });
    }

    protected processGetDropScoresByDropIds(response: Response): Promise<ScoresOfWellDropsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoresOfWellDropsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoresOfWellDropsDTO[]>(null as any);
    }
}

export class ExperimentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getExperiment(id: number, initiatePreemptiveCache: boolean | null | undefined): Promise<ExperimentDTO> {
        let url_ = this.baseUrl + "/api/Experiment/exp/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (initiatePreemptiveCache !== undefined && initiatePreemptiveCache !== null)
            url_ += "initiatePreemptiveCache=" + encodeURIComponent("" + initiatePreemptiveCache) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperiment(_response);
        });
    }

    protected processGetExperiment(response: Response): Promise<ExperimentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperimentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentDTO>(null as any);
    }

    getImagingSchedule(expId: number): Promise<ExperimentInfoImagingScheduleDTO> {
        let url_ = this.baseUrl + "/api/Experiment/schedule/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImagingSchedule(_response);
        });
    }

    protected processGetImagingSchedule(response: Response): Promise<ExperimentInfoImagingScheduleDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperimentInfoImagingScheduleDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentInfoImagingScheduleDTO>(null as any);
    }

    getLayers(expId: number): Promise<LayerDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/layers/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLayers(_response);
        });
    }

    protected processGetLayers(response: Response): Promise<LayerDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LayerDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LayerDTO[]>(null as any);
    }

    getExperimentLayers(expIds: number[]): Promise<ExpListLayerDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/layers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(expIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentLayers(_response);
        });
    }

    protected processGetExperimentLayers(response: Response): Promise<ExpListLayerDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpListLayerDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpListLayerDTO[]>(null as any);
    }

    getExperimentInfo(expId: number): Promise<ExperimentInfoDTO> {
        let url_ = this.baseUrl + "/api/Experiment/expinfo/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentInfo(_response);
        });
    }

    protected processGetExperimentInfo(response: Response): Promise<ExperimentInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperimentInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentInfoDTO>(null as any);
    }

    getExperimentInfoByTreeNodeId(treeNodeId: number): Promise<ExperimentInfoDTO> {
        let url_ = this.baseUrl + "/api/Experiment/expinfonode/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentInfoByTreeNodeId(_response);
        });
    }

    protected processGetExperimentInfoByTreeNodeId(response: Response): Promise<ExperimentInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperimentInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentInfoDTO>(null as any);
    }

    createScreenExperiment(createExperimentDTO: CreateExperimentDTO): Promise<TreeNodeDTO> {
        let url_ = this.baseUrl + "/api/Experiment/CreateScreenExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createExperimentDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateScreenExperiment(_response);
        });
    }

    protected processCreateScreenExperiment(response: Response): Promise<TreeNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeDTO>(null as any);
    }

    saveDesignCanvas(urlData: SaveDesignCanvasDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Experiment/savedesigncanvas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(urlData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveDesignCanvas(_response);
        });
    }

    protected processSaveDesignCanvas(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveExperiment(saveCommand: SaveExperimentDTO): Promise<SaveExperimentResponseDTO> {
        let url_ = this.baseUrl + "/api/Experiment/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveExperiment(_response);
        });
    }

    protected processSaveExperiment(response: Response): Promise<SaveExperimentResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveExperimentResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveExperimentResponseDTO>(null as any);
    }

    saveExperimentInfo(experimentInfo: ExperimentInfoDTO): Promise<UpdatedExperimentInfo> {
        let url_ = this.baseUrl + "/api/Experiment/saveexpinfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(experimentInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveExperimentInfo(_response);
        });
    }

    protected processSaveExperimentInfo(response: Response): Promise<UpdatedExperimentInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatedExperimentInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatedExperimentInfo>(null as any);
    }

    saveTuningInfo(tuningValuesVM: ExperimentTuningValuesDTO): Promise<ExperimentTuningValuesDTO> {
        let url_ = this.baseUrl + "/api/Experiment/savetuninginfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tuningValuesVM);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveTuningInfo(_response);
        });
    }

    protected processSaveTuningInfo(response: Response): Promise<ExperimentTuningValuesDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperimentTuningValuesDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentTuningValuesDTO>(null as any);
    }

    deleteTuningInfo(tuningValuesVM: ExperimentTuningValuesDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/Experiment/deletetuninginfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tuningValuesVM);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTuningInfo(_response);
        });
    }

    protected processDeleteTuningInfo(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getLayerDetails(expId: number): Promise<LayerDetailsDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/layerdetails/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLayerDetails(_response);
        });
    }

    protected processGetLayerDetails(response: Response): Promise<LayerDetailsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LayerDetailsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LayerDetailsDTO[]>(null as any);
    }

    getScreenLayerDetails(screenLotId: number): Promise<ScreenLotDTO> {
        let url_ = this.baseUrl + "/api/Experiment/screenlotdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(screenLotId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenLayerDetails(_response);
        });
    }

    protected processGetScreenLayerDetails(response: Response): Promise<ScreenLotDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScreenLotDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScreenLotDTO>(null as any);
    }

    saveWizardExperiment(expDto: SaveNonPersistedExpDTO): Promise<ResponseWithValueDTOOfNullableLong> {
        let url_ = this.baseUrl + "/api/Experiment/saveWizardExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(expDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveWizardExperiment(_response);
        });
    }

    protected processSaveWizardExperiment(response: Response): Promise<ResponseWithValueDTOOfNullableLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfNullableLong.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfNullableLong>(null as any);
    }

    createDefaultUnsavedExperiment(expInput: CreateDefaultExpDTO): Promise<ExperimentDTO> {
        let url_ = this.baseUrl + "/api/Experiment/createDefaultUnsavedExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(expInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDefaultUnsavedExperiment(_response);
        });
    }

    protected processCreateDefaultUnsavedExperiment(response: Response): Promise<ExperimentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperimentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentDTO>(null as any);
    }

    getExperimentContainerId(expId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Experiment/defaultExperimentId/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentContainerId(_response);
        });
    }

    protected processGetExperimentContainerId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getXMLScreenRawData(expId: number): Promise<XMLScreenDataDTO> {
        let url_ = this.baseUrl + "/api/Experiment/getxmlscreenrawdata/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetXMLScreenRawData(_response);
        });
    }

    protected processGetXMLScreenRawData(response: Response): Promise<XMLScreenDataDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = XMLScreenDataDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<XMLScreenDataDTO>(null as any);
    }

    getXMLScreenFileData(expId: number): Promise<FileResultDto> {
        let url_ = this.baseUrl + "/api/Experiment/getxmlscreenfiledata/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetXMLScreenFileData(_response);
        });
    }

    protected processGetXMLScreenFileData(response: Response): Promise<FileResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResultDto>(null as any);
    }

    getSetupTemperatures(): Promise<SetupTemperatureDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/getSetupTemperatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSetupTemperatures(_response);
        });
    }

    protected processGetSetupTemperatures(response: Response): Promise<SetupTemperatureDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SetupTemperatureDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetupTemperatureDTO[]>(null as any);
    }

    isTemperatureInUse(setupIds: number[], type: TemperatureType | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Experiment/isSetupTempInUse?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsTemperatureInUse(_response);
        });
    }

    protected processIsTemperatureInUse(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getIncubationTemperatures(): Promise<IncubationTemperatureDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/getIncubationTemperatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIncubationTemperatures(_response);
        });
    }

    protected processGetIncubationTemperatures(response: Response): Promise<IncubationTemperatureDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncubationTemperatureDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncubationTemperatureDTO[]>(null as any);
    }

    parseXmlFile(base64String: string, shouldUseUnsedStock: boolean | null | undefined): Promise<XmlScreenImportResultDto> {
        let url_ = this.baseUrl + "/api/Experiment/parsexmlfile?";
        if (shouldUseUnsedStock !== undefined && shouldUseUnsedStock !== null)
            url_ += "shouldUseUnsedStock=" + encodeURIComponent("" + shouldUseUnsedStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64String);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processParseXmlFile(_response);
        });
    }

    protected processParseXmlFile(response: Response): Promise<XmlScreenImportResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = XmlScreenImportResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<XmlScreenImportResultDto>(null as any);
    }

    getSelectedWellsTextFileData(wellIds: number[] | null | undefined, expId: number | undefined, plateIds: number[] | null | undefined): Promise<FileResultDto> {
        let url_ = this.baseUrl + "/api/Experiment?";
        if (wellIds !== undefined && wellIds !== null)
            wellIds && wellIds.forEach(item => { url_ += "wellIds=" + encodeURIComponent("" + item) + "&"; });
        if (expId === null)
            throw new globalThis.Error("The parameter 'expId' cannot be null.");
        else if (expId !== undefined)
            url_ += "expId=" + encodeURIComponent("" + expId) + "&";
        if (plateIds !== undefined && plateIds !== null)
            plateIds && plateIds.forEach(item => { url_ += "plateIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSelectedWellsTextFileData(_response);
        });
    }

    protected processGetSelectedWellsTextFileData(response: Response): Promise<FileResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResultDto>(null as any);
    }

    parseTextScreenFile(base64String: string): Promise<ConditionDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/parsetextscreenfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64String);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processParseTextScreenFile(_response);
        });
    }

    protected processParseTextScreenFile(response: Response): Promise<ConditionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConditionDTO[]>(null as any);
    }

    getImagingSettings(plateId: number | undefined, dropNumber: number | undefined, wellNumber: number | undefined, region: string | null | undefined, imageBatchId: number | undefined, captureProfileId: number | undefined): Promise<CapturePropertyDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/imageSettings?";
        if (plateId === null)
            throw new globalThis.Error("The parameter 'plateId' cannot be null.");
        else if (plateId !== undefined)
            url_ += "plateId=" + encodeURIComponent("" + plateId) + "&";
        if (dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' cannot be null.");
        else if (dropNumber !== undefined)
            url_ += "dropNumber=" + encodeURIComponent("" + dropNumber) + "&";
        if (wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' cannot be null.");
        else if (wellNumber !== undefined)
            url_ += "wellNumber=" + encodeURIComponent("" + wellNumber) + "&";
        if (region !== undefined && region !== null)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' cannot be null.");
        else if (imageBatchId !== undefined)
            url_ += "imageBatchId=" + encodeURIComponent("" + imageBatchId) + "&";
        if (captureProfileId === null)
            throw new globalThis.Error("The parameter 'captureProfileId' cannot be null.");
        else if (captureProfileId !== undefined)
            url_ += "captureProfileId=" + encodeURIComponent("" + captureProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImagingSettings(_response);
        });
    }

    protected processGetImagingSettings(response: Response): Promise<CapturePropertyDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CapturePropertyDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CapturePropertyDTO[]>(null as any);
    }

    markExperimentAsDispensed(experimentId: number): Promise<AlertDTO> {
        let url_ = this.baseUrl + "/api/Experiment/markExperimentAsDispensed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(experimentId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkExperimentAsDispensed(_response);
        });
    }

    protected processMarkExperimentAsDispensed(response: Response): Promise<AlertDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertDTO>(null as any);
    }

    markExperimentPlatesAsDispensed(plateIds: number[]): Promise<AlertDTO> {
        let url_ = this.baseUrl + "/api/Experiment/markExperimentPlatesAsDispensed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plateIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkExperimentPlatesAsDispensed(_response);
        });
    }

    protected processMarkExperimentPlatesAsDispensed(response: Response): Promise<AlertDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertDTO>(null as any);
    }

    getAllPlatesAtImagerStatus(experimentId: number): Promise<PlateAtImagerResponseDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/getAllPlatesAtImagerStatus/{experimentId}";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPlatesAtImagerStatus(_response);
        });
    }

    protected processGetAllPlatesAtImagerStatus(response: Response): Promise<PlateAtImagerResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlateAtImagerResponseDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateAtImagerResponseDTO[]>(null as any);
    }

    getExperimentsTotalImagesCount(experimentIds: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/Experiment/getExperimentsTotalImagesCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(experimentIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentsTotalImagesCount(_response);
        });
    }

    protected processGetExperimentsTotalImagesCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getExperimentPlateHitScores(expId: number): Promise<ScoresOfWellDropsDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/getExperimentPlateHitScores/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentPlateHitScores(_response);
        });
    }

    protected processGetExperimentPlateHitScores(response: Response): Promise<ScoresOfWellDropsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoresOfWellDropsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoresOfWellDropsDTO[]>(null as any);
    }

    getAllScoresOfExperimentPlateWiseByExpId(expId: number): Promise<AllPlatesScoreDTO> {
        let url_ = this.baseUrl + "/api/Experiment/GetAllScoresOfExperimentPlateWiseByExpId/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllScoresOfExperimentPlateWiseByExpId(_response);
        });
    }

    protected processGetAllScoresOfExperimentPlateWiseByExpId(response: Response): Promise<AllPlatesScoreDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllPlatesScoreDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllPlatesScoreDTO>(null as any);
    }

    getXMLExperimentFileData(expId: number, plateIds: number[] | null | undefined): Promise<FileResultDto> {
        let url_ = this.baseUrl + "/api/Experiment/getxmlexperimentfiledata/{expId}?";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        if (plateIds !== undefined && plateIds !== null)
            plateIds && plateIds.forEach(item => { url_ += "plateIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetXMLExperimentFileData(_response);
        });
    }

    protected processGetXMLExperimentFileData(response: Response): Promise<FileResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResultDto>(null as any);
    }

    repairScreenExperiments(screenRepairInfoDTO: ScreenRepairInfoDTO): Promise<ScreenRepairUpdateExpInfo> {
        let url_ = this.baseUrl + "/api/Experiment/RepairScreenExperiments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(screenRepairInfoDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRepairScreenExperiments(_response);
        });
    }

    protected processRepairScreenExperiments(response: Response): Promise<ScreenRepairUpdateExpInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScreenRepairUpdateExpInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScreenRepairUpdateExpInfo>(null as any);
    }

    setExperimentImaging(expId: number | undefined, imagingEnabled: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Experiment/setexperimentimaging?";
        if (expId === null)
            throw new globalThis.Error("The parameter 'expId' cannot be null.");
        else if (expId !== undefined)
            url_ += "expId=" + encodeURIComponent("" + expId) + "&";
        if (imagingEnabled === null)
            throw new globalThis.Error("The parameter 'imagingEnabled' cannot be null.");
        else if (imagingEnabled !== undefined)
            url_ += "imagingEnabled=" + encodeURIComponent("" + imagingEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetExperimentImaging(_response);
        });
    }

    protected processSetExperimentImaging(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getExperimentTuningValues(expId: number): Promise<ExperimentTuningValuesDTO[]> {
        let url_ = this.baseUrl + "/api/Experiment/getExperimentTuningValues/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentTuningValues(_response);
        });
    }

    protected processGetExperimentTuningValues(response: Response): Promise<ExperimentTuningValuesDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExperimentTuningValuesDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentTuningValuesDTO[]>(null as any);
    }

    markExperimentAsNotSeen(expIds: number[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Experiment/markExperimentAsNotSeen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(expIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkExperimentAsNotSeen(_response);
        });
    }

    protected processMarkExperimentAsNotSeen(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPlateDefaultImagingScheduleId(containerId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Experiment/getPlateDefaultImagingScheduleId/{containerId}";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateDefaultImagingScheduleId(_response);
        });
    }

    protected processGetPlateDefaultImagingScheduleId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveBulkImagingSchedule(bulkImagingSchedules: BulkSaveImagingScheduleDTO[]): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Experiment/saveBulkImagingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkImagingSchedules);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBulkImagingSchedule(_response);
        });
    }

    protected processSaveBulkImagingSchedule(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getMaxDropNumberByNodeIds(nodeIds: number[] | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Experiment/get-max-drop-number-by-node-ids?";
        if (nodeIds !== undefined && nodeIds !== null)
            nodeIds && nodeIds.forEach(item => { url_ += "nodeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMaxDropNumberByNodeIds(_response);
        });
    }

    protected processGetMaxDropNumberByNodeIds(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class FluidigmImagingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    import(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/FluidigmImaging/import";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class FragmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getFragmentScreenView(fragmentScreenId: number): Promise<FragmentScreenViewItemsDTO> {
        let url_ = this.baseUrl + "/api/Fragment/GetFragmentScreenView/{fragmentScreenId}";
        if (fragmentScreenId === undefined || fragmentScreenId === null)
            throw new globalThis.Error("The parameter 'fragmentScreenId' must be defined.");
        url_ = url_.replace("{fragmentScreenId}", encodeURIComponent("" + fragmentScreenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFragmentScreenView(_response);
        });
    }

    protected processGetFragmentScreenView(response: Response): Promise<FragmentScreenViewItemsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FragmentScreenViewItemsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FragmentScreenViewItemsDTO>(null as any);
    }

    createFragmentScreen(createFragmentScreenDTO: FragmentScreenDTO): Promise<FragmentScreenDTO> {
        let url_ = this.baseUrl + "/api/Fragment/CreateFragmentScreen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFragmentScreenDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFragmentScreen(_response);
        });
    }

    protected processCreateFragmentScreen(response: Response): Promise<FragmentScreenDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FragmentScreenDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FragmentScreenDTO>(null as any);
    }

    save(saveFragmentScreenViewDTO: SaveFragmentScreenViewDTO): Promise<SaveFragmentScreenViewResultDTO> {
        let url_ = this.baseUrl + "/api/Fragment/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveFragmentScreenViewDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<SaveFragmentScreenViewResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveFragmentScreenViewResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveFragmentScreenViewResultDTO>(null as any);
    }

    getFragmentScreenCount(fragmentScreenId: number): Promise<FragmentScreenTreeNodeInfoDTO> {
        let url_ = this.baseUrl + "/api/Fragment/GetFragmentScreenCount/{fragmentScreenId}";
        if (fragmentScreenId === undefined || fragmentScreenId === null)
            throw new globalThis.Error("The parameter 'fragmentScreenId' must be defined.");
        url_ = url_.replace("{fragmentScreenId}", encodeURIComponent("" + fragmentScreenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFragmentScreenCount(_response);
        });
    }

    protected processGetFragmentScreenCount(response: Response): Promise<FragmentScreenTreeNodeInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FragmentScreenTreeNodeInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FragmentScreenTreeNodeInfoDTO>(null as any);
    }

    getFragmentInfo(ids: FragmentFragmentScreenDTO[]): Promise<FragmentScreenViewDTO[]> {
        let url_ = this.baseUrl + "/api/Fragment/GetFragmentInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFragmentInfo(_response);
        });
    }

    protected processGetFragmentInfo(response: Response): Promise<FragmentScreenViewDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FragmentScreenViewDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FragmentScreenViewDTO[]>(null as any);
    }

    getFragmentScreen(id: number): Promise<FragmentScreen> {
        let url_ = this.baseUrl + "/api/Fragment/fragmentScreen/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFragmentScreen(_response);
        });
    }

    protected processGetFragmentScreen(response: Response): Promise<FragmentScreen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FragmentScreen.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FragmentScreen>(null as any);
    }
}

export class GeneralSetupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    saveGeneralSetupSettings(generalSetup: GeneralSetupDTO): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/GeneralSetup/savegeneralsetupsettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(generalSetup);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveGeneralSetupSettings(_response);
        });
    }

    protected processSaveGeneralSetupSettings(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    getSendStatisticsOptionStatus(): Promise<BooleanPropertyDTO> {
        let url_ = this.baseUrl + "/api/GeneralSetup/getsendstatisticsoptionstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSendStatisticsOptionStatus(_response);
        });
    }

    protected processGetSendStatisticsOptionStatus(response: Response): Promise<BooleanPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanPropertyDTO>(null as any);
    }

    getImageStoresInfo(defaultOnly: boolean | undefined): Promise<ImageStoreDTO[]> {
        let url_ = this.baseUrl + "/api/GeneralSetup/getimagestoresinfo?";
        if (defaultOnly === null)
            throw new globalThis.Error("The parameter 'defaultOnly' cannot be null.");
        else if (defaultOnly !== undefined)
            url_ += "defaultOnly=" + encodeURIComponent("" + defaultOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImageStoresInfo(_response);
        });
    }

    protected processGetImageStoresInfo(response: Response): Promise<ImageStoreDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageStoreDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageStoreDTO[]>(null as any);
    }

    getImageStoreLayouts(): Promise<ImageStoreLayoutDTO[]> {
        let url_ = this.baseUrl + "/api/GeneralSetup/getimagestorelayouts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImageStoreLayouts(_response);
        });
    }

    protected processGetImageStoreLayouts(response: Response): Promise<ImageStoreLayoutDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageStoreLayoutDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageStoreLayoutDTO[]>(null as any);
    }

    isImageStoreInUseByImageManagement(imageStoreId: number | undefined): Promise<BooleanPropertyDTO> {
        let url_ = this.baseUrl + "/api/GeneralSetup/isImageStoreInUseByImageManagement?";
        if (imageStoreId === null)
            throw new globalThis.Error("The parameter 'imageStoreId' cannot be null.");
        else if (imageStoreId !== undefined)
            url_ += "imageStoreId=" + encodeURIComponent("" + imageStoreId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsImageStoreInUseByImageManagement(_response);
        });
    }

    protected processIsImageStoreInUseByImageManagement(response: Response): Promise<BooleanPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanPropertyDTO>(null as any);
    }

    isImageStoreInUseByImage(imageStoreId: number | undefined): Promise<BooleanPropertyDTO> {
        let url_ = this.baseUrl + "/api/GeneralSetup/isImageStoreInUseByImage?";
        if (imageStoreId === null)
            throw new globalThis.Error("The parameter 'imageStoreId' cannot be null.");
        else if (imageStoreId !== undefined)
            url_ += "imageStoreId=" + encodeURIComponent("" + imageStoreId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsImageStoreInUseByImage(_response);
        });
    }

    protected processIsImageStoreInUseByImage(response: Response): Promise<BooleanPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanPropertyDTO>(null as any);
    }
}

export class GlobalDataVersioningClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getGlobalDataVersion(): Promise<GlobalDataVersionDTO> {
        let url_ = this.baseUrl + "/api/GlobalDataVersioning/GlobalDataVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGlobalDataVersion(_response);
        });
    }

    protected processGetGlobalDataVersion(response: Response): Promise<GlobalDataVersionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalDataVersionDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalDataVersionDTO>(null as any);
    }
}

export class GlobalPreferencesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getAllPropNames(currentPreference: string | null | undefined, groupId: number | undefined): Promise<BasePropertyDTO[]> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/getPropNames?";
        if (currentPreference !== undefined && currentPreference !== null)
            url_ += "currentPreference=" + encodeURIComponent("" + currentPreference) + "&";
        if (groupId === null)
            throw new globalThis.Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPropNames(_response);
        });
    }

    protected processGetAllPropNames(response: Response): Promise<BasePropertyDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasePropertyDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasePropertyDTO[]>(null as any);
    }

    getPropertiesByName(name: string): Promise<EnumElementDTO[]> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/getpropertiesbyname/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPropertiesByName(_response);
        });
    }

    protected processGetPropertiesByName(response: Response): Promise<EnumElementDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumElementDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumElementDTO[]>(null as any);
    }

    save(preferenes: PreferenesDTO, groupId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/save?";
        if (groupId === null)
            throw new globalThis.Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preferenes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    get(name: string): Promise<BasePropertyDTO> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/get/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<BasePropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasePropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasePropertyDTO>(null as any);
    }

    getProperties(names: string[] | null | undefined): Promise<BasePropertyDTO[]> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/getProperties?";
        if (names !== undefined && names !== null)
            names && names.forEach(item => { url_ += "names=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProperties(_response);
        });
    }

    protected processGetProperties(response: Response): Promise<BasePropertyDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasePropertyDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasePropertyDTO[]>(null as any);
    }

    getUserProperty(name: string): Promise<BasePropertyDTO> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/getUserProperty/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserProperty(_response);
        });
    }

    protected processGetUserProperty(response: Response): Promise<BasePropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasePropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasePropertyDTO>(null as any);
    }

    getExpDriverProperties(containerId: number | undefined, expId: number | undefined): Promise<ExperimentDispensingPropertiesDTO> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/getexpdriverprops?";
        if (containerId === null)
            throw new globalThis.Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "containerId=" + encodeURIComponent("" + containerId) + "&";
        if (expId === null)
            throw new globalThis.Error("The parameter 'expId' cannot be null.");
        else if (expId !== undefined)
            url_ += "expId=" + encodeURIComponent("" + expId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpDriverProperties(_response);
        });
    }

    protected processGetExpDriverProperties(response: Response): Promise<ExperimentDispensingPropertiesDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperimentDispensingPropertiesDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentDispensingPropertiesDTO>(null as any);
    }

    getDispensingProperties(): Promise<DispensingPropertiesDTO> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/getdispensingprops";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDispensingProperties(_response);
        });
    }

    protected processGetDispensingProperties(response: Response): Promise<DispensingPropertiesDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DispensingPropertiesDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DispensingPropertiesDTO>(null as any);
    }

    saveGeneralDispensingProperties(generalDispensingPropsToSave: DispensingPropertiesDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/saveGeneralDispensingProps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(generalDispensingPropsToSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveGeneralDispensingProperties(_response);
        });
    }

    protected processSaveGeneralDispensingProperties(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getUserGroupAdminStatus(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/getUserGroupAdminStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGroupAdminStatus(_response);
        });
    }

    protected processGetUserGroupAdminStatus(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    checkMotherPlateScoringEnabled(expId: number | undefined): Promise<{ [key: string]: boolean; }> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/getAllMotherPlatesScoringStatuses?";
        if (expId === null)
            throw new globalThis.Error("The parameter 'expId' cannot be null.");
        else if (expId !== undefined)
            url_ += "expId=" + encodeURIComponent("" + expId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckMotherPlateScoringEnabled(_response);
        });
    }

    protected processCheckMotherPlateScoringEnabled(response: Response): Promise<{ [key: string]: boolean; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: boolean; }>(null as any);
    }

    resetPreferences(tag: string, groupId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/GlobalPreferences/resetPreferences/{groupId}/{tag}";
        if (tag === undefined || tag === null)
            throw new globalThis.Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPreferences(_response);
        });
    }

    protected processResetPreferences(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class GroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    index(): Promise<GroupDTO[]> {
        let url_ = this.baseUrl + "/api/Group";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<GroupDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupDTO[]>(null as any);
    }
}

export class HomeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getVersion(): Promise<string> {
        let url_ = this.baseUrl + "/api/Home/getversion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getAppInfo(): Promise<AppInfoDTO> {
        let url_ = this.baseUrl + "/api/Home/getappinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppInfo(_response);
        });
    }

    protected processGetAppInfo(response: Response): Promise<AppInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppInfoDTO>(null as any);
    }

    getExpGlobalData(): Promise<ExpGlobalDataDTO> {
        let url_ = this.baseUrl + "/api/Home/gdata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpGlobalData(_response);
        });
    }

    protected processGetExpGlobalData(response: Response): Promise<ExpGlobalDataDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpGlobalDataDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpGlobalDataDTO>(null as any);
    }

    getExpGlobalComparisonData(req: GlobalDataComparisonRequestDTO): Promise<ExpGlobalDataDTO> {
        let url_ = this.baseUrl + "/api/Home/gdatacomparison";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpGlobalComparisonData(_response);
        });
    }

    protected processGetExpGlobalComparisonData(response: Response): Promise<ExpGlobalDataDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpGlobalDataDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpGlobalDataDTO>(null as any);
    }

    checkForUpdate(): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Home/checkforupdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckForUpdate(_response);
        });
    }

    protected processCheckForUpdate(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    getReleaseNotes(url: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Home/releasenotes?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReleaseNotes(_response);
        });
    }

    protected processGetReleaseNotes(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateGlobalDataStoreVersion(storeNames: string[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Home/updateglobaldatastoreversion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeNames);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGlobalDataStoreVersion(_response);
        });
    }

    protected processUpdateGlobalDataStoreVersion(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ImageManagementTaskClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getAllImageManagementTasks(): Promise<ImageManagementTaskDTO[]> {
        let url_ = this.baseUrl + "/api/ImageManagementTask/getAllImageManagementTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllImageManagementTasks(_response);
        });
    }

    protected processGetAllImageManagementTasks(response: Response): Promise<ImageManagementTaskDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageManagementTaskDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageManagementTaskDTO[]>(null as any);
    }

    addTask(request: ImageManagementTaskDTO): Promise<ImageManagementTaskDTO> {
        let url_ = this.baseUrl + "/api/ImageManagementTask/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddTask(_response);
        });
    }

    protected processAddTask(response: Response): Promise<ImageManagementTaskDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageManagementTaskDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageManagementTaskDTO>(null as any);
    }

    deleteTasks(deletedId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ImageManagementTask/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deletedId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTasks(_response);
        });
    }

    protected processDeleteTasks(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    saveImageManagementTask(request: SaveImageTaskDTO): Promise<ImageManagementTaskDTO[]> {
        let url_ = this.baseUrl + "/api/ImageManagementTask/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveImageManagementTask(_response);
        });
    }

    protected processSaveImageManagementTask(response: Response): Promise<ImageManagementTaskDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageManagementTaskDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageManagementTaskDTO[]>(null as any);
    }

    startImageManagementTask(request: ImageManagementTaskDTO, disableProgress: boolean | undefined): Promise<ImageManagementResultDTO[]> {
        let url_ = this.baseUrl + "/api/ImageManagementTask/start?";
        if (disableProgress === null)
            throw new globalThis.Error("The parameter 'disableProgress' cannot be null.");
        else if (disableProgress !== undefined)
            url_ += "disableProgress=" + encodeURIComponent("" + disableProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartImageManagementTask(_response);
        });
    }

    protected processStartImageManagementTask(response: Response): Promise<ImageManagementResultDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageManagementResultDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageManagementResultDTO[]>(null as any);
    }

    stopImageManagementTask(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ImageManagementTask/stop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStopImageManagementTask(_response);
        });
    }

    protected processStopImageManagementTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getViewLogsFile(id: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ImageManagementTask/getViewLogsFile/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetViewLogsFile(_response);
        });
    }

    protected processGetViewLogsFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ImageNowClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    setImageNow(imageNowRequestDetails: ImageNowCommandDTO): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/ImageNow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imageNowRequestDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetImageNow(_response);
        });
    }

    protected processSetImageNow(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }
}

export class ImagingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getImagingSchedule(plateId: number): Promise<ImagingScheduleDTO[]> {
        let url_ = this.baseUrl + "/api/Imaging/imagingSchedule/{plateId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImagingSchedule(_response);
        });
    }

    protected processGetImagingSchedule(response: Response): Promise<ImagingScheduleDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImagingScheduleDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImagingScheduleDTO[]>(null as any);
    }

    getFocusLevels(pid: number, wellnumber: number, batchId: number, dropNumber: number, cpID: number, regionName: string, skipBestFocusImage: boolean | undefined): Promise<ImageFocusLevelDTO[]> {
        let url_ = this.baseUrl + "/api/Imaging/focuslevelImages/{pid}/{wellnumber}/{batchId}/{dropNumber}/{cpID}/{regionName}?";
        if (pid === undefined || pid === null)
            throw new globalThis.Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid));
        if (wellnumber === undefined || wellnumber === null)
            throw new globalThis.Error("The parameter 'wellnumber' must be defined.");
        url_ = url_.replace("{wellnumber}", encodeURIComponent("" + wellnumber));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (cpID === undefined || cpID === null)
            throw new globalThis.Error("The parameter 'cpID' must be defined.");
        url_ = url_.replace("{cpID}", encodeURIComponent("" + cpID));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        if (skipBestFocusImage === null)
            throw new globalThis.Error("The parameter 'skipBestFocusImage' cannot be null.");
        else if (skipBestFocusImage !== undefined)
            url_ += "skipBestFocusImage=" + encodeURIComponent("" + skipBestFocusImage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFocusLevels(_response);
        });
    }

    protected processGetFocusLevels(response: Response): Promise<ImageFocusLevelDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageFocusLevelDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageFocusLevelDTO[]>(null as any);
    }

    getSingleFocusLevel(pid: number, wellnumber: number, batchId: number, dropNumber: number, cpID: number, regionName: string, focusLevelImageId: number): Promise<ImageFocusLevelDTO> {
        let url_ = this.baseUrl + "/api/Imaging/focuslevelImage/{pid}/{wellnumber}/{batchId}/{dropNumber}/{cpID}/{regionName}/{focusLevelImageId}";
        if (pid === undefined || pid === null)
            throw new globalThis.Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid));
        if (wellnumber === undefined || wellnumber === null)
            throw new globalThis.Error("The parameter 'wellnumber' must be defined.");
        url_ = url_.replace("{wellnumber}", encodeURIComponent("" + wellnumber));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (cpID === undefined || cpID === null)
            throw new globalThis.Error("The parameter 'cpID' must be defined.");
        url_ = url_.replace("{cpID}", encodeURIComponent("" + cpID));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        if (focusLevelImageId === undefined || focusLevelImageId === null)
            throw new globalThis.Error("The parameter 'focusLevelImageId' must be defined.");
        url_ = url_.replace("{focusLevelImageId}", encodeURIComponent("" + focusLevelImageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSingleFocusLevel(_response);
        });
    }

    protected processGetSingleFocusLevel(response: Response): Promise<ImageFocusLevelDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageFocusLevelDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageFocusLevelDTO>(null as any);
    }

    setBestFocusLevelImage(setBestFocusLevelImageRequestDTO: SetBestFocusLevelImageRequestDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Imaging/setBestFocusLevelImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setBestFocusLevelImageRequestDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetBestFocusLevelImage(_response);
        });
    }

    protected processSetBestFocusLevelImage(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCaptureResultByImageBatchId(imageBatchId: number): Promise<CaptureResult[]> {
        let url_ = this.baseUrl + "/api/Imaging/GetCaptureResultByImageBatchId/{imageBatchId}";
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptureResultByImageBatchId(_response);
        });
    }

    protected processGetCaptureResultByImageBatchId(response: Response): Promise<CaptureResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaptureResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaptureResult[]>(null as any);
    }

    getAutoScoreThresholdByImageBatchId(imageBatchId: number): Promise<ImageBatchAutoScoreThreshold[]> {
        let url_ = this.baseUrl + "/api/Imaging/GetAutoScoreThresholdByImageBatchId/{imageBatchId}";
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAutoScoreThresholdByImageBatchId(_response);
        });
    }

    protected processGetAutoScoreThresholdByImageBatchId(response: Response): Promise<ImageBatchAutoScoreThreshold[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageBatchAutoScoreThreshold.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageBatchAutoScoreThreshold[]>(null as any);
    }

    getAllImagerQuota(): Promise<ImagerQuotaDTO[]> {
        let url_ = this.baseUrl + "/api/Imaging/GetAllImagerQuota";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllImagerQuota(_response);
        });
    }

    protected processGetAllImagerQuota(response: Response): Promise<ImagerQuotaDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImagerQuotaDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImagerQuotaDTO[]>(null as any);
    }

    saveImagerQuota(imagerQuotaDTOList: ImagerQuotaDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Imaging/saveImagerQuota";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imagerQuotaDTOList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveImagerQuota(_response);
        });
    }

    protected processSaveImagerQuota(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getFrapGraph(dropRegionId: number, cpId: number, imageBatchId: number): Promise<ImageFocusLevelDTO> {
        let url_ = this.baseUrl + "/api/Imaging/frapgraph/{dropRegionId}/{cpId}/{imageBatchId}";
        if (dropRegionId === undefined || dropRegionId === null)
            throw new globalThis.Error("The parameter 'dropRegionId' must be defined.");
        url_ = url_.replace("{dropRegionId}", encodeURIComponent("" + dropRegionId));
        if (cpId === undefined || cpId === null)
            throw new globalThis.Error("The parameter 'cpId' must be defined.");
        url_ = url_.replace("{cpId}", encodeURIComponent("" + cpId));
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFrapGraph(_response);
        });
    }

    protected processGetFrapGraph(response: Response): Promise<ImageFocusLevelDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageFocusLevelDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageFocusLevelDTO>(null as any);
    }

    createCompositeImageWithDrawings(compositeImageDTO: ExperimentReportCompositeImageDTO): Promise<CompositeImageWithDrawingDTO[]> {
        let url_ = this.baseUrl + "/api/Imaging/CreateCompositeImageWithDrawings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(compositeImageDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCompositeImageWithDrawings(_response);
        });
    }

    protected processCreateCompositeImageWithDrawings(response: Response): Promise<CompositeImageWithDrawingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompositeImageWithDrawingDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompositeImageWithDrawingDTO[]>(null as any);
    }
}

export class ImagingScheduleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getImagingSchedules(): Promise<ImagingSchedulesDTO[]> {
        let url_ = this.baseUrl + "/api/ImagingSchedule/getimagingschedules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImagingSchedules(_response);
        });
    }

    protected processGetImagingSchedules(response: Response): Promise<ImagingSchedulesDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImagingSchedulesDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImagingSchedulesDTO[]>(null as any);
    }

    saveImagingSchedules(imagingSchedules: SaveImagingSchedulesDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ImagingSchedule/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imagingSchedules);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveImagingSchedules(_response);
        });
    }

    protected processSaveImagingSchedules(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCaptureProfiles(): Promise<CaptureProfile[]> {
        let url_ = this.baseUrl + "/api/ImagingSchedule/getcaptureprofiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptureProfiles(_response);
        });
    }

    protected processGetCaptureProfiles(response: Response): Promise<CaptureProfile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaptureProfile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaptureProfile[]>(null as any);
    }

    getPlatesToImage(): Promise<PlatesToImageDTO[]> {
        let url_ = this.baseUrl + "/api/ImagingSchedule/getplatestoimage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlatesToImage(_response);
        });
    }

    protected processGetPlatesToImage(response: Response): Promise<PlatesToImageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlatesToImageDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlatesToImageDTO[]>(null as any);
    }

    getPlateInspectionsToScore(): Promise<PlateInspectionsToScoreDTO[]> {
        let url_ = this.baseUrl + "/api/ImagingSchedule/getplateinspectionstoscore";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateInspectionsToScore(_response);
        });
    }

    protected processGetPlateInspectionsToScore(response: Response): Promise<PlateInspectionsToScoreDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlateInspectionsToScoreDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateInspectionsToScoreDTO[]>(null as any);
    }

    getIsImagingScheduleInUse(imagingScheduleId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ImagingSchedule/isimagingscheduleinuse?";
        if (imagingScheduleId === null)
            throw new globalThis.Error("The parameter 'imagingScheduleId' cannot be null.");
        else if (imagingScheduleId !== undefined)
            url_ += "imagingScheduleId=" + encodeURIComponent("" + imagingScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIsImagingScheduleInUse(_response);
        });
    }

    protected processGetIsImagingScheduleInUse(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getIsImagingScheduleDefault(imagingScheduleId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ImagingSchedule/isimagingscheduledefault?";
        if (imagingScheduleId === null)
            throw new globalThis.Error("The parameter 'imagingScheduleId' cannot be null.");
        else if (imagingScheduleId !== undefined)
            url_ += "imagingScheduleId=" + encodeURIComponent("" + imagingScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIsImagingScheduleDefault(_response);
        });
    }

    protected processGetIsImagingScheduleDefault(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ImagingSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getRobots(): Promise<Robot[]> {
        let url_ = this.baseUrl + "/api/ImagingSettings/getrobots";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRobots(_response);
        });
    }

    protected processGetRobots(response: Response): Promise<Robot[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Robot.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Robot[]>(null as any);
    }
}

export class IngredientClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getPlateIngredients(plateID: number): Promise<PlateIngredientDTO> {
        let url_ = this.baseUrl + "/api/Ingredient/plate/{plateID}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateIngredients(_response);
        });
    }

    protected processGetPlateIngredients(response: Response): Promise<PlateIngredientDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlateIngredientDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateIngredientDTO>(null as any);
    }

    getAllPlatesIngredients(requestData: PlateIngredientAndDrawingRequestDTO): Promise<PlateIngredientAndDrawingDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/platesIngredients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPlatesIngredients(_response);
        });
    }

    protected processGetAllPlatesIngredients(response: Response): Promise<PlateIngredientAndDrawingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlateIngredientAndDrawingDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateIngredientAndDrawingDTO[]>(null as any);
    }

    getConflictedIngredientsList(ingredientsXml: StringPropertyDTO): Promise<ImportIngredientsDTO> {
        let url_ = this.baseUrl + "/api/Ingredient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingredientsXml);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConflictedIngredientsList(_response);
        });
    }

    protected processGetConflictedIngredientsList(response: Response): Promise<ImportIngredientsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportIngredientsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportIngredientsDTO>(null as any);
    }

    saveImportedIngredients(importIngredientsDto: ImportIngredientsDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Ingredient/SaveImportIngredient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importIngredientsDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveImportedIngredients(_response);
        });
    }

    protected processSaveImportedIngredients(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSeedNodeInfo(treeNode: number): Promise<SeedNodeInfoDTO> {
        let url_ = this.baseUrl + "/api/Ingredient/seednode/{treeNode}";
        if (treeNode === undefined || treeNode === null)
            throw new globalThis.Error("The parameter 'treeNode' must be defined.");
        url_ = url_.replace("{treeNode}", encodeURIComponent("" + treeNode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSeedNodeInfo(_response);
        });
    }

    protected processGetSeedNodeInfo(response: Response): Promise<SeedNodeInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeedNodeInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeedNodeInfoDTO>(null as any);
    }

    validateIngredient(extendedIngredientDTO: ExtendedIngredientDTO, resolutionType: ConflictResolutionType | undefined): Promise<StringPropertyDTO> {
        let url_ = this.baseUrl + "/api/Ingredient/ValidateIngredient?";
        if (resolutionType === null)
            throw new globalThis.Error("The parameter 'resolutionType' cannot be null.");
        else if (resolutionType !== undefined)
            url_ += "resolutionType=" + encodeURIComponent("" + resolutionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(extendedIngredientDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateIngredient(_response);
        });
    }

    protected processValidateIngredient(response: Response): Promise<StringPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringPropertyDTO>(null as any);
    }

    getIngredients(): Promise<IngredientDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/getIngredients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIngredients(_response);
        });
    }

    protected processGetIngredients(response: Response): Promise<IngredientDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IngredientDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IngredientDTO[]>(null as any);
    }

    getIngredientsByIds(ingredientIds: number[]): Promise<ExtendedIngredientDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/getIngredientsByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingredientIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIngredientsByIds(_response);
        });
    }

    protected processGetIngredientsByIds(response: Response): Promise<ExtendedIngredientDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExtendedIngredientDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtendedIngredientDTO[]>(null as any);
    }

    getIngredientStocks(): Promise<IngredientStockDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/getIngredientStocks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIngredientStocks(_response);
        });
    }

    protected processGetIngredientStocks(response: Response): Promise<IngredientStockDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IngredientStockDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IngredientStockDTO[]>(null as any);
    }

    getIngredientIngredientTypes(): Promise<IngredientIngredientTypeDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/getIngredientIngredientTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIngredientIngredientTypes(_response);
        });
    }

    protected processGetIngredientIngredientTypes(response: Response): Promise<IngredientIngredientTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IngredientIngredientTypeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IngredientIngredientTypeDTO[]>(null as any);
    }

    getIngredientTypes(): Promise<IngredientTypeDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/getIngredientTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIngredientTypes(_response);
        });
    }

    protected processGetIngredientTypes(response: Response): Promise<IngredientTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IngredientTypeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IngredientTypeDTO[]>(null as any);
    }

    getLiquidClasses(): Promise<LiquidClassDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/getLiquidClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLiquidClasses(_response);
        });
    }

    protected processGetLiquidClasses(response: Response): Promise<LiquidClassDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiquidClassDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LiquidClassDTO[]>(null as any);
    }

    getVendors(): Promise<VendorDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/getVendors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVendors(_response);
        });
    }

    protected processGetVendors(response: Response): Promise<VendorDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorDTO[]>(null as any);
    }

    getProteinTypes(): Promise<ProteinFormulationIngredientTypeDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/getProteinTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinTypes(_response);
        });
    }

    protected processGetProteinTypes(response: Response): Promise<ProteinFormulationIngredientTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProteinFormulationIngredientTypeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProteinFormulationIngredientTypeDTO[]>(null as any);
    }

    saveIngredientType(ingredientTypeModal: IngredientTypeModalDTO): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Ingredient/saveIngredientType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingredientTypeModal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveIngredientType(_response);
        });
    }

    protected processSaveIngredientType(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    saveVendor(vendors: VendorDTO[]): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Ingredient/saveVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vendors);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveVendor(_response);
        });
    }

    protected processSaveVendor(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    saveProteinType(proteinTypes: ProteinFormulationIngredientTypeDTO[]): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Ingredient/saveProteinType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proteinTypes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveProteinType(_response);
        });
    }

    protected processSaveProteinType(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    saveLiquidClass(liquidClasses: LiquidClassDTO[]): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Ingredient/saveLiquidClass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(liquidClasses);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveLiquidClass(_response);
        });
    }

    protected processSaveLiquidClass(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    getIngredientById(id: number | undefined): Promise<IngredientDocumentDTO> {
        let url_ = this.baseUrl + "/api/Ingredient/:id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIngredientById(_response);
        });
    }

    protected processGetIngredientById(response: Response): Promise<IngredientDocumentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngredientDocumentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IngredientDocumentDTO>(null as any);
    }

    exportIngredientsToExcel(ingredients: IngredientTableRow[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Ingredient/exportIngredientsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingredients);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportIngredientsToExcel(_response);
        });
    }

    protected processExportIngredientsToExcel(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportIngredientsToText(ingredients: IngredientTableRow[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Ingredient/exportIngredientsToText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingredients);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportIngredientsToText(_response);
        });
    }

    protected processExportIngredientsToText(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportIngredientsToXML(ingredients: IngredientTableRow[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Ingredient/exportIngredientsToXML";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingredients);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportIngredientsToXML(_response);
        });
    }

    protected processExportIngredientsToXML(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportIngredientsToXMLSpreadsheet(ingredients: IngredientTableRow[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Ingredient/exportIngredientsToXMLSpreadSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingredients);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportIngredientsToXMLSpreadsheet(_response);
        });
    }

    protected processExportIngredientsToXMLSpreadsheet(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    mergeIngredient(mergeIngredientDTO: MergeIngredientDTO): Promise<{ [key: string]: IngredientDocStockDTO[]; }> {
        let url_ = this.baseUrl + "/api/Ingredient/mergeIngredient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mergeIngredientDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMergeIngredient(_response);
        });
    }

    protected processMergeIngredient(response: Response): Promise<{ [key: string]: IngredientDocStockDTO[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? resultData200[key].map((i: any) => IngredientDocStockDTO.fromJS(i)) : [];
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: IngredientDocStockDTO[]; }>(null as any);
    }

    getStocksByIngredient(ingredientId: number | undefined): Promise<IngredientDocStockDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/:ingredientId?";
        if (ingredientId === null)
            throw new globalThis.Error("The parameter 'ingredientId' cannot be null.");
        else if (ingredientId !== undefined)
            url_ += "ingredientId=" + encodeURIComponent("" + ingredientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStocksByIngredient(_response);
        });
    }

    protected processGetStocksByIngredient(response: Response): Promise<IngredientDocStockDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IngredientDocStockDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IngredientDocStockDTO[]>(null as any);
    }

    save(saveData: SaveIngredientDocDTO): Promise<ResponseWithValueDTOOfInteger> {
        let url_ = this.baseUrl + "/api/Ingredient/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<ResponseWithValueDTOOfInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfInteger.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfInteger>(null as any);
    }

    deleteIngredient(ingredientIds: number[]): Promise<DeleteIngredientResponse> {
        let url_ = this.baseUrl + "/api/Ingredient/deleteIngredient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingredientIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteIngredient(_response);
        });
    }

    protected processDeleteIngredient(response: Response): Promise<DeleteIngredientResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteIngredientResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteIngredientResponse>(null as any);
    }

    updateFavouriteIngredientStock(favIngStockDTO: FavouriteIngredientStockDTO): Promise<FavouriteIngredientStockDTO[]> {
        let url_ = this.baseUrl + "/api/Ingredient/updateFavouriteIngredientStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(favIngStockDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateFavouriteIngredientStock(_response);
        });
    }

    protected processUpdateFavouriteIngredientStock(response: Response): Promise<FavouriteIngredientStockDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FavouriteIngredientStockDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavouriteIngredientStockDTO[]>(null as any);
    }
}

export class InspectionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getCompositeNavigator(experimentId: number): Promise<NavigatorMapDTO> {
        let url_ = this.baseUrl + "/api/Inspection/NavigationMap/{experimentId}";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompositeNavigator(_response);
        });
    }

    protected processGetCompositeNavigator(response: Response): Promise<NavigatorMapDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavigatorMapDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavigatorMapDTO>(null as any);
    }

    getNavigatorInspections(experimentId: number, plateId: number, regionName: string, cpId: number, wellNumber: number, dropNumber: number): Promise<NavigatorInspectionDTO[]> {
        let url_ = this.baseUrl + "/api/Inspection/NavigatorInspections/{experimentId}/{plateId}/{regionName}/{cpId}/{wellNumber}/{dropNumber}";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        if (cpId === undefined || cpId === null)
            throw new globalThis.Error("The parameter 'cpId' must be defined.");
        url_ = url_.replace("{cpId}", encodeURIComponent("" + cpId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNavigatorInspections(_response);
        });
    }

    protected processGetNavigatorInspections(response: Response): Promise<NavigatorInspectionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NavigatorInspectionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavigatorInspectionDTO[]>(null as any);
    }

    getNavigatorImagingSettings(experimentId: number, plateId: number, regionName: string, wellNumber: number, dropNumber: number, batchId: number): Promise<NavigatorRegionImageSettingInspectionDTO[]> {
        let url_ = this.baseUrl + "/api/Inspection/NavigatorImagingSettings/{experimentId}/{plateId}/{regionName}/{wellNumber}/{dropNumber}/{batchId}";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNavigatorImagingSettings(_response);
        });
    }

    protected processGetNavigatorImagingSettings(response: Response): Promise<NavigatorRegionImageSettingInspectionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NavigatorRegionImageSettingInspectionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavigatorRegionImageSettingInspectionDTO[]>(null as any);
    }

    getNavigatorRegions(experimentId: number, plateId: number, wellNumber: number, dropNumber: number, batchId: number, cpId: number): Promise<NavigatorRegionImageSettingInspectionDTO[]> {
        let url_ = this.baseUrl + "/api/Inspection/NavigatorRegions/{experimentId}/{plateId}/{wellNumber}/{dropNumber}/{batchId}/{cpId}";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (cpId === undefined || cpId === null)
            throw new globalThis.Error("The parameter 'cpId' must be defined.");
        url_ = url_.replace("{cpId}", encodeURIComponent("" + cpId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNavigatorRegions(_response);
        });
    }

    protected processGetNavigatorRegions(response: Response): Promise<NavigatorRegionImageSettingInspectionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NavigatorRegionImageSettingInspectionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavigatorRegionImageSettingInspectionDTO[]>(null as any);
    }

    getNavigatorDrops(experimentId: number, plateId: number, wellNumber: number, batchId: number, cpId: number, regionName: string): Promise<NavigatorDropInspectionDTO[]> {
        let url_ = this.baseUrl + "/api/Inspection/NavigatorDrops/{experimentId}/{plateId}/{wellNumber}/{batchId}/{cpId}/{regionName}";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (cpId === undefined || cpId === null)
            throw new globalThis.Error("The parameter 'cpId' must be defined.");
        url_ = url_.replace("{cpId}", encodeURIComponent("" + cpId));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNavigatorDrops(_response);
        });
    }

    protected processGetNavigatorDrops(response: Response): Promise<NavigatorDropInspectionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NavigatorDropInspectionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavigatorDropInspectionDTO[]>(null as any);
    }

    deleteInspecctionSet(inspectionSetGroups: InspectionSetGroupDTO[]): Promise<number> {
        let url_ = this.baseUrl + "/api/Inspection/deleteInspectionSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionSetGroups);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInspecctionSet(_response);
        });
    }

    protected processDeleteInspecctionSet(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    generateInspectionSCVFile(inspectionSetGroup: InspectionSetGroupDTO[], experimentId: number, experimentName: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Inspection/generateInspectionCSVFile/{experimentId}/{experimentName}";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        if (experimentName === undefined || experimentName === null)
            throw new globalThis.Error("The parameter 'experimentName' must be defined.");
        url_ = url_.replace("{experimentName}", encodeURIComponent("" + experimentName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inspectionSetGroup);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateInspectionSCVFile(_response);
        });
    }

    protected processGenerateInspectionSCVFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getNavigatorImages(experimentId: number, plateId: number, wellNumber: number, batchId: number, cpId: number, dropNumber: number, regionName: string): Promise<NavigatorImagesResponseDTO> {
        let url_ = this.baseUrl + "/api/Inspection/NavigatorImages/{experimentId}/{plateId}/{wellNumber}/{batchId}/{cpId}/{dropNumber}/{regionName}";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (cpId === undefined || cpId === null)
            throw new globalThis.Error("The parameter 'cpId' must be defined.");
        url_ = url_.replace("{cpId}", encodeURIComponent("" + cpId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNavigatorImages(_response);
        });
    }

    protected processGetNavigatorImages(response: Response): Promise<NavigatorImagesResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavigatorImagesResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavigatorImagesResponseDTO>(null as any);
    }
}

export class LicenseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    activateLicenseManual(licenseFileContent: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/License/activatemanual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licenseFileContent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivateLicenseManual(_response);
        });
    }

    protected processActivateLicenseManual(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    activateLicenseOnline(clientID: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/License/activateonline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clientID);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivateLicenseOnline(_response);
        });
    }

    protected processActivateLicenseOnline(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    isValidLicense(data: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/License/isvalid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsValidLicense(_response);
        });
    }

    protected processIsValidLicense(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    requestLicenseOnline(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/License/requestonline";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestLicenseOnline(_response);
        });
    }

    protected processRequestLicenseOnline(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    requestLicenseManaual(): Promise<LicenseRequestInfo> {
        let url_ = this.baseUrl + "/api/License/requestmanual";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestLicenseManaual(_response);
        });
    }

    protected processRequestLicenseManaual(response: Response): Promise<LicenseRequestInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseRequestInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseRequestInfo>(null as any);
    }

    getLicenseDetail(showAllSeats: boolean | undefined): Promise<LicenseDetailDTO> {
        let url_ = this.baseUrl + "/api/License/licensedetail?";
        if (showAllSeats === null)
            throw new globalThis.Error("The parameter 'showAllSeats' cannot be null.");
        else if (showAllSeats !== undefined)
            url_ += "showAllSeats=" + encodeURIComponent("" + showAllSeats) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseDetail(_response);
        });
    }

    protected processGetLicenseDetail(response: Response): Promise<LicenseDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDetailDTO>(null as any);
    }

    registerComputer(seatDto: SeatDTO): Promise<SeatDTO[]> {
        let url_ = this.baseUrl + "/api/License/registercomputer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(seatDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterComputer(_response);
        });
    }

    protected processRegisterComputer(response: Response): Promise<SeatDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeatDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeatDTO[]>(null as any);
    }

    unRegisterComputer(computerName: string): Promise<SeatDTO[]> {
        let url_ = this.baseUrl + "/api/License/unregistercomputer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(computerName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnRegisterComputer(_response);
        });
    }

    protected processUnRegisterComputer(response: Response): Promise<SeatDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeatDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeatDTO[]>(null as any);
    }

    markSessionKilled(sessionToKill: string): Promise<LicenseDetailDTO> {
        let url_ = this.baseUrl + "/api/License/marksessionkilled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sessionToKill);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkSessionKilled(_response);
        });
    }

    protected processMarkSessionKilled(response: Response): Promise<LicenseDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDetailDTO>(null as any);
    }

    getLicenseEdition(): Promise<string> {
        let url_ = this.baseUrl + "/api/License/licenseedition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseEdition(_response);
        });
    }

    protected processGetLicenseEdition(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getProductEdition(): Promise<ProductEditionDTO> {
        let url_ = this.baseUrl + "/api/License/productedition";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductEdition(_response);
        });
    }

    protected processGetProductEdition(response: Response): Promise<ProductEditionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductEditionDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductEditionDTO>(null as any);
    }

    getHybridLicenseList(allSeats: boolean | undefined): Promise<LicenseDetailDTO[]> {
        let url_ = this.baseUrl + "/api/License/licenselist?";
        if (allSeats === null)
            throw new globalThis.Error("The parameter 'allSeats' cannot be null.");
        else if (allSeats !== undefined)
            url_ += "allSeats=" + encodeURIComponent("" + allSeats) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHybridLicenseList(_response);
        });
    }

    protected processGetHybridLicenseList(response: Response): Promise<LicenseDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseDetailDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDetailDTO[]>(null as any);
    }

    setPickedLicense(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/License/setpickedlicense";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPickedLicense(_response);
        });
    }

    protected processSetPickedLicense(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    checkSeatRegistered(seatDto: SeatDTO): Promise<LicenseDetailDTO> {
        let url_ = this.baseUrl + "/api/License/checkseatregister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(seatDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckSeatRegistered(_response);
        });
    }

    protected processCheckSeatRegistered(response: Response): Promise<LicenseDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDetailDTO>(null as any);
    }

    checkLicenseUpdate(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/License/checkupdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckLicenseUpdate(_response);
        });
    }

    protected processCheckLicenseUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    setAutocheckUpdate(enabled: boolean): Promise<boolean> {
        let url_ = this.baseUrl + "/api/License/setautocheckupdateflag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(enabled);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetAutocheckUpdate(_response);
        });
    }

    protected processSetAutocheckUpdate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    endLicenseSession(licString: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/License/endlicensesession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licString);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEndLicenseSession(_response);
        });
    }

    protected processEndLicenseSession(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    isSeatRegistered(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/License/isseatregistered";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsSeatRegistered(_response);
        });
    }

    protected processIsSeatRegistered(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getChallenge(publicKey: LicenseValidatorPublicKey): Promise<ChallengeDto> {
        let url_ = this.baseUrl + "/api/License/getchallenge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publicKey);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChallenge(_response);
        });
    }

    protected processGetChallenge(response: Response): Promise<ChallengeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChallengeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChallengeDto>(null as any);
    }

    verifyChallenge(payload: SignedChallengeDTO): Promise<VerifyChallengeResponse> {
        let url_ = this.baseUrl + "/api/License/verifychallenge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyChallenge(_response);
        });
    }

    protected processVerifyChallenge(response: Response): Promise<VerifyChallengeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyChallengeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyChallengeResponse>(null as any);
    }
}

export class MarcoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    sendToMarco(sendToMarcoDetails: SendToMarcoDetailDTO): Promise<AlertDTO> {
        let url_ = this.baseUrl + "/api/Marco/SendToMarco";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendToMarcoDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendToMarco(_response);
        });
    }

    protected processSendToMarco(response: Response): Promise<AlertDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertDTO>(null as any);
    }

    sendAllPlatesToMarco(sendAllPlatesToMarcoDetail: SendAllPlatesToMarcoDetailDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/Marco/SendAllPlatesToMarco";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendAllPlatesToMarcoDetail);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendAllPlatesToMarco(_response);
        });
    }

    protected processSendAllPlatesToMarco(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    sendAllPlatesToMarcoByPlateIDs(plateIDs: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/Marco/SendPlatesToMarcoByPlateIDs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plateIDs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendAllPlatesToMarcoByPlateIDs(_response);
        });
    }

    protected processSendAllPlatesToMarcoByPlateIDs(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    sendForTraining(sendforTrainingRequestDetails: SendforTrainingRequestDetailDTO): Promise<AlertDTO> {
        let url_ = this.baseUrl + "/api/Marco/SendForTraining";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendforTrainingRequestDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendForTraining(_response);
        });
    }

    protected processSendForTraining(response: Response): Promise<AlertDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertDTO>(null as any);
    }

    getNonDisputedScores(imageBatchId: number, plateId: number, wellNumber: number, dropNumber: number): Promise<ScoreDTO[]> {
        let url_ = this.baseUrl + "/api/Marco/GetNonDisputedScores/{plateId}/{imageBatchId}/{wellNumber}/{dropNumber}";
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNonDisputedScores(_response);
        });
    }

    protected processGetNonDisputedScores(response: Response): Promise<ScoreDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoreDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoreDTO[]>(null as any);
    }

    sendDisputedScore(disputedScoreDetails: SendDisputedScoreDetailDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Marco/SendDisputedScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(disputedScoreDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendDisputedScore(_response);
        });
    }

    protected processSendDisputedScore(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    ignoreAutoScore(ignoreAutoScoreDetails: IgnoreAutoScoreDetailDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Marco/IgnoreAutoScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ignoreAutoScoreDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIgnoreAutoScore(_response);
        });
    }

    protected processIgnoreAutoScore(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getMarcoScoreInfo(plateId: number, imageBatchId: number, wellNumber: number, dropNumber: number): Promise<MarcoScoreInfo[]> {
        let url_ = this.baseUrl + "/api/Marco/MarcoScoreInfo/{plateId}/{imageBatchId}/{wellNumber}/{dropNumber}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarcoScoreInfo(_response);
        });
    }

    protected processGetMarcoScoreInfo(response: Response): Promise<MarcoScoreInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarcoScoreInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarcoScoreInfo[]>(null as any);
    }

    getMarcoPlateInfo(plateId: number): Promise<MarcoPlateInfoDto> {
        let url_ = this.baseUrl + "/api/Marco/GetMarcoPlateInfo/{plateId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarcoPlateInfo(_response);
        });
    }

    protected processGetMarcoPlateInfo(response: Response): Promise<MarcoPlateInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarcoPlateInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarcoPlateInfoDto>(null as any);
    }

    getMarcoStatus(): Promise<MarcoStatusDTO> {
        let url_ = this.baseUrl + "/api/Marco/MarcoStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarcoStatus(_response);
        });
    }

    protected processGetMarcoStatus(response: Response): Promise<MarcoStatusDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarcoStatusDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarcoStatusDTO>(null as any);
    }

    getMarcoTrainingAndImprovementStatus(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Marco/MarcoTrainingAndImprovementStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarcoTrainingAndImprovementStatus(_response);
        });
    }

    protected processGetMarcoTrainingAndImprovementStatus(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    setMarcoTrainingAndImprovementStatus(marcoTrainingAndImprovementStatusDetails: MarcoTrainingAndImprovementStatusDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Marco/SetMarcoTrainingAndImprovementStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marcoTrainingAndImprovementStatusDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMarcoTrainingAndImprovementStatus(_response);
        });
    }

    protected processSetMarcoTrainingAndImprovementStatus(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    checkIsMarcoModelAvailable(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Marco/MarcoModelAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckIsMarcoModelAvailable(_response);
        });
    }

    protected processCheckIsMarcoModelAvailable(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class MatrixMakerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getMatrix(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/MatrixMaker/getmatrix";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMatrix(_response);
        });
    }

    protected processGetMatrix(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class MiscClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    testEmail(): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Misc/email/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestEmail(_response);
        });
    }

    protected processTestEmail(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    errorEmail(emailDTO: EmailDTO): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Misc/email/error";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processErrorEmail(_response);
        });
    }

    protected processErrorEmail(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    usageStatsCSVEmail(timeSpan: number | undefined): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Misc/email/usagestats?";
        if (timeSpan === null)
            throw new globalThis.Error("The parameter 'timeSpan' cannot be null.");
        else if (timeSpan !== undefined)
            url_ += "timeSpan=" + encodeURIComponent("" + timeSpan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsageStatsCSVEmail(_response);
        });
    }

    protected processUsageStatsCSVEmail(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    getAppDBVersion(): Promise<AppDBVersionDTO> {
        let url_ = this.baseUrl + "/api/Misc/getappdbversion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppDBVersion(_response);
        });
    }

    protected processGetAppDBVersion(response: Response): Promise<AppDBVersionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppDBVersionDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppDBVersionDTO>(null as any);
    }

    downloadLogs(startDate: string | null | undefined, endDate: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Misc/download?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadLogs(_response);
        });
    }

    protected processDownloadLogs(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class OrphanImagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    searchOrphanImages(imageStores: ImageStoreDTO[]): Promise<OrphanImagesResultDTO[]> {
        let url_ = this.baseUrl + "/api/OrphanImages/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imageStores);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchOrphanImages(_response);
        });
    }

    protected processSearchOrphanImages(response: Response): Promise<OrphanImagesResultDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrphanImagesResultDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrphanImagesResultDTO[]>(null as any);
    }

    moveOrphanImagesToArchive(orphanImagesList: OrphanImagesResultDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/OrphanImages/movetoarchive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orphanImagesList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveOrphanImagesToArchive(_response);
        });
    }

    protected processMoveOrphanImagesToArchive(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class PlateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getPlateDetails(id: number): Promise<PlatesDTO> {
        let url_ = this.baseUrl + "/api/Plate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateDetails(_response);
        });
    }

    protected processGetPlateDetails(response: Response): Promise<PlatesDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlatesDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlatesDTO>(null as any);
    }

    deletePlate(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Plate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePlate(_response);
        });
    }

    protected processDeletePlate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPlateInfo(isWellSelected: boolean, id: number): Promise<PlateInfoDTO> {
        let url_ = this.baseUrl + "/api/Plate/pidata/{isWellSelected}/{Id}";
        if (isWellSelected === undefined || isWellSelected === null)
            throw new globalThis.Error("The parameter 'isWellSelected' must be defined.");
        url_ = url_.replace("{isWellSelected}", encodeURIComponent("" + isWellSelected));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateInfo(_response);
        });
    }

    protected processGetPlateInfo(response: Response): Promise<PlateInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlateInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateInfoDTO>(null as any);
    }

    getCompositeImageMemoryStream(plateId: number, dropNumber: number, regionName: string, cpId: number, inspectionId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Plate/CompositeImageMemoryStream/{plateId}/{dropNumber}/{regionName}/{cpId}/{inspectionId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        if (cpId === undefined || cpId === null)
            throw new globalThis.Error("The parameter 'cpId' must be defined.");
        url_ = url_.replace("{cpId}", encodeURIComponent("" + cpId));
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompositeImageMemoryStream(_response);
        });
    }

    protected processGetCompositeImageMemoryStream(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    regenerateCompositeImage(plateId: number, dropNumber: number, regionName: string, cpId: number, inspectionId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Plate/RegenerateCompositeImage/{plateId}/{dropNumber}/{regionName}/{cpId}/{inspectionId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        if (cpId === undefined || cpId === null)
            throw new globalThis.Error("The parameter 'cpId' must be defined.");
        url_ = url_.replace("{cpId}", encodeURIComponent("" + cpId));
        if (inspectionId === undefined || inspectionId === null)
            throw new globalThis.Error("The parameter 'inspectionId' must be defined.");
        url_ = url_.replace("{inspectionId}", encodeURIComponent("" + inspectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegenerateCompositeImage(_response);
        });
    }

    protected processRegenerateCompositeImage(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getScreenByPlateId(id: number): Promise<ExperimentDTO> {
        let url_ = this.baseUrl + "/api/Plate/screen/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenByPlateId(_response);
        });
    }

    protected processGetScreenByPlateId(response: Response): Promise<ExperimentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperimentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentDTO>(null as any);
    }

    getScreen(id: number, lotNumber: number): Promise<ExperimentDTO> {
        let url_ = this.baseUrl + "/api/Plate/screen/{id}/{lotNumber}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (lotNumber === undefined || lotNumber === null)
            throw new globalThis.Error("The parameter 'lotNumber' must be defined.");
        url_ = url_.replace("{lotNumber}", encodeURIComponent("" + lotNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreen(_response);
        });
    }

    protected processGetScreen(response: Response): Promise<ExperimentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperimentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperimentDTO>(null as any);
    }

    getScreenBasicInfo(id: number): Promise<ScreenBasicInfoDTO> {
        let url_ = this.baseUrl + "/api/Plate/screenBasicInfo/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenBasicInfo(_response);
        });
    }

    protected processGetScreenBasicInfo(response: Response): Promise<ScreenBasicInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScreenBasicInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScreenBasicInfoDTO>(null as any);
    }

    getProteinFormulationDetails(id: number): Promise<ProteinFormulationDTO> {
        let url_ = this.baseUrl + "/api/Plate/proteinformulation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinFormulationDetails(_response);
        });
    }

    protected processGetProteinFormulationDetails(response: Response): Promise<ProteinFormulationDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProteinFormulationDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProteinFormulationDTO>(null as any);
    }

    getSeedingDetails(id: number): Promise<SeedingDTO> {
        let url_ = this.baseUrl + "/api/Plate/seeding/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSeedingDetails(_response);
        });
    }

    protected processGetSeedingDetails(response: Response): Promise<SeedingDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeedingDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeedingDTO>(null as any);
    }

    getTileImage(id: number, zoomLevel: number, batchid: number, dropNumber: number, cpID: number, regionName: string, tileNum: number, tileX: number, tileY: number, rows: number, cols: number): Promise<TileDTO> {
        let url_ = this.baseUrl + "/api/Plate/{id}/{zoomLevel}/{batchid}/{dropNumber}/{cpID}/{regionName}/{tileNum}/{tileX}/{tileY}/{rows}/{cols}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (zoomLevel === undefined || zoomLevel === null)
            throw new globalThis.Error("The parameter 'zoomLevel' must be defined.");
        url_ = url_.replace("{zoomLevel}", encodeURIComponent("" + zoomLevel));
        if (batchid === undefined || batchid === null)
            throw new globalThis.Error("The parameter 'batchid' must be defined.");
        url_ = url_.replace("{batchid}", encodeURIComponent("" + batchid));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (cpID === undefined || cpID === null)
            throw new globalThis.Error("The parameter 'cpID' must be defined.");
        url_ = url_.replace("{cpID}", encodeURIComponent("" + cpID));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        if (tileNum === undefined || tileNum === null)
            throw new globalThis.Error("The parameter 'tileNum' must be defined.");
        url_ = url_.replace("{tileNum}", encodeURIComponent("" + tileNum));
        if (tileX === undefined || tileX === null)
            throw new globalThis.Error("The parameter 'tileX' must be defined.");
        url_ = url_.replace("{tileX}", encodeURIComponent("" + tileX));
        if (tileY === undefined || tileY === null)
            throw new globalThis.Error("The parameter 'tileY' must be defined.");
        url_ = url_.replace("{tileY}", encodeURIComponent("" + tileY));
        if (rows === undefined || rows === null)
            throw new globalThis.Error("The parameter 'rows' must be defined.");
        url_ = url_.replace("{rows}", encodeURIComponent("" + rows));
        if (cols === undefined || cols === null)
            throw new globalThis.Error("The parameter 'cols' must be defined.");
        url_ = url_.replace("{cols}", encodeURIComponent("" + cols));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTileImage(_response);
        });
    }

    protected processGetTileImage(response: Response): Promise<TileDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TileDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TileDTO>(null as any);
    }

    getPlateDrawing(plateData: PlateAnnotationDTO): Promise<AnnotationsDTO> {
        let url_ = this.baseUrl + "/api/Plate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plateData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateDrawing(_response);
        });
    }

    protected processGetPlateDrawing(response: Response): Promise<AnnotationsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnnotationsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnnotationsDTO>(null as any);
    }

    setDropScore(scores: ScoreRequestDTO[]): Promise<number> {
        let url_ = this.baseUrl + "/api/Plate/setscore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scores);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDropScore(_response);
        });
    }

    protected processSetDropScore(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    setDropScores(scores: ScoreRequestDTO[]): Promise<number> {
        let url_ = this.baseUrl + "/api/Plate/setScores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scores);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDropScores(_response);
        });
    }

    protected processSetDropScores(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getScoresGroups(): Promise<ScoresGroupsDTO[]> {
        let url_ = this.baseUrl + "/api/Plate/scoresgroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScoresGroups(_response);
        });
    }

    protected processGetScoresGroups(response: Response): Promise<ScoresGroupsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoresGroupsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoresGroupsDTO[]>(null as any);
    }

    getPlateTypesForWizard(): Promise<PlateTypeDTO[]> {
        let url_ = this.baseUrl + "/api/Plate/wizardplatetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateTypesForWizard(_response);
        });
    }

    protected processGetPlateTypesForWizard(response: Response): Promise<PlateTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlateTypeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateTypeDTO[]>(null as any);
    }

    getPlateScores(id: number): Promise<PlateTypeDTO[]> {
        let url_ = this.baseUrl + "/api/Plate/platescores/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateScores(_response);
        });
    }

    protected processGetPlateScores(response: Response): Promise<PlateTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlateTypeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateTypeDTO[]>(null as any);
    }

    getPlateExperimentId(plateId: number): Promise<ISOPrevExpInfo> {
        let url_ = this.baseUrl + "/api/Plate/experimentId/{plateId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateExperimentId(_response);
        });
    }

    protected processGetPlateExperimentId(response: Response): Promise<ISOPrevExpInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ISOPrevExpInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ISOPrevExpInfo>(null as any);
    }

    getScoreGroupsForScoringTool(): Promise<ScoresGroupsDTO[]> {
        let url_ = this.baseUrl + "/api/Plate/getScoreGroupsForScoringTool";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScoreGroupsForScoringTool(_response);
        });
    }

    protected processGetScoreGroupsForScoringTool(response: Response): Promise<ScoresGroupsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoresGroupsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoresGroupsDTO[]>(null as any);
    }

    getPlateInfoByExperimentId(expId: number): Promise<PlateBasicInfoDTO> {
        let url_ = this.baseUrl + "/api/Plate/getPlateInfoByExperimentId/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateInfoByExperimentId(_response);
        });
    }

    protected processGetPlateInfoByExperimentId(response: Response): Promise<PlateBasicInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlateBasicInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateBasicInfoDTO>(null as any);
    }

    getExperimentPlatesInfo(treeNodeId: number): Promise<PlateInfoDTO[]> {
        let url_ = this.baseUrl + "/api/Plate/experimentPlateInfo/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentPlatesInfo(_response);
        });
    }

    protected processGetExperimentPlatesInfo(response: Response): Promise<PlateInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlateInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateInfoDTO[]>(null as any);
    }

    getPlateScoresBasedOnWells(plateId: number): Promise<ScoresOfWellDropsDTO[][]> {
        let url_ = this.baseUrl + "/api/Plate/getPlateScoresBasedOnWells/{plateId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateScoresBasedOnWells(_response);
        });
    }

    protected processGetPlateScoresBasedOnWells(response: Response): Promise<ScoresOfWellDropsDTO[][]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoresOfWellDropsDTO[][]>(null as any);
    }

    setPlatesImaging(plates: PlatesImagingTaskDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Plate/setplateimaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plates);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPlatesImaging(_response);
        });
    }

    protected processSetPlatesImaging(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAllPlatesDrawingIdentifiers(requestData: PlateIngredientAndDrawingRequestDTO): Promise<PlateDrawingIdentifierDTO[]> {
        let url_ = this.baseUrl + "/api/Plate/drawingIdentifiers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPlatesDrawingIdentifiers(_response);
        });
    }

    protected processGetAllPlatesDrawingIdentifiers(response: Response): Promise<PlateDrawingIdentifierDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlateDrawingIdentifierDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateDrawingIdentifierDTO[]>(null as any);
    }

    getPlateDefaultBarcode(plateId: number): Promise<PlateBarcode> {
        let url_ = this.baseUrl + "/api/Plate/getPlateDefaultBarcode/{plateId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateDefaultBarcode(_response);
        });
    }

    protected processGetPlateDefaultBarcode(response: Response): Promise<PlateBarcode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlateBarcode.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateBarcode>(null as any);
    }

    editBarcode(plateId: number | undefined, barcode: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Plate/EditBarcode?";
        if (plateId === null)
            throw new globalThis.Error("The parameter 'plateId' cannot be null.");
        else if (plateId !== undefined)
            url_ += "plateId=" + encodeURIComponent("" + plateId) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditBarcode(_response);
        });
    }

    protected processEditBarcode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isBarcodeAvailable(plateId: number | undefined, barcode: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Plate/IsBarcodeAvailable?";
        if (plateId === null)
            throw new globalThis.Error("The parameter 'plateId' cannot be null.");
        else if (plateId !== undefined)
            url_ += "plateId=" + encodeURIComponent("" + plateId) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsBarcodeAvailable(_response);
        });
    }

    protected processIsBarcodeAvailable(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    editBarcodesBatch(request: EditBarcodesBatchRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Plate/EditBarcodesBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditBarcodesBatch(_response);
        });
    }

    protected processEditBarcodesBatch(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getUserRecentContainerIds(): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Plate/get-user-recent-plate-type-ids";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserRecentContainerIds(_response);
        });
    }

    protected processGetUserRecentContainerIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }
}

export class PlateIngredientsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getRequiredStockInfo(pid: number): Promise<RequiredStockDTO[]> {
        let url_ = this.baseUrl + "/api/PlateIngredients/rsdata/{pid}";
        if (pid === undefined || pid === null)
            throw new globalThis.Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRequiredStockInfo(_response);
        });
    }

    protected processGetRequiredStockInfo(response: Response): Promise<RequiredStockDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequiredStockDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequiredStockDTO[]>(null as any);
    }
}

export class PrintBarcodeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    printBarCodeById(plateId: number): Promise<BarcodeLayoutAndDataWrapper> {
        let url_ = this.baseUrl + "/api/PrintBarcode/PrintBarcode/{plateId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrintBarCodeById(_response);
        });
    }

    protected processPrintBarCodeById(response: Response): Promise<BarcodeLayoutAndDataWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarcodeLayoutAndDataWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BarcodeLayoutAndDataWrapper>(null as any);
    }

    getExpBarcodeDataLayer(expId: number): Promise<BarcodeLayoutAndDataWrapper> {
        let url_ = this.baseUrl + "/api/PrintBarcode/ExpBarcode/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpBarcodeDataLayer(_response);
        });
    }

    protected processGetExpBarcodeDataLayer(response: Response): Promise<BarcodeLayoutAndDataWrapper> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarcodeLayoutAndDataWrapper.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BarcodeLayoutAndDataWrapper>(null as any);
    }

    getPrinterSettings(): Promise<LabelPrinterSettings> {
        let url_ = this.baseUrl + "/api/PrintBarcode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPrinterSettings(_response);
        });
    }

    protected processGetPrinterSettings(response: Response): Promise<LabelPrinterSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LabelPrinterSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelPrinterSettings>(null as any);
    }

    performPlateBarcodPrinting(plateId: number): Promise<PrintBarcodeApiResponse> {
        let url_ = this.baseUrl + "/api/PrintBarcode/PerformBarcodPrinting/{plateId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerformPlateBarcodPrinting(_response);
        });
    }

    protected processPerformPlateBarcodPrinting(response: Response): Promise<PrintBarcodeApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintBarcodeApiResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintBarcodeApiResponse>(null as any);
    }

    performExperimentInformationPrinting(plateId: number): Promise<PrintBarcodeApiResponse> {
        let url_ = this.baseUrl + "/api/PrintBarcode/PerformExperimentInformationPrinting/{plateId}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerformExperimentInformationPrinting(_response);
        });
    }

    protected processPerformExperimentInformationPrinting(response: Response): Promise<PrintBarcodeApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintBarcodeApiResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintBarcodeApiResponse>(null as any);
    }

    performExpBarcodPrinting(experimentIDs: number[]): Promise<PrintBarcodeApiResponse[]> {
        let url_ = this.baseUrl + "/api/PrintBarcode/PerformExpBarcodPrinting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(experimentIDs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerformExpBarcodPrinting(_response);
        });
    }

    protected processPerformExpBarcodPrinting(response: Response): Promise<PrintBarcodeApiResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrintBarcodeApiResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintBarcodeApiResponse[]>(null as any);
    }

    performPlateBarcodesPrinting(plateIds: number[]): Promise<PrintBarcodeApiResponse[]> {
        let url_ = this.baseUrl + "/api/PrintBarcode/PerformPlateBarcodesPrinting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plateIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerformPlateBarcodesPrinting(_response);
        });
    }

    protected processPerformPlateBarcodesPrinting(response: Response): Promise<PrintBarcodeApiResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrintBarcodeApiResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintBarcodeApiResponse[]>(null as any);
    }

    performIngredientBarcodPrinting(ingredientStockId: number): Promise<PrintBarcodeApiResponse> {
        let url_ = this.baseUrl + "/api/PrintBarcode/PerformIngredientBarcodPrinting/{ingredientStockId}";
        if (ingredientStockId === undefined || ingredientStockId === null)
            throw new globalThis.Error("The parameter 'ingredientStockId' must be defined.");
        url_ = url_.replace("{ingredientStockId}", encodeURIComponent("" + ingredientStockId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerformIngredientBarcodPrinting(_response);
        });
    }

    protected processPerformIngredientBarcodPrinting(response: Response): Promise<PrintBarcodeApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintBarcodeApiResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintBarcodeApiResponse>(null as any);
    }

    performScreenLotBarcodPrinting(screenLotId: number): Promise<PrintBarcodeApiResponse> {
        let url_ = this.baseUrl + "/api/PrintBarcode/PerformScreenLotBarcodPrinting/{screenLotId}";
        if (screenLotId === undefined || screenLotId === null)
            throw new globalThis.Error("The parameter 'screenLotId' must be defined.");
        url_ = url_.replace("{screenLotId}", encodeURIComponent("" + screenLotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerformScreenLotBarcodPrinting(_response);
        });
    }

    protected processPerformScreenLotBarcodPrinting(response: Response): Promise<PrintBarcodeApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintBarcodeApiResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintBarcodeApiResponse>(null as any);
    }
}

export class ProteinFormulationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    uploadAttachment(base64String: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64String);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadAttachment(_response);
        });
    }

    protected processUploadAttachment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    retrievePFDocData(treeNodeId: number): Promise<PFDocDataDTO> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/proteinformulation/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRetrievePFDocData(_response);
        });
    }

    protected processRetrievePFDocData(response: Response): Promise<PFDocDataDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PFDocDataDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PFDocDataDTO>(null as any);
    }

    getProteinNodeInfo(treeNodeId: number): Promise<PFDocDataDTO> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/proteinnodeinfo/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinNodeInfo(_response);
        });
    }

    protected processGetProteinNodeInfo(response: Response): Promise<PFDocDataDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PFDocDataDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PFDocDataDTO>(null as any);
    }

    saveProteinFormulation(data: PFDocSaveProteinFormulationDTO): Promise<PFDocSaveResult> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/savepf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveProteinFormulation(_response);
        });
    }

    protected processSaveProteinFormulation(response: Response): Promise<PFDocSaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PFDocSaveResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PFDocSaveResult>(null as any);
    }

    getNewProteinFormulationName(parentNodeId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/newpfname/{parentNodeId}";
        if (parentNodeId === undefined || parentNodeId === null)
            throw new globalThis.Error("The parameter 'parentNodeId' must be defined.");
        url_ = url_.replace("{parentNodeId}", encodeURIComponent("" + parentNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewProteinFormulationName(_response);
        });
    }

    protected processGetNewProteinFormulationName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    saveProteinFormulationIngredientTypes(data: PFDocSaveIngredientTypesDTO): Promise<SavePFIngTypesResult> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/saveingtypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveProteinFormulationIngredientTypes(_response);
        });
    }

    protected processSaveProteinFormulationIngredientTypes(response: Response): Promise<SavePFIngTypesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavePFIngTypesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavePFIngTypesResult>(null as any);
    }

    loadGlobalIngredientsData(): Promise<GlobalIngredientsDTO> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/loadingredients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLoadGlobalIngredientsData(_response);
        });
    }

    protected processLoadGlobalIngredientsData(response: Response): Promise<GlobalIngredientsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalIngredientsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalIngredientsDTO>(null as any);
    }

    getProteinFormulation(id: number): Promise<PFDocProteinFormulationInfoDTO> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/pfinfo/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinFormulation(_response);
        });
    }

    protected processGetProteinFormulation(response: Response): Promise<PFDocProteinFormulationInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PFDocProteinFormulationInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PFDocProteinFormulationInfoDTO>(null as any);
    }

    getProteinFormulationByName(pfName: string): Promise<ProteinFormulationBasicInfoDTO> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/getProteinFormulationByName/{pfName}";
        if (pfName === undefined || pfName === null)
            throw new globalThis.Error("The parameter 'pfName' must be defined.");
        url_ = url_.replace("{pfName}", encodeURIComponent("" + pfName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinFormulationByName(_response);
        });
    }

    protected processGetProteinFormulationByName(response: Response): Promise<ProteinFormulationBasicInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProteinFormulationBasicInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProteinFormulationBasicInfoDTO>(null as any);
    }

    getProteinFormulationDetailsInfo(id: number): Promise<ProteinFormulationDetailInfoDTO> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/pfDetailsInfo/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinFormulationDetailsInfo(_response);
        });
    }

    protected processGetProteinFormulationDetailsInfo(response: Response): Promise<ProteinFormulationDetailInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProteinFormulationDetailInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProteinFormulationDetailInfoDTO>(null as any);
    }

    getProteinFormulationIngredientsByTreeNodeId(treeNodeId: number): Promise<ProteinFormulation> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/getProteinFormulationIngredientsByTreeNodeId/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinFormulationIngredientsByTreeNodeId(_response);
        });
    }

    protected processGetProteinFormulationIngredientsByTreeNodeId(response: Response): Promise<ProteinFormulation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProteinFormulation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProteinFormulation>(null as any);
    }

    getProteinFormulationIngredientTypes(): Promise<ProteinFormulationIngredientTypeDTO[]> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/getProteinFormulationIngredientTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinFormulationIngredientTypes(_response);
        });
    }

    protected processGetProteinFormulationIngredientTypes(response: Response): Promise<ProteinFormulationIngredientTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProteinFormulationIngredientTypeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProteinFormulationIngredientTypeDTO[]>(null as any);
    }

    createProteinFormulationVariant(proteinFormulationVariantDTO: ProteinFormulationVariantDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/createProteinFormulationVariant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proteinFormulationVariantDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateProteinFormulationVariant(_response);
        });
    }

    protected processCreateProteinFormulationVariant(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getProteinFormulationVariants(pfTreeNodeId: number): Promise<ProteinFormulation[]> {
        let url_ = this.baseUrl + "/api/ProteinFormulation/getProteinFormulationVariants/{pfTreeNodeId}";
        if (pfTreeNodeId === undefined || pfTreeNodeId === null)
            throw new globalThis.Error("The parameter 'pfTreeNodeId' must be defined.");
        url_ = url_.replace("{pfTreeNodeId}", encodeURIComponent("" + pfTreeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProteinFormulationVariants(_response);
        });
    }

    protected processGetProteinFormulationVariants(response: Response): Promise<ProteinFormulation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProteinFormulation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProteinFormulation[]>(null as any);
    }
}

export class PuckClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getAllPucksWithOccupancyByTripId(tripId: number | undefined): Promise<PuckDTO[]> {
        let url_ = this.baseUrl + "/api/Puck/getAllWithOccupancyWithTripId?";
        if (tripId === null)
            throw new globalThis.Error("The parameter 'tripId' cannot be null.");
        else if (tripId !== undefined)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPucksWithOccupancyByTripId(_response);
        });
    }

    protected processGetAllPucksWithOccupancyByTripId(response: Response): Promise<PuckDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PuckDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PuckDTO[]>(null as any);
    }

    getAllPuckTypes(): Promise<PuckTypev4[]> {
        let url_ = this.baseUrl + "/api/Puck/getallpucktypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPuckTypes(_response);
        });
    }

    protected processGetAllPuckTypes(response: Response): Promise<PuckTypev4[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PuckTypev4.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PuckTypev4[]>(null as any);
    }

    getPuckById(id: number): Promise<PuckDTO> {
        let url_ = this.baseUrl + "/api/Puck/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPuckById(_response);
        });
    }

    protected processGetPuckById(response: Response): Promise<PuckDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PuckDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PuckDTO>(null as any);
    }

    createPuck(puckList: PuckDTO[]): Promise<Puckv4[]> {
        let url_ = this.baseUrl + "/api/Puck/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(puckList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePuck(_response);
        });
    }

    protected processCreatePuck(response: Response): Promise<Puckv4[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Puckv4.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Puckv4[]>(null as any);
    }

    updatePuck(puckList: PuckDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Puck/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(puckList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePuck(_response);
        });
    }

    protected processUpdatePuck(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deletePuck(ids: number[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Puck/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePuck(_response);
        });
    }

    protected processDeletePuck(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    save(saveData: SavePuckDTO): Promise<Puckv4[]> {
        let url_ = this.baseUrl + "/api/Puck/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<Puckv4[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Puckv4.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Puckv4[]>(null as any);
    }
}

export class RecentDocumentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    saveRecentDocument(rd: RecentDocumentReq): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/RecentDocument/SaveRecentDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveRecentDocument(_response);
        });
    }

    protected processSaveRecentDocument(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getUserRecentDocuments(): Promise<TreeNodeDTO[]> {
        let url_ = this.baseUrl + "/api/RecentDocument/userRecentDocuments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserRecentDocuments(_response);
        });
    }

    protected processGetUserRecentDocuments(response: Response): Promise<TreeNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeNodeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeDTO[]>(null as any);
    }

    getHitImagesExperiments(): Promise<TreeNodeDTO[]> {
        let url_ = this.baseUrl + "/api/RecentDocument/hitImageExperiments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHitImagesExperiments(_response);
        });
    }

    protected processGetHitImagesExperiments(response: Response): Promise<TreeNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeNodeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeDTO[]>(null as any);
    }
}

export class RecycleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getRecycleBinView(): Promise<RecycleBinViewDTO[]> {
        let url_ = this.baseUrl + "/api/Recycle/GetRecycleBinView";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecycleBinView(_response);
        });
    }

    protected processGetRecycleBinView(response: Response): Promise<RecycleBinViewDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecycleBinViewDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecycleBinViewDTO[]>(null as any);
    }

    restore(treeNodeIds: number[]): Promise<RestoreResponseDTO> {
        let url_ = this.baseUrl + "/api/Recycle/Restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: Response): Promise<RestoreResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RestoreResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestoreResponseDTO>(null as any);
    }

    deleteNow(treeNodeIds: number[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Recycle/DeleteNow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteNow(_response);
        });
    }

    protected processDeleteNow(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    checkDeleteDependencies(treeNodeIds: number[]): Promise<NameIdTuple[]> {
        let url_ = this.baseUrl + "/api/Recycle/checkDeleteDependencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckDeleteDependencies(_response);
        });
    }

    protected processCheckDeleteDependencies(response: Response): Promise<NameIdTuple[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameIdTuple.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NameIdTuple[]>(null as any);
    }

    checkRestoreDependencies(treeNodeIds: number[]): Promise<NameIdTuple[]> {
        let url_ = this.baseUrl + "/api/Recycle/checkRestoreDependencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckRestoreDependencies(_response);
        });
    }

    protected processCheckRestoreDependencies(response: Response): Promise<NameIdTuple[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameIdTuple.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NameIdTuple[]>(null as any);
    }
}

export class ScoreClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    isWellScoreGroupInUse(scoreGroup: ScoresGroupsDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/Score/iswellscoregroupinuse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scoreGroup);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsWellScoreGroupInUse(_response);
        });
    }

    protected processIsWellScoreGroupInUse(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    isWellScoreInUse(score: ScoreDefinitionDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/Score/iswellscoreinuse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(score);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsWellScoreInUse(_response);
        });
    }

    protected processIsWellScoreInUse(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getScoresGroups(): Promise<ScoresGroupsDTO[]> {
        let url_ = this.baseUrl + "/api/Score/getscoresgroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScoresGroups(_response);
        });
    }

    protected processGetScoresGroups(response: Response): Promise<ScoresGroupsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoresGroupsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoresGroupsDTO[]>(null as any);
    }

    getWellDropScores(): Promise<ScoreDefinitionDTO[]> {
        let url_ = this.baseUrl + "/api/Score/getWellDropScores";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellDropScores(_response);
        });
    }

    protected processGetWellDropScores(response: Response): Promise<ScoreDefinitionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoreDefinitionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoreDefinitionDTO[]>(null as any);
    }

    saveDropAutoScore(saveDropAutoScoreDTOs: SaveDropAutoScoreDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Score/saveDropAutoScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDropAutoScoreDTOs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveDropAutoScore(_response);
        });
    }

    protected processSaveDropAutoScore(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getWellDropScoresByGroupName(groupName: string): Promise<WellDropScore[]> {
        let url_ = this.baseUrl + "/api/Score/getWellDropScoresByGroupName/{groupName}";
        if (groupName === undefined || groupName === null)
            throw new globalThis.Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellDropScoresByGroupName(_response);
        });
    }

    protected processGetWellDropScoresByGroupName(response: Response): Promise<WellDropScore[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellDropScore.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellDropScore[]>(null as any);
    }

    getImageBatchWellDropScoresByImageBatchId(imageBatchId: number): Promise<ImageBatchWellDropScore[]> {
        let url_ = this.baseUrl + "/api/Score/getImageBatchWellDropScoresByImageBatchId/{imageBatchId}";
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImageBatchWellDropScoresByImageBatchId(_response);
        });
    }

    protected processGetImageBatchWellDropScoresByImageBatchId(response: Response): Promise<ImageBatchWellDropScore[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageBatchWellDropScore.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageBatchWellDropScore[]>(null as any);
    }

    saveAutoScoreThresholdResetValue(value: number, imageBatchId: number, autoScoreImageTypeId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Score/saveAutoScoreThresholdResetValue/{value}/{imageBatchId}/{autoScoreImageTypeId}";
        if (value === undefined || value === null)
            throw new globalThis.Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        if (autoScoreImageTypeId === undefined || autoScoreImageTypeId === null)
            throw new globalThis.Error("The parameter 'autoScoreImageTypeId' must be defined.");
        url_ = url_.replace("{autoScoreImageTypeId}", encodeURIComponent("" + autoScoreImageTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAutoScoreThresholdResetValue(_response);
        });
    }

    protected processSaveAutoScoreThresholdResetValue(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    downloadScoreLogs(fileName: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Score/downloadScoreLogs?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadScoreLogs(_response);
        });
    }

    protected processDownloadScoreLogs(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ScreenClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    createScreen(createScreenCommand: CreateScreenDTO): Promise<TreeNodeDTO> {
        let url_ = this.baseUrl + "/api/Screen/createScreen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createScreenCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateScreen(_response);
        });
    }

    protected processCreateScreen(response: Response): Promise<TreeNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeDTO>(null as any);
    }

    rotateScreen(rotateScreenCommand: RotateScreenDTO[]): Promise<CreateNewTreeNodeDTO[]> {
        let url_ = this.baseUrl + "/api/Screen/rotateScreen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rotateScreenCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRotateScreen(_response);
        });
    }

    protected processRotateScreen(response: Response): Promise<CreateNewTreeNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateNewTreeNodeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateNewTreeNodeDTO[]>(null as any);
    }

    getScreenDetailsByScreenName(screenName: string): Promise<ScreenDetailsInfoDTO> {
        let url_ = this.baseUrl + "/api/Screen/getScreenDetailByScreenName/{screenName}";
        if (screenName === undefined || screenName === null)
            throw new globalThis.Error("The parameter 'screenName' must be defined.");
        url_ = url_.replace("{screenName}", encodeURIComponent("" + screenName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenDetailsByScreenName(_response);
        });
    }

    protected processGetScreenDetailsByScreenName(response: Response): Promise<ScreenDetailsInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScreenDetailsInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScreenDetailsInfoDTO>(null as any);
    }

    getScreenNodeInfo(treeNodeId: number): Promise<ScreenNodeInfoDTO[]> {
        let url_ = this.baseUrl + "/api/Screen/screenNodelData/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenNodeInfo(_response);
        });
    }

    protected processGetScreenNodeInfo(response: Response): Promise<ScreenNodeInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScreenNodeInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScreenNodeInfoDTO[]>(null as any);
    }

    getFragmentScreenNodeInfo(treeNodeId: number): Promise<FragmentScreenNodeInfoDTO> {
        let url_ = this.baseUrl + "/api/Screen/fragmentScreenNodelData/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFragmentScreenNodeInfo(_response);
        });
    }

    protected processGetFragmentScreenNodeInfo(response: Response): Promise<FragmentScreenNodeInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FragmentScreenNodeInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FragmentScreenNodeInfoDTO>(null as any);
    }

    getScreenRepairInfo(screenId: number): Promise<ScreenRepairInfoDTO> {
        let url_ = this.baseUrl + "/api/Screen/getScreenRepairInfo/{screenId}";
        if (screenId === undefined || screenId === null)
            throw new globalThis.Error("The parameter 'screenId' must be defined.");
        url_ = url_.replace("{screenId}", encodeURIComponent("" + screenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenRepairInfo(_response);
        });
    }

    protected processGetScreenRepairInfo(response: Response): Promise<ScreenRepairInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScreenRepairInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScreenRepairInfoDTO>(null as any);
    }

    checkScreenLotInUse(screenLotId: number): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/Screen/checkScreenLotInUse/{screenLotId}";
        if (screenLotId === undefined || screenLotId === null)
            throw new globalThis.Error("The parameter 'screenLotId' must be defined.");
        url_ = url_.replace("{screenLotId}", encodeURIComponent("" + screenLotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckScreenLotInUse(_response);
        });
    }

    protected processCheckScreenLotInUse(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }
}

export class ScreenExpWizardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getScreenExperimentTemplateNames(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/ScreenExpWizard/templatenames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenExperimentTemplateNames(_response);
        });
    }

    protected processGetScreenExperimentTemplateNames(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getScreenExperimentTemplateData(templatename: string): Promise<ScreenExperimentTemplateDTO> {
        let url_ = this.baseUrl + "/api/ScreenExpWizard/screenexperimenttemplate/{templatename}";
        if (templatename === undefined || templatename === null)
            throw new globalThis.Error("The parameter 'templatename' must be defined.");
        url_ = url_.replace("{templatename}", encodeURIComponent("" + templatename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenExperimentTemplateData(_response);
        });
    }

    protected processGetScreenExperimentTemplateData(response: Response): Promise<ScreenExperimentTemplateDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScreenExperimentTemplateDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScreenExperimentTemplateDTO>(null as any);
    }

    saveScreenExperimentTemplateData(saveScreenExpTemplate: SaveScreenExpTemplateDTO): Promise<ScreenExperimentTemplate> {
        let url_ = this.baseUrl + "/api/ScreenExpWizard/savescreenexptemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveScreenExpTemplate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveScreenExperimentTemplateData(_response);
        });
    }

    protected processSaveScreenExperimentTemplateData(response: Response): Promise<ScreenExperimentTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScreenExperimentTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScreenExperimentTemplate>(null as any);
    }

    createExperiment(createExperiments: SaveNonPersistedExpDTO): Promise<ResponseWithValueDTOOfExperimentDTO> {
        let url_ = this.baseUrl + "/api/ScreenExpWizard/createExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createExperiments);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateExperiment(_response);
        });
    }

    protected processCreateExperiment(response: Response): Promise<ResponseWithValueDTOOfExperimentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfExperimentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfExperimentDTO>(null as any);
    }

    updateTemplateName(updateDTO: UpdateWizardTemplateDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ScreenExpWizard/updateTemplateName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTemplateName(_response);
        });
    }

    protected processUpdateTemplateName(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteTemplateName(fileName: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ScreenExpWizard/deleteTemplateName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTemplateName(_response);
        });
    }

    protected processDeleteTemplateName(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class SearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    search(searchDetail: SearchDetailDTO): Promise<SearchResultsDTO[]> {
        let url_ = this.baseUrl + "/api/Search/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchDetail);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchResultsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchResultsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultsDTO[]>(null as any);
    }

    getRecentSearches(): Promise<RecentSearchDTO[]> {
        let url_ = this.baseUrl + "/api/Search/Recent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecentSearches(_response);
        });
    }

    protected processGetRecentSearches(response: Response): Promise<RecentSearchDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecentSearchDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentSearchDTO[]>(null as any);
    }

    recordRecentSearch(recentSearch: SearchDetailDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/Search/RecentSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recentSearch);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecordRecentSearch(_response);
        });
    }

    protected processRecordRecentSearch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SearchnFilterClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getTargetNames(): Promise<SearchTargetDTO[]> {
        let url_ = this.baseUrl + "/api/SearchnFilter/targets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTargetNames(_response);
        });
    }

    protected processGetTargetNames(response: Response): Promise<SearchTargetDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchTargetDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchTargetDTO[]>(null as any);
    }

    getTargetFields(): Promise<SearchTargetDTO[]> {
        let url_ = this.baseUrl + "/api/SearchnFilter/targets/fields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTargetFields(_response);
        });
    }

    protected processGetTargetFields(response: Response): Promise<SearchTargetDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchTargetDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchTargetDTO[]>(null as any);
    }

    getSearchTargetRelatedTargets(targetId: number | null): Promise<{ [key: string]: number[]; }> {
        let url_ = this.baseUrl + "/api/SearchnFilter/targets/related/{targetId}";
        if (targetId === undefined || targetId === null)
            throw new globalThis.Error("The parameter 'targetId' must be defined.");
        url_ = url_.replace("{targetId}", encodeURIComponent("" + targetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchTargetRelatedTargets(_response);
        });
    }

    protected processGetSearchTargetRelatedTargets(response: Response): Promise<{ [key: string]: number[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: number[]; }>(null as any);
    }

    saveSearch(search: SearchDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SearchnFilter/search2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(search);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveSearch(_response);
        });
    }

    protected processSaveSearch(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSearch(searchId: number): Promise<SearchDTO> {
        let url_ = this.baseUrl + "/api/SearchnFilter/search2/{searchId}";
        if (searchId === undefined || searchId === null)
            throw new globalThis.Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch(_response);
        });
    }

    protected processGetSearch(response: Response): Promise<SearchDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDTO>(null as any);
    }

    getWellIngredients(ws: number[] | undefined): Promise<WellIngDTO[]> {
        let url_ = this.baseUrl + "/api/SearchnFilter/wellingredients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ws);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellIngredients(_response);
        });
    }

    protected processGetWellIngredients(response: Response): Promise<WellIngDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellIngDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellIngDTO[]>(null as any);
    }

    getSearchResultData(searchRequest: SearchRequestDTO): Promise<SearchResultDTO> {
        let url_ = this.baseUrl + "/api/SearchnFilter/search/result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchResultData(_response);
        });
    }

    protected processGetSearchResultData(response: Response): Promise<SearchResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultDTO>(null as any);
    }

    createSearch(model: ParentTreeNodeModel): Promise<SearchDTO> {
        let url_ = this.baseUrl + "/api/SearchnFilter/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSearch(_response);
        });
    }

    protected processCreateSearch(response: Response): Promise<SearchDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchDTO>(null as any);
    }

    getSearchFilterOptions(requestDTO: FilterOptionsRequestDTO): Promise<SearchFieldTypeDTO> {
        let url_ = this.baseUrl + "/api/SearchnFilter/search/filters/options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchFilterOptions(_response);
        });
    }

    protected processGetSearchFilterOptions(response: Response): Promise<SearchFieldTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchFieldTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchFieldTypeDTO>(null as any);
    }

    getDefaultSelectedSearchFields(): Promise<{ [key: string]: SearchFieldDTO[]; }> {
        let url_ = this.baseUrl + "/api/SearchnFilter/search/defaultSelectedSearchFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefaultSelectedSearchFields(_response);
        });
    }

    protected processGetDefaultSelectedSearchFields(response: Response): Promise<{ [key: string]: SearchFieldDTO[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? resultData200[key].map((i: any) => SearchFieldDTO.fromJS(i)) : [];
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: SearchFieldDTO[]; }>(null as any);
    }

    getSearchFilters(searchId: number): Promise<FilterDTO[]> {
        let url_ = this.baseUrl + "/api/SearchnFilter/search/{searchId}/filters";
        if (searchId === undefined || searchId === null)
            throw new globalThis.Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchFilters(_response);
        });
    }

    protected processGetSearchFilters(response: Response): Promise<FilterDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterDTO[]>(null as any);
    }

    getExperimentIdByWellId(wellId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/SearchnFilter/search/experimentId?";
        if (wellId === null)
            throw new globalThis.Error("The parameter 'wellId' cannot be null.");
        else if (wellId !== undefined)
            url_ += "wellId=" + encodeURIComponent("" + wellId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentIdByWellId(_response);
        });
    }

    protected processGetExperimentIdByWellId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getExperimentIdByTreeNodeId(treeNodeId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/SearchnFilter/search/experimentIdByTreeNodeId?";
        if (treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' cannot be null.");
        else if (treeNodeId !== undefined)
            url_ += "treeNodeId=" + encodeURIComponent("" + treeNodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentIdByTreeNodeId(_response);
        });
    }

    protected processGetExperimentIdByTreeNodeId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getExperimentIdByPlateId(plateId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/SearchnFilter/search/experimentIdByPlateId?";
        if (plateId === null)
            throw new globalThis.Error("The parameter 'plateId' cannot be null.");
        else if (plateId !== undefined)
            url_ += "plateId=" + encodeURIComponent("" + plateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentIdByPlateId(_response);
        });
    }

    protected processGetExperimentIdByPlateId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSearchChartData(requestDTO: ChartDataRequestDTO): Promise<SearchResultDTO> {
        let url_ = this.baseUrl + "/api/SearchnFilter/chart/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchChartData(_response);
        });
    }

    protected processGetSearchChartData(response: Response): Promise<SearchResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultDTO>(null as any);
    }

    getSearchTargetCharts(): Promise<{ [key: string]: ChartDTO[]; }> {
        let url_ = this.baseUrl + "/api/SearchnFilter/target/charts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchTargetCharts(_response);
        });
    }

    protected processGetSearchTargetCharts(response: Response): Promise<{ [key: string]: ChartDTO[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? resultData200[key].map((i: any) => ChartDTO.fromJS(i)) : [];
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: ChartDTO[]; }>(null as any);
    }
}

export class SeedFormulationConrollerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    saveSeedFormulation(data: SeedDTO): Promise<SeedDTO> {
        let url_ = this.baseUrl + "/api/SeedFormulationConroller/save-seed-formulation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveSeedFormulation(_response);
        });
    }

    protected processSaveSeedFormulation(response: Response): Promise<SeedDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeedDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeedDTO>(null as any);
    }

    generateSeedFormat(data: SeedDTO): Promise<SeedDTO> {
        let url_ = this.baseUrl + "/api/SeedFormulationConroller/generate-seed-format";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateSeedFormat(_response);
        });
    }

    protected processGenerateSeedFormat(response: Response): Promise<SeedDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeedDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeedDTO>(null as any);
    }

    saveSeed(data: SeedDTO): Promise<SeedDTO> {
        let url_ = this.baseUrl + "/api/SeedFormulationConroller/saveseed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveSeed(_response);
        });
    }

    protected processSaveSeed(response: Response): Promise<SeedDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeedDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeedDTO>(null as any);
    }

    getSeedInfo(treeNodeId: number | undefined): Promise<SeedDTO> {
        let url_ = this.baseUrl + "/api/SeedFormulationConroller/getSeedInfo?";
        if (treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' cannot be null.");
        else if (treeNodeId !== undefined)
            url_ += "treeNodeId=" + encodeURIComponent("" + treeNodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSeedInfo(_response);
        });
    }

    protected processGetSeedInfo(response: Response): Promise<SeedDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeedDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeedDTO>(null as any);
    }

    updateSeed(data: SeedDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SeedFormulationConroller/updateseed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSeed(_response);
        });
    }

    protected processUpdateSeed(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSeeds(seedIds: number[] | null | undefined): Promise<SeedInfoDTO[]> {
        let url_ = this.baseUrl + "/api/SeedFormulationConroller/get-seeds?";
        if (seedIds !== undefined && seedIds !== null)
            seedIds && seedIds.forEach(item => { url_ += "seedIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSeeds(_response);
        });
    }

    protected processGetSeeds(response: Response): Promise<SeedInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeedInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeedInfoDTO[]>(null as any);
    }
}

export class SoakingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getAllSoakingOfCurrentUser(): Promise<SoakingDTO[]> {
        let url_ = this.baseUrl + "/api/Soaking/GetAllSoakingOfCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSoakingOfCurrentUser(_response);
        });
    }

    protected processGetAllSoakingOfCurrentUser(response: Response): Promise<SoakingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SoakingDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SoakingDTO[]>(null as any);
    }

    saveSoakings(soakingList: SoakingDTO[]): Promise<SoakingDTO[]> {
        let url_ = this.baseUrl + "/api/Soaking/SaveSoakings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(soakingList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveSoakings(_response);
        });
    }

    protected processSaveSoakings(response: Response): Promise<SoakingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SoakingDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SoakingDTO[]>(null as any);
    }

    deleteSoaking(soakingList: SoakingDTO[]): Promise<SoakingDTO[]> {
        let url_ = this.baseUrl + "/api/Soaking/DeleteSoakings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(soakingList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSoaking(_response);
        });
    }

    protected processDeleteSoaking(response: Response): Promise<SoakingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SoakingDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SoakingDTO[]>(null as any);
    }

    assignSoakingToCrystals(crystalSoakingList: CrystalSoakingDTO[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Soaking/AssignSoakings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crystalSoakingList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignSoakingToCrystals(_response);
        });
    }

    protected processAssignSoakingToCrystals(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getInUseSoakingsByIds(soakingIds: number[]): Promise<SoakingDTO[]> {
        let url_ = this.baseUrl + "/api/Soaking/GetInUseSoakingsByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(soakingIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInUseSoakingsByIds(_response);
        });
    }

    protected processGetInUseSoakingsByIds(response: Response): Promise<SoakingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SoakingDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SoakingDTO[]>(null as any);
    }
}

export class StorageInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getStorageInfo(request: StorageInfoTaskDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/StorageInfo/storageinfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStorageInfo(_response);
        });
    }

    protected processGetStorageInfo(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDatabaseSize(): Promise<DataBaseSizeDTO> {
        let url_ = this.baseUrl + "/api/StorageInfo/getDatabaseSize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDatabaseSize(_response);
        });
    }

    protected processGetDatabaseSize(response: Response): Promise<DataBaseSizeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataBaseSizeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataBaseSizeDTO>(null as any);
    }

    checkDatabaseSizeLimit(): Promise<DatabaseSizeAlertDTO> {
        let url_ = this.baseUrl + "/api/StorageInfo/checkDatabaseSizeLimit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckDatabaseSizeLimit(_response);
        });
    }

    protected processCheckDatabaseSizeLimit(response: Response): Promise<DatabaseSizeAlertDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatabaseSizeAlertDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatabaseSizeAlertDTO>(null as any);
    }

    stopStorageInfoTask(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/StorageInfo/stop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStopStorageInfoTask(_response);
        });
    }

    protected processStopStorageInfoTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class SynchTripClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    createSynchTrip(treeNodeId: number): Promise<SynchTripDTO> {
        let url_ = this.baseUrl + "/api/SynchTrip/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSynchTrip(_response);
        });
    }

    protected processCreateSynchTrip(response: Response): Promise<SynchTripDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SynchTripDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripDTO>(null as any);
    }

    save(synchTripDTO: SynchTripDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/SynchTrip/savetrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(synchTripDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSynchTrip(treeNodeId: number | undefined): Promise<SynchTripDTO> {
        let url_ = this.baseUrl + "/api/SynchTrip/gettrip?";
        if (treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' cannot be null.");
        else if (treeNodeId !== undefined)
            url_ += "treeNodeId=" + encodeURIComponent("" + treeNodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSynchTrip(_response);
        });
    }

    protected processGetSynchTrip(response: Response): Promise<SynchTripDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SynchTripDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripDTO>(null as any);
    }

    getSynchTripById(id: number | undefined): Promise<SynchTripDTO> {
        let url_ = this.baseUrl + "/api/SynchTrip/gettripbyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSynchTripById(_response);
        });
    }

    protected processGetSynchTripById(response: Response): Promise<SynchTripDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SynchTripDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripDTO>(null as any);
    }

    getOpenSynchTrips(): Promise<SynchTripDTO[]> {
        let url_ = this.baseUrl + "/api/SynchTrip/getalltrips";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOpenSynchTrips(_response);
        });
    }

    protected processGetOpenSynchTrips(response: Response): Promise<SynchTripDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SynchTripDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripDTO[]>(null as any);
    }

    deleteSynchTripFromExp(tripId: number | undefined): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/SynchTrip/deleteTripExp?";
        if (tripId === null)
            throw new globalThis.Error("The parameter 'tripId' cannot be null.");
        else if (tripId !== undefined)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSynchTripFromExp(_response);
        });
    }

    protected processDeleteSynchTripFromExp(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    checkTripCrystalsResultsExists(tripId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SynchTrip/checkTripCrystalsResultsExists?";
        if (tripId === null)
            throw new globalThis.Error("The parameter 'tripId' cannot be null.");
        else if (tripId !== undefined)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckTripCrystalsResultsExists(_response);
        });
    }

    protected processCheckTripCrystalsResultsExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSynchTripsNodeInfo(): Promise<SynchTripsNodeInfoDTO> {
        let url_ = this.baseUrl + "/api/SynchTrip/gettripsinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSynchTripsNodeInfo(_response);
        });
    }

    protected processGetSynchTripsNodeInfo(response: Response): Promise<SynchTripsNodeInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SynchTripsNodeInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripsNodeInfoDTO>(null as any);
    }

    getSynchTripsRootTreeNodeId(): Promise<number> {
        let url_ = this.baseUrl + "/api/SynchTrip/roottreenodeid";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSynchTripsRootTreeNodeId(_response);
        });
    }

    protected processGetSynchTripsRootTreeNodeId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSynchTripReport(ids: number[]): Promise<SynchTripDTO[]> {
        let url_ = this.baseUrl + "/api/SynchTrip/getsynchtripreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSynchTripReport(_response);
        });
    }

    protected processGetSynchTripReport(response: Response): Promise<SynchTripDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SynchTripDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripDTO[]>(null as any);
    }

    getSynchTripExportCSV(synchTripExportDTO: SynchTripExportDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SynchTrip/exportcsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(synchTripExportDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSynchTripExportCSV(_response);
        });
    }

    protected processGetSynchTripExportCSV(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportSynchTripResults(crystalResultDTOList: SynchTripResultExportDTO[]): Promise<string> {
        let url_ = this.baseUrl + "/api/SynchTrip/exportsynchtripresults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crystalResultDTOList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportSynchTripResults(_response);
        });
    }

    protected processExportSynchTripResults(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    verifySynchTripImportData(importDTO: SynchTripImportPayload): Promise<SynchTripImportDTO[]> {
        let url_ = this.baseUrl + "/api/SynchTrip/verifysynchTripimportdata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifySynchTripImportData(_response);
        });
    }

    protected processVerifySynchTripImportData(response: Response): Promise<SynchTripImportDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SynchTripImportDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripImportDTO[]>(null as any);
    }

    verifySynchTripResultImport(importDTO: SynchTripResultImportDTO[]): Promise<SynchTripResultImportDTO[]> {
        let url_ = this.baseUrl + "/api/SynchTrip/verifySynchTripResultImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifySynchTripResultImport(_response);
        });
    }

    protected processVerifySynchTripResultImport(response: Response): Promise<SynchTripResultImportDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SynchTripResultImportDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripResultImportDTO[]>(null as any);
    }

    saveSynchTripResultImportData(importDTO: SynchTripResultImportDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SynchTrip/saveSynchTripResultImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveSynchTripResultImportData(_response);
        });
    }

    protected processSaveSynchTripResultImportData(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSynchTripCrystalCount(tripId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/SynchTrip/getCrystalCount?";
        if (tripId === null)
            throw new globalThis.Error("The parameter 'tripId' cannot be null.");
        else if (tripId !== undefined)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSynchTripCrystalCount(_response);
        });
    }

    protected processGetSynchTripCrystalCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getLatestSynchrotronTrips(): Promise<SynchTripDTO[]> {
        let url_ = this.baseUrl + "/api/SynchTrip/getLatestSynchrotronTrips";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestSynchrotronTrips(_response);
        });
    }

    protected processGetLatestSynchrotronTrips(response: Response): Promise<SynchTripDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SynchTripDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripDTO[]>(null as any);
    }

    getSynchTripsByExpId(expId: number | undefined): Promise<SynchTripDTO[]> {
        let url_ = this.baseUrl + "/api/SynchTrip/getsynchtripsbyexpid?";
        if (expId === null)
            throw new globalThis.Error("The parameter 'expId' cannot be null.");
        else if (expId !== undefined)
            url_ += "expId=" + encodeURIComponent("" + expId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSynchTripsByExpId(_response);
        });
    }

    protected processGetSynchTripsByExpId(response: Response): Promise<SynchTripDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SynchTripDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripDTO[]>(null as any);
    }

    getSynchTripsExpReport(reportDto: SynchTripsExpReportDTO): Promise<SynchTripDTO[]> {
        let url_ = this.baseUrl + "/api/SynchTrip/getsynchtripsexpreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSynchTripsExpReport(_response);
        });
    }

    protected processGetSynchTripsExpReport(response: Response): Promise<SynchTripDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SynchTripDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynchTripDTO[]>(null as any);
    }
}

export class SystemReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    singleDropReport(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SystemReport/singledrop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSingleDropReport(_response);
        });
    }

    protected processSingleDropReport(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getExperimentReportPdf(experimentIds: number[] | null | undefined, captureProfileIds: number[] | null | undefined, dropImages: boolean | undefined, wellIngredients: boolean | undefined, designReport: boolean | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SystemReport/experiment-report/pdf?";
        if (experimentIds !== undefined && experimentIds !== null)
            experimentIds && experimentIds.forEach(item => { url_ += "experimentIds=" + encodeURIComponent("" + item) + "&"; });
        if (captureProfileIds !== undefined && captureProfileIds !== null)
            captureProfileIds && captureProfileIds.forEach(item => { url_ += "captureProfileIds=" + encodeURIComponent("" + item) + "&"; });
        if (dropImages === null)
            throw new globalThis.Error("The parameter 'dropImages' cannot be null.");
        else if (dropImages !== undefined)
            url_ += "dropImages=" + encodeURIComponent("" + dropImages) + "&";
        if (wellIngredients === null)
            throw new globalThis.Error("The parameter 'wellIngredients' cannot be null.");
        else if (wellIngredients !== undefined)
            url_ += "wellIngredients=" + encodeURIComponent("" + wellIngredients) + "&";
        if (designReport === null)
            throw new globalThis.Error("The parameter 'designReport' cannot be null.");
        else if (designReport !== undefined)
            url_ += "designReport=" + encodeURIComponent("" + designReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentReportPdf(_response);
        });
    }

    protected processGetExperimentReportPdf(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    startExperimentReportJob(request: ExperimentReportJobStartRequestDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SystemReport/experiment-report/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartExperimentReportJob(_response);
        });
    }

    protected processStartExperimentReportJob(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getExperimentReportJobResult(jobId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SystemReport/experiment-report/result/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentReportJobResult(_response);
        });
    }

    protected processGetExperimentReportJobResult(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class SystemTasksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    pasteFolder(task: PasteFolderTaskDTO): Promise<SystemTaskResponseDTO> {
        let url_ = this.baseUrl + "/api/SystemTasks/pastefolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPasteFolder(_response);
        });
    }

    protected processPasteFolder(response: Response): Promise<SystemTaskResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemTaskResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemTaskResponseDTO>(null as any);
    }

    saveImage(task: SaveImageTaskRequestDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SystemTasks/saveimage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveImage(_response);
        });
    }

    protected processSaveImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class TreeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getScreenOrProteinTreeNodesByParentId(id: number, screenTreeControl: boolean): Promise<TreeNodeListDTO> {
        let url_ = this.baseUrl + "/api/Tree/sidebar/{id}/{screenTreeControl}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (screenTreeControl === undefined || screenTreeControl === null)
            throw new globalThis.Error("The parameter 'screenTreeControl' must be defined.");
        url_ = url_.replace("{screenTreeControl}", encodeURIComponent("" + screenTreeControl));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenOrProteinTreeNodesByParentId(_response);
        });
    }

    protected processGetScreenOrProteinTreeNodesByParentId(response: Response): Promise<TreeNodeListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeListDTO>(null as any);
    }

    getSeedTreeNodesByParentId(id: number): Promise<TreeNodeListDTO> {
        let url_ = this.baseUrl + "/api/Tree/seedsidebar/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSeedTreeNodesByParentId(_response);
        });
    }

    protected processGetSeedTreeNodesByParentId(response: Response): Promise<TreeNodeListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeListDTO>(null as any);
    }

    getSeedsFolderNode(treeNodeDTO: TreeNodeDTO): Promise<TreeNodeDTO> {
        let url_ = this.baseUrl + "/api/Tree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSeedsFolderNode(_response);
        });
    }

    protected processGetSeedsFolderNode(response: Response): Promise<TreeNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeDTO>(null as any);
    }

    getWizardTreeNodeByParentId(id: number): Promise<TreeNodeListDTO> {
        let url_ = this.baseUrl + "/api/Tree/wizardtree/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWizardTreeNodeByParentId(_response);
        });
    }

    protected processGetWizardTreeNodeByParentId(response: Response): Promise<TreeNodeListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeListDTO>(null as any);
    }

    getTreeNodeByParentId(id: number, validTreeNodesTypes: string[] | null | undefined): Promise<TreeNodeListDTO> {
        let url_ = this.baseUrl + "/api/Tree/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (validTreeNodesTypes !== undefined && validTreeNodesTypes !== null)
            validTreeNodesTypes && validTreeNodesTypes.forEach(item => { url_ += "validTreeNodesTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodeByParentId(_response);
        });
    }

    protected processGetTreeNodeByParentId(response: Response): Promise<TreeNodeListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeListDTO>(null as any);
    }

    getTreeNodeByExpId(expId: number): Promise<TreeNodeDTO> {
        let url_ = this.baseUrl + "/api/Tree/getTreeNodeByExpId/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodeByExpId(_response);
        });
    }

    protected processGetTreeNodeByExpId(response: Response): Promise<TreeNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeDTO>(null as any);
    }

    getWizardScreensByParentId(id: number, plateTypeId: number): Promise<ScreenInfoDTO[]> {
        let url_ = this.baseUrl + "/api/Tree/screens/{id}/{plateTypeId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (plateTypeId === undefined || plateTypeId === null)
            throw new globalThis.Error("The parameter 'plateTypeId' must be defined.");
        url_ = url_.replace("{plateTypeId}", encodeURIComponent("" + plateTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWizardScreensByParentId(_response);
        });
    }

    protected processGetWizardScreensByParentId(response: Response): Promise<ScreenInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScreenInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScreenInfoDTO[]>(null as any);
    }

    getWizardFragmentsByParentId(id: number): Promise<FragmentScreenInfoDTO[]> {
        let url_ = this.baseUrl + "/api/Tree/fragmentScreens/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWizardFragmentsByParentId(_response);
        });
    }

    protected processGetWizardFragmentsByParentId(response: Response): Promise<FragmentScreenInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FragmentScreenInfoDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FragmentScreenInfoDTO[]>(null as any);
    }

    getWizardProteinsByParentId(id: number, plateTypeId: number, includePath: boolean | undefined, filterByAccessRights: boolean | undefined): Promise<ResponseWithValueDTOOfListOfProteinInfoDTO> {
        let url_ = this.baseUrl + "/api/Tree/proteins/{id}/{plateTypeId}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (plateTypeId === undefined || plateTypeId === null)
            throw new globalThis.Error("The parameter 'plateTypeId' must be defined.");
        url_ = url_.replace("{plateTypeId}", encodeURIComponent("" + plateTypeId));
        if (includePath === null)
            throw new globalThis.Error("The parameter 'includePath' cannot be null.");
        else if (includePath !== undefined)
            url_ += "includePath=" + encodeURIComponent("" + includePath) + "&";
        if (filterByAccessRights === null)
            throw new globalThis.Error("The parameter 'filterByAccessRights' cannot be null.");
        else if (filterByAccessRights !== undefined)
            url_ += "filterByAccessRights=" + encodeURIComponent("" + filterByAccessRights) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWizardProteinsByParentId(_response);
        });
    }

    protected processGetWizardProteinsByParentId(response: Response): Promise<ResponseWithValueDTOOfListOfProteinInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseWithValueDTOOfListOfProteinInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseWithValueDTOOfListOfProteinInfoDTO>(null as any);
    }

    getUsersTempImagingSchedules(): Promise<UsersTempImagingSchedulesDTO> {
        let url_ = this.baseUrl + "/api/Tree/userstempimagingschedules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsersTempImagingSchedules(_response);
        });
    }

    protected processGetUsersTempImagingSchedules(response: Response): Promise<UsersTempImagingSchedulesDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersTempImagingSchedulesDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersTempImagingSchedulesDTO>(null as any);
    }

    getScreenExperimentTemplateNames(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Tree/screenexperimenttemplatenames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenExperimentTemplateNames(_response);
        });
    }

    protected processGetScreenExperimentTemplateNames(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    testPrintBarcode(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Tree/printbarcode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestPrintBarcode(_response);
        });
    }

    protected processTestPrintBarcode(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createNewTreeNode(tn: CreateNewTreeNodeDTO): Promise<CreateNewTreeNodeDTO> {
        let url_ = this.baseUrl + "/api/Tree/createnew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tn);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewTreeNode(_response);
        });
    }

    protected processCreateNewTreeNode(response: Response): Promise<CreateNewTreeNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateNewTreeNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateNewTreeNodeDTO>(null as any);
    }

    getNewUniqueName(parentId: number, type: string, baseName: string | null | undefined): Promise<TreeNodeNameDTO> {
        let url_ = this.baseUrl + "/api/Tree/getnewname/{parentId}/{type}?";
        if (parentId === undefined || parentId === null)
            throw new globalThis.Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (baseName !== undefined && baseName !== null)
            url_ += "baseName=" + encodeURIComponent("" + baseName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewUniqueName(_response);
        });
    }

    protected processGetNewUniqueName(response: Response): Promise<TreeNodeNameDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeNameDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeNameDTO>(null as any);
    }

    getDocumentParentNodes(id: number, type: string, includeSelf: boolean): Promise<TreeNodeDTO[]> {
        let url_ = this.baseUrl + "/api/Tree/getdocumentparents/{id}/{type}/{includeSelf}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (includeSelf === undefined || includeSelf === null)
            throw new globalThis.Error("The parameter 'includeSelf' must be defined.");
        url_ = url_.replace("{includeSelf}", encodeURIComponent("" + includeSelf));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocumentParentNodes(_response);
        });
    }

    protected processGetDocumentParentNodes(response: Response): Promise<TreeNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeNodeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeDTO[]>(null as any);
    }

    deleteTreeNode(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Tree/deleteNode/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTreeNode(_response);
        });
    }

    protected processDeleteTreeNode(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    pasteTreeNode(treeNodeIdsToPaste: number[], targetId: number | undefined): Promise<PasteResponseDTO> {
        let url_ = this.baseUrl + "/api/Tree/pasteNode?";
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIdsToPaste);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPasteTreeNode(_response);
        });
    }

    protected processPasteTreeNode(response: Response): Promise<PasteResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasteResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PasteResponseDTO>(null as any);
    }

    cutPasteTreeNode(treeNodeIdsToPaste: number[], targetId: number | undefined): Promise<PasteResponseDTO> {
        let url_ = this.baseUrl + "/api/Tree/cutPasteNode?";
        if (targetId === null)
            throw new globalThis.Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIdsToPaste);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCutPasteTreeNode(_response);
        });
    }

    protected processCutPasteTreeNode(response: Response): Promise<PasteResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasteResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PasteResponseDTO>(null as any);
    }

    getExperimentProjectInfo(expId: number): Promise<ProjectInfoDTO> {
        let url_ = this.baseUrl + "/api/Tree/getexperimentproject/{expId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentProjectInfo(_response);
        });
    }

    protected processGetExperimentProjectInfo(response: Response): Promise<ProjectInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectInfoDTO>(null as any);
    }

    getTreeNodeHitReportData(hitsReportDataRequestDTO: HitsReportDataRequestDTO): Promise<HitReportDataDTO[]> {
        let url_ = this.baseUrl + "/api/Tree/hitreportdata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hitsReportDataRequestDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodeHitReportData(_response);
        });
    }

    protected processGetTreeNodeHitReportData(response: Response): Promise<HitReportDataDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HitReportDataDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HitReportDataDTO[]>(null as any);
    }

    getScreenConditionsCount(experimentId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Tree/screens/{experimentId}/conditionscount";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScreenConditionsCount(_response);
        });
    }

    protected processGetScreenConditionsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getParentIdByTreeNodeId(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Tree/getParentIdByTreeNodeId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParentIdByTreeNodeId(_response);
        });
    }

    protected processGetParentIdByTreeNodeId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getParentNodeByTreeNodeId(id: number): Promise<TreeNode> {
        let url_ = this.baseUrl + "/api/Tree/getParentNodeByTreeNodeId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParentNodeByTreeNodeId(_response);
        });
    }

    protected processGetParentNodeByTreeNodeId(response: Response): Promise<TreeNode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNode.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNode>(null as any);
    }

    renameNode(request: RenameNodeRequestDTO): Promise<AlertDTO> {
        let url_ = this.baseUrl + "/api/Tree/renameNode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenameNode(_response);
        });
    }

    protected processRenameNode(response: Response): Promise<AlertDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertDTO>(null as any);
    }

    getTreeNodeAccessRights(id: number): Promise<TreeNodeAccessRightRequestDTO> {
        let url_ = this.baseUrl + "/api/Tree/{id}/access-rights";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodeAccessRights(_response);
        });
    }

    protected processGetTreeNodeAccessRights(response: Response): Promise<TreeNodeAccessRightRequestDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeAccessRightRequestDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeAccessRightRequestDTO>(null as any);
    }

    updateTreeNodeAccessRights(id: number, request: TreeNodeAccessRightDTO[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Tree/{id}/access-rights";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTreeNodeAccessRights(_response);
        });
    }

    protected processUpdateTreeNodeAccessRights(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getProjectNodeData(treeNodeId: number): Promise<ProjectNodeInfoDTO> {
        let url_ = this.baseUrl + "/api/Tree/projectNode/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProjectNodeData(_response);
        });
    }

    protected processGetProjectNodeData(response: Response): Promise<ProjectNodeInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectNodeInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectNodeInfoDTO>(null as any);
    }

    updateProjectNodeData(node: ProjectNodeInfoDTO): Promise<AlertDTO> {
        let url_ = this.baseUrl + "/api/Tree/updateProjectNodeData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(node);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProjectNodeData(_response);
        });
    }

    protected processUpdateProjectNodeData(response: Response): Promise<AlertDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertDTO>(null as any);
    }

    getNodeChildsCount(treeNodeId: number): Promise<NodeChildsCountDTO> {
        let url_ = this.baseUrl + "/api/Tree/nodeChildsCount/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNodeChildsCount(_response);
        });
    }

    protected processGetNodeChildsCount(response: Response): Promise<NodeChildsCountDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NodeChildsCountDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NodeChildsCountDTO>(null as any);
    }

    getProjectCrystalData(treeNodeId: number): Promise<ProjectCrystalDTO[]> {
        let url_ = this.baseUrl + "/api/Tree/projectCrystalData/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProjectCrystalData(_response);
        });
    }

    protected processGetProjectCrystalData(response: Response): Promise<ProjectCrystalDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectCrystalDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCrystalDTO[]>(null as any);
    }

    addToQuickAccess(treeNodeIds: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/Tree/addToQuickAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddToQuickAccess(_response);
        });
    }

    protected processAddToQuickAccess(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    removeFromQuickAccess(treeNodeIds: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/Tree/removeFromQuickAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveFromQuickAccess(_response);
        });
    }

    protected processRemoveFromQuickAccess(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    unlockNode(request: UnlockNodeRequestDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Tree/unlockNode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnlockNode(_response);
        });
    }

    protected processUnlockNode(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAbsoluteRootNodeIdFromChildId(treeNodeId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Tree/getAbsoluteRootNodeIdFromChildId/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAbsoluteRootNodeIdFromChildId(_response);
        });
    }

    protected processGetAbsoluteRootNodeIdFromChildId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getTreeNodeByTreeNodeId(treeNodeId: number): Promise<TreeNodeDTO> {
        let url_ = this.baseUrl + "/api/Tree/getTreeNodeByTreeNodeId/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodeByTreeNodeId(_response);
        });
    }

    protected processGetTreeNodeByTreeNodeId(response: Response): Promise<TreeNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeDTO>(null as any);
    }

    getTreeNodesByTreeNodeType(treeNodeType: string): Promise<TreeNodeDTO[]> {
        let url_ = this.baseUrl + "/api/Tree/getTreeNodesByTreeNodeType/{treeNodeType}";
        if (treeNodeType === undefined || treeNodeType === null)
            throw new globalThis.Error("The parameter 'treeNodeType' must be defined.");
        url_ = url_.replace("{treeNodeType}", encodeURIComponent("" + treeNodeType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodesByTreeNodeType(_response);
        });
    }

    protected processGetTreeNodesByTreeNodeType(response: Response): Promise<TreeNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeNodeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeNodeDTO[]>(null as any);
    }

    getTreeNodeAccessRightName(id: number): Promise<AccessRightDTO> {
        let url_ = this.baseUrl + "/api/Tree/getTreeNodeAccessRightName/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodeAccessRightName(_response);
        });
    }

    protected processGetTreeNodeAccessRightName(response: Response): Promise<AccessRightDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessRightDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRightDTO>(null as any);
    }

    getTreeNodePaths(pathIds: number[] | null | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/Tree/getTreeNodePaths?";
        if (pathIds !== undefined && pathIds !== null)
            pathIds && pathIds.forEach(item => { url_ += "pathIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreeNodePaths(_response);
        });
    }

    protected processGetTreeNodePaths(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    getAnalyzeTreeNodes(): Promise<AnalyzeTreeNodeDTO> {
        let url_ = this.baseUrl + "/api/Tree/getAnalyzeTreeNodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnalyzeTreeNodes(_response);
        });
    }

    protected processGetAnalyzeTreeNodes(response: Response): Promise<AnalyzeTreeNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalyzeTreeNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalyzeTreeNodeDTO>(null as any);
    }

    isAnyTreeNodeContainsHit(treeNodeIds: number[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tree/isAnyTreeNodeContainsHit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsAnyTreeNodeContainsHit(_response);
        });
    }

    protected processIsAnyTreeNodeContainsHit(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteTreeNodes(request: DeleteTreeNodesRequest): Promise<DeleteFolderTaskResponseDTO[]> {
        let url_ = this.baseUrl + "/api/Tree/deletenodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTreeNodes(_response);
        });
    }

    protected processDeleteTreeNodes(response: Response): Promise<DeleteFolderTaskResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeleteFolderTaskResponseDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteFolderTaskResponseDTO[]>(null as any);
    }

    getSearchNodeInfo(treeNodeId: number): Promise<SearchNodeInfoDTO> {
        let url_ = this.baseUrl + "/api/Tree/nodeInfo/{treeNodeId}";
        if (treeNodeId === undefined || treeNodeId === null)
            throw new globalThis.Error("The parameter 'treeNodeId' must be defined.");
        url_ = url_.replace("{treeNodeId}", encodeURIComponent("" + treeNodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchNodeInfo(_response);
        });
    }

    protected processGetSearchNodeInfo(response: Response): Promise<SearchNodeInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchNodeInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchNodeInfoDTO>(null as any);
    }

    getAllTreeNodes(validTreeNodesTypes: string[] | null | undefined, includeScreenConditionsCount: boolean | undefined): Promise<EagerLoadTreeNodeDTO[]> {
        let url_ = this.baseUrl + "/api/Tree/eagerload?";
        if (validTreeNodesTypes !== undefined && validTreeNodesTypes !== null)
            validTreeNodesTypes && validTreeNodesTypes.forEach(item => { url_ += "validTreeNodesTypes=" + encodeURIComponent("" + item) + "&"; });
        if (includeScreenConditionsCount === null)
            throw new globalThis.Error("The parameter 'includeScreenConditionsCount' cannot be null.");
        else if (includeScreenConditionsCount !== undefined)
            url_ += "includeScreenConditionsCount=" + encodeURIComponent("" + includeScreenConditionsCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTreeNodes(_response);
        });
    }

    protected processGetAllTreeNodes(response: Response): Promise<EagerLoadTreeNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EagerLoadTreeNodeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EagerLoadTreeNodeDTO[]>(null as any);
    }

    isAllTreeNodesExist(treeNodeIds: number[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tree/isAllTreeNodesExist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNodeIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsAllTreeNodesExist(_response);
        });
    }

    protected processIsAllTreeNodesExist(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDeletedNodeAvailability(treeNode: number[]): Promise<DeleteFolderTaskResponseDTO> {
        let url_ = this.baseUrl + "/api/Tree/deleted-node-availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeNode);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeletedNodeAvailability(_response);
        });
    }

    protected processGetDeletedNodeAvailability(response: Response): Promise<DeleteFolderTaskResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFolderTaskResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteFolderTaskResponseDTO>(null as any);
    }
}

export class UsageStatClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    createUsageStat(usageStat: UsageStatDTO): Promise<UsageStat> {
        let url_ = this.baseUrl + "/api/UsageStat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(usageStat);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUsageStat(_response);
        });
    }

    protected processCreateUsageStat(response: Response): Promise<UsageStat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsageStat.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsageStat>(null as any);
    }

    usageStatExportAsCSV(timeSpan: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UsageStat/csv?";
        if (timeSpan === null)
            throw new globalThis.Error("The parameter 'timeSpan' cannot be null.");
        else if (timeSpan !== undefined)
            url_ += "timeSpan=" + encodeURIComponent("" + timeSpan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsageStatExportAsCSV(_response);
        });
    }

    protected processUsageStatExportAsCSV(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    sendLabwareReportEmail(recepientEmailAddress: string): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/UsageStat/SendLabwareReportEmail/{recepientEmailAddress}";
        if (recepientEmailAddress === undefined || recepientEmailAddress === null)
            throw new globalThis.Error("The parameter 'recepientEmailAddress' must be defined.");
        url_ = url_.replace("{recepientEmailAddress}", encodeURIComponent("" + recepientEmailAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendLabwareReportEmail(_response);
        });
    }

    protected processSendLabwareReportEmail(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    index(): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    user(id: number): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser(_response);
        });
    }

    protected processUser(response: Response): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO>(null as any);
    }

    updatePassword(id: number, user: UserDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/User/{id}/UpdatePassword";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateUser(id: number, user: UserDTO): Promise<UserDTO> {
        let url_ = this.baseUrl + "/api/User/{id}/Update";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<UserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO>(null as any);
    }

    getUserTypes(): Promise<UserTypeDTO[]> {
        let url_ = this.baseUrl + "/api/User/getUserTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserTypes(_response);
        });
    }

    protected processGetUserTypes(response: Response): Promise<UserTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTypeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTypeDTO[]>(null as any);
    }

    generateUserOTP(userCred: UserCredentialDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/generateUserOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCred);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateUserOTP(_response);
        });
    }

    protected processGenerateUserOTP(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class UserGroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    upsertUserGroup(userGroupDetailDTO: UserGroupDetailDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UserGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userGroupDetailDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpsertUserGroup(_response);
        });
    }

    protected processUpsertUserGroup(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    checkGroupAvailability(groupId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/UserGroup/check-group-availability/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckGroupAvailability(_response);
        });
    }

    protected processCheckGroupAvailability(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class WellInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getImagesWellNumbers(pid: number, dropNumber: number, cpID: number): Promise<number[]> {
        let url_ = this.baseUrl + "/api/WellInfo/wellnumberswithimages/{pid}/{dropNumber}/{cpID}";
        if (pid === undefined || pid === null)
            throw new globalThis.Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (cpID === undefined || cpID === null)
            throw new globalThis.Error("The parameter 'cpID' must be defined.");
        url_ = url_.replace("{cpID}", encodeURIComponent("" + cpID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImagesWellNumbers(_response);
        });
    }

    protected processGetImagesWellNumbers(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getWellDrawing(pid: number, wellnumber: number, batchId: number, dropNumber: number, cpID: number, regionName: string): Promise<WellDrawingDTO> {
        let url_ = this.baseUrl + "/api/WellInfo/{pid}/{wellnumber}/{batchId}/{dropNumber}/{cpID}/{regionName}";
        if (pid === undefined || pid === null)
            throw new globalThis.Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid));
        if (wellnumber === undefined || wellnumber === null)
            throw new globalThis.Error("The parameter 'wellnumber' must be defined.");
        url_ = url_.replace("{wellnumber}", encodeURIComponent("" + wellnumber));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (cpID === undefined || cpID === null)
            throw new globalThis.Error("The parameter 'cpID' must be defined.");
        url_ = url_.replace("{cpID}", encodeURIComponent("" + cpID));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellDrawing(_response);
        });
    }

    protected processGetWellDrawing(response: Response): Promise<WellDrawingDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellDrawingDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellDrawingDTO>(null as any);
    }

    getWellImage(pid: number, wellnumber: number, batchId: number, dropNumber: number, cpID: number, regionID: number, width: number | undefined, height: number | undefined, bestFocusImageRequired: boolean | undefined, thumbnailImageType: string | null | undefined): Promise<WellImageDTO> {
        let url_ = this.baseUrl + "/api/WellInfo/img/{pid}/{wellnumber}/{batchId}/{dropNumber}/{cpID}/{regionID}?";
        if (pid === undefined || pid === null)
            throw new globalThis.Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid));
        if (wellnumber === undefined || wellnumber === null)
            throw new globalThis.Error("The parameter 'wellnumber' must be defined.");
        url_ = url_.replace("{wellnumber}", encodeURIComponent("" + wellnumber));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (cpID === undefined || cpID === null)
            throw new globalThis.Error("The parameter 'cpID' must be defined.");
        url_ = url_.replace("{cpID}", encodeURIComponent("" + cpID));
        if (regionID === undefined || regionID === null)
            throw new globalThis.Error("The parameter 'regionID' must be defined.");
        url_ = url_.replace("{regionID}", encodeURIComponent("" + regionID));
        if (width === null)
            throw new globalThis.Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new globalThis.Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        if (bestFocusImageRequired === null)
            throw new globalThis.Error("The parameter 'bestFocusImageRequired' cannot be null.");
        else if (bestFocusImageRequired !== undefined)
            url_ += "bestFocusImageRequired=" + encodeURIComponent("" + bestFocusImageRequired) + "&";
        if (thumbnailImageType !== undefined && thumbnailImageType !== null)
            url_ += "thumbnailImageType=" + encodeURIComponent("" + thumbnailImageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellImage(_response);
        });
    }

    protected processGetWellImage(response: Response): Promise<WellImageDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellImageDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImageDTO>(null as any);
    }

    streamWellImage(requestParams: WellImageDetailsDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WellInfo/image-stream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestParams);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStreamWellImage(_response);
        });
    }

    protected processStreamWellImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getWellImagesMetaData(experimentId: number, batchIds: number[] | null | undefined): Promise<WellImageDTO[]> {
        let url_ = this.baseUrl + "/api/WellInfo/image-meta/{experimentId}?";
        if (experimentId === undefined || experimentId === null)
            throw new globalThis.Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        if (batchIds !== undefined && batchIds !== null)
            batchIds && batchIds.forEach(item => { url_ += "batchIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellImagesMetaData(_response);
        });
    }

    protected processGetWellImagesMetaData(response: Response): Promise<WellImageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellImageDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImageDTO[]>(null as any);
    }

    getWellImages(pList: WellImageParams[]): Promise<WellImageDTO[]> {
        let url_ = this.baseUrl + "/api/WellInfo/image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pList);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellImages(_response);
        });
    }

    protected processGetWellImages(response: Response): Promise<WellImageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellImageDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImageDTO[]>(null as any);
    }

    getWellImageForHitImageExperiments(wellHitImageRequestDTO: WellHitImageRequestDTO): Promise<WellImageDTO> {
        let url_ = this.baseUrl + "/api/WellInfo/getHitImageExpWell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wellHitImageRequestDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellImageForHitImageExperiments(_response);
        });
    }

    protected processGetWellImageForHitImageExperiments(response: Response): Promise<WellImageDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellImageDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImageDTO>(null as any);
    }

    getWellImageWithDrawingAnnotations(reportImageRequestDTO: ReportImageRequestDTO): Promise<WellImageDTO> {
        let url_ = this.baseUrl + "/api/WellInfo/getWellImageWithDrawingAnnotations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportImageRequestDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellImageWithDrawingAnnotations(_response);
        });
    }

    protected processGetWellImageWithDrawingAnnotations(response: Response): Promise<WellImageDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellImageDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImageDTO>(null as any);
    }

    getWellImagesForImageReport(imageRequestDTO: SaveImageRequestDTO): Promise<WellImageDTO[]> {
        let url_ = this.baseUrl + "/api/WellInfo/getWellImagesForImageReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imageRequestDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellImagesForImageReport(_response);
        });
    }

    protected processGetWellImagesForImageReport(response: Response): Promise<WellImageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellImageDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImageDTO[]>(null as any);
    }

    getWellLayerIngredients(wellId: number): Promise<WellLayerIngredientDTO[]> {
        let url_ = this.baseUrl + "/api/WellInfo/getwelllayeringredients/{wellId}";
        if (wellId === undefined || wellId === null)
            throw new globalThis.Error("The parameter 'wellId' must be defined.");
        url_ = url_.replace("{wellId}", encodeURIComponent("" + wellId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellLayerIngredients(_response);
        });
    }

    protected processGetWellLayerIngredients(response: Response): Promise<WellLayerIngredientDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellLayerIngredientDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellLayerIngredientDTO[]>(null as any);
    }

    saveScribble(saveScribbleCommandDTO: RegionDrawingDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/WellInfo/savescribble";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveScribbleCommandDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveScribble(_response);
        });
    }

    protected processSaveScribble(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    addNewScribble(drawingDetails: RegionDrawingDTO): Promise<PlateScribbleResponseDTO> {
        let url_ = this.baseUrl + "/api/WellInfo/addNewScribble";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drawingDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewScribble(_response);
        });
    }

    protected processAddNewScribble(response: Response): Promise<PlateScribbleResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlateScribbleResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlateScribbleResponseDTO>(null as any);
    }

    updateScribble(saveScribbleCommandDTO: ScribbleDrawingDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/WellInfo/updatescribble";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveScribbleCommandDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateScribble(_response);
        });
    }

    protected processUpdateScribble(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteScribble(deleteScribble: DeleteScribbleDTO): Promise<ResponseDTO> {
        let url_ = this.baseUrl + "/api/WellInfo/deletescribble";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteScribble);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteScribble(_response);
        });
    }

    protected processDeleteScribble(response: Response): Promise<ResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO>(null as any);
    }

    saveCaptureResultTuningValues(captureResultTuningValuesVM: CaptureResultTuningValuesDTO): Promise<CaptureResultTuningValuesDTO> {
        let url_ = this.baseUrl + "/api/WellInfo/savecaptureresulttuningvalues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(captureResultTuningValuesVM);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveCaptureResultTuningValues(_response);
        });
    }

    protected processSaveCaptureResultTuningValues(response: Response): Promise<CaptureResultTuningValuesDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaptureResultTuningValuesDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaptureResultTuningValuesDTO>(null as any);
    }

    deleteCaptureResultTuningValues(captureResultTuningValuesVM: CaptureResultTuningValuesDTO): Promise<boolean> {
        let url_ = this.baseUrl + "/api/WellInfo/deletecaptureresulttuningvalues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(captureResultTuningValuesVM);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCaptureResultTuningValues(_response);
        });
    }

    protected processDeleteCaptureResultTuningValues(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    disableImaging(regionIds: number[], imagingEnabled: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/WellInfo/DisableImaging?";
        if (imagingEnabled === null)
            throw new globalThis.Error("The parameter 'imagingEnabled' cannot be null.");
        else if (imagingEnabled !== undefined)
            url_ += "imagingEnabled=" + encodeURIComponent("" + imagingEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(regionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDisableImaging(_response);
        });
    }

    protected processDisableImaging(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    setWellDropImagingEnabled(wells: WellSelectionDTO[], imagingEnabled: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/WellInfo/setwelldropimagingenabled?";
        if (imagingEnabled === null)
            throw new globalThis.Error("The parameter 'imagingEnabled' cannot be null.");
        else if (imagingEnabled !== undefined)
            url_ += "imagingEnabled=" + encodeURIComponent("" + imagingEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wells);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetWellDropImagingEnabled(_response);
        });
    }

    protected processSetWellDropImagingEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    generatePoiCsv(request: CSVExportRequestDTO): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/WellInfo/generatePoiCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeneratePoiCsv(_response);
        });
    }

    protected processGeneratePoiCsv(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSystemFonts(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/WellInfo/systemFonts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSystemFonts(_response);
        });
    }

    protected processGetSystemFonts(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getSeedWellImage(pid: number, wellnumber: number, batchId: number, dropNumber: number, cpID: number, regionName: string, regionID: number, width: number | undefined, height: number | undefined, bestFocusImageRequired: boolean | undefined, thumbnailImageType: string | null | undefined): Promise<WellImageDTO> {
        let url_ = this.baseUrl + "/api/WellInfo/seedWellImage/{pid}/{wellnumber}/{batchId}/{dropNumber}/{cpID}/{regionName}/{regionID}?";
        if (pid === undefined || pid === null)
            throw new globalThis.Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid));
        if (wellnumber === undefined || wellnumber === null)
            throw new globalThis.Error("The parameter 'wellnumber' must be defined.");
        url_ = url_.replace("{wellnumber}", encodeURIComponent("" + wellnumber));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (cpID === undefined || cpID === null)
            throw new globalThis.Error("The parameter 'cpID' must be defined.");
        url_ = url_.replace("{cpID}", encodeURIComponent("" + cpID));
        if (regionName === undefined || regionName === null)
            throw new globalThis.Error("The parameter 'regionName' must be defined.");
        url_ = url_.replace("{regionName}", encodeURIComponent("" + regionName));
        if (regionID === undefined || regionID === null)
            throw new globalThis.Error("The parameter 'regionID' must be defined.");
        url_ = url_.replace("{regionID}", encodeURIComponent("" + regionID));
        if (width === null)
            throw new globalThis.Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new globalThis.Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        if (bestFocusImageRequired === null)
            throw new globalThis.Error("The parameter 'bestFocusImageRequired' cannot be null.");
        else if (bestFocusImageRequired !== undefined)
            url_ += "bestFocusImageRequired=" + encodeURIComponent("" + bestFocusImageRequired) + "&";
        if (thumbnailImageType !== undefined && thumbnailImageType !== null)
            url_ += "thumbnailImageType=" + encodeURIComponent("" + thumbnailImageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSeedWellImage(_response);
        });
    }

    protected processGetSeedWellImage(response: Response): Promise<WellImageDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellImageDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImageDTO>(null as any);
    }

    getWellImagingDetails(expId: number, regionId: number, cpId: number, imageBatchId: number): Promise<WellImagingDetails> {
        let url_ = this.baseUrl + "/api/WellInfo/GetWellImagingDetails/{expId}/{regionId}/{cpId}/{imageBatchId}";
        if (expId === undefined || expId === null)
            throw new globalThis.Error("The parameter 'expId' must be defined.");
        url_ = url_.replace("{expId}", encodeURIComponent("" + expId));
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        if (cpId === undefined || cpId === null)
            throw new globalThis.Error("The parameter 'cpId' must be defined.");
        url_ = url_.replace("{cpId}", encodeURIComponent("" + cpId));
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellImagingDetails(_response);
        });
    }

    protected processGetWellImagingDetails(response: Response): Promise<WellImagingDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellImagingDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImagingDetails>(null as any);
    }

    updateWellDropImportFl(wellDropImportFlDto: WellDropImportFlDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/WellInfo/updatewelldropimportfl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wellDropImportFlDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWellDropImportFl(_response);
        });
    }

    protected processUpdateWellDropImportFl(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveRegionDropLocation(regionDropLocationDTO: RegionDropLocationDTO): Promise<number> {
        let url_ = this.baseUrl + "/api/WellInfo/saveregiondroplocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(regionDropLocationDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveRegionDropLocation(_response);
        });
    }

    protected processSaveRegionDropLocation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getHighScoreWellImagesWithScoreByContainerNodeId(containerProjectId: number, scoreGroupId: number, cpid: number): Promise<WellImageScoreDTO[]> {
        let url_ = this.baseUrl + "/api/WellInfo/highScoreWellImagesWithScore/{containerProjectId}/{scoreGroupId}/{cpid}";
        if (containerProjectId === undefined || containerProjectId === null)
            throw new globalThis.Error("The parameter 'containerProjectId' must be defined.");
        url_ = url_.replace("{containerProjectId}", encodeURIComponent("" + containerProjectId));
        if (scoreGroupId === undefined || scoreGroupId === null)
            throw new globalThis.Error("The parameter 'scoreGroupId' must be defined.");
        url_ = url_.replace("{scoreGroupId}", encodeURIComponent("" + scoreGroupId));
        if (cpid === undefined || cpid === null)
            throw new globalThis.Error("The parameter 'cpid' must be defined.");
        url_ = url_.replace("{cpid}", encodeURIComponent("" + cpid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHighScoreWellImagesWithScoreByContainerNodeId(_response);
        });
    }

    protected processGetHighScoreWellImagesWithScoreByContainerNodeId(response: Response): Promise<WellImageScoreDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellImageScoreDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImageScoreDTO[]>(null as any);
    }

    getWellImagesWithDrawingAnnotations(reportImageRequest: ReportImageRequestDTO): Promise<WellImageDTO[]> {
        let url_ = this.baseUrl + "/api/WellInfo/getWellImagesWithDrawingAnnotations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportImageRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWellImagesWithDrawingAnnotations(_response);
        });
    }

    protected processGetWellImagesWithDrawingAnnotations(response: Response): Promise<WellImageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellImageDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WellImageDTO[]>(null as any);
    }
}

export class FrapExporterClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getFrapDataPoints(plateId: number, batchId: number, cpId: number, dropNumber: number): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/utility/frap-data-points/{plateId}/{batchId}/{cpId}/{dropNumber}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (batchId === undefined || batchId === null)
            throw new globalThis.Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (cpId === undefined || cpId === null)
            throw new globalThis.Error("The parameter 'cpId' must be defined.");
        url_ = url_.replace("{cpId}", encodeURIComponent("" + cpId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFrapDataPoints(_response);
        });
    }

    protected processGetFrapDataPoints(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }
}

export class NtClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getDispenseList(barcode: string): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/nt8/dispense-list/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new globalThis.Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDispenseList(_response);
        });
    }

    protected processGetDispenseList(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }

    setMarkAsDispensed(request: MarkAsDispensedRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/nt8/mark-as-dispensed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMarkAsDispensed(_response);
        });
    }

    protected processSetMarkAsDispensed(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    updateVolume(request: UpdateVolumeRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/nt8/update-volume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateVolume(_response);
        });
    }

    protected processUpdateVolume(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    ping(): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/nt8/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }

    setMessage(request: DispensingRobotMessageRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/nt8/set-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMessage(_response);
        });
    }

    protected processSetMessage(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getDispenseListWithWaterAndFragmentVolume(robotId: string | null | undefined, barcode: string): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/nt8/dispense-list/{barcode}?";
        if (barcode === undefined || barcode === null)
            throw new globalThis.Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        if (robotId !== undefined && robotId !== null)
            url_ += "robotId=" + encodeURIComponent("" + robotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDispenseListWithWaterAndFragmentVolume(_response);
        });
    }

    protected processGetDispenseListWithWaterAndFragmentVolume(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }
}

export class ImagerLinkImageProcessingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    saveCaptureInfoResult(request: SaveCaptureResultRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/save-capture-result-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveCaptureInfoResult(_response);
        });
    }

    protected processSaveCaptureInfoResult(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    saveImage(files: FileParameter[] | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/save-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveImage(_response);
        });
    }

    protected processSaveImage(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getApiVersion(): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/get-api-version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiVersion(_response);
        });
    }

    protected processGetApiVersion(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getImagePathDirectory(plateId: number, imageBatchId: number, wellNumber: number, captureProfileId: number, dropNumber: number, regionId: number, imageType: EImageType, focusLevel: number, imageFormat: EImageFormat): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/save-image-path/{plateId}/{imageBatchId}/{wellNumber}/{captureProfileId}/{dropNumber}/{regionId}/{imageType}/{focusLevel}/{imageFormat}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (captureProfileId === undefined || captureProfileId === null)
            throw new globalThis.Error("The parameter 'captureProfileId' must be defined.");
        url_ = url_.replace("{captureProfileId}", encodeURIComponent("" + captureProfileId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        if (imageType === undefined || imageType === null)
            throw new globalThis.Error("The parameter 'imageType' must be defined.");
        url_ = url_.replace("{imageType}", encodeURIComponent("" + imageType));
        if (focusLevel === undefined || focusLevel === null)
            throw new globalThis.Error("The parameter 'focusLevel' must be defined.");
        url_ = url_.replace("{focusLevel}", encodeURIComponent("" + focusLevel));
        if (imageFormat === undefined || imageFormat === null)
            throw new globalThis.Error("The parameter 'imageFormat' must be defined.");
        url_ = url_.replace("{imageFormat}", encodeURIComponent("" + imageFormat));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImagePathDirectory(_response);
        });
    }

    protected processGetImagePathDirectory(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    importFocusLevelEnable(regionId: number, plateId: number, wellNumber: number, dropNumber: number, captureProfileId: number, imageType: EImageType): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/import-focus-level-enable/{regionId}/{plateId}/{wellNumber}/{dropNumber}/{captureProfileId}/{imageType}";
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (captureProfileId === undefined || captureProfileId === null)
            throw new globalThis.Error("The parameter 'captureProfileId' must be defined.");
        url_ = url_.replace("{captureProfileId}", encodeURIComponent("" + captureProfileId));
        if (imageType === undefined || imageType === null)
            throw new globalThis.Error("The parameter 'imageType' must be defined.");
        url_ = url_.replace("{imageType}", encodeURIComponent("" + imageType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportFocusLevelEnable(_response);
        });
    }

    protected processImportFocusLevelEnable(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getImageSaveInfo(plateId: number, imageBatchId: number, wellNumber: number, captureProfileId: number, dropNumber: number, regionId: number, imageType: EImageType): Promise<ResultWithValueOfImageSaveInfoDto> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/image-save-info/{plateId}/{imageBatchId}/{wellNumber}/{captureProfileId}/{dropNumber}/{regionId}/{imageType}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (captureProfileId === undefined || captureProfileId === null)
            throw new globalThis.Error("The parameter 'captureProfileId' must be defined.");
        url_ = url_.replace("{captureProfileId}", encodeURIComponent("" + captureProfileId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        if (imageType === undefined || imageType === null)
            throw new globalThis.Error("The parameter 'imageType' must be defined.");
        url_ = url_.replace("{imageType}", encodeURIComponent("" + imageType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImageSaveInfo(_response);
        });
    }

    protected processGetImageSaveInfo(response: Response): Promise<ResultWithValueOfImageSaveInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfImageSaveInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfImageSaveInfoDto>(null as any);
    }

    getRegionName(regionId: number): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/region-name/{regionId}";
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegionName(_response);
        });
    }

    protected processGetRegionName(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }

    getCaptureProfileName(captureProfileId: number): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-profile-name/{captureProfileId}";
        if (captureProfileId === undefined || captureProfileId === null)
            throw new globalThis.Error("The parameter 'captureProfileId' must be defined.");
        url_ = url_.replace("{captureProfileId}", encodeURIComponent("" + captureProfileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptureProfileName(_response);
        });
    }

    protected processGetCaptureProfileName(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }

    setAutoScoreImageDataAndClass(request: SetAutoScoreImageDataAndClassRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/auto-score-image-data-and-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetAutoScoreImageDataAndClass(_response);
        });
    }

    protected processSetAutoScoreImageDataAndClass(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getStorageInfo(): Promise<ResultWithValueOfStorageInfoDto> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/storage-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStorageInfo(_response);
        });
    }

    protected processGetStorageInfo(response: Response): Promise<ResultWithValueOfStorageInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfStorageInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfStorageInfoDto>(null as any);
    }

    getSoftwareInfo(): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/software-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSoftwareInfo(_response);
        });
    }

    protected processGetSoftwareInfo(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }

    setFrapImageDataPoints(request: SaveFrapImageDataPointsRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/save-frap-image-data-points";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetFrapImageDataPoints(_response);
        });
    }

    protected processSetFrapImageDataPoints(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    saveImageV2(files: FileParameter | null | undefined, checkSum: string | null | undefined, useCheckSum: boolean | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/save-image-v2?";
        if (checkSum !== undefined && checkSum !== null)
            url_ += "checkSum=" + encodeURIComponent("" + checkSum) + "&";
        if (useCheckSum === null)
            throw new globalThis.Error("The parameter 'useCheckSum' cannot be null.");
        else if (useCheckSum !== undefined)
            url_ += "useCheckSum=" + encodeURIComponent("" + useCheckSum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            content_.append("files", files.data, files.fileName ? files.fileName : "files");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveImageV2(_response);
        });
    }

    protected processSaveImageV2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveImageInfoV2(requestDto: SaveImageRequestDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/save-image-info-v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveImageInfoV2(_response);
        });
    }

    protected processSaveImageInfoV2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    imageSaveInfoV2(plateId: number, imageBatchId: number, wellNumber: number, captureProfileId: number, dropNumber: number, regionId: number, imageType: EImageType, lightPath: ELightPath): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/image-save-info-v2/{plateId}/{imageBatchId}/{wellNumber}/{captureProfileId}/{dropNumber}/{regionId}/{imageType}/{lightPath}";
        if (plateId === undefined || plateId === null)
            throw new globalThis.Error("The parameter 'plateId' must be defined.");
        url_ = url_.replace("{plateId}", encodeURIComponent("" + plateId));
        if (imageBatchId === undefined || imageBatchId === null)
            throw new globalThis.Error("The parameter 'imageBatchId' must be defined.");
        url_ = url_.replace("{imageBatchId}", encodeURIComponent("" + imageBatchId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (captureProfileId === undefined || captureProfileId === null)
            throw new globalThis.Error("The parameter 'captureProfileId' must be defined.");
        url_ = url_.replace("{captureProfileId}", encodeURIComponent("" + captureProfileId));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        if (imageType === undefined || imageType === null)
            throw new globalThis.Error("The parameter 'imageType' must be defined.");
        url_ = url_.replace("{imageType}", encodeURIComponent("" + imageType));
        if (lightPath === undefined || lightPath === null)
            throw new globalThis.Error("The parameter 'lightPath' must be defined.");
        url_ = url_.replace("{lightPath}", encodeURIComponent("" + lightPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImageSaveInfoV2(_response);
        });
    }

    protected processImageSaveInfoV2(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class ImagerLinkImagingTaskClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getScheduleSyncPoint(robotID: number): Promise<ResultWithValueOfLong> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/schedule-sync-point/{robotID}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScheduleSyncPoint(_response);
        });
    }

    protected processGetScheduleSyncPoint(response: Response): Promise<ResultWithValueOfLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfLong.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfLong>(null as any);
    }

    getPlateIDsWithScheduleUpdates(robotID: number, lastExperimentPlateEventId: number): Promise<ResultWithValueOfPlateWithScheduleUpdateDto> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plate-ids-with-schedule-updates/{robotID}/{lastExperimentPlateEventId}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (lastExperimentPlateEventId === undefined || lastExperimentPlateEventId === null)
            throw new globalThis.Error("The parameter 'lastExperimentPlateEventId' must be defined.");
        url_ = url_.replace("{lastExperimentPlateEventId}", encodeURIComponent("" + lastExperimentPlateEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateIDsWithScheduleUpdates(_response);
        });
    }

    protected processGetPlateIDsWithScheduleUpdates(response: Response): Promise<ResultWithValueOfPlateWithScheduleUpdateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfPlateWithScheduleUpdateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfPlateWithScheduleUpdateDto>(null as any);
    }

    imagingPlate(request: ImagingPlateRequestDTO): Promise<ResultWithValueOfInteger> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/imaging-plate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImagingPlate(_response);
        });
    }

    protected processImagingPlate(response: Response): Promise<ResultWithValueOfInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfInteger.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfInteger>(null as any);
    }
}

export class GetImagingTasksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withRobotId(plateID: number, robotId: string): Promise<ResultWithValueOfListOfRiImagingTaskDto> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/imaging-tasks/{robotId}/{plateID}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithRobotId(_response);
        });
    }

    protected processWithRobotId(response: Response): Promise<ResultWithValueOfListOfRiImagingTaskDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfRiImagingTaskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfRiImagingTaskDto>(null as any);
    }
}

export class ImagerLinkInspectionSchedulingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getImagingTasksByPlateIds(request: GetImagingTasksByPlateIdsRequestDto): Promise<ResultWithValueOfListOfRiImagingTaskByPlateIdDto> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/imaging-tasks-by-plate-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImagingTasksByPlateIds(_response);
        });
    }

    protected processGetImagingTasksByPlateIds(response: Response): Promise<ResultWithValueOfListOfRiImagingTaskByPlateIdDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfRiImagingTaskByPlateIdDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfRiImagingTaskByPlateIdDto>(null as any);
    }

    setImagePlateCancelled(request: ImagePlateCancelledRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/image-plate-cancelled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetImagePlateCancelled(_response);
        });
    }

    protected processSetImagePlateCancelled(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    skippedImaging(request: SkippedImagingRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/skipped-imaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSkippedImaging(_response);
        });
    }

    protected processSkippedImaging(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    setUpdatePriority(request: UpdatedPriorityRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/updated-priority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUpdatePriority(_response);
        });
    }

    protected processSetUpdatePriority(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getSupportsPriority(robotID: number): Promise<ResultWithValueOfBoolean> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/supports-priority/{robotId}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSupportsPriority(_response);
        });
    }

    protected processGetSupportsPriority(response: Response): Promise<ResultWithValueOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfBoolean>(null as any);
    }

    getMultiPlateImagingTasks(robotId: number): Promise<ResultWithValueOfListOfImagingTaskDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/multi-plate-imaging-tasks/{robotId}";
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMultiPlateImagingTasks(_response);
        });
    }

    protected processGetMultiPlateImagingTasks(response: Response): Promise<ResultWithValueOfListOfImagingTaskDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfImagingTaskDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfImagingTaskDTO>(null as any);
    }

    getImagingTasks(plateID: number): Promise<ResultWithValueOfListOfRiImagingTaskDto> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/imaging-tasks/{plateID}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImagingTasks(_response);
        });
    }

    protected processGetImagingTasks(response: Response): Promise<ResultWithValueOfListOfRiImagingTaskDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfRiImagingTaskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfRiImagingTaskDto>(null as any);
    }
}

export class SetImagePlateCompletedClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withPlateId(request: ImagePlateCompletedRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/imaged-plate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithPlateId(_response);
        });
    }

    protected processWithPlateId(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class ImagerLinkCaptureProfileClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getSetupTemperatures(): Promise<ResultWithValueOfListOfSetupTemperatureDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/setup-temperatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSetupTemperatures(_response);
        });
    }

    protected processGetSetupTemperatures(response: Response): Promise<ResultWithValueOfListOfSetupTemperatureDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfSetupTemperatureDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfSetupTemperatureDTO>(null as any);
    }

    getCapturePropertyValuesByCaptureProfileIDs(robotID: number, propertyName: string, isDistinct: boolean, userSelectionCaptureProfileIDs: number[] | null | undefined): Promise<ResultWithValueOfListOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-property-values-by-user-selection/{robotID}/{propertyName}/{isDistinct}?";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (propertyName === undefined || propertyName === null)
            throw new globalThis.Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        if (isDistinct === undefined || isDistinct === null)
            throw new globalThis.Error("The parameter 'isDistinct' must be defined.");
        url_ = url_.replace("{isDistinct}", encodeURIComponent("" + isDistinct));
        if (userSelectionCaptureProfileIDs !== undefined && userSelectionCaptureProfileIDs !== null)
            userSelectionCaptureProfileIDs && userSelectionCaptureProfileIDs.forEach(item => { url_ += "userSelectionCaptureProfileIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCapturePropertyValuesByCaptureProfileIDs(_response);
        });
    }

    protected processGetCapturePropertyValuesByCaptureProfileIDs(response: Response): Promise<ResultWithValueOfListOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfString>(null as any);
    }

    getLightpathsByCaptureProfileIDs(robotID: number, userSelectionCaptureProfileIDs: number[] | null | undefined): Promise<ResultWithValueOfListOfELightPath> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/lightpaths-by-user-selection/{robotId}?";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (userSelectionCaptureProfileIDs !== undefined && userSelectionCaptureProfileIDs !== null)
            userSelectionCaptureProfileIDs && userSelectionCaptureProfileIDs.forEach(item => { url_ += "userSelectionCaptureProfileIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLightpathsByCaptureProfileIDs(_response);
        });
    }

    protected processGetLightpathsByCaptureProfileIDs(response: Response): Promise<ResultWithValueOfListOfELightPath> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfELightPath.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfELightPath>(null as any);
    }

    getCapturePropertyValues(robotID: number, plateID: number, isScheduled: boolean, dateToImage: Date, dateImaged: Date, propertyName: string, isDistinct: boolean): Promise<IResultOfListOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-property-values/{robotID}/{plateID}/{isScheduled}/{dateToImage}/{dateImaged}/{propertyName}/{isDistinct}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (isScheduled === undefined || isScheduled === null)
            throw new globalThis.Error("The parameter 'isScheduled' must be defined.");
        url_ = url_.replace("{isScheduled}", encodeURIComponent("" + isScheduled));
        if (dateToImage === undefined || dateToImage === null)
            throw new globalThis.Error("The parameter 'dateToImage' must be defined.");
        url_ = url_.replace("{dateToImage}", encodeURIComponent(dateToImage ? "" + dateToImage.toISOString() : "null"));
        if (dateImaged === undefined || dateImaged === null)
            throw new globalThis.Error("The parameter 'dateImaged' must be defined.");
        url_ = url_.replace("{dateImaged}", encodeURIComponent(dateImaged ? "" + dateImaged.toISOString() : "null"));
        if (propertyName === undefined || propertyName === null)
            throw new globalThis.Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        if (isDistinct === undefined || isDistinct === null)
            throw new globalThis.Error("The parameter 'isDistinct' must be defined.");
        url_ = url_.replace("{isDistinct}", encodeURIComponent("" + isDistinct));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCapturePropertyValues(_response);
        });
    }

    protected processGetCapturePropertyValues(response: Response): Promise<IResultOfListOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResultOfListOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResultOfListOfString>(null as any);
    }

    getLightpaths(robotID: number, plateID: number, isScheduled: boolean | undefined, dateToImage: Date, dateImaged: Date, propertyName: string | null | undefined, scheduled: string): Promise<IResultOfListOfELightPath> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/lightpaths/{robotId}/{plateID}/{scheduled}/{dateToImage}/{dateImaged}?";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (dateToImage === undefined || dateToImage === null)
            throw new globalThis.Error("The parameter 'dateToImage' must be defined.");
        url_ = url_.replace("{dateToImage}", encodeURIComponent(dateToImage ? "" + dateToImage.toISOString() : "null"));
        if (dateImaged === undefined || dateImaged === null)
            throw new globalThis.Error("The parameter 'dateImaged' must be defined.");
        url_ = url_.replace("{dateImaged}", encodeURIComponent(dateImaged ? "" + dateImaged.toISOString() : "null"));
        if (scheduled === undefined || scheduled === null)
            throw new globalThis.Error("The parameter 'scheduled' must be defined.");
        url_ = url_.replace("{scheduled}", encodeURIComponent("" + scheduled));
        if (isScheduled === null)
            throw new globalThis.Error("The parameter 'isScheduled' cannot be null.");
        else if (isScheduled !== undefined)
            url_ += "isScheduled=" + encodeURIComponent("" + isScheduled) + "&";
        if (propertyName !== undefined && propertyName !== null)
            url_ += "propertyName=" + encodeURIComponent("" + propertyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLightpaths(_response);
        });
    }

    protected processGetLightpaths(response: Response): Promise<IResultOfListOfELightPath> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResultOfListOfELightPath.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResultOfListOfELightPath>(null as any);
    }

    getTaggedCapturePoints(robotID: number, imagingID: number, includeOverview: boolean, userSelectionCaptureProfileIDs: number[] | null | undefined, plateID: string): Promise<IResultOfCapturePointListDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/tagged-capture-points/{robotID}/{plateID}/{imagingID}/{includeOverview}?";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (imagingID === undefined || imagingID === null)
            throw new globalThis.Error("The parameter 'imagingID' must be defined.");
        url_ = url_.replace("{imagingID}", encodeURIComponent("" + imagingID));
        if (includeOverview === undefined || includeOverview === null)
            throw new globalThis.Error("The parameter 'includeOverview' must be defined.");
        url_ = url_.replace("{includeOverview}", encodeURIComponent("" + includeOverview));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (userSelectionCaptureProfileIDs !== undefined && userSelectionCaptureProfileIDs !== null)
            userSelectionCaptureProfileIDs && userSelectionCaptureProfileIDs.forEach(item => { url_ += "userSelectionCaptureProfileIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaggedCapturePoints(_response);
        });
    }

    protected processGetTaggedCapturePoints(response: Response): Promise<IResultOfCapturePointListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResultOfCapturePointListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResultOfCapturePointListDTO>(null as any);
    }

    /**
     * @param includeOverview (optional) 
     * @param isTaggedPointOnly (optional) 
     * @param userSelectionCaptureProfileID (optional) 
     * @deprecated
     */
    getCapturePoints(robotID: number, imagingID: number, includeOverview: boolean | undefined, isTaggedPointOnly: boolean | undefined, userSelectionCaptureProfileID: number[] | null | undefined): Promise<IResultOfCapturePointListDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-points/{robotID}/{imagingID}?";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (imagingID === undefined || imagingID === null)
            throw new globalThis.Error("The parameter 'imagingID' must be defined.");
        url_ = url_.replace("{imagingID}", encodeURIComponent("" + imagingID));
        if (includeOverview === null)
            throw new globalThis.Error("The parameter 'includeOverview' cannot be null.");
        else if (includeOverview !== undefined)
            url_ += "includeOverview=" + encodeURIComponent("" + includeOverview) + "&";
        if (isTaggedPointOnly === null)
            throw new globalThis.Error("The parameter 'isTaggedPointOnly' cannot be null.");
        else if (isTaggedPointOnly !== undefined)
            url_ += "isTaggedPointOnly=" + encodeURIComponent("" + isTaggedPointOnly) + "&";
        if (userSelectionCaptureProfileID !== undefined && userSelectionCaptureProfileID !== null)
            userSelectionCaptureProfileID && userSelectionCaptureProfileID.forEach(item => { url_ += "userSelectionCaptureProfileID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCapturePoints(_response);
        });
    }

    protected processGetCapturePoints(response: Response): Promise<IResultOfCapturePointListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResultOfCapturePointListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResultOfCapturePointListDTO>(null as any);
    }

    getCapturePointsByPlateID(plateID: number): Promise<ResultWithValueOfCapturePointListDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-points/{plateID}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCapturePointsByPlateID(_response);
        });
    }

    protected processGetCapturePointsByPlateID(response: Response): Promise<ResultWithValueOfCapturePointListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfCapturePointListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfCapturePointListDTO>(null as any);
    }

    getCapturePointsByImagingID(plateID: number, imagingTaskID: number): Promise<ResultWithValueOfCapturePointListDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-points-by-imaging-task/{plateID}/{imagingTaskID}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (imagingTaskID === undefined || imagingTaskID === null)
            throw new globalThis.Error("The parameter 'imagingTaskID' must be defined.");
        url_ = url_.replace("{imagingTaskID}", encodeURIComponent("" + imagingTaskID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCapturePointsByImagingID(_response);
        });
    }

    protected processGetCapturePointsByImagingID(response: Response): Promise<ResultWithValueOfCapturePointListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfCapturePointListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfCapturePointListDTO>(null as any);
    }

    updateCaptureProfile(request: UpdateCaptureProfileRequestDTO): Promise<IResultOfInteger> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/update-capture-profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCaptureProfile(_response);
        });
    }

    protected processUpdateCaptureProfile(response: Response): Promise<IResultOfInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResultOfInteger.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResultOfInteger>(null as any);
    }

    getMultiPlateCapturePropertyValues(robotID: number, request: PlateScheduleInfoDto): Promise<ResultWithValueOfListOfPlateCapturePropertyValuesDto> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/multi-plate-capture-property-values/{robotId}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMultiPlateCapturePropertyValues(_response);
        });
    }

    protected processGetMultiPlateCapturePropertyValues(response: Response): Promise<ResultWithValueOfListOfPlateCapturePropertyValuesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPlateCapturePropertyValuesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPlateCapturePropertyValuesDto>(null as any);
    }

    getCapturePointsByImagingID2(robotID: number, imagingID: number, includeOverview: boolean): Promise<IResultOfCapturePointListDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/capture-points-by-imaging-id/{robotID}/{imagingID}/{includeOverview}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (imagingID === undefined || imagingID === null)
            throw new globalThis.Error("The parameter 'imagingID' must be defined.");
        url_ = url_.replace("{imagingID}", encodeURIComponent("" + imagingID));
        if (includeOverview === undefined || includeOverview === null)
            throw new globalThis.Error("The parameter 'includeOverview' must be defined.");
        url_ = url_.replace("{includeOverview}", encodeURIComponent("" + includeOverview));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCapturePointsByImagingID2(_response);
        });
    }

    protected processGetCapturePointsByImagingID2(response: Response): Promise<IResultOfCapturePointListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResultOfCapturePointListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResultOfCapturePointListDTO>(null as any);
    }
}

export class GetCapturePointsByImagingIDClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withPlateID(robotID: number, imagingID: number, includeOverview: boolean, plateID: string): Promise<IResultOfCapturePointListDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-points-by-imaging-id/{robotID}/{plateID}/{imagingID}/{includeOverview}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (imagingID === undefined || imagingID === null)
            throw new globalThis.Error("The parameter 'imagingID' must be defined.");
        url_ = url_.replace("{imagingID}", encodeURIComponent("" + imagingID));
        if (includeOverview === undefined || includeOverview === null)
            throw new globalThis.Error("The parameter 'includeOverview' must be defined.");
        url_ = url_.replace("{includeOverview}", encodeURIComponent("" + includeOverview));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithPlateID(_response);
        });
    }

    protected processWithPlateID(response: Response): Promise<IResultOfCapturePointListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResultOfCapturePointListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResultOfCapturePointListDTO>(null as any);
    }
}

export class WithPlateIDClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    singleUserSelectionCaptureProfileID(robotID: number, imagingID: number, includeOverview: boolean, userSelectionCaptureProfileID: number, plateID: string): Promise<IResultOfCapturePointListDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-points-by-imaging-id-user-selection/{robotId}/{plateID}/{imagingID}/{includeOverview}/{userSelectionCaptureProfileID}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (imagingID === undefined || imagingID === null)
            throw new globalThis.Error("The parameter 'imagingID' must be defined.");
        url_ = url_.replace("{imagingID}", encodeURIComponent("" + imagingID));
        if (includeOverview === undefined || includeOverview === null)
            throw new globalThis.Error("The parameter 'includeOverview' must be defined.");
        url_ = url_.replace("{includeOverview}", encodeURIComponent("" + includeOverview));
        if (userSelectionCaptureProfileID === undefined || userSelectionCaptureProfileID === null)
            throw new globalThis.Error("The parameter 'userSelectionCaptureProfileID' must be defined.");
        url_ = url_.replace("{userSelectionCaptureProfileID}", encodeURIComponent("" + userSelectionCaptureProfileID));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSingleUserSelectionCaptureProfileID(_response);
        });
    }

    protected processSingleUserSelectionCaptureProfileID(response: Response): Promise<IResultOfCapturePointListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResultOfCapturePointListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResultOfCapturePointListDTO>(null as any);
    }

    userSelectionCaptureProfileID(robotID: number, imagingID: number, includeOverview: boolean, userSelectionCaptureProfileIDs: number[] | null | undefined, plateID: string): Promise<IResultOfCapturePointListDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-points-by-imaging-id-user-selection/{robotId}/{plateID}/{imagingID}/{includeOverview}?";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (imagingID === undefined || imagingID === null)
            throw new globalThis.Error("The parameter 'imagingID' must be defined.");
        url_ = url_.replace("{imagingID}", encodeURIComponent("" + imagingID));
        if (includeOverview === undefined || includeOverview === null)
            throw new globalThis.Error("The parameter 'includeOverview' must be defined.");
        url_ = url_.replace("{includeOverview}", encodeURIComponent("" + includeOverview));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (userSelectionCaptureProfileIDs !== undefined && userSelectionCaptureProfileIDs !== null)
            userSelectionCaptureProfileIDs && userSelectionCaptureProfileIDs.forEach(item => { url_ += "userSelectionCaptureProfileIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserSelectionCaptureProfileID(_response);
        });
    }

    protected processUserSelectionCaptureProfileID(response: Response): Promise<IResultOfCapturePointListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResultOfCapturePointListDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResultOfCapturePointListDTO>(null as any);
    }
}

export class GetParentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withRobotId(childCaptureProfileID: number, robotId: string): Promise<ResultWithValueOfPropertyDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/parent/{robotId}/{childCaptureProfileID}";
        if (childCaptureProfileID === undefined || childCaptureProfileID === null)
            throw new globalThis.Error("The parameter 'childCaptureProfileID' must be defined.");
        url_ = url_.replace("{childCaptureProfileID}", encodeURIComponent("" + childCaptureProfileID));
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithRobotId(_response);
        });
    }

    protected processWithRobotId(response: Response): Promise<ResultWithValueOfPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfPropertyDTO>(null as any);
    }
}

export class GetChildrenClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withRobotId(parentCaptureProfileID: number, robotId: string): Promise<ResultWithValueOfListOfPropertyDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/children/{robotId}/{parentCaptureProfileID}";
        if (parentCaptureProfileID === undefined || parentCaptureProfileID === null)
            throw new globalThis.Error("The parameter 'parentCaptureProfileID' must be defined.");
        url_ = url_.replace("{parentCaptureProfileID}", encodeURIComponent("" + parentCaptureProfileID));
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithRobotId(_response);
        });
    }

    protected processWithRobotId(response: Response): Promise<ResultWithValueOfListOfPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPropertyDTO>(null as any);
    }
}

export class ImagerLinkCaptureProfileInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getCaptureProfile(robotID: number, captureProfileID: number): Promise<ResultWithValueOfCaptureProfileDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-profile/{robotID}/{captureProfileID}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (captureProfileID === undefined || captureProfileID === null)
            throw new globalThis.Error("The parameter 'captureProfileID' must be defined.");
        url_ = url_.replace("{captureProfileID}", encodeURIComponent("" + captureProfileID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptureProfile(_response);
        });
    }

    protected processGetCaptureProfile(response: Response): Promise<ResultWithValueOfCaptureProfileDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfCaptureProfileDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfCaptureProfileDTO>(null as any);
    }

    getCaptureProfilesByPropertyName(robotID: number, capturePropertyNameFilters: string[] | null | undefined): Promise<ResultWithValueOfListOfPropertyDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-profiles-by-property-name/{robotID}?";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (capturePropertyNameFilters !== undefined && capturePropertyNameFilters !== null)
            capturePropertyNameFilters && capturePropertyNameFilters.forEach(item => { url_ += "capturePropertyNameFilters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptureProfilesByPropertyName(_response);
        });
    }

    protected processGetCaptureProfilesByPropertyName(response: Response): Promise<ResultWithValueOfListOfPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPropertyDTO>(null as any);
    }

    getCaptureProfilesByFilter(request: GetCaptureProfilesByFilterRequestDTO): Promise<ResultWithValueOfListOfPropertyDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-profiles-by-filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptureProfilesByFilter(_response);
        });
    }

    protected processGetCaptureProfilesByFilter(response: Response): Promise<ResultWithValueOfListOfPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPropertyDTO>(null as any);
    }

    getCaptureProfiles(): Promise<ResultWithValueOfListOfPropertyDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/capture-profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptureProfiles(_response);
        });
    }

    protected processGetCaptureProfiles(response: Response): Promise<ResultWithValueOfListOfPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPropertyDTO>(null as any);
    }

    getParent(childCaptureProfileID: number): Promise<ResultWithValueOfPropertyDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/parent/{childCaptureProfileID}";
        if (childCaptureProfileID === undefined || childCaptureProfileID === null)
            throw new globalThis.Error("The parameter 'childCaptureProfileID' must be defined.");
        url_ = url_.replace("{childCaptureProfileID}", encodeURIComponent("" + childCaptureProfileID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParent(_response);
        });
    }

    protected processGetParent(response: Response): Promise<ResultWithValueOfPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfPropertyDTO>(null as any);
    }

    getChildren(parentCaptureProfileID: number): Promise<ResultWithValueOfListOfPropertyDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/children/{parentCaptureProfileID}";
        if (parentCaptureProfileID === undefined || parentCaptureProfileID === null)
            throw new globalThis.Error("The parameter 'parentCaptureProfileID' must be defined.");
        url_ = url_.replace("{parentCaptureProfileID}", encodeURIComponent("" + parentCaptureProfileID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChildren(_response);
        });
    }

    protected processGetChildren(response: Response): Promise<ResultWithValueOfListOfPropertyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPropertyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPropertyDTO>(null as any);
    }
}

export class ImagerLinkDropLocationInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    isDropLocationOverrideExistsByPlateIDs(plateIDs: number[] | null | undefined): Promise<ResultWithValueOfBoolean> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/drop-location-override-exist-by-plate-ids?";
        if (plateIDs !== undefined && plateIDs !== null)
            plateIDs && plateIDs.forEach(item => { url_ += "plateIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsDropLocationOverrideExistsByPlateIDs(_response);
        });
    }

    protected processIsDropLocationOverrideExistsByPlateIDs(response: Response): Promise<ResultWithValueOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfBoolean>(null as any);
    }

    isDropLocationOverrideExistsByPlateWellDrop(plateID: number, wellNumber: number, dropNumber: number): Promise<ResultWithValueOfBoolean> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/drop-location-override-exist-by-plate-well-drop/{plateID}/{wellNumber}/{dropNumber}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsDropLocationOverrideExistsByPlateWellDrop(_response);
        });
    }

    protected processIsDropLocationOverrideExistsByPlateWellDrop(response: Response): Promise<ResultWithValueOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfBoolean>(null as any);
    }
}

export class ImagerLinkDropLocationOverrideInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    clearDropLocationOverrideByPlateIDs(request: ClearDropLocationOverrideRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/clear-drop-location-override-by-plate-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClearDropLocationOverrideByPlateIDs(_response);
        });
    }

    protected processClearDropLocationOverrideByPlateIDs(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    clearDropLocationOverrideByPlateWellDrop(request: ClearDropLocationOverrideByPlateWellDropRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/clear-drop-location-override-by-plate-well-drop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClearDropLocationOverrideByPlateWellDrop(_response);
        });
    }

    protected processClearDropLocationOverrideByPlateWellDrop(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class ImagerLinkDropProcessingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    setMarkDone(request: MarkDoneRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/mark-done";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMarkDone(_response);
        });
    }

    protected processSetMarkDone(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class ImagerLinkGroupNotificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    setMailSendingStatus(request: MailSendingStatusRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/mail-sending-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMailSendingStatus(_response);
        });
    }

    protected processSetMailSendingStatus(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getNotificationType(barcode: string): Promise<ResultWithValueOfInteger> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/notification-type/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new globalThis.Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotificationType(_response);
        });
    }

    protected processGetNotificationType(response: Response): Promise<ResultWithValueOfInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfInteger.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfInteger>(null as any);
    }

    getGroups(includeDefaultGroup: boolean): Promise<ResultWithValueOfListOfGroupDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/groups/{includeDefaultGroup}";
        if (includeDefaultGroup === undefined || includeDefaultGroup === null)
            throw new globalThis.Error("The parameter 'includeDefaultGroup' must be defined.");
        url_ = url_.replace("{includeDefaultGroup}", encodeURIComponent("" + includeDefaultGroup));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: Response): Promise<ResultWithValueOfListOfGroupDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfGroupDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfGroupDTO>(null as any);
    }

    getUserGroups(robotID: number, plateID: number): Promise<ResultWithValueOfListOfUserGroupDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/user-groups/{plateID}/{robotID}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGroups(_response);
        });
    }

    protected processGetUserGroups(response: Response): Promise<ResultWithValueOfListOfUserGroupDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfUserGroupDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfUserGroupDTO>(null as any);
    }
}

export class ImagerLinkImageNowClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getImageNowImagingTasks(): Promise<ResultWithValueOfListOfImageNowDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/image-now-imaging-tasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImageNowImagingTasks(_response);
        });
    }

    protected processGetImageNowImagingTasks(response: Response): Promise<ResultWithValueOfListOfImageNowDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfImageNowDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfImageNowDTO>(null as any);
    }

    getImageNowTasks(): Promise<ResultWithValueOfListOfImageNowBarcodeDto> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/image-now-task";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImageNowTasks(_response);
        });
    }

    protected processGetImageNowTasks(response: Response): Promise<ResultWithValueOfListOfImageNowBarcodeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfImageNowBarcodeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfImageNowBarcodeDto>(null as any);
    }

    setImageNowTasksHandled(request: ImageNowTasksHandledRequestDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/image-now-tasks-handled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetImageNowTasksHandled(_response);
        });
    }

    protected processSetImageNowTasksHandled(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getImageNowImagingTasks2(robotId: number): Promise<ResultWithValueOfListOfImageNowDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/image-now-imaging-tasks/{robotId}";
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImageNowImagingTasks2(_response);
        });
    }

    protected processGetImageNowImagingTasks2(response: Response): Promise<ResultWithValueOfListOfImageNowDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfImageNowDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfImageNowDTO>(null as any);
    }
}

export class ImagerLinkImagingCaptureClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getFirstDrop(plateID: number, robotId: string, wellNumber: string, dropNumber: string): Promise<ResultWithValueOfWellDropDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/first-drop/{robotId}/{plateID}/{wellNumber}/{dropNumber}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFirstDrop(_response);
        });
    }

    protected processGetFirstDrop(response: Response): Promise<ResultWithValueOfWellDropDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfWellDropDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfWellDropDTO>(null as any);
    }
}

export class ImagerLinkLegacyRiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    setDefaultCompositeThreshold(request: SetDefaultCompositeThresholdRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/default-composite-threshold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDefaultCompositeThreshold(_response);
        });
    }

    protected processSetDefaultCompositeThreshold(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    setRobot(request: SetRobotRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/robot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetRobot(_response);
        });
    }

    protected processSetRobot(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    setOriginalDefaultCompositeThreshold(request: SetOriginalDefaultCompositeThresholdRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/original-default-composite-threshold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetOriginalDefaultCompositeThreshold(_response);
        });
    }

    protected processSetOriginalDefaultCompositeThreshold(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getOriginalDefaultCompositeThreshold(imageTypeID: number): Promise<ResultWithValueOfDouble> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/original-default-composite-threshold/{imageTypeID}";
        if (imageTypeID === undefined || imageTypeID === null)
            throw new globalThis.Error("The parameter 'imageTypeID' must be defined.");
        url_ = url_.replace("{imageTypeID}", encodeURIComponent("" + imageTypeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOriginalDefaultCompositeThreshold(_response);
        });
    }

    protected processGetOriginalDefaultCompositeThreshold(response: Response): Promise<ResultWithValueOfDouble> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfDouble.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfDouble>(null as any);
    }

    getMaxCompositeThreshold(): Promise<ResultWithValueOfSingle> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/max-composite-threshold";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMaxCompositeThreshold(_response);
        });
    }

    protected processGetMaxCompositeThreshold(response: Response): Promise<ResultWithValueOfSingle> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfSingle.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfSingle>(null as any);
    }

    getImageClass(imageData: AutoScoreImageDataDTO): Promise<ResultWithValueOfEAutoScoreImageClass> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/image-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imageData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImageClass(_response);
        });
    }

    protected processGetImageClass(response: Response): Promise<ResultWithValueOfEAutoScoreImageClass> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfEAutoScoreImageClass.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfEAutoScoreImageClass>(null as any);
    }

    getMinCompositeThreshold(): Promise<ResultWithValueOfSingle> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/min-composite-threshold";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMinCompositeThreshold(_response);
        });
    }

    protected processGetMinCompositeThreshold(response: Response): Promise<ResultWithValueOfSingle> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfSingle.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfSingle>(null as any);
    }

    getSupportedImageTypes(): Promise<ResultWithValueOfListOfAutoScoreImageTypeDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/supported-image-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSupportedImageTypes(_response);
        });
    }

    protected processGetSupportedImageTypes(response: Response): Promise<ResultWithValueOfListOfAutoScoreImageTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfAutoScoreImageTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfAutoScoreImageTypeDTO>(null as any);
    }

    getIsImageNowSupported(robotID: number): Promise<ResultWithValueOfBoolean> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/is-image-now-supported/{robotID}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIsImageNowSupported(_response);
        });
    }

    protected processGetIsImageNowSupported(response: Response): Promise<ResultWithValueOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfBoolean>(null as any);
    }

    setImagingSetting(imagingSettingDefinition: ImagingSettingDefinitionDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/imaging-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imagingSettingDefinition);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetImagingSetting(_response);
        });
    }

    protected processSetImagingSetting(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    setFrapConfig(request: FrapConfigDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/set-frap-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetFrapConfig(_response);
        });
    }

    protected processSetFrapConfig(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getImagingSetting(robotID: number): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/imaging-setting/{robotID}";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImagingSetting(_response);
        });
    }

    protected processGetImagingSetting(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }

    setPlateStateAtImager(request: SetPlateStateAtImagerRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plate-state-at-imager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPlateStateAtImager(_response);
        });
    }

    protected processSetPlateStateAtImager(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    setPlates(request: SetPlatesRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPlates(_response);
        });
    }

    protected processSetPlates(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class GetPlateTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withRobotId(robotId: string): Promise<ResultWithValueOfListOfPlateTypeDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plate-types/{robotId}";
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithRobotId(_response);
        });
    }

    protected processWithRobotId(response: Response): Promise<ResultWithValueOfListOfPlateTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPlateTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPlateTypeDTO>(null as any);
    }
}

export class GetPlateTypeByIDClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withRobotId(plateTypeID: number, robotId: string): Promise<ResultWithValueOfPlateTypeDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plate-type/{robotId}/{plateTypeID}";
        if (plateTypeID === undefined || plateTypeID === null)
            throw new globalThis.Error("The parameter 'plateTypeID' must be defined.");
        url_ = url_.replace("{plateTypeID}", encodeURIComponent("" + plateTypeID));
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithRobotId(_response);
        });
    }

    protected processWithRobotId(response: Response): Promise<ResultWithValueOfPlateTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfPlateTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfPlateTypeDTO>(null as any);
    }
}

export class ImagerLinkPlateInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getPlateTypesByIDs(plateTypeIDs: number[] | null | undefined, robotID: string): Promise<ResultWithValueOfListOfPlateTypeDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plate-types-by-ids/{robotID}?";
        if (robotID === undefined || robotID === null)
            throw new globalThis.Error("The parameter 'robotID' must be defined.");
        url_ = url_.replace("{robotID}", encodeURIComponent("" + robotID));
        if (plateTypeIDs !== undefined && plateTypeIDs !== null)
            plateTypeIDs && plateTypeIDs.forEach(item => { url_ += "plateTypeIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateTypesByIDs(_response);
        });
    }

    protected processGetPlateTypesByIDs(response: Response): Promise<ResultWithValueOfListOfPlateTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPlateTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPlateTypeDTO>(null as any);
    }

    getFullpath(plateID: number): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/full-path/{plateID}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFullpath(_response);
        });
    }

    protected processGetFullpath(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }

    updatePlateInfo(robotId: number, plateID: number, experimentName: string, projectName: string, userName: string, userEmail: string, plateTypeID: number, plateNumber: number, dateDispensed: Date): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/update-plate-info/{robotId}/{plateID}/{experimentName}/{projectName}/{userName}/{userEmail}/{plateTypeID}/{plateNumber}/{dateDispensed}";
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (experimentName === undefined || experimentName === null)
            throw new globalThis.Error("The parameter 'experimentName' must be defined.");
        url_ = url_.replace("{experimentName}", encodeURIComponent("" + experimentName));
        if (projectName === undefined || projectName === null)
            throw new globalThis.Error("The parameter 'projectName' must be defined.");
        url_ = url_.replace("{projectName}", encodeURIComponent("" + projectName));
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        if (userEmail === undefined || userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' must be defined.");
        url_ = url_.replace("{userEmail}", encodeURIComponent("" + userEmail));
        if (plateTypeID === undefined || plateTypeID === null)
            throw new globalThis.Error("The parameter 'plateTypeID' must be defined.");
        url_ = url_.replace("{plateTypeID}", encodeURIComponent("" + plateTypeID));
        if (plateNumber === undefined || plateNumber === null)
            throw new globalThis.Error("The parameter 'plateNumber' must be defined.");
        url_ = url_.replace("{plateNumber}", encodeURIComponent("" + plateNumber));
        if (dateDispensed === undefined || dateDispensed === null)
            throw new globalThis.Error("The parameter 'dateDispensed' must be defined.");
        url_ = url_.replace("{dateDispensed}", encodeURIComponent(dateDispensed ? "" + dateDispensed.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePlateInfo(_response);
        });
    }

    protected processUpdatePlateInfo(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getPlateTypes(): Promise<ResultWithValueOfListOfPlateTypeDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/plate-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateTypes(_response);
        });
    }

    protected processGetPlateTypes(response: Response): Promise<ResultWithValueOfListOfPlateTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPlateTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPlateTypeDTO>(null as any);
    }

    getPlateTypeByID(plateTypeID: number): Promise<ResultWithValueOfPlateTypeDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/plate-type/{plateTypeID}";
        if (plateTypeID === undefined || plateTypeID === null)
            throw new globalThis.Error("The parameter 'plateTypeID' must be defined.");
        url_ = url_.replace("{plateTypeID}", encodeURIComponent("" + plateTypeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateTypeByID(_response);
        });
    }

    protected processGetPlateTypeByID(response: Response): Promise<ResultWithValueOfPlateTypeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfPlateTypeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfPlateTypeDTO>(null as any);
    }

    getPlateInfo(plateID: number): Promise<ResultWithValueOfPlateInfoDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/plate-info/{plateID}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateInfo(_response);
        });
    }

    protected processGetPlateInfo(response: Response): Promise<ResultWithValueOfPlateInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfPlateInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfPlateInfoDTO>(null as any);
    }

    getPlateInfos(plateID: number[] | null | undefined): Promise<ResultWithValueOfListOfPlateInfoDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/plate-infos?";
        if (plateID !== undefined && plateID !== null)
            plateID && plateID.forEach(item => { url_ += "plateID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateInfos(_response);
        });
    }

    protected processGetPlateInfos(response: Response): Promise<ResultWithValueOfListOfPlateInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPlateInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPlateInfoDTO>(null as any);
    }

    getPlateID(barcode: string): Promise<ResultWithValueOfLong> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/plate-id/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new globalThis.Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateID(_response);
        });
    }

    protected processGetPlateID(response: Response): Promise<ResultWithValueOfLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfLong.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfLong>(null as any);
    }

    getPlateIDs(barcode: string[] | null | undefined): Promise<ResultWithValueOfListOfLong> {
        let url_ = this.baseUrl + "/api/integrations/v1.1/imager-link/plate-ids?";
        if (barcode !== undefined && barcode !== null)
            barcode && barcode.forEach(item => { url_ += "barcode=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlateIDs(_response);
        });
    }

    protected processGetPlateIDs(response: Response): Promise<ResultWithValueOfListOfLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfLong.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfLong>(null as any);
    }
}

export class GetPlateInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withRobotId(plateID: number, robotId: string): Promise<ResultWithValueOfPlateInfoDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plate-info/{robotId}/{plateID}";
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithRobotId(_response);
        });
    }

    protected processWithRobotId(response: Response): Promise<ResultWithValueOfPlateInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfPlateInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfPlateInfoDTO>(null as any);
    }
}

export class GetPlateInfosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withRobotID(plateIDs: number[] | null | undefined, robotId: string): Promise<ResultWithValueOfListOfPlateInfoDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plate-infos/{robotId}?";
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        if (plateIDs !== undefined && plateIDs !== null)
            plateIDs && plateIDs.forEach(item => { url_ += "plateIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithRobotID(_response);
        });
    }

    protected processWithRobotID(response: Response): Promise<ResultWithValueOfListOfPlateInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfPlateInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfPlateInfoDTO>(null as any);
    }
}

export class GetPlateIDClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withRobotId(barcode: string, robotId: string): Promise<ResultWithValueOfLong> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plate-id/{robotId}/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new globalThis.Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithRobotId(_response);
        });
    }

    protected processWithRobotId(response: Response): Promise<ResultWithValueOfLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfLong.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfLong>(null as any);
    }
}

export class GetPlateIDsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    withRobotId(barcode: string[] | null | undefined, robotId: string): Promise<ResultWithValueOfListOfLong> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/plate-ids/{robotId}?";
        if (robotId === undefined || robotId === null)
            throw new globalThis.Error("The parameter 'robotId' must be defined.");
        url_ = url_.replace("{robotId}", encodeURIComponent("" + robotId));
        if (barcode !== undefined && barcode !== null)
            barcode && barcode.forEach(item => { url_ += "barcode=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithRobotId(_response);
        });
    }

    protected processWithRobotId(response: Response): Promise<ResultWithValueOfListOfLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfLong.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfLong>(null as any);
    }
}

export class ImagerLinkQuickImagingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getIncubationTemperatures(): Promise<ResultWithValueOfListOfIncubationTemperatureDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/incubation-temperatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIncubationTemperatures(_response);
        });
    }

    protected processGetIncubationTemperatures(response: Response): Promise<ResultWithValueOfListOfIncubationTemperatureDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfIncubationTemperatureDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfIncubationTemperatureDTO>(null as any);
    }

    createExperimentPlate(request: CreateExperimentRequestDTO): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/create-experiment-plate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateExperimentPlate(_response);
        });
    }

    protected processCreateExperimentPlate(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }
}

export class ImagerLinkScoreClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getScore(imageBatchID: number, plateID: number, wellNumber: number, dropNumber: number, wellDropScoreGroupID: number): Promise<ResultWithValueOfDouble> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/score/{imageBatchID}/{plateID}/{wellNumber}/{dropNumber}/{wellDropScoreGroupID}";
        if (imageBatchID === undefined || imageBatchID === null)
            throw new globalThis.Error("The parameter 'imageBatchID' must be defined.");
        url_ = url_.replace("{imageBatchID}", encodeURIComponent("" + imageBatchID));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (wellDropScoreGroupID === undefined || wellDropScoreGroupID === null)
            throw new globalThis.Error("The parameter 'wellDropScoreGroupID' must be defined.");
        url_ = url_.replace("{wellDropScoreGroupID}", encodeURIComponent("" + wellDropScoreGroupID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScore(_response);
        });
    }

    protected processGetScore(response: Response): Promise<ResultWithValueOfDouble> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfDouble.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfDouble>(null as any);
    }

    getScoreGroups(): Promise<ResultWithValueOfListOfScoreGroupDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/score-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScoreGroups(_response);
        });
    }

    protected processGetScoreGroups(response: Response): Promise<ResultWithValueOfListOfScoreGroupDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfScoreGroupDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfScoreGroupDTO>(null as any);
    }

    getScoreByCaptureProfileID(imageBatchID: number, plateID: number, wellNumber: number, dropNumber: number, wellDropScoreGroupID: number, captureProfileID: number): Promise<ResultWithValueOfDouble> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/score-by-capture-profile-id/{imageBatchID}/{captureProfileID}/{plateID}/{wellNumber}/{dropNumber}/{wellDropScoreGroupID}";
        if (imageBatchID === undefined || imageBatchID === null)
            throw new globalThis.Error("The parameter 'imageBatchID' must be defined.");
        url_ = url_.replace("{imageBatchID}", encodeURIComponent("" + imageBatchID));
        if (plateID === undefined || plateID === null)
            throw new globalThis.Error("The parameter 'plateID' must be defined.");
        url_ = url_.replace("{plateID}", encodeURIComponent("" + plateID));
        if (wellNumber === undefined || wellNumber === null)
            throw new globalThis.Error("The parameter 'wellNumber' must be defined.");
        url_ = url_.replace("{wellNumber}", encodeURIComponent("" + wellNumber));
        if (dropNumber === undefined || dropNumber === null)
            throw new globalThis.Error("The parameter 'dropNumber' must be defined.");
        url_ = url_.replace("{dropNumber}", encodeURIComponent("" + dropNumber));
        if (wellDropScoreGroupID === undefined || wellDropScoreGroupID === null)
            throw new globalThis.Error("The parameter 'wellDropScoreGroupID' must be defined.");
        url_ = url_.replace("{wellDropScoreGroupID}", encodeURIComponent("" + wellDropScoreGroupID));
        if (captureProfileID === undefined || captureProfileID === null)
            throw new globalThis.Error("The parameter 'captureProfileID' must be defined.");
        url_ = url_.replace("{captureProfileID}", encodeURIComponent("" + captureProfileID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScoreByCaptureProfileID(_response);
        });
    }

    protected processGetScoreByCaptureProfileID(response: Response): Promise<ResultWithValueOfDouble> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfDouble.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfDouble>(null as any);
    }

    getAutoScoreCompositeThreshold(request: GetAutoScoreCompositeThresholdRequestDTO): Promise<ResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/auto-score-composite-thresholds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAutoScoreCompositeThreshold(_response);
        });
    }

    protected processGetAutoScoreCompositeThreshold(response: Response): Promise<ResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle>(null as any);
    }

    setScore(request: SetScoreRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/score";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetScore(_response);
        });
    }

    protected processSetScore(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    setScoreByCaptureProfile(request: SetScoreRequestDTO): Promise<Result> {
        let url_ = this.baseUrl + "/api/integrations/v1/imager-link/score-by-capture-profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetScoreByCaptureProfile(_response);
        });
    }

    protected processSetScoreByCaptureProfile(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class FormulatorClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    setMarkAsDispensed(request: MarkAsDispensedRequestDto2): Promise<IResult> {
        let url_ = this.baseUrl + "/api/integrations/v1/formulator/mark-as-dispensed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMarkAsDispensed(_response);
        });
    }

    protected processSetMarkAsDispensed(response: Response): Promise<IResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IResult>(null as any);
    }

    getDispenseListAsToken(barcode: string): Promise<ResultWithValueOfListOfListOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/formulator/dispense-list-as-token/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new globalThis.Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDispenseListAsToken(_response);
        });
    }

    protected processGetDispenseListAsToken(response: Response): Promise<ResultWithValueOfListOfListOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfListOfListOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfListOfListOfString>(null as any);
    }

    getDispenseList(barcode: string): Promise<ResultWithValueOfString> {
        let url_ = this.baseUrl + "/api/integrations/v1/formulator/dispense-list/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new globalThis.Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDispenseList(_response);
        });
    }

    protected processGetDispenseList(response: Response): Promise<ResultWithValueOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithValueOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithValueOfString>(null as any);
    }
}

export class OptimizationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:51725";
    }

    getAllIngredientStocks(pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<PaginatedIngredientStocksDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/ai/Optimization/all_ingredient_stocks?";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllIngredientStocks(_response);
        });
    }

    protected processGetAllIngredientStocks(response: Response): Promise<PaginatedIngredientStocksDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedIngredientStocksDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedIngredientStocksDTO>(null as any);
    }

    getAllIngredientStocksCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/integrations/v1/ai/Optimization/all_ingredient_stocks_count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllIngredientStocksCount(_response);
        });
    }

    protected processGetAllIngredientStocksCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAllProteinFormulations(startDate: Date | null | undefined, endDate: Date | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<PaginatedProteinFormulationsDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/ai/Optimization/all_protein_formulation?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProteinFormulations(_response);
        });
    }

    protected processGetAllProteinFormulations(response: Response): Promise<PaginatedProteinFormulationsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedProteinFormulationsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedProteinFormulationsDTO>(null as any);
    }

    getAllProteinFormulationsCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/integrations/v1/ai/Optimization/all_protein_formulation_count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllProteinFormulationsCount(_response);
        });
    }

    protected processGetAllProteinFormulationsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getExperimentData(proteinFormulationId: number | null | undefined, experimentId: number | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<PaginatedDropDetailsDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/ai/Optimization/experiment_data?";
        if (proteinFormulationId !== undefined && proteinFormulationId !== null)
            url_ += "proteinFormulationId=" + encodeURIComponent("" + proteinFormulationId) + "&";
        if (experimentId !== undefined && experimentId !== null)
            url_ += "experimentId=" + encodeURIComponent("" + experimentId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentData(_response);
        });
    }

    protected processGetExperimentData(response: Response): Promise<PaginatedDropDetailsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedDropDetailsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedDropDetailsDTO>(null as any);
    }

    getExperimentDataCount(proteinFormulationId: number | null | undefined, experimentId: number | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/integrations/v1/ai/Optimization/experiment_data_count?";
        if (proteinFormulationId !== undefined && proteinFormulationId !== null)
            url_ += "proteinFormulationId=" + encodeURIComponent("" + proteinFormulationId) + "&";
        if (experimentId !== undefined && experimentId !== null)
            url_ += "experimentId=" + encodeURIComponent("" + experimentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperimentDataCount(_response);
        });
    }

    protected processGetExperimentDataCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    listExperiments(includeScreens: boolean | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<PaginatedExperimentInfoDTO> {
        let url_ = this.baseUrl + "/api/integrations/v1/ai/Optimization/list_experiments?";
        if (includeScreens === null)
            throw new globalThis.Error("The parameter 'includeScreens' cannot be null.");
        else if (includeScreens !== undefined)
            url_ += "includeScreens=" + encodeURIComponent("" + includeScreens) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListExperiments(_response);
        });
    }

    protected processListExperiments(response: Response): Promise<PaginatedExperimentInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedExperimentInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedExperimentInfoDTO>(null as any);
    }

    listExperimentsCount(includeScreens: boolean | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/integrations/v1/ai/Optimization/list_experiments_count?";
        if (includeScreens === null)
            throw new globalThis.Error("The parameter 'includeScreens' cannot be null.");
        else if (includeScreens !== undefined)
            url_ += "includeScreens=" + encodeURIComponent("" + includeScreens) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListExperimentsCount(_response);
        });
    }

    protected processListExperimentsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ResponseDTO implements IResponseDTO {
    message?: string | undefined;
    responseType!: ResponseType;

    constructor(data?: IResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.responseType = _data["responseType"];
        }
    }

    static fromJS(data: any): ResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["responseType"] = this.responseType;
        return data;
    }
}

export interface IResponseDTO {
    message?: string | undefined;
    responseType: ResponseType;
}

export class ResponseWithValueDTOOfListOfPreviewResultRowDTO extends ResponseDTO implements IResponseWithValueDTOOfListOfPreviewResultRowDTO {
    value?: PreviewResultRowDTO[] | undefined;

    constructor(data?: IResponseWithValueDTOOfListOfPreviewResultRowDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(PreviewResultRowDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfListOfPreviewResultRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfListOfPreviewResultRowDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfListOfPreviewResultRowDTO extends IResponseDTO {
    value?: PreviewResultRowDTO[] | undefined;
}

export class PreviewResultRowDTO implements IPreviewResultRowDTO {
    id!: number;
    treeNodeId!: number;
    name?: string | undefined;
    dateCreated!: Date;
    path?: string | undefined;
    inspectionDate?: Date | undefined;
    isArchived!: boolean;

    constructor(data?: IPreviewResultRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.name = _data["name"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.path = _data["path"];
            this.inspectionDate = _data["inspectionDate"] ? new Date(_data["inspectionDate"].toString()) : undefined as any;
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): PreviewResultRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewResultRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["name"] = this.name;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["path"] = this.path;
        data["inspectionDate"] = this.inspectionDate ? this.inspectionDate.toISOString() : undefined as any;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IPreviewResultRowDTO {
    id: number;
    treeNodeId: number;
    name?: string | undefined;
    dateCreated: Date;
    path?: string | undefined;
    inspectionDate?: Date | undefined;
    isArchived: boolean;
}

export enum ResponseType {
    None = 0,
    Warning = 1,
    Info = 2,
    Ask = 3,
    Error = 4,
    Exception = 5,
    Success = 6,
}

export class PreviewFiltersDTO implements IPreviewFiltersDTO {
    type!: EPreviewFilterType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    filterByField!: EPreviewFilterField;
    olderThanValue?: number | undefined;
    olderThanUnit?: EOlderThanUnit | undefined;
    selectedTreeNodeIds?: number[] | undefined;

    constructor(data?: IPreviewFiltersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.filterByField = _data["filterByField"];
            this.olderThanValue = _data["olderThanValue"];
            this.olderThanUnit = _data["olderThanUnit"];
            if (Array.isArray(_data["selectedTreeNodeIds"])) {
                this.selectedTreeNodeIds = [] as any;
                for (let item of _data["selectedTreeNodeIds"])
                    this.selectedTreeNodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PreviewFiltersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewFiltersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["filterByField"] = this.filterByField;
        data["olderThanValue"] = this.olderThanValue;
        data["olderThanUnit"] = this.olderThanUnit;
        if (Array.isArray(this.selectedTreeNodeIds)) {
            data["selectedTreeNodeIds"] = [];
            for (let item of this.selectedTreeNodeIds)
                data["selectedTreeNodeIds"].push(item);
        }
        return data;
    }
}

export interface IPreviewFiltersDTO {
    type: EPreviewFilterType;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    filterByField: EPreviewFilterField;
    olderThanValue?: number | undefined;
    olderThanUnit?: EOlderThanUnit | undefined;
    selectedTreeNodeIds?: number[] | undefined;
}

export enum EPreviewFilterType {
    None = 0,
    OlderThan = 1,
    DateRange = 2,
}

export enum EPreviewFilterField {
    None = 0,
    CreationDate = 1,
    InspectionDate = 2,
}

export enum EOlderThanUnit {
    Days = 0,
    Months = 1,
    Years = 2,
}

export class ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO extends ResponseDTO implements IResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO {
    value?: ArchivingJobExperimentResultDTO[] | undefined;

    constructor(data?: IResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ArchivingJobExperimentResultDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfListOfArchivingJobExperimentResultDTO extends IResponseDTO {
    value?: ArchivingJobExperimentResultDTO[] | undefined;
}

export class ArchivingJobExperimentResultDTO implements IArchivingJobExperimentResultDTO {
    experimentId!: number;
    experimentName?: string | undefined;
    originalLocation?: string | undefined;
    currentLocation?: string | undefined;
    dateCreated?: Date | undefined;
    inspectionDate?: Date | undefined;
    archivedDate?: Date | undefined;
    restoredDate?: Date | undefined;
    status!: ArchivingJobExperimentStatusDto;
    errorMessage?: string | undefined;
    newExperimentId?: number | undefined;

    constructor(data?: IArchivingJobExperimentResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.experimentName = _data["experimentName"];
            this.originalLocation = _data["originalLocation"];
            this.currentLocation = _data["currentLocation"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.inspectionDate = _data["inspectionDate"] ? new Date(_data["inspectionDate"].toString()) : undefined as any;
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : undefined as any;
            this.restoredDate = _data["restoredDate"] ? new Date(_data["restoredDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.errorMessage = _data["errorMessage"];
            this.newExperimentId = _data["newExperimentId"];
        }
    }

    static fromJS(data: any): ArchivingJobExperimentResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingJobExperimentResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["experimentName"] = this.experimentName;
        data["originalLocation"] = this.originalLocation;
        data["currentLocation"] = this.currentLocation;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["inspectionDate"] = this.inspectionDate ? this.inspectionDate.toISOString() : undefined as any;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : undefined as any;
        data["restoredDate"] = this.restoredDate ? this.restoredDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        data["newExperimentId"] = this.newExperimentId;
        return data;
    }
}

export interface IArchivingJobExperimentResultDTO {
    experimentId: number;
    experimentName?: string | undefined;
    originalLocation?: string | undefined;
    currentLocation?: string | undefined;
    dateCreated?: Date | undefined;
    inspectionDate?: Date | undefined;
    archivedDate?: Date | undefined;
    restoredDate?: Date | undefined;
    status: ArchivingJobExperimentStatusDto;
    errorMessage?: string | undefined;
    newExperimentId?: number | undefined;
}

export enum ArchivingJobExperimentStatusDto {
    Pending = 0,
    Running = 1,
    Completed = 2,
    Failed = 3,
}

export class RunArchivingDTO implements IRunArchivingDTO {
    name?: string | undefined;
    experiments?: RunArchivingExperimentDTO[] | undefined;

    constructor(data?: IRunArchivingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["experiments"])) {
                this.experiments = [] as any;
                for (let item of _data["experiments"])
                    this.experiments!.push(RunArchivingExperimentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RunArchivingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RunArchivingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.experiments)) {
            data["experiments"] = [];
            for (let item of this.experiments)
                data["experiments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRunArchivingDTO {
    name?: string | undefined;
    experiments?: RunArchivingExperimentDTO[] | undefined;
}

export class RunArchivingExperimentDTO implements IRunArchivingExperimentDTO {
    experimentId!: number;
    experimentName?: string | undefined;
    originalLocation?: string | undefined;
    dateCreated!: Date;
    inspectionDate?: Date | undefined;

    constructor(data?: IRunArchivingExperimentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.experimentName = _data["experimentName"];
            this.originalLocation = _data["originalLocation"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.inspectionDate = _data["inspectionDate"] ? new Date(_data["inspectionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RunArchivingExperimentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RunArchivingExperimentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["experimentName"] = this.experimentName;
        data["originalLocation"] = this.originalLocation;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["inspectionDate"] = this.inspectionDate ? this.inspectionDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IRunArchivingExperimentDTO {
    experimentId: number;
    experimentName?: string | undefined;
    originalLocation?: string | undefined;
    dateCreated: Date;
    inspectionDate?: Date | undefined;
}

export class RunUnarchiveDTO implements IRunUnarchiveDTO {
    projectName?: string | undefined;
    experiments?: RunUnarchiveExperimentDTO[] | undefined;

    constructor(data?: IRunUnarchiveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            if (Array.isArray(_data["experiments"])) {
                this.experiments = [] as any;
                for (let item of _data["experiments"])
                    this.experiments!.push(RunUnarchiveExperimentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RunUnarchiveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RunUnarchiveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        if (Array.isArray(this.experiments)) {
            data["experiments"] = [];
            for (let item of this.experiments)
                data["experiments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRunUnarchiveDTO {
    projectName?: string | undefined;
    experiments?: RunUnarchiveExperimentDTO[] | undefined;
}

export class RunUnarchiveExperimentDTO implements IRunUnarchiveExperimentDTO {
    experimentId!: number;
    experimentName?: string | undefined;
    originalLocation?: string | undefined;
    dateCreated?: Date | undefined;
    inspectionDate?: Date | undefined;
    archivedDate?: Date | undefined;

    constructor(data?: IRunUnarchiveExperimentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.experimentName = _data["experimentName"];
            this.originalLocation = _data["originalLocation"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.inspectionDate = _data["inspectionDate"] ? new Date(_data["inspectionDate"].toString()) : undefined as any;
            this.archivedDate = _data["archivedDate"] ? new Date(_data["archivedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RunUnarchiveExperimentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RunUnarchiveExperimentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["experimentName"] = this.experimentName;
        data["originalLocation"] = this.originalLocation;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["inspectionDate"] = this.inspectionDate ? this.inspectionDate.toISOString() : undefined as any;
        data["archivedDate"] = this.archivedDate ? this.archivedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IRunUnarchiveExperimentDTO {
    experimentId: number;
    experimentName?: string | undefined;
    originalLocation?: string | undefined;
    dateCreated?: Date | undefined;
    inspectionDate?: Date | undefined;
    archivedDate?: Date | undefined;
}

export class ResponseWithValueDTOOfListOfString extends ResponseDTO implements IResponseWithValueDTOOfListOfString {
    value?: string[] | undefined;

    constructor(data?: IResponseWithValueDTOOfListOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfListOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfListOfString extends IResponseDTO {
    value?: string[] | undefined;
}

export class ResponseWithValueDTOOfArchivingLocationDTO extends ResponseDTO implements IResponseWithValueDTOOfArchivingLocationDTO {
    value?: ArchivingLocationDTO | undefined;

    constructor(data?: IResponseWithValueDTOOfArchivingLocationDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ArchivingLocationDTO.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfArchivingLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfArchivingLocationDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfArchivingLocationDTO extends IResponseDTO {
    value?: ArchivingLocationDTO | undefined;
}

export class ArchivingLocationDTO implements IArchivingLocationDTO {
    location?: string | undefined;
    availableSize!: number;
    diskSize!: number;

    constructor(data?: IArchivingLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.availableSize = _data["availableSize"];
            this.diskSize = _data["diskSize"];
        }
    }

    static fromJS(data: any): ArchivingLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivingLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["availableSize"] = this.availableSize;
        data["diskSize"] = this.diskSize;
        return data;
    }
}

export interface IArchivingLocationDTO {
    location?: string | undefined;
    availableSize: number;
    diskSize: number;
}

export class ResponseWithValueDTOOfListOfArchivedTaskDTO extends ResponseDTO implements IResponseWithValueDTOOfListOfArchivedTaskDTO {
    value?: ArchivedTaskDTO[] | undefined;

    constructor(data?: IResponseWithValueDTOOfListOfArchivedTaskDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ArchivedTaskDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfListOfArchivedTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfListOfArchivedTaskDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfListOfArchivedTaskDTO extends IResponseDTO {
    value?: ArchivedTaskDTO[] | undefined;
}

export class ArchivedTaskDTO implements IArchivedTaskDTO {
    jobId!: number;
    name?: string | undefined;
    completedUtc?: Date | undefined;
    experimentCount!: number;
    currentLocation?: string | undefined;

    constructor(data?: IArchivedTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.name = _data["name"];
            this.completedUtc = _data["completedUtc"] ? new Date(_data["completedUtc"].toString()) : undefined as any;
            this.experimentCount = _data["experimentCount"];
            this.currentLocation = _data["currentLocation"];
        }
    }

    static fromJS(data: any): ArchivedTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["name"] = this.name;
        data["completedUtc"] = this.completedUtc ? this.completedUtc.toISOString() : undefined as any;
        data["experimentCount"] = this.experimentCount;
        data["currentLocation"] = this.currentLocation;
        return data;
    }
}

export interface IArchivedTaskDTO {
    jobId: number;
    name?: string | undefined;
    completedUtc?: Date | undefined;
    experimentCount: number;
    currentLocation?: string | undefined;
}

export class DismissArchivingResultsDTO implements IDismissArchivingResultsDTO {
    experimentIds?: number[] | undefined;

    constructor(data?: IDismissArchivingResultsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["experimentIds"])) {
                this.experimentIds = [] as any;
                for (let item of _data["experimentIds"])
                    this.experimentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DismissArchivingResultsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DismissArchivingResultsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.experimentIds)) {
            data["experimentIds"] = [];
            for (let item of this.experimentIds)
                data["experimentIds"].push(item);
        }
        return data;
    }
}

export interface IDismissArchivingResultsDTO {
    experimentIds?: number[] | undefined;
}

export class UserCredentialDTO implements IUserCredentialDTO {
    userName?: string | undefined;
    pass?: string | undefined;
    staySignedIn!: boolean;

    constructor(data?: IUserCredentialDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.pass = _data["pass"];
            this.staySignedIn = _data["staySignedIn"];
        }
    }

    static fromJS(data: any): UserCredentialDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserCredentialDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["pass"] = this.pass;
        data["staySignedIn"] = this.staySignedIn;
        return data;
    }
}

export interface IUserCredentialDTO {
    userName?: string | undefined;
    pass?: string | undefined;
    staySignedIn: boolean;
}

export class AuthenticationDTO implements IAuthenticationDTO {
    jwtToken!: string;
    refreshToken!: string;
    sessionId?: string | undefined;
    userId!: number;
    user?: UserDTO | undefined;
    responseType!: ResponseType;
    responseMessage!: string;
    licenseType?: string | undefined;
    licensedFeatures?: string[] | undefined;
    hasAnySeatLicense!: boolean;
    supportedApiVersions?: IEnumerable | undefined;

    constructor(data?: IAuthenticationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jwtToken = _data["jwtToken"];
            this.refreshToken = _data["refreshToken"];
            this.sessionId = _data["sessionId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDTO.fromJS(_data["user"]) : undefined as any;
            this.responseType = _data["responseType"];
            this.responseMessage = _data["responseMessage"];
            this.licenseType = _data["licenseType"];
            if (Array.isArray(_data["licensedFeatures"])) {
                this.licensedFeatures = [] as any;
                for (let item of _data["licensedFeatures"])
                    this.licensedFeatures!.push(item);
            }
            this.hasAnySeatLicense = _data["hasAnySeatLicense"];
            this.supportedApiVersions = _data["supportedApiVersions"] ? IEnumerable.fromJS(_data["supportedApiVersions"]) : undefined as any;
        }
    }

    static fromJS(data: any): AuthenticationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jwtToken"] = this.jwtToken;
        data["refreshToken"] = this.refreshToken;
        data["sessionId"] = this.sessionId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["responseType"] = this.responseType;
        data["responseMessage"] = this.responseMessage;
        data["licenseType"] = this.licenseType;
        if (Array.isArray(this.licensedFeatures)) {
            data["licensedFeatures"] = [];
            for (let item of this.licensedFeatures)
                data["licensedFeatures"].push(item);
        }
        data["hasAnySeatLicense"] = this.hasAnySeatLicense;
        data["supportedApiVersions"] = this.supportedApiVersions ? this.supportedApiVersions.toJSON() : undefined as any;
        return data;
    }
}

export interface IAuthenticationDTO {
    jwtToken: string;
    refreshToken: string;
    sessionId?: string | undefined;
    userId: number;
    user?: UserDTO | undefined;
    responseType: ResponseType;
    responseMessage: string;
    licenseType?: string | undefined;
    licensedFeatures?: string[] | undefined;
    hasAnySeatLicense: boolean;
    supportedApiVersions?: IEnumerable | undefined;
}

export class UserDTO implements IUserDTO {
    id!: number;
    name?: string | undefined;
    email?: string | undefined;
    notificationType?: NotificationTypeDTO | undefined;
    groups?: GroupDTO[] | undefined;
    isGroupAdmin?: boolean | undefined;
    password?: string | undefined;
    shouldResetPassword?: boolean | undefined;
    resetPassword?: ResetPasswordType | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpiry?: Date | undefined;
    sessionId?: string | undefined;
    isPersistentSession!: boolean;
    userType?: UserTypeDTO | undefined;
    userOTP?: number | undefined;
    userOTPValidity?: string | undefined;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.notificationType = _data["notificationType"] ? NotificationTypeDTO.fromJS(_data["notificationType"]) : undefined as any;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupDTO.fromJS(item));
            }
            this.isGroupAdmin = _data["isGroupAdmin"];
            this.password = _data["password"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.resetPassword = _data["resetPassword"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiry = _data["refreshTokenExpiry"] ? new Date(_data["refreshTokenExpiry"].toString()) : undefined as any;
            this.sessionId = _data["sessionId"];
            this.isPersistentSession = _data["isPersistentSession"];
            this.userType = _data["userType"] ? UserTypeDTO.fromJS(_data["userType"]) : undefined as any;
            this.userOTP = _data["userOTP"];
            this.userOTPValidity = _data["userOTPValidity"];
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["notificationType"] = this.notificationType ? this.notificationType.toJSON() : undefined as any;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : undefined as any);
        }
        data["isGroupAdmin"] = this.isGroupAdmin;
        data["password"] = this.password;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["resetPassword"] = this.resetPassword;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiry"] = this.refreshTokenExpiry ? this.refreshTokenExpiry.toISOString() : undefined as any;
        data["sessionId"] = this.sessionId;
        data["isPersistentSession"] = this.isPersistentSession;
        data["userType"] = this.userType ? this.userType.toJSON() : undefined as any;
        data["userOTP"] = this.userOTP;
        data["userOTPValidity"] = this.userOTPValidity;
        return data;
    }
}

export interface IUserDTO {
    id: number;
    name?: string | undefined;
    email?: string | undefined;
    notificationType?: NotificationTypeDTO | undefined;
    groups?: GroupDTO[] | undefined;
    isGroupAdmin?: boolean | undefined;
    password?: string | undefined;
    shouldResetPassword?: boolean | undefined;
    resetPassword?: ResetPasswordType | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpiry?: Date | undefined;
    sessionId?: string | undefined;
    isPersistentSession: boolean;
    userType?: UserTypeDTO | undefined;
    userOTP?: number | undefined;
    userOTPValidity?: string | undefined;
}

export class NotificationTypeDTO implements INotificationTypeDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: INotificationTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NotificationTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface INotificationTypeDTO {
    id: number;
    name?: string | undefined;
}

export class GroupDTO implements IGroupDTO {
    name?: string | undefined;
    id!: number;
    isPrimaryGroup?: boolean | undefined;
    isGroupAdmin?: boolean | undefined;
    isImagerGroup?: boolean | undefined;
    groupAdmins?: UserDTO[] | undefined;
    isPreferenceGroup?: boolean | undefined;
    users?: UserDTO[] | undefined;

    constructor(data?: IGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.isPrimaryGroup = _data["isPrimaryGroup"];
            this.isGroupAdmin = _data["isGroupAdmin"];
            this.isImagerGroup = _data["isImagerGroup"];
            if (Array.isArray(_data["groupAdmins"])) {
                this.groupAdmins = [] as any;
                for (let item of _data["groupAdmins"])
                    this.groupAdmins!.push(UserDTO.fromJS(item));
            }
            this.isPreferenceGroup = _data["isPreferenceGroup"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["isPrimaryGroup"] = this.isPrimaryGroup;
        data["isGroupAdmin"] = this.isGroupAdmin;
        data["isImagerGroup"] = this.isImagerGroup;
        if (Array.isArray(this.groupAdmins)) {
            data["groupAdmins"] = [];
            for (let item of this.groupAdmins)
                data["groupAdmins"].push(item ? item.toJSON() : undefined as any);
        }
        data["isPreferenceGroup"] = this.isPreferenceGroup;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGroupDTO {
    name?: string | undefined;
    id: number;
    isPrimaryGroup?: boolean | undefined;
    isGroupAdmin?: boolean | undefined;
    isImagerGroup?: boolean | undefined;
    groupAdmins?: UserDTO[] | undefined;
    isPreferenceGroup?: boolean | undefined;
    users?: UserDTO[] | undefined;
}

export enum ResetPasswordType {
    Initiated = 1,
    Approved = 2,
}

export class UserTypeDTO implements IUserTypeDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IUserTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserTypeDTO {
    id: number;
    name?: string | undefined;
}

export abstract class IEnumerable implements IIEnumerable {

    constructor(data?: IIEnumerable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IEnumerable {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEnumerable' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIEnumerable {
}

export class UserOtpDTO implements IUserOtpDTO {
    otp!: number;
    userName?: string | undefined;
    password?: string | undefined;
    otpExpiry!: Date;

    constructor(data?: IUserOtpDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otp = _data["otp"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.otpExpiry = _data["otpExpiry"] ? new Date(_data["otpExpiry"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserOtpDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserOtpDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otp"] = this.otp;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["otpExpiry"] = this.otpExpiry ? this.otpExpiry.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserOtpDTO {
    otp: number;
    userName?: string | undefined;
    password?: string | undefined;
    otpExpiry: Date;
}

export class BatchLoadExperimentsDTO implements IBatchLoadExperimentsDTO {
    status?: ValidationStatus | undefined;
    batchLoadExperimentsData?: BatchLoadExperimentsData[] | undefined;
    missingColumns?: string[] | undefined;
    experimentCount!: number;
    projectCount!: number;
    sampleCount!: number;
    warningCount!: number;
    errorCount!: number;

    constructor(data?: IBatchLoadExperimentsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] ? ValidationStatus.fromJS(_data["status"]) : undefined as any;
            if (Array.isArray(_data["batchLoadExperimentsData"])) {
                this.batchLoadExperimentsData = [] as any;
                for (let item of _data["batchLoadExperimentsData"])
                    this.batchLoadExperimentsData!.push(BatchLoadExperimentsData.fromJS(item));
            }
            if (Array.isArray(_data["missingColumns"])) {
                this.missingColumns = [] as any;
                for (let item of _data["missingColumns"])
                    this.missingColumns!.push(item);
            }
            this.experimentCount = _data["experimentCount"];
            this.projectCount = _data["projectCount"];
            this.sampleCount = _data["sampleCount"];
            this.warningCount = _data["warningCount"];
            this.errorCount = _data["errorCount"];
        }
    }

    static fromJS(data: any): BatchLoadExperimentsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLoadExperimentsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (Array.isArray(this.batchLoadExperimentsData)) {
            data["batchLoadExperimentsData"] = [];
            for (let item of this.batchLoadExperimentsData)
                data["batchLoadExperimentsData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingColumns)) {
            data["missingColumns"] = [];
            for (let item of this.missingColumns)
                data["missingColumns"].push(item);
        }
        data["experimentCount"] = this.experimentCount;
        data["projectCount"] = this.projectCount;
        data["sampleCount"] = this.sampleCount;
        data["warningCount"] = this.warningCount;
        data["errorCount"] = this.errorCount;
        return data;
    }
}

export interface IBatchLoadExperimentsDTO {
    status?: ValidationStatus | undefined;
    batchLoadExperimentsData?: BatchLoadExperimentsData[] | undefined;
    missingColumns?: string[] | undefined;
    experimentCount: number;
    projectCount: number;
    sampleCount: number;
    warningCount: number;
    errorCount: number;
}

export class ValidationStatus implements IValidationStatus {
    result!: EValidationResult;
    message?: string | undefined;
    statusCode?: number | undefined;

    constructor(data?: IValidationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.message = _data["message"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): ValidationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["message"] = this.message;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface IValidationStatus {
    result: EValidationResult;
    message?: string | undefined;
    statusCode?: number | undefined;
}

export enum EValidationResult {
    Valid = 0,
    Warning = 1,
    Invalid = 2,
}

export class BatchLoadExperimentsData implements IBatchLoadExperimentsData {
    status?: Entry | undefined;
    folder?: Entry | undefined;
    project?: Entry | undefined;
    subFolder?: Entry | undefined;
    folderHierarchyOrder?: Entry | undefined;
    user?: Entry | undefined;
    userID?: Entry | undefined;
    sample?: Entry | undefined;
    class?: Entry | undefined;
    datePrepared?: Entry | undefined;
    liquidClass?: Entry | undefined;
    liquidClassId?: Entry | undefined;
    volume?: Entry | undefined;
    storageTemp?: Entry | undefined;
    extinctionCoefficient?: Entry | undefined;
    notebookPage?: Entry | undefined;
    screen?: Entry | undefined;
    screenLotID?: Entry | undefined;
    seed?: Entry | undefined;
    seedId?: Entry | undefined;
    temperature?: Entry | undefined;
    schedule?: Entry | undefined;
    incubationTemperatureID?: Entry | undefined;
    imagingScheduleID?: Entry | undefined;
    plateType?: Entry | undefined;
    plateTypeID?: Entry | undefined;
    plateBarcode?: Entry | undefined;
    plateLocalID?: Entry | undefined;
    dropNumber?: Entry | undefined;
    wellVolul?: Entry | undefined;
    dropVolnl?: Entry | undefined;
    samplePercentage?: Entry | undefined;
    proteinLotId?: Entry | undefined;
    protein?: Entry | undefined;
    lot?: Entry | undefined;
    mWkDa?: Entry | undefined;
    concentration?: Entry | undefined;
    ligand?: Entry | undefined;
    lot2?: Entry | undefined;
    mWkDa2?: Entry | undefined;
    concentration2?: Entry | undefined;
    compound?: Entry | undefined;
    lot3?: Entry | undefined;
    mWkDa3?: Entry | undefined;
    concentration3?: Entry | undefined;
    errorDescription?: Entry | undefined;
    sampleWellRatio?: Entry | undefined;
    dropVolume?: Entry | undefined;
    plateNumber?: Entry | undefined;
    experimentName?: Entry | undefined;
    experimentNumber?: Entry | undefined;
    experimentNameTag?: Entry | undefined;
    experimentNotes?: Entry | undefined;
    formulationNotes?: Entry | undefined;
    drops?: BatchLoadDrop[] | undefined;

    constructor(data?: IBatchLoadExperimentsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] ? Entry.fromJS(_data["status"]) : undefined as any;
            this.folder = _data["folder"] ? Entry.fromJS(_data["folder"]) : undefined as any;
            this.project = _data["project"] ? Entry.fromJS(_data["project"]) : undefined as any;
            this.subFolder = _data["subFolder"] ? Entry.fromJS(_data["subFolder"]) : undefined as any;
            this.folderHierarchyOrder = _data["folderHierarchyOrder"] ? Entry.fromJS(_data["folderHierarchyOrder"]) : undefined as any;
            this.user = _data["user"] ? Entry.fromJS(_data["user"]) : undefined as any;
            this.userID = _data["userID"] ? Entry.fromJS(_data["userID"]) : undefined as any;
            this.sample = _data["sample"] ? Entry.fromJS(_data["sample"]) : undefined as any;
            this.class = _data["class"] ? Entry.fromJS(_data["class"]) : undefined as any;
            this.datePrepared = _data["datePrepared"] ? Entry.fromJS(_data["datePrepared"]) : undefined as any;
            this.liquidClass = _data["liquidClass"] ? Entry.fromJS(_data["liquidClass"]) : undefined as any;
            this.liquidClassId = _data["liquidClassId"] ? Entry.fromJS(_data["liquidClassId"]) : undefined as any;
            this.volume = _data["volume"] ? Entry.fromJS(_data["volume"]) : undefined as any;
            this.storageTemp = _data["storageTemp"] ? Entry.fromJS(_data["storageTemp"]) : undefined as any;
            this.extinctionCoefficient = _data["extinctionCoefficient"] ? Entry.fromJS(_data["extinctionCoefficient"]) : undefined as any;
            this.notebookPage = _data["notebookPage"] ? Entry.fromJS(_data["notebookPage"]) : undefined as any;
            this.screen = _data["screen"] ? Entry.fromJS(_data["screen"]) : undefined as any;
            this.screenLotID = _data["screenLotID"] ? Entry.fromJS(_data["screenLotID"]) : undefined as any;
            this.seed = _data["seed"] ? Entry.fromJS(_data["seed"]) : undefined as any;
            this.seedId = _data["seedId"] ? Entry.fromJS(_data["seedId"]) : undefined as any;
            this.temperature = _data["temperature"] ? Entry.fromJS(_data["temperature"]) : undefined as any;
            this.schedule = _data["schedule"] ? Entry.fromJS(_data["schedule"]) : undefined as any;
            this.incubationTemperatureID = _data["incubationTemperatureID"] ? Entry.fromJS(_data["incubationTemperatureID"]) : undefined as any;
            this.imagingScheduleID = _data["imagingScheduleID"] ? Entry.fromJS(_data["imagingScheduleID"]) : undefined as any;
            this.plateType = _data["plateType"] ? Entry.fromJS(_data["plateType"]) : undefined as any;
            this.plateTypeID = _data["plateTypeID"] ? Entry.fromJS(_data["plateTypeID"]) : undefined as any;
            this.plateBarcode = _data["plateBarcode"] ? Entry.fromJS(_data["plateBarcode"]) : undefined as any;
            this.plateLocalID = _data["plateLocalID"] ? Entry.fromJS(_data["plateLocalID"]) : undefined as any;
            this.dropNumber = _data["dropNumber"] ? Entry.fromJS(_data["dropNumber"]) : undefined as any;
            this.wellVolul = _data["wellVolul"] ? Entry.fromJS(_data["wellVolul"]) : undefined as any;
            this.dropVolnl = _data["dropVolnl"] ? Entry.fromJS(_data["dropVolnl"]) : undefined as any;
            this.samplePercentage = _data["samplePercentage"] ? Entry.fromJS(_data["samplePercentage"]) : undefined as any;
            this.proteinLotId = _data["proteinLotId"] ? Entry.fromJS(_data["proteinLotId"]) : undefined as any;
            this.protein = _data["protein"] ? Entry.fromJS(_data["protein"]) : undefined as any;
            this.lot = _data["lot"] ? Entry.fromJS(_data["lot"]) : undefined as any;
            this.mWkDa = _data["mWkDa"] ? Entry.fromJS(_data["mWkDa"]) : undefined as any;
            this.concentration = _data["concentration"] ? Entry.fromJS(_data["concentration"]) : undefined as any;
            this.ligand = _data["ligand"] ? Entry.fromJS(_data["ligand"]) : undefined as any;
            this.lot2 = _data["lot2"] ? Entry.fromJS(_data["lot2"]) : undefined as any;
            this.mWkDa2 = _data["mWkDa2"] ? Entry.fromJS(_data["mWkDa2"]) : undefined as any;
            this.concentration2 = _data["concentration2"] ? Entry.fromJS(_data["concentration2"]) : undefined as any;
            this.compound = _data["compound"] ? Entry.fromJS(_data["compound"]) : undefined as any;
            this.lot3 = _data["lot3"] ? Entry.fromJS(_data["lot3"]) : undefined as any;
            this.mWkDa3 = _data["mWkDa3"] ? Entry.fromJS(_data["mWkDa3"]) : undefined as any;
            this.concentration3 = _data["concentration3"] ? Entry.fromJS(_data["concentration3"]) : undefined as any;
            this.errorDescription = _data["errorDescription"] ? Entry.fromJS(_data["errorDescription"]) : undefined as any;
            this.sampleWellRatio = _data["sampleWellRatio"] ? Entry.fromJS(_data["sampleWellRatio"]) : undefined as any;
            this.dropVolume = _data["dropVolume"] ? Entry.fromJS(_data["dropVolume"]) : undefined as any;
            this.plateNumber = _data["plateNumber"] ? Entry.fromJS(_data["plateNumber"]) : undefined as any;
            this.experimentName = _data["experimentName"] ? Entry.fromJS(_data["experimentName"]) : undefined as any;
            this.experimentNumber = _data["experimentNumber"] ? Entry.fromJS(_data["experimentNumber"]) : undefined as any;
            this.experimentNameTag = _data["experimentNameTag"] ? Entry.fromJS(_data["experimentNameTag"]) : undefined as any;
            this.experimentNotes = _data["experimentNotes"] ? Entry.fromJS(_data["experimentNotes"]) : undefined as any;
            this.formulationNotes = _data["formulationNotes"] ? Entry.fromJS(_data["formulationNotes"]) : undefined as any;
            if (Array.isArray(_data["drops"])) {
                this.drops = [] as any;
                for (let item of _data["drops"])
                    this.drops!.push(BatchLoadDrop.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchLoadExperimentsData {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLoadExperimentsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        data["folder"] = this.folder ? this.folder.toJSON() : undefined as any;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["subFolder"] = this.subFolder ? this.subFolder.toJSON() : undefined as any;
        data["folderHierarchyOrder"] = this.folderHierarchyOrder ? this.folderHierarchyOrder.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["userID"] = this.userID ? this.userID.toJSON() : undefined as any;
        data["sample"] = this.sample ? this.sample.toJSON() : undefined as any;
        data["class"] = this.class ? this.class.toJSON() : undefined as any;
        data["datePrepared"] = this.datePrepared ? this.datePrepared.toJSON() : undefined as any;
        data["liquidClass"] = this.liquidClass ? this.liquidClass.toJSON() : undefined as any;
        data["liquidClassId"] = this.liquidClassId ? this.liquidClassId.toJSON() : undefined as any;
        data["volume"] = this.volume ? this.volume.toJSON() : undefined as any;
        data["storageTemp"] = this.storageTemp ? this.storageTemp.toJSON() : undefined as any;
        data["extinctionCoefficient"] = this.extinctionCoefficient ? this.extinctionCoefficient.toJSON() : undefined as any;
        data["notebookPage"] = this.notebookPage ? this.notebookPage.toJSON() : undefined as any;
        data["screen"] = this.screen ? this.screen.toJSON() : undefined as any;
        data["screenLotID"] = this.screenLotID ? this.screenLotID.toJSON() : undefined as any;
        data["seed"] = this.seed ? this.seed.toJSON() : undefined as any;
        data["seedId"] = this.seedId ? this.seedId.toJSON() : undefined as any;
        data["temperature"] = this.temperature ? this.temperature.toJSON() : undefined as any;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : undefined as any;
        data["incubationTemperatureID"] = this.incubationTemperatureID ? this.incubationTemperatureID.toJSON() : undefined as any;
        data["imagingScheduleID"] = this.imagingScheduleID ? this.imagingScheduleID.toJSON() : undefined as any;
        data["plateType"] = this.plateType ? this.plateType.toJSON() : undefined as any;
        data["plateTypeID"] = this.plateTypeID ? this.plateTypeID.toJSON() : undefined as any;
        data["plateBarcode"] = this.plateBarcode ? this.plateBarcode.toJSON() : undefined as any;
        data["plateLocalID"] = this.plateLocalID ? this.plateLocalID.toJSON() : undefined as any;
        data["dropNumber"] = this.dropNumber ? this.dropNumber.toJSON() : undefined as any;
        data["wellVolul"] = this.wellVolul ? this.wellVolul.toJSON() : undefined as any;
        data["dropVolnl"] = this.dropVolnl ? this.dropVolnl.toJSON() : undefined as any;
        data["samplePercentage"] = this.samplePercentage ? this.samplePercentage.toJSON() : undefined as any;
        data["proteinLotId"] = this.proteinLotId ? this.proteinLotId.toJSON() : undefined as any;
        data["protein"] = this.protein ? this.protein.toJSON() : undefined as any;
        data["lot"] = this.lot ? this.lot.toJSON() : undefined as any;
        data["mWkDa"] = this.mWkDa ? this.mWkDa.toJSON() : undefined as any;
        data["concentration"] = this.concentration ? this.concentration.toJSON() : undefined as any;
        data["ligand"] = this.ligand ? this.ligand.toJSON() : undefined as any;
        data["lot2"] = this.lot2 ? this.lot2.toJSON() : undefined as any;
        data["mWkDa2"] = this.mWkDa2 ? this.mWkDa2.toJSON() : undefined as any;
        data["concentration2"] = this.concentration2 ? this.concentration2.toJSON() : undefined as any;
        data["compound"] = this.compound ? this.compound.toJSON() : undefined as any;
        data["lot3"] = this.lot3 ? this.lot3.toJSON() : undefined as any;
        data["mWkDa3"] = this.mWkDa3 ? this.mWkDa3.toJSON() : undefined as any;
        data["concentration3"] = this.concentration3 ? this.concentration3.toJSON() : undefined as any;
        data["errorDescription"] = this.errorDescription ? this.errorDescription.toJSON() : undefined as any;
        data["sampleWellRatio"] = this.sampleWellRatio ? this.sampleWellRatio.toJSON() : undefined as any;
        data["dropVolume"] = this.dropVolume ? this.dropVolume.toJSON() : undefined as any;
        data["plateNumber"] = this.plateNumber ? this.plateNumber.toJSON() : undefined as any;
        data["experimentName"] = this.experimentName ? this.experimentName.toJSON() : undefined as any;
        data["experimentNumber"] = this.experimentNumber ? this.experimentNumber.toJSON() : undefined as any;
        data["experimentNameTag"] = this.experimentNameTag ? this.experimentNameTag.toJSON() : undefined as any;
        data["experimentNotes"] = this.experimentNotes ? this.experimentNotes.toJSON() : undefined as any;
        data["formulationNotes"] = this.formulationNotes ? this.formulationNotes.toJSON() : undefined as any;
        if (Array.isArray(this.drops)) {
            data["drops"] = [];
            for (let item of this.drops)
                data["drops"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBatchLoadExperimentsData {
    status?: Entry | undefined;
    folder?: Entry | undefined;
    project?: Entry | undefined;
    subFolder?: Entry | undefined;
    folderHierarchyOrder?: Entry | undefined;
    user?: Entry | undefined;
    userID?: Entry | undefined;
    sample?: Entry | undefined;
    class?: Entry | undefined;
    datePrepared?: Entry | undefined;
    liquidClass?: Entry | undefined;
    liquidClassId?: Entry | undefined;
    volume?: Entry | undefined;
    storageTemp?: Entry | undefined;
    extinctionCoefficient?: Entry | undefined;
    notebookPage?: Entry | undefined;
    screen?: Entry | undefined;
    screenLotID?: Entry | undefined;
    seed?: Entry | undefined;
    seedId?: Entry | undefined;
    temperature?: Entry | undefined;
    schedule?: Entry | undefined;
    incubationTemperatureID?: Entry | undefined;
    imagingScheduleID?: Entry | undefined;
    plateType?: Entry | undefined;
    plateTypeID?: Entry | undefined;
    plateBarcode?: Entry | undefined;
    plateLocalID?: Entry | undefined;
    dropNumber?: Entry | undefined;
    wellVolul?: Entry | undefined;
    dropVolnl?: Entry | undefined;
    samplePercentage?: Entry | undefined;
    proteinLotId?: Entry | undefined;
    protein?: Entry | undefined;
    lot?: Entry | undefined;
    mWkDa?: Entry | undefined;
    concentration?: Entry | undefined;
    ligand?: Entry | undefined;
    lot2?: Entry | undefined;
    mWkDa2?: Entry | undefined;
    concentration2?: Entry | undefined;
    compound?: Entry | undefined;
    lot3?: Entry | undefined;
    mWkDa3?: Entry | undefined;
    concentration3?: Entry | undefined;
    errorDescription?: Entry | undefined;
    sampleWellRatio?: Entry | undefined;
    dropVolume?: Entry | undefined;
    plateNumber?: Entry | undefined;
    experimentName?: Entry | undefined;
    experimentNumber?: Entry | undefined;
    experimentNameTag?: Entry | undefined;
    experimentNotes?: Entry | undefined;
    formulationNotes?: Entry | undefined;
    drops?: BatchLoadDrop[] | undefined;
}

export class Entry implements IEntry {
    value?: string | undefined;
    validation?: ValidationStatus | undefined;

    constructor(data?: IEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.validation = _data["validation"] ? ValidationStatus.fromJS(_data["validation"]) : undefined as any;
        }
    }

    static fromJS(data: any): Entry {
        data = typeof data === 'object' ? data : {};
        let result = new Entry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["validation"] = this.validation ? this.validation.toJSON() : undefined as any;
        return data;
    }
}

export interface IEntry {
    value?: string | undefined;
    validation?: ValidationStatus | undefined;
}

export class BatchLoadDrop implements IBatchLoadDrop {
    sample?: Entry | undefined;
    sampleLot?: Entry | undefined;
    protein?: Entry | undefined;
    proteinLot?: Entry | undefined;
    proteinMolecularWeight?: Entry | undefined;
    proteinConcentration?: Entry | undefined;
    ligand?: Entry | undefined;
    ligandLot?: Entry | undefined;
    ligandMolecularWeight?: Entry | undefined;
    ligandConcentration?: Entry | undefined;
    compound?: Entry | undefined;
    compoundLot?: Entry | undefined;
    compoundMolecularWeight?: Entry | undefined;
    compoundConcentration?: Entry | undefined;
    dropNumber?: Entry | undefined;
    dropVolnl?: Entry | undefined;
    sampleWellRatio?: Entry | undefined;
    dropVolume?: Entry | undefined;

    constructor(data?: IBatchLoadDrop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sample = _data["sample"] ? Entry.fromJS(_data["sample"]) : undefined as any;
            this.sampleLot = _data["sampleLot"] ? Entry.fromJS(_data["sampleLot"]) : undefined as any;
            this.protein = _data["protein"] ? Entry.fromJS(_data["protein"]) : undefined as any;
            this.proteinLot = _data["proteinLot"] ? Entry.fromJS(_data["proteinLot"]) : undefined as any;
            this.proteinMolecularWeight = _data["proteinMolecularWeight"] ? Entry.fromJS(_data["proteinMolecularWeight"]) : undefined as any;
            this.proteinConcentration = _data["proteinConcentration"] ? Entry.fromJS(_data["proteinConcentration"]) : undefined as any;
            this.ligand = _data["ligand"] ? Entry.fromJS(_data["ligand"]) : undefined as any;
            this.ligandLot = _data["ligandLot"] ? Entry.fromJS(_data["ligandLot"]) : undefined as any;
            this.ligandMolecularWeight = _data["ligandMolecularWeight"] ? Entry.fromJS(_data["ligandMolecularWeight"]) : undefined as any;
            this.ligandConcentration = _data["ligandConcentration"] ? Entry.fromJS(_data["ligandConcentration"]) : undefined as any;
            this.compound = _data["compound"] ? Entry.fromJS(_data["compound"]) : undefined as any;
            this.compoundLot = _data["compoundLot"] ? Entry.fromJS(_data["compoundLot"]) : undefined as any;
            this.compoundMolecularWeight = _data["compoundMolecularWeight"] ? Entry.fromJS(_data["compoundMolecularWeight"]) : undefined as any;
            this.compoundConcentration = _data["compoundConcentration"] ? Entry.fromJS(_data["compoundConcentration"]) : undefined as any;
            this.dropNumber = _data["dropNumber"] ? Entry.fromJS(_data["dropNumber"]) : undefined as any;
            this.dropVolnl = _data["dropVolnl"] ? Entry.fromJS(_data["dropVolnl"]) : undefined as any;
            this.sampleWellRatio = _data["sampleWellRatio"] ? Entry.fromJS(_data["sampleWellRatio"]) : undefined as any;
            this.dropVolume = _data["dropVolume"] ? Entry.fromJS(_data["dropVolume"]) : undefined as any;
        }
    }

    static fromJS(data: any): BatchLoadDrop {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLoadDrop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sample"] = this.sample ? this.sample.toJSON() : undefined as any;
        data["sampleLot"] = this.sampleLot ? this.sampleLot.toJSON() : undefined as any;
        data["protein"] = this.protein ? this.protein.toJSON() : undefined as any;
        data["proteinLot"] = this.proteinLot ? this.proteinLot.toJSON() : undefined as any;
        data["proteinMolecularWeight"] = this.proteinMolecularWeight ? this.proteinMolecularWeight.toJSON() : undefined as any;
        data["proteinConcentration"] = this.proteinConcentration ? this.proteinConcentration.toJSON() : undefined as any;
        data["ligand"] = this.ligand ? this.ligand.toJSON() : undefined as any;
        data["ligandLot"] = this.ligandLot ? this.ligandLot.toJSON() : undefined as any;
        data["ligandMolecularWeight"] = this.ligandMolecularWeight ? this.ligandMolecularWeight.toJSON() : undefined as any;
        data["ligandConcentration"] = this.ligandConcentration ? this.ligandConcentration.toJSON() : undefined as any;
        data["compound"] = this.compound ? this.compound.toJSON() : undefined as any;
        data["compoundLot"] = this.compoundLot ? this.compoundLot.toJSON() : undefined as any;
        data["compoundMolecularWeight"] = this.compoundMolecularWeight ? this.compoundMolecularWeight.toJSON() : undefined as any;
        data["compoundConcentration"] = this.compoundConcentration ? this.compoundConcentration.toJSON() : undefined as any;
        data["dropNumber"] = this.dropNumber ? this.dropNumber.toJSON() : undefined as any;
        data["dropVolnl"] = this.dropVolnl ? this.dropVolnl.toJSON() : undefined as any;
        data["sampleWellRatio"] = this.sampleWellRatio ? this.sampleWellRatio.toJSON() : undefined as any;
        data["dropVolume"] = this.dropVolume ? this.dropVolume.toJSON() : undefined as any;
        return data;
    }
}

export interface IBatchLoadDrop {
    sample?: Entry | undefined;
    sampleLot?: Entry | undefined;
    protein?: Entry | undefined;
    proteinLot?: Entry | undefined;
    proteinMolecularWeight?: Entry | undefined;
    proteinConcentration?: Entry | undefined;
    ligand?: Entry | undefined;
    ligandLot?: Entry | undefined;
    ligandMolecularWeight?: Entry | undefined;
    ligandConcentration?: Entry | undefined;
    compound?: Entry | undefined;
    compoundLot?: Entry | undefined;
    compoundMolecularWeight?: Entry | undefined;
    compoundConcentration?: Entry | undefined;
    dropNumber?: Entry | undefined;
    dropVolnl?: Entry | undefined;
    sampleWellRatio?: Entry | undefined;
    dropVolume?: Entry | undefined;
}

export class BatchLoadExperimentRequest implements IBatchLoadExperimentRequest {
    fileInput?: string | undefined;

    constructor(data?: IBatchLoadExperimentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileInput = _data["fileInput"];
        }
    }

    static fromJS(data: any): BatchLoadExperimentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLoadExperimentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileInput"] = this.fileInput;
        return data;
    }
}

export interface IBatchLoadExperimentRequest {
    fileInput?: string | undefined;
}

export class BatchloadExperimentInfoDTO implements IBatchloadExperimentInfoDTO {
    experimentInfo?: ExperimentInfo | undefined;
    parentTreeNodeId!: number;
    proteinFormulationList?: ProteinFormulationDTO[] | undefined;
    proteins?: ProteinInfoDTO[] | undefined;
    dropProtiens?: DropProtienPairDTO[] | undefined;

    constructor(data?: IBatchloadExperimentInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentInfo = _data["experimentInfo"] ? ExperimentInfo.fromJS(_data["experimentInfo"]) : undefined as any;
            this.parentTreeNodeId = _data["parentTreeNodeId"];
            if (Array.isArray(_data["proteinFormulationList"])) {
                this.proteinFormulationList = [] as any;
                for (let item of _data["proteinFormulationList"])
                    this.proteinFormulationList!.push(ProteinFormulationDTO.fromJS(item));
            }
            if (Array.isArray(_data["proteins"])) {
                this.proteins = [] as any;
                for (let item of _data["proteins"])
                    this.proteins!.push(ProteinInfoDTO.fromJS(item));
            }
            if (Array.isArray(_data["dropProtiens"])) {
                this.dropProtiens = [] as any;
                for (let item of _data["dropProtiens"])
                    this.dropProtiens!.push(DropProtienPairDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchloadExperimentInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BatchloadExperimentInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentInfo"] = this.experimentInfo ? this.experimentInfo.toJSON() : undefined as any;
        data["parentTreeNodeId"] = this.parentTreeNodeId;
        if (Array.isArray(this.proteinFormulationList)) {
            data["proteinFormulationList"] = [];
            for (let item of this.proteinFormulationList)
                data["proteinFormulationList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteins)) {
            data["proteins"] = [];
            for (let item of this.proteins)
                data["proteins"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dropProtiens)) {
            data["dropProtiens"] = [];
            for (let item of this.dropProtiens)
                data["dropProtiens"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBatchloadExperimentInfoDTO {
    experimentInfo?: ExperimentInfo | undefined;
    parentTreeNodeId: number;
    proteinFormulationList?: ProteinFormulationDTO[] | undefined;
    proteins?: ProteinInfoDTO[] | undefined;
    dropProtiens?: DropProtienPairDTO[] | undefined;
}

export class ExperimentInfo implements IExperimentInfo {
    screenExperimentName?: string | undefined;
    experimentContainerID!: number;
    incubationTempID!: number;
    setupTempID!: number;
    imagingScheduleID!: number;
    ownerUserID!: number;
    screenInfo?: ScreenInfoDTO | undefined;

    constructor(data?: IExperimentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screenExperimentName = _data["screenExperimentName"];
            this.experimentContainerID = _data["experimentContainerID"];
            this.incubationTempID = _data["incubationTempID"];
            this.setupTempID = _data["setupTempID"];
            this.imagingScheduleID = _data["imagingScheduleID"];
            this.ownerUserID = _data["ownerUserID"];
            this.screenInfo = _data["screenInfo"] ? ScreenInfoDTO.fromJS(_data["screenInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExperimentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["screenExperimentName"] = this.screenExperimentName;
        data["experimentContainerID"] = this.experimentContainerID;
        data["incubationTempID"] = this.incubationTempID;
        data["setupTempID"] = this.setupTempID;
        data["imagingScheduleID"] = this.imagingScheduleID;
        data["ownerUserID"] = this.ownerUserID;
        data["screenInfo"] = this.screenInfo ? this.screenInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IExperimentInfo {
    screenExperimentName?: string | undefined;
    experimentContainerID: number;
    incubationTempID: number;
    setupTempID: number;
    imagingScheduleID: number;
    ownerUserID: number;
    screenInfo?: ScreenInfoDTO | undefined;
}

export class ScreenInfoDTO implements IScreenInfoDTO {
    id!: number;
    name?: string | undefined;
    screenLotRows?: ScreenLotInfoDTO[] | undefined;
    layerVolume!: number;
    defaultLotNumber!: number;
    screenLotId!: number;

    constructor(data?: IScreenInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["screenLotRows"])) {
                this.screenLotRows = [] as any;
                for (let item of _data["screenLotRows"])
                    this.screenLotRows!.push(ScreenLotInfoDTO.fromJS(item));
            }
            this.layerVolume = _data["layerVolume"];
            this.defaultLotNumber = _data["defaultLotNumber"];
            this.screenLotId = _data["screenLotId"];
        }
    }

    static fromJS(data: any): ScreenInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.screenLotRows)) {
            data["screenLotRows"] = [];
            for (let item of this.screenLotRows)
                data["screenLotRows"].push(item ? item.toJSON() : undefined as any);
        }
        data["layerVolume"] = this.layerVolume;
        data["defaultLotNumber"] = this.defaultLotNumber;
        data["screenLotId"] = this.screenLotId;
        return data;
    }
}

export interface IScreenInfoDTO {
    id: number;
    name?: string | undefined;
    screenLotRows?: ScreenLotInfoDTO[] | undefined;
    layerVolume: number;
    defaultLotNumber: number;
    screenLotId: number;
}

export class ScreenLotInfoDTO implements IScreenLotInfoDTO {
    id!: number;
    name!: number;

    constructor(data?: IScreenLotInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ScreenLotInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenLotInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IScreenLotInfoDTO {
    id: number;
    name: number;
}

export class ProteinFormulationDTO implements IProteinFormulationDTO {
    id!: number;
    proteinLotId?: string | undefined;
    treeNodeId!: number;
    volume?: number | undefined;
    pfName?: string | undefined;
    datePrepared?: Date | undefined;
    storageTemp?: string | undefined;
    class?: string | undefined;
    extCoefficient?: string | undefined;
    type?: string | undefined;
    pfIng?: ProteinFormulationIngredientsDTO[] | undefined;
    pfStIng?: ProteinFormulationStandardIngredientsDTO[] | undefined;

    constructor(data?: IProteinFormulationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proteinLotId = _data["proteinLotId"];
            this.treeNodeId = _data["treeNodeId"];
            this.volume = _data["volume"];
            this.pfName = _data["pfName"];
            this.datePrepared = _data["datePrepared"] ? new Date(_data["datePrepared"].toString()) : undefined as any;
            this.storageTemp = _data["storageTemp"];
            this.class = _data["class"];
            this.extCoefficient = _data["extCoefficient"];
            this.type = _data["type"];
            if (Array.isArray(_data["pfIng"])) {
                this.pfIng = [] as any;
                for (let item of _data["pfIng"])
                    this.pfIng!.push(ProteinFormulationIngredientsDTO.fromJS(item));
            }
            if (Array.isArray(_data["pfStIng"])) {
                this.pfStIng = [] as any;
                for (let item of _data["pfStIng"])
                    this.pfStIng!.push(ProteinFormulationStandardIngredientsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProteinFormulationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proteinLotId"] = this.proteinLotId;
        data["treeNodeId"] = this.treeNodeId;
        data["volume"] = this.volume;
        data["pfName"] = this.pfName;
        data["datePrepared"] = this.datePrepared ? this.datePrepared.toISOString() : undefined as any;
        data["storageTemp"] = this.storageTemp;
        data["class"] = this.class;
        data["extCoefficient"] = this.extCoefficient;
        data["type"] = this.type;
        if (Array.isArray(this.pfIng)) {
            data["pfIng"] = [];
            for (let item of this.pfIng)
                data["pfIng"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pfStIng)) {
            data["pfStIng"] = [];
            for (let item of this.pfStIng)
                data["pfStIng"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProteinFormulationDTO {
    id: number;
    proteinLotId?: string | undefined;
    treeNodeId: number;
    volume?: number | undefined;
    pfName?: string | undefined;
    datePrepared?: Date | undefined;
    storageTemp?: string | undefined;
    class?: string | undefined;
    extCoefficient?: string | undefined;
    type?: string | undefined;
    pfIng?: ProteinFormulationIngredientsDTO[] | undefined;
    pfStIng?: ProteinFormulationStandardIngredientsDTO[] | undefined;
}

export class ProteinFormulationIngredientsDTO implements IProteinFormulationIngredientsDTO {
    name?: string | undefined;
    concentrationmgml?: number | undefined;
    concentrationmM?: number | undefined;
    moleculerWeight?: number | undefined;
    typeName?: string | undefined;
    id!: number;
    userId?: string | undefined;
    lot?: string | undefined;

    constructor(data?: IProteinFormulationIngredientsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.concentrationmgml = _data["concentrationmgml"];
            this.concentrationmM = _data["concentrationmM"];
            this.moleculerWeight = _data["moleculerWeight"];
            this.typeName = _data["typeName"];
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.lot = _data["lot"];
        }
    }

    static fromJS(data: any): ProteinFormulationIngredientsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationIngredientsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["concentrationmgml"] = this.concentrationmgml;
        data["concentrationmM"] = this.concentrationmM;
        data["moleculerWeight"] = this.moleculerWeight;
        data["typeName"] = this.typeName;
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["lot"] = this.lot;
        return data;
    }
}

export interface IProteinFormulationIngredientsDTO {
    name?: string | undefined;
    concentrationmgml?: number | undefined;
    concentrationmM?: number | undefined;
    moleculerWeight?: number | undefined;
    typeName?: string | undefined;
    id: number;
    userId?: string | undefined;
    lot?: string | undefined;
}

export class ProteinFormulationStandardIngredientsDTO implements IProteinFormulationStandardIngredientsDTO {
    ingredientName?: string | undefined;
    concentrationM?: number | undefined;
    pH?: number | undefined;
    stockConcentration?: number | undefined;
    stockConcentrationUnit?: string | undefined;
    stockpH?: number | undefined;
    highpHStockpH?: number | undefined;
    type?: string | undefined;
    ingredientID!: number;
    stockNumber!: number;
    lowConcentration?: number | undefined;
    highConcentration?: number | undefined;

    constructor(data?: IProteinFormulationStandardIngredientsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredientName = _data["ingredientName"];
            this.concentrationM = _data["concentrationM"];
            this.pH = _data["pH"];
            this.stockConcentration = _data["stockConcentration"];
            this.stockConcentrationUnit = _data["stockConcentrationUnit"];
            this.stockpH = _data["stockpH"];
            this.highpHStockpH = _data["highpHStockpH"];
            this.type = _data["type"];
            this.ingredientID = _data["ingredientID"];
            this.stockNumber = _data["stockNumber"];
            this.lowConcentration = _data["lowConcentration"];
            this.highConcentration = _data["highConcentration"];
        }
    }

    static fromJS(data: any): ProteinFormulationStandardIngredientsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationStandardIngredientsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredientName"] = this.ingredientName;
        data["concentrationM"] = this.concentrationM;
        data["pH"] = this.pH;
        data["stockConcentration"] = this.stockConcentration;
        data["stockConcentrationUnit"] = this.stockConcentrationUnit;
        data["stockpH"] = this.stockpH;
        data["highpHStockpH"] = this.highpHStockpH;
        data["type"] = this.type;
        data["ingredientID"] = this.ingredientID;
        data["stockNumber"] = this.stockNumber;
        data["lowConcentration"] = this.lowConcentration;
        data["highConcentration"] = this.highConcentration;
        return data;
    }
}

export interface IProteinFormulationStandardIngredientsDTO {
    ingredientName?: string | undefined;
    concentrationM?: number | undefined;
    pH?: number | undefined;
    stockConcentration?: number | undefined;
    stockConcentrationUnit?: string | undefined;
    stockpH?: number | undefined;
    highpHStockpH?: number | undefined;
    type?: string | undefined;
    ingredientID: number;
    stockNumber: number;
    lowConcentration?: number | undefined;
    highConcentration?: number | undefined;
}

export class ProteinInfoDTO implements IProteinInfoDTO {
    id!: number;
    name?: string | undefined;
    dropVolume!: number;
    proteinVolume!: number;
    pfId!: number;
    path?: string | undefined;
    isProteinHasVariants!: boolean;

    constructor(data?: IProteinInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dropVolume = _data["dropVolume"];
            this.proteinVolume = _data["proteinVolume"];
            this.pfId = _data["pfId"];
            this.path = _data["path"];
            this.isProteinHasVariants = _data["isProteinHasVariants"];
        }
    }

    static fromJS(data: any): ProteinInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dropVolume"] = this.dropVolume;
        data["proteinVolume"] = this.proteinVolume;
        data["pfId"] = this.pfId;
        data["path"] = this.path;
        data["isProteinHasVariants"] = this.isProteinHasVariants;
        return data;
    }
}

export interface IProteinInfoDTO {
    id: number;
    name?: string | undefined;
    dropVolume: number;
    proteinVolume: number;
    pfId: number;
    path?: string | undefined;
    isProteinHasVariants: boolean;
}

export class DropProtienPairDTO implements IDropProtienPairDTO {
    dropNumber!: number;
    proteinInfo?: ProteinInfoDTO | undefined;

    constructor(data?: IDropProtienPairDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dropNumber = _data["dropNumber"];
            this.proteinInfo = _data["proteinInfo"] ? ProteinInfoDTO.fromJS(_data["proteinInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): DropProtienPairDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DropProtienPairDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dropNumber"] = this.dropNumber;
        data["proteinInfo"] = this.proteinInfo ? this.proteinInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IDropProtienPairDTO {
    dropNumber: number;
    proteinInfo?: ProteinInfoDTO | undefined;
}

export class CaptureProfileDTO implements ICaptureProfileDTO {
    captureProfileRows?: ProfileDTO[] | undefined;

    constructor(data?: ICaptureProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["captureProfileRows"])) {
                this.captureProfileRows = [] as any;
                for (let item of _data["captureProfileRows"])
                    this.captureProfileRows!.push(ProfileDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaptureProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.captureProfileRows)) {
            data["captureProfileRows"] = [];
            for (let item of this.captureProfileRows)
                data["captureProfileRows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICaptureProfileDTO {
    captureProfileRows?: ProfileDTO[] | undefined;
}

export class ProfileDTO implements IProfileDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProfileDTO {
    id: number;
    name?: string | undefined;
}

export class SaveCaptureProfilesDTO implements ISaveCaptureProfilesDTO {
    captureProfilesDto?: SaveProfileDTO[] | undefined;
    deletedProfileIds?: number[] | undefined;

    constructor(data?: ISaveCaptureProfilesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["captureProfilesDto"])) {
                this.captureProfilesDto = [] as any;
                for (let item of _data["captureProfilesDto"])
                    this.captureProfilesDto!.push(SaveProfileDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedProfileIds"])) {
                this.deletedProfileIds = [] as any;
                for (let item of _data["deletedProfileIds"])
                    this.deletedProfileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveCaptureProfilesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCaptureProfilesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.captureProfilesDto)) {
            data["captureProfilesDto"] = [];
            for (let item of this.captureProfilesDto)
                data["captureProfilesDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedProfileIds)) {
            data["deletedProfileIds"] = [];
            for (let item of this.deletedProfileIds)
                data["deletedProfileIds"].push(item);
        }
        return data;
    }
}

export interface ISaveCaptureProfilesDTO {
    captureProfilesDto?: SaveProfileDTO[] | undefined;
    deletedProfileIds?: number[] | undefined;
}

export class SaveProfileDTO implements ISaveProfileDTO {
    id!: number;
    name?: string | undefined;
    enabled?: boolean | undefined;
    importFl?: boolean | undefined;
    status?: number | undefined;
    currentCaptureProfileVersionId?: number | undefined;
    experimentPlateId?: number | undefined;
    parentID?: number | undefined;
    isModified?: boolean | undefined;
    inUse?: boolean | undefined;
    hidden?: boolean | undefined;
    tuningValuesDTOs?: SaveProfileTuningValuesDTO[] | undefined;
    profileVersionDTOs?: SaveProfileVersionDTO[] | undefined;
    capturePropertySaveDTO?: CapturePropertySaveDTO[] | undefined;
    capturePropertyRobotDTO?: CapturePropertyRobotDTO | undefined;

    constructor(data?: ISaveProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.importFl = _data["importFl"];
            this.status = _data["status"];
            this.currentCaptureProfileVersionId = _data["currentCaptureProfileVersionId"];
            this.experimentPlateId = _data["experimentPlateId"];
            this.parentID = _data["parentID"];
            this.isModified = _data["isModified"];
            this.inUse = _data["inUse"];
            this.hidden = _data["hidden"];
            if (Array.isArray(_data["tuningValuesDTOs"])) {
                this.tuningValuesDTOs = [] as any;
                for (let item of _data["tuningValuesDTOs"])
                    this.tuningValuesDTOs!.push(SaveProfileTuningValuesDTO.fromJS(item));
            }
            if (Array.isArray(_data["profileVersionDTOs"])) {
                this.profileVersionDTOs = [] as any;
                for (let item of _data["profileVersionDTOs"])
                    this.profileVersionDTOs!.push(SaveProfileVersionDTO.fromJS(item));
            }
            if (Array.isArray(_data["capturePropertySaveDTO"])) {
                this.capturePropertySaveDTO = [] as any;
                for (let item of _data["capturePropertySaveDTO"])
                    this.capturePropertySaveDTO!.push(CapturePropertySaveDTO.fromJS(item));
            }
            this.capturePropertyRobotDTO = _data["capturePropertyRobotDTO"] ? CapturePropertyRobotDTO.fromJS(_data["capturePropertyRobotDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["importFl"] = this.importFl;
        data["status"] = this.status;
        data["currentCaptureProfileVersionId"] = this.currentCaptureProfileVersionId;
        data["experimentPlateId"] = this.experimentPlateId;
        data["parentID"] = this.parentID;
        data["isModified"] = this.isModified;
        data["inUse"] = this.inUse;
        data["hidden"] = this.hidden;
        if (Array.isArray(this.tuningValuesDTOs)) {
            data["tuningValuesDTOs"] = [];
            for (let item of this.tuningValuesDTOs)
                data["tuningValuesDTOs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.profileVersionDTOs)) {
            data["profileVersionDTOs"] = [];
            for (let item of this.profileVersionDTOs)
                data["profileVersionDTOs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.capturePropertySaveDTO)) {
            data["capturePropertySaveDTO"] = [];
            for (let item of this.capturePropertySaveDTO)
                data["capturePropertySaveDTO"].push(item ? item.toJSON() : undefined as any);
        }
        data["capturePropertyRobotDTO"] = this.capturePropertyRobotDTO ? this.capturePropertyRobotDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveProfileDTO {
    id: number;
    name?: string | undefined;
    enabled?: boolean | undefined;
    importFl?: boolean | undefined;
    status?: number | undefined;
    currentCaptureProfileVersionId?: number | undefined;
    experimentPlateId?: number | undefined;
    parentID?: number | undefined;
    isModified?: boolean | undefined;
    inUse?: boolean | undefined;
    hidden?: boolean | undefined;
    tuningValuesDTOs?: SaveProfileTuningValuesDTO[] | undefined;
    profileVersionDTOs?: SaveProfileVersionDTO[] | undefined;
    capturePropertySaveDTO?: CapturePropertySaveDTO[] | undefined;
    capturePropertyRobotDTO?: CapturePropertyRobotDTO | undefined;
}

export class SaveProfileTuningValuesDTO implements ISaveProfileTuningValuesDTO {
    id!: number;
    captureProfileId!: number;
    autoLevelingOn!: boolean;
    autoLevelingMode!: number;
    autoLevelingLowThreshold!: number;
    autoLevelingHighThreshold!: number;
    lowerLevelLimit!: number;
    upperLevelLimit!: number;
    brightness!: number;
    contrast!: number;
    gamma!: number;

    constructor(data?: ISaveProfileTuningValuesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.captureProfileId = _data["captureProfileId"];
            this.autoLevelingOn = _data["autoLevelingOn"];
            this.autoLevelingMode = _data["autoLevelingMode"];
            this.autoLevelingLowThreshold = _data["autoLevelingLowThreshold"];
            this.autoLevelingHighThreshold = _data["autoLevelingHighThreshold"];
            this.lowerLevelLimit = _data["lowerLevelLimit"];
            this.upperLevelLimit = _data["upperLevelLimit"];
            this.brightness = _data["brightness"];
            this.contrast = _data["contrast"];
            this.gamma = _data["gamma"];
        }
    }

    static fromJS(data: any): SaveProfileTuningValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProfileTuningValuesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureProfileId"] = this.captureProfileId;
        data["autoLevelingOn"] = this.autoLevelingOn;
        data["autoLevelingMode"] = this.autoLevelingMode;
        data["autoLevelingLowThreshold"] = this.autoLevelingLowThreshold;
        data["autoLevelingHighThreshold"] = this.autoLevelingHighThreshold;
        data["lowerLevelLimit"] = this.lowerLevelLimit;
        data["upperLevelLimit"] = this.upperLevelLimit;
        data["brightness"] = this.brightness;
        data["contrast"] = this.contrast;
        data["gamma"] = this.gamma;
        return data;
    }
}

export interface ISaveProfileTuningValuesDTO {
    id: number;
    captureProfileId: number;
    autoLevelingOn: boolean;
    autoLevelingMode: number;
    autoLevelingLowThreshold: number;
    autoLevelingHighThreshold: number;
    lowerLevelLimit: number;
    upperLevelLimit: number;
    brightness: number;
    contrast: number;
    gamma: number;
}

export class SaveProfileVersionDTO implements ISaveProfileVersionDTO {
    id!: number;
    captureProfileId!: number;
    dateCreated!: Date;

    constructor(data?: ISaveProfileVersionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.captureProfileId = _data["captureProfileId"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SaveProfileVersionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProfileVersionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureProfileId"] = this.captureProfileId;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        return data;
    }
}

export interface ISaveProfileVersionDTO {
    id: number;
    captureProfileId: number;
    dateCreated: Date;
}

export class CapturePropertySaveDTO implements ICapturePropertySaveDTO {
    captureProfileVersionId?: number | undefined;
    robotId!: number;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: ICapturePropertySaveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captureProfileVersionId = _data["captureProfileVersionId"];
            this.robotId = _data["robotId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CapturePropertySaveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CapturePropertySaveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captureProfileVersionId"] = this.captureProfileVersionId;
        data["robotId"] = this.robotId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ICapturePropertySaveDTO {
    captureProfileVersionId?: number | undefined;
    robotId: number;
    name?: string | undefined;
    value?: string | undefined;
}

export class CapturePropertyRobotDTO implements ICapturePropertyRobotDTO {
    data?: { [key: string]: { [key: string]: any; }; } | undefined;

    constructor(data?: ICapturePropertyRobotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (this.data as any)![key] = _data["data"][key] !== undefined ? _data["data"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): CapturePropertyRobotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CapturePropertyRobotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = (this.data as any)[key];
            }
        }
        return data;
    }
}

export interface ICapturePropertyRobotDTO {
    data?: { [key: string]: { [key: string]: any; }; } | undefined;
}

export class RegionCaptureProfile implements IRegionCaptureProfile {
    id!: number;
    regionId!: number;
    captureProfileId!: number;
    imagingEnabled!: boolean;
    captureProfile?: CaptureProfile | undefined;
    region?: Region | undefined;

    constructor(data?: IRegionCaptureProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.captureProfileId = _data["captureProfileId"];
            this.imagingEnabled = _data["imagingEnabled"];
            this.captureProfile = _data["captureProfile"] ? CaptureProfile.fromJS(_data["captureProfile"]) : undefined as any;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegionCaptureProfile {
        data = typeof data === 'object' ? data : {};
        let result = new RegionCaptureProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["captureProfileId"] = this.captureProfileId;
        data["imagingEnabled"] = this.imagingEnabled;
        data["captureProfile"] = this.captureProfile ? this.captureProfile.toJSON() : undefined as any;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegionCaptureProfile {
    id: number;
    regionId: number;
    captureProfileId: number;
    imagingEnabled: boolean;
    captureProfile?: CaptureProfile | undefined;
    region?: Region | undefined;
}

export class CaptureProfile implements ICaptureProfile {
    id!: number;
    name?: string | undefined;
    experimentPlateId?: number | undefined;
    currentCaptureProfileVersionId?: number | undefined;
    enabled?: boolean | undefined;
    status!: number;
    parentId?: number | undefined;
    importFl?: boolean | undefined;
    experimentPlate?: ExperimentPlate | undefined;
    captureProfileTuningValues?: CaptureProfileTuningValues[] | undefined;
    captureProfileVersion?: CaptureProfileVersion[] | undefined;
    experimentCaptureProfileTuningValues?: ExperimentCaptureProfileTuningValues[] | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
    imagingScheduleEntryCaptureProfile?: ImagingScheduleEntryCaptureProfile[] | undefined;
    imagingTaskCaptureProfile?: ImagingTaskCaptureProfile[] | undefined;
    regionCaptureProfile?: RegionCaptureProfile[] | undefined;

    constructor(data?: ICaptureProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.experimentPlateId = _data["experimentPlateId"];
            this.currentCaptureProfileVersionId = _data["currentCaptureProfileVersionId"];
            this.enabled = _data["enabled"];
            this.status = _data["status"];
            this.parentId = _data["parentId"];
            this.importFl = _data["importFl"];
            this.experimentPlate = _data["experimentPlate"] ? ExperimentPlate.fromJS(_data["experimentPlate"]) : undefined as any;
            if (Array.isArray(_data["captureProfileTuningValues"])) {
                this.captureProfileTuningValues = [] as any;
                for (let item of _data["captureProfileTuningValues"])
                    this.captureProfileTuningValues!.push(CaptureProfileTuningValues.fromJS(item));
            }
            if (Array.isArray(_data["captureProfileVersion"])) {
                this.captureProfileVersion = [] as any;
                for (let item of _data["captureProfileVersion"])
                    this.captureProfileVersion!.push(CaptureProfileVersion.fromJS(item));
            }
            if (Array.isArray(_data["experimentCaptureProfileTuningValues"])) {
                this.experimentCaptureProfileTuningValues = [] as any;
                for (let item of _data["experimentCaptureProfileTuningValues"])
                    this.experimentCaptureProfileTuningValues!.push(ExperimentCaptureProfileTuningValues.fromJS(item));
            }
            if (Array.isArray(_data["imageBatchWellDropScore"])) {
                this.imageBatchWellDropScore = [] as any;
                for (let item of _data["imageBatchWellDropScore"])
                    this.imageBatchWellDropScore!.push(ImageBatchWellDropScore.fromJS(item));
            }
            if (Array.isArray(_data["imagingScheduleEntryCaptureProfile"])) {
                this.imagingScheduleEntryCaptureProfile = [] as any;
                for (let item of _data["imagingScheduleEntryCaptureProfile"])
                    this.imagingScheduleEntryCaptureProfile!.push(ImagingScheduleEntryCaptureProfile.fromJS(item));
            }
            if (Array.isArray(_data["imagingTaskCaptureProfile"])) {
                this.imagingTaskCaptureProfile = [] as any;
                for (let item of _data["imagingTaskCaptureProfile"])
                    this.imagingTaskCaptureProfile!.push(ImagingTaskCaptureProfile.fromJS(item));
            }
            if (Array.isArray(_data["regionCaptureProfile"])) {
                this.regionCaptureProfile = [] as any;
                for (let item of _data["regionCaptureProfile"])
                    this.regionCaptureProfile!.push(RegionCaptureProfile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaptureProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["experimentPlateId"] = this.experimentPlateId;
        data["currentCaptureProfileVersionId"] = this.currentCaptureProfileVersionId;
        data["enabled"] = this.enabled;
        data["status"] = this.status;
        data["parentId"] = this.parentId;
        data["importFl"] = this.importFl;
        data["experimentPlate"] = this.experimentPlate ? this.experimentPlate.toJSON() : undefined as any;
        if (Array.isArray(this.captureProfileTuningValues)) {
            data["captureProfileTuningValues"] = [];
            for (let item of this.captureProfileTuningValues)
                data["captureProfileTuningValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.captureProfileVersion)) {
            data["captureProfileVersion"] = [];
            for (let item of this.captureProfileVersion)
                data["captureProfileVersion"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.experimentCaptureProfileTuningValues)) {
            data["experimentCaptureProfileTuningValues"] = [];
            for (let item of this.experimentCaptureProfileTuningValues)
                data["experimentCaptureProfileTuningValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageBatchWellDropScore)) {
            data["imageBatchWellDropScore"] = [];
            for (let item of this.imageBatchWellDropScore)
                data["imageBatchWellDropScore"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagingScheduleEntryCaptureProfile)) {
            data["imagingScheduleEntryCaptureProfile"] = [];
            for (let item of this.imagingScheduleEntryCaptureProfile)
                data["imagingScheduleEntryCaptureProfile"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagingTaskCaptureProfile)) {
            data["imagingTaskCaptureProfile"] = [];
            for (let item of this.imagingTaskCaptureProfile)
                data["imagingTaskCaptureProfile"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionCaptureProfile)) {
            data["regionCaptureProfile"] = [];
            for (let item of this.regionCaptureProfile)
                data["regionCaptureProfile"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICaptureProfile {
    id: number;
    name?: string | undefined;
    experimentPlateId?: number | undefined;
    currentCaptureProfileVersionId?: number | undefined;
    enabled?: boolean | undefined;
    status: number;
    parentId?: number | undefined;
    importFl?: boolean | undefined;
    experimentPlate?: ExperimentPlate | undefined;
    captureProfileTuningValues?: CaptureProfileTuningValues[] | undefined;
    captureProfileVersion?: CaptureProfileVersion[] | undefined;
    experimentCaptureProfileTuningValues?: ExperimentCaptureProfileTuningValues[] | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
    imagingScheduleEntryCaptureProfile?: ImagingScheduleEntryCaptureProfile[] | undefined;
    imagingTaskCaptureProfile?: ImagingTaskCaptureProfile[] | undefined;
    regionCaptureProfile?: RegionCaptureProfile[] | undefined;
}

export class ExperimentPlate implements IExperimentPlate {
    id!: number;
    plateId!: number;
    imagingTasksEnabled!: boolean;
    notes?: string | undefined;
    imagesViewed?: boolean | undefined;
    plate?: Plate | undefined;
    captureProfile?: CaptureProfile[] | undefined;
    imagingTask?: ImagingTask[] | undefined;

    constructor(data?: IExperimentPlate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plateId = _data["plateId"];
            this.imagingTasksEnabled = _data["imagingTasksEnabled"];
            this.notes = _data["notes"];
            this.imagesViewed = _data["imagesViewed"];
            this.plate = _data["plate"] ? Plate.fromJS(_data["plate"]) : undefined as any;
            if (Array.isArray(_data["captureProfile"])) {
                this.captureProfile = [] as any;
                for (let item of _data["captureProfile"])
                    this.captureProfile!.push(CaptureProfile.fromJS(item));
            }
            if (Array.isArray(_data["imagingTask"])) {
                this.imagingTask = [] as any;
                for (let item of _data["imagingTask"])
                    this.imagingTask!.push(ImagingTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExperimentPlate {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentPlate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plateId"] = this.plateId;
        data["imagingTasksEnabled"] = this.imagingTasksEnabled;
        data["notes"] = this.notes;
        data["imagesViewed"] = this.imagesViewed;
        data["plate"] = this.plate ? this.plate.toJSON() : undefined as any;
        if (Array.isArray(this.captureProfile)) {
            data["captureProfile"] = [];
            for (let item of this.captureProfile)
                data["captureProfile"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagingTask)) {
            data["imagingTask"] = [];
            for (let item of this.imagingTask)
                data["imagingTask"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExperimentPlate {
    id: number;
    plateId: number;
    imagingTasksEnabled: boolean;
    notes?: string | undefined;
    imagesViewed?: boolean | undefined;
    plate?: Plate | undefined;
    captureProfile?: CaptureProfile[] | undefined;
    imagingTask?: ImagingTask[] | undefined;
}

export class Plate implements IPlate {
    plateContainerID!: number;
    id!: number;
    plateNumber!: number;
    experimentId!: number;
    barcode?: string | undefined;
    treeNodeId!: number;
    state!: number;
    isQueued!: boolean;
    robotID?: number | undefined;
    dateDispensed?: Date | undefined;
    dispensingRobotId?: number | undefined;
    canvasRowPosition!: number;
    canvasColumnPosition!: number;
    isopreviousPlateId?: number | undefined;
    isoroundNumber?: number | undefined;
    dispensingRobot?: DispensingRobot | undefined;
    experiment?: Experiment | undefined;
    treeNode?: TreeNode | undefined;
    dispenseQueue?: DispenseQueue[] | undefined;
    experimentPlate?: ExperimentPlate[] | undefined;
    isowellDropScoreValue?: IsowellDropScoreValue[] | undefined;
    plateEvents?: PlateEvents[] | undefined;
    screenLotPlate?: ScreenLotPlate[] | undefined;
    seed?: Seed[] | undefined;
    well?: Well[] | undefined;

    constructor(data?: IPlate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateContainerID = _data["plateContainerID"];
            this.id = _data["id"];
            this.plateNumber = _data["plateNumber"];
            this.experimentId = _data["experimentId"];
            this.barcode = _data["barcode"];
            this.treeNodeId = _data["treeNodeId"];
            this.state = _data["state"];
            this.isQueued = _data["isQueued"];
            this.robotID = _data["robotID"];
            this.dateDispensed = _data["dateDispensed"] ? new Date(_data["dateDispensed"].toString()) : undefined as any;
            this.dispensingRobotId = _data["dispensingRobotId"];
            this.canvasRowPosition = _data["canvasRowPosition"];
            this.canvasColumnPosition = _data["canvasColumnPosition"];
            this.isopreviousPlateId = _data["isopreviousPlateId"];
            this.isoroundNumber = _data["isoroundNumber"];
            this.dispensingRobot = _data["dispensingRobot"] ? DispensingRobot.fromJS(_data["dispensingRobot"]) : undefined as any;
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            if (Array.isArray(_data["dispenseQueue"])) {
                this.dispenseQueue = [] as any;
                for (let item of _data["dispenseQueue"])
                    this.dispenseQueue!.push(DispenseQueue.fromJS(item));
            }
            if (Array.isArray(_data["experimentPlate"])) {
                this.experimentPlate = [] as any;
                for (let item of _data["experimentPlate"])
                    this.experimentPlate!.push(ExperimentPlate.fromJS(item));
            }
            if (Array.isArray(_data["isowellDropScoreValue"])) {
                this.isowellDropScoreValue = [] as any;
                for (let item of _data["isowellDropScoreValue"])
                    this.isowellDropScoreValue!.push(IsowellDropScoreValue.fromJS(item));
            }
            if (Array.isArray(_data["plateEvents"])) {
                this.plateEvents = [] as any;
                for (let item of _data["plateEvents"])
                    this.plateEvents!.push(PlateEvents.fromJS(item));
            }
            if (Array.isArray(_data["screenLotPlate"])) {
                this.screenLotPlate = [] as any;
                for (let item of _data["screenLotPlate"])
                    this.screenLotPlate!.push(ScreenLotPlate.fromJS(item));
            }
            if (Array.isArray(_data["seed"])) {
                this.seed = [] as any;
                for (let item of _data["seed"])
                    this.seed!.push(Seed.fromJS(item));
            }
            if (Array.isArray(_data["well"])) {
                this.well = [] as any;
                for (let item of _data["well"])
                    this.well!.push(Well.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Plate {
        data = typeof data === 'object' ? data : {};
        let result = new Plate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateContainerID"] = this.plateContainerID;
        data["id"] = this.id;
        data["plateNumber"] = this.plateNumber;
        data["experimentId"] = this.experimentId;
        data["barcode"] = this.barcode;
        data["treeNodeId"] = this.treeNodeId;
        data["state"] = this.state;
        data["isQueued"] = this.isQueued;
        data["robotID"] = this.robotID;
        data["dateDispensed"] = this.dateDispensed ? this.dateDispensed.toISOString() : undefined as any;
        data["dispensingRobotId"] = this.dispensingRobotId;
        data["canvasRowPosition"] = this.canvasRowPosition;
        data["canvasColumnPosition"] = this.canvasColumnPosition;
        data["isopreviousPlateId"] = this.isopreviousPlateId;
        data["isoroundNumber"] = this.isoroundNumber;
        data["dispensingRobot"] = this.dispensingRobot ? this.dispensingRobot.toJSON() : undefined as any;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        if (Array.isArray(this.dispenseQueue)) {
            data["dispenseQueue"] = [];
            for (let item of this.dispenseQueue)
                data["dispenseQueue"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.experimentPlate)) {
            data["experimentPlate"] = [];
            for (let item of this.experimentPlate)
                data["experimentPlate"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isowellDropScoreValue)) {
            data["isowellDropScoreValue"] = [];
            for (let item of this.isowellDropScoreValue)
                data["isowellDropScoreValue"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plateEvents)) {
            data["plateEvents"] = [];
            for (let item of this.plateEvents)
                data["plateEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenLotPlate)) {
            data["screenLotPlate"] = [];
            for (let item of this.screenLotPlate)
                data["screenLotPlate"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seed)) {
            data["seed"] = [];
            for (let item of this.seed)
                data["seed"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.well)) {
            data["well"] = [];
            for (let item of this.well)
                data["well"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPlate {
    plateContainerID: number;
    id: number;
    plateNumber: number;
    experimentId: number;
    barcode?: string | undefined;
    treeNodeId: number;
    state: number;
    isQueued: boolean;
    robotID?: number | undefined;
    dateDispensed?: Date | undefined;
    dispensingRobotId?: number | undefined;
    canvasRowPosition: number;
    canvasColumnPosition: number;
    isopreviousPlateId?: number | undefined;
    isoroundNumber?: number | undefined;
    dispensingRobot?: DispensingRobot | undefined;
    experiment?: Experiment | undefined;
    treeNode?: TreeNode | undefined;
    dispenseQueue?: DispenseQueue[] | undefined;
    experimentPlate?: ExperimentPlate[] | undefined;
    isowellDropScoreValue?: IsowellDropScoreValue[] | undefined;
    plateEvents?: PlateEvents[] | undefined;
    screenLotPlate?: ScreenLotPlate[] | undefined;
    seed?: Seed[] | undefined;
    well?: Well[] | undefined;
}

export class DispensingRobot implements IDispensingRobot {
    id!: number;
    name?: string | undefined;
    isDefault!: boolean;
    typeId!: number;
    type?: DispensingRobotType | undefined;
    deck?: Deck[] | undefined;
    dispenseQueue?: DispenseQueue[] | undefined;
    driverProperty?: DriverProperty[] | undefined;
    lidStorageType?: LidStorageType[] | undefined;
    plate?: Plate[] | undefined;
    rackType?: RackType[] | undefined;

    constructor(data?: IDispensingRobot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.typeId = _data["typeId"];
            this.type = _data["type"] ? DispensingRobotType.fromJS(_data["type"]) : undefined as any;
            if (Array.isArray(_data["deck"])) {
                this.deck = [] as any;
                for (let item of _data["deck"])
                    this.deck!.push(Deck.fromJS(item));
            }
            if (Array.isArray(_data["dispenseQueue"])) {
                this.dispenseQueue = [] as any;
                for (let item of _data["dispenseQueue"])
                    this.dispenseQueue!.push(DispenseQueue.fromJS(item));
            }
            if (Array.isArray(_data["driverProperty"])) {
                this.driverProperty = [] as any;
                for (let item of _data["driverProperty"])
                    this.driverProperty!.push(DriverProperty.fromJS(item));
            }
            if (Array.isArray(_data["lidStorageType"])) {
                this.lidStorageType = [] as any;
                for (let item of _data["lidStorageType"])
                    this.lidStorageType!.push(LidStorageType.fromJS(item));
            }
            if (Array.isArray(_data["plate"])) {
                this.plate = [] as any;
                for (let item of _data["plate"])
                    this.plate!.push(Plate.fromJS(item));
            }
            if (Array.isArray(_data["rackType"])) {
                this.rackType = [] as any;
                for (let item of _data["rackType"])
                    this.rackType!.push(RackType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DispensingRobot {
        data = typeof data === 'object' ? data : {};
        let result = new DispensingRobot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["typeId"] = this.typeId;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        if (Array.isArray(this.deck)) {
            data["deck"] = [];
            for (let item of this.deck)
                data["deck"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dispenseQueue)) {
            data["dispenseQueue"] = [];
            for (let item of this.dispenseQueue)
                data["dispenseQueue"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.driverProperty)) {
            data["driverProperty"] = [];
            for (let item of this.driverProperty)
                data["driverProperty"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lidStorageType)) {
            data["lidStorageType"] = [];
            for (let item of this.lidStorageType)
                data["lidStorageType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plate)) {
            data["plate"] = [];
            for (let item of this.plate)
                data["plate"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rackType)) {
            data["rackType"] = [];
            for (let item of this.rackType)
                data["rackType"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDispensingRobot {
    id: number;
    name?: string | undefined;
    isDefault: boolean;
    typeId: number;
    type?: DispensingRobotType | undefined;
    deck?: Deck[] | undefined;
    dispenseQueue?: DispenseQueue[] | undefined;
    driverProperty?: DriverProperty[] | undefined;
    lidStorageType?: LidStorageType[] | undefined;
    plate?: Plate[] | undefined;
    rackType?: RackType[] | undefined;
}

export class DispensingRobotType implements IDispensingRobotType {
    id!: number;
    type?: string | undefined;
    dispensingRobot?: DispensingRobot[] | undefined;

    constructor(data?: IDispensingRobotType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            if (Array.isArray(_data["dispensingRobot"])) {
                this.dispensingRobot = [] as any;
                for (let item of _data["dispensingRobot"])
                    this.dispensingRobot!.push(DispensingRobot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DispensingRobotType {
        data = typeof data === 'object' ? data : {};
        let result = new DispensingRobotType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        if (Array.isArray(this.dispensingRobot)) {
            data["dispensingRobot"] = [];
            for (let item of this.dispensingRobot)
                data["dispensingRobot"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDispensingRobotType {
    id: number;
    type?: string | undefined;
    dispensingRobot?: DispensingRobot[] | undefined;
}

export class Deck implements IDeck {
    id!: number;
    rackId?: number | undefined;
    siteName?: string | undefined;
    lidSiteName?: string | undefined;
    lidStorageId?: number | undefined;
    dispensingRobotId!: number;
    dispensingRobot?: DispensingRobot | undefined;
    lidStorage?: LidStorage | undefined;
    rack?: Rack | undefined;

    constructor(data?: IDeck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rackId = _data["rackId"];
            this.siteName = _data["siteName"];
            this.lidSiteName = _data["lidSiteName"];
            this.lidStorageId = _data["lidStorageId"];
            this.dispensingRobotId = _data["dispensingRobotId"];
            this.dispensingRobot = _data["dispensingRobot"] ? DispensingRobot.fromJS(_data["dispensingRobot"]) : undefined as any;
            this.lidStorage = _data["lidStorage"] ? LidStorage.fromJS(_data["lidStorage"]) : undefined as any;
            this.rack = _data["rack"] ? Rack.fromJS(_data["rack"]) : undefined as any;
        }
    }

    static fromJS(data: any): Deck {
        data = typeof data === 'object' ? data : {};
        let result = new Deck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rackId"] = this.rackId;
        data["siteName"] = this.siteName;
        data["lidSiteName"] = this.lidSiteName;
        data["lidStorageId"] = this.lidStorageId;
        data["dispensingRobotId"] = this.dispensingRobotId;
        data["dispensingRobot"] = this.dispensingRobot ? this.dispensingRobot.toJSON() : undefined as any;
        data["lidStorage"] = this.lidStorage ? this.lidStorage.toJSON() : undefined as any;
        data["rack"] = this.rack ? this.rack.toJSON() : undefined as any;
        return data;
    }
}

export interface IDeck {
    id: number;
    rackId?: number | undefined;
    siteName?: string | undefined;
    lidSiteName?: string | undefined;
    lidStorageId?: number | undefined;
    dispensingRobotId: number;
    dispensingRobot?: DispensingRobot | undefined;
    lidStorage?: LidStorage | undefined;
    rack?: Rack | undefined;
}

export class LidStorage implements ILidStorage {
    id!: number;
    siteName?: string | undefined;
    lidStorageTypeId!: number;
    lidStorageType?: LidStorageType | undefined;
    deck?: Deck[] | undefined;

    constructor(data?: ILidStorage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteName = _data["siteName"];
            this.lidStorageTypeId = _data["lidStorageTypeId"];
            this.lidStorageType = _data["lidStorageType"] ? LidStorageType.fromJS(_data["lidStorageType"]) : undefined as any;
            if (Array.isArray(_data["deck"])) {
                this.deck = [] as any;
                for (let item of _data["deck"])
                    this.deck!.push(Deck.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LidStorage {
        data = typeof data === 'object' ? data : {};
        let result = new LidStorage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteName"] = this.siteName;
        data["lidStorageTypeId"] = this.lidStorageTypeId;
        data["lidStorageType"] = this.lidStorageType ? this.lidStorageType.toJSON() : undefined as any;
        if (Array.isArray(this.deck)) {
            data["deck"] = [];
            for (let item of this.deck)
                data["deck"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILidStorage {
    id: number;
    siteName?: string | undefined;
    lidStorageTypeId: number;
    lidStorageType?: LidStorageType | undefined;
    deck?: Deck[] | undefined;
}

export class LidStorageType implements ILidStorageType {
    id!: number;
    name?: string | undefined;
    numCols!: number;
    numRows!: number;
    numStack!: number;
    dispensingRobotId!: number;
    dispensingRobot?: DispensingRobot | undefined;
    lidStorage?: LidStorage[] | undefined;

    constructor(data?: ILidStorageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numCols = _data["numCols"];
            this.numRows = _data["numRows"];
            this.numStack = _data["numStack"];
            this.dispensingRobotId = _data["dispensingRobotId"];
            this.dispensingRobot = _data["dispensingRobot"] ? DispensingRobot.fromJS(_data["dispensingRobot"]) : undefined as any;
            if (Array.isArray(_data["lidStorage"])) {
                this.lidStorage = [] as any;
                for (let item of _data["lidStorage"])
                    this.lidStorage!.push(LidStorage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LidStorageType {
        data = typeof data === 'object' ? data : {};
        let result = new LidStorageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numCols"] = this.numCols;
        data["numRows"] = this.numRows;
        data["numStack"] = this.numStack;
        data["dispensingRobotId"] = this.dispensingRobotId;
        data["dispensingRobot"] = this.dispensingRobot ? this.dispensingRobot.toJSON() : undefined as any;
        if (Array.isArray(this.lidStorage)) {
            data["lidStorage"] = [];
            for (let item of this.lidStorage)
                data["lidStorage"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILidStorageType {
    id: number;
    name?: string | undefined;
    numCols: number;
    numRows: number;
    numStack: number;
    dispensingRobotId: number;
    dispensingRobot?: DispensingRobot | undefined;
    lidStorage?: LidStorage[] | undefined;
}

export class Rack implements IRack {
    id!: number;
    rackTypeId!: number;
    name?: string | undefined;
    rackType?: RackType | undefined;
    deck?: Deck[] | undefined;
    rackIngredient?: RackIngredient[] | undefined;

    constructor(data?: IRack) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rackTypeId = _data["rackTypeId"];
            this.name = _data["name"];
            this.rackType = _data["rackType"] ? RackType.fromJS(_data["rackType"]) : undefined as any;
            if (Array.isArray(_data["deck"])) {
                this.deck = [] as any;
                for (let item of _data["deck"])
                    this.deck!.push(Deck.fromJS(item));
            }
            if (Array.isArray(_data["rackIngredient"])) {
                this.rackIngredient = [] as any;
                for (let item of _data["rackIngredient"])
                    this.rackIngredient!.push(RackIngredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Rack {
        data = typeof data === 'object' ? data : {};
        let result = new Rack();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rackTypeId"] = this.rackTypeId;
        data["name"] = this.name;
        data["rackType"] = this.rackType ? this.rackType.toJSON() : undefined as any;
        if (Array.isArray(this.deck)) {
            data["deck"] = [];
            for (let item of this.deck)
                data["deck"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rackIngredient)) {
            data["rackIngredient"] = [];
            for (let item of this.rackIngredient)
                data["rackIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRack {
    id: number;
    rackTypeId: number;
    name?: string | undefined;
    rackType?: RackType | undefined;
    deck?: Deck[] | undefined;
    rackIngredient?: RackIngredient[] | undefined;
}

export class RackType implements IRackType {
    id!: number;
    name?: string | undefined;
    numCols!: number;
    numRows!: number;
    tipAccess!: number;
    volume!: number;
    deadVolume!: number;
    dispensingRobotId!: number;
    dispensingRobot?: DispensingRobot | undefined;
    rack?: Rack[] | undefined;

    constructor(data?: IRackType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numCols = _data["numCols"];
            this.numRows = _data["numRows"];
            this.tipAccess = _data["tipAccess"];
            this.volume = _data["volume"];
            this.deadVolume = _data["deadVolume"];
            this.dispensingRobotId = _data["dispensingRobotId"];
            this.dispensingRobot = _data["dispensingRobot"] ? DispensingRobot.fromJS(_data["dispensingRobot"]) : undefined as any;
            if (Array.isArray(_data["rack"])) {
                this.rack = [] as any;
                for (let item of _data["rack"])
                    this.rack!.push(Rack.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RackType {
        data = typeof data === 'object' ? data : {};
        let result = new RackType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numCols"] = this.numCols;
        data["numRows"] = this.numRows;
        data["tipAccess"] = this.tipAccess;
        data["volume"] = this.volume;
        data["deadVolume"] = this.deadVolume;
        data["dispensingRobotId"] = this.dispensingRobotId;
        data["dispensingRobot"] = this.dispensingRobot ? this.dispensingRobot.toJSON() : undefined as any;
        if (Array.isArray(this.rack)) {
            data["rack"] = [];
            for (let item of this.rack)
                data["rack"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRackType {
    id: number;
    name?: string | undefined;
    numCols: number;
    numRows: number;
    tipAccess: number;
    volume: number;
    deadVolume: number;
    dispensingRobotId: number;
    dispensingRobot?: DispensingRobot | undefined;
    rack?: Rack[] | undefined;
}

export class RackIngredient implements IRackIngredient {
    id!: number;
    rackId!: number;
    ingredientStockId!: number;
    rackPosition!: number;
    volume?: number | undefined;
    barcode?: string | undefined;
    ingredientStock?: IngredientStock | undefined;
    rack?: Rack | undefined;

    constructor(data?: IRackIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rackId = _data["rackId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.rackPosition = _data["rackPosition"];
            this.volume = _data["volume"];
            this.barcode = _data["barcode"];
            this.ingredientStock = _data["ingredientStock"] ? IngredientStock.fromJS(_data["ingredientStock"]) : undefined as any;
            this.rack = _data["rack"] ? Rack.fromJS(_data["rack"]) : undefined as any;
        }
    }

    static fromJS(data: any): RackIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new RackIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rackId"] = this.rackId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["rackPosition"] = this.rackPosition;
        data["volume"] = this.volume;
        data["barcode"] = this.barcode;
        data["ingredientStock"] = this.ingredientStock ? this.ingredientStock.toJSON() : undefined as any;
        data["rack"] = this.rack ? this.rack.toJSON() : undefined as any;
        return data;
    }
}

export interface IRackIngredient {
    id: number;
    rackId: number;
    ingredientStockId: number;
    rackPosition: number;
    volume?: number | undefined;
    barcode?: string | undefined;
    ingredientStock?: IngredientStock | undefined;
    rack?: Rack | undefined;
}

export class IngredientStock implements IIngredientStock {
    id!: number;
    ingredientId!: number;
    stockNumber!: number;
    stockConcentration!: number;
    lowConcentration!: number;
    highConcentration!: number;
    concentrationUnits?: string | undefined;
    stockPh?: number | undefined;
    isBuffer!: boolean;
    isPrepared!: boolean;
    liquidClassId!: number;
    labelPrinted!: boolean;
    dispenseOrder!: number;
    vendorId?: number | undefined;
    vendorPartNumber?: string | undefined;
    comments?: string | undefined;
    stockLocation?: string | undefined;
    active?: boolean | undefined;
    ingredient?: Ingredient | undefined;
    liquidClass?: LiquidClass | undefined;
    vendor?: Vendor | undefined;

    constructor(data?: IIngredientStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientId = _data["ingredientId"];
            this.stockNumber = _data["stockNumber"];
            this.stockConcentration = _data["stockConcentration"];
            this.lowConcentration = _data["lowConcentration"];
            this.highConcentration = _data["highConcentration"];
            this.concentrationUnits = _data["concentrationUnits"];
            this.stockPh = _data["stockPh"];
            this.isBuffer = _data["isBuffer"];
            this.isPrepared = _data["isPrepared"];
            this.liquidClassId = _data["liquidClassId"];
            this.labelPrinted = _data["labelPrinted"];
            this.dispenseOrder = _data["dispenseOrder"];
            this.vendorId = _data["vendorId"];
            this.vendorPartNumber = _data["vendorPartNumber"];
            this.comments = _data["comments"];
            this.stockLocation = _data["stockLocation"];
            this.active = _data["active"];
            this.ingredient = _data["ingredient"] ? Ingredient.fromJS(_data["ingredient"]) : undefined as any;
            this.liquidClass = _data["liquidClass"] ? LiquidClass.fromJS(_data["liquidClass"]) : undefined as any;
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : undefined as any;
        }
    }

    static fromJS(data: any): IngredientStock {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientStock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientId"] = this.ingredientId;
        data["stockNumber"] = this.stockNumber;
        data["stockConcentration"] = this.stockConcentration;
        data["lowConcentration"] = this.lowConcentration;
        data["highConcentration"] = this.highConcentration;
        data["concentrationUnits"] = this.concentrationUnits;
        data["stockPh"] = this.stockPh;
        data["isBuffer"] = this.isBuffer;
        data["isPrepared"] = this.isPrepared;
        data["liquidClassId"] = this.liquidClassId;
        data["labelPrinted"] = this.labelPrinted;
        data["dispenseOrder"] = this.dispenseOrder;
        data["vendorId"] = this.vendorId;
        data["vendorPartNumber"] = this.vendorPartNumber;
        data["comments"] = this.comments;
        data["stockLocation"] = this.stockLocation;
        data["active"] = this.active;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        data["liquidClass"] = this.liquidClass ? this.liquidClass.toJSON() : undefined as any;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : undefined as any;
        return data;
    }
}

export interface IIngredientStock {
    id: number;
    ingredientId: number;
    stockNumber: number;
    stockConcentration: number;
    lowConcentration: number;
    highConcentration: number;
    concentrationUnits?: string | undefined;
    stockPh?: number | undefined;
    isBuffer: boolean;
    isPrepared: boolean;
    liquidClassId: number;
    labelPrinted: boolean;
    dispenseOrder: number;
    vendorId?: number | undefined;
    vendorPartNumber?: string | undefined;
    comments?: string | undefined;
    stockLocation?: string | undefined;
    active?: boolean | undefined;
    ingredient?: Ingredient | undefined;
    liquidClass?: LiquidClass | undefined;
    vendor?: Vendor | undefined;
}

export class Ingredient implements IIngredient {
    id!: number;
    longName?: string | undefined;
    shortName?: string | undefined;
    maxStockNumber!: number;
    defaultNonBufferIngredientStockId?: number | undefined;
    defaultBufferIngredientStockId?: number | undefined;
    bufferCalculationTypeId?: number | undefined;
    pKa?: number | undefined;
    exportIngredientAliasId?: number | undefined;
    bufferCalculationType?: BufferCalculationType | undefined;
    bufferDataPoint?: BufferDataPoint[] | undefined;
    casnumber?: Casnumber[] | undefined;
    ingredientAlias?: IngredientAlias[] | undefined;
    ingredientIngredientType?: IngredientIngredientType[] | undefined;
    ingredientStock?: IngredientStock[] | undefined;
    randomLayerExcludeListIngredient1?: RandomLayerExcludeList[] | undefined;
    randomLayerExcludeListIngredient2?: RandomLayerExcludeList[] | undefined;

    constructor(data?: IIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.longName = _data["longName"];
            this.shortName = _data["shortName"];
            this.maxStockNumber = _data["maxStockNumber"];
            this.defaultNonBufferIngredientStockId = _data["defaultNonBufferIngredientStockId"];
            this.defaultBufferIngredientStockId = _data["defaultBufferIngredientStockId"];
            this.bufferCalculationTypeId = _data["bufferCalculationTypeId"];
            this.pKa = _data["pKa"];
            this.exportIngredientAliasId = _data["exportIngredientAliasId"];
            this.bufferCalculationType = _data["bufferCalculationType"] ? BufferCalculationType.fromJS(_data["bufferCalculationType"]) : undefined as any;
            if (Array.isArray(_data["bufferDataPoint"])) {
                this.bufferDataPoint = [] as any;
                for (let item of _data["bufferDataPoint"])
                    this.bufferDataPoint!.push(BufferDataPoint.fromJS(item));
            }
            if (Array.isArray(_data["casnumber"])) {
                this.casnumber = [] as any;
                for (let item of _data["casnumber"])
                    this.casnumber!.push(Casnumber.fromJS(item));
            }
            if (Array.isArray(_data["ingredientAlias"])) {
                this.ingredientAlias = [] as any;
                for (let item of _data["ingredientAlias"])
                    this.ingredientAlias!.push(IngredientAlias.fromJS(item));
            }
            if (Array.isArray(_data["ingredientIngredientType"])) {
                this.ingredientIngredientType = [] as any;
                for (let item of _data["ingredientIngredientType"])
                    this.ingredientIngredientType!.push(IngredientIngredientType.fromJS(item));
            }
            if (Array.isArray(_data["ingredientStock"])) {
                this.ingredientStock = [] as any;
                for (let item of _data["ingredientStock"])
                    this.ingredientStock!.push(IngredientStock.fromJS(item));
            }
            if (Array.isArray(_data["randomLayerExcludeListIngredient1"])) {
                this.randomLayerExcludeListIngredient1 = [] as any;
                for (let item of _data["randomLayerExcludeListIngredient1"])
                    this.randomLayerExcludeListIngredient1!.push(RandomLayerExcludeList.fromJS(item));
            }
            if (Array.isArray(_data["randomLayerExcludeListIngredient2"])) {
                this.randomLayerExcludeListIngredient2 = [] as any;
                for (let item of _data["randomLayerExcludeListIngredient2"])
                    this.randomLayerExcludeListIngredient2!.push(RandomLayerExcludeList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Ingredient {
        data = typeof data === 'object' ? data : {};
        let result = new Ingredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["longName"] = this.longName;
        data["shortName"] = this.shortName;
        data["maxStockNumber"] = this.maxStockNumber;
        data["defaultNonBufferIngredientStockId"] = this.defaultNonBufferIngredientStockId;
        data["defaultBufferIngredientStockId"] = this.defaultBufferIngredientStockId;
        data["bufferCalculationTypeId"] = this.bufferCalculationTypeId;
        data["pKa"] = this.pKa;
        data["exportIngredientAliasId"] = this.exportIngredientAliasId;
        data["bufferCalculationType"] = this.bufferCalculationType ? this.bufferCalculationType.toJSON() : undefined as any;
        if (Array.isArray(this.bufferDataPoint)) {
            data["bufferDataPoint"] = [];
            for (let item of this.bufferDataPoint)
                data["bufferDataPoint"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.casnumber)) {
            data["casnumber"] = [];
            for (let item of this.casnumber)
                data["casnumber"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredientAlias)) {
            data["ingredientAlias"] = [];
            for (let item of this.ingredientAlias)
                data["ingredientAlias"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredientIngredientType)) {
            data["ingredientIngredientType"] = [];
            for (let item of this.ingredientIngredientType)
                data["ingredientIngredientType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredientStock)) {
            data["ingredientStock"] = [];
            for (let item of this.ingredientStock)
                data["ingredientStock"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.randomLayerExcludeListIngredient1)) {
            data["randomLayerExcludeListIngredient1"] = [];
            for (let item of this.randomLayerExcludeListIngredient1)
                data["randomLayerExcludeListIngredient1"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.randomLayerExcludeListIngredient2)) {
            data["randomLayerExcludeListIngredient2"] = [];
            for (let item of this.randomLayerExcludeListIngredient2)
                data["randomLayerExcludeListIngredient2"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIngredient {
    id: number;
    longName?: string | undefined;
    shortName?: string | undefined;
    maxStockNumber: number;
    defaultNonBufferIngredientStockId?: number | undefined;
    defaultBufferIngredientStockId?: number | undefined;
    bufferCalculationTypeId?: number | undefined;
    pKa?: number | undefined;
    exportIngredientAliasId?: number | undefined;
    bufferCalculationType?: BufferCalculationType | undefined;
    bufferDataPoint?: BufferDataPoint[] | undefined;
    casnumber?: Casnumber[] | undefined;
    ingredientAlias?: IngredientAlias[] | undefined;
    ingredientIngredientType?: IngredientIngredientType[] | undefined;
    ingredientStock?: IngredientStock[] | undefined;
    randomLayerExcludeListIngredient1?: RandomLayerExcludeList[] | undefined;
    randomLayerExcludeListIngredient2?: RandomLayerExcludeList[] | undefined;
}

export class BufferCalculationType implements IBufferCalculationType {
    id!: number;
    name?: string | undefined;
    ingredient?: Ingredient[] | undefined;

    constructor(data?: IBufferCalculationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["ingredient"])) {
                this.ingredient = [] as any;
                for (let item of _data["ingredient"])
                    this.ingredient!.push(Ingredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BufferCalculationType {
        data = typeof data === 'object' ? data : {};
        let result = new BufferCalculationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.ingredient)) {
            data["ingredient"] = [];
            for (let item of this.ingredient)
                data["ingredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBufferCalculationType {
    id: number;
    name?: string | undefined;
    ingredient?: Ingredient[] | undefined;
}

export class BufferDataPoint implements IBufferDataPoint {
    id!: number;
    ingredientId!: number;
    ph!: number;
    ratio!: number;
    ingredient?: Ingredient | undefined;

    constructor(data?: IBufferDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientId = _data["ingredientId"];
            this.ph = _data["ph"];
            this.ratio = _data["ratio"];
            this.ingredient = _data["ingredient"] ? Ingredient.fromJS(_data["ingredient"]) : undefined as any;
        }
    }

    static fromJS(data: any): BufferDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new BufferDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientId"] = this.ingredientId;
        data["ph"] = this.ph;
        data["ratio"] = this.ratio;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        return data;
    }
}

export interface IBufferDataPoint {
    id: number;
    ingredientId: number;
    ph: number;
    ratio: number;
    ingredient?: Ingredient | undefined;
}

export class Casnumber implements ICasnumber {
    id!: number;
    number?: string | undefined;
    ingredientId!: number;
    ingredient?: Ingredient | undefined;

    constructor(data?: ICasnumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.ingredientId = _data["ingredientId"];
            this.ingredient = _data["ingredient"] ? Ingredient.fromJS(_data["ingredient"]) : undefined as any;
        }
    }

    static fromJS(data: any): Casnumber {
        data = typeof data === 'object' ? data : {};
        let result = new Casnumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["ingredientId"] = this.ingredientId;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        return data;
    }
}

export interface ICasnumber {
    id: number;
    number?: string | undefined;
    ingredientId: number;
    ingredient?: Ingredient | undefined;
}

export class IngredientAlias implements IIngredientAlias {
    id!: number;
    ingredientId!: number;
    name?: string | undefined;
    ingredient?: Ingredient | undefined;

    constructor(data?: IIngredientAlias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientId = _data["ingredientId"];
            this.name = _data["name"];
            this.ingredient = _data["ingredient"] ? Ingredient.fromJS(_data["ingredient"]) : undefined as any;
        }
    }

    static fromJS(data: any): IngredientAlias {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientAlias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientId"] = this.ingredientId;
        data["name"] = this.name;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        return data;
    }
}

export interface IIngredientAlias {
    id: number;
    ingredientId: number;
    name?: string | undefined;
    ingredient?: Ingredient | undefined;
}

export class IngredientIngredientType implements IIngredientIngredientType {
    id!: number;
    ingredientId!: number;
    ingredientTypeId!: number;
    ingredient?: Ingredient | undefined;
    ingredientType?: IngredientType | undefined;

    constructor(data?: IIngredientIngredientType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientId = _data["ingredientId"];
            this.ingredientTypeId = _data["ingredientTypeId"];
            this.ingredient = _data["ingredient"] ? Ingredient.fromJS(_data["ingredient"]) : undefined as any;
            this.ingredientType = _data["ingredientType"] ? IngredientType.fromJS(_data["ingredientType"]) : undefined as any;
        }
    }

    static fromJS(data: any): IngredientIngredientType {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientIngredientType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientId"] = this.ingredientId;
        data["ingredientTypeId"] = this.ingredientTypeId;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        data["ingredientType"] = this.ingredientType ? this.ingredientType.toJSON() : undefined as any;
        return data;
    }
}

export interface IIngredientIngredientType {
    id: number;
    ingredientId: number;
    ingredientTypeId: number;
    ingredient?: Ingredient | undefined;
    ingredientType?: IngredientType | undefined;
}

export class IngredientType implements IIngredientType {
    id!: number;
    isBuffer!: boolean;
    name?: string | undefined;
    ingredientTypeColorId?: number | undefined;
    ingredientTypeColor?: IngredientTypeColor | undefined;

    constructor(data?: IIngredientType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isBuffer = _data["isBuffer"];
            this.name = _data["name"];
            this.ingredientTypeColorId = _data["ingredientTypeColorId"];
            this.ingredientTypeColor = _data["ingredientTypeColor"] ? IngredientTypeColor.fromJS(_data["ingredientTypeColor"]) : undefined as any;
        }
    }

    static fromJS(data: any): IngredientType {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBuffer"] = this.isBuffer;
        data["name"] = this.name;
        data["ingredientTypeColorId"] = this.ingredientTypeColorId;
        data["ingredientTypeColor"] = this.ingredientTypeColor ? this.ingredientTypeColor.toJSON() : undefined as any;
        return data;
    }
}

export interface IIngredientType {
    id: number;
    isBuffer: boolean;
    name?: string | undefined;
    ingredientTypeColorId?: number | undefined;
    ingredientTypeColor?: IngredientTypeColor | undefined;
}

export class IngredientTypeColor implements IIngredientTypeColor {
    id!: number;
    groupId!: number;
    colorToneSequence!: number;
    color!: number;

    constructor(data?: IIngredientTypeColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.colorToneSequence = _data["colorToneSequence"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): IngredientTypeColor {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTypeColor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["colorToneSequence"] = this.colorToneSequence;
        data["color"] = this.color;
        return data;
    }
}

export interface IIngredientTypeColor {
    id: number;
    groupId: number;
    colorToneSequence: number;
    color: number;
}

export class RandomLayerExcludeList implements IRandomLayerExcludeList {
    id!: number;
    randomLayerId!: number;
    ingredient1Id!: number;
    ingredient2Id!: number;
    ingredient1?: Ingredient | undefined;
    ingredient2?: Ingredient | undefined;
    randomLayer?: RandomLayer | undefined;

    constructor(data?: IRandomLayerExcludeList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.randomLayerId = _data["randomLayerId"];
            this.ingredient1Id = _data["ingredient1Id"];
            this.ingredient2Id = _data["ingredient2Id"];
            this.ingredient1 = _data["ingredient1"] ? Ingredient.fromJS(_data["ingredient1"]) : undefined as any;
            this.ingredient2 = _data["ingredient2"] ? Ingredient.fromJS(_data["ingredient2"]) : undefined as any;
            this.randomLayer = _data["randomLayer"] ? RandomLayer.fromJS(_data["randomLayer"]) : undefined as any;
        }
    }

    static fromJS(data: any): RandomLayerExcludeList {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayerExcludeList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["randomLayerId"] = this.randomLayerId;
        data["ingredient1Id"] = this.ingredient1Id;
        data["ingredient2Id"] = this.ingredient2Id;
        data["ingredient1"] = this.ingredient1 ? this.ingredient1.toJSON() : undefined as any;
        data["ingredient2"] = this.ingredient2 ? this.ingredient2.toJSON() : undefined as any;
        data["randomLayer"] = this.randomLayer ? this.randomLayer.toJSON() : undefined as any;
        return data;
    }
}

export interface IRandomLayerExcludeList {
    id: number;
    randomLayerId: number;
    ingredient1Id: number;
    ingredient2Id: number;
    ingredient1?: Ingredient | undefined;
    ingredient2?: Ingredient | undefined;
    randomLayer?: RandomLayer | undefined;
}

export class RandomLayer implements IRandomLayer {
    id!: number;
    layerId!: number;
    experimentId!: number;
    gridSteps!: number;
    wellVolume!: number;
    experiment?: Experiment | undefined;
    layer?: Layer | undefined;
    randomLayerExcludeList?: RandomLayerExcludeList[] | undefined;
    randomLayerIngredientGroup?: RandomLayerIngredientGroup[] | undefined;

    constructor(data?: IRandomLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layerId = _data["layerId"];
            this.experimentId = _data["experimentId"];
            this.gridSteps = _data["gridSteps"];
            this.wellVolume = _data["wellVolume"];
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
            this.layer = _data["layer"] ? Layer.fromJS(_data["layer"]) : undefined as any;
            if (Array.isArray(_data["randomLayerExcludeList"])) {
                this.randomLayerExcludeList = [] as any;
                for (let item of _data["randomLayerExcludeList"])
                    this.randomLayerExcludeList!.push(RandomLayerExcludeList.fromJS(item));
            }
            if (Array.isArray(_data["randomLayerIngredientGroup"])) {
                this.randomLayerIngredientGroup = [] as any;
                for (let item of _data["randomLayerIngredientGroup"])
                    this.randomLayerIngredientGroup!.push(RandomLayerIngredientGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RandomLayer {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layerId"] = this.layerId;
        data["experimentId"] = this.experimentId;
        data["gridSteps"] = this.gridSteps;
        data["wellVolume"] = this.wellVolume;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        if (Array.isArray(this.randomLayerExcludeList)) {
            data["randomLayerExcludeList"] = [];
            for (let item of this.randomLayerExcludeList)
                data["randomLayerExcludeList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.randomLayerIngredientGroup)) {
            data["randomLayerIngredientGroup"] = [];
            for (let item of this.randomLayerIngredientGroup)
                data["randomLayerIngredientGroup"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRandomLayer {
    id: number;
    layerId: number;
    experimentId: number;
    gridSteps: number;
    wellVolume: number;
    experiment?: Experiment | undefined;
    layer?: Layer | undefined;
    randomLayerExcludeList?: RandomLayerExcludeList[] | undefined;
    randomLayerIngredientGroup?: RandomLayerIngredientGroup[] | undefined;
}

export class Experiment implements IExperiment {
    proteinLayer?: ProteinLayer[] | undefined;
    id!: number;
    seeding!: boolean;
    userId!: number;
    containerId!: number;
    imagingScheduleId!: number;
    treeNodeId!: number;
    datePrepared!: Date;
    setupTempId!: number;
    incubationTempId!: number;
    notes?: string | undefined;
    status!: ExperimentStatus;
    notebookPageNum?: string | undefined;
    reducingAgentVolume?: number | undefined;
    dispensingRobotId?: number | undefined;
    maxLotNumber?: number | undefined;
    plateRowCount!: number;
    plateColumnCount!: number;
    zoomRectangleX?: number | undefined;
    zoomRectangleY?: number | undefined;
    zoomRectangleWidth?: number | undefined;
    zoomRectangleHeight?: number | undefined;
    zoomLocked?: boolean | undefined;
    autoScoreThresholdsImageBatchId?: number | undefined;
    dispensingRobots?: string | undefined;
    autoScoreThresholdsImageBatch?: ImageBatch | undefined;
    container?: Containers | undefined;
    imagingSchedule?: ImagingSchedule | undefined;
    treeNode?: TreeNode | undefined;
    user?: Users | undefined;
    conditionListLayer?: ConditionListLayer[] | undefined;
    experimentCaptureProfileTuningValues?: ExperimentCaptureProfileTuningValues[] | undefined;
    fragmentLayer?: FragmentLayer[] | undefined;
    grid?: Grid[] | undefined;
    microfluidicsExperiment?: MicrofluidicsExperiment[] | undefined;
    plate?: Plate[] | undefined;
    randomLayer?: RandomLayer[] | undefined;
    screenLayer?: ScreenLayer[] | undefined;
    screenLot?: ScreenLot[] | undefined;
    seedLayer?: SeedLayer[] | undefined;

    constructor(data?: IExperiment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["proteinLayer"])) {
                this.proteinLayer = [] as any;
                for (let item of _data["proteinLayer"])
                    this.proteinLayer!.push(ProteinLayer.fromJS(item));
            }
            this.id = _data["id"];
            this.seeding = _data["seeding"];
            this.userId = _data["userId"];
            this.containerId = _data["containerId"];
            this.imagingScheduleId = _data["imagingScheduleId"];
            this.treeNodeId = _data["treeNodeId"];
            this.datePrepared = _data["datePrepared"] ? new Date(_data["datePrepared"].toString()) : undefined as any;
            this.setupTempId = _data["setupTempId"];
            this.incubationTempId = _data["incubationTempId"];
            this.notes = _data["notes"];
            this.status = _data["status"];
            this.notebookPageNum = _data["notebookPageNum"];
            this.reducingAgentVolume = _data["reducingAgentVolume"];
            this.dispensingRobotId = _data["dispensingRobotId"];
            this.maxLotNumber = _data["maxLotNumber"];
            this.plateRowCount = _data["plateRowCount"];
            this.plateColumnCount = _data["plateColumnCount"];
            this.zoomRectangleX = _data["zoomRectangleX"];
            this.zoomRectangleY = _data["zoomRectangleY"];
            this.zoomRectangleWidth = _data["zoomRectangleWidth"];
            this.zoomRectangleHeight = _data["zoomRectangleHeight"];
            this.zoomLocked = _data["zoomLocked"];
            this.autoScoreThresholdsImageBatchId = _data["autoScoreThresholdsImageBatchId"];
            this.dispensingRobots = _data["dispensingRobots"];
            this.autoScoreThresholdsImageBatch = _data["autoScoreThresholdsImageBatch"] ? ImageBatch.fromJS(_data["autoScoreThresholdsImageBatch"]) : undefined as any;
            this.container = _data["container"] ? Containers.fromJS(_data["container"]) : undefined as any;
            this.imagingSchedule = _data["imagingSchedule"] ? ImagingSchedule.fromJS(_data["imagingSchedule"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["conditionListLayer"])) {
                this.conditionListLayer = [] as any;
                for (let item of _data["conditionListLayer"])
                    this.conditionListLayer!.push(ConditionListLayer.fromJS(item));
            }
            if (Array.isArray(_data["experimentCaptureProfileTuningValues"])) {
                this.experimentCaptureProfileTuningValues = [] as any;
                for (let item of _data["experimentCaptureProfileTuningValues"])
                    this.experimentCaptureProfileTuningValues!.push(ExperimentCaptureProfileTuningValues.fromJS(item));
            }
            if (Array.isArray(_data["fragmentLayer"])) {
                this.fragmentLayer = [] as any;
                for (let item of _data["fragmentLayer"])
                    this.fragmentLayer!.push(FragmentLayer.fromJS(item));
            }
            if (Array.isArray(_data["grid"])) {
                this.grid = [] as any;
                for (let item of _data["grid"])
                    this.grid!.push(Grid.fromJS(item));
            }
            if (Array.isArray(_data["microfluidicsExperiment"])) {
                this.microfluidicsExperiment = [] as any;
                for (let item of _data["microfluidicsExperiment"])
                    this.microfluidicsExperiment!.push(MicrofluidicsExperiment.fromJS(item));
            }
            if (Array.isArray(_data["plate"])) {
                this.plate = [] as any;
                for (let item of _data["plate"])
                    this.plate!.push(Plate.fromJS(item));
            }
            if (Array.isArray(_data["randomLayer"])) {
                this.randomLayer = [] as any;
                for (let item of _data["randomLayer"])
                    this.randomLayer!.push(RandomLayer.fromJS(item));
            }
            if (Array.isArray(_data["screenLayer"])) {
                this.screenLayer = [] as any;
                for (let item of _data["screenLayer"])
                    this.screenLayer!.push(ScreenLayer.fromJS(item));
            }
            if (Array.isArray(_data["screenLot"])) {
                this.screenLot = [] as any;
                for (let item of _data["screenLot"])
                    this.screenLot!.push(ScreenLot.fromJS(item));
            }
            if (Array.isArray(_data["seedLayer"])) {
                this.seedLayer = [] as any;
                for (let item of _data["seedLayer"])
                    this.seedLayer!.push(SeedLayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Experiment {
        data = typeof data === 'object' ? data : {};
        let result = new Experiment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.proteinLayer)) {
            data["proteinLayer"] = [];
            for (let item of this.proteinLayer)
                data["proteinLayer"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["seeding"] = this.seeding;
        data["userId"] = this.userId;
        data["containerId"] = this.containerId;
        data["imagingScheduleId"] = this.imagingScheduleId;
        data["treeNodeId"] = this.treeNodeId;
        data["datePrepared"] = this.datePrepared ? this.datePrepared.toISOString() : undefined as any;
        data["setupTempId"] = this.setupTempId;
        data["incubationTempId"] = this.incubationTempId;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["notebookPageNum"] = this.notebookPageNum;
        data["reducingAgentVolume"] = this.reducingAgentVolume;
        data["dispensingRobotId"] = this.dispensingRobotId;
        data["maxLotNumber"] = this.maxLotNumber;
        data["plateRowCount"] = this.plateRowCount;
        data["plateColumnCount"] = this.plateColumnCount;
        data["zoomRectangleX"] = this.zoomRectangleX;
        data["zoomRectangleY"] = this.zoomRectangleY;
        data["zoomRectangleWidth"] = this.zoomRectangleWidth;
        data["zoomRectangleHeight"] = this.zoomRectangleHeight;
        data["zoomLocked"] = this.zoomLocked;
        data["autoScoreThresholdsImageBatchId"] = this.autoScoreThresholdsImageBatchId;
        data["dispensingRobots"] = this.dispensingRobots;
        data["autoScoreThresholdsImageBatch"] = this.autoScoreThresholdsImageBatch ? this.autoScoreThresholdsImageBatch.toJSON() : undefined as any;
        data["container"] = this.container ? this.container.toJSON() : undefined as any;
        data["imagingSchedule"] = this.imagingSchedule ? this.imagingSchedule.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.conditionListLayer)) {
            data["conditionListLayer"] = [];
            for (let item of this.conditionListLayer)
                data["conditionListLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.experimentCaptureProfileTuningValues)) {
            data["experimentCaptureProfileTuningValues"] = [];
            for (let item of this.experimentCaptureProfileTuningValues)
                data["experimentCaptureProfileTuningValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fragmentLayer)) {
            data["fragmentLayer"] = [];
            for (let item of this.fragmentLayer)
                data["fragmentLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grid)) {
            data["grid"] = [];
            for (let item of this.grid)
                data["grid"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.microfluidicsExperiment)) {
            data["microfluidicsExperiment"] = [];
            for (let item of this.microfluidicsExperiment)
                data["microfluidicsExperiment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plate)) {
            data["plate"] = [];
            for (let item of this.plate)
                data["plate"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.randomLayer)) {
            data["randomLayer"] = [];
            for (let item of this.randomLayer)
                data["randomLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenLayer)) {
            data["screenLayer"] = [];
            for (let item of this.screenLayer)
                data["screenLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenLot)) {
            data["screenLot"] = [];
            for (let item of this.screenLot)
                data["screenLot"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seedLayer)) {
            data["seedLayer"] = [];
            for (let item of this.seedLayer)
                data["seedLayer"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExperiment {
    proteinLayer?: ProteinLayer[] | undefined;
    id: number;
    seeding: boolean;
    userId: number;
    containerId: number;
    imagingScheduleId: number;
    treeNodeId: number;
    datePrepared: Date;
    setupTempId: number;
    incubationTempId: number;
    notes?: string | undefined;
    status: ExperimentStatus;
    notebookPageNum?: string | undefined;
    reducingAgentVolume?: number | undefined;
    dispensingRobotId?: number | undefined;
    maxLotNumber?: number | undefined;
    plateRowCount: number;
    plateColumnCount: number;
    zoomRectangleX?: number | undefined;
    zoomRectangleY?: number | undefined;
    zoomRectangleWidth?: number | undefined;
    zoomRectangleHeight?: number | undefined;
    zoomLocked?: boolean | undefined;
    autoScoreThresholdsImageBatchId?: number | undefined;
    dispensingRobots?: string | undefined;
    autoScoreThresholdsImageBatch?: ImageBatch | undefined;
    container?: Containers | undefined;
    imagingSchedule?: ImagingSchedule | undefined;
    treeNode?: TreeNode | undefined;
    user?: Users | undefined;
    conditionListLayer?: ConditionListLayer[] | undefined;
    experimentCaptureProfileTuningValues?: ExperimentCaptureProfileTuningValues[] | undefined;
    fragmentLayer?: FragmentLayer[] | undefined;
    grid?: Grid[] | undefined;
    microfluidicsExperiment?: MicrofluidicsExperiment[] | undefined;
    plate?: Plate[] | undefined;
    randomLayer?: RandomLayer[] | undefined;
    screenLayer?: ScreenLayer[] | undefined;
    screenLot?: ScreenLot[] | undefined;
    seedLayer?: SeedLayer[] | undefined;
}

export class ProteinLayer implements IProteinLayer {
    experiment?: Experiment | undefined;
    id!: number;
    experimentId!: number;
    layerId!: number;
    layer?: Layer | undefined;
    proteinLayerProteinFormulation?: ProteinLayerProteinFormulation[] | undefined;

    constructor(data?: IProteinLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.layerId = _data["layerId"];
            this.layer = _data["layer"] ? Layer.fromJS(_data["layer"]) : undefined as any;
            if (Array.isArray(_data["proteinLayerProteinFormulation"])) {
                this.proteinLayerProteinFormulation = [] as any;
                for (let item of _data["proteinLayerProteinFormulation"])
                    this.proteinLayerProteinFormulation!.push(ProteinLayerProteinFormulation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProteinLayer {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["layerId"] = this.layerId;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        if (Array.isArray(this.proteinLayerProteinFormulation)) {
            data["proteinLayerProteinFormulation"] = [];
            for (let item of this.proteinLayerProteinFormulation)
                data["proteinLayerProteinFormulation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProteinLayer {
    experiment?: Experiment | undefined;
    id: number;
    experimentId: number;
    layerId: number;
    layer?: Layer | undefined;
    proteinLayerProteinFormulation?: ProteinLayerProteinFormulation[] | undefined;
}

export class Layer implements ILayer {
    id!: number;
    name?: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    targetDropNumber?: number | undefined;
    volumeBasedAddition?: boolean | undefined;
    dispenseManually!: boolean;
    override!: boolean;
    locked!: boolean;
    conditionListLayer?: ConditionListLayer[] | undefined;
    fragmentLayer?: FragmentLayer[] | undefined;
    gridLayer?: GridLayer[] | undefined;
    proteinLayer?: ProteinLayer[] | undefined;
    randomLayer?: RandomLayer[] | undefined;
    screenLayer?: ScreenLayer[] | undefined;
    seedLayer?: SeedLayer[] | undefined;
    wellDropLayer?: WellDropLayer[] | undefined;
    wellLayer?: WellLayer[] | undefined;

    constructor(data?: ILayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.targetDropNumber = _data["targetDropNumber"];
            this.volumeBasedAddition = _data["volumeBasedAddition"];
            this.dispenseManually = _data["dispenseManually"];
            this.override = _data["override"];
            this.locked = _data["locked"];
            if (Array.isArray(_data["conditionListLayer"])) {
                this.conditionListLayer = [] as any;
                for (let item of _data["conditionListLayer"])
                    this.conditionListLayer!.push(ConditionListLayer.fromJS(item));
            }
            if (Array.isArray(_data["fragmentLayer"])) {
                this.fragmentLayer = [] as any;
                for (let item of _data["fragmentLayer"])
                    this.fragmentLayer!.push(FragmentLayer.fromJS(item));
            }
            if (Array.isArray(_data["gridLayer"])) {
                this.gridLayer = [] as any;
                for (let item of _data["gridLayer"])
                    this.gridLayer!.push(GridLayer.fromJS(item));
            }
            if (Array.isArray(_data["proteinLayer"])) {
                this.proteinLayer = [] as any;
                for (let item of _data["proteinLayer"])
                    this.proteinLayer!.push(ProteinLayer.fromJS(item));
            }
            if (Array.isArray(_data["randomLayer"])) {
                this.randomLayer = [] as any;
                for (let item of _data["randomLayer"])
                    this.randomLayer!.push(RandomLayer.fromJS(item));
            }
            if (Array.isArray(_data["screenLayer"])) {
                this.screenLayer = [] as any;
                for (let item of _data["screenLayer"])
                    this.screenLayer!.push(ScreenLayer.fromJS(item));
            }
            if (Array.isArray(_data["seedLayer"])) {
                this.seedLayer = [] as any;
                for (let item of _data["seedLayer"])
                    this.seedLayer!.push(SeedLayer.fromJS(item));
            }
            if (Array.isArray(_data["wellDropLayer"])) {
                this.wellDropLayer = [] as any;
                for (let item of _data["wellDropLayer"])
                    this.wellDropLayer!.push(WellDropLayer.fromJS(item));
            }
            if (Array.isArray(_data["wellLayer"])) {
                this.wellLayer = [] as any;
                for (let item of _data["wellLayer"])
                    this.wellLayer!.push(WellLayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Layer {
        data = typeof data === 'object' ? data : {};
        let result = new Layer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["targetDropNumber"] = this.targetDropNumber;
        data["volumeBasedAddition"] = this.volumeBasedAddition;
        data["dispenseManually"] = this.dispenseManually;
        data["override"] = this.override;
        data["locked"] = this.locked;
        if (Array.isArray(this.conditionListLayer)) {
            data["conditionListLayer"] = [];
            for (let item of this.conditionListLayer)
                data["conditionListLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fragmentLayer)) {
            data["fragmentLayer"] = [];
            for (let item of this.fragmentLayer)
                data["fragmentLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gridLayer)) {
            data["gridLayer"] = [];
            for (let item of this.gridLayer)
                data["gridLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinLayer)) {
            data["proteinLayer"] = [];
            for (let item of this.proteinLayer)
                data["proteinLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.randomLayer)) {
            data["randomLayer"] = [];
            for (let item of this.randomLayer)
                data["randomLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenLayer)) {
            data["screenLayer"] = [];
            for (let item of this.screenLayer)
                data["screenLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seedLayer)) {
            data["seedLayer"] = [];
            for (let item of this.seedLayer)
                data["seedLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDropLayer)) {
            data["wellDropLayer"] = [];
            for (let item of this.wellDropLayer)
                data["wellDropLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellLayer)) {
            data["wellLayer"] = [];
            for (let item of this.wellLayer)
                data["wellLayer"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILayer {
    id: number;
    name?: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
    targetDropNumber?: number | undefined;
    volumeBasedAddition?: boolean | undefined;
    dispenseManually: boolean;
    override: boolean;
    locked: boolean;
    conditionListLayer?: ConditionListLayer[] | undefined;
    fragmentLayer?: FragmentLayer[] | undefined;
    gridLayer?: GridLayer[] | undefined;
    proteinLayer?: ProteinLayer[] | undefined;
    randomLayer?: RandomLayer[] | undefined;
    screenLayer?: ScreenLayer[] | undefined;
    seedLayer?: SeedLayer[] | undefined;
    wellDropLayer?: WellDropLayer[] | undefined;
    wellLayer?: WellLayer[] | undefined;
}

export class ConditionListLayer implements IConditionListLayer {
    id!: number;
    layerId!: number;
    experimentId!: number;
    wellVolume!: number;
    experiment?: Experiment | undefined;
    layer?: Layer | undefined;
    condition?: Condition[] | undefined;

    constructor(data?: IConditionListLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layerId = _data["layerId"];
            this.experimentId = _data["experimentId"];
            this.wellVolume = _data["wellVolume"];
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
            this.layer = _data["layer"] ? Layer.fromJS(_data["layer"]) : undefined as any;
            if (Array.isArray(_data["condition"])) {
                this.condition = [] as any;
                for (let item of _data["condition"])
                    this.condition!.push(Condition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConditionListLayer {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionListLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layerId"] = this.layerId;
        data["experimentId"] = this.experimentId;
        data["wellVolume"] = this.wellVolume;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        if (Array.isArray(this.condition)) {
            data["condition"] = [];
            for (let item of this.condition)
                data["condition"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConditionListLayer {
    id: number;
    layerId: number;
    experimentId: number;
    wellVolume: number;
    experiment?: Experiment | undefined;
    layer?: Layer | undefined;
    condition?: Condition[] | undefined;
}

export class Condition implements ICondition {
    id!: number;
    conditionListLayerId!: number;
    conditionNumber!: number;
    metadata?: string | undefined;
    conditionListLayer?: ConditionListLayer | undefined;
    conditionIngredient?: ConditionIngredient[] | undefined;

    constructor(data?: ICondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conditionListLayerId = _data["conditionListLayerId"];
            this.conditionNumber = _data["conditionNumber"];
            this.metadata = _data["metadata"];
            this.conditionListLayer = _data["conditionListLayer"] ? ConditionListLayer.fromJS(_data["conditionListLayer"]) : undefined as any;
            if (Array.isArray(_data["conditionIngredient"])) {
                this.conditionIngredient = [] as any;
                for (let item of _data["conditionIngredient"])
                    this.conditionIngredient!.push(ConditionIngredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Condition {
        data = typeof data === 'object' ? data : {};
        let result = new Condition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conditionListLayerId"] = this.conditionListLayerId;
        data["conditionNumber"] = this.conditionNumber;
        data["metadata"] = this.metadata;
        data["conditionListLayer"] = this.conditionListLayer ? this.conditionListLayer.toJSON() : undefined as any;
        if (Array.isArray(this.conditionIngredient)) {
            data["conditionIngredient"] = [];
            for (let item of this.conditionIngredient)
                data["conditionIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICondition {
    id: number;
    conditionListLayerId: number;
    conditionNumber: number;
    metadata?: string | undefined;
    conditionListLayer?: ConditionListLayer | undefined;
    conditionIngredient?: ConditionIngredient[] | undefined;
}

export class ConditionIngredient implements IConditionIngredient {
    id!: number;
    conditionId!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    concentration!: number;
    ph?: number | undefined;
    condition?: Condition | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;

    constructor(data?: IConditionIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conditionId = _data["conditionId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.concentration = _data["concentration"];
            this.ph = _data["ph"];
            this.condition = _data["condition"] ? Condition.fromJS(_data["condition"]) : undefined as any;
            this.highPhingredientStock = _data["highPhingredientStock"] ? IngredientStock.fromJS(_data["highPhingredientStock"]) : undefined as any;
            this.ingredientIngredientType = _data["ingredientIngredientType"] ? IngredientIngredientType.fromJS(_data["ingredientIngredientType"]) : undefined as any;
            this.ingredientStock = _data["ingredientStock"] ? IngredientStock.fromJS(_data["ingredientStock"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConditionIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conditionId"] = this.conditionId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["concentration"] = this.concentration;
        data["ph"] = this.ph;
        data["condition"] = this.condition ? this.condition.toJSON() : undefined as any;
        data["highPhingredientStock"] = this.highPhingredientStock ? this.highPhingredientStock.toJSON() : undefined as any;
        data["ingredientIngredientType"] = this.ingredientIngredientType ? this.ingredientIngredientType.toJSON() : undefined as any;
        data["ingredientStock"] = this.ingredientStock ? this.ingredientStock.toJSON() : undefined as any;
        return data;
    }
}

export interface IConditionIngredient {
    id: number;
    conditionId: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    concentration: number;
    ph?: number | undefined;
    condition?: Condition | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
}

export class FragmentLayer implements IFragmentLayer {
    id!: number;
    layerId!: number;
    experimentId!: number;
    startingWellNumber!: number;
    fragmentScreenId!: number;
    volume?: number | undefined;
    experiment?: Experiment | undefined;
    fragmentScreen?: FragmentScreen | undefined;
    layer?: Layer | undefined;

    constructor(data?: IFragmentLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layerId = _data["layerId"];
            this.experimentId = _data["experimentId"];
            this.startingWellNumber = _data["startingWellNumber"];
            this.fragmentScreenId = _data["fragmentScreenId"];
            this.volume = _data["volume"];
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
            this.fragmentScreen = _data["fragmentScreen"] ? FragmentScreen.fromJS(_data["fragmentScreen"]) : undefined as any;
            this.layer = _data["layer"] ? Layer.fromJS(_data["layer"]) : undefined as any;
        }
    }

    static fromJS(data: any): FragmentLayer {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layerId"] = this.layerId;
        data["experimentId"] = this.experimentId;
        data["startingWellNumber"] = this.startingWellNumber;
        data["fragmentScreenId"] = this.fragmentScreenId;
        data["volume"] = this.volume;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        data["fragmentScreen"] = this.fragmentScreen ? this.fragmentScreen.toJSON() : undefined as any;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        return data;
    }
}

export interface IFragmentLayer {
    id: number;
    layerId: number;
    experimentId: number;
    startingWellNumber: number;
    fragmentScreenId: number;
    volume?: number | undefined;
    experiment?: Experiment | undefined;
    fragmentScreen?: FragmentScreen | undefined;
    layer?: Layer | undefined;
}

export class FragmentScreen implements IFragmentScreen {
    id!: number;
    treeNodeId!: number;
    treeNode?: TreeNode | undefined;
    fragmentFragmentScreen?: FragmentFragmentScreen[] | undefined;
    fragmentLayer?: FragmentLayer[] | undefined;
    wellDrop?: WellDrop[] | undefined;

    constructor(data?: IFragmentScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            if (Array.isArray(_data["fragmentFragmentScreen"])) {
                this.fragmentFragmentScreen = [] as any;
                for (let item of _data["fragmentFragmentScreen"])
                    this.fragmentFragmentScreen!.push(FragmentFragmentScreen.fromJS(item));
            }
            if (Array.isArray(_data["fragmentLayer"])) {
                this.fragmentLayer = [] as any;
                for (let item of _data["fragmentLayer"])
                    this.fragmentLayer!.push(FragmentLayer.fromJS(item));
            }
            if (Array.isArray(_data["wellDrop"])) {
                this.wellDrop = [] as any;
                for (let item of _data["wellDrop"])
                    this.wellDrop!.push(WellDrop.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FragmentScreen {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        if (Array.isArray(this.fragmentFragmentScreen)) {
            data["fragmentFragmentScreen"] = [];
            for (let item of this.fragmentFragmentScreen)
                data["fragmentFragmentScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fragmentLayer)) {
            data["fragmentLayer"] = [];
            for (let item of this.fragmentLayer)
                data["fragmentLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDrop)) {
            data["wellDrop"] = [];
            for (let item of this.wellDrop)
                data["wellDrop"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFragmentScreen {
    id: number;
    treeNodeId: number;
    treeNode?: TreeNode | undefined;
    fragmentFragmentScreen?: FragmentFragmentScreen[] | undefined;
    fragmentLayer?: FragmentLayer[] | undefined;
    wellDrop?: WellDrop[] | undefined;
}

export class TreeNode implements ITreeNode {
    id!: number;
    type?: string | undefined;
    name?: string | undefined;
    parentId?: number | undefined;
    sortOrder?: number | undefined;
    locked!: boolean;
    allowEdits!: number;
    hitCount?: number | undefined;
    dateCreated?: Date | undefined;
    createdByUserId?: number | undefined;
    parent?: TreeNode | undefined;
    treeNodeFile?: TreeNodeFile | undefined;
    experiment?: Experiment[] | undefined;
    fragmentScreen?: FragmentScreen[] | undefined;
    imageManagement?: ImageManagement[] | undefined;
    imageManagementTarget?: ImageManagementTarget[] | undefined;
    inverseParent?: TreeNode[] | undefined;
    plate?: Plate[] | undefined;
    project?: Project[] | undefined;
    proteinFormulation?: ProteinFormulation[] | undefined;
    quickAccess?: QuickAccess[] | undefined;
    screenLot?: ScreenLot[] | undefined;
    search?: Search[] | undefined;
    searchPath?: SearchPath[] | undefined;
    seed?: Seed[] | undefined;
    synchrotronTrip?: SynchrotronTrip[] | undefined;
    synchrotronTripv4?: SynchrotronTripv4[] | undefined;
    treeNodeAccessRight?: TreeNodeAccessRight[] | undefined;
    userRecentDocuments?: UserRecentDocuments[] | undefined;
    createdByUser?: Users | undefined;
    trashRootNode?: Trash[] | undefined;
    trashTreeNode?: Trash | undefined;
    searchParameters?: SearchParameters | undefined;

    constructor(data?: ITreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.sortOrder = _data["sortOrder"];
            this.locked = _data["locked"];
            this.allowEdits = _data["allowEdits"];
            this.hitCount = _data["hitCount"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.createdByUserId = _data["createdByUserId"];
            this.parent = _data["parent"] ? TreeNode.fromJS(_data["parent"]) : undefined as any;
            this.treeNodeFile = _data["treeNodeFile"] ? TreeNodeFile.fromJS(_data["treeNodeFile"]) : undefined as any;
            if (Array.isArray(_data["experiment"])) {
                this.experiment = [] as any;
                for (let item of _data["experiment"])
                    this.experiment!.push(Experiment.fromJS(item));
            }
            if (Array.isArray(_data["fragmentScreen"])) {
                this.fragmentScreen = [] as any;
                for (let item of _data["fragmentScreen"])
                    this.fragmentScreen!.push(FragmentScreen.fromJS(item));
            }
            if (Array.isArray(_data["imageManagement"])) {
                this.imageManagement = [] as any;
                for (let item of _data["imageManagement"])
                    this.imageManagement!.push(ImageManagement.fromJS(item));
            }
            if (Array.isArray(_data["imageManagementTarget"])) {
                this.imageManagementTarget = [] as any;
                for (let item of _data["imageManagementTarget"])
                    this.imageManagementTarget!.push(ImageManagementTarget.fromJS(item));
            }
            if (Array.isArray(_data["inverseParent"])) {
                this.inverseParent = [] as any;
                for (let item of _data["inverseParent"])
                    this.inverseParent!.push(TreeNode.fromJS(item));
            }
            if (Array.isArray(_data["plate"])) {
                this.plate = [] as any;
                for (let item of _data["plate"])
                    this.plate!.push(Plate.fromJS(item));
            }
            if (Array.isArray(_data["project"])) {
                this.project = [] as any;
                for (let item of _data["project"])
                    this.project!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["proteinFormulation"])) {
                this.proteinFormulation = [] as any;
                for (let item of _data["proteinFormulation"])
                    this.proteinFormulation!.push(ProteinFormulation.fromJS(item));
            }
            if (Array.isArray(_data["quickAccess"])) {
                this.quickAccess = [] as any;
                for (let item of _data["quickAccess"])
                    this.quickAccess!.push(QuickAccess.fromJS(item));
            }
            if (Array.isArray(_data["screenLot"])) {
                this.screenLot = [] as any;
                for (let item of _data["screenLot"])
                    this.screenLot!.push(ScreenLot.fromJS(item));
            }
            if (Array.isArray(_data["search"])) {
                this.search = [] as any;
                for (let item of _data["search"])
                    this.search!.push(Search.fromJS(item));
            }
            if (Array.isArray(_data["searchPath"])) {
                this.searchPath = [] as any;
                for (let item of _data["searchPath"])
                    this.searchPath!.push(SearchPath.fromJS(item));
            }
            if (Array.isArray(_data["seed"])) {
                this.seed = [] as any;
                for (let item of _data["seed"])
                    this.seed!.push(Seed.fromJS(item));
            }
            if (Array.isArray(_data["synchrotronTrip"])) {
                this.synchrotronTrip = [] as any;
                for (let item of _data["synchrotronTrip"])
                    this.synchrotronTrip!.push(SynchrotronTrip.fromJS(item));
            }
            if (Array.isArray(_data["synchrotronTripv4"])) {
                this.synchrotronTripv4 = [] as any;
                for (let item of _data["synchrotronTripv4"])
                    this.synchrotronTripv4!.push(SynchrotronTripv4.fromJS(item));
            }
            if (Array.isArray(_data["treeNodeAccessRight"])) {
                this.treeNodeAccessRight = [] as any;
                for (let item of _data["treeNodeAccessRight"])
                    this.treeNodeAccessRight!.push(TreeNodeAccessRight.fromJS(item));
            }
            if (Array.isArray(_data["userRecentDocuments"])) {
                this.userRecentDocuments = [] as any;
                for (let item of _data["userRecentDocuments"])
                    this.userRecentDocuments!.push(UserRecentDocuments.fromJS(item));
            }
            this.createdByUser = _data["createdByUser"] ? Users.fromJS(_data["createdByUser"]) : undefined as any;
            if (Array.isArray(_data["trashRootNode"])) {
                this.trashRootNode = [] as any;
                for (let item of _data["trashRootNode"])
                    this.trashRootNode!.push(Trash.fromJS(item));
            }
            this.trashTreeNode = _data["trashTreeNode"] ? Trash.fromJS(_data["trashTreeNode"]) : undefined as any;
            this.searchParameters = _data["searchParameters"] ? SearchParameters.fromJS(_data["searchParameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): TreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["sortOrder"] = this.sortOrder;
        data["locked"] = this.locked;
        data["allowEdits"] = this.allowEdits;
        data["hitCount"] = this.hitCount;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["createdByUserId"] = this.createdByUserId;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["treeNodeFile"] = this.treeNodeFile ? this.treeNodeFile.toJSON() : undefined as any;
        if (Array.isArray(this.experiment)) {
            data["experiment"] = [];
            for (let item of this.experiment)
                data["experiment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fragmentScreen)) {
            data["fragmentScreen"] = [];
            for (let item of this.fragmentScreen)
                data["fragmentScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageManagement)) {
            data["imageManagement"] = [];
            for (let item of this.imageManagement)
                data["imageManagement"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageManagementTarget)) {
            data["imageManagementTarget"] = [];
            for (let item of this.imageManagementTarget)
                data["imageManagementTarget"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inverseParent)) {
            data["inverseParent"] = [];
            for (let item of this.inverseParent)
                data["inverseParent"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plate)) {
            data["plate"] = [];
            for (let item of this.plate)
                data["plate"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.project)) {
            data["project"] = [];
            for (let item of this.project)
                data["project"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinFormulation)) {
            data["proteinFormulation"] = [];
            for (let item of this.proteinFormulation)
                data["proteinFormulation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.quickAccess)) {
            data["quickAccess"] = [];
            for (let item of this.quickAccess)
                data["quickAccess"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenLot)) {
            data["screenLot"] = [];
            for (let item of this.screenLot)
                data["screenLot"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.search)) {
            data["search"] = [];
            for (let item of this.search)
                data["search"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchPath)) {
            data["searchPath"] = [];
            for (let item of this.searchPath)
                data["searchPath"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seed)) {
            data["seed"] = [];
            for (let item of this.seed)
                data["seed"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.synchrotronTrip)) {
            data["synchrotronTrip"] = [];
            for (let item of this.synchrotronTrip)
                data["synchrotronTrip"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.synchrotronTripv4)) {
            data["synchrotronTripv4"] = [];
            for (let item of this.synchrotronTripv4)
                data["synchrotronTripv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.treeNodeAccessRight)) {
            data["treeNodeAccessRight"] = [];
            for (let item of this.treeNodeAccessRight)
                data["treeNodeAccessRight"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userRecentDocuments)) {
            data["userRecentDocuments"] = [];
            for (let item of this.userRecentDocuments)
                data["userRecentDocuments"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        if (Array.isArray(this.trashRootNode)) {
            data["trashRootNode"] = [];
            for (let item of this.trashRootNode)
                data["trashRootNode"].push(item ? item.toJSON() : undefined as any);
        }
        data["trashTreeNode"] = this.trashTreeNode ? this.trashTreeNode.toJSON() : undefined as any;
        data["searchParameters"] = this.searchParameters ? this.searchParameters.toJSON() : undefined as any;
        return data;
    }
}

export interface ITreeNode {
    id: number;
    type?: string | undefined;
    name?: string | undefined;
    parentId?: number | undefined;
    sortOrder?: number | undefined;
    locked: boolean;
    allowEdits: number;
    hitCount?: number | undefined;
    dateCreated?: Date | undefined;
    createdByUserId?: number | undefined;
    parent?: TreeNode | undefined;
    treeNodeFile?: TreeNodeFile | undefined;
    experiment?: Experiment[] | undefined;
    fragmentScreen?: FragmentScreen[] | undefined;
    imageManagement?: ImageManagement[] | undefined;
    imageManagementTarget?: ImageManagementTarget[] | undefined;
    inverseParent?: TreeNode[] | undefined;
    plate?: Plate[] | undefined;
    project?: Project[] | undefined;
    proteinFormulation?: ProteinFormulation[] | undefined;
    quickAccess?: QuickAccess[] | undefined;
    screenLot?: ScreenLot[] | undefined;
    search?: Search[] | undefined;
    searchPath?: SearchPath[] | undefined;
    seed?: Seed[] | undefined;
    synchrotronTrip?: SynchrotronTrip[] | undefined;
    synchrotronTripv4?: SynchrotronTripv4[] | undefined;
    treeNodeAccessRight?: TreeNodeAccessRight[] | undefined;
    userRecentDocuments?: UserRecentDocuments[] | undefined;
    createdByUser?: Users | undefined;
    trashRootNode?: Trash[] | undefined;
    trashTreeNode?: Trash | undefined;
    searchParameters?: SearchParameters | undefined;
}

export class TreeNodeFile implements ITreeNodeFile {
    id!: number;
    treeNodeId!: number;
    data?: string | undefined;
    creationTime!: Date;
    treeNode?: TreeNode | undefined;

    constructor(data?: ITreeNodeFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.data = _data["data"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
        }
    }

    static fromJS(data: any): TreeNodeFile {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["data"] = this.data;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        return data;
    }
}

export interface ITreeNodeFile {
    id: number;
    treeNodeId: number;
    data?: string | undefined;
    creationTime: Date;
    treeNode?: TreeNode | undefined;
}

export class ImageManagement implements IImageManagement {
    id!: number;
    treeNodeId!: number;
    errorBehaviour?: number | undefined;
    isBackground!: boolean;
    lastExecutionTime?: Date | undefined;
    treeNode?: TreeNode | undefined;
    imageManagementAction?: ImageManagementAction[] | undefined;
    imageManagementTarget?: ImageManagementTarget[] | undefined;

    constructor(data?: IImageManagement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.errorBehaviour = _data["errorBehaviour"];
            this.isBackground = _data["isBackground"];
            this.lastExecutionTime = _data["lastExecutionTime"] ? new Date(_data["lastExecutionTime"].toString()) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            if (Array.isArray(_data["imageManagementAction"])) {
                this.imageManagementAction = [] as any;
                for (let item of _data["imageManagementAction"])
                    this.imageManagementAction!.push(ImageManagementAction.fromJS(item));
            }
            if (Array.isArray(_data["imageManagementTarget"])) {
                this.imageManagementTarget = [] as any;
                for (let item of _data["imageManagementTarget"])
                    this.imageManagementTarget!.push(ImageManagementTarget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageManagement {
        data = typeof data === 'object' ? data : {};
        let result = new ImageManagement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["errorBehaviour"] = this.errorBehaviour;
        data["isBackground"] = this.isBackground;
        data["lastExecutionTime"] = this.lastExecutionTime ? this.lastExecutionTime.toISOString() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        if (Array.isArray(this.imageManagementAction)) {
            data["imageManagementAction"] = [];
            for (let item of this.imageManagementAction)
                data["imageManagementAction"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageManagementTarget)) {
            data["imageManagementTarget"] = [];
            for (let item of this.imageManagementTarget)
                data["imageManagementTarget"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImageManagement {
    id: number;
    treeNodeId: number;
    errorBehaviour?: number | undefined;
    isBackground: boolean;
    lastExecutionTime?: Date | undefined;
    treeNode?: TreeNode | undefined;
    imageManagementAction?: ImageManagementAction[] | undefined;
    imageManagementTarget?: ImageManagementTarget[] | undefined;
}

export class ImageManagementAction implements IImageManagementAction {
    id!: number;
    imageManagementId!: number;
    rootSearchConstraintTreeNodeId!: number;
    actionType!: number;
    sourceImageStoreId!: number;
    targetImageStoreId?: number | undefined;
    verify!: boolean;
    excludeFirstInspection!: boolean;
    excludeLastInspection!: boolean;
    isExecuting!: boolean;
    minImageAge?: number | undefined;
    imageManagement?: ImageManagement | undefined;
    rootSearchConstraintTreeNode?: SearchConstraintTreeNode | undefined;
    sourceImageStore?: ImageStore | undefined;
    targetImageStore?: ImageStore | undefined;

    constructor(data?: IImageManagementAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageManagementId = _data["imageManagementId"];
            this.rootSearchConstraintTreeNodeId = _data["rootSearchConstraintTreeNodeId"];
            this.actionType = _data["actionType"];
            this.sourceImageStoreId = _data["sourceImageStoreId"];
            this.targetImageStoreId = _data["targetImageStoreId"];
            this.verify = _data["verify"];
            this.excludeFirstInspection = _data["excludeFirstInspection"];
            this.excludeLastInspection = _data["excludeLastInspection"];
            this.isExecuting = _data["isExecuting"];
            this.minImageAge = _data["minImageAge"];
            this.imageManagement = _data["imageManagement"] ? ImageManagement.fromJS(_data["imageManagement"]) : undefined as any;
            this.rootSearchConstraintTreeNode = _data["rootSearchConstraintTreeNode"] ? SearchConstraintTreeNode.fromJS(_data["rootSearchConstraintTreeNode"]) : undefined as any;
            this.sourceImageStore = _data["sourceImageStore"] ? ImageStore.fromJS(_data["sourceImageStore"]) : undefined as any;
            this.targetImageStore = _data["targetImageStore"] ? ImageStore.fromJS(_data["targetImageStore"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImageManagementAction {
        data = typeof data === 'object' ? data : {};
        let result = new ImageManagementAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageManagementId"] = this.imageManagementId;
        data["rootSearchConstraintTreeNodeId"] = this.rootSearchConstraintTreeNodeId;
        data["actionType"] = this.actionType;
        data["sourceImageStoreId"] = this.sourceImageStoreId;
        data["targetImageStoreId"] = this.targetImageStoreId;
        data["verify"] = this.verify;
        data["excludeFirstInspection"] = this.excludeFirstInspection;
        data["excludeLastInspection"] = this.excludeLastInspection;
        data["isExecuting"] = this.isExecuting;
        data["minImageAge"] = this.minImageAge;
        data["imageManagement"] = this.imageManagement ? this.imageManagement.toJSON() : undefined as any;
        data["rootSearchConstraintTreeNode"] = this.rootSearchConstraintTreeNode ? this.rootSearchConstraintTreeNode.toJSON() : undefined as any;
        data["sourceImageStore"] = this.sourceImageStore ? this.sourceImageStore.toJSON() : undefined as any;
        data["targetImageStore"] = this.targetImageStore ? this.targetImageStore.toJSON() : undefined as any;
        return data;
    }
}

export interface IImageManagementAction {
    id: number;
    imageManagementId: number;
    rootSearchConstraintTreeNodeId: number;
    actionType: number;
    sourceImageStoreId: number;
    targetImageStoreId?: number | undefined;
    verify: boolean;
    excludeFirstInspection: boolean;
    excludeLastInspection: boolean;
    isExecuting: boolean;
    minImageAge?: number | undefined;
    imageManagement?: ImageManagement | undefined;
    rootSearchConstraintTreeNode?: SearchConstraintTreeNode | undefined;
    sourceImageStore?: ImageStore | undefined;
    targetImageStore?: ImageStore | undefined;
}

export class SearchConstraintTreeNode implements ISearchConstraintTreeNode {
    id!: number;
    rootId?: number | undefined;
    parentId?: number | undefined;
    nodeType!: number;
    parent?: SearchConstraintTreeNode | undefined;
    root?: SearchConstraintTreeNode | undefined;
    imageManagementAction?: ImageManagementAction[] | undefined;
    inverseParent?: SearchConstraintTreeNode[] | undefined;
    inverseRoot?: SearchConstraintTreeNode[] | undefined;
    search?: Search[] | undefined;
    searchConstraint?: SearchConstraint[] | undefined;

    constructor(data?: ISearchConstraintTreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rootId = _data["rootId"];
            this.parentId = _data["parentId"];
            this.nodeType = _data["nodeType"];
            this.parent = _data["parent"] ? SearchConstraintTreeNode.fromJS(_data["parent"]) : undefined as any;
            this.root = _data["root"] ? SearchConstraintTreeNode.fromJS(_data["root"]) : undefined as any;
            if (Array.isArray(_data["imageManagementAction"])) {
                this.imageManagementAction = [] as any;
                for (let item of _data["imageManagementAction"])
                    this.imageManagementAction!.push(ImageManagementAction.fromJS(item));
            }
            if (Array.isArray(_data["inverseParent"])) {
                this.inverseParent = [] as any;
                for (let item of _data["inverseParent"])
                    this.inverseParent!.push(SearchConstraintTreeNode.fromJS(item));
            }
            if (Array.isArray(_data["inverseRoot"])) {
                this.inverseRoot = [] as any;
                for (let item of _data["inverseRoot"])
                    this.inverseRoot!.push(SearchConstraintTreeNode.fromJS(item));
            }
            if (Array.isArray(_data["search"])) {
                this.search = [] as any;
                for (let item of _data["search"])
                    this.search!.push(Search.fromJS(item));
            }
            if (Array.isArray(_data["searchConstraint"])) {
                this.searchConstraint = [] as any;
                for (let item of _data["searchConstraint"])
                    this.searchConstraint!.push(SearchConstraint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchConstraintTreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new SearchConstraintTreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rootId"] = this.rootId;
        data["parentId"] = this.parentId;
        data["nodeType"] = this.nodeType;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["root"] = this.root ? this.root.toJSON() : undefined as any;
        if (Array.isArray(this.imageManagementAction)) {
            data["imageManagementAction"] = [];
            for (let item of this.imageManagementAction)
                data["imageManagementAction"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inverseParent)) {
            data["inverseParent"] = [];
            for (let item of this.inverseParent)
                data["inverseParent"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inverseRoot)) {
            data["inverseRoot"] = [];
            for (let item of this.inverseRoot)
                data["inverseRoot"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.search)) {
            data["search"] = [];
            for (let item of this.search)
                data["search"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchConstraint)) {
            data["searchConstraint"] = [];
            for (let item of this.searchConstraint)
                data["searchConstraint"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchConstraintTreeNode {
    id: number;
    rootId?: number | undefined;
    parentId?: number | undefined;
    nodeType: number;
    parent?: SearchConstraintTreeNode | undefined;
    root?: SearchConstraintTreeNode | undefined;
    imageManagementAction?: ImageManagementAction[] | undefined;
    inverseParent?: SearchConstraintTreeNode[] | undefined;
    inverseRoot?: SearchConstraintTreeNode[] | undefined;
    search?: Search[] | undefined;
    searchConstraint?: SearchConstraint[] | undefined;
}

export class Search implements ISearch {
    id!: number;
    treeNodeId!: number;
    searchTargetId!: number;
    flattenTargetId?: number | undefined;
    rootTreeNodeId?: number | undefined;
    rootSearchConstraintTreeNodeId!: number;
    selectDistinct!: boolean;
    hasIndependentConstraints!: boolean;
    flattenTarget?: SearchTarget | undefined;
    rootSearchConstraintTreeNode?: SearchConstraintTreeNode | undefined;
    searchTarget?: SearchTarget | undefined;
    treeNode?: TreeNode | undefined;
    filter?: Filter[] | undefined;
    searchChart?: SearchChart[] | undefined;
    searchDisplayField?: SearchDisplayField[] | undefined;
    searchPath?: SearchPath[] | undefined;
    searchResultField?: SearchResultField[] | undefined;

    constructor(data?: ISearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.searchTargetId = _data["searchTargetId"];
            this.flattenTargetId = _data["flattenTargetId"];
            this.rootTreeNodeId = _data["rootTreeNodeId"];
            this.rootSearchConstraintTreeNodeId = _data["rootSearchConstraintTreeNodeId"];
            this.selectDistinct = _data["selectDistinct"];
            this.hasIndependentConstraints = _data["hasIndependentConstraints"];
            this.flattenTarget = _data["flattenTarget"] ? SearchTarget.fromJS(_data["flattenTarget"]) : undefined as any;
            this.rootSearchConstraintTreeNode = _data["rootSearchConstraintTreeNode"] ? SearchConstraintTreeNode.fromJS(_data["rootSearchConstraintTreeNode"]) : undefined as any;
            this.searchTarget = _data["searchTarget"] ? SearchTarget.fromJS(_data["searchTarget"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            if (Array.isArray(_data["filter"])) {
                this.filter = [] as any;
                for (let item of _data["filter"])
                    this.filter!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["searchChart"])) {
                this.searchChart = [] as any;
                for (let item of _data["searchChart"])
                    this.searchChart!.push(SearchChart.fromJS(item));
            }
            if (Array.isArray(_data["searchDisplayField"])) {
                this.searchDisplayField = [] as any;
                for (let item of _data["searchDisplayField"])
                    this.searchDisplayField!.push(SearchDisplayField.fromJS(item));
            }
            if (Array.isArray(_data["searchPath"])) {
                this.searchPath = [] as any;
                for (let item of _data["searchPath"])
                    this.searchPath!.push(SearchPath.fromJS(item));
            }
            if (Array.isArray(_data["searchResultField"])) {
                this.searchResultField = [] as any;
                for (let item of _data["searchResultField"])
                    this.searchResultField!.push(SearchResultField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Search {
        data = typeof data === 'object' ? data : {};
        let result = new Search();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["searchTargetId"] = this.searchTargetId;
        data["flattenTargetId"] = this.flattenTargetId;
        data["rootTreeNodeId"] = this.rootTreeNodeId;
        data["rootSearchConstraintTreeNodeId"] = this.rootSearchConstraintTreeNodeId;
        data["selectDistinct"] = this.selectDistinct;
        data["hasIndependentConstraints"] = this.hasIndependentConstraints;
        data["flattenTarget"] = this.flattenTarget ? this.flattenTarget.toJSON() : undefined as any;
        data["rootSearchConstraintTreeNode"] = this.rootSearchConstraintTreeNode ? this.rootSearchConstraintTreeNode.toJSON() : undefined as any;
        data["searchTarget"] = this.searchTarget ? this.searchTarget.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        if (Array.isArray(this.filter)) {
            data["filter"] = [];
            for (let item of this.filter)
                data["filter"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchChart)) {
            data["searchChart"] = [];
            for (let item of this.searchChart)
                data["searchChart"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchDisplayField)) {
            data["searchDisplayField"] = [];
            for (let item of this.searchDisplayField)
                data["searchDisplayField"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchPath)) {
            data["searchPath"] = [];
            for (let item of this.searchPath)
                data["searchPath"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchResultField)) {
            data["searchResultField"] = [];
            for (let item of this.searchResultField)
                data["searchResultField"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearch {
    id: number;
    treeNodeId: number;
    searchTargetId: number;
    flattenTargetId?: number | undefined;
    rootTreeNodeId?: number | undefined;
    rootSearchConstraintTreeNodeId: number;
    selectDistinct: boolean;
    hasIndependentConstraints: boolean;
    flattenTarget?: SearchTarget | undefined;
    rootSearchConstraintTreeNode?: SearchConstraintTreeNode | undefined;
    searchTarget?: SearchTarget | undefined;
    treeNode?: TreeNode | undefined;
    filter?: Filter[] | undefined;
    searchChart?: SearchChart[] | undefined;
    searchDisplayField?: SearchDisplayField[] | undefined;
    searchPath?: SearchPath[] | undefined;
    searchResultField?: SearchResultField[] | undefined;
}

export class SearchTarget implements ISearchTarget {
    id!: number;
    targetName?: string | undefined;
    tableName?: string | undefined;
    tableHints?: string | undefined;
    joins?: string | undefined;
    treeNodeField?: string | undefined;
    visible!: boolean;
    defaultSortColumn?: number | undefined;
    newSearchTarget!: boolean;
    searchField?: SearchField[] | undefined;
    searchFlattenTarget?: Search[] | undefined;
    searchSearchTarget?: Search[] | undefined;
    searchTargetChart?: SearchTargetChart[] | undefined;
    searchTargetField?: SearchTargetField[] | undefined;
    searchTargetRelationSearchTargetChild?: SearchTargetRelation[] | undefined;
    searchTargetRelationSearchTargetParent?: SearchTargetRelation[] | undefined;

    constructor(data?: ISearchTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.targetName = _data["targetName"];
            this.tableName = _data["tableName"];
            this.tableHints = _data["tableHints"];
            this.joins = _data["joins"];
            this.treeNodeField = _data["treeNodeField"];
            this.visible = _data["visible"];
            this.defaultSortColumn = _data["defaultSortColumn"];
            this.newSearchTarget = _data["newSearchTarget"];
            if (Array.isArray(_data["searchField"])) {
                this.searchField = [] as any;
                for (let item of _data["searchField"])
                    this.searchField!.push(SearchField.fromJS(item));
            }
            if (Array.isArray(_data["searchFlattenTarget"])) {
                this.searchFlattenTarget = [] as any;
                for (let item of _data["searchFlattenTarget"])
                    this.searchFlattenTarget!.push(Search.fromJS(item));
            }
            if (Array.isArray(_data["searchSearchTarget"])) {
                this.searchSearchTarget = [] as any;
                for (let item of _data["searchSearchTarget"])
                    this.searchSearchTarget!.push(Search.fromJS(item));
            }
            if (Array.isArray(_data["searchTargetChart"])) {
                this.searchTargetChart = [] as any;
                for (let item of _data["searchTargetChart"])
                    this.searchTargetChart!.push(SearchTargetChart.fromJS(item));
            }
            if (Array.isArray(_data["searchTargetField"])) {
                this.searchTargetField = [] as any;
                for (let item of _data["searchTargetField"])
                    this.searchTargetField!.push(SearchTargetField.fromJS(item));
            }
            if (Array.isArray(_data["searchTargetRelationSearchTargetChild"])) {
                this.searchTargetRelationSearchTargetChild = [] as any;
                for (let item of _data["searchTargetRelationSearchTargetChild"])
                    this.searchTargetRelationSearchTargetChild!.push(SearchTargetRelation.fromJS(item));
            }
            if (Array.isArray(_data["searchTargetRelationSearchTargetParent"])) {
                this.searchTargetRelationSearchTargetParent = [] as any;
                for (let item of _data["searchTargetRelationSearchTargetParent"])
                    this.searchTargetRelationSearchTargetParent!.push(SearchTargetRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchTarget {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetName"] = this.targetName;
        data["tableName"] = this.tableName;
        data["tableHints"] = this.tableHints;
        data["joins"] = this.joins;
        data["treeNodeField"] = this.treeNodeField;
        data["visible"] = this.visible;
        data["defaultSortColumn"] = this.defaultSortColumn;
        data["newSearchTarget"] = this.newSearchTarget;
        if (Array.isArray(this.searchField)) {
            data["searchField"] = [];
            for (let item of this.searchField)
                data["searchField"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchFlattenTarget)) {
            data["searchFlattenTarget"] = [];
            for (let item of this.searchFlattenTarget)
                data["searchFlattenTarget"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchSearchTarget)) {
            data["searchSearchTarget"] = [];
            for (let item of this.searchSearchTarget)
                data["searchSearchTarget"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchTargetChart)) {
            data["searchTargetChart"] = [];
            for (let item of this.searchTargetChart)
                data["searchTargetChart"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchTargetField)) {
            data["searchTargetField"] = [];
            for (let item of this.searchTargetField)
                data["searchTargetField"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchTargetRelationSearchTargetChild)) {
            data["searchTargetRelationSearchTargetChild"] = [];
            for (let item of this.searchTargetRelationSearchTargetChild)
                data["searchTargetRelationSearchTargetChild"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchTargetRelationSearchTargetParent)) {
            data["searchTargetRelationSearchTargetParent"] = [];
            for (let item of this.searchTargetRelationSearchTargetParent)
                data["searchTargetRelationSearchTargetParent"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchTarget {
    id: number;
    targetName?: string | undefined;
    tableName?: string | undefined;
    tableHints?: string | undefined;
    joins?: string | undefined;
    treeNodeField?: string | undefined;
    visible: boolean;
    defaultSortColumn?: number | undefined;
    newSearchTarget: boolean;
    searchField?: SearchField[] | undefined;
    searchFlattenTarget?: Search[] | undefined;
    searchSearchTarget?: Search[] | undefined;
    searchTargetChart?: SearchTargetChart[] | undefined;
    searchTargetField?: SearchTargetField[] | undefined;
    searchTargetRelationSearchTargetChild?: SearchTargetRelation[] | undefined;
    searchTargetRelationSearchTargetParent?: SearchTargetRelation[] | undefined;
}

export class SearchField implements ISearchField {
    id!: number;
    searchTargetId!: number;
    tableName?: string | undefined;
    fieldName?: string | undefined;
    displayName?: string | undefined;
    fieldClass?: string | undefined;
    searchTarget?: SearchTarget | undefined;
    chartRequiredField?: ChartRequiredField[] | undefined;
    filter?: Filter[] | undefined;
    searchConstraint?: SearchConstraint[] | undefined;
    searchDisplayField?: SearchDisplayField[] | undefined;
    searchResultField?: SearchResultField[] | undefined;
    searchTargetField?: SearchTargetField[] | undefined;

    constructor(data?: ISearchField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchTargetId = _data["searchTargetId"];
            this.tableName = _data["tableName"];
            this.fieldName = _data["fieldName"];
            this.displayName = _data["displayName"];
            this.fieldClass = _data["fieldClass"];
            this.searchTarget = _data["searchTarget"] ? SearchTarget.fromJS(_data["searchTarget"]) : undefined as any;
            if (Array.isArray(_data["chartRequiredField"])) {
                this.chartRequiredField = [] as any;
                for (let item of _data["chartRequiredField"])
                    this.chartRequiredField!.push(ChartRequiredField.fromJS(item));
            }
            if (Array.isArray(_data["filter"])) {
                this.filter = [] as any;
                for (let item of _data["filter"])
                    this.filter!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["searchConstraint"])) {
                this.searchConstraint = [] as any;
                for (let item of _data["searchConstraint"])
                    this.searchConstraint!.push(SearchConstraint.fromJS(item));
            }
            if (Array.isArray(_data["searchDisplayField"])) {
                this.searchDisplayField = [] as any;
                for (let item of _data["searchDisplayField"])
                    this.searchDisplayField!.push(SearchDisplayField.fromJS(item));
            }
            if (Array.isArray(_data["searchResultField"])) {
                this.searchResultField = [] as any;
                for (let item of _data["searchResultField"])
                    this.searchResultField!.push(SearchResultField.fromJS(item));
            }
            if (Array.isArray(_data["searchTargetField"])) {
                this.searchTargetField = [] as any;
                for (let item of _data["searchTargetField"])
                    this.searchTargetField!.push(SearchTargetField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchField {
        data = typeof data === 'object' ? data : {};
        let result = new SearchField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchTargetId"] = this.searchTargetId;
        data["tableName"] = this.tableName;
        data["fieldName"] = this.fieldName;
        data["displayName"] = this.displayName;
        data["fieldClass"] = this.fieldClass;
        data["searchTarget"] = this.searchTarget ? this.searchTarget.toJSON() : undefined as any;
        if (Array.isArray(this.chartRequiredField)) {
            data["chartRequiredField"] = [];
            for (let item of this.chartRequiredField)
                data["chartRequiredField"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.filter)) {
            data["filter"] = [];
            for (let item of this.filter)
                data["filter"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchConstraint)) {
            data["searchConstraint"] = [];
            for (let item of this.searchConstraint)
                data["searchConstraint"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchDisplayField)) {
            data["searchDisplayField"] = [];
            for (let item of this.searchDisplayField)
                data["searchDisplayField"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchResultField)) {
            data["searchResultField"] = [];
            for (let item of this.searchResultField)
                data["searchResultField"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchTargetField)) {
            data["searchTargetField"] = [];
            for (let item of this.searchTargetField)
                data["searchTargetField"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchField {
    id: number;
    searchTargetId: number;
    tableName?: string | undefined;
    fieldName?: string | undefined;
    displayName?: string | undefined;
    fieldClass?: string | undefined;
    searchTarget?: SearchTarget | undefined;
    chartRequiredField?: ChartRequiredField[] | undefined;
    filter?: Filter[] | undefined;
    searchConstraint?: SearchConstraint[] | undefined;
    searchDisplayField?: SearchDisplayField[] | undefined;
    searchResultField?: SearchResultField[] | undefined;
    searchTargetField?: SearchTargetField[] | undefined;
}

export class ChartRequiredField implements IChartRequiredField {
    id!: number;
    chartId!: number;
    searchFieldId!: number;
    chart?: Chart | undefined;
    searchField?: SearchField | undefined;

    constructor(data?: IChartRequiredField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chartId = _data["chartId"];
            this.searchFieldId = _data["searchFieldId"];
            this.chart = _data["chart"] ? Chart.fromJS(_data["chart"]) : undefined as any;
            this.searchField = _data["searchField"] ? SearchField.fromJS(_data["searchField"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChartRequiredField {
        data = typeof data === 'object' ? data : {};
        let result = new ChartRequiredField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chartId"] = this.chartId;
        data["searchFieldId"] = this.searchFieldId;
        data["chart"] = this.chart ? this.chart.toJSON() : undefined as any;
        data["searchField"] = this.searchField ? this.searchField.toJSON() : undefined as any;
        return data;
    }
}

export interface IChartRequiredField {
    id: number;
    chartId: number;
    searchFieldId: number;
    chart?: Chart | undefined;
    searchField?: SearchField | undefined;
}

export class Chart implements IChart {
    id!: number;
    title?: string | undefined;
    query?: string | undefined;
    xaxis?: string | undefined;
    yaxis?: string | undefined;
    series?: string | undefined;
    defaultChartType?: string | undefined;
    active!: boolean;
    chartRequiredField?: ChartRequiredField[] | undefined;
    searchChart?: SearchChart[] | undefined;
    searchTargetChart?: SearchTargetChart[] | undefined;

    constructor(data?: IChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.query = _data["query"];
            this.xaxis = _data["xaxis"];
            this.yaxis = _data["yaxis"];
            this.series = _data["series"];
            this.defaultChartType = _data["defaultChartType"];
            this.active = _data["active"];
            if (Array.isArray(_data["chartRequiredField"])) {
                this.chartRequiredField = [] as any;
                for (let item of _data["chartRequiredField"])
                    this.chartRequiredField!.push(ChartRequiredField.fromJS(item));
            }
            if (Array.isArray(_data["searchChart"])) {
                this.searchChart = [] as any;
                for (let item of _data["searchChart"])
                    this.searchChart!.push(SearchChart.fromJS(item));
            }
            if (Array.isArray(_data["searchTargetChart"])) {
                this.searchTargetChart = [] as any;
                for (let item of _data["searchTargetChart"])
                    this.searchTargetChart!.push(SearchTargetChart.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Chart {
        data = typeof data === 'object' ? data : {};
        let result = new Chart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["query"] = this.query;
        data["xaxis"] = this.xaxis;
        data["yaxis"] = this.yaxis;
        data["series"] = this.series;
        data["defaultChartType"] = this.defaultChartType;
        data["active"] = this.active;
        if (Array.isArray(this.chartRequiredField)) {
            data["chartRequiredField"] = [];
            for (let item of this.chartRequiredField)
                data["chartRequiredField"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchChart)) {
            data["searchChart"] = [];
            for (let item of this.searchChart)
                data["searchChart"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchTargetChart)) {
            data["searchTargetChart"] = [];
            for (let item of this.searchTargetChart)
                data["searchTargetChart"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChart {
    id: number;
    title?: string | undefined;
    query?: string | undefined;
    xaxis?: string | undefined;
    yaxis?: string | undefined;
    series?: string | undefined;
    defaultChartType?: string | undefined;
    active: boolean;
    chartRequiredField?: ChartRequiredField[] | undefined;
    searchChart?: SearchChart[] | undefined;
    searchTargetChart?: SearchTargetChart[] | undefined;
}

export class SearchChart implements ISearchChart {
    id!: number;
    searchId!: number;
    chartId!: number;
    chart?: Chart | undefined;
    search?: Search | undefined;

    constructor(data?: ISearchChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchId = _data["searchId"];
            this.chartId = _data["chartId"];
            this.chart = _data["chart"] ? Chart.fromJS(_data["chart"]) : undefined as any;
            this.search = _data["search"] ? Search.fromJS(_data["search"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchChart {
        data = typeof data === 'object' ? data : {};
        let result = new SearchChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchId"] = this.searchId;
        data["chartId"] = this.chartId;
        data["chart"] = this.chart ? this.chart.toJSON() : undefined as any;
        data["search"] = this.search ? this.search.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchChart {
    id: number;
    searchId: number;
    chartId: number;
    chart?: Chart | undefined;
    search?: Search | undefined;
}

export class SearchTargetChart implements ISearchTargetChart {
    id!: number;
    searchTargetId!: number;
    chartId!: number;
    chart?: Chart | undefined;
    searchTarget?: SearchTarget | undefined;

    constructor(data?: ISearchTargetChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchTargetId = _data["searchTargetId"];
            this.chartId = _data["chartId"];
            this.chart = _data["chart"] ? Chart.fromJS(_data["chart"]) : undefined as any;
            this.searchTarget = _data["searchTarget"] ? SearchTarget.fromJS(_data["searchTarget"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchTargetChart {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTargetChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchTargetId"] = this.searchTargetId;
        data["chartId"] = this.chartId;
        data["chart"] = this.chart ? this.chart.toJSON() : undefined as any;
        data["searchTarget"] = this.searchTarget ? this.searchTarget.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchTargetChart {
    id: number;
    searchTargetId: number;
    chartId: number;
    chart?: Chart | undefined;
    searchTarget?: SearchTarget | undefined;
}

export class Filter implements IFilter {
    id!: number;
    searchId!: number;
    searchFieldId!: number;
    search?: Search | undefined;
    searchField?: SearchField | undefined;
    filterValue?: FilterValue[] | undefined;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchId = _data["searchId"];
            this.searchFieldId = _data["searchFieldId"];
            this.search = _data["search"] ? Search.fromJS(_data["search"]) : undefined as any;
            this.searchField = _data["searchField"] ? SearchField.fromJS(_data["searchField"]) : undefined as any;
            if (Array.isArray(_data["filterValue"])) {
                this.filterValue = [] as any;
                for (let item of _data["filterValue"])
                    this.filterValue!.push(FilterValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchId"] = this.searchId;
        data["searchFieldId"] = this.searchFieldId;
        data["search"] = this.search ? this.search.toJSON() : undefined as any;
        data["searchField"] = this.searchField ? this.searchField.toJSON() : undefined as any;
        if (Array.isArray(this.filterValue)) {
            data["filterValue"] = [];
            for (let item of this.filterValue)
                data["filterValue"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilter {
    id: number;
    searchId: number;
    searchFieldId: number;
    search?: Search | undefined;
    searchField?: SearchField | undefined;
    filterValue?: FilterValue[] | undefined;
}

export class FilterValue implements IFilterValue {
    id!: number;
    filterId!: number;
    filterValue1?: string | undefined;
    filterValueType!: number;
    filter?: Filter | undefined;

    constructor(data?: IFilterValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filterId = _data["filterId"];
            this.filterValue1 = _data["filterValue1"];
            this.filterValueType = _data["filterValueType"];
            this.filter = _data["filter"] ? Filter.fromJS(_data["filter"]) : undefined as any;
        }
    }

    static fromJS(data: any): FilterValue {
        data = typeof data === 'object' ? data : {};
        let result = new FilterValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filterId"] = this.filterId;
        data["filterValue1"] = this.filterValue1;
        data["filterValueType"] = this.filterValueType;
        data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        return data;
    }
}

export interface IFilterValue {
    id: number;
    filterId: number;
    filterValue1?: string | undefined;
    filterValueType: number;
    filter?: Filter | undefined;
}

export class SearchConstraint implements ISearchConstraint {
    id!: number;
    searchConstraintTreeNodeId!: number;
    searchFieldId!: number;
    searchOperator?: string | undefined;
    searchValue?: string | undefined;
    isDropdown?: boolean | undefined;
    searchConstraintTreeNode?: SearchConstraintTreeNode | undefined;
    searchField?: SearchField | undefined;

    constructor(data?: ISearchConstraint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchConstraintTreeNodeId = _data["searchConstraintTreeNodeId"];
            this.searchFieldId = _data["searchFieldId"];
            this.searchOperator = _data["searchOperator"];
            this.searchValue = _data["searchValue"];
            this.isDropdown = _data["isDropdown"];
            this.searchConstraintTreeNode = _data["searchConstraintTreeNode"] ? SearchConstraintTreeNode.fromJS(_data["searchConstraintTreeNode"]) : undefined as any;
            this.searchField = _data["searchField"] ? SearchField.fromJS(_data["searchField"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchConstraint {
        data = typeof data === 'object' ? data : {};
        let result = new SearchConstraint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchConstraintTreeNodeId"] = this.searchConstraintTreeNodeId;
        data["searchFieldId"] = this.searchFieldId;
        data["searchOperator"] = this.searchOperator;
        data["searchValue"] = this.searchValue;
        data["isDropdown"] = this.isDropdown;
        data["searchConstraintTreeNode"] = this.searchConstraintTreeNode ? this.searchConstraintTreeNode.toJSON() : undefined as any;
        data["searchField"] = this.searchField ? this.searchField.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchConstraint {
    id: number;
    searchConstraintTreeNodeId: number;
    searchFieldId: number;
    searchOperator?: string | undefined;
    searchValue?: string | undefined;
    isDropdown?: boolean | undefined;
    searchConstraintTreeNode?: SearchConstraintTreeNode | undefined;
    searchField?: SearchField | undefined;
}

export class SearchDisplayField implements ISearchDisplayField {
    id!: number;
    searchFieldId!: number;
    searchId!: number;
    displayOrder!: number;
    columnHeader?: string | undefined;
    status!: number;
    search?: Search | undefined;
    searchField?: SearchField | undefined;

    constructor(data?: ISearchDisplayField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchFieldId = _data["searchFieldId"];
            this.searchId = _data["searchId"];
            this.displayOrder = _data["displayOrder"];
            this.columnHeader = _data["columnHeader"];
            this.status = _data["status"];
            this.search = _data["search"] ? Search.fromJS(_data["search"]) : undefined as any;
            this.searchField = _data["searchField"] ? SearchField.fromJS(_data["searchField"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchDisplayField {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDisplayField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchFieldId"] = this.searchFieldId;
        data["searchId"] = this.searchId;
        data["displayOrder"] = this.displayOrder;
        data["columnHeader"] = this.columnHeader;
        data["status"] = this.status;
        data["search"] = this.search ? this.search.toJSON() : undefined as any;
        data["searchField"] = this.searchField ? this.searchField.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchDisplayField {
    id: number;
    searchFieldId: number;
    searchId: number;
    displayOrder: number;
    columnHeader?: string | undefined;
    status: number;
    search?: Search | undefined;
    searchField?: SearchField | undefined;
}

export class SearchResultField implements ISearchResultField {
    id!: number;
    searchFieldId?: number | undefined;
    searchId?: number | undefined;
    displayOrder?: number | undefined;
    columnHeader?: string | undefined;
    search?: Search | undefined;
    searchField?: SearchField | undefined;

    constructor(data?: ISearchResultField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchFieldId = _data["searchFieldId"];
            this.searchId = _data["searchId"];
            this.displayOrder = _data["displayOrder"];
            this.columnHeader = _data["columnHeader"];
            this.search = _data["search"] ? Search.fromJS(_data["search"]) : undefined as any;
            this.searchField = _data["searchField"] ? SearchField.fromJS(_data["searchField"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchResultField {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchFieldId"] = this.searchFieldId;
        data["searchId"] = this.searchId;
        data["displayOrder"] = this.displayOrder;
        data["columnHeader"] = this.columnHeader;
        data["search"] = this.search ? this.search.toJSON() : undefined as any;
        data["searchField"] = this.searchField ? this.searchField.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchResultField {
    id: number;
    searchFieldId?: number | undefined;
    searchId?: number | undefined;
    displayOrder?: number | undefined;
    columnHeader?: string | undefined;
    search?: Search | undefined;
    searchField?: SearchField | undefined;
}

export class SearchTargetField implements ISearchTargetField {
    id!: number;
    searchTargetId!: number;
    searchFieldId!: number;
    mandatory?: boolean | undefined;
    status!: number;
    searchField?: SearchField | undefined;
    searchTarget?: SearchTarget | undefined;

    constructor(data?: ISearchTargetField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchTargetId = _data["searchTargetId"];
            this.searchFieldId = _data["searchFieldId"];
            this.mandatory = _data["mandatory"];
            this.status = _data["status"];
            this.searchField = _data["searchField"] ? SearchField.fromJS(_data["searchField"]) : undefined as any;
            this.searchTarget = _data["searchTarget"] ? SearchTarget.fromJS(_data["searchTarget"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchTargetField {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTargetField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchTargetId"] = this.searchTargetId;
        data["searchFieldId"] = this.searchFieldId;
        data["mandatory"] = this.mandatory;
        data["status"] = this.status;
        data["searchField"] = this.searchField ? this.searchField.toJSON() : undefined as any;
        data["searchTarget"] = this.searchTarget ? this.searchTarget.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchTargetField {
    id: number;
    searchTargetId: number;
    searchFieldId: number;
    mandatory?: boolean | undefined;
    status: number;
    searchField?: SearchField | undefined;
    searchTarget?: SearchTarget | undefined;
}

export class SearchTargetRelation implements ISearchTargetRelation {
    searchTargetParentId!: number;
    searchTargetChildId!: number;
    parentField?: string | undefined;
    childField?: string | undefined;
    searchTargetChild?: SearchTarget | undefined;
    searchTargetParent?: SearchTarget | undefined;

    constructor(data?: ISearchTargetRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTargetParentId = _data["searchTargetParentId"];
            this.searchTargetChildId = _data["searchTargetChildId"];
            this.parentField = _data["parentField"];
            this.childField = _data["childField"];
            this.searchTargetChild = _data["searchTargetChild"] ? SearchTarget.fromJS(_data["searchTargetChild"]) : undefined as any;
            this.searchTargetParent = _data["searchTargetParent"] ? SearchTarget.fromJS(_data["searchTargetParent"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchTargetRelation {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTargetRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTargetParentId"] = this.searchTargetParentId;
        data["searchTargetChildId"] = this.searchTargetChildId;
        data["parentField"] = this.parentField;
        data["childField"] = this.childField;
        data["searchTargetChild"] = this.searchTargetChild ? this.searchTargetChild.toJSON() : undefined as any;
        data["searchTargetParent"] = this.searchTargetParent ? this.searchTargetParent.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchTargetRelation {
    searchTargetParentId: number;
    searchTargetChildId: number;
    parentField?: string | undefined;
    childField?: string | undefined;
    searchTargetChild?: SearchTarget | undefined;
    searchTargetParent?: SearchTarget | undefined;
}

export class SearchPath implements ISearchPath {
    id!: number;
    searchId?: number | undefined;
    treeNodeId?: number | undefined;
    search?: Search | undefined;
    treeNode?: TreeNode | undefined;

    constructor(data?: ISearchPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchId = _data["searchId"];
            this.treeNodeId = _data["treeNodeId"];
            this.search = _data["search"] ? Search.fromJS(_data["search"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchPath {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchId"] = this.searchId;
        data["treeNodeId"] = this.treeNodeId;
        data["search"] = this.search ? this.search.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchPath {
    id: number;
    searchId?: number | undefined;
    treeNodeId?: number | undefined;
    search?: Search | undefined;
    treeNode?: TreeNode | undefined;
}

export class ImageStore implements IImageStore {
    id!: number;
    name?: string | undefined;
    imageStoreLayoutId!: number;
    basePath?: string | undefined;
    imageStoreLayout?: ImageStoreLayout | undefined;
    image?: Image[] | undefined;
    imageManagementActionSourceImageStore?: ImageManagementAction[] | undefined;
    imageManagementActionTargetImageStore?: ImageManagementAction[] | undefined;

    constructor(data?: IImageStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageStoreLayoutId = _data["imageStoreLayoutId"];
            this.basePath = _data["basePath"];
            this.imageStoreLayout = _data["imageStoreLayout"] ? ImageStoreLayout.fromJS(_data["imageStoreLayout"]) : undefined as any;
            if (Array.isArray(_data["image"])) {
                this.image = [] as any;
                for (let item of _data["image"])
                    this.image!.push(Image.fromJS(item));
            }
            if (Array.isArray(_data["imageManagementActionSourceImageStore"])) {
                this.imageManagementActionSourceImageStore = [] as any;
                for (let item of _data["imageManagementActionSourceImageStore"])
                    this.imageManagementActionSourceImageStore!.push(ImageManagementAction.fromJS(item));
            }
            if (Array.isArray(_data["imageManagementActionTargetImageStore"])) {
                this.imageManagementActionTargetImageStore = [] as any;
                for (let item of _data["imageManagementActionTargetImageStore"])
                    this.imageManagementActionTargetImageStore!.push(ImageManagementAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageStore {
        data = typeof data === 'object' ? data : {};
        let result = new ImageStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageStoreLayoutId"] = this.imageStoreLayoutId;
        data["basePath"] = this.basePath;
        data["imageStoreLayout"] = this.imageStoreLayout ? this.imageStoreLayout.toJSON() : undefined as any;
        if (Array.isArray(this.image)) {
            data["image"] = [];
            for (let item of this.image)
                data["image"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageManagementActionSourceImageStore)) {
            data["imageManagementActionSourceImageStore"] = [];
            for (let item of this.imageManagementActionSourceImageStore)
                data["imageManagementActionSourceImageStore"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageManagementActionTargetImageStore)) {
            data["imageManagementActionTargetImageStore"] = [];
            for (let item of this.imageManagementActionTargetImageStore)
                data["imageManagementActionTargetImageStore"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImageStore {
    id: number;
    name?: string | undefined;
    imageStoreLayoutId: number;
    basePath?: string | undefined;
    imageStoreLayout?: ImageStoreLayout | undefined;
    image?: Image[] | undefined;
    imageManagementActionSourceImageStore?: ImageManagementAction[] | undefined;
    imageManagementActionTargetImageStore?: ImageManagementAction[] | undefined;
}

export class ImageStoreLayout implements IImageStoreLayout {
    id!: number;
    name?: string | undefined;
    imageCodec!: number;
    imageStore?: ImageStore[] | undefined;

    constructor(data?: IImageStoreLayout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageCodec = _data["imageCodec"];
            if (Array.isArray(_data["imageStore"])) {
                this.imageStore = [] as any;
                for (let item of _data["imageStore"])
                    this.imageStore!.push(ImageStore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageStoreLayout {
        data = typeof data === 'object' ? data : {};
        let result = new ImageStoreLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageCodec"] = this.imageCodec;
        if (Array.isArray(this.imageStore)) {
            data["imageStore"] = [];
            for (let item of this.imageStore)
                data["imageStore"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImageStoreLayout {
    id: number;
    name?: string | undefined;
    imageCodec: number;
    imageStore?: ImageStore[] | undefined;
}

export class Image implements IImage {
    id!: number;
    captureResultId!: number;
    imageStoreId!: number;
    imageTypeId!: number;
    imageTypeIndex!: number;
    pixelSize?: number | undefined;
    xcenterOffset?: number | undefined;
    ycenterOffset?: number | undefined;
    zheight?: number | undefined;
    fileSize?: number | undefined;
    captureResultNavigation?: CaptureResult | undefined;
    imageStore?: ImageStore | undefined;
    imageType?: ImageType | undefined;
    bestFocusLevel?: BestFocusLevel[] | undefined;
    captureResult?: CaptureResult[] | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
    imageProperty?: ImageProperty[] | undefined;
    retrainingImage?: RetrainingImage[] | undefined;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.captureResultId = _data["captureResultId"];
            this.imageStoreId = _data["imageStoreId"];
            this.imageTypeId = _data["imageTypeId"];
            this.imageTypeIndex = _data["imageTypeIndex"];
            this.pixelSize = _data["pixelSize"];
            this.xcenterOffset = _data["xcenterOffset"];
            this.ycenterOffset = _data["ycenterOffset"];
            this.zheight = _data["zheight"];
            this.fileSize = _data["fileSize"];
            this.captureResultNavigation = _data["captureResultNavigation"] ? CaptureResult.fromJS(_data["captureResultNavigation"]) : undefined as any;
            this.imageStore = _data["imageStore"] ? ImageStore.fromJS(_data["imageStore"]) : undefined as any;
            this.imageType = _data["imageType"] ? ImageType.fromJS(_data["imageType"]) : undefined as any;
            if (Array.isArray(_data["bestFocusLevel"])) {
                this.bestFocusLevel = [] as any;
                for (let item of _data["bestFocusLevel"])
                    this.bestFocusLevel!.push(BestFocusLevel.fromJS(item));
            }
            if (Array.isArray(_data["captureResult"])) {
                this.captureResult = [] as any;
                for (let item of _data["captureResult"])
                    this.captureResult!.push(CaptureResult.fromJS(item));
            }
            if (Array.isArray(_data["imageBatchWellDropScore"])) {
                this.imageBatchWellDropScore = [] as any;
                for (let item of _data["imageBatchWellDropScore"])
                    this.imageBatchWellDropScore!.push(ImageBatchWellDropScore.fromJS(item));
            }
            if (Array.isArray(_data["imageProperty"])) {
                this.imageProperty = [] as any;
                for (let item of _data["imageProperty"])
                    this.imageProperty!.push(ImageProperty.fromJS(item));
            }
            if (Array.isArray(_data["retrainingImage"])) {
                this.retrainingImage = [] as any;
                for (let item of _data["retrainingImage"])
                    this.retrainingImage!.push(RetrainingImage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureResultId"] = this.captureResultId;
        data["imageStoreId"] = this.imageStoreId;
        data["imageTypeId"] = this.imageTypeId;
        data["imageTypeIndex"] = this.imageTypeIndex;
        data["pixelSize"] = this.pixelSize;
        data["xcenterOffset"] = this.xcenterOffset;
        data["ycenterOffset"] = this.ycenterOffset;
        data["zheight"] = this.zheight;
        data["fileSize"] = this.fileSize;
        data["captureResultNavigation"] = this.captureResultNavigation ? this.captureResultNavigation.toJSON() : undefined as any;
        data["imageStore"] = this.imageStore ? this.imageStore.toJSON() : undefined as any;
        data["imageType"] = this.imageType ? this.imageType.toJSON() : undefined as any;
        if (Array.isArray(this.bestFocusLevel)) {
            data["bestFocusLevel"] = [];
            for (let item of this.bestFocusLevel)
                data["bestFocusLevel"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.captureResult)) {
            data["captureResult"] = [];
            for (let item of this.captureResult)
                data["captureResult"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageBatchWellDropScore)) {
            data["imageBatchWellDropScore"] = [];
            for (let item of this.imageBatchWellDropScore)
                data["imageBatchWellDropScore"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageProperty)) {
            data["imageProperty"] = [];
            for (let item of this.imageProperty)
                data["imageProperty"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.retrainingImage)) {
            data["retrainingImage"] = [];
            for (let item of this.retrainingImage)
                data["retrainingImage"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImage {
    id: number;
    captureResultId: number;
    imageStoreId: number;
    imageTypeId: number;
    imageTypeIndex: number;
    pixelSize?: number | undefined;
    xcenterOffset?: number | undefined;
    ycenterOffset?: number | undefined;
    zheight?: number | undefined;
    fileSize?: number | undefined;
    captureResultNavigation?: CaptureResult | undefined;
    imageStore?: ImageStore | undefined;
    imageType?: ImageType | undefined;
    bestFocusLevel?: BestFocusLevel[] | undefined;
    captureResult?: CaptureResult[] | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
    imageProperty?: ImageProperty[] | undefined;
    retrainingImage?: RetrainingImage[] | undefined;
}

export class CaptureResult implements ICaptureResult {
    id!: number;
    regionId!: number;
    captureProfileVersionId!: number;
    imageBatchId!: number;
    xcenter?: number | undefined;
    ycenter?: number | undefined;
    zheight?: number | undefined;
    xwidth?: number | undefined;
    yheight?: number | undefined;
    autoScoreImageId?: number | undefined;
    autoScoreImageData?: string | undefined;
    autoScoreImageDataVersion?: string | undefined;
    frapDataPoint?: string | undefined;
    autoScoreImage?: Image | undefined;
    captureProfileVersion?: CaptureProfileVersion | undefined;
    imageBatch?: ImageBatch | undefined;
    region?: Region | undefined;
    captureResultTuningValues?: CaptureResultTuningValues | undefined;
    captureResultProperty?: CaptureResultProperty[] | undefined;
    focalPoint?: FocalPoint[] | undefined;
    image?: Image[] | undefined;

    constructor(data?: ICaptureResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.captureProfileVersionId = _data["captureProfileVersionId"];
            this.imageBatchId = _data["imageBatchId"];
            this.xcenter = _data["xcenter"];
            this.ycenter = _data["ycenter"];
            this.zheight = _data["zheight"];
            this.xwidth = _data["xwidth"];
            this.yheight = _data["yheight"];
            this.autoScoreImageId = _data["autoScoreImageId"];
            this.autoScoreImageData = _data["autoScoreImageData"];
            this.autoScoreImageDataVersion = _data["autoScoreImageDataVersion"];
            this.frapDataPoint = _data["frapDataPoint"];
            this.autoScoreImage = _data["autoScoreImage"] ? Image.fromJS(_data["autoScoreImage"]) : undefined as any;
            this.captureProfileVersion = _data["captureProfileVersion"] ? CaptureProfileVersion.fromJS(_data["captureProfileVersion"]) : undefined as any;
            this.imageBatch = _data["imageBatch"] ? ImageBatch.fromJS(_data["imageBatch"]) : undefined as any;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
            this.captureResultTuningValues = _data["captureResultTuningValues"] ? CaptureResultTuningValues.fromJS(_data["captureResultTuningValues"]) : undefined as any;
            if (Array.isArray(_data["captureResultProperty"])) {
                this.captureResultProperty = [] as any;
                for (let item of _data["captureResultProperty"])
                    this.captureResultProperty!.push(CaptureResultProperty.fromJS(item));
            }
            if (Array.isArray(_data["focalPoint"])) {
                this.focalPoint = [] as any;
                for (let item of _data["focalPoint"])
                    this.focalPoint!.push(FocalPoint.fromJS(item));
            }
            if (Array.isArray(_data["image"])) {
                this.image = [] as any;
                for (let item of _data["image"])
                    this.image!.push(Image.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaptureResult {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["captureProfileVersionId"] = this.captureProfileVersionId;
        data["imageBatchId"] = this.imageBatchId;
        data["xcenter"] = this.xcenter;
        data["ycenter"] = this.ycenter;
        data["zheight"] = this.zheight;
        data["xwidth"] = this.xwidth;
        data["yheight"] = this.yheight;
        data["autoScoreImageId"] = this.autoScoreImageId;
        data["autoScoreImageData"] = this.autoScoreImageData;
        data["autoScoreImageDataVersion"] = this.autoScoreImageDataVersion;
        data["frapDataPoint"] = this.frapDataPoint;
        data["autoScoreImage"] = this.autoScoreImage ? this.autoScoreImage.toJSON() : undefined as any;
        data["captureProfileVersion"] = this.captureProfileVersion ? this.captureProfileVersion.toJSON() : undefined as any;
        data["imageBatch"] = this.imageBatch ? this.imageBatch.toJSON() : undefined as any;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        data["captureResultTuningValues"] = this.captureResultTuningValues ? this.captureResultTuningValues.toJSON() : undefined as any;
        if (Array.isArray(this.captureResultProperty)) {
            data["captureResultProperty"] = [];
            for (let item of this.captureResultProperty)
                data["captureResultProperty"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.focalPoint)) {
            data["focalPoint"] = [];
            for (let item of this.focalPoint)
                data["focalPoint"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.image)) {
            data["image"] = [];
            for (let item of this.image)
                data["image"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICaptureResult {
    id: number;
    regionId: number;
    captureProfileVersionId: number;
    imageBatchId: number;
    xcenter?: number | undefined;
    ycenter?: number | undefined;
    zheight?: number | undefined;
    xwidth?: number | undefined;
    yheight?: number | undefined;
    autoScoreImageId?: number | undefined;
    autoScoreImageData?: string | undefined;
    autoScoreImageDataVersion?: string | undefined;
    frapDataPoint?: string | undefined;
    autoScoreImage?: Image | undefined;
    captureProfileVersion?: CaptureProfileVersion | undefined;
    imageBatch?: ImageBatch | undefined;
    region?: Region | undefined;
    captureResultTuningValues?: CaptureResultTuningValues | undefined;
    captureResultProperty?: CaptureResultProperty[] | undefined;
    focalPoint?: FocalPoint[] | undefined;
    image?: Image[] | undefined;
}

export class CaptureProfileVersion implements ICaptureProfileVersion {
    id!: number;
    captureProfileId!: number;
    dateCreated!: Date;
    captureProfile?: CaptureProfile | undefined;
    captureProperty?: CaptureProperty[] | undefined;
    captureResult?: CaptureResult[] | undefined;
    crystal?: Crystal[] | undefined;
    crystalv4?: Crystalv4[] | undefined;

    constructor(data?: ICaptureProfileVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.captureProfileId = _data["captureProfileId"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.captureProfile = _data["captureProfile"] ? CaptureProfile.fromJS(_data["captureProfile"]) : undefined as any;
            if (Array.isArray(_data["captureProperty"])) {
                this.captureProperty = [] as any;
                for (let item of _data["captureProperty"])
                    this.captureProperty!.push(CaptureProperty.fromJS(item));
            }
            if (Array.isArray(_data["captureResult"])) {
                this.captureResult = [] as any;
                for (let item of _data["captureResult"])
                    this.captureResult!.push(CaptureResult.fromJS(item));
            }
            if (Array.isArray(_data["crystal"])) {
                this.crystal = [] as any;
                for (let item of _data["crystal"])
                    this.crystal!.push(Crystal.fromJS(item));
            }
            if (Array.isArray(_data["crystalv4"])) {
                this.crystalv4 = [] as any;
                for (let item of _data["crystalv4"])
                    this.crystalv4!.push(Crystalv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaptureProfileVersion {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProfileVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureProfileId"] = this.captureProfileId;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["captureProfile"] = this.captureProfile ? this.captureProfile.toJSON() : undefined as any;
        if (Array.isArray(this.captureProperty)) {
            data["captureProperty"] = [];
            for (let item of this.captureProperty)
                data["captureProperty"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.captureResult)) {
            data["captureResult"] = [];
            for (let item of this.captureResult)
                data["captureResult"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystal)) {
            data["crystal"] = [];
            for (let item of this.crystal)
                data["crystal"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystalv4)) {
            data["crystalv4"] = [];
            for (let item of this.crystalv4)
                data["crystalv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICaptureProfileVersion {
    id: number;
    captureProfileId: number;
    dateCreated: Date;
    captureProfile?: CaptureProfile | undefined;
    captureProperty?: CaptureProperty[] | undefined;
    captureResult?: CaptureResult[] | undefined;
    crystal?: Crystal[] | undefined;
    crystalv4?: Crystalv4[] | undefined;
}

export class CaptureProperty implements ICaptureProperty {
    id!: number;
    captureProfileVersionId!: number;
    robotId!: number;
    name?: string | undefined;
    value?: string | undefined;
    captureProfileVersion?: CaptureProfileVersion | undefined;

    constructor(data?: ICaptureProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.captureProfileVersionId = _data["captureProfileVersionId"];
            this.robotId = _data["robotId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.captureProfileVersion = _data["captureProfileVersion"] ? CaptureProfileVersion.fromJS(_data["captureProfileVersion"]) : undefined as any;
        }
    }

    static fromJS(data: any): CaptureProperty {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureProfileVersionId"] = this.captureProfileVersionId;
        data["robotId"] = this.robotId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["captureProfileVersion"] = this.captureProfileVersion ? this.captureProfileVersion.toJSON() : undefined as any;
        return data;
    }
}

export interface ICaptureProperty {
    id: number;
    captureProfileVersionId: number;
    robotId: number;
    name?: string | undefined;
    value?: string | undefined;
    captureProfileVersion?: CaptureProfileVersion | undefined;
}

export class Crystal implements ICrystal {
    id!: number;
    regionId!: number;
    captureProfileVersionId!: number;
    imageBatchId!: number;
    name?: string | undefined;
    dataCollected!: boolean;
    resolution?: string | undefined;
    attachedFile?: string | undefined;
    cryoprotectantSavedAs?: string | undefined;
    x?: number | undefined;
    y?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    dateFrozen?: Date | undefined;
    ownerUserId!: number;
    position?: number | undefined;
    notes?: string | undefined;
    puckPinId?: number | undefined;
    screenDate?: Date | undefined;
    collectionDate?: Date | undefined;
    quality?: string | undefined;
    structureTxt?: string | undefined;
    captureProfileVersion?: CaptureProfileVersion | undefined;
    imageBatch?: ImageBatch | undefined;
    ownerUser?: Users | undefined;
    puckPin?: PuckPin | undefined;
    region?: Region | undefined;
    cryoprotectant?: Cryoprotectant[] | undefined;
    soaking?: Soaking[] | undefined;

    constructor(data?: ICrystal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.captureProfileVersionId = _data["captureProfileVersionId"];
            this.imageBatchId = _data["imageBatchId"];
            this.name = _data["name"];
            this.dataCollected = _data["dataCollected"];
            this.resolution = _data["resolution"];
            this.attachedFile = _data["attachedFile"];
            this.cryoprotectantSavedAs = _data["cryoprotectantSavedAs"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.dateFrozen = _data["dateFrozen"] ? new Date(_data["dateFrozen"].toString()) : undefined as any;
            this.ownerUserId = _data["ownerUserId"];
            this.position = _data["position"];
            this.notes = _data["notes"];
            this.puckPinId = _data["puckPinId"];
            this.screenDate = _data["screenDate"] ? new Date(_data["screenDate"].toString()) : undefined as any;
            this.collectionDate = _data["collectionDate"] ? new Date(_data["collectionDate"].toString()) : undefined as any;
            this.quality = _data["quality"];
            this.structureTxt = _data["structureTxt"];
            this.captureProfileVersion = _data["captureProfileVersion"] ? CaptureProfileVersion.fromJS(_data["captureProfileVersion"]) : undefined as any;
            this.imageBatch = _data["imageBatch"] ? ImageBatch.fromJS(_data["imageBatch"]) : undefined as any;
            this.ownerUser = _data["ownerUser"] ? Users.fromJS(_data["ownerUser"]) : undefined as any;
            this.puckPin = _data["puckPin"] ? PuckPin.fromJS(_data["puckPin"]) : undefined as any;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
            if (Array.isArray(_data["cryoprotectant"])) {
                this.cryoprotectant = [] as any;
                for (let item of _data["cryoprotectant"])
                    this.cryoprotectant!.push(Cryoprotectant.fromJS(item));
            }
            if (Array.isArray(_data["soaking"])) {
                this.soaking = [] as any;
                for (let item of _data["soaking"])
                    this.soaking!.push(Soaking.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Crystal {
        data = typeof data === 'object' ? data : {};
        let result = new Crystal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["captureProfileVersionId"] = this.captureProfileVersionId;
        data["imageBatchId"] = this.imageBatchId;
        data["name"] = this.name;
        data["dataCollected"] = this.dataCollected;
        data["resolution"] = this.resolution;
        data["attachedFile"] = this.attachedFile;
        data["cryoprotectantSavedAs"] = this.cryoprotectantSavedAs;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["dateFrozen"] = this.dateFrozen ? this.dateFrozen.toISOString() : undefined as any;
        data["ownerUserId"] = this.ownerUserId;
        data["position"] = this.position;
        data["notes"] = this.notes;
        data["puckPinId"] = this.puckPinId;
        data["screenDate"] = this.screenDate ? this.screenDate.toISOString() : undefined as any;
        data["collectionDate"] = this.collectionDate ? this.collectionDate.toISOString() : undefined as any;
        data["quality"] = this.quality;
        data["structureTxt"] = this.structureTxt;
        data["captureProfileVersion"] = this.captureProfileVersion ? this.captureProfileVersion.toJSON() : undefined as any;
        data["imageBatch"] = this.imageBatch ? this.imageBatch.toJSON() : undefined as any;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : undefined as any;
        data["puckPin"] = this.puckPin ? this.puckPin.toJSON() : undefined as any;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        if (Array.isArray(this.cryoprotectant)) {
            data["cryoprotectant"] = [];
            for (let item of this.cryoprotectant)
                data["cryoprotectant"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.soaking)) {
            data["soaking"] = [];
            for (let item of this.soaking)
                data["soaking"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICrystal {
    id: number;
    regionId: number;
    captureProfileVersionId: number;
    imageBatchId: number;
    name?: string | undefined;
    dataCollected: boolean;
    resolution?: string | undefined;
    attachedFile?: string | undefined;
    cryoprotectantSavedAs?: string | undefined;
    x?: number | undefined;
    y?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    dateFrozen?: Date | undefined;
    ownerUserId: number;
    position?: number | undefined;
    notes?: string | undefined;
    puckPinId?: number | undefined;
    screenDate?: Date | undefined;
    collectionDate?: Date | undefined;
    quality?: string | undefined;
    structureTxt?: string | undefined;
    captureProfileVersion?: CaptureProfileVersion | undefined;
    imageBatch?: ImageBatch | undefined;
    ownerUser?: Users | undefined;
    puckPin?: PuckPin | undefined;
    region?: Region | undefined;
    cryoprotectant?: Cryoprotectant[] | undefined;
    soaking?: Soaking[] | undefined;
}

export class ImageBatch implements IImageBatch {
    id!: number;
    imagingTaskId!: number;
    imagingTask?: ImagingTask | undefined;
    captureResult?: CaptureResult[] | undefined;
    crystal?: Crystal[] | undefined;
    crystalv4?: Crystalv4[] | undefined;
    dropsToScore?: DropsToScore[] | undefined;
    experiment?: Experiment[] | undefined;
    imageBatchAutoScoreThreshold?: ImageBatchAutoScoreThreshold[] | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;

    constructor(data?: IImageBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imagingTaskId = _data["imagingTaskId"];
            this.imagingTask = _data["imagingTask"] ? ImagingTask.fromJS(_data["imagingTask"]) : undefined as any;
            if (Array.isArray(_data["captureResult"])) {
                this.captureResult = [] as any;
                for (let item of _data["captureResult"])
                    this.captureResult!.push(CaptureResult.fromJS(item));
            }
            if (Array.isArray(_data["crystal"])) {
                this.crystal = [] as any;
                for (let item of _data["crystal"])
                    this.crystal!.push(Crystal.fromJS(item));
            }
            if (Array.isArray(_data["crystalv4"])) {
                this.crystalv4 = [] as any;
                for (let item of _data["crystalv4"])
                    this.crystalv4!.push(Crystalv4.fromJS(item));
            }
            if (Array.isArray(_data["dropsToScore"])) {
                this.dropsToScore = [] as any;
                for (let item of _data["dropsToScore"])
                    this.dropsToScore!.push(DropsToScore.fromJS(item));
            }
            if (Array.isArray(_data["experiment"])) {
                this.experiment = [] as any;
                for (let item of _data["experiment"])
                    this.experiment!.push(Experiment.fromJS(item));
            }
            if (Array.isArray(_data["imageBatchAutoScoreThreshold"])) {
                this.imageBatchAutoScoreThreshold = [] as any;
                for (let item of _data["imageBatchAutoScoreThreshold"])
                    this.imageBatchAutoScoreThreshold!.push(ImageBatchAutoScoreThreshold.fromJS(item));
            }
            if (Array.isArray(_data["imageBatchWellDropScore"])) {
                this.imageBatchWellDropScore = [] as any;
                for (let item of _data["imageBatchWellDropScore"])
                    this.imageBatchWellDropScore!.push(ImageBatchWellDropScore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageBatch {
        data = typeof data === 'object' ? data : {};
        let result = new ImageBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imagingTaskId"] = this.imagingTaskId;
        data["imagingTask"] = this.imagingTask ? this.imagingTask.toJSON() : undefined as any;
        if (Array.isArray(this.captureResult)) {
            data["captureResult"] = [];
            for (let item of this.captureResult)
                data["captureResult"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystal)) {
            data["crystal"] = [];
            for (let item of this.crystal)
                data["crystal"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystalv4)) {
            data["crystalv4"] = [];
            for (let item of this.crystalv4)
                data["crystalv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dropsToScore)) {
            data["dropsToScore"] = [];
            for (let item of this.dropsToScore)
                data["dropsToScore"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.experiment)) {
            data["experiment"] = [];
            for (let item of this.experiment)
                data["experiment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageBatchAutoScoreThreshold)) {
            data["imageBatchAutoScoreThreshold"] = [];
            for (let item of this.imageBatchAutoScoreThreshold)
                data["imageBatchAutoScoreThreshold"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageBatchWellDropScore)) {
            data["imageBatchWellDropScore"] = [];
            for (let item of this.imageBatchWellDropScore)
                data["imageBatchWellDropScore"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImageBatch {
    id: number;
    imagingTaskId: number;
    imagingTask?: ImagingTask | undefined;
    captureResult?: CaptureResult[] | undefined;
    crystal?: Crystal[] | undefined;
    crystalv4?: Crystalv4[] | undefined;
    dropsToScore?: DropsToScore[] | undefined;
    experiment?: Experiment[] | undefined;
    imageBatchAutoScoreThreshold?: ImageBatchAutoScoreThreshold[] | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
}

export class ImagingTask implements IImagingTask {
    id!: number;
    experimentPlateId!: number;
    imagingScheduleEntryId?: number | undefined;
    state!: number;
    dateToImage!: Date;
    dateImaged?: Date | undefined;
    clearedFromToImage!: boolean;
    clearedFromToScore!: boolean;
    experimentPlateImagingScheduleEntryCalc?: number | undefined;
    source!: number;
    priority!: number;
    experimentPlate?: ExperimentPlate | undefined;
    imagingScheduleEntry?: ImagingScheduleEntry | undefined;
    imageBatch?: ImageBatch | undefined;
    imagingTaskCaptureProfile?: ImagingTaskCaptureProfile[] | undefined;
    imagingTaskWellDrop?: ImagingTaskWellDrop[] | undefined;

    constructor(data?: IImagingTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentPlateId = _data["experimentPlateId"];
            this.imagingScheduleEntryId = _data["imagingScheduleEntryId"];
            this.state = _data["state"];
            this.dateToImage = _data["dateToImage"] ? new Date(_data["dateToImage"].toString()) : undefined as any;
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.clearedFromToImage = _data["clearedFromToImage"];
            this.clearedFromToScore = _data["clearedFromToScore"];
            this.experimentPlateImagingScheduleEntryCalc = _data["experimentPlateImagingScheduleEntryCalc"];
            this.source = _data["source"];
            this.priority = _data["priority"];
            this.experimentPlate = _data["experimentPlate"] ? ExperimentPlate.fromJS(_data["experimentPlate"]) : undefined as any;
            this.imagingScheduleEntry = _data["imagingScheduleEntry"] ? ImagingScheduleEntry.fromJS(_data["imagingScheduleEntry"]) : undefined as any;
            this.imageBatch = _data["imageBatch"] ? ImageBatch.fromJS(_data["imageBatch"]) : undefined as any;
            if (Array.isArray(_data["imagingTaskCaptureProfile"])) {
                this.imagingTaskCaptureProfile = [] as any;
                for (let item of _data["imagingTaskCaptureProfile"])
                    this.imagingTaskCaptureProfile!.push(ImagingTaskCaptureProfile.fromJS(item));
            }
            if (Array.isArray(_data["imagingTaskWellDrop"])) {
                this.imagingTaskWellDrop = [] as any;
                for (let item of _data["imagingTaskWellDrop"])
                    this.imagingTaskWellDrop!.push(ImagingTaskWellDrop.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImagingTask {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentPlateId"] = this.experimentPlateId;
        data["imagingScheduleEntryId"] = this.imagingScheduleEntryId;
        data["state"] = this.state;
        data["dateToImage"] = this.dateToImage ? this.dateToImage.toISOString() : undefined as any;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["clearedFromToImage"] = this.clearedFromToImage;
        data["clearedFromToScore"] = this.clearedFromToScore;
        data["experimentPlateImagingScheduleEntryCalc"] = this.experimentPlateImagingScheduleEntryCalc;
        data["source"] = this.source;
        data["priority"] = this.priority;
        data["experimentPlate"] = this.experimentPlate ? this.experimentPlate.toJSON() : undefined as any;
        data["imagingScheduleEntry"] = this.imagingScheduleEntry ? this.imagingScheduleEntry.toJSON() : undefined as any;
        data["imageBatch"] = this.imageBatch ? this.imageBatch.toJSON() : undefined as any;
        if (Array.isArray(this.imagingTaskCaptureProfile)) {
            data["imagingTaskCaptureProfile"] = [];
            for (let item of this.imagingTaskCaptureProfile)
                data["imagingTaskCaptureProfile"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagingTaskWellDrop)) {
            data["imagingTaskWellDrop"] = [];
            for (let item of this.imagingTaskWellDrop)
                data["imagingTaskWellDrop"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImagingTask {
    id: number;
    experimentPlateId: number;
    imagingScheduleEntryId?: number | undefined;
    state: number;
    dateToImage: Date;
    dateImaged?: Date | undefined;
    clearedFromToImage: boolean;
    clearedFromToScore: boolean;
    experimentPlateImagingScheduleEntryCalc?: number | undefined;
    source: number;
    priority: number;
    experimentPlate?: ExperimentPlate | undefined;
    imagingScheduleEntry?: ImagingScheduleEntry | undefined;
    imageBatch?: ImageBatch | undefined;
    imagingTaskCaptureProfile?: ImagingTaskCaptureProfile[] | undefined;
    imagingTaskWellDrop?: ImagingTaskWellDrop[] | undefined;
}

export class ImagingScheduleEntry implements IImagingScheduleEntry {
    id!: number;
    imagingScheduleId!: number;
    days!: number;
    hours!: number;
    notify!: boolean;
    priority!: number;
    autoScoringEnabled!: boolean;
    imagingSchedule?: ImagingSchedule | undefined;
    imagingScheduleEntryCaptureProfile?: ImagingScheduleEntryCaptureProfile[] | undefined;
    imagingTask?: ImagingTask[] | undefined;

    constructor(data?: IImagingScheduleEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imagingScheduleId = _data["imagingScheduleId"];
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.notify = _data["notify"];
            this.priority = _data["priority"];
            this.autoScoringEnabled = _data["autoScoringEnabled"];
            this.imagingSchedule = _data["imagingSchedule"] ? ImagingSchedule.fromJS(_data["imagingSchedule"]) : undefined as any;
            if (Array.isArray(_data["imagingScheduleEntryCaptureProfile"])) {
                this.imagingScheduleEntryCaptureProfile = [] as any;
                for (let item of _data["imagingScheduleEntryCaptureProfile"])
                    this.imagingScheduleEntryCaptureProfile!.push(ImagingScheduleEntryCaptureProfile.fromJS(item));
            }
            if (Array.isArray(_data["imagingTask"])) {
                this.imagingTask = [] as any;
                for (let item of _data["imagingTask"])
                    this.imagingTask!.push(ImagingTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImagingScheduleEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingScheduleEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imagingScheduleId"] = this.imagingScheduleId;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["notify"] = this.notify;
        data["priority"] = this.priority;
        data["autoScoringEnabled"] = this.autoScoringEnabled;
        data["imagingSchedule"] = this.imagingSchedule ? this.imagingSchedule.toJSON() : undefined as any;
        if (Array.isArray(this.imagingScheduleEntryCaptureProfile)) {
            data["imagingScheduleEntryCaptureProfile"] = [];
            for (let item of this.imagingScheduleEntryCaptureProfile)
                data["imagingScheduleEntryCaptureProfile"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagingTask)) {
            data["imagingTask"] = [];
            for (let item of this.imagingTask)
                data["imagingTask"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImagingScheduleEntry {
    id: number;
    imagingScheduleId: number;
    days: number;
    hours: number;
    notify: boolean;
    priority: number;
    autoScoringEnabled: boolean;
    imagingSchedule?: ImagingSchedule | undefined;
    imagingScheduleEntryCaptureProfile?: ImagingScheduleEntryCaptureProfile[] | undefined;
    imagingTask?: ImagingTask[] | undefined;
}

export class ImagingSchedule implements IImagingSchedule {
    id!: number;
    experimentId?: number | undefined;
    name?: string | undefined;
    enable?: boolean | undefined;
    experiment?: Experiment[] | undefined;
    imagingScheduleEntry?: ImagingScheduleEntry[] | undefined;
    project?: Project[] | undefined;

    constructor(data?: IImagingSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.name = _data["name"];
            this.enable = _data["enable"];
            if (Array.isArray(_data["experiment"])) {
                this.experiment = [] as any;
                for (let item of _data["experiment"])
                    this.experiment!.push(Experiment.fromJS(item));
            }
            if (Array.isArray(_data["imagingScheduleEntry"])) {
                this.imagingScheduleEntry = [] as any;
                for (let item of _data["imagingScheduleEntry"])
                    this.imagingScheduleEntry!.push(ImagingScheduleEntry.fromJS(item));
            }
            if (Array.isArray(_data["project"])) {
                this.project = [] as any;
                for (let item of _data["project"])
                    this.project!.push(Project.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImagingSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["name"] = this.name;
        data["enable"] = this.enable;
        if (Array.isArray(this.experiment)) {
            data["experiment"] = [];
            for (let item of this.experiment)
                data["experiment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagingScheduleEntry)) {
            data["imagingScheduleEntry"] = [];
            for (let item of this.imagingScheduleEntry)
                data["imagingScheduleEntry"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.project)) {
            data["project"] = [];
            for (let item of this.project)
                data["project"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImagingSchedule {
    id: number;
    experimentId?: number | undefined;
    name?: string | undefined;
    enable?: boolean | undefined;
    experiment?: Experiment[] | undefined;
    imagingScheduleEntry?: ImagingScheduleEntry[] | undefined;
    project?: Project[] | undefined;
}

export class Project implements IProject {
    id!: number;
    treeNodeId!: number;
    dateCreated!: Date;
    ownerUserId!: number;
    defaultImagingScheduleId!: number;
    notes?: string | undefined;
    defaultImagingSchedule?: ImagingSchedule | undefined;
    ownerUser?: Users | undefined;
    treeNode?: TreeNode | undefined;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.ownerUserId = _data["ownerUserId"];
            this.defaultImagingScheduleId = _data["defaultImagingScheduleId"];
            this.notes = _data["notes"];
            this.defaultImagingSchedule = _data["defaultImagingSchedule"] ? ImagingSchedule.fromJS(_data["defaultImagingSchedule"]) : undefined as any;
            this.ownerUser = _data["ownerUser"] ? Users.fromJS(_data["ownerUser"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["ownerUserId"] = this.ownerUserId;
        data["defaultImagingScheduleId"] = this.defaultImagingScheduleId;
        data["notes"] = this.notes;
        data["defaultImagingSchedule"] = this.defaultImagingSchedule ? this.defaultImagingSchedule.toJSON() : undefined as any;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        return data;
    }
}

export interface IProject {
    id: number;
    treeNodeId: number;
    dateCreated: Date;
    ownerUserId: number;
    defaultImagingScheduleId: number;
    notes?: string | undefined;
    defaultImagingSchedule?: ImagingSchedule | undefined;
    ownerUser?: Users | undefined;
    treeNode?: TreeNode | undefined;
}

export class Users implements IUsers {
    id!: number;
    name?: string | undefined;
    passwordHash?: string | undefined;
    passwordSalt?: string | undefined;
    emailAddress?: string | undefined;
    notificationTypeId?: number | undefined;
    active?: boolean | undefined;
    resetPassword?: number | undefined;
    userTypeId?: number | undefined;
    notificationType?: NotificationType | undefined;
    userType?: UserType | undefined;
    usersOtp?: UsersOtp | undefined;
    cryoprotectantv4?: Cryoprotectantv4[] | undefined;
    crystal?: Crystal[] | undefined;
    crystalv4?: Crystalv4[] | undefined;
    experiment?: Experiment[] | undefined;
    favoriteIngredientStock?: FavoriteIngredientStock[] | undefined;
    groupUser?: GroupUser[] | undefined;
    project?: Project[] | undefined;
    quickAccess?: QuickAccess[] | undefined;
    soakingv4?: Soakingv4[] | undefined;
    treeNodeAccessRight?: TreeNodeAccessRight[] | undefined;
    usageStat?: UsageStat[] | undefined;
    userRecentDocuments?: UserRecentDocuments[] | undefined;

    constructor(data?: IUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.passwordHash = _data["passwordHash"];
            this.passwordSalt = _data["passwordSalt"];
            this.emailAddress = _data["emailAddress"];
            this.notificationTypeId = _data["notificationTypeId"];
            this.active = _data["active"];
            this.resetPassword = _data["resetPassword"];
            this.userTypeId = _data["userTypeId"];
            this.notificationType = _data["notificationType"] ? NotificationType.fromJS(_data["notificationType"]) : undefined as any;
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : undefined as any;
            this.usersOtp = _data["usersOtp"] ? UsersOtp.fromJS(_data["usersOtp"]) : undefined as any;
            if (Array.isArray(_data["cryoprotectantv4"])) {
                this.cryoprotectantv4 = [] as any;
                for (let item of _data["cryoprotectantv4"])
                    this.cryoprotectantv4!.push(Cryoprotectantv4.fromJS(item));
            }
            if (Array.isArray(_data["crystal"])) {
                this.crystal = [] as any;
                for (let item of _data["crystal"])
                    this.crystal!.push(Crystal.fromJS(item));
            }
            if (Array.isArray(_data["crystalv4"])) {
                this.crystalv4 = [] as any;
                for (let item of _data["crystalv4"])
                    this.crystalv4!.push(Crystalv4.fromJS(item));
            }
            if (Array.isArray(_data["experiment"])) {
                this.experiment = [] as any;
                for (let item of _data["experiment"])
                    this.experiment!.push(Experiment.fromJS(item));
            }
            if (Array.isArray(_data["favoriteIngredientStock"])) {
                this.favoriteIngredientStock = [] as any;
                for (let item of _data["favoriteIngredientStock"])
                    this.favoriteIngredientStock!.push(FavoriteIngredientStock.fromJS(item));
            }
            if (Array.isArray(_data["groupUser"])) {
                this.groupUser = [] as any;
                for (let item of _data["groupUser"])
                    this.groupUser!.push(GroupUser.fromJS(item));
            }
            if (Array.isArray(_data["project"])) {
                this.project = [] as any;
                for (let item of _data["project"])
                    this.project!.push(Project.fromJS(item));
            }
            if (Array.isArray(_data["quickAccess"])) {
                this.quickAccess = [] as any;
                for (let item of _data["quickAccess"])
                    this.quickAccess!.push(QuickAccess.fromJS(item));
            }
            if (Array.isArray(_data["soakingv4"])) {
                this.soakingv4 = [] as any;
                for (let item of _data["soakingv4"])
                    this.soakingv4!.push(Soakingv4.fromJS(item));
            }
            if (Array.isArray(_data["treeNodeAccessRight"])) {
                this.treeNodeAccessRight = [] as any;
                for (let item of _data["treeNodeAccessRight"])
                    this.treeNodeAccessRight!.push(TreeNodeAccessRight.fromJS(item));
            }
            if (Array.isArray(_data["usageStat"])) {
                this.usageStat = [] as any;
                for (let item of _data["usageStat"])
                    this.usageStat!.push(UsageStat.fromJS(item));
            }
            if (Array.isArray(_data["userRecentDocuments"])) {
                this.userRecentDocuments = [] as any;
                for (let item of _data["userRecentDocuments"])
                    this.userRecentDocuments!.push(UserRecentDocuments.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Users {
        data = typeof data === 'object' ? data : {};
        let result = new Users();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["passwordHash"] = this.passwordHash;
        data["passwordSalt"] = this.passwordSalt;
        data["emailAddress"] = this.emailAddress;
        data["notificationTypeId"] = this.notificationTypeId;
        data["active"] = this.active;
        data["resetPassword"] = this.resetPassword;
        data["userTypeId"] = this.userTypeId;
        data["notificationType"] = this.notificationType ? this.notificationType.toJSON() : undefined as any;
        data["userType"] = this.userType ? this.userType.toJSON() : undefined as any;
        data["usersOtp"] = this.usersOtp ? this.usersOtp.toJSON() : undefined as any;
        if (Array.isArray(this.cryoprotectantv4)) {
            data["cryoprotectantv4"] = [];
            for (let item of this.cryoprotectantv4)
                data["cryoprotectantv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystal)) {
            data["crystal"] = [];
            for (let item of this.crystal)
                data["crystal"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystalv4)) {
            data["crystalv4"] = [];
            for (let item of this.crystalv4)
                data["crystalv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.experiment)) {
            data["experiment"] = [];
            for (let item of this.experiment)
                data["experiment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.favoriteIngredientStock)) {
            data["favoriteIngredientStock"] = [];
            for (let item of this.favoriteIngredientStock)
                data["favoriteIngredientStock"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groupUser)) {
            data["groupUser"] = [];
            for (let item of this.groupUser)
                data["groupUser"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.project)) {
            data["project"] = [];
            for (let item of this.project)
                data["project"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.quickAccess)) {
            data["quickAccess"] = [];
            for (let item of this.quickAccess)
                data["quickAccess"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.soakingv4)) {
            data["soakingv4"] = [];
            for (let item of this.soakingv4)
                data["soakingv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.treeNodeAccessRight)) {
            data["treeNodeAccessRight"] = [];
            for (let item of this.treeNodeAccessRight)
                data["treeNodeAccessRight"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.usageStat)) {
            data["usageStat"] = [];
            for (let item of this.usageStat)
                data["usageStat"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userRecentDocuments)) {
            data["userRecentDocuments"] = [];
            for (let item of this.userRecentDocuments)
                data["userRecentDocuments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUsers {
    id: number;
    name?: string | undefined;
    passwordHash?: string | undefined;
    passwordSalt?: string | undefined;
    emailAddress?: string | undefined;
    notificationTypeId?: number | undefined;
    active?: boolean | undefined;
    resetPassword?: number | undefined;
    userTypeId?: number | undefined;
    notificationType?: NotificationType | undefined;
    userType?: UserType | undefined;
    usersOtp?: UsersOtp | undefined;
    cryoprotectantv4?: Cryoprotectantv4[] | undefined;
    crystal?: Crystal[] | undefined;
    crystalv4?: Crystalv4[] | undefined;
    experiment?: Experiment[] | undefined;
    favoriteIngredientStock?: FavoriteIngredientStock[] | undefined;
    groupUser?: GroupUser[] | undefined;
    project?: Project[] | undefined;
    quickAccess?: QuickAccess[] | undefined;
    soakingv4?: Soakingv4[] | undefined;
    treeNodeAccessRight?: TreeNodeAccessRight[] | undefined;
    usageStat?: UsageStat[] | undefined;
    userRecentDocuments?: UserRecentDocuments[] | undefined;
}

export class NotificationType implements INotificationType {
    id!: number;
    name?: string | undefined;
    users?: Users[] | undefined;

    constructor(data?: INotificationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(Users.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationType {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INotificationType {
    id: number;
    name?: string | undefined;
    users?: Users[] | undefined;
}

export class UserType implements IUserType {
    id!: number;
    name?: string | undefined;
    users?: Users[] | undefined;

    constructor(data?: IUserType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(Users.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserType {
        data = typeof data === 'object' ? data : {};
        let result = new UserType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserType {
    id: number;
    name?: string | undefined;
    users?: Users[] | undefined;
}

export class UsersOtp implements IUsersOtp {
    id!: number;
    userId!: number;
    otp!: number;
    otpExpiry!: Date;
    user?: Users | undefined;

    constructor(data?: IUsersOtp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.otp = _data["otp"];
            this.otpExpiry = _data["otpExpiry"] ? new Date(_data["otpExpiry"].toString()) : undefined as any;
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): UsersOtp {
        data = typeof data === 'object' ? data : {};
        let result = new UsersOtp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["otp"] = this.otp;
        data["otpExpiry"] = this.otpExpiry ? this.otpExpiry.toISOString() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IUsersOtp {
    id: number;
    userId: number;
    otp: number;
    otpExpiry: Date;
    user?: Users | undefined;
}

export class Cryoprotectantv4 implements ICryoprotectantv4 {
    id!: number;
    ingredient?: string | undefined;
    conc!: number;
    concUnit?: string | undefined;
    ph?: number | undefined;
    protocol?: string | undefined;
    userId?: number | undefined;
    sourceWellId?: number | undefined;
    sourceWell?: Well | undefined;
    user?: Users | undefined;
    crystalCryoprotectantv4?: CrystalCryoprotectantv4[] | undefined;

    constructor(data?: ICryoprotectantv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredient = _data["ingredient"];
            this.conc = _data["conc"];
            this.concUnit = _data["concUnit"];
            this.ph = _data["ph"];
            this.protocol = _data["protocol"];
            this.userId = _data["userId"];
            this.sourceWellId = _data["sourceWellId"];
            this.sourceWell = _data["sourceWell"] ? Well.fromJS(_data["sourceWell"]) : undefined as any;
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["crystalCryoprotectantv4"])) {
                this.crystalCryoprotectantv4 = [] as any;
                for (let item of _data["crystalCryoprotectantv4"])
                    this.crystalCryoprotectantv4!.push(CrystalCryoprotectantv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Cryoprotectantv4 {
        data = typeof data === 'object' ? data : {};
        let result = new Cryoprotectantv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredient"] = this.ingredient;
        data["conc"] = this.conc;
        data["concUnit"] = this.concUnit;
        data["ph"] = this.ph;
        data["protocol"] = this.protocol;
        data["userId"] = this.userId;
        data["sourceWellId"] = this.sourceWellId;
        data["sourceWell"] = this.sourceWell ? this.sourceWell.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.crystalCryoprotectantv4)) {
            data["crystalCryoprotectantv4"] = [];
            for (let item of this.crystalCryoprotectantv4)
                data["crystalCryoprotectantv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICryoprotectantv4 {
    id: number;
    ingredient?: string | undefined;
    conc: number;
    concUnit?: string | undefined;
    ph?: number | undefined;
    protocol?: string | undefined;
    userId?: number | undefined;
    sourceWellId?: number | undefined;
    sourceWell?: Well | undefined;
    user?: Users | undefined;
    crystalCryoprotectantv4?: CrystalCryoprotectantv4[] | undefined;
}

export class Well implements IWell {
    id!: number;
    plateId!: number;
    wellNumber!: number;
    rowLetter?: string | undefined;
    columnNumber!: number;
    volume?: number | undefined;
    waterVolume?: number | undefined;
    currentVolume?: number | undefined;
    plate?: Plate | undefined;
    cryoprotectantv4?: Cryoprotectantv4[] | undefined;
    seed?: Seed[] | undefined;
    seedWell?: SeedWell[] | undefined;
    wellDrop?: WellDrop[] | undefined;
    wellLayer?: WellLayer[] | undefined;

    constructor(data?: IWell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plateId = _data["plateId"];
            this.wellNumber = _data["wellNumber"];
            this.rowLetter = _data["rowLetter"];
            this.columnNumber = _data["columnNumber"];
            this.volume = _data["volume"];
            this.waterVolume = _data["waterVolume"];
            this.currentVolume = _data["currentVolume"];
            this.plate = _data["plate"] ? Plate.fromJS(_data["plate"]) : undefined as any;
            if (Array.isArray(_data["cryoprotectantv4"])) {
                this.cryoprotectantv4 = [] as any;
                for (let item of _data["cryoprotectantv4"])
                    this.cryoprotectantv4!.push(Cryoprotectantv4.fromJS(item));
            }
            if (Array.isArray(_data["seed"])) {
                this.seed = [] as any;
                for (let item of _data["seed"])
                    this.seed!.push(Seed.fromJS(item));
            }
            if (Array.isArray(_data["seedWell"])) {
                this.seedWell = [] as any;
                for (let item of _data["seedWell"])
                    this.seedWell!.push(SeedWell.fromJS(item));
            }
            if (Array.isArray(_data["wellDrop"])) {
                this.wellDrop = [] as any;
                for (let item of _data["wellDrop"])
                    this.wellDrop!.push(WellDrop.fromJS(item));
            }
            if (Array.isArray(_data["wellLayer"])) {
                this.wellLayer = [] as any;
                for (let item of _data["wellLayer"])
                    this.wellLayer!.push(WellLayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Well {
        data = typeof data === 'object' ? data : {};
        let result = new Well();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plateId"] = this.plateId;
        data["wellNumber"] = this.wellNumber;
        data["rowLetter"] = this.rowLetter;
        data["columnNumber"] = this.columnNumber;
        data["volume"] = this.volume;
        data["waterVolume"] = this.waterVolume;
        data["currentVolume"] = this.currentVolume;
        data["plate"] = this.plate ? this.plate.toJSON() : undefined as any;
        if (Array.isArray(this.cryoprotectantv4)) {
            data["cryoprotectantv4"] = [];
            for (let item of this.cryoprotectantv4)
                data["cryoprotectantv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seed)) {
            data["seed"] = [];
            for (let item of this.seed)
                data["seed"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seedWell)) {
            data["seedWell"] = [];
            for (let item of this.seedWell)
                data["seedWell"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDrop)) {
            data["wellDrop"] = [];
            for (let item of this.wellDrop)
                data["wellDrop"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellLayer)) {
            data["wellLayer"] = [];
            for (let item of this.wellLayer)
                data["wellLayer"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWell {
    id: number;
    plateId: number;
    wellNumber: number;
    rowLetter?: string | undefined;
    columnNumber: number;
    volume?: number | undefined;
    waterVolume?: number | undefined;
    currentVolume?: number | undefined;
    plate?: Plate | undefined;
    cryoprotectantv4?: Cryoprotectantv4[] | undefined;
    seed?: Seed[] | undefined;
    seedWell?: SeedWell[] | undefined;
    wellDrop?: WellDrop[] | undefined;
    wellLayer?: WellLayer[] | undefined;
}

export class Seed implements ISeed {
    id!: number;
    treeNodeId?: number | undefined;
    name?: string | undefined;
    dateCreated?: Date | undefined;
    plateId?: number | undefined;
    wellDropId?: number | undefined;
    proteinFormulationId?: number | undefined;
    wellSolutionWellId?: number | undefined;
    notes?: string | undefined;
    plate?: Plate | undefined;
    proteinFormulation?: ProteinFormulation | undefined;
    treeNode?: TreeNode | undefined;
    wellDrop?: WellDrop | undefined;
    wellSolutionWell?: Well | undefined;
    seedSeedLayer?: SeedSeedLayer[] | undefined;
    seedSolutionIngredients?: SeedSolutionIngredients[] | undefined;
    seedWell?: SeedWell[] | undefined;
    wellDropNavigation?: WellDrop[] | undefined;

    constructor(data?: ISeed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.name = _data["name"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.plateId = _data["plateId"];
            this.wellDropId = _data["wellDropId"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.wellSolutionWellId = _data["wellSolutionWellId"];
            this.notes = _data["notes"];
            this.plate = _data["plate"] ? Plate.fromJS(_data["plate"]) : undefined as any;
            this.proteinFormulation = _data["proteinFormulation"] ? ProteinFormulation.fromJS(_data["proteinFormulation"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            this.wellDrop = _data["wellDrop"] ? WellDrop.fromJS(_data["wellDrop"]) : undefined as any;
            this.wellSolutionWell = _data["wellSolutionWell"] ? Well.fromJS(_data["wellSolutionWell"]) : undefined as any;
            if (Array.isArray(_data["seedSeedLayer"])) {
                this.seedSeedLayer = [] as any;
                for (let item of _data["seedSeedLayer"])
                    this.seedSeedLayer!.push(SeedSeedLayer.fromJS(item));
            }
            if (Array.isArray(_data["seedSolutionIngredients"])) {
                this.seedSolutionIngredients = [] as any;
                for (let item of _data["seedSolutionIngredients"])
                    this.seedSolutionIngredients!.push(SeedSolutionIngredients.fromJS(item));
            }
            if (Array.isArray(_data["seedWell"])) {
                this.seedWell = [] as any;
                for (let item of _data["seedWell"])
                    this.seedWell!.push(SeedWell.fromJS(item));
            }
            if (Array.isArray(_data["wellDropNavigation"])) {
                this.wellDropNavigation = [] as any;
                for (let item of _data["wellDropNavigation"])
                    this.wellDropNavigation!.push(WellDrop.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Seed {
        data = typeof data === 'object' ? data : {};
        let result = new Seed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["name"] = this.name;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["plateId"] = this.plateId;
        data["wellDropId"] = this.wellDropId;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["wellSolutionWellId"] = this.wellSolutionWellId;
        data["notes"] = this.notes;
        data["plate"] = this.plate ? this.plate.toJSON() : undefined as any;
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        data["wellDrop"] = this.wellDrop ? this.wellDrop.toJSON() : undefined as any;
        data["wellSolutionWell"] = this.wellSolutionWell ? this.wellSolutionWell.toJSON() : undefined as any;
        if (Array.isArray(this.seedSeedLayer)) {
            data["seedSeedLayer"] = [];
            for (let item of this.seedSeedLayer)
                data["seedSeedLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seedSolutionIngredients)) {
            data["seedSolutionIngredients"] = [];
            for (let item of this.seedSolutionIngredients)
                data["seedSolutionIngredients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seedWell)) {
            data["seedWell"] = [];
            for (let item of this.seedWell)
                data["seedWell"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDropNavigation)) {
            data["wellDropNavigation"] = [];
            for (let item of this.wellDropNavigation)
                data["wellDropNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISeed {
    id: number;
    treeNodeId?: number | undefined;
    name?: string | undefined;
    dateCreated?: Date | undefined;
    plateId?: number | undefined;
    wellDropId?: number | undefined;
    proteinFormulationId?: number | undefined;
    wellSolutionWellId?: number | undefined;
    notes?: string | undefined;
    plate?: Plate | undefined;
    proteinFormulation?: ProteinFormulation | undefined;
    treeNode?: TreeNode | undefined;
    wellDrop?: WellDrop | undefined;
    wellSolutionWell?: Well | undefined;
    seedSeedLayer?: SeedSeedLayer[] | undefined;
    seedSolutionIngredients?: SeedSolutionIngredients[] | undefined;
    seedWell?: SeedWell[] | undefined;
    wellDropNavigation?: WellDrop[] | undefined;
}

export class ProteinFormulation implements IProteinFormulation {
    id!: number;
    treeNodeId!: number;
    proteinLotId?: string | undefined;
    class?: string | undefined;
    datePrepared!: Date;
    volume?: number | undefined;
    storageTemperature?: number | undefined;
    extinctionCoefficient?: string | undefined;
    notebookPageNo?: string | undefined;
    notes?: string | undefined;
    liquidClassId!: number;
    apidata?: string | undefined;
    liquidClass?: LiquidClass | undefined;
    treeNode?: TreeNode | undefined;
    proteinFormulationAttachment?: ProteinFormulationAttachment[] | undefined;
    proteinFormulationIngredient?: ProteinFormulationIngredient[] | undefined;
    proteinFormulationStandardIngredient?: ProteinFormulationStandardIngredient[] | undefined;
    proteinLayerProteinFormulation?: ProteinLayerProteinFormulation[] | undefined;
    seed?: Seed[] | undefined;
    wellDrop?: WellDrop[] | undefined;
    wellDropProteinFormulation?: WellDropProteinFormulation[] | undefined;

    constructor(data?: IProteinFormulation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.proteinLotId = _data["proteinLotId"];
            this.class = _data["class"];
            this.datePrepared = _data["datePrepared"] ? new Date(_data["datePrepared"].toString()) : undefined as any;
            this.volume = _data["volume"];
            this.storageTemperature = _data["storageTemperature"];
            this.extinctionCoefficient = _data["extinctionCoefficient"];
            this.notebookPageNo = _data["notebookPageNo"];
            this.notes = _data["notes"];
            this.liquidClassId = _data["liquidClassId"];
            this.apidata = _data["apidata"];
            this.liquidClass = _data["liquidClass"] ? LiquidClass.fromJS(_data["liquidClass"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            if (Array.isArray(_data["proteinFormulationAttachment"])) {
                this.proteinFormulationAttachment = [] as any;
                for (let item of _data["proteinFormulationAttachment"])
                    this.proteinFormulationAttachment!.push(ProteinFormulationAttachment.fromJS(item));
            }
            if (Array.isArray(_data["proteinFormulationIngredient"])) {
                this.proteinFormulationIngredient = [] as any;
                for (let item of _data["proteinFormulationIngredient"])
                    this.proteinFormulationIngredient!.push(ProteinFormulationIngredient.fromJS(item));
            }
            if (Array.isArray(_data["proteinFormulationStandardIngredient"])) {
                this.proteinFormulationStandardIngredient = [] as any;
                for (let item of _data["proteinFormulationStandardIngredient"])
                    this.proteinFormulationStandardIngredient!.push(ProteinFormulationStandardIngredient.fromJS(item));
            }
            if (Array.isArray(_data["proteinLayerProteinFormulation"])) {
                this.proteinLayerProteinFormulation = [] as any;
                for (let item of _data["proteinLayerProteinFormulation"])
                    this.proteinLayerProteinFormulation!.push(ProteinLayerProteinFormulation.fromJS(item));
            }
            if (Array.isArray(_data["seed"])) {
                this.seed = [] as any;
                for (let item of _data["seed"])
                    this.seed!.push(Seed.fromJS(item));
            }
            if (Array.isArray(_data["wellDrop"])) {
                this.wellDrop = [] as any;
                for (let item of _data["wellDrop"])
                    this.wellDrop!.push(WellDrop.fromJS(item));
            }
            if (Array.isArray(_data["wellDropProteinFormulation"])) {
                this.wellDropProteinFormulation = [] as any;
                for (let item of _data["wellDropProteinFormulation"])
                    this.wellDropProteinFormulation!.push(WellDropProteinFormulation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProteinFormulation {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["proteinLotId"] = this.proteinLotId;
        data["class"] = this.class;
        data["datePrepared"] = this.datePrepared ? this.datePrepared.toISOString() : undefined as any;
        data["volume"] = this.volume;
        data["storageTemperature"] = this.storageTemperature;
        data["extinctionCoefficient"] = this.extinctionCoefficient;
        data["notebookPageNo"] = this.notebookPageNo;
        data["notes"] = this.notes;
        data["liquidClassId"] = this.liquidClassId;
        data["apidata"] = this.apidata;
        data["liquidClass"] = this.liquidClass ? this.liquidClass.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        if (Array.isArray(this.proteinFormulationAttachment)) {
            data["proteinFormulationAttachment"] = [];
            for (let item of this.proteinFormulationAttachment)
                data["proteinFormulationAttachment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinFormulationIngredient)) {
            data["proteinFormulationIngredient"] = [];
            for (let item of this.proteinFormulationIngredient)
                data["proteinFormulationIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinFormulationStandardIngredient)) {
            data["proteinFormulationStandardIngredient"] = [];
            for (let item of this.proteinFormulationStandardIngredient)
                data["proteinFormulationStandardIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinLayerProteinFormulation)) {
            data["proteinLayerProteinFormulation"] = [];
            for (let item of this.proteinLayerProteinFormulation)
                data["proteinLayerProteinFormulation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seed)) {
            data["seed"] = [];
            for (let item of this.seed)
                data["seed"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDrop)) {
            data["wellDrop"] = [];
            for (let item of this.wellDrop)
                data["wellDrop"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDropProteinFormulation)) {
            data["wellDropProteinFormulation"] = [];
            for (let item of this.wellDropProteinFormulation)
                data["wellDropProteinFormulation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProteinFormulation {
    id: number;
    treeNodeId: number;
    proteinLotId?: string | undefined;
    class?: string | undefined;
    datePrepared: Date;
    volume?: number | undefined;
    storageTemperature?: number | undefined;
    extinctionCoefficient?: string | undefined;
    notebookPageNo?: string | undefined;
    notes?: string | undefined;
    liquidClassId: number;
    apidata?: string | undefined;
    liquidClass?: LiquidClass | undefined;
    treeNode?: TreeNode | undefined;
    proteinFormulationAttachment?: ProteinFormulationAttachment[] | undefined;
    proteinFormulationIngredient?: ProteinFormulationIngredient[] | undefined;
    proteinFormulationStandardIngredient?: ProteinFormulationStandardIngredient[] | undefined;
    proteinLayerProteinFormulation?: ProteinLayerProteinFormulation[] | undefined;
    seed?: Seed[] | undefined;
    wellDrop?: WellDrop[] | undefined;
    wellDropProteinFormulation?: WellDropProteinFormulation[] | undefined;
}

export class LiquidClass implements ILiquidClass {
    id!: number;
    name?: string | undefined;
    ingredientStock?: IngredientStock[] | undefined;
    proteinFormulation?: ProteinFormulation[] | undefined;

    constructor(data?: ILiquidClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["ingredientStock"])) {
                this.ingredientStock = [] as any;
                for (let item of _data["ingredientStock"])
                    this.ingredientStock!.push(IngredientStock.fromJS(item));
            }
            if (Array.isArray(_data["proteinFormulation"])) {
                this.proteinFormulation = [] as any;
                for (let item of _data["proteinFormulation"])
                    this.proteinFormulation!.push(ProteinFormulation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiquidClass {
        data = typeof data === 'object' ? data : {};
        let result = new LiquidClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.ingredientStock)) {
            data["ingredientStock"] = [];
            for (let item of this.ingredientStock)
                data["ingredientStock"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinFormulation)) {
            data["proteinFormulation"] = [];
            for (let item of this.proteinFormulation)
                data["proteinFormulation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILiquidClass {
    id: number;
    name?: string | undefined;
    ingredientStock?: IngredientStock[] | undefined;
    proteinFormulation?: ProteinFormulation[] | undefined;
}

export class ProteinFormulationAttachment implements IProteinFormulationAttachment {
    proteinFormulationId!: number;
    name?: string | undefined;
    proteinFormulation?: ProteinFormulation | undefined;

    constructor(data?: IProteinFormulationAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.name = _data["name"];
            this.proteinFormulation = _data["proteinFormulation"] ? ProteinFormulation.fromJS(_data["proteinFormulation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProteinFormulationAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["name"] = this.name;
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        return data;
    }
}

export interface IProteinFormulationAttachment {
    proteinFormulationId: number;
    name?: string | undefined;
    proteinFormulation?: ProteinFormulation | undefined;
}

export class ProteinFormulationIngredient implements IProteinFormulationIngredient {
    id!: number;
    proteinFormulationId!: number;
    proteinFormulationIngredientTypeId!: number;
    name?: string | undefined;
    userId?: string | undefined;
    lot?: string | undefined;
    molecularWeight?: number | undefined;
    concentrationmgmL?: number | undefined;
    concentrationmM?: number | undefined;
    proteinFormulation?: ProteinFormulation | undefined;
    proteinFormulationIngredientType?: ProteinFormulationIngredientType | undefined;

    constructor(data?: IProteinFormulationIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.proteinFormulationIngredientTypeId = _data["proteinFormulationIngredientTypeId"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.lot = _data["lot"];
            this.molecularWeight = _data["molecularWeight"];
            this.concentrationmgmL = _data["concentrationmgmL"];
            this.concentrationmM = _data["concentrationmM"];
            this.proteinFormulation = _data["proteinFormulation"] ? ProteinFormulation.fromJS(_data["proteinFormulation"]) : undefined as any;
            this.proteinFormulationIngredientType = _data["proteinFormulationIngredientType"] ? ProteinFormulationIngredientType.fromJS(_data["proteinFormulationIngredientType"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProteinFormulationIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["proteinFormulationIngredientTypeId"] = this.proteinFormulationIngredientTypeId;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["lot"] = this.lot;
        data["molecularWeight"] = this.molecularWeight;
        data["concentrationmgmL"] = this.concentrationmgmL;
        data["concentrationmM"] = this.concentrationmM;
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        data["proteinFormulationIngredientType"] = this.proteinFormulationIngredientType ? this.proteinFormulationIngredientType.toJSON() : undefined as any;
        return data;
    }
}

export interface IProteinFormulationIngredient {
    id: number;
    proteinFormulationId: number;
    proteinFormulationIngredientTypeId: number;
    name?: string | undefined;
    userId?: string | undefined;
    lot?: string | undefined;
    molecularWeight?: number | undefined;
    concentrationmgmL?: number | undefined;
    concentrationmM?: number | undefined;
    proteinFormulation?: ProteinFormulation | undefined;
    proteinFormulationIngredientType?: ProteinFormulationIngredientType | undefined;
}

export class ProteinFormulationIngredientType implements IProteinFormulationIngredientType {
    id!: number;
    name?: string | undefined;
    proteinFormulationIngredient?: ProteinFormulationIngredient[] | undefined;

    constructor(data?: IProteinFormulationIngredientType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["proteinFormulationIngredient"])) {
                this.proteinFormulationIngredient = [] as any;
                for (let item of _data["proteinFormulationIngredient"])
                    this.proteinFormulationIngredient!.push(ProteinFormulationIngredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProteinFormulationIngredientType {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationIngredientType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.proteinFormulationIngredient)) {
            data["proteinFormulationIngredient"] = [];
            for (let item of this.proteinFormulationIngredient)
                data["proteinFormulationIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProteinFormulationIngredientType {
    id: number;
    name?: string | undefined;
    proteinFormulationIngredient?: ProteinFormulationIngredient[] | undefined;
}

export class ProteinFormulationStandardIngredient implements IProteinFormulationStandardIngredient {
    id!: number;
    proteinFormulationId!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    concentration!: number;
    ph?: number | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    proteinFormulation?: ProteinFormulation | undefined;

    constructor(data?: IProteinFormulationStandardIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.concentration = _data["concentration"];
            this.ph = _data["ph"];
            this.highPhingredientStock = _data["highPhingredientStock"] ? IngredientStock.fromJS(_data["highPhingredientStock"]) : undefined as any;
            this.ingredientIngredientType = _data["ingredientIngredientType"] ? IngredientIngredientType.fromJS(_data["ingredientIngredientType"]) : undefined as any;
            this.ingredientStock = _data["ingredientStock"] ? IngredientStock.fromJS(_data["ingredientStock"]) : undefined as any;
            this.proteinFormulation = _data["proteinFormulation"] ? ProteinFormulation.fromJS(_data["proteinFormulation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProteinFormulationStandardIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationStandardIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["concentration"] = this.concentration;
        data["ph"] = this.ph;
        data["highPhingredientStock"] = this.highPhingredientStock ? this.highPhingredientStock.toJSON() : undefined as any;
        data["ingredientIngredientType"] = this.ingredientIngredientType ? this.ingredientIngredientType.toJSON() : undefined as any;
        data["ingredientStock"] = this.ingredientStock ? this.ingredientStock.toJSON() : undefined as any;
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        return data;
    }
}

export interface IProteinFormulationStandardIngredient {
    id: number;
    proteinFormulationId: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    concentration: number;
    ph?: number | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    proteinFormulation?: ProteinFormulation | undefined;
}

export class ProteinLayerProteinFormulation implements IProteinLayerProteinFormulation {
    id!: number;
    proteinLayerId!: number;
    proteinFormulationId!: number;
    startWellDropVolume!: number;
    stopWellDropVolume!: number;
    wellDropVolumeVaryAlong!: number;
    startProteinDropVolume!: number;
    stopProteinDropVolume!: number;
    proteinDropVolumeVaryAlong!: number;
    proteinFormulation?: ProteinFormulation | undefined;
    proteinLayer?: ProteinLayer | undefined;

    constructor(data?: IProteinLayerProteinFormulation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proteinLayerId = _data["proteinLayerId"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.startWellDropVolume = _data["startWellDropVolume"];
            this.stopWellDropVolume = _data["stopWellDropVolume"];
            this.wellDropVolumeVaryAlong = _data["wellDropVolumeVaryAlong"];
            this.startProteinDropVolume = _data["startProteinDropVolume"];
            this.stopProteinDropVolume = _data["stopProteinDropVolume"];
            this.proteinDropVolumeVaryAlong = _data["proteinDropVolumeVaryAlong"];
            this.proteinFormulation = _data["proteinFormulation"] ? ProteinFormulation.fromJS(_data["proteinFormulation"]) : undefined as any;
            this.proteinLayer = _data["proteinLayer"] ? ProteinLayer.fromJS(_data["proteinLayer"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProteinLayerProteinFormulation {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinLayerProteinFormulation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proteinLayerId"] = this.proteinLayerId;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["startWellDropVolume"] = this.startWellDropVolume;
        data["stopWellDropVolume"] = this.stopWellDropVolume;
        data["wellDropVolumeVaryAlong"] = this.wellDropVolumeVaryAlong;
        data["startProteinDropVolume"] = this.startProteinDropVolume;
        data["stopProteinDropVolume"] = this.stopProteinDropVolume;
        data["proteinDropVolumeVaryAlong"] = this.proteinDropVolumeVaryAlong;
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        data["proteinLayer"] = this.proteinLayer ? this.proteinLayer.toJSON() : undefined as any;
        return data;
    }
}

export interface IProteinLayerProteinFormulation {
    id: number;
    proteinLayerId: number;
    proteinFormulationId: number;
    startWellDropVolume: number;
    stopWellDropVolume: number;
    wellDropVolumeVaryAlong: number;
    startProteinDropVolume: number;
    stopProteinDropVolume: number;
    proteinDropVolumeVaryAlong: number;
    proteinFormulation?: ProteinFormulation | undefined;
    proteinLayer?: ProteinLayer | undefined;
}

export class WellDrop implements IWellDrop {
    id!: number;
    wellId!: number;
    dropNumber!: number;
    proteinFormulationId?: number | undefined;
    dropWellVolume!: number;
    dropProteinVolume!: number;
    volume?: number | undefined;
    waterVolume?: number | undefined;
    importFl?: boolean | undefined;
    seedId?: number | undefined;
    dropSeedVolume!: number;
    fragmentScreenId?: number | undefined;
    dropFragmentVolume?: number | undefined;
    proteinFormulation?: ProteinFormulation | undefined;
    seedNavigation?: Seed | undefined;
    well?: Well | undefined;
    dropsToScore?: DropsToScore[] | undefined;
    imagingTaskWellDrop?: ImagingTaskWellDrop[] | undefined;
    seed?: Seed[] | undefined;
    fragmentScreen?: FragmentScreen | undefined;
    wellDropLayer?: WellDropLayer[] | undefined;
    wellDropProteinFormulation?: WellDropProteinFormulation[] | undefined;

    constructor(data?: IWellDrop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellId = _data["wellId"];
            this.dropNumber = _data["dropNumber"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.dropWellVolume = _data["dropWellVolume"];
            this.dropProteinVolume = _data["dropProteinVolume"];
            this.volume = _data["volume"];
            this.waterVolume = _data["waterVolume"];
            this.importFl = _data["importFl"];
            this.seedId = _data["seedId"];
            this.dropSeedVolume = _data["dropSeedVolume"];
            this.fragmentScreenId = _data["fragmentScreenId"];
            this.dropFragmentVolume = _data["dropFragmentVolume"];
            this.proteinFormulation = _data["proteinFormulation"] ? ProteinFormulation.fromJS(_data["proteinFormulation"]) : undefined as any;
            this.seedNavigation = _data["seedNavigation"] ? Seed.fromJS(_data["seedNavigation"]) : undefined as any;
            this.well = _data["well"] ? Well.fromJS(_data["well"]) : undefined as any;
            if (Array.isArray(_data["dropsToScore"])) {
                this.dropsToScore = [] as any;
                for (let item of _data["dropsToScore"])
                    this.dropsToScore!.push(DropsToScore.fromJS(item));
            }
            if (Array.isArray(_data["imagingTaskWellDrop"])) {
                this.imagingTaskWellDrop = [] as any;
                for (let item of _data["imagingTaskWellDrop"])
                    this.imagingTaskWellDrop!.push(ImagingTaskWellDrop.fromJS(item));
            }
            if (Array.isArray(_data["seed"])) {
                this.seed = [] as any;
                for (let item of _data["seed"])
                    this.seed!.push(Seed.fromJS(item));
            }
            this.fragmentScreen = _data["fragmentScreen"] ? FragmentScreen.fromJS(_data["fragmentScreen"]) : undefined as any;
            if (Array.isArray(_data["wellDropLayer"])) {
                this.wellDropLayer = [] as any;
                for (let item of _data["wellDropLayer"])
                    this.wellDropLayer!.push(WellDropLayer.fromJS(item));
            }
            if (Array.isArray(_data["wellDropProteinFormulation"])) {
                this.wellDropProteinFormulation = [] as any;
                for (let item of _data["wellDropProteinFormulation"])
                    this.wellDropProteinFormulation!.push(WellDropProteinFormulation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WellDrop {
        data = typeof data === 'object' ? data : {};
        let result = new WellDrop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellId"] = this.wellId;
        data["dropNumber"] = this.dropNumber;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["dropWellVolume"] = this.dropWellVolume;
        data["dropProteinVolume"] = this.dropProteinVolume;
        data["volume"] = this.volume;
        data["waterVolume"] = this.waterVolume;
        data["importFl"] = this.importFl;
        data["seedId"] = this.seedId;
        data["dropSeedVolume"] = this.dropSeedVolume;
        data["fragmentScreenId"] = this.fragmentScreenId;
        data["dropFragmentVolume"] = this.dropFragmentVolume;
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        data["seedNavigation"] = this.seedNavigation ? this.seedNavigation.toJSON() : undefined as any;
        data["well"] = this.well ? this.well.toJSON() : undefined as any;
        if (Array.isArray(this.dropsToScore)) {
            data["dropsToScore"] = [];
            for (let item of this.dropsToScore)
                data["dropsToScore"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagingTaskWellDrop)) {
            data["imagingTaskWellDrop"] = [];
            for (let item of this.imagingTaskWellDrop)
                data["imagingTaskWellDrop"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seed)) {
            data["seed"] = [];
            for (let item of this.seed)
                data["seed"].push(item ? item.toJSON() : undefined as any);
        }
        data["fragmentScreen"] = this.fragmentScreen ? this.fragmentScreen.toJSON() : undefined as any;
        if (Array.isArray(this.wellDropLayer)) {
            data["wellDropLayer"] = [];
            for (let item of this.wellDropLayer)
                data["wellDropLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDropProteinFormulation)) {
            data["wellDropProteinFormulation"] = [];
            for (let item of this.wellDropProteinFormulation)
                data["wellDropProteinFormulation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWellDrop {
    id: number;
    wellId: number;
    dropNumber: number;
    proteinFormulationId?: number | undefined;
    dropWellVolume: number;
    dropProteinVolume: number;
    volume?: number | undefined;
    waterVolume?: number | undefined;
    importFl?: boolean | undefined;
    seedId?: number | undefined;
    dropSeedVolume: number;
    fragmentScreenId?: number | undefined;
    dropFragmentVolume?: number | undefined;
    proteinFormulation?: ProteinFormulation | undefined;
    seedNavigation?: Seed | undefined;
    well?: Well | undefined;
    dropsToScore?: DropsToScore[] | undefined;
    imagingTaskWellDrop?: ImagingTaskWellDrop[] | undefined;
    seed?: Seed[] | undefined;
    fragmentScreen?: FragmentScreen | undefined;
    wellDropLayer?: WellDropLayer[] | undefined;
    wellDropProteinFormulation?: WellDropProteinFormulation[] | undefined;
}

export class DropsToScore implements IDropsToScore {
    id!: number;
    wellDropId!: number;
    imageBatchId!: number;
    status?: number | undefined;
    dateScored?: Date | undefined;
    dateSubmitted?: Date | undefined;
    priority!: number;
    imageBatch?: ImageBatch | undefined;
    wellDrop?: WellDrop | undefined;
    disputedScore?: DisputedScore[] | undefined;

    constructor(data?: IDropsToScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDropId = _data["wellDropId"];
            this.imageBatchId = _data["imageBatchId"];
            this.status = _data["status"];
            this.dateScored = _data["dateScored"] ? new Date(_data["dateScored"].toString()) : undefined as any;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : undefined as any;
            this.priority = _data["priority"];
            this.imageBatch = _data["imageBatch"] ? ImageBatch.fromJS(_data["imageBatch"]) : undefined as any;
            this.wellDrop = _data["wellDrop"] ? WellDrop.fromJS(_data["wellDrop"]) : undefined as any;
            if (Array.isArray(_data["disputedScore"])) {
                this.disputedScore = [] as any;
                for (let item of _data["disputedScore"])
                    this.disputedScore!.push(DisputedScore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DropsToScore {
        data = typeof data === 'object' ? data : {};
        let result = new DropsToScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDropId"] = this.wellDropId;
        data["imageBatchId"] = this.imageBatchId;
        data["status"] = this.status;
        data["dateScored"] = this.dateScored ? this.dateScored.toISOString() : undefined as any;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : undefined as any;
        data["priority"] = this.priority;
        data["imageBatch"] = this.imageBatch ? this.imageBatch.toJSON() : undefined as any;
        data["wellDrop"] = this.wellDrop ? this.wellDrop.toJSON() : undefined as any;
        if (Array.isArray(this.disputedScore)) {
            data["disputedScore"] = [];
            for (let item of this.disputedScore)
                data["disputedScore"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDropsToScore {
    id: number;
    wellDropId: number;
    imageBatchId: number;
    status?: number | undefined;
    dateScored?: Date | undefined;
    dateSubmitted?: Date | undefined;
    priority: number;
    imageBatch?: ImageBatch | undefined;
    wellDrop?: WellDrop | undefined;
    disputedScore?: DisputedScore[] | undefined;
}

export class DisputedScore implements IDisputedScore {
    id!: number;
    imageBatchWellDropScoreId!: number;
    dropToScoreId?: number | undefined;
    message?: string | undefined;
    status?: number | undefined;
    recommendedScore?: number | undefined;
    disputeType!: number;
    dropToScore?: DropsToScore | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore | undefined;

    constructor(data?: IDisputedScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageBatchWellDropScoreId = _data["imageBatchWellDropScoreId"];
            this.dropToScoreId = _data["dropToScoreId"];
            this.message = _data["message"];
            this.status = _data["status"];
            this.recommendedScore = _data["recommendedScore"];
            this.disputeType = _data["disputeType"];
            this.dropToScore = _data["dropToScore"] ? DropsToScore.fromJS(_data["dropToScore"]) : undefined as any;
            this.imageBatchWellDropScore = _data["imageBatchWellDropScore"] ? ImageBatchWellDropScore.fromJS(_data["imageBatchWellDropScore"]) : undefined as any;
        }
    }

    static fromJS(data: any): DisputedScore {
        data = typeof data === 'object' ? data : {};
        let result = new DisputedScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageBatchWellDropScoreId"] = this.imageBatchWellDropScoreId;
        data["dropToScoreId"] = this.dropToScoreId;
        data["message"] = this.message;
        data["status"] = this.status;
        data["recommendedScore"] = this.recommendedScore;
        data["disputeType"] = this.disputeType;
        data["dropToScore"] = this.dropToScore ? this.dropToScore.toJSON() : undefined as any;
        data["imageBatchWellDropScore"] = this.imageBatchWellDropScore ? this.imageBatchWellDropScore.toJSON() : undefined as any;
        return data;
    }
}

export interface IDisputedScore {
    id: number;
    imageBatchWellDropScoreId: number;
    dropToScoreId?: number | undefined;
    message?: string | undefined;
    status?: number | undefined;
    recommendedScore?: number | undefined;
    disputeType: number;
    dropToScore?: DropsToScore | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore | undefined;
}

export class ImageBatchWellDropScore implements IImageBatchWellDropScore {
    id!: number;
    wellDropId!: number;
    imageBatchId!: number;
    wellDropScoreId!: number;
    autoScoreValue?: number | undefined;
    scoreType!: number;
    captureProfileId?: number | undefined;
    sourceRegionId?: number | undefined;
    scorerVersionId?: number | undefined;
    imageId?: number | undefined;
    isAutoScoreIgnored?: boolean | undefined;
    sourceScoreId?: number | undefined;
    captureProfile?: CaptureProfile | undefined;
    image?: Image | undefined;
    imageBatch?: ImageBatch | undefined;
    scorerVersion?: ScorerVersion | undefined;
    sourceRegion?: Region | undefined;
    wellDropScore?: WellDropScore | undefined;
    disputedScore?: DisputedScore[] | undefined;
    morphologyDetail?: MorphologyDetail[] | undefined;
    scoreDetail?: ScoreDetail[] | undefined;
    ultravioletDetail?: UltravioletDetail[] | undefined;

    constructor(data?: IImageBatchWellDropScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDropId = _data["wellDropId"];
            this.imageBatchId = _data["imageBatchId"];
            this.wellDropScoreId = _data["wellDropScoreId"];
            this.autoScoreValue = _data["autoScoreValue"];
            this.scoreType = _data["scoreType"];
            this.captureProfileId = _data["captureProfileId"];
            this.sourceRegionId = _data["sourceRegionId"];
            this.scorerVersionId = _data["scorerVersionId"];
            this.imageId = _data["imageId"];
            this.isAutoScoreIgnored = _data["isAutoScoreIgnored"];
            this.sourceScoreId = _data["sourceScoreId"];
            this.captureProfile = _data["captureProfile"] ? CaptureProfile.fromJS(_data["captureProfile"]) : undefined as any;
            this.image = _data["image"] ? Image.fromJS(_data["image"]) : undefined as any;
            this.imageBatch = _data["imageBatch"] ? ImageBatch.fromJS(_data["imageBatch"]) : undefined as any;
            this.scorerVersion = _data["scorerVersion"] ? ScorerVersion.fromJS(_data["scorerVersion"]) : undefined as any;
            this.sourceRegion = _data["sourceRegion"] ? Region.fromJS(_data["sourceRegion"]) : undefined as any;
            this.wellDropScore = _data["wellDropScore"] ? WellDropScore.fromJS(_data["wellDropScore"]) : undefined as any;
            if (Array.isArray(_data["disputedScore"])) {
                this.disputedScore = [] as any;
                for (let item of _data["disputedScore"])
                    this.disputedScore!.push(DisputedScore.fromJS(item));
            }
            if (Array.isArray(_data["morphologyDetail"])) {
                this.morphologyDetail = [] as any;
                for (let item of _data["morphologyDetail"])
                    this.morphologyDetail!.push(MorphologyDetail.fromJS(item));
            }
            if (Array.isArray(_data["scoreDetail"])) {
                this.scoreDetail = [] as any;
                for (let item of _data["scoreDetail"])
                    this.scoreDetail!.push(ScoreDetail.fromJS(item));
            }
            if (Array.isArray(_data["ultravioletDetail"])) {
                this.ultravioletDetail = [] as any;
                for (let item of _data["ultravioletDetail"])
                    this.ultravioletDetail!.push(UltravioletDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageBatchWellDropScore {
        data = typeof data === 'object' ? data : {};
        let result = new ImageBatchWellDropScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDropId"] = this.wellDropId;
        data["imageBatchId"] = this.imageBatchId;
        data["wellDropScoreId"] = this.wellDropScoreId;
        data["autoScoreValue"] = this.autoScoreValue;
        data["scoreType"] = this.scoreType;
        data["captureProfileId"] = this.captureProfileId;
        data["sourceRegionId"] = this.sourceRegionId;
        data["scorerVersionId"] = this.scorerVersionId;
        data["imageId"] = this.imageId;
        data["isAutoScoreIgnored"] = this.isAutoScoreIgnored;
        data["sourceScoreId"] = this.sourceScoreId;
        data["captureProfile"] = this.captureProfile ? this.captureProfile.toJSON() : undefined as any;
        data["image"] = this.image ? this.image.toJSON() : undefined as any;
        data["imageBatch"] = this.imageBatch ? this.imageBatch.toJSON() : undefined as any;
        data["scorerVersion"] = this.scorerVersion ? this.scorerVersion.toJSON() : undefined as any;
        data["sourceRegion"] = this.sourceRegion ? this.sourceRegion.toJSON() : undefined as any;
        data["wellDropScore"] = this.wellDropScore ? this.wellDropScore.toJSON() : undefined as any;
        if (Array.isArray(this.disputedScore)) {
            data["disputedScore"] = [];
            for (let item of this.disputedScore)
                data["disputedScore"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.morphologyDetail)) {
            data["morphologyDetail"] = [];
            for (let item of this.morphologyDetail)
                data["morphologyDetail"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scoreDetail)) {
            data["scoreDetail"] = [];
            for (let item of this.scoreDetail)
                data["scoreDetail"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ultravioletDetail)) {
            data["ultravioletDetail"] = [];
            for (let item of this.ultravioletDetail)
                data["ultravioletDetail"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImageBatchWellDropScore {
    id: number;
    wellDropId: number;
    imageBatchId: number;
    wellDropScoreId: number;
    autoScoreValue?: number | undefined;
    scoreType: number;
    captureProfileId?: number | undefined;
    sourceRegionId?: number | undefined;
    scorerVersionId?: number | undefined;
    imageId?: number | undefined;
    isAutoScoreIgnored?: boolean | undefined;
    sourceScoreId?: number | undefined;
    captureProfile?: CaptureProfile | undefined;
    image?: Image | undefined;
    imageBatch?: ImageBatch | undefined;
    scorerVersion?: ScorerVersion | undefined;
    sourceRegion?: Region | undefined;
    wellDropScore?: WellDropScore | undefined;
    disputedScore?: DisputedScore[] | undefined;
    morphologyDetail?: MorphologyDetail[] | undefined;
    scoreDetail?: ScoreDetail[] | undefined;
    ultravioletDetail?: UltravioletDetail[] | undefined;
}

export class ScorerVersion implements IScorerVersion {
    id!: number;
    scorerId!: number;
    version?: string | undefined;
    versionType?: number | undefined;
    scorer?: Scorer | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;

    constructor(data?: IScorerVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scorerId = _data["scorerId"];
            this.version = _data["version"];
            this.versionType = _data["versionType"];
            this.scorer = _data["scorer"] ? Scorer.fromJS(_data["scorer"]) : undefined as any;
            if (Array.isArray(_data["imageBatchWellDropScore"])) {
                this.imageBatchWellDropScore = [] as any;
                for (let item of _data["imageBatchWellDropScore"])
                    this.imageBatchWellDropScore!.push(ImageBatchWellDropScore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScorerVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ScorerVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scorerId"] = this.scorerId;
        data["version"] = this.version;
        data["versionType"] = this.versionType;
        data["scorer"] = this.scorer ? this.scorer.toJSON() : undefined as any;
        if (Array.isArray(this.imageBatchWellDropScore)) {
            data["imageBatchWellDropScore"] = [];
            for (let item of this.imageBatchWellDropScore)
                data["imageBatchWellDropScore"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScorerVersion {
    id: number;
    scorerId: number;
    version?: string | undefined;
    versionType?: number | undefined;
    scorer?: Scorer | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
}

export class Scorer implements IScorer {
    id!: number;
    name?: string | undefined;
    description?: string | undefined;
    scoreGroupId!: number;
    modelPath?: string | undefined;
    scoreGroup?: WellDropScoreGroup | undefined;
    scorerLightPath?: ScorerLightPath[] | undefined;
    scorerVersion?: ScorerVersion[] | undefined;

    constructor(data?: IScorer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.scoreGroupId = _data["scoreGroupId"];
            this.modelPath = _data["modelPath"];
            this.scoreGroup = _data["scoreGroup"] ? WellDropScoreGroup.fromJS(_data["scoreGroup"]) : undefined as any;
            if (Array.isArray(_data["scorerLightPath"])) {
                this.scorerLightPath = [] as any;
                for (let item of _data["scorerLightPath"])
                    this.scorerLightPath!.push(ScorerLightPath.fromJS(item));
            }
            if (Array.isArray(_data["scorerVersion"])) {
                this.scorerVersion = [] as any;
                for (let item of _data["scorerVersion"])
                    this.scorerVersion!.push(ScorerVersion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Scorer {
        data = typeof data === 'object' ? data : {};
        let result = new Scorer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["scoreGroupId"] = this.scoreGroupId;
        data["modelPath"] = this.modelPath;
        data["scoreGroup"] = this.scoreGroup ? this.scoreGroup.toJSON() : undefined as any;
        if (Array.isArray(this.scorerLightPath)) {
            data["scorerLightPath"] = [];
            for (let item of this.scorerLightPath)
                data["scorerLightPath"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scorerVersion)) {
            data["scorerVersion"] = [];
            for (let item of this.scorerVersion)
                data["scorerVersion"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScorer {
    id: number;
    name?: string | undefined;
    description?: string | undefined;
    scoreGroupId: number;
    modelPath?: string | undefined;
    scoreGroup?: WellDropScoreGroup | undefined;
    scorerLightPath?: ScorerLightPath[] | undefined;
    scorerVersion?: ScorerVersion[] | undefined;
}

export class WellDropScoreGroup implements IWellDropScoreGroup {
    id!: number;
    name?: string | undefined;
    isAutoScore!: boolean;
    unit?: string | undefined;
    autoScoreType?: number | undefined;
    inherits?: boolean | undefined;
    scorer?: Scorer[] | undefined;
    wellDropScore?: WellDropScore[] | undefined;

    constructor(data?: IWellDropScoreGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isAutoScore = _data["isAutoScore"];
            this.unit = _data["unit"];
            this.autoScoreType = _data["autoScoreType"];
            this.inherits = _data["inherits"];
            if (Array.isArray(_data["scorer"])) {
                this.scorer = [] as any;
                for (let item of _data["scorer"])
                    this.scorer!.push(Scorer.fromJS(item));
            }
            if (Array.isArray(_data["wellDropScore"])) {
                this.wellDropScore = [] as any;
                for (let item of _data["wellDropScore"])
                    this.wellDropScore!.push(WellDropScore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WellDropScoreGroup {
        data = typeof data === 'object' ? data : {};
        let result = new WellDropScoreGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isAutoScore"] = this.isAutoScore;
        data["unit"] = this.unit;
        data["autoScoreType"] = this.autoScoreType;
        data["inherits"] = this.inherits;
        if (Array.isArray(this.scorer)) {
            data["scorer"] = [];
            for (let item of this.scorer)
                data["scorer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDropScore)) {
            data["wellDropScore"] = [];
            for (let item of this.wellDropScore)
                data["wellDropScore"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWellDropScoreGroup {
    id: number;
    name?: string | undefined;
    isAutoScore: boolean;
    unit?: string | undefined;
    autoScoreType?: number | undefined;
    inherits?: boolean | undefined;
    scorer?: Scorer[] | undefined;
    wellDropScore?: WellDropScore[] | undefined;
}

export class WellDropScore implements IWellDropScore {
    id!: number;
    wellDropScoreGroupId!: number;
    name?: string | undefined;
    hotKey?: string | undefined;
    orderNumber!: number;
    color!: number;
    value!: number;
    hit!: boolean;
    isovalue?: number | undefined;
    wellDropScoreGroup?: WellDropScoreGroup | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
    isowellDropScoreValue?: IsowellDropScoreValue[] | undefined;

    constructor(data?: IWellDropScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDropScoreGroupId = _data["wellDropScoreGroupId"];
            this.name = _data["name"];
            this.hotKey = _data["hotKey"];
            this.orderNumber = _data["orderNumber"];
            this.color = _data["color"];
            this.value = _data["value"];
            this.hit = _data["hit"];
            this.isovalue = _data["isovalue"];
            this.wellDropScoreGroup = _data["wellDropScoreGroup"] ? WellDropScoreGroup.fromJS(_data["wellDropScoreGroup"]) : undefined as any;
            if (Array.isArray(_data["imageBatchWellDropScore"])) {
                this.imageBatchWellDropScore = [] as any;
                for (let item of _data["imageBatchWellDropScore"])
                    this.imageBatchWellDropScore!.push(ImageBatchWellDropScore.fromJS(item));
            }
            if (Array.isArray(_data["isowellDropScoreValue"])) {
                this.isowellDropScoreValue = [] as any;
                for (let item of _data["isowellDropScoreValue"])
                    this.isowellDropScoreValue!.push(IsowellDropScoreValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WellDropScore {
        data = typeof data === 'object' ? data : {};
        let result = new WellDropScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDropScoreGroupId"] = this.wellDropScoreGroupId;
        data["name"] = this.name;
        data["hotKey"] = this.hotKey;
        data["orderNumber"] = this.orderNumber;
        data["color"] = this.color;
        data["value"] = this.value;
        data["hit"] = this.hit;
        data["isovalue"] = this.isovalue;
        data["wellDropScoreGroup"] = this.wellDropScoreGroup ? this.wellDropScoreGroup.toJSON() : undefined as any;
        if (Array.isArray(this.imageBatchWellDropScore)) {
            data["imageBatchWellDropScore"] = [];
            for (let item of this.imageBatchWellDropScore)
                data["imageBatchWellDropScore"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isowellDropScoreValue)) {
            data["isowellDropScoreValue"] = [];
            for (let item of this.isowellDropScoreValue)
                data["isowellDropScoreValue"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWellDropScore {
    id: number;
    wellDropScoreGroupId: number;
    name?: string | undefined;
    hotKey?: string | undefined;
    orderNumber: number;
    color: number;
    value: number;
    hit: boolean;
    isovalue?: number | undefined;
    wellDropScoreGroup?: WellDropScoreGroup | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
    isowellDropScoreValue?: IsowellDropScoreValue[] | undefined;
}

export class IsowellDropScoreValue implements IIsowellDropScoreValue {
    id!: number;
    plateId?: number | undefined;
    wellDropScoreId?: number | undefined;
    isovalue?: number | undefined;
    plate?: Plate | undefined;
    wellDropScore?: WellDropScore | undefined;

    constructor(data?: IIsowellDropScoreValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plateId = _data["plateId"];
            this.wellDropScoreId = _data["wellDropScoreId"];
            this.isovalue = _data["isovalue"];
            this.plate = _data["plate"] ? Plate.fromJS(_data["plate"]) : undefined as any;
            this.wellDropScore = _data["wellDropScore"] ? WellDropScore.fromJS(_data["wellDropScore"]) : undefined as any;
        }
    }

    static fromJS(data: any): IsowellDropScoreValue {
        data = typeof data === 'object' ? data : {};
        let result = new IsowellDropScoreValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plateId"] = this.plateId;
        data["wellDropScoreId"] = this.wellDropScoreId;
        data["isovalue"] = this.isovalue;
        data["plate"] = this.plate ? this.plate.toJSON() : undefined as any;
        data["wellDropScore"] = this.wellDropScore ? this.wellDropScore.toJSON() : undefined as any;
        return data;
    }
}

export interface IIsowellDropScoreValue {
    id: number;
    plateId?: number | undefined;
    wellDropScoreId?: number | undefined;
    isovalue?: number | undefined;
    plate?: Plate | undefined;
    wellDropScore?: WellDropScore | undefined;
}

export class ScorerLightPath implements IScorerLightPath {
    id!: number;
    scorerId!: number;
    lightPath?: string | undefined;
    scorer?: Scorer | undefined;

    constructor(data?: IScorerLightPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scorerId = _data["scorerId"];
            this.lightPath = _data["lightPath"];
            this.scorer = _data["scorer"] ? Scorer.fromJS(_data["scorer"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScorerLightPath {
        data = typeof data === 'object' ? data : {};
        let result = new ScorerLightPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scorerId"] = this.scorerId;
        data["lightPath"] = this.lightPath;
        data["scorer"] = this.scorer ? this.scorer.toJSON() : undefined as any;
        return data;
    }
}

export interface IScorerLightPath {
    id: number;
    scorerId: number;
    lightPath?: string | undefined;
    scorer?: Scorer | undefined;
}

export class Region implements IRegion {
    id!: number;
    wellDropId!: number;
    regionTypeId!: number;
    parentRegionId?: number | undefined;
    regionName?: string | undefined;
    imagingEnabled!: boolean;
    xcenterOffset?: number | undefined;
    ycenterOffset?: number | undefined;
    zheight?: number | undefined;
    xwidth?: number | undefined;
    yheight?: number | undefined;
    parentRegion?: Region | undefined;
    regionType?: RegionType | undefined;
    captureResult?: CaptureResult[] | undefined;
    crystal?: Crystal[] | undefined;
    crystalv4?: Crystalv4[] | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
    inverseParentRegion?: Region[] | undefined;
    regionAnnotation?: RegionAnnotation[] | undefined;
    regionCaptureProfile?: RegionCaptureProfile[] | undefined;
    regionPoint?: RegionPoint[] | undefined;
    regionProperty?: RegionProperty[] | undefined;
    regionRuler?: RegionRuler[] | undefined;
    regionScribble?: RegionScribble[] | undefined;

    constructor(data?: IRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDropId = _data["wellDropId"];
            this.regionTypeId = _data["regionTypeId"];
            this.parentRegionId = _data["parentRegionId"];
            this.regionName = _data["regionName"];
            this.imagingEnabled = _data["imagingEnabled"];
            this.xcenterOffset = _data["xcenterOffset"];
            this.ycenterOffset = _data["ycenterOffset"];
            this.zheight = _data["zheight"];
            this.xwidth = _data["xwidth"];
            this.yheight = _data["yheight"];
            this.parentRegion = _data["parentRegion"] ? Region.fromJS(_data["parentRegion"]) : undefined as any;
            this.regionType = _data["regionType"] ? RegionType.fromJS(_data["regionType"]) : undefined as any;
            if (Array.isArray(_data["captureResult"])) {
                this.captureResult = [] as any;
                for (let item of _data["captureResult"])
                    this.captureResult!.push(CaptureResult.fromJS(item));
            }
            if (Array.isArray(_data["crystal"])) {
                this.crystal = [] as any;
                for (let item of _data["crystal"])
                    this.crystal!.push(Crystal.fromJS(item));
            }
            if (Array.isArray(_data["crystalv4"])) {
                this.crystalv4 = [] as any;
                for (let item of _data["crystalv4"])
                    this.crystalv4!.push(Crystalv4.fromJS(item));
            }
            if (Array.isArray(_data["imageBatchWellDropScore"])) {
                this.imageBatchWellDropScore = [] as any;
                for (let item of _data["imageBatchWellDropScore"])
                    this.imageBatchWellDropScore!.push(ImageBatchWellDropScore.fromJS(item));
            }
            if (Array.isArray(_data["inverseParentRegion"])) {
                this.inverseParentRegion = [] as any;
                for (let item of _data["inverseParentRegion"])
                    this.inverseParentRegion!.push(Region.fromJS(item));
            }
            if (Array.isArray(_data["regionAnnotation"])) {
                this.regionAnnotation = [] as any;
                for (let item of _data["regionAnnotation"])
                    this.regionAnnotation!.push(RegionAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["regionCaptureProfile"])) {
                this.regionCaptureProfile = [] as any;
                for (let item of _data["regionCaptureProfile"])
                    this.regionCaptureProfile!.push(RegionCaptureProfile.fromJS(item));
            }
            if (Array.isArray(_data["regionPoint"])) {
                this.regionPoint = [] as any;
                for (let item of _data["regionPoint"])
                    this.regionPoint!.push(RegionPoint.fromJS(item));
            }
            if (Array.isArray(_data["regionProperty"])) {
                this.regionProperty = [] as any;
                for (let item of _data["regionProperty"])
                    this.regionProperty!.push(RegionProperty.fromJS(item));
            }
            if (Array.isArray(_data["regionRuler"])) {
                this.regionRuler = [] as any;
                for (let item of _data["regionRuler"])
                    this.regionRuler!.push(RegionRuler.fromJS(item));
            }
            if (Array.isArray(_data["regionScribble"])) {
                this.regionScribble = [] as any;
                for (let item of _data["regionScribble"])
                    this.regionScribble!.push(RegionScribble.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Region {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDropId"] = this.wellDropId;
        data["regionTypeId"] = this.regionTypeId;
        data["parentRegionId"] = this.parentRegionId;
        data["regionName"] = this.regionName;
        data["imagingEnabled"] = this.imagingEnabled;
        data["xcenterOffset"] = this.xcenterOffset;
        data["ycenterOffset"] = this.ycenterOffset;
        data["zheight"] = this.zheight;
        data["xwidth"] = this.xwidth;
        data["yheight"] = this.yheight;
        data["parentRegion"] = this.parentRegion ? this.parentRegion.toJSON() : undefined as any;
        data["regionType"] = this.regionType ? this.regionType.toJSON() : undefined as any;
        if (Array.isArray(this.captureResult)) {
            data["captureResult"] = [];
            for (let item of this.captureResult)
                data["captureResult"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystal)) {
            data["crystal"] = [];
            for (let item of this.crystal)
                data["crystal"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystalv4)) {
            data["crystalv4"] = [];
            for (let item of this.crystalv4)
                data["crystalv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageBatchWellDropScore)) {
            data["imageBatchWellDropScore"] = [];
            for (let item of this.imageBatchWellDropScore)
                data["imageBatchWellDropScore"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inverseParentRegion)) {
            data["inverseParentRegion"] = [];
            for (let item of this.inverseParentRegion)
                data["inverseParentRegion"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionAnnotation)) {
            data["regionAnnotation"] = [];
            for (let item of this.regionAnnotation)
                data["regionAnnotation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionCaptureProfile)) {
            data["regionCaptureProfile"] = [];
            for (let item of this.regionCaptureProfile)
                data["regionCaptureProfile"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionPoint)) {
            data["regionPoint"] = [];
            for (let item of this.regionPoint)
                data["regionPoint"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionProperty)) {
            data["regionProperty"] = [];
            for (let item of this.regionProperty)
                data["regionProperty"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionRuler)) {
            data["regionRuler"] = [];
            for (let item of this.regionRuler)
                data["regionRuler"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionScribble)) {
            data["regionScribble"] = [];
            for (let item of this.regionScribble)
                data["regionScribble"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegion {
    id: number;
    wellDropId: number;
    regionTypeId: number;
    parentRegionId?: number | undefined;
    regionName?: string | undefined;
    imagingEnabled: boolean;
    xcenterOffset?: number | undefined;
    ycenterOffset?: number | undefined;
    zheight?: number | undefined;
    xwidth?: number | undefined;
    yheight?: number | undefined;
    parentRegion?: Region | undefined;
    regionType?: RegionType | undefined;
    captureResult?: CaptureResult[] | undefined;
    crystal?: Crystal[] | undefined;
    crystalv4?: Crystalv4[] | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore[] | undefined;
    inverseParentRegion?: Region[] | undefined;
    regionAnnotation?: RegionAnnotation[] | undefined;
    regionCaptureProfile?: RegionCaptureProfile[] | undefined;
    regionPoint?: RegionPoint[] | undefined;
    regionProperty?: RegionProperty[] | undefined;
    regionRuler?: RegionRuler[] | undefined;
    regionScribble?: RegionScribble[] | undefined;
}

export class RegionType implements IRegionType {
    id!: number;
    name?: string | undefined;
    region?: Region[] | undefined;

    constructor(data?: IRegionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["region"])) {
                this.region = [] as any;
                for (let item of _data["region"])
                    this.region!.push(Region.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegionType {
        data = typeof data === 'object' ? data : {};
        let result = new RegionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.region)) {
            data["region"] = [];
            for (let item of this.region)
                data["region"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegionType {
    id: number;
    name?: string | undefined;
    region?: Region[] | undefined;
}

export class Crystalv4 implements ICrystalv4 {
    id!: number;
    regionId!: number;
    captureProfileVersionId!: number;
    imageBatchId!: number;
    name?: string | undefined;
    dataCollected!: boolean;
    x?: number | undefined;
    y?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    dateFrozen?: Date | undefined;
    ownerUserId!: number;
    position?: number | undefined;
    notes?: string | undefined;
    dateCollected?: Date | undefined;
    captureProfileVersion?: CaptureProfileVersion | undefined;
    imageBatch?: ImageBatch | undefined;
    ownerUser?: Users | undefined;
    region?: Region | undefined;
    crystalCryoprotectantv4?: CrystalCryoprotectantv4[] | undefined;
    crystalFilesv4?: CrystalFilesv4[] | undefined;
    crystalSoakingv4?: CrystalSoakingv4[] | undefined;
    crystalTripv4?: CrystalTripv4[] | undefined;

    constructor(data?: ICrystalv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.captureProfileVersionId = _data["captureProfileVersionId"];
            this.imageBatchId = _data["imageBatchId"];
            this.name = _data["name"];
            this.dataCollected = _data["dataCollected"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.dateFrozen = _data["dateFrozen"] ? new Date(_data["dateFrozen"].toString()) : undefined as any;
            this.ownerUserId = _data["ownerUserId"];
            this.position = _data["position"];
            this.notes = _data["notes"];
            this.dateCollected = _data["dateCollected"] ? new Date(_data["dateCollected"].toString()) : undefined as any;
            this.captureProfileVersion = _data["captureProfileVersion"] ? CaptureProfileVersion.fromJS(_data["captureProfileVersion"]) : undefined as any;
            this.imageBatch = _data["imageBatch"] ? ImageBatch.fromJS(_data["imageBatch"]) : undefined as any;
            this.ownerUser = _data["ownerUser"] ? Users.fromJS(_data["ownerUser"]) : undefined as any;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
            if (Array.isArray(_data["crystalCryoprotectantv4"])) {
                this.crystalCryoprotectantv4 = [] as any;
                for (let item of _data["crystalCryoprotectantv4"])
                    this.crystalCryoprotectantv4!.push(CrystalCryoprotectantv4.fromJS(item));
            }
            if (Array.isArray(_data["crystalFilesv4"])) {
                this.crystalFilesv4 = [] as any;
                for (let item of _data["crystalFilesv4"])
                    this.crystalFilesv4!.push(CrystalFilesv4.fromJS(item));
            }
            if (Array.isArray(_data["crystalSoakingv4"])) {
                this.crystalSoakingv4 = [] as any;
                for (let item of _data["crystalSoakingv4"])
                    this.crystalSoakingv4!.push(CrystalSoakingv4.fromJS(item));
            }
            if (Array.isArray(_data["crystalTripv4"])) {
                this.crystalTripv4 = [] as any;
                for (let item of _data["crystalTripv4"])
                    this.crystalTripv4!.push(CrystalTripv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Crystalv4 {
        data = typeof data === 'object' ? data : {};
        let result = new Crystalv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["captureProfileVersionId"] = this.captureProfileVersionId;
        data["imageBatchId"] = this.imageBatchId;
        data["name"] = this.name;
        data["dataCollected"] = this.dataCollected;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["dateFrozen"] = this.dateFrozen ? this.dateFrozen.toISOString() : undefined as any;
        data["ownerUserId"] = this.ownerUserId;
        data["position"] = this.position;
        data["notes"] = this.notes;
        data["dateCollected"] = this.dateCollected ? this.dateCollected.toISOString() : undefined as any;
        data["captureProfileVersion"] = this.captureProfileVersion ? this.captureProfileVersion.toJSON() : undefined as any;
        data["imageBatch"] = this.imageBatch ? this.imageBatch.toJSON() : undefined as any;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : undefined as any;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        if (Array.isArray(this.crystalCryoprotectantv4)) {
            data["crystalCryoprotectantv4"] = [];
            for (let item of this.crystalCryoprotectantv4)
                data["crystalCryoprotectantv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystalFilesv4)) {
            data["crystalFilesv4"] = [];
            for (let item of this.crystalFilesv4)
                data["crystalFilesv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystalSoakingv4)) {
            data["crystalSoakingv4"] = [];
            for (let item of this.crystalSoakingv4)
                data["crystalSoakingv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystalTripv4)) {
            data["crystalTripv4"] = [];
            for (let item of this.crystalTripv4)
                data["crystalTripv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICrystalv4 {
    id: number;
    regionId: number;
    captureProfileVersionId: number;
    imageBatchId: number;
    name?: string | undefined;
    dataCollected: boolean;
    x?: number | undefined;
    y?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    dateFrozen?: Date | undefined;
    ownerUserId: number;
    position?: number | undefined;
    notes?: string | undefined;
    dateCollected?: Date | undefined;
    captureProfileVersion?: CaptureProfileVersion | undefined;
    imageBatch?: ImageBatch | undefined;
    ownerUser?: Users | undefined;
    region?: Region | undefined;
    crystalCryoprotectantv4?: CrystalCryoprotectantv4[] | undefined;
    crystalFilesv4?: CrystalFilesv4[] | undefined;
    crystalSoakingv4?: CrystalSoakingv4[] | undefined;
    crystalTripv4?: CrystalTripv4[] | undefined;
}

export class CrystalCryoprotectantv4 implements ICrystalCryoprotectantv4 {
    id!: number;
    crystalId!: number;
    cryoprotectantId!: number;
    cryoprotectant?: Cryoprotectantv4 | undefined;
    crystal?: Crystalv4 | undefined;

    constructor(data?: ICrystalCryoprotectantv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crystalId = _data["crystalId"];
            this.cryoprotectantId = _data["cryoprotectantId"];
            this.cryoprotectant = _data["cryoprotectant"] ? Cryoprotectantv4.fromJS(_data["cryoprotectant"]) : undefined as any;
            this.crystal = _data["crystal"] ? Crystalv4.fromJS(_data["crystal"]) : undefined as any;
        }
    }

    static fromJS(data: any): CrystalCryoprotectantv4 {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalCryoprotectantv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crystalId"] = this.crystalId;
        data["cryoprotectantId"] = this.cryoprotectantId;
        data["cryoprotectant"] = this.cryoprotectant ? this.cryoprotectant.toJSON() : undefined as any;
        data["crystal"] = this.crystal ? this.crystal.toJSON() : undefined as any;
        return data;
    }
}

export interface ICrystalCryoprotectantv4 {
    id: number;
    crystalId: number;
    cryoprotectantId: number;
    cryoprotectant?: Cryoprotectantv4 | undefined;
    crystal?: Crystalv4 | undefined;
}

export class CrystalFilesv4 implements ICrystalFilesv4 {
    id!: number;
    attachedFile?: string | undefined;
    crystalId!: number;
    crystal?: Crystalv4 | undefined;

    constructor(data?: ICrystalFilesv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attachedFile = _data["attachedFile"];
            this.crystalId = _data["crystalId"];
            this.crystal = _data["crystal"] ? Crystalv4.fromJS(_data["crystal"]) : undefined as any;
        }
    }

    static fromJS(data: any): CrystalFilesv4 {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalFilesv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attachedFile"] = this.attachedFile;
        data["crystalId"] = this.crystalId;
        data["crystal"] = this.crystal ? this.crystal.toJSON() : undefined as any;
        return data;
    }
}

export interface ICrystalFilesv4 {
    id: number;
    attachedFile?: string | undefined;
    crystalId: number;
    crystal?: Crystalv4 | undefined;
}

export class CrystalSoakingv4 implements ICrystalSoakingv4 {
    id!: number;
    crystalId!: number;
    soakingId!: number;
    crystal?: Crystalv4 | undefined;
    soaking?: Soakingv4 | undefined;

    constructor(data?: ICrystalSoakingv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crystalId = _data["crystalId"];
            this.soakingId = _data["soakingId"];
            this.crystal = _data["crystal"] ? Crystalv4.fromJS(_data["crystal"]) : undefined as any;
            this.soaking = _data["soaking"] ? Soakingv4.fromJS(_data["soaking"]) : undefined as any;
        }
    }

    static fromJS(data: any): CrystalSoakingv4 {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalSoakingv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crystalId"] = this.crystalId;
        data["soakingId"] = this.soakingId;
        data["crystal"] = this.crystal ? this.crystal.toJSON() : undefined as any;
        data["soaking"] = this.soaking ? this.soaking.toJSON() : undefined as any;
        return data;
    }
}

export interface ICrystalSoakingv4 {
    id: number;
    crystalId: number;
    soakingId: number;
    crystal?: Crystalv4 | undefined;
    soaking?: Soakingv4 | undefined;
}

export class Soakingv4 implements ISoakingv4 {
    id!: number;
    ingredient?: string | undefined;
    conc!: number;
    concUnit?: string | undefined;
    time?: number | undefined;
    timeUnit?: string | undefined;
    textInfo?: string | undefined;
    userId?: number | undefined;
    user?: Users | undefined;
    crystalSoakingv4?: CrystalSoakingv4[] | undefined;

    constructor(data?: ISoakingv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredient = _data["ingredient"];
            this.conc = _data["conc"];
            this.concUnit = _data["concUnit"];
            this.time = _data["time"];
            this.timeUnit = _data["timeUnit"];
            this.textInfo = _data["textInfo"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["crystalSoakingv4"])) {
                this.crystalSoakingv4 = [] as any;
                for (let item of _data["crystalSoakingv4"])
                    this.crystalSoakingv4!.push(CrystalSoakingv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Soakingv4 {
        data = typeof data === 'object' ? data : {};
        let result = new Soakingv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredient"] = this.ingredient;
        data["conc"] = this.conc;
        data["concUnit"] = this.concUnit;
        data["time"] = this.time;
        data["timeUnit"] = this.timeUnit;
        data["textInfo"] = this.textInfo;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.crystalSoakingv4)) {
            data["crystalSoakingv4"] = [];
            for (let item of this.crystalSoakingv4)
                data["crystalSoakingv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISoakingv4 {
    id: number;
    ingredient?: string | undefined;
    conc: number;
    concUnit?: string | undefined;
    time?: number | undefined;
    timeUnit?: string | undefined;
    textInfo?: string | undefined;
    userId?: number | undefined;
    user?: Users | undefined;
    crystalSoakingv4?: CrystalSoakingv4[] | undefined;
}

export class CrystalTripv4 implements ICrystalTripv4 {
    id!: number;
    puckPinId?: number | undefined;
    synchrotronTripId?: number | undefined;
    crystalId!: number;
    crystal?: Crystalv4 | undefined;
    puckPin?: PuckPinv4 | undefined;
    synchrotronTrip?: SynchrotronTripv4 | undefined;
    crystalTripResultv4?: CrystalTripResultv4[] | undefined;

    constructor(data?: ICrystalTripv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.puckPinId = _data["puckPinId"];
            this.synchrotronTripId = _data["synchrotronTripId"];
            this.crystalId = _data["crystalId"];
            this.crystal = _data["crystal"] ? Crystalv4.fromJS(_data["crystal"]) : undefined as any;
            this.puckPin = _data["puckPin"] ? PuckPinv4.fromJS(_data["puckPin"]) : undefined as any;
            this.synchrotronTrip = _data["synchrotronTrip"] ? SynchrotronTripv4.fromJS(_data["synchrotronTrip"]) : undefined as any;
            if (Array.isArray(_data["crystalTripResultv4"])) {
                this.crystalTripResultv4 = [] as any;
                for (let item of _data["crystalTripResultv4"])
                    this.crystalTripResultv4!.push(CrystalTripResultv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CrystalTripv4 {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalTripv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["puckPinId"] = this.puckPinId;
        data["synchrotronTripId"] = this.synchrotronTripId;
        data["crystalId"] = this.crystalId;
        data["crystal"] = this.crystal ? this.crystal.toJSON() : undefined as any;
        data["puckPin"] = this.puckPin ? this.puckPin.toJSON() : undefined as any;
        data["synchrotronTrip"] = this.synchrotronTrip ? this.synchrotronTrip.toJSON() : undefined as any;
        if (Array.isArray(this.crystalTripResultv4)) {
            data["crystalTripResultv4"] = [];
            for (let item of this.crystalTripResultv4)
                data["crystalTripResultv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICrystalTripv4 {
    id: number;
    puckPinId?: number | undefined;
    synchrotronTripId?: number | undefined;
    crystalId: number;
    crystal?: Crystalv4 | undefined;
    puckPin?: PuckPinv4 | undefined;
    synchrotronTrip?: SynchrotronTripv4 | undefined;
    crystalTripResultv4?: CrystalTripResultv4[] | undefined;
}

export class PuckPinv4 implements IPuckPinv4 {
    id!: number;
    puckDewarId!: number;
    position!: number;
    puckDewar?: PuckDewarv4 | undefined;
    crystalTripv4?: CrystalTripv4[] | undefined;

    constructor(data?: IPuckPinv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.puckDewarId = _data["puckDewarId"];
            this.position = _data["position"];
            this.puckDewar = _data["puckDewar"] ? PuckDewarv4.fromJS(_data["puckDewar"]) : undefined as any;
            if (Array.isArray(_data["crystalTripv4"])) {
                this.crystalTripv4 = [] as any;
                for (let item of _data["crystalTripv4"])
                    this.crystalTripv4!.push(CrystalTripv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PuckPinv4 {
        data = typeof data === 'object' ? data : {};
        let result = new PuckPinv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["puckDewarId"] = this.puckDewarId;
        data["position"] = this.position;
        data["puckDewar"] = this.puckDewar ? this.puckDewar.toJSON() : undefined as any;
        if (Array.isArray(this.crystalTripv4)) {
            data["crystalTripv4"] = [];
            for (let item of this.crystalTripv4)
                data["crystalTripv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPuckPinv4 {
    id: number;
    puckDewarId: number;
    position: number;
    puckDewar?: PuckDewarv4 | undefined;
    crystalTripv4?: CrystalTripv4[] | undefined;
}

export class PuckDewarv4 implements IPuckDewarv4 {
    id!: number;
    dewarId?: number | undefined;
    puckId!: number;
    dewar?: Dewarv4 | undefined;
    puck?: Puckv4 | undefined;
    puckPinv4?: PuckPinv4[] | undefined;

    constructor(data?: IPuckDewarv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dewarId = _data["dewarId"];
            this.puckId = _data["puckId"];
            this.dewar = _data["dewar"] ? Dewarv4.fromJS(_data["dewar"]) : undefined as any;
            this.puck = _data["puck"] ? Puckv4.fromJS(_data["puck"]) : undefined as any;
            if (Array.isArray(_data["puckPinv4"])) {
                this.puckPinv4 = [] as any;
                for (let item of _data["puckPinv4"])
                    this.puckPinv4!.push(PuckPinv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PuckDewarv4 {
        data = typeof data === 'object' ? data : {};
        let result = new PuckDewarv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dewarId"] = this.dewarId;
        data["puckId"] = this.puckId;
        data["dewar"] = this.dewar ? this.dewar.toJSON() : undefined as any;
        data["puck"] = this.puck ? this.puck.toJSON() : undefined as any;
        if (Array.isArray(this.puckPinv4)) {
            data["puckPinv4"] = [];
            for (let item of this.puckPinv4)
                data["puckPinv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPuckDewarv4 {
    id: number;
    dewarId?: number | undefined;
    puckId: number;
    dewar?: Dewarv4 | undefined;
    puck?: Puckv4 | undefined;
    puckPinv4?: PuckPinv4[] | undefined;
}

export class Dewarv4 implements IDewarv4 {
    id!: number;
    name?: string | undefined;
    puckCount!: number;
    enable?: boolean | undefined;
    puckDewarv4?: PuckDewarv4[] | undefined;
    tripDewarv4?: TripDewarv4[] | undefined;

    constructor(data?: IDewarv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.puckCount = _data["puckCount"];
            this.enable = _data["enable"];
            if (Array.isArray(_data["puckDewarv4"])) {
                this.puckDewarv4 = [] as any;
                for (let item of _data["puckDewarv4"])
                    this.puckDewarv4!.push(PuckDewarv4.fromJS(item));
            }
            if (Array.isArray(_data["tripDewarv4"])) {
                this.tripDewarv4 = [] as any;
                for (let item of _data["tripDewarv4"])
                    this.tripDewarv4!.push(TripDewarv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dewarv4 {
        data = typeof data === 'object' ? data : {};
        let result = new Dewarv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["puckCount"] = this.puckCount;
        data["enable"] = this.enable;
        if (Array.isArray(this.puckDewarv4)) {
            data["puckDewarv4"] = [];
            for (let item of this.puckDewarv4)
                data["puckDewarv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tripDewarv4)) {
            data["tripDewarv4"] = [];
            for (let item of this.tripDewarv4)
                data["tripDewarv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDewarv4 {
    id: number;
    name?: string | undefined;
    puckCount: number;
    enable?: boolean | undefined;
    puckDewarv4?: PuckDewarv4[] | undefined;
    tripDewarv4?: TripDewarv4[] | undefined;
}

export class TripDewarv4 implements ITripDewarv4 {
    id!: number;
    synchrotronTripId!: number;
    dewarId!: number;
    dewar?: Dewarv4 | undefined;
    synchrotronTrip?: SynchrotronTripv4 | undefined;

    constructor(data?: ITripDewarv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.synchrotronTripId = _data["synchrotronTripId"];
            this.dewarId = _data["dewarId"];
            this.dewar = _data["dewar"] ? Dewarv4.fromJS(_data["dewar"]) : undefined as any;
            this.synchrotronTrip = _data["synchrotronTrip"] ? SynchrotronTripv4.fromJS(_data["synchrotronTrip"]) : undefined as any;
        }
    }

    static fromJS(data: any): TripDewarv4 {
        data = typeof data === 'object' ? data : {};
        let result = new TripDewarv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["synchrotronTripId"] = this.synchrotronTripId;
        data["dewarId"] = this.dewarId;
        data["dewar"] = this.dewar ? this.dewar.toJSON() : undefined as any;
        data["synchrotronTrip"] = this.synchrotronTrip ? this.synchrotronTrip.toJSON() : undefined as any;
        return data;
    }
}

export interface ITripDewarv4 {
    id: number;
    synchrotronTripId: number;
    dewarId: number;
    dewar?: Dewarv4 | undefined;
    synchrotronTrip?: SynchrotronTripv4 | undefined;
}

export class SynchrotronTripv4 implements ISynchrotronTripv4 {
    id!: number;
    treeNodeId!: number;
    dataCollectionDate!: Date;
    beamline?: string | undefined;
    detectorType?: string | undefined;
    contactPerson?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    treeNode?: TreeNode | undefined;
    crystalTripv4?: CrystalTripv4[] | undefined;
    tripDewarv4?: TripDewarv4[] | undefined;

    constructor(data?: ISynchrotronTripv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.dataCollectionDate = _data["dataCollectionDate"] ? new Date(_data["dataCollectionDate"].toString()) : undefined as any;
            this.beamline = _data["beamline"];
            this.detectorType = _data["detectorType"];
            this.contactPerson = _data["contactPerson"];
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            if (Array.isArray(_data["crystalTripv4"])) {
                this.crystalTripv4 = [] as any;
                for (let item of _data["crystalTripv4"])
                    this.crystalTripv4!.push(CrystalTripv4.fromJS(item));
            }
            if (Array.isArray(_data["tripDewarv4"])) {
                this.tripDewarv4 = [] as any;
                for (let item of _data["tripDewarv4"])
                    this.tripDewarv4!.push(TripDewarv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SynchrotronTripv4 {
        data = typeof data === 'object' ? data : {};
        let result = new SynchrotronTripv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["dataCollectionDate"] = this.dataCollectionDate ? this.dataCollectionDate.toISOString() : undefined as any;
        data["beamline"] = this.beamline;
        data["detectorType"] = this.detectorType;
        data["contactPerson"] = this.contactPerson;
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        if (Array.isArray(this.crystalTripv4)) {
            data["crystalTripv4"] = [];
            for (let item of this.crystalTripv4)
                data["crystalTripv4"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tripDewarv4)) {
            data["tripDewarv4"] = [];
            for (let item of this.tripDewarv4)
                data["tripDewarv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISynchrotronTripv4 {
    id: number;
    treeNodeId: number;
    dataCollectionDate: Date;
    beamline?: string | undefined;
    detectorType?: string | undefined;
    contactPerson?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    treeNode?: TreeNode | undefined;
    crystalTripv4?: CrystalTripv4[] | undefined;
    tripDewarv4?: TripDewarv4[] | undefined;
}

export class Puckv4 implements IPuckv4 {
    id!: number;
    puckTypeId!: number;
    name?: string | undefined;
    barcode?: string | undefined;
    enable?: boolean | undefined;
    puckType?: PuckTypev4 | undefined;
    puckDewarv4?: PuckDewarv4[] | undefined;

    constructor(data?: IPuckv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.puckTypeId = _data["puckTypeId"];
            this.name = _data["name"];
            this.barcode = _data["barcode"];
            this.enable = _data["enable"];
            this.puckType = _data["puckType"] ? PuckTypev4.fromJS(_data["puckType"]) : undefined as any;
            if (Array.isArray(_data["puckDewarv4"])) {
                this.puckDewarv4 = [] as any;
                for (let item of _data["puckDewarv4"])
                    this.puckDewarv4!.push(PuckDewarv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Puckv4 {
        data = typeof data === 'object' ? data : {};
        let result = new Puckv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["puckTypeId"] = this.puckTypeId;
        data["name"] = this.name;
        data["barcode"] = this.barcode;
        data["enable"] = this.enable;
        data["puckType"] = this.puckType ? this.puckType.toJSON() : undefined as any;
        if (Array.isArray(this.puckDewarv4)) {
            data["puckDewarv4"] = [];
            for (let item of this.puckDewarv4)
                data["puckDewarv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPuckv4 {
    id: number;
    puckTypeId: number;
    name?: string | undefined;
    barcode?: string | undefined;
    enable?: boolean | undefined;
    puckType?: PuckTypev4 | undefined;
    puckDewarv4?: PuckDewarv4[] | undefined;
}

export class PuckTypev4 implements IPuckTypev4 {
    id!: number;
    name?: string | undefined;
    pinCount!: number;
    puckv4?: Puckv4[] | undefined;

    constructor(data?: IPuckTypev4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pinCount = _data["pinCount"];
            if (Array.isArray(_data["puckv4"])) {
                this.puckv4 = [] as any;
                for (let item of _data["puckv4"])
                    this.puckv4!.push(Puckv4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PuckTypev4 {
        data = typeof data === 'object' ? data : {};
        let result = new PuckTypev4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pinCount"] = this.pinCount;
        if (Array.isArray(this.puckv4)) {
            data["puckv4"] = [];
            for (let item of this.puckv4)
                data["puckv4"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPuckTypev4 {
    id: number;
    name?: string | undefined;
    pinCount: number;
    puckv4?: Puckv4[] | undefined;
}

export class CrystalTripResultv4 implements ICrystalTripResultv4 {
    id!: number;
    crystalTripId!: number;
    crystalNameInternal?: string | undefined;
    symm?: string | undefined;
    xtalRun?: string | undefined;
    resoLow?: string | undefined;
    hiShells?: string | undefined;
    cellA?: string | undefined;
    cellB?: string | undefined;
    cellC?: string | undefined;
    cellAlpha?: string | undefined;
    cellBeta?: string | undefined;
    cellGamma?: string | undefined;
    raddamRfree?: string | undefined;
    e21?: string | undefined;
    compEll?: string | undefined;
    compSph?: string | undefined;
    rmeas?: string | undefined;
    foFc?: string | undefined;
    cc12?: string | undefined;
    multiplicity?: string | undefined;
    isigma?: string | undefined;
    refinementProgram?: string | undefined;
    resultNotes?: string | undefined;
    resultStatus!: number;
    crystalTrip?: CrystalTripv4 | undefined;

    constructor(data?: ICrystalTripResultv4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crystalTripId = _data["crystalTripId"];
            this.crystalNameInternal = _data["crystalNameInternal"];
            this.symm = _data["symm"];
            this.xtalRun = _data["xtalRun"];
            this.resoLow = _data["resoLow"];
            this.hiShells = _data["hiShells"];
            this.cellA = _data["cellA"];
            this.cellB = _data["cellB"];
            this.cellC = _data["cellC"];
            this.cellAlpha = _data["cellAlpha"];
            this.cellBeta = _data["cellBeta"];
            this.cellGamma = _data["cellGamma"];
            this.raddamRfree = _data["raddamRfree"];
            this.e21 = _data["e21"];
            this.compEll = _data["compEll"];
            this.compSph = _data["compSph"];
            this.rmeas = _data["rmeas"];
            this.foFc = _data["foFc"];
            this.cc12 = _data["cc12"];
            this.multiplicity = _data["multiplicity"];
            this.isigma = _data["isigma"];
            this.refinementProgram = _data["refinementProgram"];
            this.resultNotes = _data["resultNotes"];
            this.resultStatus = _data["resultStatus"];
            this.crystalTrip = _data["crystalTrip"] ? CrystalTripv4.fromJS(_data["crystalTrip"]) : undefined as any;
        }
    }

    static fromJS(data: any): CrystalTripResultv4 {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalTripResultv4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crystalTripId"] = this.crystalTripId;
        data["crystalNameInternal"] = this.crystalNameInternal;
        data["symm"] = this.symm;
        data["xtalRun"] = this.xtalRun;
        data["resoLow"] = this.resoLow;
        data["hiShells"] = this.hiShells;
        data["cellA"] = this.cellA;
        data["cellB"] = this.cellB;
        data["cellC"] = this.cellC;
        data["cellAlpha"] = this.cellAlpha;
        data["cellBeta"] = this.cellBeta;
        data["cellGamma"] = this.cellGamma;
        data["raddamRfree"] = this.raddamRfree;
        data["e21"] = this.e21;
        data["compEll"] = this.compEll;
        data["compSph"] = this.compSph;
        data["rmeas"] = this.rmeas;
        data["foFc"] = this.foFc;
        data["cc12"] = this.cc12;
        data["multiplicity"] = this.multiplicity;
        data["isigma"] = this.isigma;
        data["refinementProgram"] = this.refinementProgram;
        data["resultNotes"] = this.resultNotes;
        data["resultStatus"] = this.resultStatus;
        data["crystalTrip"] = this.crystalTrip ? this.crystalTrip.toJSON() : undefined as any;
        return data;
    }
}

export interface ICrystalTripResultv4 {
    id: number;
    crystalTripId: number;
    crystalNameInternal?: string | undefined;
    symm?: string | undefined;
    xtalRun?: string | undefined;
    resoLow?: string | undefined;
    hiShells?: string | undefined;
    cellA?: string | undefined;
    cellB?: string | undefined;
    cellC?: string | undefined;
    cellAlpha?: string | undefined;
    cellBeta?: string | undefined;
    cellGamma?: string | undefined;
    raddamRfree?: string | undefined;
    e21?: string | undefined;
    compEll?: string | undefined;
    compSph?: string | undefined;
    rmeas?: string | undefined;
    foFc?: string | undefined;
    cc12?: string | undefined;
    multiplicity?: string | undefined;
    isigma?: string | undefined;
    refinementProgram?: string | undefined;
    resultNotes?: string | undefined;
    resultStatus: number;
    crystalTrip?: CrystalTripv4 | undefined;
}

export class RegionAnnotation implements IRegionAnnotation {
    id!: number;
    regionId!: number;
    regionAnnotationTypeId!: number;
    expanded!: boolean;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    font?: string | undefined;
    text?: string | undefined;
    region?: Region | undefined;
    regionAnnotationType?: RegionAnnotationType | undefined;

    constructor(data?: IRegionAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.regionAnnotationTypeId = _data["regionAnnotationTypeId"];
            this.expanded = _data["expanded"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.font = _data["font"];
            this.text = _data["text"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
            this.regionAnnotationType = _data["regionAnnotationType"] ? RegionAnnotationType.fromJS(_data["regionAnnotationType"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegionAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new RegionAnnotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["regionAnnotationTypeId"] = this.regionAnnotationTypeId;
        data["expanded"] = this.expanded;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["font"] = this.font;
        data["text"] = this.text;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        data["regionAnnotationType"] = this.regionAnnotationType ? this.regionAnnotationType.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegionAnnotation {
    id: number;
    regionId: number;
    regionAnnotationTypeId: number;
    expanded: boolean;
    x: number;
    y: number;
    width: number;
    height: number;
    font?: string | undefined;
    text?: string | undefined;
    region?: Region | undefined;
    regionAnnotationType?: RegionAnnotationType | undefined;
}

export class RegionAnnotationType implements IRegionAnnotationType {
    id!: number;
    name?: string | undefined;
    textArgb!: number;
    backgroundArgb!: number;
    icon?: string | undefined;
    regionAnnotation?: RegionAnnotation[] | undefined;

    constructor(data?: IRegionAnnotationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.textArgb = _data["textArgb"];
            this.backgroundArgb = _data["backgroundArgb"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["regionAnnotation"])) {
                this.regionAnnotation = [] as any;
                for (let item of _data["regionAnnotation"])
                    this.regionAnnotation!.push(RegionAnnotation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegionAnnotationType {
        data = typeof data === 'object' ? data : {};
        let result = new RegionAnnotationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["textArgb"] = this.textArgb;
        data["backgroundArgb"] = this.backgroundArgb;
        data["icon"] = this.icon;
        if (Array.isArray(this.regionAnnotation)) {
            data["regionAnnotation"] = [];
            for (let item of this.regionAnnotation)
                data["regionAnnotation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegionAnnotationType {
    id: number;
    name?: string | undefined;
    textArgb: number;
    backgroundArgb: number;
    icon?: string | undefined;
    regionAnnotation?: RegionAnnotation[] | undefined;
}

export class RegionPoint implements IRegionPoint {
    id!: number;
    regionId!: number;
    pointName?: string | undefined;
    x!: number;
    y!: number;
    color?: number | undefined;
    region?: Region | undefined;

    constructor(data?: IRegionPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.pointName = _data["pointName"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.color = _data["color"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegionPoint {
        data = typeof data === 'object' ? data : {};
        let result = new RegionPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["pointName"] = this.pointName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["color"] = this.color;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegionPoint {
    id: number;
    regionId: number;
    pointName?: string | undefined;
    x: number;
    y: number;
    color?: number | undefined;
    region?: Region | undefined;
}

export class RegionProperty implements IRegionProperty {
    id!: number;
    regionId!: number;
    name?: string | undefined;
    value?: string | undefined;
    region?: Region | undefined;

    constructor(data?: IRegionProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegionProperty {
        data = typeof data === 'object' ? data : {};
        let result = new RegionProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegionProperty {
    id: number;
    regionId: number;
    name?: string | undefined;
    value?: string | undefined;
    region?: Region | undefined;
}

export class RegionRuler implements IRegionRuler {
    id!: number;
    regionId!: number;
    argb!: number;
    x1!: number;
    y1!: number;
    x2!: number;
    y2!: number;
    region?: Region | undefined;

    constructor(data?: IRegionRuler) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.argb = _data["argb"];
            this.x1 = _data["x1"];
            this.y1 = _data["y1"];
            this.x2 = _data["x2"];
            this.y2 = _data["y2"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegionRuler {
        data = typeof data === 'object' ? data : {};
        let result = new RegionRuler();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["argb"] = this.argb;
        data["x1"] = this.x1;
        data["y1"] = this.y1;
        data["x2"] = this.x2;
        data["y2"] = this.y2;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegionRuler {
    id: number;
    regionId: number;
    argb: number;
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    region?: Region | undefined;
}

export class RegionScribble implements IRegionScribble {
    id!: number;
    regionId!: number;
    argb!: number;
    xstart!: number;
    ystart!: number;
    region?: Region | undefined;
    regionScribblePoint?: RegionScribblePoint[] | undefined;

    constructor(data?: IRegionScribble) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.argb = _data["argb"];
            this.xstart = _data["xstart"];
            this.ystart = _data["ystart"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined as any;
            if (Array.isArray(_data["regionScribblePoint"])) {
                this.regionScribblePoint = [] as any;
                for (let item of _data["regionScribblePoint"])
                    this.regionScribblePoint!.push(RegionScribblePoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegionScribble {
        data = typeof data === 'object' ? data : {};
        let result = new RegionScribble();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["argb"] = this.argb;
        data["xstart"] = this.xstart;
        data["ystart"] = this.ystart;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        if (Array.isArray(this.regionScribblePoint)) {
            data["regionScribblePoint"] = [];
            for (let item of this.regionScribblePoint)
                data["regionScribblePoint"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegionScribble {
    id: number;
    regionId: number;
    argb: number;
    xstart: number;
    ystart: number;
    region?: Region | undefined;
    regionScribblePoint?: RegionScribblePoint[] | undefined;
}

export class RegionScribblePoint implements IRegionScribblePoint {
    id!: number;
    regionScribbleId!: number;
    pointIndex!: number;
    xoffset!: number;
    yoffset!: number;
    regionScribble?: RegionScribble | undefined;

    constructor(data?: IRegionScribblePoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionScribbleId = _data["regionScribbleId"];
            this.pointIndex = _data["pointIndex"];
            this.xoffset = _data["xoffset"];
            this.yoffset = _data["yoffset"];
            this.regionScribble = _data["regionScribble"] ? RegionScribble.fromJS(_data["regionScribble"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegionScribblePoint {
        data = typeof data === 'object' ? data : {};
        let result = new RegionScribblePoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionScribbleId"] = this.regionScribbleId;
        data["pointIndex"] = this.pointIndex;
        data["xoffset"] = this.xoffset;
        data["yoffset"] = this.yoffset;
        data["regionScribble"] = this.regionScribble ? this.regionScribble.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegionScribblePoint {
    id: number;
    regionScribbleId: number;
    pointIndex: number;
    xoffset: number;
    yoffset: number;
    regionScribble?: RegionScribble | undefined;
}

export class MorphologyDetail implements IMorphologyDetail {
    id!: number;
    imageBatchWellDropScoreId!: number;
    item?: string | undefined;
    value?: string | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore | undefined;

    constructor(data?: IMorphologyDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageBatchWellDropScoreId = _data["imageBatchWellDropScoreId"];
            this.item = _data["item"];
            this.value = _data["value"];
            this.imageBatchWellDropScore = _data["imageBatchWellDropScore"] ? ImageBatchWellDropScore.fromJS(_data["imageBatchWellDropScore"]) : undefined as any;
        }
    }

    static fromJS(data: any): MorphologyDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MorphologyDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageBatchWellDropScoreId"] = this.imageBatchWellDropScoreId;
        data["item"] = this.item;
        data["value"] = this.value;
        data["imageBatchWellDropScore"] = this.imageBatchWellDropScore ? this.imageBatchWellDropScore.toJSON() : undefined as any;
        return data;
    }
}

export interface IMorphologyDetail {
    id: number;
    imageBatchWellDropScoreId: number;
    item?: string | undefined;
    value?: string | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore | undefined;
}

export class ScoreDetail implements IScoreDetail {
    id!: number;
    imageBatchWellDropScoreId!: number;
    item?: string | undefined;
    value?: string | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore | undefined;

    constructor(data?: IScoreDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageBatchWellDropScoreId = _data["imageBatchWellDropScoreId"];
            this.item = _data["item"];
            this.value = _data["value"];
            this.imageBatchWellDropScore = _data["imageBatchWellDropScore"] ? ImageBatchWellDropScore.fromJS(_data["imageBatchWellDropScore"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScoreDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageBatchWellDropScoreId"] = this.imageBatchWellDropScoreId;
        data["item"] = this.item;
        data["value"] = this.value;
        data["imageBatchWellDropScore"] = this.imageBatchWellDropScore ? this.imageBatchWellDropScore.toJSON() : undefined as any;
        return data;
    }
}

export interface IScoreDetail {
    id: number;
    imageBatchWellDropScoreId: number;
    item?: string | undefined;
    value?: string | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore | undefined;
}

export class UltravioletDetail implements IUltravioletDetail {
    id!: number;
    imageBatchWellDropScoreId!: number;
    item?: string | undefined;
    value?: string | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore | undefined;

    constructor(data?: IUltravioletDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageBatchWellDropScoreId = _data["imageBatchWellDropScoreId"];
            this.item = _data["item"];
            this.value = _data["value"];
            this.imageBatchWellDropScore = _data["imageBatchWellDropScore"] ? ImageBatchWellDropScore.fromJS(_data["imageBatchWellDropScore"]) : undefined as any;
        }
    }

    static fromJS(data: any): UltravioletDetail {
        data = typeof data === 'object' ? data : {};
        let result = new UltravioletDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageBatchWellDropScoreId"] = this.imageBatchWellDropScoreId;
        data["item"] = this.item;
        data["value"] = this.value;
        data["imageBatchWellDropScore"] = this.imageBatchWellDropScore ? this.imageBatchWellDropScore.toJSON() : undefined as any;
        return data;
    }
}

export interface IUltravioletDetail {
    id: number;
    imageBatchWellDropScoreId: number;
    item?: string | undefined;
    value?: string | undefined;
    imageBatchWellDropScore?: ImageBatchWellDropScore | undefined;
}

export class ImagingTaskWellDrop implements IImagingTaskWellDrop {
    id!: number;
    imagingTaskId!: number;
    wellDropId!: number;
    imagingTask?: ImagingTask | undefined;
    wellDrop?: WellDrop | undefined;

    constructor(data?: IImagingTaskWellDrop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imagingTaskId = _data["imagingTaskId"];
            this.wellDropId = _data["wellDropId"];
            this.imagingTask = _data["imagingTask"] ? ImagingTask.fromJS(_data["imagingTask"]) : undefined as any;
            this.wellDrop = _data["wellDrop"] ? WellDrop.fromJS(_data["wellDrop"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImagingTaskWellDrop {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingTaskWellDrop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imagingTaskId"] = this.imagingTaskId;
        data["wellDropId"] = this.wellDropId;
        data["imagingTask"] = this.imagingTask ? this.imagingTask.toJSON() : undefined as any;
        data["wellDrop"] = this.wellDrop ? this.wellDrop.toJSON() : undefined as any;
        return data;
    }
}

export interface IImagingTaskWellDrop {
    id: number;
    imagingTaskId: number;
    wellDropId: number;
    imagingTask?: ImagingTask | undefined;
    wellDrop?: WellDrop | undefined;
}

export class WellDropLayer implements IWellDropLayer {
    id!: number;
    wellDropId!: number;
    layerId!: number;
    volume!: number;
    waterVolume!: number;
    sourceWellId?: number | undefined;
    waterSource?: string | undefined;
    layer?: Layer | undefined;
    wellDrop?: WellDrop | undefined;
    wellDropLayerFragment?: WellDropLayerFragment[] | undefined;
    wellDropLayerIngredient?: WellDropLayerIngredient[] | undefined;

    constructor(data?: IWellDropLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDropId = _data["wellDropId"];
            this.layerId = _data["layerId"];
            this.volume = _data["volume"];
            this.waterVolume = _data["waterVolume"];
            this.sourceWellId = _data["sourceWellId"];
            this.waterSource = _data["waterSource"];
            this.layer = _data["layer"] ? Layer.fromJS(_data["layer"]) : undefined as any;
            this.wellDrop = _data["wellDrop"] ? WellDrop.fromJS(_data["wellDrop"]) : undefined as any;
            if (Array.isArray(_data["wellDropLayerFragment"])) {
                this.wellDropLayerFragment = [] as any;
                for (let item of _data["wellDropLayerFragment"])
                    this.wellDropLayerFragment!.push(WellDropLayerFragment.fromJS(item));
            }
            if (Array.isArray(_data["wellDropLayerIngredient"])) {
                this.wellDropLayerIngredient = [] as any;
                for (let item of _data["wellDropLayerIngredient"])
                    this.wellDropLayerIngredient!.push(WellDropLayerIngredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WellDropLayer {
        data = typeof data === 'object' ? data : {};
        let result = new WellDropLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDropId"] = this.wellDropId;
        data["layerId"] = this.layerId;
        data["volume"] = this.volume;
        data["waterVolume"] = this.waterVolume;
        data["sourceWellId"] = this.sourceWellId;
        data["waterSource"] = this.waterSource;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        data["wellDrop"] = this.wellDrop ? this.wellDrop.toJSON() : undefined as any;
        if (Array.isArray(this.wellDropLayerFragment)) {
            data["wellDropLayerFragment"] = [];
            for (let item of this.wellDropLayerFragment)
                data["wellDropLayerFragment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDropLayerIngredient)) {
            data["wellDropLayerIngredient"] = [];
            for (let item of this.wellDropLayerIngredient)
                data["wellDropLayerIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWellDropLayer {
    id: number;
    wellDropId: number;
    layerId: number;
    volume: number;
    waterVolume: number;
    sourceWellId?: number | undefined;
    waterSource?: string | undefined;
    layer?: Layer | undefined;
    wellDrop?: WellDrop | undefined;
    wellDropLayerFragment?: WellDropLayerFragment[] | undefined;
    wellDropLayerIngredient?: WellDropLayerIngredient[] | undefined;
}

export class WellDropLayerFragment implements IWellDropLayerFragment {
    id!: number;
    wellDropLayerId!: number;
    fragmentId!: number;
    concentration!: number;
    source?: string | undefined;
    fragment?: Fragment | undefined;
    wellDropLayer?: WellDropLayer | undefined;

    constructor(data?: IWellDropLayerFragment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDropLayerId = _data["wellDropLayerId"];
            this.fragmentId = _data["fragmentId"];
            this.concentration = _data["concentration"];
            this.source = _data["source"];
            this.fragment = _data["fragment"] ? Fragment.fromJS(_data["fragment"]) : undefined as any;
            this.wellDropLayer = _data["wellDropLayer"] ? WellDropLayer.fromJS(_data["wellDropLayer"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellDropLayerFragment {
        data = typeof data === 'object' ? data : {};
        let result = new WellDropLayerFragment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDropLayerId"] = this.wellDropLayerId;
        data["fragmentId"] = this.fragmentId;
        data["concentration"] = this.concentration;
        data["source"] = this.source;
        data["fragment"] = this.fragment ? this.fragment.toJSON() : undefined as any;
        data["wellDropLayer"] = this.wellDropLayer ? this.wellDropLayer.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellDropLayerFragment {
    id: number;
    wellDropLayerId: number;
    fragmentId: number;
    concentration: number;
    source?: string | undefined;
    fragment?: Fragment | undefined;
    wellDropLayer?: WellDropLayer | undefined;
}

export class Fragment implements IFragment {
    id!: number;
    name?: string | undefined;
    fragmentTypeId!: number;
    size!: number;
    stockConcentration!: number;
    lowConcentration?: number | undefined;
    highConcentration?: number | undefined;
    concentrationUnits?: string | undefined;
    fragmentType?: FragmentType | undefined;
    fragmentFragmentScreen?: FragmentFragmentScreen[] | undefined;
    wellDropLayerFragment?: WellDropLayerFragment[] | undefined;

    constructor(data?: IFragment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fragmentTypeId = _data["fragmentTypeId"];
            this.size = _data["size"];
            this.stockConcentration = _data["stockConcentration"];
            this.lowConcentration = _data["lowConcentration"];
            this.highConcentration = _data["highConcentration"];
            this.concentrationUnits = _data["concentrationUnits"];
            this.fragmentType = _data["fragmentType"] ? FragmentType.fromJS(_data["fragmentType"]) : undefined as any;
            if (Array.isArray(_data["fragmentFragmentScreen"])) {
                this.fragmentFragmentScreen = [] as any;
                for (let item of _data["fragmentFragmentScreen"])
                    this.fragmentFragmentScreen!.push(FragmentFragmentScreen.fromJS(item));
            }
            if (Array.isArray(_data["wellDropLayerFragment"])) {
                this.wellDropLayerFragment = [] as any;
                for (let item of _data["wellDropLayerFragment"])
                    this.wellDropLayerFragment!.push(WellDropLayerFragment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Fragment {
        data = typeof data === 'object' ? data : {};
        let result = new Fragment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fragmentTypeId"] = this.fragmentTypeId;
        data["size"] = this.size;
        data["stockConcentration"] = this.stockConcentration;
        data["lowConcentration"] = this.lowConcentration;
        data["highConcentration"] = this.highConcentration;
        data["concentrationUnits"] = this.concentrationUnits;
        data["fragmentType"] = this.fragmentType ? this.fragmentType.toJSON() : undefined as any;
        if (Array.isArray(this.fragmentFragmentScreen)) {
            data["fragmentFragmentScreen"] = [];
            for (let item of this.fragmentFragmentScreen)
                data["fragmentFragmentScreen"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellDropLayerFragment)) {
            data["wellDropLayerFragment"] = [];
            for (let item of this.wellDropLayerFragment)
                data["wellDropLayerFragment"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFragment {
    id: number;
    name?: string | undefined;
    fragmentTypeId: number;
    size: number;
    stockConcentration: number;
    lowConcentration?: number | undefined;
    highConcentration?: number | undefined;
    concentrationUnits?: string | undefined;
    fragmentType?: FragmentType | undefined;
    fragmentFragmentScreen?: FragmentFragmentScreen[] | undefined;
    wellDropLayerFragment?: WellDropLayerFragment[] | undefined;
}

export class FragmentType implements IFragmentType {
    id!: number;
    name?: string | undefined;
    fragment?: Fragment[] | undefined;

    constructor(data?: IFragmentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["fragment"])) {
                this.fragment = [] as any;
                for (let item of _data["fragment"])
                    this.fragment!.push(Fragment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FragmentType {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.fragment)) {
            data["fragment"] = [];
            for (let item of this.fragment)
                data["fragment"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFragmentType {
    id: number;
    name?: string | undefined;
    fragment?: Fragment[] | undefined;
}

export class FragmentFragmentScreen implements IFragmentFragmentScreen {
    id!: number;
    fragmentScreenId!: number;
    fragmentId!: number;
    concentration!: number;
    conditionNumber!: number;
    notes?: string | undefined;
    fragment?: Fragment | undefined;
    fragmentScreen?: FragmentScreen | undefined;

    constructor(data?: IFragmentFragmentScreen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fragmentScreenId = _data["fragmentScreenId"];
            this.fragmentId = _data["fragmentId"];
            this.concentration = _data["concentration"];
            this.conditionNumber = _data["conditionNumber"];
            this.notes = _data["notes"];
            this.fragment = _data["fragment"] ? Fragment.fromJS(_data["fragment"]) : undefined as any;
            this.fragmentScreen = _data["fragmentScreen"] ? FragmentScreen.fromJS(_data["fragmentScreen"]) : undefined as any;
        }
    }

    static fromJS(data: any): FragmentFragmentScreen {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentFragmentScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fragmentScreenId"] = this.fragmentScreenId;
        data["fragmentId"] = this.fragmentId;
        data["concentration"] = this.concentration;
        data["conditionNumber"] = this.conditionNumber;
        data["notes"] = this.notes;
        data["fragment"] = this.fragment ? this.fragment.toJSON() : undefined as any;
        data["fragmentScreen"] = this.fragmentScreen ? this.fragmentScreen.toJSON() : undefined as any;
        return data;
    }
}

export interface IFragmentFragmentScreen {
    id: number;
    fragmentScreenId: number;
    fragmentId: number;
    concentration: number;
    conditionNumber: number;
    notes?: string | undefined;
    fragment?: Fragment | undefined;
    fragmentScreen?: FragmentScreen | undefined;
}

export class WellDropLayerIngredient implements IWellDropLayerIngredient {
    id!: number;
    wellDropLayerId!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    concentration!: number;
    preMixedConcentration!: number;
    volume!: number;
    ph?: number | undefined;
    lowPhvolume?: number | undefined;
    highPhvolume?: number | undefined;
    source?: string | undefined;
    highPhsource?: string | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    wellDropLayer?: WellDropLayer | undefined;

    constructor(data?: IWellDropLayerIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDropLayerId = _data["wellDropLayerId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.concentration = _data["concentration"];
            this.preMixedConcentration = _data["preMixedConcentration"];
            this.volume = _data["volume"];
            this.ph = _data["ph"];
            this.lowPhvolume = _data["lowPhvolume"];
            this.highPhvolume = _data["highPhvolume"];
            this.source = _data["source"];
            this.highPhsource = _data["highPhsource"];
            this.highPhingredientStock = _data["highPhingredientStock"] ? IngredientStock.fromJS(_data["highPhingredientStock"]) : undefined as any;
            this.ingredientIngredientType = _data["ingredientIngredientType"] ? IngredientIngredientType.fromJS(_data["ingredientIngredientType"]) : undefined as any;
            this.ingredientStock = _data["ingredientStock"] ? IngredientStock.fromJS(_data["ingredientStock"]) : undefined as any;
            this.wellDropLayer = _data["wellDropLayer"] ? WellDropLayer.fromJS(_data["wellDropLayer"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellDropLayerIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new WellDropLayerIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDropLayerId"] = this.wellDropLayerId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["concentration"] = this.concentration;
        data["preMixedConcentration"] = this.preMixedConcentration;
        data["volume"] = this.volume;
        data["ph"] = this.ph;
        data["lowPhvolume"] = this.lowPhvolume;
        data["highPhvolume"] = this.highPhvolume;
        data["source"] = this.source;
        data["highPhsource"] = this.highPhsource;
        data["highPhingredientStock"] = this.highPhingredientStock ? this.highPhingredientStock.toJSON() : undefined as any;
        data["ingredientIngredientType"] = this.ingredientIngredientType ? this.ingredientIngredientType.toJSON() : undefined as any;
        data["ingredientStock"] = this.ingredientStock ? this.ingredientStock.toJSON() : undefined as any;
        data["wellDropLayer"] = this.wellDropLayer ? this.wellDropLayer.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellDropLayerIngredient {
    id: number;
    wellDropLayerId: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    concentration: number;
    preMixedConcentration: number;
    volume: number;
    ph?: number | undefined;
    lowPhvolume?: number | undefined;
    highPhvolume?: number | undefined;
    source?: string | undefined;
    highPhsource?: string | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    wellDropLayer?: WellDropLayer | undefined;
}

export class WellDropProteinFormulation implements IWellDropProteinFormulation {
    id!: number;
    wellDropId!: number;
    proteinFormulationId!: number;
    wellDrop?: WellDrop | undefined;
    proteinFormulation?: ProteinFormulation | undefined;

    constructor(data?: IWellDropProteinFormulation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDropId = _data["wellDropId"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.wellDrop = _data["wellDrop"] ? WellDrop.fromJS(_data["wellDrop"]) : undefined as any;
            this.proteinFormulation = _data["proteinFormulation"] ? ProteinFormulation.fromJS(_data["proteinFormulation"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellDropProteinFormulation {
        data = typeof data === 'object' ? data : {};
        let result = new WellDropProteinFormulation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDropId"] = this.wellDropId;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["wellDrop"] = this.wellDrop ? this.wellDrop.toJSON() : undefined as any;
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellDropProteinFormulation {
    id: number;
    wellDropId: number;
    proteinFormulationId: number;
    wellDrop?: WellDrop | undefined;
    proteinFormulation?: ProteinFormulation | undefined;
}

export class SeedSeedLayer implements ISeedSeedLayer {
    id!: number;
    seedLayerId?: number | undefined;
    seedId?: number | undefined;
    startSeedDropVolume?: number | undefined;
    stopSeedDropVolume?: number | undefined;
    seedDropVolumeVaryAlong?: number | undefined;
    seed?: Seed | undefined;
    seedLayer?: SeedLayer | undefined;

    constructor(data?: ISeedSeedLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seedLayerId = _data["seedLayerId"];
            this.seedId = _data["seedId"];
            this.startSeedDropVolume = _data["startSeedDropVolume"];
            this.stopSeedDropVolume = _data["stopSeedDropVolume"];
            this.seedDropVolumeVaryAlong = _data["seedDropVolumeVaryAlong"];
            this.seed = _data["seed"] ? Seed.fromJS(_data["seed"]) : undefined as any;
            this.seedLayer = _data["seedLayer"] ? SeedLayer.fromJS(_data["seedLayer"]) : undefined as any;
        }
    }

    static fromJS(data: any): SeedSeedLayer {
        data = typeof data === 'object' ? data : {};
        let result = new SeedSeedLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seedLayerId"] = this.seedLayerId;
        data["seedId"] = this.seedId;
        data["startSeedDropVolume"] = this.startSeedDropVolume;
        data["stopSeedDropVolume"] = this.stopSeedDropVolume;
        data["seedDropVolumeVaryAlong"] = this.seedDropVolumeVaryAlong;
        data["seed"] = this.seed ? this.seed.toJSON() : undefined as any;
        data["seedLayer"] = this.seedLayer ? this.seedLayer.toJSON() : undefined as any;
        return data;
    }
}

export interface ISeedSeedLayer {
    id: number;
    seedLayerId?: number | undefined;
    seedId?: number | undefined;
    startSeedDropVolume?: number | undefined;
    stopSeedDropVolume?: number | undefined;
    seedDropVolumeVaryAlong?: number | undefined;
    seed?: Seed | undefined;
    seedLayer?: SeedLayer | undefined;
}

export class SeedLayer implements ISeedLayer {
    id!: number;
    experimentId?: number | undefined;
    layerId?: number | undefined;
    experiment?: Experiment | undefined;
    layer?: Layer | undefined;
    seedSeedLayer?: SeedSeedLayer[] | undefined;

    constructor(data?: ISeedLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.layerId = _data["layerId"];
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
            this.layer = _data["layer"] ? Layer.fromJS(_data["layer"]) : undefined as any;
            if (Array.isArray(_data["seedSeedLayer"])) {
                this.seedSeedLayer = [] as any;
                for (let item of _data["seedSeedLayer"])
                    this.seedSeedLayer!.push(SeedSeedLayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeedLayer {
        data = typeof data === 'object' ? data : {};
        let result = new SeedLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["layerId"] = this.layerId;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        if (Array.isArray(this.seedSeedLayer)) {
            data["seedSeedLayer"] = [];
            for (let item of this.seedSeedLayer)
                data["seedSeedLayer"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISeedLayer {
    id: number;
    experimentId?: number | undefined;
    layerId?: number | undefined;
    experiment?: Experiment | undefined;
    layer?: Layer | undefined;
    seedSeedLayer?: SeedSeedLayer[] | undefined;
}

export class SeedSolutionIngredients implements ISeedSolutionIngredients {
    id!: number;
    seedId!: number;
    type?: string | undefined;
    name?: string | undefined;
    concentration?: number | undefined;
    concentrationUnit?: string | undefined;
    seed?: Seed | undefined;

    constructor(data?: ISeedSolutionIngredients) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seedId = _data["seedId"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.concentration = _data["concentration"];
            this.concentrationUnit = _data["concentrationUnit"];
            this.seed = _data["seed"] ? Seed.fromJS(_data["seed"]) : undefined as any;
        }
    }

    static fromJS(data: any): SeedSolutionIngredients {
        data = typeof data === 'object' ? data : {};
        let result = new SeedSolutionIngredients();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seedId"] = this.seedId;
        data["type"] = this.type;
        data["name"] = this.name;
        data["concentration"] = this.concentration;
        data["concentrationUnit"] = this.concentrationUnit;
        data["seed"] = this.seed ? this.seed.toJSON() : undefined as any;
        return data;
    }
}

export interface ISeedSolutionIngredients {
    id: number;
    seedId: number;
    type?: string | undefined;
    name?: string | undefined;
    concentration?: number | undefined;
    concentrationUnit?: string | undefined;
    seed?: Seed | undefined;
}

export class SeedWell implements ISeedWell {
    id!: number;
    seedId?: number | undefined;
    wellId?: number | undefined;
    seed?: Seed | undefined;
    well?: Well | undefined;

    constructor(data?: ISeedWell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seedId = _data["seedId"];
            this.wellId = _data["wellId"];
            this.seed = _data["seed"] ? Seed.fromJS(_data["seed"]) : undefined as any;
            this.well = _data["well"] ? Well.fromJS(_data["well"]) : undefined as any;
        }
    }

    static fromJS(data: any): SeedWell {
        data = typeof data === 'object' ? data : {};
        let result = new SeedWell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seedId"] = this.seedId;
        data["wellId"] = this.wellId;
        data["seed"] = this.seed ? this.seed.toJSON() : undefined as any;
        data["well"] = this.well ? this.well.toJSON() : undefined as any;
        return data;
    }
}

export interface ISeedWell {
    id: number;
    seedId?: number | undefined;
    wellId?: number | undefined;
    seed?: Seed | undefined;
    well?: Well | undefined;
}

export class WellLayer implements IWellLayer {
    id!: number;
    wellId!: number;
    layerId!: number;
    volume!: number;
    waterVolume!: number;
    sourceWellId?: number | undefined;
    waterSource?: string | undefined;
    sourceWellConditionNumber?: string | undefined;
    layer?: Layer | undefined;
    well?: Well | undefined;
    wellLayerIngredient?: WellLayerIngredient[] | undefined;

    constructor(data?: IWellLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellId = _data["wellId"];
            this.layerId = _data["layerId"];
            this.volume = _data["volume"];
            this.waterVolume = _data["waterVolume"];
            this.sourceWellId = _data["sourceWellId"];
            this.waterSource = _data["waterSource"];
            this.sourceWellConditionNumber = _data["sourceWellConditionNumber"];
            this.layer = _data["layer"] ? Layer.fromJS(_data["layer"]) : undefined as any;
            this.well = _data["well"] ? Well.fromJS(_data["well"]) : undefined as any;
            if (Array.isArray(_data["wellLayerIngredient"])) {
                this.wellLayerIngredient = [] as any;
                for (let item of _data["wellLayerIngredient"])
                    this.wellLayerIngredient!.push(WellLayerIngredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WellLayer {
        data = typeof data === 'object' ? data : {};
        let result = new WellLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellId"] = this.wellId;
        data["layerId"] = this.layerId;
        data["volume"] = this.volume;
        data["waterVolume"] = this.waterVolume;
        data["sourceWellId"] = this.sourceWellId;
        data["waterSource"] = this.waterSource;
        data["sourceWellConditionNumber"] = this.sourceWellConditionNumber;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        data["well"] = this.well ? this.well.toJSON() : undefined as any;
        if (Array.isArray(this.wellLayerIngredient)) {
            data["wellLayerIngredient"] = [];
            for (let item of this.wellLayerIngredient)
                data["wellLayerIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWellLayer {
    id: number;
    wellId: number;
    layerId: number;
    volume: number;
    waterVolume: number;
    sourceWellId?: number | undefined;
    waterSource?: string | undefined;
    sourceWellConditionNumber?: string | undefined;
    layer?: Layer | undefined;
    well?: Well | undefined;
    wellLayerIngredient?: WellLayerIngredient[] | undefined;
}

export class WellLayerIngredient implements IWellLayerIngredient {
    id!: number;
    wellLayerId!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    concentration!: number;
    preMixedConcentration!: number;
    volume!: number;
    ph?: number | undefined;
    lowPhvolume?: number | undefined;
    highPhvolume?: number | undefined;
    source?: string | undefined;
    highPhsource?: string | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    wellLayer?: WellLayer | undefined;

    constructor(data?: IWellLayerIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellLayerId = _data["wellLayerId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.concentration = _data["concentration"];
            this.preMixedConcentration = _data["preMixedConcentration"];
            this.volume = _data["volume"];
            this.ph = _data["ph"];
            this.lowPhvolume = _data["lowPhvolume"];
            this.highPhvolume = _data["highPhvolume"];
            this.source = _data["source"];
            this.highPhsource = _data["highPhsource"];
            this.highPhingredientStock = _data["highPhingredientStock"] ? IngredientStock.fromJS(_data["highPhingredientStock"]) : undefined as any;
            this.ingredientIngredientType = _data["ingredientIngredientType"] ? IngredientIngredientType.fromJS(_data["ingredientIngredientType"]) : undefined as any;
            this.ingredientStock = _data["ingredientStock"] ? IngredientStock.fromJS(_data["ingredientStock"]) : undefined as any;
            this.wellLayer = _data["wellLayer"] ? WellLayer.fromJS(_data["wellLayer"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellLayerIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new WellLayerIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellLayerId"] = this.wellLayerId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["concentration"] = this.concentration;
        data["preMixedConcentration"] = this.preMixedConcentration;
        data["volume"] = this.volume;
        data["ph"] = this.ph;
        data["lowPhvolume"] = this.lowPhvolume;
        data["highPhvolume"] = this.highPhvolume;
        data["source"] = this.source;
        data["highPhsource"] = this.highPhsource;
        data["highPhingredientStock"] = this.highPhingredientStock ? this.highPhingredientStock.toJSON() : undefined as any;
        data["ingredientIngredientType"] = this.ingredientIngredientType ? this.ingredientIngredientType.toJSON() : undefined as any;
        data["ingredientStock"] = this.ingredientStock ? this.ingredientStock.toJSON() : undefined as any;
        data["wellLayer"] = this.wellLayer ? this.wellLayer.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellLayerIngredient {
    id: number;
    wellLayerId: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    concentration: number;
    preMixedConcentration: number;
    volume: number;
    ph?: number | undefined;
    lowPhvolume?: number | undefined;
    highPhvolume?: number | undefined;
    source?: string | undefined;
    highPhsource?: string | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    wellLayer?: WellLayer | undefined;
}

export class FavoriteIngredientStock implements IFavoriteIngredientStock {
    id!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    userId?: number | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    user?: Users | undefined;

    constructor(data?: IFavoriteIngredientStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.userId = _data["userId"];
            this.ingredientIngredientType = _data["ingredientIngredientType"] ? IngredientIngredientType.fromJS(_data["ingredientIngredientType"]) : undefined as any;
            this.ingredientStock = _data["ingredientStock"] ? IngredientStock.fromJS(_data["ingredientStock"]) : undefined as any;
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): FavoriteIngredientStock {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteIngredientStock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["userId"] = this.userId;
        data["ingredientIngredientType"] = this.ingredientIngredientType ? this.ingredientIngredientType.toJSON() : undefined as any;
        data["ingredientStock"] = this.ingredientStock ? this.ingredientStock.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IFavoriteIngredientStock {
    id: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    userId?: number | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    user?: Users | undefined;
}

export class GroupUser implements IGroupUser {
    id!: number;
    groupId!: number;
    userId!: number;
    primaryGroup?: boolean | undefined;
    groupAdmin?: boolean | undefined;
    preferenceGroup?: boolean | undefined;
    group?: Groups | undefined;
    user?: Users | undefined;

    constructor(data?: IGroupUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.userId = _data["userId"];
            this.primaryGroup = _data["primaryGroup"];
            this.groupAdmin = _data["groupAdmin"];
            this.preferenceGroup = _data["preferenceGroup"];
            this.group = _data["group"] ? Groups.fromJS(_data["group"]) : undefined as any;
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): GroupUser {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["userId"] = this.userId;
        data["primaryGroup"] = this.primaryGroup;
        data["groupAdmin"] = this.groupAdmin;
        data["preferenceGroup"] = this.preferenceGroup;
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IGroupUser {
    id: number;
    groupId: number;
    userId: number;
    primaryGroup?: boolean | undefined;
    groupAdmin?: boolean | undefined;
    preferenceGroup?: boolean | undefined;
    group?: Groups | undefined;
    user?: Users | undefined;
}

export class Groups implements IGroups {
    id!: number;
    name?: string | undefined;
    groupUser?: GroupUser[] | undefined;
    imagerGroups?: ImagerGroups[] | undefined;
    treeNodeAccessRight?: TreeNodeAccessRight[] | undefined;

    constructor(data?: IGroups) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["groupUser"])) {
                this.groupUser = [] as any;
                for (let item of _data["groupUser"])
                    this.groupUser!.push(GroupUser.fromJS(item));
            }
            if (Array.isArray(_data["imagerGroups"])) {
                this.imagerGroups = [] as any;
                for (let item of _data["imagerGroups"])
                    this.imagerGroups!.push(ImagerGroups.fromJS(item));
            }
            if (Array.isArray(_data["treeNodeAccessRight"])) {
                this.treeNodeAccessRight = [] as any;
                for (let item of _data["treeNodeAccessRight"])
                    this.treeNodeAccessRight!.push(TreeNodeAccessRight.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Groups {
        data = typeof data === 'object' ? data : {};
        let result = new Groups();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.groupUser)) {
            data["groupUser"] = [];
            for (let item of this.groupUser)
                data["groupUser"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagerGroups)) {
            data["imagerGroups"] = [];
            for (let item of this.imagerGroups)
                data["imagerGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.treeNodeAccessRight)) {
            data["treeNodeAccessRight"] = [];
            for (let item of this.treeNodeAccessRight)
                data["treeNodeAccessRight"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGroups {
    id: number;
    name?: string | undefined;
    groupUser?: GroupUser[] | undefined;
    imagerGroups?: ImagerGroups[] | undefined;
    treeNodeAccessRight?: TreeNodeAccessRight[] | undefined;
}

export class ImagerGroups implements IImagerGroups {
    id!: number;
    groupId!: number;
    imagerId!: number;
    plateQuota!: number;
    group?: Groups | undefined;
    imager?: Imager | undefined;

    constructor(data?: IImagerGroups) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.imagerId = _data["imagerId"];
            this.plateQuota = _data["plateQuota"];
            this.group = _data["group"] ? Groups.fromJS(_data["group"]) : undefined as any;
            this.imager = _data["imager"] ? Imager.fromJS(_data["imager"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImagerGroups {
        data = typeof data === 'object' ? data : {};
        let result = new ImagerGroups();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["imagerId"] = this.imagerId;
        data["plateQuota"] = this.plateQuota;
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        data["imager"] = this.imager ? this.imager.toJSON() : undefined as any;
        return data;
    }
}

export interface IImagerGroups {
    id: number;
    groupId: number;
    imagerId: number;
    plateQuota: number;
    group?: Groups | undefined;
    imager?: Imager | undefined;
}

export class Imager implements IImager {
    id!: number;
    robotId?: string | undefined;
    name?: string | undefined;
    status!: boolean;
    imagerGroups?: ImagerGroups[] | undefined;

    constructor(data?: IImager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.robotId = _data["robotId"];
            this.name = _data["name"];
            this.status = _data["status"];
            if (Array.isArray(_data["imagerGroups"])) {
                this.imagerGroups = [] as any;
                for (let item of _data["imagerGroups"])
                    this.imagerGroups!.push(ImagerGroups.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Imager {
        data = typeof data === 'object' ? data : {};
        let result = new Imager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["robotId"] = this.robotId;
        data["name"] = this.name;
        data["status"] = this.status;
        if (Array.isArray(this.imagerGroups)) {
            data["imagerGroups"] = [];
            for (let item of this.imagerGroups)
                data["imagerGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImager {
    id: number;
    robotId?: string | undefined;
    name?: string | undefined;
    status: boolean;
    imagerGroups?: ImagerGroups[] | undefined;
}

export class TreeNodeAccessRight implements ITreeNodeAccessRight {
    id!: number;
    accessRightId!: number;
    treeNodeId!: number;
    userId?: number | undefined;
    groupId?: number | undefined;
    accessRight?: AccessRight | undefined;
    group?: Groups | undefined;
    treeNode?: TreeNode | undefined;
    user?: Users | undefined;

    constructor(data?: ITreeNodeAccessRight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessRightId = _data["accessRightId"];
            this.treeNodeId = _data["treeNodeId"];
            this.userId = _data["userId"];
            this.groupId = _data["groupId"];
            this.accessRight = _data["accessRight"] ? AccessRight.fromJS(_data["accessRight"]) : undefined as any;
            this.group = _data["group"] ? Groups.fromJS(_data["group"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): TreeNodeAccessRight {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeAccessRight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessRightId"] = this.accessRightId;
        data["treeNodeId"] = this.treeNodeId;
        data["userId"] = this.userId;
        data["groupId"] = this.groupId;
        data["accessRight"] = this.accessRight ? this.accessRight.toJSON() : undefined as any;
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface ITreeNodeAccessRight {
    id: number;
    accessRightId: number;
    treeNodeId: number;
    userId?: number | undefined;
    groupId?: number | undefined;
    accessRight?: AccessRight | undefined;
    group?: Groups | undefined;
    treeNode?: TreeNode | undefined;
    user?: Users | undefined;
}

export class AccessRight implements IAccessRight {
    id!: number;
    name?: string | undefined;
    accessLevel!: number;
    treeNodeAccessRight?: TreeNodeAccessRight[] | undefined;

    constructor(data?: IAccessRight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.accessLevel = _data["accessLevel"];
            if (Array.isArray(_data["treeNodeAccessRight"])) {
                this.treeNodeAccessRight = [] as any;
                for (let item of _data["treeNodeAccessRight"])
                    this.treeNodeAccessRight!.push(TreeNodeAccessRight.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessRight {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["accessLevel"] = this.accessLevel;
        if (Array.isArray(this.treeNodeAccessRight)) {
            data["treeNodeAccessRight"] = [];
            for (let item of this.treeNodeAccessRight)
                data["treeNodeAccessRight"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccessRight {
    id: number;
    name?: string | undefined;
    accessLevel: number;
    treeNodeAccessRight?: TreeNodeAccessRight[] | undefined;
}

export class QuickAccess implements IQuickAccess {
    id!: number;
    treeNodeId!: number;
    userId!: number;
    sortOrder?: number | undefined;
    treeNode?: TreeNode | undefined;
    user?: Users | undefined;

    constructor(data?: IQuickAccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.userId = _data["userId"];
            this.sortOrder = _data["sortOrder"];
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): QuickAccess {
        data = typeof data === 'object' ? data : {};
        let result = new QuickAccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["userId"] = this.userId;
        data["sortOrder"] = this.sortOrder;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IQuickAccess {
    id: number;
    treeNodeId: number;
    userId: number;
    sortOrder?: number | undefined;
    treeNode?: TreeNode | undefined;
    user?: Users | undefined;
}

export class UsageStat implements IUsageStat {
    id!: number;
    userId!: number;
    feature?: string | undefined;
    count!: number;
    logSpan!: number;
    logDate!: Date;
    createdAt?: Date | undefined;
    modifiedAt?: Date | undefined;
    user?: Users | undefined;

    constructor(data?: IUsageStat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.feature = _data["feature"];
            this.count = _data["count"];
            this.logSpan = _data["logSpan"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): UsageStat {
        data = typeof data === 'object' ? data : {};
        let result = new UsageStat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["feature"] = this.feature;
        data["count"] = this.count;
        data["logSpan"] = this.logSpan;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IUsageStat {
    id: number;
    userId: number;
    feature?: string | undefined;
    count: number;
    logSpan: number;
    logDate: Date;
    createdAt?: Date | undefined;
    modifiedAt?: Date | undefined;
    user?: Users | undefined;
}

export class UserRecentDocuments implements IUserRecentDocuments {
    id!: number;
    treeNodeId!: number;
    userId?: number | undefined;
    lastOpened!: Date;
    treeNode?: TreeNode | undefined;
    user?: Users | undefined;

    constructor(data?: IUserRecentDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.userId = _data["userId"];
            this.lastOpened = _data["lastOpened"] ? new Date(_data["lastOpened"].toString()) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            this.user = _data["user"] ? Users.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserRecentDocuments {
        data = typeof data === 'object' ? data : {};
        let result = new UserRecentDocuments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["userId"] = this.userId;
        data["lastOpened"] = this.lastOpened ? this.lastOpened.toISOString() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserRecentDocuments {
    id: number;
    treeNodeId: number;
    userId?: number | undefined;
    lastOpened: Date;
    treeNode?: TreeNode | undefined;
    user?: Users | undefined;
}

export class ImagingScheduleEntryCaptureProfile implements IImagingScheduleEntryCaptureProfile {
    id!: number;
    imagingScheduleEntryId!: number;
    captureProfileId!: number;
    captureProfile?: CaptureProfile | undefined;
    imagingScheduleEntry?: ImagingScheduleEntry | undefined;

    constructor(data?: IImagingScheduleEntryCaptureProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imagingScheduleEntryId = _data["imagingScheduleEntryId"];
            this.captureProfileId = _data["captureProfileId"];
            this.captureProfile = _data["captureProfile"] ? CaptureProfile.fromJS(_data["captureProfile"]) : undefined as any;
            this.imagingScheduleEntry = _data["imagingScheduleEntry"] ? ImagingScheduleEntry.fromJS(_data["imagingScheduleEntry"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImagingScheduleEntryCaptureProfile {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingScheduleEntryCaptureProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imagingScheduleEntryId"] = this.imagingScheduleEntryId;
        data["captureProfileId"] = this.captureProfileId;
        data["captureProfile"] = this.captureProfile ? this.captureProfile.toJSON() : undefined as any;
        data["imagingScheduleEntry"] = this.imagingScheduleEntry ? this.imagingScheduleEntry.toJSON() : undefined as any;
        return data;
    }
}

export interface IImagingScheduleEntryCaptureProfile {
    id: number;
    imagingScheduleEntryId: number;
    captureProfileId: number;
    captureProfile?: CaptureProfile | undefined;
    imagingScheduleEntry?: ImagingScheduleEntry | undefined;
}

export class ImagingTaskCaptureProfile implements IImagingTaskCaptureProfile {
    id!: number;
    imagingTaskId!: number;
    captureProfileId!: number;
    captureProfile?: CaptureProfile | undefined;
    imagingTask?: ImagingTask | undefined;

    constructor(data?: IImagingTaskCaptureProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imagingTaskId = _data["imagingTaskId"];
            this.captureProfileId = _data["captureProfileId"];
            this.captureProfile = _data["captureProfile"] ? CaptureProfile.fromJS(_data["captureProfile"]) : undefined as any;
            this.imagingTask = _data["imagingTask"] ? ImagingTask.fromJS(_data["imagingTask"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImagingTaskCaptureProfile {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingTaskCaptureProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imagingTaskId"] = this.imagingTaskId;
        data["captureProfileId"] = this.captureProfileId;
        data["captureProfile"] = this.captureProfile ? this.captureProfile.toJSON() : undefined as any;
        data["imagingTask"] = this.imagingTask ? this.imagingTask.toJSON() : undefined as any;
        return data;
    }
}

export interface IImagingTaskCaptureProfile {
    id: number;
    imagingTaskId: number;
    captureProfileId: number;
    captureProfile?: CaptureProfile | undefined;
    imagingTask?: ImagingTask | undefined;
}

export class ImageBatchAutoScoreThreshold implements IImageBatchAutoScoreThreshold {
    id!: number;
    imageBatchId!: number;
    autoScoreImageTypeId!: number;
    value!: number;
    imageBatch?: ImageBatch | undefined;

    constructor(data?: IImageBatchAutoScoreThreshold) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageBatchId = _data["imageBatchId"];
            this.autoScoreImageTypeId = _data["autoScoreImageTypeId"];
            this.value = _data["value"];
            this.imageBatch = _data["imageBatch"] ? ImageBatch.fromJS(_data["imageBatch"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImageBatchAutoScoreThreshold {
        data = typeof data === 'object' ? data : {};
        let result = new ImageBatchAutoScoreThreshold();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageBatchId"] = this.imageBatchId;
        data["autoScoreImageTypeId"] = this.autoScoreImageTypeId;
        data["value"] = this.value;
        data["imageBatch"] = this.imageBatch ? this.imageBatch.toJSON() : undefined as any;
        return data;
    }
}

export interface IImageBatchAutoScoreThreshold {
    id: number;
    imageBatchId: number;
    autoScoreImageTypeId: number;
    value: number;
    imageBatch?: ImageBatch | undefined;
}

export class PuckPin implements IPuckPin {
    id!: number;
    puckId!: number;
    position!: number;
    puck?: Puck | undefined;
    crystal?: Crystal[] | undefined;

    constructor(data?: IPuckPin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.puckId = _data["puckId"];
            this.position = _data["position"];
            this.puck = _data["puck"] ? Puck.fromJS(_data["puck"]) : undefined as any;
            if (Array.isArray(_data["crystal"])) {
                this.crystal = [] as any;
                for (let item of _data["crystal"])
                    this.crystal!.push(Crystal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PuckPin {
        data = typeof data === 'object' ? data : {};
        let result = new PuckPin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["puckId"] = this.puckId;
        data["position"] = this.position;
        data["puck"] = this.puck ? this.puck.toJSON() : undefined as any;
        if (Array.isArray(this.crystal)) {
            data["crystal"] = [];
            for (let item of this.crystal)
                data["crystal"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPuckPin {
    id: number;
    puckId: number;
    position: number;
    puck?: Puck | undefined;
    crystal?: Crystal[] | undefined;
}

export class Puck implements IPuck {
    id!: number;
    puckTypeId!: number;
    name?: string | undefined;
    barcode?: string | undefined;
    dewarId?: number | undefined;
    occupiedPinCount!: number;
    dewar?: Dewar | undefined;
    puckType?: PuckType | undefined;
    puckPin?: PuckPin[] | undefined;

    constructor(data?: IPuck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.puckTypeId = _data["puckTypeId"];
            this.name = _data["name"];
            this.barcode = _data["barcode"];
            this.dewarId = _data["dewarId"];
            this.occupiedPinCount = _data["occupiedPinCount"];
            this.dewar = _data["dewar"] ? Dewar.fromJS(_data["dewar"]) : undefined as any;
            this.puckType = _data["puckType"] ? PuckType.fromJS(_data["puckType"]) : undefined as any;
            if (Array.isArray(_data["puckPin"])) {
                this.puckPin = [] as any;
                for (let item of _data["puckPin"])
                    this.puckPin!.push(PuckPin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Puck {
        data = typeof data === 'object' ? data : {};
        let result = new Puck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["puckTypeId"] = this.puckTypeId;
        data["name"] = this.name;
        data["barcode"] = this.barcode;
        data["dewarId"] = this.dewarId;
        data["occupiedPinCount"] = this.occupiedPinCount;
        data["dewar"] = this.dewar ? this.dewar.toJSON() : undefined as any;
        data["puckType"] = this.puckType ? this.puckType.toJSON() : undefined as any;
        if (Array.isArray(this.puckPin)) {
            data["puckPin"] = [];
            for (let item of this.puckPin)
                data["puckPin"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPuck {
    id: number;
    puckTypeId: number;
    name?: string | undefined;
    barcode?: string | undefined;
    dewarId?: number | undefined;
    occupiedPinCount: number;
    dewar?: Dewar | undefined;
    puckType?: PuckType | undefined;
    puckPin?: PuckPin[] | undefined;
}

export class Dewar implements IDewar {
    id!: number;
    name?: string | undefined;
    puckCount!: number;
    occupiedPuckCount!: number;
    synchrotronTripId?: number | undefined;
    synchrotronTrip?: SynchrotronTrip | undefined;
    puck?: Puck[] | undefined;

    constructor(data?: IDewar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.puckCount = _data["puckCount"];
            this.occupiedPuckCount = _data["occupiedPuckCount"];
            this.synchrotronTripId = _data["synchrotronTripId"];
            this.synchrotronTrip = _data["synchrotronTrip"] ? SynchrotronTrip.fromJS(_data["synchrotronTrip"]) : undefined as any;
            if (Array.isArray(_data["puck"])) {
                this.puck = [] as any;
                for (let item of _data["puck"])
                    this.puck!.push(Puck.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dewar {
        data = typeof data === 'object' ? data : {};
        let result = new Dewar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["puckCount"] = this.puckCount;
        data["occupiedPuckCount"] = this.occupiedPuckCount;
        data["synchrotronTripId"] = this.synchrotronTripId;
        data["synchrotronTrip"] = this.synchrotronTrip ? this.synchrotronTrip.toJSON() : undefined as any;
        if (Array.isArray(this.puck)) {
            data["puck"] = [];
            for (let item of this.puck)
                data["puck"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDewar {
    id: number;
    name?: string | undefined;
    puckCount: number;
    occupiedPuckCount: number;
    synchrotronTripId?: number | undefined;
    synchrotronTrip?: SynchrotronTrip | undefined;
    puck?: Puck[] | undefined;
}

export class SynchrotronTrip implements ISynchrotronTrip {
    id!: number;
    treeNodeId!: number;
    dataCollectionDate!: Date;
    beamline?: string | undefined;
    detectorType?: string | undefined;
    contactPerson?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    treeNode?: TreeNode | undefined;
    dewar?: Dewar[] | undefined;

    constructor(data?: ISynchrotronTrip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.dataCollectionDate = _data["dataCollectionDate"] ? new Date(_data["dataCollectionDate"].toString()) : undefined as any;
            this.beamline = _data["beamline"];
            this.detectorType = _data["detectorType"];
            this.contactPerson = _data["contactPerson"];
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            if (Array.isArray(_data["dewar"])) {
                this.dewar = [] as any;
                for (let item of _data["dewar"])
                    this.dewar!.push(Dewar.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SynchrotronTrip {
        data = typeof data === 'object' ? data : {};
        let result = new SynchrotronTrip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["dataCollectionDate"] = this.dataCollectionDate ? this.dataCollectionDate.toISOString() : undefined as any;
        data["beamline"] = this.beamline;
        data["detectorType"] = this.detectorType;
        data["contactPerson"] = this.contactPerson;
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        if (Array.isArray(this.dewar)) {
            data["dewar"] = [];
            for (let item of this.dewar)
                data["dewar"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISynchrotronTrip {
    id: number;
    treeNodeId: number;
    dataCollectionDate: Date;
    beamline?: string | undefined;
    detectorType?: string | undefined;
    contactPerson?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    treeNode?: TreeNode | undefined;
    dewar?: Dewar[] | undefined;
}

export class PuckType implements IPuckType {
    id!: number;
    name?: string | undefined;
    pinCount!: number;
    puck?: Puck[] | undefined;

    constructor(data?: IPuckType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pinCount = _data["pinCount"];
            if (Array.isArray(_data["puck"])) {
                this.puck = [] as any;
                for (let item of _data["puck"])
                    this.puck!.push(Puck.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PuckType {
        data = typeof data === 'object' ? data : {};
        let result = new PuckType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pinCount"] = this.pinCount;
        if (Array.isArray(this.puck)) {
            data["puck"] = [];
            for (let item of this.puck)
                data["puck"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPuckType {
    id: number;
    name?: string | undefined;
    pinCount: number;
    puck?: Puck[] | undefined;
}

export class Cryoprotectant implements ICryoprotectant {
    id!: number;
    ingredient?: string | undefined;
    conc!: number;
    concUnit?: string | undefined;
    ph?: number | undefined;
    protocol?: string | undefined;
    crystalId!: number;
    crystal?: Crystal | undefined;

    constructor(data?: ICryoprotectant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredient = _data["ingredient"];
            this.conc = _data["conc"];
            this.concUnit = _data["concUnit"];
            this.ph = _data["ph"];
            this.protocol = _data["protocol"];
            this.crystalId = _data["crystalId"];
            this.crystal = _data["crystal"] ? Crystal.fromJS(_data["crystal"]) : undefined as any;
        }
    }

    static fromJS(data: any): Cryoprotectant {
        data = typeof data === 'object' ? data : {};
        let result = new Cryoprotectant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredient"] = this.ingredient;
        data["conc"] = this.conc;
        data["concUnit"] = this.concUnit;
        data["ph"] = this.ph;
        data["protocol"] = this.protocol;
        data["crystalId"] = this.crystalId;
        data["crystal"] = this.crystal ? this.crystal.toJSON() : undefined as any;
        return data;
    }
}

export interface ICryoprotectant {
    id: number;
    ingredient?: string | undefined;
    conc: number;
    concUnit?: string | undefined;
    ph?: number | undefined;
    protocol?: string | undefined;
    crystalId: number;
    crystal?: Crystal | undefined;
}

export class Soaking implements ISoaking {
    id!: number;
    ingredient?: string | undefined;
    conc!: number;
    concUnit?: string | undefined;
    time?: number | undefined;
    timeUnit?: string | undefined;
    textInfo?: string | undefined;
    crystalId!: number;
    crystal?: Crystal | undefined;

    constructor(data?: ISoaking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredient = _data["ingredient"];
            this.conc = _data["conc"];
            this.concUnit = _data["concUnit"];
            this.time = _data["time"];
            this.timeUnit = _data["timeUnit"];
            this.textInfo = _data["textInfo"];
            this.crystalId = _data["crystalId"];
            this.crystal = _data["crystal"] ? Crystal.fromJS(_data["crystal"]) : undefined as any;
        }
    }

    static fromJS(data: any): Soaking {
        data = typeof data === 'object' ? data : {};
        let result = new Soaking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredient"] = this.ingredient;
        data["conc"] = this.conc;
        data["concUnit"] = this.concUnit;
        data["time"] = this.time;
        data["timeUnit"] = this.timeUnit;
        data["textInfo"] = this.textInfo;
        data["crystalId"] = this.crystalId;
        data["crystal"] = this.crystal ? this.crystal.toJSON() : undefined as any;
        return data;
    }
}

export interface ISoaking {
    id: number;
    ingredient?: string | undefined;
    conc: number;
    concUnit?: string | undefined;
    time?: number | undefined;
    timeUnit?: string | undefined;
    textInfo?: string | undefined;
    crystalId: number;
    crystal?: Crystal | undefined;
}

export class CaptureResultTuningValues implements ICaptureResultTuningValues {
    id!: number;
    captureResultId!: number;
    autoLevelingOn!: boolean;
    autoLevelingLowThreshold!: number;
    autoLevelingHighThreshold!: number;
    lowerLevelLimit!: number;
    upperLevelLimit!: number;
    brightness!: number;
    contrast!: number;
    gamma!: number;
    autoLevelingMode!: number;
    captureResult?: CaptureResult | undefined;

    constructor(data?: ICaptureResultTuningValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.captureResultId = _data["captureResultId"];
            this.autoLevelingOn = _data["autoLevelingOn"];
            this.autoLevelingLowThreshold = _data["autoLevelingLowThreshold"];
            this.autoLevelingHighThreshold = _data["autoLevelingHighThreshold"];
            this.lowerLevelLimit = _data["lowerLevelLimit"];
            this.upperLevelLimit = _data["upperLevelLimit"];
            this.brightness = _data["brightness"];
            this.contrast = _data["contrast"];
            this.gamma = _data["gamma"];
            this.autoLevelingMode = _data["autoLevelingMode"];
            this.captureResult = _data["captureResult"] ? CaptureResult.fromJS(_data["captureResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): CaptureResultTuningValues {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureResultTuningValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureResultId"] = this.captureResultId;
        data["autoLevelingOn"] = this.autoLevelingOn;
        data["autoLevelingLowThreshold"] = this.autoLevelingLowThreshold;
        data["autoLevelingHighThreshold"] = this.autoLevelingHighThreshold;
        data["lowerLevelLimit"] = this.lowerLevelLimit;
        data["upperLevelLimit"] = this.upperLevelLimit;
        data["brightness"] = this.brightness;
        data["contrast"] = this.contrast;
        data["gamma"] = this.gamma;
        data["autoLevelingMode"] = this.autoLevelingMode;
        data["captureResult"] = this.captureResult ? this.captureResult.toJSON() : undefined as any;
        return data;
    }
}

export interface ICaptureResultTuningValues {
    id: number;
    captureResultId: number;
    autoLevelingOn: boolean;
    autoLevelingLowThreshold: number;
    autoLevelingHighThreshold: number;
    lowerLevelLimit: number;
    upperLevelLimit: number;
    brightness: number;
    contrast: number;
    gamma: number;
    autoLevelingMode: number;
    captureResult?: CaptureResult | undefined;
}

export class CaptureResultProperty implements ICaptureResultProperty {
    id!: number;
    captureResultId!: number;
    name?: string | undefined;
    value?: string | undefined;
    captureResult?: CaptureResult | undefined;

    constructor(data?: ICaptureResultProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.captureResultId = _data["captureResultId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.captureResult = _data["captureResult"] ? CaptureResult.fromJS(_data["captureResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): CaptureResultProperty {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureResultProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureResultId"] = this.captureResultId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["captureResult"] = this.captureResult ? this.captureResult.toJSON() : undefined as any;
        return data;
    }
}

export interface ICaptureResultProperty {
    id: number;
    captureResultId: number;
    name?: string | undefined;
    value?: string | undefined;
    captureResult?: CaptureResult | undefined;
}

export class FocalPoint implements IFocalPoint {
    id!: number;
    captureResultId!: number;
    z!: number;
    focus!: number;
    captureResult?: CaptureResult | undefined;

    constructor(data?: IFocalPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.captureResultId = _data["captureResultId"];
            this.z = _data["z"];
            this.focus = _data["focus"];
            this.captureResult = _data["captureResult"] ? CaptureResult.fromJS(_data["captureResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): FocalPoint {
        data = typeof data === 'object' ? data : {};
        let result = new FocalPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureResultId"] = this.captureResultId;
        data["z"] = this.z;
        data["focus"] = this.focus;
        data["captureResult"] = this.captureResult ? this.captureResult.toJSON() : undefined as any;
        return data;
    }
}

export interface IFocalPoint {
    id: number;
    captureResultId: number;
    z: number;
    focus: number;
    captureResult?: CaptureResult | undefined;
}

export class ImageType implements IImageType {
    id!: number;
    longName?: string | undefined;
    shortName?: string | undefined;
    sortOrder!: number;
    inRegionView!: boolean;
    image?: Image[] | undefined;

    constructor(data?: IImageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.longName = _data["longName"];
            this.shortName = _data["shortName"];
            this.sortOrder = _data["sortOrder"];
            this.inRegionView = _data["inRegionView"];
            if (Array.isArray(_data["image"])) {
                this.image = [] as any;
                for (let item of _data["image"])
                    this.image!.push(Image.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageType {
        data = typeof data === 'object' ? data : {};
        let result = new ImageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["longName"] = this.longName;
        data["shortName"] = this.shortName;
        data["sortOrder"] = this.sortOrder;
        data["inRegionView"] = this.inRegionView;
        if (Array.isArray(this.image)) {
            data["image"] = [];
            for (let item of this.image)
                data["image"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImageType {
    id: number;
    longName?: string | undefined;
    shortName?: string | undefined;
    sortOrder: number;
    inRegionView: boolean;
    image?: Image[] | undefined;
}

export class BestFocusLevel implements IBestFocusLevel {
    id!: number;
    imageId!: number;
    image?: Image | undefined;

    constructor(data?: IBestFocusLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageId = _data["imageId"];
            this.image = _data["image"] ? Image.fromJS(_data["image"]) : undefined as any;
        }
    }

    static fromJS(data: any): BestFocusLevel {
        data = typeof data === 'object' ? data : {};
        let result = new BestFocusLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageId"] = this.imageId;
        data["image"] = this.image ? this.image.toJSON() : undefined as any;
        return data;
    }
}

export interface IBestFocusLevel {
    id: number;
    imageId: number;
    image?: Image | undefined;
}

export class ImageProperty implements IImageProperty {
    id!: number;
    imageId!: number;
    name?: string | undefined;
    value?: string | undefined;
    image?: Image | undefined;

    constructor(data?: IImageProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageId = _data["imageId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.image = _data["image"] ? Image.fromJS(_data["image"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImageProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ImageProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageId"] = this.imageId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["image"] = this.image ? this.image.toJSON() : undefined as any;
        return data;
    }
}

export interface IImageProperty {
    id: number;
    imageId: number;
    name?: string | undefined;
    value?: string | undefined;
    image?: Image | undefined;
}

export class RetrainingImage implements IRetrainingImage {
    id!: number;
    imageId!: number;
    wellDropId!: number;
    imageBatchId!: number;
    regionId!: number;
    captureProfileId!: number;
    captureResultId!: number;
    status?: number | undefined;
    dateSubmitted?: Date | undefined;
    image?: Image | undefined;

    constructor(data?: IRetrainingImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageId = _data["imageId"];
            this.wellDropId = _data["wellDropId"];
            this.imageBatchId = _data["imageBatchId"];
            this.regionId = _data["regionId"];
            this.captureProfileId = _data["captureProfileId"];
            this.captureResultId = _data["captureResultId"];
            this.status = _data["status"];
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : undefined as any;
            this.image = _data["image"] ? Image.fromJS(_data["image"]) : undefined as any;
        }
    }

    static fromJS(data: any): RetrainingImage {
        data = typeof data === 'object' ? data : {};
        let result = new RetrainingImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageId"] = this.imageId;
        data["wellDropId"] = this.wellDropId;
        data["imageBatchId"] = this.imageBatchId;
        data["regionId"] = this.regionId;
        data["captureProfileId"] = this.captureProfileId;
        data["captureResultId"] = this.captureResultId;
        data["status"] = this.status;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : undefined as any;
        data["image"] = this.image ? this.image.toJSON() : undefined as any;
        return data;
    }
}

export interface IRetrainingImage {
    id: number;
    imageId: number;
    wellDropId: number;
    imageBatchId: number;
    regionId: number;
    captureProfileId: number;
    captureResultId: number;
    status?: number | undefined;
    dateSubmitted?: Date | undefined;
    image?: Image | undefined;
}

export class ImageManagementTarget implements IImageManagementTarget {
    id!: number;
    imageManagementId!: number;
    treeNodeId!: number;
    imageManagement?: ImageManagement | undefined;
    treeNode?: TreeNode | undefined;

    constructor(data?: IImageManagementTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageManagementId = _data["imageManagementId"];
            this.treeNodeId = _data["treeNodeId"];
            this.imageManagement = _data["imageManagement"] ? ImageManagement.fromJS(_data["imageManagement"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImageManagementTarget {
        data = typeof data === 'object' ? data : {};
        let result = new ImageManagementTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageManagementId"] = this.imageManagementId;
        data["treeNodeId"] = this.treeNodeId;
        data["imageManagement"] = this.imageManagement ? this.imageManagement.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        return data;
    }
}

export interface IImageManagementTarget {
    id: number;
    imageManagementId: number;
    treeNodeId: number;
    imageManagement?: ImageManagement | undefined;
    treeNode?: TreeNode | undefined;
}

export class ScreenLot implements IScreenLot {
    id!: number;
    experimentId!: number;
    containerId!: number;
    treeNodeId!: number;
    lotNumber!: number;
    dispenseVolume!: number;
    currentVolume!: number;
    comment?: string | undefined;
    initialLot!: boolean;
    container?: Containers | undefined;
    experiment?: Experiment | undefined;
    treeNode?: TreeNode | undefined;
    screenLayer?: ScreenLayer[] | undefined;
    screenLotPlate?: ScreenLotPlate[] | undefined;

    constructor(data?: IScreenLot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.containerId = _data["containerId"];
            this.treeNodeId = _data["treeNodeId"];
            this.lotNumber = _data["lotNumber"];
            this.dispenseVolume = _data["dispenseVolume"];
            this.currentVolume = _data["currentVolume"];
            this.comment = _data["comment"];
            this.initialLot = _data["initialLot"];
            this.container = _data["container"] ? Containers.fromJS(_data["container"]) : undefined as any;
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            if (Array.isArray(_data["screenLayer"])) {
                this.screenLayer = [] as any;
                for (let item of _data["screenLayer"])
                    this.screenLayer!.push(ScreenLayer.fromJS(item));
            }
            if (Array.isArray(_data["screenLotPlate"])) {
                this.screenLotPlate = [] as any;
                for (let item of _data["screenLotPlate"])
                    this.screenLotPlate!.push(ScreenLotPlate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScreenLot {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenLot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["containerId"] = this.containerId;
        data["treeNodeId"] = this.treeNodeId;
        data["lotNumber"] = this.lotNumber;
        data["dispenseVolume"] = this.dispenseVolume;
        data["currentVolume"] = this.currentVolume;
        data["comment"] = this.comment;
        data["initialLot"] = this.initialLot;
        data["container"] = this.container ? this.container.toJSON() : undefined as any;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        if (Array.isArray(this.screenLayer)) {
            data["screenLayer"] = [];
            for (let item of this.screenLayer)
                data["screenLayer"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenLotPlate)) {
            data["screenLotPlate"] = [];
            for (let item of this.screenLotPlate)
                data["screenLotPlate"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScreenLot {
    id: number;
    experimentId: number;
    containerId: number;
    treeNodeId: number;
    lotNumber: number;
    dispenseVolume: number;
    currentVolume: number;
    comment?: string | undefined;
    initialLot: boolean;
    container?: Containers | undefined;
    experiment?: Experiment | undefined;
    treeNode?: TreeNode | undefined;
    screenLayer?: ScreenLayer[] | undefined;
    screenLotPlate?: ScreenLotPlate[] | undefined;
}

export class Containers implements IContainers {
    id!: number;
    name?: string | undefined;
    numRows!: number;
    numColumns!: number;
    defaultWellVolume!: number;
    defaultAdditiveVolume!: number;
    maxWellVolume!: number;
    maxNumDrops!: number;
    defaultDropVolume!: number;
    maxDropVolume!: number;
    type!: number;
    enable?: boolean | undefined;
    defaultSeedVolume?: number | undefined;
    defaultFragmentVolume?: number | undefined;
    containerDrop?: ContainerDrop[] | undefined;
    experiment?: Experiment[] | undefined;
    screenLot?: ScreenLot[] | undefined;

    constructor(data?: IContainers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numRows = _data["numRows"];
            this.numColumns = _data["numColumns"];
            this.defaultWellVolume = _data["defaultWellVolume"];
            this.defaultAdditiveVolume = _data["defaultAdditiveVolume"];
            this.maxWellVolume = _data["maxWellVolume"];
            this.maxNumDrops = _data["maxNumDrops"];
            this.defaultDropVolume = _data["defaultDropVolume"];
            this.maxDropVolume = _data["maxDropVolume"];
            this.type = _data["type"];
            this.enable = _data["enable"];
            this.defaultSeedVolume = _data["defaultSeedVolume"];
            this.defaultFragmentVolume = _data["defaultFragmentVolume"];
            if (Array.isArray(_data["containerDrop"])) {
                this.containerDrop = [] as any;
                for (let item of _data["containerDrop"])
                    this.containerDrop!.push(ContainerDrop.fromJS(item));
            }
            if (Array.isArray(_data["experiment"])) {
                this.experiment = [] as any;
                for (let item of _data["experiment"])
                    this.experiment!.push(Experiment.fromJS(item));
            }
            if (Array.isArray(_data["screenLot"])) {
                this.screenLot = [] as any;
                for (let item of _data["screenLot"])
                    this.screenLot!.push(ScreenLot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Containers {
        data = typeof data === 'object' ? data : {};
        let result = new Containers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numRows"] = this.numRows;
        data["numColumns"] = this.numColumns;
        data["defaultWellVolume"] = this.defaultWellVolume;
        data["defaultAdditiveVolume"] = this.defaultAdditiveVolume;
        data["maxWellVolume"] = this.maxWellVolume;
        data["maxNumDrops"] = this.maxNumDrops;
        data["defaultDropVolume"] = this.defaultDropVolume;
        data["maxDropVolume"] = this.maxDropVolume;
        data["type"] = this.type;
        data["enable"] = this.enable;
        data["defaultSeedVolume"] = this.defaultSeedVolume;
        data["defaultFragmentVolume"] = this.defaultFragmentVolume;
        if (Array.isArray(this.containerDrop)) {
            data["containerDrop"] = [];
            for (let item of this.containerDrop)
                data["containerDrop"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.experiment)) {
            data["experiment"] = [];
            for (let item of this.experiment)
                data["experiment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenLot)) {
            data["screenLot"] = [];
            for (let item of this.screenLot)
                data["screenLot"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContainers {
    id: number;
    name?: string | undefined;
    numRows: number;
    numColumns: number;
    defaultWellVolume: number;
    defaultAdditiveVolume: number;
    maxWellVolume: number;
    maxNumDrops: number;
    defaultDropVolume: number;
    maxDropVolume: number;
    type: number;
    enable?: boolean | undefined;
    defaultSeedVolume?: number | undefined;
    defaultFragmentVolume?: number | undefined;
    containerDrop?: ContainerDrop[] | undefined;
    experiment?: Experiment[] | undefined;
    screenLot?: ScreenLot[] | undefined;
}

export class ContainerDrop implements IContainerDrop {
    id!: number;
    containerId!: number;
    dropNumber!: number;
    container?: Containers | undefined;

    constructor(data?: IContainerDrop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerId = _data["containerId"];
            this.dropNumber = _data["dropNumber"];
            this.container = _data["container"] ? Containers.fromJS(_data["container"]) : undefined as any;
        }
    }

    static fromJS(data: any): ContainerDrop {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerDrop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerId"] = this.containerId;
        data["dropNumber"] = this.dropNumber;
        data["container"] = this.container ? this.container.toJSON() : undefined as any;
        return data;
    }
}

export interface IContainerDrop {
    id: number;
    containerId: number;
    dropNumber: number;
    container?: Containers | undefined;
}

export class ScreenLayer implements IScreenLayer {
    id!: number;
    layerId!: number;
    experimentId!: number;
    screenLotId!: number;
    volume!: number;
    startingWellNumber?: number | undefined;
    experiment?: Experiment | undefined;
    layer?: Layer | undefined;
    screenLot?: ScreenLot | undefined;

    constructor(data?: IScreenLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layerId = _data["layerId"];
            this.experimentId = _data["experimentId"];
            this.screenLotId = _data["screenLotId"];
            this.volume = _data["volume"];
            this.startingWellNumber = _data["startingWellNumber"];
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
            this.layer = _data["layer"] ? Layer.fromJS(_data["layer"]) : undefined as any;
            this.screenLot = _data["screenLot"] ? ScreenLot.fromJS(_data["screenLot"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScreenLayer {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layerId"] = this.layerId;
        data["experimentId"] = this.experimentId;
        data["screenLotId"] = this.screenLotId;
        data["volume"] = this.volume;
        data["startingWellNumber"] = this.startingWellNumber;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        data["screenLot"] = this.screenLot ? this.screenLot.toJSON() : undefined as any;
        return data;
    }
}

export interface IScreenLayer {
    id: number;
    layerId: number;
    experimentId: number;
    screenLotId: number;
    volume: number;
    startingWellNumber?: number | undefined;
    experiment?: Experiment | undefined;
    layer?: Layer | undefined;
    screenLot?: ScreenLot | undefined;
}

export class ScreenLotPlate implements IScreenLotPlate {
    id!: number;
    screenLotId!: number;
    plateId!: number;
    migrated!: boolean;
    plate?: Plate | undefined;
    screenLot?: ScreenLot | undefined;

    constructor(data?: IScreenLotPlate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.screenLotId = _data["screenLotId"];
            this.plateId = _data["plateId"];
            this.migrated = _data["migrated"];
            this.plate = _data["plate"] ? Plate.fromJS(_data["plate"]) : undefined as any;
            this.screenLot = _data["screenLot"] ? ScreenLot.fromJS(_data["screenLot"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScreenLotPlate {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenLotPlate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["screenLotId"] = this.screenLotId;
        data["plateId"] = this.plateId;
        data["migrated"] = this.migrated;
        data["plate"] = this.plate ? this.plate.toJSON() : undefined as any;
        data["screenLot"] = this.screenLot ? this.screenLot.toJSON() : undefined as any;
        return data;
    }
}

export interface IScreenLotPlate {
    id: number;
    screenLotId: number;
    plateId: number;
    migrated: boolean;
    plate?: Plate | undefined;
    screenLot?: ScreenLot | undefined;
}

export class Trash implements ITrash {
    id!: number;
    treeNodeId!: number;
    deleteRequestedAt!: Date;
    rootNodeId?: number | undefined;
    deleteInProgress!: boolean;
    type?: string | undefined;
    rootNode?: TreeNode | undefined;
    treeNode?: TreeNode | undefined;

    constructor(data?: ITrash) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.deleteRequestedAt = _data["deleteRequestedAt"] ? new Date(_data["deleteRequestedAt"].toString()) : undefined as any;
            this.rootNodeId = _data["rootNodeId"];
            this.deleteInProgress = _data["deleteInProgress"];
            this.type = _data["type"];
            this.rootNode = _data["rootNode"] ? TreeNode.fromJS(_data["rootNode"]) : undefined as any;
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
        }
    }

    static fromJS(data: any): Trash {
        data = typeof data === 'object' ? data : {};
        let result = new Trash();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["deleteRequestedAt"] = this.deleteRequestedAt ? this.deleteRequestedAt.toISOString() : undefined as any;
        data["rootNodeId"] = this.rootNodeId;
        data["deleteInProgress"] = this.deleteInProgress;
        data["type"] = this.type;
        data["rootNode"] = this.rootNode ? this.rootNode.toJSON() : undefined as any;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        return data;
    }
}

export interface ITrash {
    id: number;
    treeNodeId: number;
    deleteRequestedAt: Date;
    rootNodeId?: number | undefined;
    deleteInProgress: boolean;
    type?: string | undefined;
    rootNode?: TreeNode | undefined;
    treeNode?: TreeNode | undefined;
}

export class SearchParameters implements ISearchParameters {
    id!: number;
    treeNodeId!: number;
    searchQuery?: string | undefined;
    fileName?: string | undefined;
    searchTargets?: string | undefined;
    ownerId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    locationTreeNodeIds?: string | undefined;
    treeNode?: TreeNode | undefined;

    constructor(data?: ISearchParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.searchQuery = _data["searchQuery"];
            this.fileName = _data["fileName"];
            this.searchTargets = _data["searchTargets"];
            this.ownerId = _data["ownerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined as any;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined as any;
            this.locationTreeNodeIds = _data["locationTreeNodeIds"];
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchParameters {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["searchQuery"] = this.searchQuery;
        data["fileName"] = this.fileName;
        data["searchTargets"] = this.searchTargets;
        data["ownerId"] = this.ownerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined as any;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined as any;
        data["locationTreeNodeIds"] = this.locationTreeNodeIds;
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchParameters {
    id: number;
    treeNodeId: number;
    searchQuery?: string | undefined;
    fileName?: string | undefined;
    searchTargets?: string | undefined;
    ownerId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    locationTreeNodeIds?: string | undefined;
    treeNode?: TreeNode | undefined;
}

export class GridLayer implements IGridLayer {
    id!: number;
    gridId!: number;
    layerId!: number;
    subGridNumber!: number;
    grid?: Grid | undefined;
    layer?: Layer | undefined;

    constructor(data?: IGridLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gridId = _data["gridId"];
            this.layerId = _data["layerId"];
            this.subGridNumber = _data["subGridNumber"];
            this.grid = _data["grid"] ? Grid.fromJS(_data["grid"]) : undefined as any;
            this.layer = _data["layer"] ? Layer.fromJS(_data["layer"]) : undefined as any;
        }
    }

    static fromJS(data: any): GridLayer {
        data = typeof data === 'object' ? data : {};
        let result = new GridLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gridId"] = this.gridId;
        data["layerId"] = this.layerId;
        data["subGridNumber"] = this.subGridNumber;
        data["grid"] = this.grid ? this.grid.toJSON() : undefined as any;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        return data;
    }
}

export interface IGridLayer {
    id: number;
    gridId: number;
    layerId: number;
    subGridNumber: number;
    grid?: Grid | undefined;
    layer?: Layer | undefined;
}

export class Grid implements IGrid {
    id!: number;
    experimentId!: number;
    startWellVolume!: number;
    stopWellVolume!: number;
    wellVolumeVaryAlong!: number;
    experiment?: Experiment | undefined;
    wellVolumeVaryAlongNavigation?: GridVaryAlong | undefined;
    gridIngredient?: GridIngredient[] | undefined;
    gridLayer?: GridLayer[] | undefined;

    constructor(data?: IGrid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.startWellVolume = _data["startWellVolume"];
            this.stopWellVolume = _data["stopWellVolume"];
            this.wellVolumeVaryAlong = _data["wellVolumeVaryAlong"];
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
            this.wellVolumeVaryAlongNavigation = _data["wellVolumeVaryAlongNavigation"] ? GridVaryAlong.fromJS(_data["wellVolumeVaryAlongNavigation"]) : undefined as any;
            if (Array.isArray(_data["gridIngredient"])) {
                this.gridIngredient = [] as any;
                for (let item of _data["gridIngredient"])
                    this.gridIngredient!.push(GridIngredient.fromJS(item));
            }
            if (Array.isArray(_data["gridLayer"])) {
                this.gridLayer = [] as any;
                for (let item of _data["gridLayer"])
                    this.gridLayer!.push(GridLayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Grid {
        data = typeof data === 'object' ? data : {};
        let result = new Grid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["startWellVolume"] = this.startWellVolume;
        data["stopWellVolume"] = this.stopWellVolume;
        data["wellVolumeVaryAlong"] = this.wellVolumeVaryAlong;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        data["wellVolumeVaryAlongNavigation"] = this.wellVolumeVaryAlongNavigation ? this.wellVolumeVaryAlongNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.gridIngredient)) {
            data["gridIngredient"] = [];
            for (let item of this.gridIngredient)
                data["gridIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gridLayer)) {
            data["gridLayer"] = [];
            for (let item of this.gridLayer)
                data["gridLayer"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGrid {
    id: number;
    experimentId: number;
    startWellVolume: number;
    stopWellVolume: number;
    wellVolumeVaryAlong: number;
    experiment?: Experiment | undefined;
    wellVolumeVaryAlongNavigation?: GridVaryAlong | undefined;
    gridIngredient?: GridIngredient[] | undefined;
    gridLayer?: GridLayer[] | undefined;
}

export class GridVaryAlong implements IGridVaryAlong {
    id!: number;
    name?: string | undefined;
    grid?: Grid[] | undefined;
    gridIngredientConcentrationVaryAlongNavigation?: GridIngredient[] | undefined;
    gridIngredientPHvaryAlongNavigation?: GridIngredient[] | undefined;

    constructor(data?: IGridVaryAlong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["grid"])) {
                this.grid = [] as any;
                for (let item of _data["grid"])
                    this.grid!.push(Grid.fromJS(item));
            }
            if (Array.isArray(_data["gridIngredientConcentrationVaryAlongNavigation"])) {
                this.gridIngredientConcentrationVaryAlongNavigation = [] as any;
                for (let item of _data["gridIngredientConcentrationVaryAlongNavigation"])
                    this.gridIngredientConcentrationVaryAlongNavigation!.push(GridIngredient.fromJS(item));
            }
            if (Array.isArray(_data["gridIngredientPHvaryAlongNavigation"])) {
                this.gridIngredientPHvaryAlongNavigation = [] as any;
                for (let item of _data["gridIngredientPHvaryAlongNavigation"])
                    this.gridIngredientPHvaryAlongNavigation!.push(GridIngredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GridVaryAlong {
        data = typeof data === 'object' ? data : {};
        let result = new GridVaryAlong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.grid)) {
            data["grid"] = [];
            for (let item of this.grid)
                data["grid"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gridIngredientConcentrationVaryAlongNavigation)) {
            data["gridIngredientConcentrationVaryAlongNavigation"] = [];
            for (let item of this.gridIngredientConcentrationVaryAlongNavigation)
                data["gridIngredientConcentrationVaryAlongNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gridIngredientPHvaryAlongNavigation)) {
            data["gridIngredientPHvaryAlongNavigation"] = [];
            for (let item of this.gridIngredientPHvaryAlongNavigation)
                data["gridIngredientPHvaryAlongNavigation"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGridVaryAlong {
    id: number;
    name?: string | undefined;
    grid?: Grid[] | undefined;
    gridIngredientConcentrationVaryAlongNavigation?: GridIngredient[] | undefined;
    gridIngredientPHvaryAlongNavigation?: GridIngredient[] | undefined;
}

export class GridIngredient implements IGridIngredient {
    id!: number;
    gridId!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    startConcentration!: number;
    stopConcentration!: number;
    concentrationVaryAlong!: number;
    startpH?: number | undefined;
    stoppH?: number | undefined;
    pHvaryAlong?: number | undefined;
    concentrationVaryAlongNavigation?: GridVaryAlong | undefined;
    grid?: Grid | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    pHvaryAlongNavigation?: GridVaryAlong | undefined;
    gridVaryAlongCustom?: GridVaryAlongCustom[] | undefined;

    constructor(data?: IGridIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gridId = _data["gridId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.startConcentration = _data["startConcentration"];
            this.stopConcentration = _data["stopConcentration"];
            this.concentrationVaryAlong = _data["concentrationVaryAlong"];
            this.startpH = _data["startpH"];
            this.stoppH = _data["stoppH"];
            this.pHvaryAlong = _data["pHvaryAlong"];
            this.concentrationVaryAlongNavigation = _data["concentrationVaryAlongNavigation"] ? GridVaryAlong.fromJS(_data["concentrationVaryAlongNavigation"]) : undefined as any;
            this.grid = _data["grid"] ? Grid.fromJS(_data["grid"]) : undefined as any;
            this.highPhingredientStock = _data["highPhingredientStock"] ? IngredientStock.fromJS(_data["highPhingredientStock"]) : undefined as any;
            this.ingredientIngredientType = _data["ingredientIngredientType"] ? IngredientIngredientType.fromJS(_data["ingredientIngredientType"]) : undefined as any;
            this.ingredientStock = _data["ingredientStock"] ? IngredientStock.fromJS(_data["ingredientStock"]) : undefined as any;
            this.pHvaryAlongNavigation = _data["pHvaryAlongNavigation"] ? GridVaryAlong.fromJS(_data["pHvaryAlongNavigation"]) : undefined as any;
            if (Array.isArray(_data["gridVaryAlongCustom"])) {
                this.gridVaryAlongCustom = [] as any;
                for (let item of _data["gridVaryAlongCustom"])
                    this.gridVaryAlongCustom!.push(GridVaryAlongCustom.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GridIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new GridIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gridId"] = this.gridId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["startConcentration"] = this.startConcentration;
        data["stopConcentration"] = this.stopConcentration;
        data["concentrationVaryAlong"] = this.concentrationVaryAlong;
        data["startpH"] = this.startpH;
        data["stoppH"] = this.stoppH;
        data["pHvaryAlong"] = this.pHvaryAlong;
        data["concentrationVaryAlongNavigation"] = this.concentrationVaryAlongNavigation ? this.concentrationVaryAlongNavigation.toJSON() : undefined as any;
        data["grid"] = this.grid ? this.grid.toJSON() : undefined as any;
        data["highPhingredientStock"] = this.highPhingredientStock ? this.highPhingredientStock.toJSON() : undefined as any;
        data["ingredientIngredientType"] = this.ingredientIngredientType ? this.ingredientIngredientType.toJSON() : undefined as any;
        data["ingredientStock"] = this.ingredientStock ? this.ingredientStock.toJSON() : undefined as any;
        data["pHvaryAlongNavigation"] = this.pHvaryAlongNavigation ? this.pHvaryAlongNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.gridVaryAlongCustom)) {
            data["gridVaryAlongCustom"] = [];
            for (let item of this.gridVaryAlongCustom)
                data["gridVaryAlongCustom"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGridIngredient {
    id: number;
    gridId: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    startConcentration: number;
    stopConcentration: number;
    concentrationVaryAlong: number;
    startpH?: number | undefined;
    stoppH?: number | undefined;
    pHvaryAlong?: number | undefined;
    concentrationVaryAlongNavigation?: GridVaryAlong | undefined;
    grid?: Grid | undefined;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    pHvaryAlongNavigation?: GridVaryAlong | undefined;
    gridVaryAlongCustom?: GridVaryAlongCustom[] | undefined;
}

export class GridVaryAlongCustom implements IGridVaryAlongCustom {
    id!: number;
    csv?: string | undefined;
    gridIngredientId!: number;
    csvph?: string | undefined;
    gridIngredient?: GridIngredient | undefined;

    constructor(data?: IGridVaryAlongCustom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.csv = _data["csv"];
            this.gridIngredientId = _data["gridIngredientId"];
            this.csvph = _data["csvph"];
            this.gridIngredient = _data["gridIngredient"] ? GridIngredient.fromJS(_data["gridIngredient"]) : undefined as any;
        }
    }

    static fromJS(data: any): GridVaryAlongCustom {
        data = typeof data === 'object' ? data : {};
        let result = new GridVaryAlongCustom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["csv"] = this.csv;
        data["gridIngredientId"] = this.gridIngredientId;
        data["csvph"] = this.csvph;
        data["gridIngredient"] = this.gridIngredient ? this.gridIngredient.toJSON() : undefined as any;
        return data;
    }
}

export interface IGridVaryAlongCustom {
    id: number;
    csv?: string | undefined;
    gridIngredientId: number;
    csvph?: string | undefined;
    gridIngredient?: GridIngredient | undefined;
}

export enum ExperimentStatus {
    None = 0,
    RestoredWithWarning = 1,
}

export class ExperimentCaptureProfileTuningValues implements IExperimentCaptureProfileTuningValues {
    id!: number;
    experimentId!: number;
    captureProfileId!: number;
    autoLevelingOn!: boolean;
    autoLevelingLowThreshold!: number;
    autoLevelingHighThreshold!: number;
    lowerLevelLimit!: number;
    upperLevelLimit!: number;
    brightness!: number;
    contrast!: number;
    gamma!: number;
    autoLevelingMode!: number;
    captureProfile?: CaptureProfile | undefined;
    experiment?: Experiment | undefined;

    constructor(data?: IExperimentCaptureProfileTuningValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.captureProfileId = _data["captureProfileId"];
            this.autoLevelingOn = _data["autoLevelingOn"];
            this.autoLevelingLowThreshold = _data["autoLevelingLowThreshold"];
            this.autoLevelingHighThreshold = _data["autoLevelingHighThreshold"];
            this.lowerLevelLimit = _data["lowerLevelLimit"];
            this.upperLevelLimit = _data["upperLevelLimit"];
            this.brightness = _data["brightness"];
            this.contrast = _data["contrast"];
            this.gamma = _data["gamma"];
            this.autoLevelingMode = _data["autoLevelingMode"];
            this.captureProfile = _data["captureProfile"] ? CaptureProfile.fromJS(_data["captureProfile"]) : undefined as any;
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExperimentCaptureProfileTuningValues {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentCaptureProfileTuningValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["captureProfileId"] = this.captureProfileId;
        data["autoLevelingOn"] = this.autoLevelingOn;
        data["autoLevelingLowThreshold"] = this.autoLevelingLowThreshold;
        data["autoLevelingHighThreshold"] = this.autoLevelingHighThreshold;
        data["lowerLevelLimit"] = this.lowerLevelLimit;
        data["upperLevelLimit"] = this.upperLevelLimit;
        data["brightness"] = this.brightness;
        data["contrast"] = this.contrast;
        data["gamma"] = this.gamma;
        data["autoLevelingMode"] = this.autoLevelingMode;
        data["captureProfile"] = this.captureProfile ? this.captureProfile.toJSON() : undefined as any;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        return data;
    }
}

export interface IExperimentCaptureProfileTuningValues {
    id: number;
    experimentId: number;
    captureProfileId: number;
    autoLevelingOn: boolean;
    autoLevelingLowThreshold: number;
    autoLevelingHighThreshold: number;
    lowerLevelLimit: number;
    upperLevelLimit: number;
    brightness: number;
    contrast: number;
    gamma: number;
    autoLevelingMode: number;
    captureProfile?: CaptureProfile | undefined;
    experiment?: Experiment | undefined;
}

export class MicrofluidicsExperiment implements IMicrofluidicsExperiment {
    id!: number;
    experimentId!: number;
    fidTime?: number | undefined;
    experiment?: Experiment | undefined;

    constructor(data?: IMicrofluidicsExperiment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.fidTime = _data["fidTime"];
            this.experiment = _data["experiment"] ? Experiment.fromJS(_data["experiment"]) : undefined as any;
        }
    }

    static fromJS(data: any): MicrofluidicsExperiment {
        data = typeof data === 'object' ? data : {};
        let result = new MicrofluidicsExperiment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["fidTime"] = this.fidTime;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        return data;
    }
}

export interface IMicrofluidicsExperiment {
    id: number;
    experimentId: number;
    fidTime?: number | undefined;
    experiment?: Experiment | undefined;
}

export class RandomLayerIngredientGroup implements IRandomLayerIngredientGroup {
    id!: number;
    randomLayerId!: number;
    name?: string | undefined;
    randomLayer?: RandomLayer | undefined;
    randomLayerGenerationList?: RandomLayerGenerationList[] | undefined;
    randomLayerGroupIngredient?: RandomLayerGroupIngredient[] | undefined;

    constructor(data?: IRandomLayerIngredientGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.randomLayerId = _data["randomLayerId"];
            this.name = _data["name"];
            this.randomLayer = _data["randomLayer"] ? RandomLayer.fromJS(_data["randomLayer"]) : undefined as any;
            if (Array.isArray(_data["randomLayerGenerationList"])) {
                this.randomLayerGenerationList = [] as any;
                for (let item of _data["randomLayerGenerationList"])
                    this.randomLayerGenerationList!.push(RandomLayerGenerationList.fromJS(item));
            }
            if (Array.isArray(_data["randomLayerGroupIngredient"])) {
                this.randomLayerGroupIngredient = [] as any;
                for (let item of _data["randomLayerGroupIngredient"])
                    this.randomLayerGroupIngredient!.push(RandomLayerGroupIngredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RandomLayerIngredientGroup {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayerIngredientGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["randomLayerId"] = this.randomLayerId;
        data["name"] = this.name;
        data["randomLayer"] = this.randomLayer ? this.randomLayer.toJSON() : undefined as any;
        if (Array.isArray(this.randomLayerGenerationList)) {
            data["randomLayerGenerationList"] = [];
            for (let item of this.randomLayerGenerationList)
                data["randomLayerGenerationList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.randomLayerGroupIngredient)) {
            data["randomLayerGroupIngredient"] = [];
            for (let item of this.randomLayerGroupIngredient)
                data["randomLayerGroupIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRandomLayerIngredientGroup {
    id: number;
    randomLayerId: number;
    name?: string | undefined;
    randomLayer?: RandomLayer | undefined;
    randomLayerGenerationList?: RandomLayerGenerationList[] | undefined;
    randomLayerGroupIngredient?: RandomLayerGroupIngredient[] | undefined;
}

export class RandomLayerGenerationList implements IRandomLayerGenerationList {
    id!: number;
    randomLayerId!: number;
    randomLayerIngredientGroupId!: number;
    probability!: number;
    randomLayerIngredientGroup?: RandomLayerIngredientGroup | undefined;

    constructor(data?: IRandomLayerGenerationList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.randomLayerId = _data["randomLayerId"];
            this.randomLayerIngredientGroupId = _data["randomLayerIngredientGroupId"];
            this.probability = _data["probability"];
            this.randomLayerIngredientGroup = _data["randomLayerIngredientGroup"] ? RandomLayerIngredientGroup.fromJS(_data["randomLayerIngredientGroup"]) : undefined as any;
        }
    }

    static fromJS(data: any): RandomLayerGenerationList {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayerGenerationList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["randomLayerId"] = this.randomLayerId;
        data["randomLayerIngredientGroupId"] = this.randomLayerIngredientGroupId;
        data["probability"] = this.probability;
        data["randomLayerIngredientGroup"] = this.randomLayerIngredientGroup ? this.randomLayerIngredientGroup.toJSON() : undefined as any;
        return data;
    }
}

export interface IRandomLayerGenerationList {
    id: number;
    randomLayerId: number;
    randomLayerIngredientGroupId: number;
    probability: number;
    randomLayerIngredientGroup?: RandomLayerIngredientGroup | undefined;
}

export class RandomLayerGroupIngredient implements IRandomLayerGroupIngredient {
    id!: number;
    randomLayerIngredientGroupId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    ingredientIngredientTypeId!: number;
    lowConcentration!: number;
    highConcentration!: number;
    lowPh?: number | undefined;
    highPh?: number | undefined;
    weight!: number;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    randomLayerIngredientGroup?: RandomLayerIngredientGroup | undefined;

    constructor(data?: IRandomLayerGroupIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.randomLayerIngredientGroupId = _data["randomLayerIngredientGroupId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.lowConcentration = _data["lowConcentration"];
            this.highConcentration = _data["highConcentration"];
            this.lowPh = _data["lowPh"];
            this.highPh = _data["highPh"];
            this.weight = _data["weight"];
            this.highPhingredientStock = _data["highPhingredientStock"] ? IngredientStock.fromJS(_data["highPhingredientStock"]) : undefined as any;
            this.ingredientIngredientType = _data["ingredientIngredientType"] ? IngredientIngredientType.fromJS(_data["ingredientIngredientType"]) : undefined as any;
            this.ingredientStock = _data["ingredientStock"] ? IngredientStock.fromJS(_data["ingredientStock"]) : undefined as any;
            this.randomLayerIngredientGroup = _data["randomLayerIngredientGroup"] ? RandomLayerIngredientGroup.fromJS(_data["randomLayerIngredientGroup"]) : undefined as any;
        }
    }

    static fromJS(data: any): RandomLayerGroupIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayerGroupIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["randomLayerIngredientGroupId"] = this.randomLayerIngredientGroupId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["lowConcentration"] = this.lowConcentration;
        data["highConcentration"] = this.highConcentration;
        data["lowPh"] = this.lowPh;
        data["highPh"] = this.highPh;
        data["weight"] = this.weight;
        data["highPhingredientStock"] = this.highPhingredientStock ? this.highPhingredientStock.toJSON() : undefined as any;
        data["ingredientIngredientType"] = this.ingredientIngredientType ? this.ingredientIngredientType.toJSON() : undefined as any;
        data["ingredientStock"] = this.ingredientStock ? this.ingredientStock.toJSON() : undefined as any;
        data["randomLayerIngredientGroup"] = this.randomLayerIngredientGroup ? this.randomLayerIngredientGroup.toJSON() : undefined as any;
        return data;
    }
}

export interface IRandomLayerGroupIngredient {
    id: number;
    randomLayerIngredientGroupId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    ingredientIngredientTypeId: number;
    lowConcentration: number;
    highConcentration: number;
    lowPh?: number | undefined;
    highPh?: number | undefined;
    weight: number;
    highPhingredientStock?: IngredientStock | undefined;
    ingredientIngredientType?: IngredientIngredientType | undefined;
    ingredientStock?: IngredientStock | undefined;
    randomLayerIngredientGroup?: RandomLayerIngredientGroup | undefined;
}

export class Vendor implements IVendor {
    id!: number;
    name?: string | undefined;
    ingredientStock?: IngredientStock[] | undefined;

    constructor(data?: IVendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["ingredientStock"])) {
                this.ingredientStock = [] as any;
                for (let item of _data["ingredientStock"])
                    this.ingredientStock!.push(IngredientStock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Vendor {
        data = typeof data === 'object' ? data : {};
        let result = new Vendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.ingredientStock)) {
            data["ingredientStock"] = [];
            for (let item of this.ingredientStock)
                data["ingredientStock"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVendor {
    id: number;
    name?: string | undefined;
    ingredientStock?: IngredientStock[] | undefined;
}

export class DispenseQueue implements IDispenseQueue {
    id!: number;
    plateId?: number | undefined;
    dateQueued!: Date;
    dispensingRobotId?: number | undefined;
    dispensingRobot?: DispensingRobot | undefined;
    plate?: Plate | undefined;

    constructor(data?: IDispenseQueue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plateId = _data["plateId"];
            this.dateQueued = _data["dateQueued"] ? new Date(_data["dateQueued"].toString()) : undefined as any;
            this.dispensingRobotId = _data["dispensingRobotId"];
            this.dispensingRobot = _data["dispensingRobot"] ? DispensingRobot.fromJS(_data["dispensingRobot"]) : undefined as any;
            this.plate = _data["plate"] ? Plate.fromJS(_data["plate"]) : undefined as any;
        }
    }

    static fromJS(data: any): DispenseQueue {
        data = typeof data === 'object' ? data : {};
        let result = new DispenseQueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plateId"] = this.plateId;
        data["dateQueued"] = this.dateQueued ? this.dateQueued.toISOString() : undefined as any;
        data["dispensingRobotId"] = this.dispensingRobotId;
        data["dispensingRobot"] = this.dispensingRobot ? this.dispensingRobot.toJSON() : undefined as any;
        data["plate"] = this.plate ? this.plate.toJSON() : undefined as any;
        return data;
    }
}

export interface IDispenseQueue {
    id: number;
    plateId?: number | undefined;
    dateQueued: Date;
    dispensingRobotId?: number | undefined;
    dispensingRobot?: DispensingRobot | undefined;
    plate?: Plate | undefined;
}

export class DriverProperty implements IDriverProperty {
    id!: number;
    name?: string | undefined;
    value?: string | undefined;
    dispensingRobotId!: number;
    foreignKeyTable?: string | undefined;
    foreignKeyId?: number | undefined;
    dispensingRobot?: DispensingRobot | undefined;

    constructor(data?: IDriverProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.dispensingRobotId = _data["dispensingRobotId"];
            this.foreignKeyTable = _data["foreignKeyTable"];
            this.foreignKeyId = _data["foreignKeyId"];
            this.dispensingRobot = _data["dispensingRobot"] ? DispensingRobot.fromJS(_data["dispensingRobot"]) : undefined as any;
        }
    }

    static fromJS(data: any): DriverProperty {
        data = typeof data === 'object' ? data : {};
        let result = new DriverProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["dispensingRobotId"] = this.dispensingRobotId;
        data["foreignKeyTable"] = this.foreignKeyTable;
        data["foreignKeyId"] = this.foreignKeyId;
        data["dispensingRobot"] = this.dispensingRobot ? this.dispensingRobot.toJSON() : undefined as any;
        return data;
    }
}

export interface IDriverProperty {
    id: number;
    name?: string | undefined;
    value?: string | undefined;
    dispensingRobotId: number;
    foreignKeyTable?: string | undefined;
    foreignKeyId?: number | undefined;
    dispensingRobot?: DispensingRobot | undefined;
}

export class PlateEvents implements IPlateEvents {
    id!: number;
    plateId!: number;
    plateEventTypeId!: number;
    eventDate!: Date;
    plate?: Plate | undefined;
    plateEventType?: PlateEventType | undefined;

    constructor(data?: IPlateEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plateId = _data["plateId"];
            this.plateEventTypeId = _data["plateEventTypeId"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : undefined as any;
            this.plate = _data["plate"] ? Plate.fromJS(_data["plate"]) : undefined as any;
            this.plateEventType = _data["plateEventType"] ? PlateEventType.fromJS(_data["plateEventType"]) : undefined as any;
        }
    }

    static fromJS(data: any): PlateEvents {
        data = typeof data === 'object' ? data : {};
        let result = new PlateEvents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plateId"] = this.plateId;
        data["plateEventTypeId"] = this.plateEventTypeId;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : undefined as any;
        data["plate"] = this.plate ? this.plate.toJSON() : undefined as any;
        data["plateEventType"] = this.plateEventType ? this.plateEventType.toJSON() : undefined as any;
        return data;
    }
}

export interface IPlateEvents {
    id: number;
    plateId: number;
    plateEventTypeId: number;
    eventDate: Date;
    plate?: Plate | undefined;
    plateEventType?: PlateEventType | undefined;
}

export class PlateEventType implements IPlateEventType {
    id!: number;
    name?: string | undefined;
    value!: number;
    plateEvents?: PlateEvents[] | undefined;

    constructor(data?: IPlateEventType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            if (Array.isArray(_data["plateEvents"])) {
                this.plateEvents = [] as any;
                for (let item of _data["plateEvents"])
                    this.plateEvents!.push(PlateEvents.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlateEventType {
        data = typeof data === 'object' ? data : {};
        let result = new PlateEventType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        if (Array.isArray(this.plateEvents)) {
            data["plateEvents"] = [];
            for (let item of this.plateEvents)
                data["plateEvents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPlateEventType {
    id: number;
    name?: string | undefined;
    value: number;
    plateEvents?: PlateEvents[] | undefined;
}

export class CaptureProfileTuningValues implements ICaptureProfileTuningValues {
    id!: number;
    captureProfileId!: number;
    autoLevelingOn!: boolean;
    autoLevelingMode!: number;
    autoLevelingLowThreshold!: number;
    autoLevelingHighThreshold!: number;
    lowerLevelLimit!: number;
    upperLevelLimit!: number;
    brightness!: number;
    contrast!: number;
    gamma!: number;
    captureProfile?: CaptureProfile | undefined;

    constructor(data?: ICaptureProfileTuningValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.captureProfileId = _data["captureProfileId"];
            this.autoLevelingOn = _data["autoLevelingOn"];
            this.autoLevelingMode = _data["autoLevelingMode"];
            this.autoLevelingLowThreshold = _data["autoLevelingLowThreshold"];
            this.autoLevelingHighThreshold = _data["autoLevelingHighThreshold"];
            this.lowerLevelLimit = _data["lowerLevelLimit"];
            this.upperLevelLimit = _data["upperLevelLimit"];
            this.brightness = _data["brightness"];
            this.contrast = _data["contrast"];
            this.gamma = _data["gamma"];
            this.captureProfile = _data["captureProfile"] ? CaptureProfile.fromJS(_data["captureProfile"]) : undefined as any;
        }
    }

    static fromJS(data: any): CaptureProfileTuningValues {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProfileTuningValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureProfileId"] = this.captureProfileId;
        data["autoLevelingOn"] = this.autoLevelingOn;
        data["autoLevelingMode"] = this.autoLevelingMode;
        data["autoLevelingLowThreshold"] = this.autoLevelingLowThreshold;
        data["autoLevelingHighThreshold"] = this.autoLevelingHighThreshold;
        data["lowerLevelLimit"] = this.lowerLevelLimit;
        data["upperLevelLimit"] = this.upperLevelLimit;
        data["brightness"] = this.brightness;
        data["contrast"] = this.contrast;
        data["gamma"] = this.gamma;
        data["captureProfile"] = this.captureProfile ? this.captureProfile.toJSON() : undefined as any;
        return data;
    }
}

export interface ICaptureProfileTuningValues {
    id: number;
    captureProfileId: number;
    autoLevelingOn: boolean;
    autoLevelingMode: number;
    autoLevelingLowThreshold: number;
    autoLevelingHighThreshold: number;
    lowerLevelLimit: number;
    upperLevelLimit: number;
    brightness: number;
    contrast: number;
    gamma: number;
    captureProfile?: CaptureProfile | undefined;
}

export class SaveRegionCaptureProfilesDTO implements ISaveRegionCaptureProfilesDTO {
    regionCaptureProfiles?: RegionCaptureProfile[] | undefined;
    isDeleteProfiles!: boolean;

    constructor(data?: ISaveRegionCaptureProfilesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["regionCaptureProfiles"])) {
                this.regionCaptureProfiles = [] as any;
                for (let item of _data["regionCaptureProfiles"])
                    this.regionCaptureProfiles!.push(RegionCaptureProfile.fromJS(item));
            }
            this.isDeleteProfiles = _data["isDeleteProfiles"];
        }
    }

    static fromJS(data: any): SaveRegionCaptureProfilesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRegionCaptureProfilesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regionCaptureProfiles)) {
            data["regionCaptureProfiles"] = [];
            for (let item of this.regionCaptureProfiles)
                data["regionCaptureProfiles"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleteProfiles"] = this.isDeleteProfiles;
        return data;
    }
}

export interface ISaveRegionCaptureProfilesDTO {
    regionCaptureProfiles?: RegionCaptureProfile[] | undefined;
    isDeleteProfiles: boolean;
}

export class RegionCaptureProfileDTO implements IRegionCaptureProfileDTO {
    id!: number;
    regionId!: number;
    captureProfileId!: number;
    imagingEnabled!: boolean;
    captureProfile?: CaptureProfilesDTO | undefined;

    constructor(data?: IRegionCaptureProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionId = _data["regionId"];
            this.captureProfileId = _data["captureProfileId"];
            this.imagingEnabled = _data["imagingEnabled"];
            this.captureProfile = _data["captureProfile"] ? CaptureProfilesDTO.fromJS(_data["captureProfile"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegionCaptureProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionCaptureProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionId"] = this.regionId;
        data["captureProfileId"] = this.captureProfileId;
        data["imagingEnabled"] = this.imagingEnabled;
        data["captureProfile"] = this.captureProfile ? this.captureProfile.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegionCaptureProfileDTO {
    id: number;
    regionId: number;
    captureProfileId: number;
    imagingEnabled: boolean;
    captureProfile?: CaptureProfilesDTO | undefined;
}

export class CaptureProfilesDTO implements ICaptureProfilesDTO {
    id!: number;
    name?: string | undefined;
    imageBatchId!: number;
    dateImaged?: Date | undefined;
    cpvId!: number;

    constructor(data?: ICaptureProfilesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageBatchId = _data["imageBatchId"];
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.cpvId = _data["cpvId"];
        }
    }

    static fromJS(data: any): CaptureProfilesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProfilesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageBatchId"] = this.imageBatchId;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["cpvId"] = this.cpvId;
        return data;
    }
}

export interface ICaptureProfilesDTO {
    id: number;
    name?: string | undefined;
    imageBatchId: number;
    dateImaged?: Date | undefined;
    cpvId: number;
}

export class DropImageSettingsDTO implements IDropImageSettingsDTO {
    captureProfileName?: string | undefined;
    expId!: number;
    regionIds?: number[] | undefined;
    isCustomized!: boolean;
    isNone!: boolean;
    isCustomizedDeleted!: boolean;

    constructor(data?: IDropImageSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captureProfileName = _data["captureProfileName"];
            this.expId = _data["expId"];
            if (Array.isArray(_data["regionIds"])) {
                this.regionIds = [] as any;
                for (let item of _data["regionIds"])
                    this.regionIds!.push(item);
            }
            this.isCustomized = _data["isCustomized"];
            this.isNone = _data["isNone"];
            this.isCustomizedDeleted = _data["isCustomizedDeleted"];
        }
    }

    static fromJS(data: any): DropImageSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DropImageSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captureProfileName"] = this.captureProfileName;
        data["expId"] = this.expId;
        if (Array.isArray(this.regionIds)) {
            data["regionIds"] = [];
            for (let item of this.regionIds)
                data["regionIds"].push(item);
        }
        data["isCustomized"] = this.isCustomized;
        data["isNone"] = this.isNone;
        data["isCustomizedDeleted"] = this.isCustomizedDeleted;
        return data;
    }
}

export interface IDropImageSettingsDTO {
    captureProfileName?: string | undefined;
    expId: number;
    regionIds?: number[] | undefined;
    isCustomized: boolean;
    isNone: boolean;
    isCustomizedDeleted: boolean;
}

export class SavePlateTypeDTO implements ISavePlateTypeDTO {
    saveContainerDTOs?: SaveContainerDTO[] | undefined;
    deleteContainerIds?: number[] | undefined;
    deleteContainerDropsIds?: number[] | undefined;
    isInUse!: boolean;

    constructor(data?: ISavePlateTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["saveContainerDTOs"])) {
                this.saveContainerDTOs = [] as any;
                for (let item of _data["saveContainerDTOs"])
                    this.saveContainerDTOs!.push(SaveContainerDTO.fromJS(item));
            }
            if (Array.isArray(_data["deleteContainerIds"])) {
                this.deleteContainerIds = [] as any;
                for (let item of _data["deleteContainerIds"])
                    this.deleteContainerIds!.push(item);
            }
            if (Array.isArray(_data["deleteContainerDropsIds"])) {
                this.deleteContainerDropsIds = [] as any;
                for (let item of _data["deleteContainerDropsIds"])
                    this.deleteContainerDropsIds!.push(item);
            }
            this.isInUse = _data["isInUse"];
        }
    }

    static fromJS(data: any): SavePlateTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SavePlateTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.saveContainerDTOs)) {
            data["saveContainerDTOs"] = [];
            for (let item of this.saveContainerDTOs)
                data["saveContainerDTOs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteContainerIds)) {
            data["deleteContainerIds"] = [];
            for (let item of this.deleteContainerIds)
                data["deleteContainerIds"].push(item);
        }
        if (Array.isArray(this.deleteContainerDropsIds)) {
            data["deleteContainerDropsIds"] = [];
            for (let item of this.deleteContainerDropsIds)
                data["deleteContainerDropsIds"].push(item);
        }
        data["isInUse"] = this.isInUse;
        return data;
    }
}

export interface ISavePlateTypeDTO {
    saveContainerDTOs?: SaveContainerDTO[] | undefined;
    deleteContainerIds?: number[] | undefined;
    deleteContainerDropsIds?: number[] | undefined;
    isInUse: boolean;
}

export class SaveContainerDTO implements ISaveContainerDTO {
    containerDrops?: SaveContainerDropDTO[] | undefined;
    id!: number;
    name?: string | undefined;
    numRows!: number;
    numColumns!: number;
    defaultWellVolume!: number;
    defaultAdditiveVolume!: number;
    maxWellVolume!: number;
    maxNumDrops!: number;
    defaultDropVolume!: number;
    maxDropVolume!: number;
    type!: number;
    enable?: boolean | undefined;
    defaultSeedVolume?: number | undefined;
    defaultFragmentVolume?: number | undefined;
    inUse!: boolean;
    isAtImager!: boolean;

    constructor(data?: ISaveContainerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["containerDrops"])) {
                this.containerDrops = [] as any;
                for (let item of _data["containerDrops"])
                    this.containerDrops!.push(SaveContainerDropDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.numRows = _data["numRows"];
            this.numColumns = _data["numColumns"];
            this.defaultWellVolume = _data["defaultWellVolume"];
            this.defaultAdditiveVolume = _data["defaultAdditiveVolume"];
            this.maxWellVolume = _data["maxWellVolume"];
            this.maxNumDrops = _data["maxNumDrops"];
            this.defaultDropVolume = _data["defaultDropVolume"];
            this.maxDropVolume = _data["maxDropVolume"];
            this.type = _data["type"];
            this.enable = _data["enable"];
            this.defaultSeedVolume = _data["defaultSeedVolume"];
            this.defaultFragmentVolume = _data["defaultFragmentVolume"];
            this.inUse = _data["inUse"];
            this.isAtImager = _data["isAtImager"];
        }
    }

    static fromJS(data: any): SaveContainerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveContainerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.containerDrops)) {
            data["containerDrops"] = [];
            for (let item of this.containerDrops)
                data["containerDrops"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["numRows"] = this.numRows;
        data["numColumns"] = this.numColumns;
        data["defaultWellVolume"] = this.defaultWellVolume;
        data["defaultAdditiveVolume"] = this.defaultAdditiveVolume;
        data["maxWellVolume"] = this.maxWellVolume;
        data["maxNumDrops"] = this.maxNumDrops;
        data["defaultDropVolume"] = this.defaultDropVolume;
        data["maxDropVolume"] = this.maxDropVolume;
        data["type"] = this.type;
        data["enable"] = this.enable;
        data["defaultSeedVolume"] = this.defaultSeedVolume;
        data["defaultFragmentVolume"] = this.defaultFragmentVolume;
        data["inUse"] = this.inUse;
        data["isAtImager"] = this.isAtImager;
        return data;
    }
}

export interface ISaveContainerDTO {
    containerDrops?: SaveContainerDropDTO[] | undefined;
    id: number;
    name?: string | undefined;
    numRows: number;
    numColumns: number;
    defaultWellVolume: number;
    defaultAdditiveVolume: number;
    maxWellVolume: number;
    maxNumDrops: number;
    defaultDropVolume: number;
    maxDropVolume: number;
    type: number;
    enable?: boolean | undefined;
    defaultSeedVolume?: number | undefined;
    defaultFragmentVolume?: number | undefined;
    inUse: boolean;
    isAtImager: boolean;
}

export class SaveContainerDropDTO implements ISaveContainerDropDTO {
    id!: number;
    containerId!: number;
    dropNumber!: number;

    constructor(data?: ISaveContainerDropDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerId = _data["containerId"];
            this.dropNumber = _data["dropNumber"];
        }
    }

    static fromJS(data: any): SaveContainerDropDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveContainerDropDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerId"] = this.containerId;
        data["dropNumber"] = this.dropNumber;
        return data;
    }
}

export interface ISaveContainerDropDTO {
    id: number;
    containerId: number;
    dropNumber: number;
}

export class CryoDTO implements ICryoDTO {
    id?: number | undefined;
    ingredient?: string | undefined;
    conc?: number | undefined;
    concUnit?: string | undefined;
    pH?: number | undefined;
    protocol?: string | undefined;
    userId?: number | undefined;
    sourceWellId?: number | undefined;

    constructor(data?: ICryoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredient = _data["ingredient"];
            this.conc = _data["conc"];
            this.concUnit = _data["concUnit"];
            this.pH = _data["pH"];
            this.protocol = _data["protocol"];
            this.userId = _data["userId"];
            this.sourceWellId = _data["sourceWellId"];
        }
    }

    static fromJS(data: any): CryoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CryoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredient"] = this.ingredient;
        data["conc"] = this.conc;
        data["concUnit"] = this.concUnit;
        data["pH"] = this.pH;
        data["protocol"] = this.protocol;
        data["userId"] = this.userId;
        data["sourceWellId"] = this.sourceWellId;
        return data;
    }
}

export interface ICryoDTO {
    id?: number | undefined;
    ingredient?: string | undefined;
    conc?: number | undefined;
    concUnit?: string | undefined;
    pH?: number | undefined;
    protocol?: string | undefined;
    userId?: number | undefined;
    sourceWellId?: number | undefined;
}

export class CrystalCryoDTO implements ICrystalCryoDTO {
    id!: number;
    crystalId!: number;
    cryoprotectantID!: number;

    constructor(data?: ICrystalCryoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crystalId = _data["crystalId"];
            this.cryoprotectantID = _data["cryoprotectantID"];
        }
    }

    static fromJS(data: any): CrystalCryoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalCryoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crystalId"] = this.crystalId;
        data["cryoprotectantID"] = this.cryoprotectantID;
        return data;
    }
}

export interface ICrystalCryoDTO {
    id: number;
    crystalId: number;
    cryoprotectantID: number;
}

export class CrystalDTO implements ICrystalDTO {
    id!: number;
    name?: string | undefined;
    plateId?: number | undefined;
    wellNumber?: number | undefined;
    dataCollected!: boolean;
    regionId!: number;
    regionName?: string | undefined;
    captureProfileVersionId!: number;
    imageBatchId!: number;
    projectName?: string | undefined;
    experimentName?: string | undefined;
    ownerName?: string | undefined;
    barcode?: string | undefined;
    wellRowCol?: string | undefined;
    dropNumber!: number;
    synchTripName?: string | undefined;
    synchrotronTripId?: number | undefined;
    dateCollected?: Date | undefined;
    ownerUserId!: number;
    crystalStatus?: number | undefined;
    harvestFrom?: string | undefined;
    proteinName?: string | undefined;
    dateFrozen?: Date | undefined;
    attachedFiles?: CrystalFilesDTO[] | undefined;
    notes?: string | undefined;
    isChecked!: boolean;
    proteinFormulationDTO?: PFDocProteinFormulationDTO | undefined;
    cryoprotectants?: Cryoprotectantv4[] | undefined;
    soakings?: Soakingv4[] | undefined;
    x?: number | undefined;
    y?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    assignedPinPosition?: number | undefined;
    assignedPuckId?: number | undefined;
    assignedDewarId?: number | undefined;
    isAssignmentsUpdated?: boolean | undefined;
    result?: CrystalTripResultv4 | undefined;
    puckDewar?: CrystalPuckDewarDTO | undefined;
    crystalDropInfo?: CrystalDropInfo | undefined;

    constructor(data?: ICrystalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.plateId = _data["plateId"];
            this.wellNumber = _data["wellNumber"];
            this.dataCollected = _data["dataCollected"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.captureProfileVersionId = _data["captureProfileVersionId"];
            this.imageBatchId = _data["imageBatchId"];
            this.projectName = _data["projectName"];
            this.experimentName = _data["experimentName"];
            this.ownerName = _data["ownerName"];
            this.barcode = _data["barcode"];
            this.wellRowCol = _data["wellRowCol"];
            this.dropNumber = _data["dropNumber"];
            this.synchTripName = _data["synchTripName"];
            this.synchrotronTripId = _data["synchrotronTripId"];
            this.dateCollected = _data["dateCollected"] ? new Date(_data["dateCollected"].toString()) : undefined as any;
            this.ownerUserId = _data["ownerUserId"];
            this.crystalStatus = _data["crystalStatus"];
            this.harvestFrom = _data["harvestFrom"];
            this.proteinName = _data["proteinName"];
            this.dateFrozen = _data["dateFrozen"] ? new Date(_data["dateFrozen"].toString()) : undefined as any;
            if (Array.isArray(_data["attachedFiles"])) {
                this.attachedFiles = [] as any;
                for (let item of _data["attachedFiles"])
                    this.attachedFiles!.push(CrystalFilesDTO.fromJS(item));
            }
            this.notes = _data["notes"];
            this.isChecked = _data["isChecked"];
            this.proteinFormulationDTO = _data["proteinFormulationDTO"] ? PFDocProteinFormulationDTO.fromJS(_data["proteinFormulationDTO"]) : undefined as any;
            if (Array.isArray(_data["cryoprotectants"])) {
                this.cryoprotectants = [] as any;
                for (let item of _data["cryoprotectants"])
                    this.cryoprotectants!.push(Cryoprotectantv4.fromJS(item));
            }
            if (Array.isArray(_data["soakings"])) {
                this.soakings = [] as any;
                for (let item of _data["soakings"])
                    this.soakings!.push(Soakingv4.fromJS(item));
            }
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.assignedPinPosition = _data["assignedPinPosition"];
            this.assignedPuckId = _data["assignedPuckId"];
            this.assignedDewarId = _data["assignedDewarId"];
            this.isAssignmentsUpdated = _data["isAssignmentsUpdated"];
            this.result = _data["result"] ? CrystalTripResultv4.fromJS(_data["result"]) : undefined as any;
            this.puckDewar = _data["puckDewar"] ? CrystalPuckDewarDTO.fromJS(_data["puckDewar"]) : undefined as any;
            this.crystalDropInfo = _data["crystalDropInfo"] ? CrystalDropInfo.fromJS(_data["crystalDropInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): CrystalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["plateId"] = this.plateId;
        data["wellNumber"] = this.wellNumber;
        data["dataCollected"] = this.dataCollected;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["captureProfileVersionId"] = this.captureProfileVersionId;
        data["imageBatchId"] = this.imageBatchId;
        data["projectName"] = this.projectName;
        data["experimentName"] = this.experimentName;
        data["ownerName"] = this.ownerName;
        data["barcode"] = this.barcode;
        data["wellRowCol"] = this.wellRowCol;
        data["dropNumber"] = this.dropNumber;
        data["synchTripName"] = this.synchTripName;
        data["synchrotronTripId"] = this.synchrotronTripId;
        data["dateCollected"] = this.dateCollected ? this.dateCollected.toISOString() : undefined as any;
        data["ownerUserId"] = this.ownerUserId;
        data["crystalStatus"] = this.crystalStatus;
        data["harvestFrom"] = this.harvestFrom;
        data["proteinName"] = this.proteinName;
        data["dateFrozen"] = this.dateFrozen ? this.dateFrozen.toISOString() : undefined as any;
        if (Array.isArray(this.attachedFiles)) {
            data["attachedFiles"] = [];
            for (let item of this.attachedFiles)
                data["attachedFiles"].push(item ? item.toJSON() : undefined as any);
        }
        data["notes"] = this.notes;
        data["isChecked"] = this.isChecked;
        data["proteinFormulationDTO"] = this.proteinFormulationDTO ? this.proteinFormulationDTO.toJSON() : undefined as any;
        if (Array.isArray(this.cryoprotectants)) {
            data["cryoprotectants"] = [];
            for (let item of this.cryoprotectants)
                data["cryoprotectants"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.soakings)) {
            data["soakings"] = [];
            for (let item of this.soakings)
                data["soakings"].push(item ? item.toJSON() : undefined as any);
        }
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["assignedPinPosition"] = this.assignedPinPosition;
        data["assignedPuckId"] = this.assignedPuckId;
        data["assignedDewarId"] = this.assignedDewarId;
        data["isAssignmentsUpdated"] = this.isAssignmentsUpdated;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        data["puckDewar"] = this.puckDewar ? this.puckDewar.toJSON() : undefined as any;
        data["crystalDropInfo"] = this.crystalDropInfo ? this.crystalDropInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface ICrystalDTO {
    id: number;
    name?: string | undefined;
    plateId?: number | undefined;
    wellNumber?: number | undefined;
    dataCollected: boolean;
    regionId: number;
    regionName?: string | undefined;
    captureProfileVersionId: number;
    imageBatchId: number;
    projectName?: string | undefined;
    experimentName?: string | undefined;
    ownerName?: string | undefined;
    barcode?: string | undefined;
    wellRowCol?: string | undefined;
    dropNumber: number;
    synchTripName?: string | undefined;
    synchrotronTripId?: number | undefined;
    dateCollected?: Date | undefined;
    ownerUserId: number;
    crystalStatus?: number | undefined;
    harvestFrom?: string | undefined;
    proteinName?: string | undefined;
    dateFrozen?: Date | undefined;
    attachedFiles?: CrystalFilesDTO[] | undefined;
    notes?: string | undefined;
    isChecked: boolean;
    proteinFormulationDTO?: PFDocProteinFormulationDTO | undefined;
    cryoprotectants?: Cryoprotectantv4[] | undefined;
    soakings?: Soakingv4[] | undefined;
    x?: number | undefined;
    y?: number | undefined;
    width?: number | undefined;
    height?: number | undefined;
    assignedPinPosition?: number | undefined;
    assignedPuckId?: number | undefined;
    assignedDewarId?: number | undefined;
    isAssignmentsUpdated?: boolean | undefined;
    result?: CrystalTripResultv4 | undefined;
    puckDewar?: CrystalPuckDewarDTO | undefined;
    crystalDropInfo?: CrystalDropInfo | undefined;
}

export class CrystalFilesDTO implements ICrystalFilesDTO {
    id!: number;
    fileName?: string | undefined;

    constructor(data?: ICrystalFilesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): CrystalFilesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalFilesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface ICrystalFilesDTO {
    id: number;
    fileName?: string | undefined;
}

export class PFDocProteinFormulationDTO implements IPFDocProteinFormulationDTO {
    id!: number;
    proteinLotId?: string | undefined;
    treeNodeId!: number;
    volume?: number | undefined;
    pfName?: string | undefined;
    storageTemperature?: number | undefined;
    pclass?: string | undefined;
    extinctionCoefficient?: string | undefined;
    notes?: string | undefined;
    notebookPageNo?: string | undefined;
    apidata?: string | undefined;
    datePrepared!: Date;
    proteinFormulationIngredient?: PFDocProteinFormulationIngredientsDTO[] | undefined;
    liquidClassId!: number;
    proteinFormulationStandardIngredient?: PFDocStandardIngredientsDTO[] | undefined;
    pfState!: PFStateDTO;
    proteinFormulationAttachments?: PFDocAttachmentDTO[] | undefined;
    accessRightName?: string | undefined;

    constructor(data?: IPFDocProteinFormulationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proteinLotId = _data["proteinLotId"];
            this.treeNodeId = _data["treeNodeId"];
            this.volume = _data["volume"];
            this.pfName = _data["pfName"];
            this.storageTemperature = _data["storageTemperature"];
            this.pclass = _data["pclass"];
            this.extinctionCoefficient = _data["extinctionCoefficient"];
            this.notes = _data["notes"];
            this.notebookPageNo = _data["notebookPageNo"];
            this.apidata = _data["apidata"];
            this.datePrepared = _data["datePrepared"] ? new Date(_data["datePrepared"].toString()) : undefined as any;
            if (Array.isArray(_data["proteinFormulationIngredient"])) {
                this.proteinFormulationIngredient = [] as any;
                for (let item of _data["proteinFormulationIngredient"])
                    this.proteinFormulationIngredient!.push(PFDocProteinFormulationIngredientsDTO.fromJS(item));
            }
            this.liquidClassId = _data["liquidClassId"];
            if (Array.isArray(_data["proteinFormulationStandardIngredient"])) {
                this.proteinFormulationStandardIngredient = [] as any;
                for (let item of _data["proteinFormulationStandardIngredient"])
                    this.proteinFormulationStandardIngredient!.push(PFDocStandardIngredientsDTO.fromJS(item));
            }
            this.pfState = _data["pfState"];
            if (Array.isArray(_data["proteinFormulationAttachments"])) {
                this.proteinFormulationAttachments = [] as any;
                for (let item of _data["proteinFormulationAttachments"])
                    this.proteinFormulationAttachments!.push(PFDocAttachmentDTO.fromJS(item));
            }
            this.accessRightName = _data["accessRightName"];
        }
    }

    static fromJS(data: any): PFDocProteinFormulationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocProteinFormulationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proteinLotId"] = this.proteinLotId;
        data["treeNodeId"] = this.treeNodeId;
        data["volume"] = this.volume;
        data["pfName"] = this.pfName;
        data["storageTemperature"] = this.storageTemperature;
        data["pclass"] = this.pclass;
        data["extinctionCoefficient"] = this.extinctionCoefficient;
        data["notes"] = this.notes;
        data["notebookPageNo"] = this.notebookPageNo;
        data["apidata"] = this.apidata;
        data["datePrepared"] = this.datePrepared ? this.datePrepared.toISOString() : undefined as any;
        if (Array.isArray(this.proteinFormulationIngredient)) {
            data["proteinFormulationIngredient"] = [];
            for (let item of this.proteinFormulationIngredient)
                data["proteinFormulationIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        data["liquidClassId"] = this.liquidClassId;
        if (Array.isArray(this.proteinFormulationStandardIngredient)) {
            data["proteinFormulationStandardIngredient"] = [];
            for (let item of this.proteinFormulationStandardIngredient)
                data["proteinFormulationStandardIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        data["pfState"] = this.pfState;
        if (Array.isArray(this.proteinFormulationAttachments)) {
            data["proteinFormulationAttachments"] = [];
            for (let item of this.proteinFormulationAttachments)
                data["proteinFormulationAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["accessRightName"] = this.accessRightName;
        return data;
    }
}

export interface IPFDocProteinFormulationDTO {
    id: number;
    proteinLotId?: string | undefined;
    treeNodeId: number;
    volume?: number | undefined;
    pfName?: string | undefined;
    storageTemperature?: number | undefined;
    pclass?: string | undefined;
    extinctionCoefficient?: string | undefined;
    notes?: string | undefined;
    notebookPageNo?: string | undefined;
    apidata?: string | undefined;
    datePrepared: Date;
    proteinFormulationIngredient?: PFDocProteinFormulationIngredientsDTO[] | undefined;
    liquidClassId: number;
    proteinFormulationStandardIngredient?: PFDocStandardIngredientsDTO[] | undefined;
    pfState: PFStateDTO;
    proteinFormulationAttachments?: PFDocAttachmentDTO[] | undefined;
    accessRightName?: string | undefined;
}

export class PFDocProteinFormulationIngredientsDTO implements IPFDocProteinFormulationIngredientsDTO {
    id!: number;
    name?: string | undefined;
    concentrationmgmL?: number | undefined;
    concentrationmM?: number | undefined;
    molecularWeight?: number | undefined;
    proteinFormulationIngredientTypeId!: number;
    lot?: string | undefined;
    ingState!: PFStateDTO;
    proteinFormulationId!: number;
    userId?: string | undefined;

    constructor(data?: IPFDocProteinFormulationIngredientsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.concentrationmgmL = _data["concentrationmgmL"];
            this.concentrationmM = _data["concentrationmM"];
            this.molecularWeight = _data["molecularWeight"];
            this.proteinFormulationIngredientTypeId = _data["proteinFormulationIngredientTypeId"];
            this.lot = _data["lot"];
            this.ingState = _data["ingState"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): PFDocProteinFormulationIngredientsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocProteinFormulationIngredientsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["concentrationmgmL"] = this.concentrationmgmL;
        data["concentrationmM"] = this.concentrationmM;
        data["molecularWeight"] = this.molecularWeight;
        data["proteinFormulationIngredientTypeId"] = this.proteinFormulationIngredientTypeId;
        data["lot"] = this.lot;
        data["ingState"] = this.ingState;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IPFDocProteinFormulationIngredientsDTO {
    id: number;
    name?: string | undefined;
    concentrationmgmL?: number | undefined;
    concentrationmM?: number | undefined;
    molecularWeight?: number | undefined;
    proteinFormulationIngredientTypeId: number;
    lot?: string | undefined;
    ingState: PFStateDTO;
    proteinFormulationId: number;
    userId?: string | undefined;
}

export enum PFStateDTO {
    UnChanged = 1,
    Modified = 2,
    New = 3,
    Deleted = 4,
    Renamed = 5,
}

export class PFDocStandardIngredientsDTO implements IPFDocStandardIngredientsDTO {
    id!: number;
    ingredientName?: string | undefined;
    concentrationM?: number | undefined;
    pH?: number | undefined;
    stockConcentration?: number | undefined;
    stockConcentrationUnit?: string | undefined;
    type?: string | undefined;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    concentration!: number;
    sIngState!: PFStateDTO;
    proteinFormulationId!: number;

    constructor(data?: IPFDocStandardIngredientsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientName = _data["ingredientName"];
            this.concentrationM = _data["concentrationM"];
            this.pH = _data["pH"];
            this.stockConcentration = _data["stockConcentration"];
            this.stockConcentrationUnit = _data["stockConcentrationUnit"];
            this.type = _data["type"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.concentration = _data["concentration"];
            this.sIngState = _data["sIngState"];
            this.proteinFormulationId = _data["proteinFormulationId"];
        }
    }

    static fromJS(data: any): PFDocStandardIngredientsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocStandardIngredientsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientName"] = this.ingredientName;
        data["concentrationM"] = this.concentrationM;
        data["pH"] = this.pH;
        data["stockConcentration"] = this.stockConcentration;
        data["stockConcentrationUnit"] = this.stockConcentrationUnit;
        data["type"] = this.type;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["concentration"] = this.concentration;
        data["sIngState"] = this.sIngState;
        data["proteinFormulationId"] = this.proteinFormulationId;
        return data;
    }
}

export interface IPFDocStandardIngredientsDTO {
    id: number;
    ingredientName?: string | undefined;
    concentrationM?: number | undefined;
    pH?: number | undefined;
    stockConcentration?: number | undefined;
    stockConcentrationUnit?: string | undefined;
    type?: string | undefined;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    concentration: number;
    sIngState: PFStateDTO;
    proteinFormulationId: number;
}

export class PFDocAttachmentDTO implements IPFDocAttachmentDTO {
    name?: string | undefined;
    data?: string | undefined;
    link?: string | undefined;
    proteinFormulationId!: number;
    attachmentState!: PFStateDTO;

    constructor(data?: IPFDocAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.data = _data["data"];
            this.link = _data["link"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.attachmentState = _data["attachmentState"];
        }
    }

    static fromJS(data: any): PFDocAttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocAttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["data"] = this.data;
        data["link"] = this.link;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["attachmentState"] = this.attachmentState;
        return data;
    }
}

export interface IPFDocAttachmentDTO {
    name?: string | undefined;
    data?: string | undefined;
    link?: string | undefined;
    proteinFormulationId: number;
    attachmentState: PFStateDTO;
}

export class CrystalPuckDewarDTO implements ICrystalPuckDewarDTO {
    puckId!: number;
    puckName?: string | undefined;
    puckBarcode?: string | undefined;
    puckPosition!: number;
    puckType?: string | undefined;
    dewarId!: number;
    dewarName?: string | undefined;

    constructor(data?: ICrystalPuckDewarDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.puckId = _data["puckId"];
            this.puckName = _data["puckName"];
            this.puckBarcode = _data["puckBarcode"];
            this.puckPosition = _data["puckPosition"];
            this.puckType = _data["puckType"];
            this.dewarId = _data["dewarId"];
            this.dewarName = _data["dewarName"];
        }
    }

    static fromJS(data: any): CrystalPuckDewarDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalPuckDewarDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["puckId"] = this.puckId;
        data["puckName"] = this.puckName;
        data["puckBarcode"] = this.puckBarcode;
        data["puckPosition"] = this.puckPosition;
        data["puckType"] = this.puckType;
        data["dewarId"] = this.dewarId;
        data["dewarName"] = this.dewarName;
        return data;
    }
}

export interface ICrystalPuckDewarDTO {
    puckId: number;
    puckName?: string | undefined;
    puckBarcode?: string | undefined;
    puckPosition: number;
    puckType?: string | undefined;
    dewarId: number;
    dewarName?: string | undefined;
}

export class CrystalDropInfo implements ICrystalDropInfo {
    expId!: number;
    plateId!: number;
    wellNumber!: number;
    dropNumber!: number;
    cpId!: number;
    regionName?: string | undefined;
    imageBatchId!: number;

    constructor(data?: ICrystalDropInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expId = _data["expId"];
            this.plateId = _data["plateId"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.cpId = _data["cpId"];
            this.regionName = _data["regionName"];
            this.imageBatchId = _data["imageBatchId"];
        }
    }

    static fromJS(data: any): CrystalDropInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalDropInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expId"] = this.expId;
        data["plateId"] = this.plateId;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["cpId"] = this.cpId;
        data["regionName"] = this.regionName;
        data["imageBatchId"] = this.imageBatchId;
        return data;
    }
}

export interface ICrystalDropInfo {
    expId: number;
    plateId: number;
    wellNumber: number;
    dropNumber: number;
    cpId: number;
    regionName?: string | undefined;
    imageBatchId: number;
}

export class CrystalImageDTO implements ICrystalImageDTO {
    image?: string | undefined;
    drawingX?: number | undefined;
    drawingY?: number | undefined;
    drawingWidth?: number | undefined;
    drawingHeight?: number | undefined;

    constructor(data?: ICrystalImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.drawingX = _data["drawingX"];
            this.drawingY = _data["drawingY"];
            this.drawingWidth = _data["drawingWidth"];
            this.drawingHeight = _data["drawingHeight"];
        }
    }

    static fromJS(data: any): CrystalImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["drawingX"] = this.drawingX;
        data["drawingY"] = this.drawingY;
        data["drawingWidth"] = this.drawingWidth;
        data["drawingHeight"] = this.drawingHeight;
        return data;
    }
}

export interface ICrystalImageDTO {
    image?: string | undefined;
    drawingX?: number | undefined;
    drawingY?: number | undefined;
    drawingWidth?: number | undefined;
    drawingHeight?: number | undefined;
}

export class CrystalFilesUploadDTO implements ICrystalFilesUploadDTO {
    crystalId!: number;
    files?: FileUploadDTO[] | undefined;

    constructor(data?: ICrystalFilesUploadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crystalId = _data["crystalId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileUploadDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CrystalFilesUploadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalFilesUploadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crystalId"] = this.crystalId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICrystalFilesUploadDTO {
    crystalId: number;
    files?: FileUploadDTO[] | undefined;
}

export class FileUploadDTO implements IFileUploadDTO {
    fileName?: string | undefined;
    fileData?: string | undefined;

    constructor(data?: IFileUploadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileData = _data["fileData"];
        }
    }

    static fromJS(data: any): FileUploadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileData"] = this.fileData;
        return data;
    }
}

export interface IFileUploadDTO {
    fileName?: string | undefined;
    fileData?: string | undefined;
}

export class ResponseWithValueDTOOfCrystalTripAssignmentResponseDTO extends ResponseDTO implements IResponseWithValueDTOOfCrystalTripAssignmentResponseDTO {
    value?: CrystalTripAssignmentResponseDTO | undefined;

    constructor(data?: IResponseWithValueDTOOfCrystalTripAssignmentResponseDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? CrystalTripAssignmentResponseDTO.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfCrystalTripAssignmentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfCrystalTripAssignmentResponseDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfCrystalTripAssignmentResponseDTO extends IResponseDTO {
    value?: CrystalTripAssignmentResponseDTO | undefined;
}

export class CrystalTripAssignmentResponseDTO implements ICrystalTripAssignmentResponseDTO {
    crystalTrips?: CrystalTripDTO[] | undefined;
    refetchCrystalDetails!: boolean;

    constructor(data?: ICrystalTripAssignmentResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["crystalTrips"])) {
                this.crystalTrips = [] as any;
                for (let item of _data["crystalTrips"])
                    this.crystalTrips!.push(CrystalTripDTO.fromJS(item));
            }
            this.refetchCrystalDetails = _data["refetchCrystalDetails"];
        }
    }

    static fromJS(data: any): CrystalTripAssignmentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalTripAssignmentResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.crystalTrips)) {
            data["crystalTrips"] = [];
            for (let item of this.crystalTrips)
                data["crystalTrips"].push(item ? item.toJSON() : undefined as any);
        }
        data["refetchCrystalDetails"] = this.refetchCrystalDetails;
        return data;
    }
}

export interface ICrystalTripAssignmentResponseDTO {
    crystalTrips?: CrystalTripDTO[] | undefined;
    refetchCrystalDetails: boolean;
}

export class CrystalTripDTO implements ICrystalTripDTO {
    id!: number;
    puckPinId?: number | undefined;
    synchrotronTripId!: number;
    crystalId!: number;
    synchrotronTripName?: string | undefined;
    dataCollectionDate!: Date;

    constructor(data?: ICrystalTripDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.puckPinId = _data["puckPinId"];
            this.synchrotronTripId = _data["synchrotronTripId"];
            this.crystalId = _data["crystalId"];
            this.synchrotronTripName = _data["synchrotronTripName"];
            this.dataCollectionDate = _data["dataCollectionDate"] ? new Date(_data["dataCollectionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CrystalTripDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalTripDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["puckPinId"] = this.puckPinId;
        data["synchrotronTripId"] = this.synchrotronTripId;
        data["crystalId"] = this.crystalId;
        data["synchrotronTripName"] = this.synchrotronTripName;
        data["dataCollectionDate"] = this.dataCollectionDate ? this.dataCollectionDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICrystalTripDTO {
    id: number;
    puckPinId?: number | undefined;
    synchrotronTripId: number;
    crystalId: number;
    synchrotronTripName?: string | undefined;
    dataCollectionDate: Date;
}

export class CrystalWithResultDTO implements ICrystalWithResultDTO {
    id!: number;
    crystalTripId!: number;
    crystalName?: string | undefined;
    dateFrozen?: Date | undefined;
    dateCollected?: Date | undefined;
    owner?: string | undefined;
    puckName?: string | undefined;
    puckBarcode?: string | undefined;
    position?: number | undefined;
    dewarName?: string | undefined;
    resultStatus?: string | undefined;
    result?: CrystalTripResultv4 | undefined;

    constructor(data?: ICrystalWithResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crystalTripId = _data["crystalTripId"];
            this.crystalName = _data["crystalName"];
            this.dateFrozen = _data["dateFrozen"] ? new Date(_data["dateFrozen"].toString()) : undefined as any;
            this.dateCollected = _data["dateCollected"] ? new Date(_data["dateCollected"].toString()) : undefined as any;
            this.owner = _data["owner"];
            this.puckName = _data["puckName"];
            this.puckBarcode = _data["puckBarcode"];
            this.position = _data["position"];
            this.dewarName = _data["dewarName"];
            this.resultStatus = _data["resultStatus"];
            this.result = _data["result"] ? CrystalTripResultv4.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): CrystalWithResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalWithResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crystalTripId"] = this.crystalTripId;
        data["crystalName"] = this.crystalName;
        data["dateFrozen"] = this.dateFrozen ? this.dateFrozen.toISOString() : undefined as any;
        data["dateCollected"] = this.dateCollected ? this.dateCollected.toISOString() : undefined as any;
        data["owner"] = this.owner;
        data["puckName"] = this.puckName;
        data["puckBarcode"] = this.puckBarcode;
        data["position"] = this.position;
        data["dewarName"] = this.dewarName;
        data["resultStatus"] = this.resultStatus;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface ICrystalWithResultDTO {
    id: number;
    crystalTripId: number;
    crystalName?: string | undefined;
    dateFrozen?: Date | undefined;
    dateCollected?: Date | undefined;
    owner?: string | undefined;
    puckName?: string | undefined;
    puckBarcode?: string | undefined;
    position?: number | undefined;
    dewarName?: string | undefined;
    resultStatus?: string | undefined;
    result?: CrystalTripResultv4 | undefined;
}

export class DewarDTO implements IDewarDTO {
    id!: number;
    name?: string | undefined;
    puckCount!: number;
    inUse!: boolean;
    enable?: boolean | undefined;

    constructor(data?: IDewarDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.puckCount = _data["puckCount"];
            this.inUse = _data["inUse"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): DewarDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DewarDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["puckCount"] = this.puckCount;
        data["inUse"] = this.inUse;
        data["enable"] = this.enable;
        return data;
    }
}

export interface IDewarDTO {
    id: number;
    name?: string | undefined;
    puckCount: number;
    inUse: boolean;
    enable?: boolean | undefined;
}

export class SaveDewarDTO implements ISaveDewarDTO {
    dewarDtoList?: Dewarv4[] | undefined;
    deletedIds?: number[] | undefined;

    constructor(data?: ISaveDewarDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dewarDtoList"])) {
                this.dewarDtoList = [] as any;
                for (let item of _data["dewarDtoList"])
                    this.dewarDtoList!.push(Dewarv4.fromJS(item));
            }
            if (Array.isArray(_data["deletedIds"])) {
                this.deletedIds = [] as any;
                for (let item of _data["deletedIds"])
                    this.deletedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveDewarDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDewarDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dewarDtoList)) {
            data["dewarDtoList"] = [];
            for (let item of this.dewarDtoList)
                data["dewarDtoList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedIds)) {
            data["deletedIds"] = [];
            for (let item of this.deletedIds)
                data["deletedIds"].push(item);
        }
        return data;
    }
}

export interface ISaveDewarDTO {
    dewarDtoList?: Dewarv4[] | undefined;
    deletedIds?: number[] | undefined;
}

export class ScoresOfWellDropsDTO implements IScoresOfWellDropsDTO {
    dropId?: number | undefined;
    wellId?: number | undefined;
    wellNumber!: number;
    plateId?: number | undefined;
    wellRow?: string | undefined;
    wellCol?: number | undefined;
    wellDropScoreId!: number;
    wellDropScoreGroupId!: number;
    imageBatchWellDropScoreId!: number;
    isDisputed!: boolean;
    isAutoScoreIgnored!: boolean;
    isAutoScore!: boolean;
    scoreBatchId!: number;
    dropNumber!: number;
    autoScoreValue?: number | undefined;
    autoScoreType?: number | undefined;
    ipScoreValue!: number;
    scoreType!: number;
    hotKey?: string | undefined;
    color!: number;
    colorRGB!: string;
    scoreName?: string | undefined;
    scoreGroupName?: string | undefined;
    hit!: boolean;
    orderNumber!: number;
    isUVIndicator!: boolean;
    sourceScoreId?: number | undefined;
    scoreDetails?: ScoreDetail[] | undefined;
    morphologyDetails?: MorphologyDetail[] | undefined;
    ultravioletDetails?: UltravioletDetail[] | undefined;

    constructor(data?: IScoresOfWellDropsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dropId = _data["dropId"];
            this.wellId = _data["wellId"];
            this.wellNumber = _data["wellNumber"];
            this.plateId = _data["plateId"];
            this.wellRow = _data["wellRow"];
            this.wellCol = _data["wellCol"];
            this.wellDropScoreId = _data["wellDropScoreId"];
            this.wellDropScoreGroupId = _data["wellDropScoreGroupId"];
            this.imageBatchWellDropScoreId = _data["imageBatchWellDropScoreId"];
            this.isDisputed = _data["isDisputed"];
            this.isAutoScoreIgnored = _data["isAutoScoreIgnored"];
            this.isAutoScore = _data["isAutoScore"];
            this.scoreBatchId = _data["scoreBatchId"];
            this.dropNumber = _data["dropNumber"];
            this.autoScoreValue = _data["autoScoreValue"];
            this.autoScoreType = _data["autoScoreType"];
            this.ipScoreValue = _data["ipScoreValue"];
            this.scoreType = _data["scoreType"];
            this.hotKey = _data["hotKey"];
            this.color = _data["color"];
            this.colorRGB = _data["colorRGB"];
            this.scoreName = _data["scoreName"];
            this.scoreGroupName = _data["scoreGroupName"];
            this.hit = _data["hit"];
            this.orderNumber = _data["orderNumber"];
            this.isUVIndicator = _data["isUVIndicator"];
            this.sourceScoreId = _data["sourceScoreId"];
            if (Array.isArray(_data["scoreDetails"])) {
                this.scoreDetails = [] as any;
                for (let item of _data["scoreDetails"])
                    this.scoreDetails!.push(ScoreDetail.fromJS(item));
            }
            if (Array.isArray(_data["morphologyDetails"])) {
                this.morphologyDetails = [] as any;
                for (let item of _data["morphologyDetails"])
                    this.morphologyDetails!.push(MorphologyDetail.fromJS(item));
            }
            if (Array.isArray(_data["ultravioletDetails"])) {
                this.ultravioletDetails = [] as any;
                for (let item of _data["ultravioletDetails"])
                    this.ultravioletDetails!.push(UltravioletDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScoresOfWellDropsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScoresOfWellDropsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dropId"] = this.dropId;
        data["wellId"] = this.wellId;
        data["wellNumber"] = this.wellNumber;
        data["plateId"] = this.plateId;
        data["wellRow"] = this.wellRow;
        data["wellCol"] = this.wellCol;
        data["wellDropScoreId"] = this.wellDropScoreId;
        data["wellDropScoreGroupId"] = this.wellDropScoreGroupId;
        data["imageBatchWellDropScoreId"] = this.imageBatchWellDropScoreId;
        data["isDisputed"] = this.isDisputed;
        data["isAutoScoreIgnored"] = this.isAutoScoreIgnored;
        data["isAutoScore"] = this.isAutoScore;
        data["scoreBatchId"] = this.scoreBatchId;
        data["dropNumber"] = this.dropNumber;
        data["autoScoreValue"] = this.autoScoreValue;
        data["autoScoreType"] = this.autoScoreType;
        data["ipScoreValue"] = this.ipScoreValue;
        data["scoreType"] = this.scoreType;
        data["hotKey"] = this.hotKey;
        data["color"] = this.color;
        data["colorRGB"] = this.colorRGB;
        data["scoreName"] = this.scoreName;
        data["scoreGroupName"] = this.scoreGroupName;
        data["hit"] = this.hit;
        data["orderNumber"] = this.orderNumber;
        data["isUVIndicator"] = this.isUVIndicator;
        data["sourceScoreId"] = this.sourceScoreId;
        if (Array.isArray(this.scoreDetails)) {
            data["scoreDetails"] = [];
            for (let item of this.scoreDetails)
                data["scoreDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.morphologyDetails)) {
            data["morphologyDetails"] = [];
            for (let item of this.morphologyDetails)
                data["morphologyDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ultravioletDetails)) {
            data["ultravioletDetails"] = [];
            for (let item of this.ultravioletDetails)
                data["ultravioletDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScoresOfWellDropsDTO {
    dropId?: number | undefined;
    wellId?: number | undefined;
    wellNumber: number;
    plateId?: number | undefined;
    wellRow?: string | undefined;
    wellCol?: number | undefined;
    wellDropScoreId: number;
    wellDropScoreGroupId: number;
    imageBatchWellDropScoreId: number;
    isDisputed: boolean;
    isAutoScoreIgnored: boolean;
    isAutoScore: boolean;
    scoreBatchId: number;
    dropNumber: number;
    autoScoreValue?: number | undefined;
    autoScoreType?: number | undefined;
    ipScoreValue: number;
    scoreType: number;
    hotKey?: string | undefined;
    color: number;
    colorRGB: string;
    scoreName?: string | undefined;
    scoreGroupName?: string | undefined;
    hit: boolean;
    orderNumber: number;
    isUVIndicator: boolean;
    sourceScoreId?: number | undefined;
    scoreDetails?: ScoreDetail[] | undefined;
    morphologyDetails?: MorphologyDetail[] | undefined;
    ultravioletDetails?: UltravioletDetail[] | undefined;
}

export class ExperimentDTO implements IExperimentDTO {
    plateDto?: PlatesDTO[] | undefined;
    experimentId!: number;
    accessRightName?: string | undefined;
    containerRows!: number;
    expName?: string | undefined;
    containerCols?: any | undefined;
    colCount!: number;
    rowCount!: number;
    screenLotId!: number;
    treeNodeId!: number;
    defWellVolume!: number;
    containerMaxWellVolume!: number;
    containerDefDropVolume!: number;
    containerDefAdditiveVolume!: number;
    containerMaxDropVolume!: number;
    containerDefSeedVolume?: number | undefined;
    containerDefaultFragmentVolume?: number | undefined;
    isCotainerScreenLotPlate!: boolean;
    isImageModeActive!: boolean;
    isDispensed!: boolean;
    inspections?: InspectionSetDTO[] | undefined;
    profiles?: ProfileDTO[] | undefined;
    regions?: RegionsDTO[] | undefined;
    regionCaptureProfiles?: RegionCaptureProfileDTO[] | undefined;
    dropLables?: DropsDTO[] | undefined;
    experimentTuningValues?: ExperimentTuningValuesDTO[] | undefined;
    expSelectedStates?: ExperimentSelectedStatesDTO | undefined;
    info?: ExperimentInfoDTO | undefined;
    imagingSchedule?: ExperimentInfoImagingScheduleDTO | undefined;
    containerDrops?: ContainerDropDTO[] | undefined;
    screenRepairInfo?: ScreenRepairInfoDTO | undefined;
    restoreWarningMessage?: string | undefined;

    constructor(data?: IExperimentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plateDto"])) {
                this.plateDto = [] as any;
                for (let item of _data["plateDto"])
                    this.plateDto!.push(PlatesDTO.fromJS(item));
            }
            this.experimentId = _data["experimentId"];
            this.accessRightName = _data["accessRightName"];
            this.containerRows = _data["containerRows"];
            this.expName = _data["expName"];
            this.containerCols = _data["containerCols"];
            this.colCount = _data["colCount"];
            this.rowCount = _data["rowCount"];
            this.screenLotId = _data["screenLotId"];
            this.treeNodeId = _data["treeNodeId"];
            this.defWellVolume = _data["defWellVolume"];
            this.containerMaxWellVolume = _data["containerMaxWellVolume"];
            this.containerDefDropVolume = _data["containerDefDropVolume"];
            this.containerDefAdditiveVolume = _data["containerDefAdditiveVolume"];
            this.containerMaxDropVolume = _data["containerMaxDropVolume"];
            this.containerDefSeedVolume = _data["containerDefSeedVolume"];
            this.containerDefaultFragmentVolume = _data["containerDefaultFragmentVolume"];
            this.isCotainerScreenLotPlate = _data["isCotainerScreenLotPlate"];
            this.isImageModeActive = _data["isImageModeActive"];
            this.isDispensed = _data["isDispensed"];
            if (Array.isArray(_data["inspections"])) {
                this.inspections = [] as any;
                for (let item of _data["inspections"])
                    this.inspections!.push(InspectionSetDTO.fromJS(item));
            }
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(ProfileDTO.fromJS(item));
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(RegionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["regionCaptureProfiles"])) {
                this.regionCaptureProfiles = [] as any;
                for (let item of _data["regionCaptureProfiles"])
                    this.regionCaptureProfiles!.push(RegionCaptureProfileDTO.fromJS(item));
            }
            if (Array.isArray(_data["dropLables"])) {
                this.dropLables = [] as any;
                for (let item of _data["dropLables"])
                    this.dropLables!.push(DropsDTO.fromJS(item));
            }
            if (Array.isArray(_data["experimentTuningValues"])) {
                this.experimentTuningValues = [] as any;
                for (let item of _data["experimentTuningValues"])
                    this.experimentTuningValues!.push(ExperimentTuningValuesDTO.fromJS(item));
            }
            this.expSelectedStates = _data["expSelectedStates"] ? ExperimentSelectedStatesDTO.fromJS(_data["expSelectedStates"]) : undefined as any;
            this.info = _data["info"] ? ExperimentInfoDTO.fromJS(_data["info"]) : undefined as any;
            this.imagingSchedule = _data["imagingSchedule"] ? ExperimentInfoImagingScheduleDTO.fromJS(_data["imagingSchedule"]) : undefined as any;
            if (Array.isArray(_data["containerDrops"])) {
                this.containerDrops = [] as any;
                for (let item of _data["containerDrops"])
                    this.containerDrops!.push(ContainerDropDTO.fromJS(item));
            }
            this.screenRepairInfo = _data["screenRepairInfo"] ? ScreenRepairInfoDTO.fromJS(_data["screenRepairInfo"]) : undefined as any;
            this.restoreWarningMessage = _data["restoreWarningMessage"];
        }
    }

    static fromJS(data: any): ExperimentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plateDto)) {
            data["plateDto"] = [];
            for (let item of this.plateDto)
                data["plateDto"].push(item ? item.toJSON() : undefined as any);
        }
        data["experimentId"] = this.experimentId;
        data["accessRightName"] = this.accessRightName;
        data["containerRows"] = this.containerRows;
        data["expName"] = this.expName;
        data["containerCols"] = this.containerCols;
        data["colCount"] = this.colCount;
        data["rowCount"] = this.rowCount;
        data["screenLotId"] = this.screenLotId;
        data["treeNodeId"] = this.treeNodeId;
        data["defWellVolume"] = this.defWellVolume;
        data["containerMaxWellVolume"] = this.containerMaxWellVolume;
        data["containerDefDropVolume"] = this.containerDefDropVolume;
        data["containerDefAdditiveVolume"] = this.containerDefAdditiveVolume;
        data["containerMaxDropVolume"] = this.containerMaxDropVolume;
        data["containerDefSeedVolume"] = this.containerDefSeedVolume;
        data["containerDefaultFragmentVolume"] = this.containerDefaultFragmentVolume;
        data["isCotainerScreenLotPlate"] = this.isCotainerScreenLotPlate;
        data["isImageModeActive"] = this.isImageModeActive;
        data["isDispensed"] = this.isDispensed;
        if (Array.isArray(this.inspections)) {
            data["inspections"] = [];
            for (let item of this.inspections)
                data["inspections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionCaptureProfiles)) {
            data["regionCaptureProfiles"] = [];
            for (let item of this.regionCaptureProfiles)
                data["regionCaptureProfiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dropLables)) {
            data["dropLables"] = [];
            for (let item of this.dropLables)
                data["dropLables"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.experimentTuningValues)) {
            data["experimentTuningValues"] = [];
            for (let item of this.experimentTuningValues)
                data["experimentTuningValues"].push(item ? item.toJSON() : undefined as any);
        }
        data["expSelectedStates"] = this.expSelectedStates ? this.expSelectedStates.toJSON() : undefined as any;
        data["info"] = this.info ? this.info.toJSON() : undefined as any;
        data["imagingSchedule"] = this.imagingSchedule ? this.imagingSchedule.toJSON() : undefined as any;
        if (Array.isArray(this.containerDrops)) {
            data["containerDrops"] = [];
            for (let item of this.containerDrops)
                data["containerDrops"].push(item ? item.toJSON() : undefined as any);
        }
        data["screenRepairInfo"] = this.screenRepairInfo ? this.screenRepairInfo.toJSON() : undefined as any;
        data["restoreWarningMessage"] = this.restoreWarningMessage;
        return data;
    }
}

export interface IExperimentDTO {
    plateDto?: PlatesDTO[] | undefined;
    experimentId: number;
    accessRightName?: string | undefined;
    containerRows: number;
    expName?: string | undefined;
    containerCols?: any | undefined;
    colCount: number;
    rowCount: number;
    screenLotId: number;
    treeNodeId: number;
    defWellVolume: number;
    containerMaxWellVolume: number;
    containerDefDropVolume: number;
    containerDefAdditiveVolume: number;
    containerMaxDropVolume: number;
    containerDefSeedVolume?: number | undefined;
    containerDefaultFragmentVolume?: number | undefined;
    isCotainerScreenLotPlate: boolean;
    isImageModeActive: boolean;
    isDispensed: boolean;
    inspections?: InspectionSetDTO[] | undefined;
    profiles?: ProfileDTO[] | undefined;
    regions?: RegionsDTO[] | undefined;
    regionCaptureProfiles?: RegionCaptureProfileDTO[] | undefined;
    dropLables?: DropsDTO[] | undefined;
    experimentTuningValues?: ExperimentTuningValuesDTO[] | undefined;
    expSelectedStates?: ExperimentSelectedStatesDTO | undefined;
    info?: ExperimentInfoDTO | undefined;
    imagingSchedule?: ExperimentInfoImagingScheduleDTO | undefined;
    containerDrops?: ContainerDropDTO[] | undefined;
    screenRepairInfo?: ScreenRepairInfoDTO | undefined;
    restoreWarningMessage?: string | undefined;
}

export class PlatesDTO implements IPlatesDTO {
    numRows!: number;
    numCols!: number;
    plateId!: number;
    barCode?: string | undefined;
    plateBarName?: string | undefined;
    compositeFileStr?: string | undefined;
    hasErrors!: boolean;
    hasWarning!: boolean;
    experimentPlate?: ExperimentPlateDTO | undefined;
    screenLotPlate?: ScreenLotPlateDTO | undefined;
    colPos!: number;
    rowPos!: number;
    imagePath?: string | undefined;
    plateNumber!: number;
    rows!: number;
    cols!: number;
    ingredients?: PlateIngredientDTO | undefined;
    isoPreviousPlateID?: number | undefined;
    isoRoundNumber?: number | undefined;
    isoScores?: ISOWellDropScoreDTO[] | undefined;
    experimentID!: number;
    treeNodeID!: number;
    state!: number;
    isQueued!: boolean;
    dispensingRobotID?: number | undefined;
    canvasRowPosition!: number;
    canvasColumnPosition!: number;
    imagingTasksEnabled?: boolean | undefined;
    isSeeded!: boolean;

    constructor(data?: IPlatesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numRows = _data["numRows"];
            this.numCols = _data["numCols"];
            this.plateId = _data["plateId"];
            this.barCode = _data["barCode"];
            this.plateBarName = _data["plateBarName"];
            this.compositeFileStr = _data["compositeFileStr"];
            this.hasErrors = _data["hasErrors"];
            this.hasWarning = _data["hasWarning"];
            this.experimentPlate = _data["experimentPlate"] ? ExperimentPlateDTO.fromJS(_data["experimentPlate"]) : undefined as any;
            this.screenLotPlate = _data["screenLotPlate"] ? ScreenLotPlateDTO.fromJS(_data["screenLotPlate"]) : undefined as any;
            this.colPos = _data["colPos"];
            this.rowPos = _data["rowPos"];
            this.imagePath = _data["imagePath"];
            this.plateNumber = _data["plateNumber"];
            this.rows = _data["rows"];
            this.cols = _data["cols"];
            this.ingredients = _data["ingredients"] ? PlateIngredientDTO.fromJS(_data["ingredients"]) : undefined as any;
            this.isoPreviousPlateID = _data["isoPreviousPlateID"];
            this.isoRoundNumber = _data["isoRoundNumber"];
            if (Array.isArray(_data["isoScores"])) {
                this.isoScores = [] as any;
                for (let item of _data["isoScores"])
                    this.isoScores!.push(ISOWellDropScoreDTO.fromJS(item));
            }
            this.experimentID = _data["experimentID"];
            this.treeNodeID = _data["treeNodeID"];
            this.state = _data["state"];
            this.isQueued = _data["isQueued"];
            this.dispensingRobotID = _data["dispensingRobotID"];
            this.canvasRowPosition = _data["canvasRowPosition"];
            this.canvasColumnPosition = _data["canvasColumnPosition"];
            this.imagingTasksEnabled = _data["imagingTasksEnabled"];
            this.isSeeded = _data["isSeeded"];
        }
    }

    static fromJS(data: any): PlatesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlatesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numRows"] = this.numRows;
        data["numCols"] = this.numCols;
        data["plateId"] = this.plateId;
        data["barCode"] = this.barCode;
        data["plateBarName"] = this.plateBarName;
        data["compositeFileStr"] = this.compositeFileStr;
        data["hasErrors"] = this.hasErrors;
        data["hasWarning"] = this.hasWarning;
        data["experimentPlate"] = this.experimentPlate ? this.experimentPlate.toJSON() : undefined as any;
        data["screenLotPlate"] = this.screenLotPlate ? this.screenLotPlate.toJSON() : undefined as any;
        data["colPos"] = this.colPos;
        data["rowPos"] = this.rowPos;
        data["imagePath"] = this.imagePath;
        data["plateNumber"] = this.plateNumber;
        data["rows"] = this.rows;
        data["cols"] = this.cols;
        data["ingredients"] = this.ingredients ? this.ingredients.toJSON() : undefined as any;
        data["isoPreviousPlateID"] = this.isoPreviousPlateID;
        data["isoRoundNumber"] = this.isoRoundNumber;
        if (Array.isArray(this.isoScores)) {
            data["isoScores"] = [];
            for (let item of this.isoScores)
                data["isoScores"].push(item ? item.toJSON() : undefined as any);
        }
        data["experimentID"] = this.experimentID;
        data["treeNodeID"] = this.treeNodeID;
        data["state"] = this.state;
        data["isQueued"] = this.isQueued;
        data["dispensingRobotID"] = this.dispensingRobotID;
        data["canvasRowPosition"] = this.canvasRowPosition;
        data["canvasColumnPosition"] = this.canvasColumnPosition;
        data["imagingTasksEnabled"] = this.imagingTasksEnabled;
        data["isSeeded"] = this.isSeeded;
        return data;
    }
}

export interface IPlatesDTO {
    numRows: number;
    numCols: number;
    plateId: number;
    barCode?: string | undefined;
    plateBarName?: string | undefined;
    compositeFileStr?: string | undefined;
    hasErrors: boolean;
    hasWarning: boolean;
    experimentPlate?: ExperimentPlateDTO | undefined;
    screenLotPlate?: ScreenLotPlateDTO | undefined;
    colPos: number;
    rowPos: number;
    imagePath?: string | undefined;
    plateNumber: number;
    rows: number;
    cols: number;
    ingredients?: PlateIngredientDTO | undefined;
    isoPreviousPlateID?: number | undefined;
    isoRoundNumber?: number | undefined;
    isoScores?: ISOWellDropScoreDTO[] | undefined;
    experimentID: number;
    treeNodeID: number;
    state: number;
    isQueued: boolean;
    dispensingRobotID?: number | undefined;
    canvasRowPosition: number;
    canvasColumnPosition: number;
    imagingTasksEnabled?: boolean | undefined;
    isSeeded: boolean;
}

export class ExperimentPlateDTO implements IExperimentPlateDTO {
    id!: number;

    constructor(data?: IExperimentPlateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExperimentPlateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentPlateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IExperimentPlateDTO {
    id: number;
}

export class ScreenLotPlateDTO implements IScreenLotPlateDTO {
    screenLotId!: number;
    id!: number;
    screenLot?: ScreenLotDTO | undefined;

    constructor(data?: IScreenLotPlateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screenLotId = _data["screenLotId"];
            this.id = _data["id"];
            this.screenLot = _data["screenLot"] ? ScreenLotDTO.fromJS(_data["screenLot"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScreenLotPlateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenLotPlateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["screenLotId"] = this.screenLotId;
        data["id"] = this.id;
        data["screenLot"] = this.screenLot ? this.screenLot.toJSON() : undefined as any;
        return data;
    }
}

export interface IScreenLotPlateDTO {
    screenLotId: number;
    id: number;
    screenLot?: ScreenLotDTO | undefined;
}

export class ScreenLotDTO implements IScreenLotDTO {
    id!: number;
    experimentId!: number;
    containerId!: number;
    treeNodeId!: number;
    lotNumber!: number;
    dispenseVolume!: number;
    currentVolume!: number;
    comment?: string | undefined;
    initialLot!: boolean;
    experiment?: ExperimentDTO | undefined;

    constructor(data?: IScreenLotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.containerId = _data["containerId"];
            this.treeNodeId = _data["treeNodeId"];
            this.lotNumber = _data["lotNumber"];
            this.dispenseVolume = _data["dispenseVolume"];
            this.currentVolume = _data["currentVolume"];
            this.comment = _data["comment"];
            this.initialLot = _data["initialLot"];
            this.experiment = _data["experiment"] ? ExperimentDTO.fromJS(_data["experiment"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScreenLotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenLotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["containerId"] = this.containerId;
        data["treeNodeId"] = this.treeNodeId;
        data["lotNumber"] = this.lotNumber;
        data["dispenseVolume"] = this.dispenseVolume;
        data["currentVolume"] = this.currentVolume;
        data["comment"] = this.comment;
        data["initialLot"] = this.initialLot;
        data["experiment"] = this.experiment ? this.experiment.toJSON() : undefined as any;
        return data;
    }
}

export interface IScreenLotDTO {
    id: number;
    experimentId: number;
    containerId: number;
    treeNodeId: number;
    lotNumber: number;
    dispenseVolume: number;
    currentVolume: number;
    comment?: string | undefined;
    initialLot: boolean;
    experiment?: ExperimentDTO | undefined;
}

export class PlateIngredientDTO implements IPlateIngredientDTO {
    plateId!: number;
    maxWellVolume?: number | undefined;
    containerMaxVolume!: number;
    error?: string | undefined;
    hasError!: boolean;
    warning?: string | undefined;
    hasWarning!: boolean;
    proteinFormulation?: { [key: string]: ProteinFormulationListDTO; } | undefined;
    wellList?: WellIngDTO[] | undefined;
    containerDropList?: ContainerDropDTO[] | undefined;

    constructor(data?: IPlateIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.maxWellVolume = _data["maxWellVolume"];
            this.containerMaxVolume = _data["containerMaxVolume"];
            this.error = _data["error"];
            this.hasError = _data["hasError"];
            this.warning = _data["warning"];
            this.hasWarning = _data["hasWarning"];
            if (_data["proteinFormulation"]) {
                this.proteinFormulation = {} as any;
                for (let key in _data["proteinFormulation"]) {
                    if (_data["proteinFormulation"].hasOwnProperty(key))
                        (this.proteinFormulation as any)![key] = _data["proteinFormulation"][key] ? ProteinFormulationListDTO.fromJS(_data["proteinFormulation"][key]) : new ProteinFormulationListDTO();
                }
            }
            if (Array.isArray(_data["wellList"])) {
                this.wellList = [] as any;
                for (let item of _data["wellList"])
                    this.wellList!.push(WellIngDTO.fromJS(item));
            }
            if (Array.isArray(_data["containerDropList"])) {
                this.containerDropList = [] as any;
                for (let item of _data["containerDropList"])
                    this.containerDropList!.push(ContainerDropDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlateIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["maxWellVolume"] = this.maxWellVolume;
        data["containerMaxVolume"] = this.containerMaxVolume;
        data["error"] = this.error;
        data["hasError"] = this.hasError;
        data["warning"] = this.warning;
        data["hasWarning"] = this.hasWarning;
        if (this.proteinFormulation) {
            data["proteinFormulation"] = {};
            for (let key in this.proteinFormulation) {
                if (this.proteinFormulation.hasOwnProperty(key))
                    (data["proteinFormulation"] as any)[key] = this.proteinFormulation[key] ? this.proteinFormulation[key].toJSON() : undefined as any;
            }
        }
        if (Array.isArray(this.wellList)) {
            data["wellList"] = [];
            for (let item of this.wellList)
                data["wellList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.containerDropList)) {
            data["containerDropList"] = [];
            for (let item of this.containerDropList)
                data["containerDropList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPlateIngredientDTO {
    plateId: number;
    maxWellVolume?: number | undefined;
    containerMaxVolume: number;
    error?: string | undefined;
    hasError: boolean;
    warning?: string | undefined;
    hasWarning: boolean;
    proteinFormulation?: { [key: string]: ProteinFormulationListDTO; } | undefined;
    wellList?: WellIngDTO[] | undefined;
    containerDropList?: ContainerDropDTO[] | undefined;
}

export class ProteinFormulationListDTO implements IProteinFormulationListDTO {
    proteinFormulationId!: number;
    proteinInfo?: ProteinFormulationInfoDTO | undefined;
    ingredients?: ProteinFormulationIngredientsDTO[] | undefined;
    standardIngredients?: ProteinFormulationStandardIngredientsDTO[] | undefined;

    constructor(data?: IProteinFormulationListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.proteinInfo = _data["proteinInfo"] ? ProteinFormulationInfoDTO.fromJS(_data["proteinInfo"]) : undefined as any;
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(ProteinFormulationIngredientsDTO.fromJS(item));
            }
            if (Array.isArray(_data["standardIngredients"])) {
                this.standardIngredients = [] as any;
                for (let item of _data["standardIngredients"])
                    this.standardIngredients!.push(ProteinFormulationStandardIngredientsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProteinFormulationListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["proteinInfo"] = this.proteinInfo ? this.proteinInfo.toJSON() : undefined as any;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.standardIngredients)) {
            data["standardIngredients"] = [];
            for (let item of this.standardIngredients)
                data["standardIngredients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProteinFormulationListDTO {
    proteinFormulationId: number;
    proteinInfo?: ProteinFormulationInfoDTO | undefined;
    ingredients?: ProteinFormulationIngredientsDTO[] | undefined;
    standardIngredients?: ProteinFormulationStandardIngredientsDTO[] | undefined;
}

export class ProteinFormulationInfoDTO implements IProteinFormulationInfoDTO {
    name?: string | undefined;
    proteinLotId?: string | undefined;
    volume!: number;
    storageTemp!: number;
    pclass?: string | undefined;
    extCoefficient?: string | undefined;
    datePrepared!: Date;
    notes?: string | undefined;
    noteBookPageNo?: string | undefined;
    liquidClassName?: string | undefined;

    constructor(data?: IProteinFormulationInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.proteinLotId = _data["proteinLotId"];
            this.volume = _data["volume"];
            this.storageTemp = _data["storageTemp"];
            this.pclass = _data["pclass"];
            this.extCoefficient = _data["extCoefficient"];
            this.datePrepared = _data["datePrepared"] ? new Date(_data["datePrepared"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.noteBookPageNo = _data["noteBookPageNo"];
            this.liquidClassName = _data["liquidClassName"];
        }
    }

    static fromJS(data: any): ProteinFormulationInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["proteinLotId"] = this.proteinLotId;
        data["volume"] = this.volume;
        data["storageTemp"] = this.storageTemp;
        data["pclass"] = this.pclass;
        data["extCoefficient"] = this.extCoefficient;
        data["datePrepared"] = this.datePrepared ? this.datePrepared.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["noteBookPageNo"] = this.noteBookPageNo;
        data["liquidClassName"] = this.liquidClassName;
        return data;
    }
}

export interface IProteinFormulationInfoDTO {
    name?: string | undefined;
    proteinLotId?: string | undefined;
    volume: number;
    storageTemp: number;
    pclass?: string | undefined;
    extCoefficient?: string | undefined;
    datePrepared: Date;
    notes?: string | undefined;
    noteBookPageNo?: string | undefined;
    liquidClassName?: string | undefined;
}

export class WellIngDTO implements IWellIngDTO {
    plateId!: number;
    wellId!: number;
    wellNumber!: number;
    rowLetter?: string | undefined;
    columnNumber!: number;
    wellVolume?: number | undefined;
    wellWaterVolume?: number | undefined;
    error?: string | undefined;
    hasError!: boolean;
    warning?: string | undefined;
    hasWarning!: boolean;
    wellLayerList?: WellLayerDTO[] | undefined;
    dropList?: DropDTO[] | undefined;
    maxWellVolume?: number | undefined;

    constructor(data?: IWellIngDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.wellId = _data["wellId"];
            this.wellNumber = _data["wellNumber"];
            this.rowLetter = _data["rowLetter"];
            this.columnNumber = _data["columnNumber"];
            this.wellVolume = _data["wellVolume"];
            this.wellWaterVolume = _data["wellWaterVolume"];
            this.error = _data["error"];
            this.hasError = _data["hasError"];
            this.warning = _data["warning"];
            this.hasWarning = _data["hasWarning"];
            if (Array.isArray(_data["wellLayerList"])) {
                this.wellLayerList = [] as any;
                for (let item of _data["wellLayerList"])
                    this.wellLayerList!.push(WellLayerDTO.fromJS(item));
            }
            if (Array.isArray(_data["dropList"])) {
                this.dropList = [] as any;
                for (let item of _data["dropList"])
                    this.dropList!.push(DropDTO.fromJS(item));
            }
            this.maxWellVolume = _data["maxWellVolume"];
        }
    }

    static fromJS(data: any): WellIngDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellIngDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["wellId"] = this.wellId;
        data["wellNumber"] = this.wellNumber;
        data["rowLetter"] = this.rowLetter;
        data["columnNumber"] = this.columnNumber;
        data["wellVolume"] = this.wellVolume;
        data["wellWaterVolume"] = this.wellWaterVolume;
        data["error"] = this.error;
        data["hasError"] = this.hasError;
        data["warning"] = this.warning;
        data["hasWarning"] = this.hasWarning;
        if (Array.isArray(this.wellLayerList)) {
            data["wellLayerList"] = [];
            for (let item of this.wellLayerList)
                data["wellLayerList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dropList)) {
            data["dropList"] = [];
            for (let item of this.dropList)
                data["dropList"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxWellVolume"] = this.maxWellVolume;
        return data;
    }
}

export interface IWellIngDTO {
    plateId: number;
    wellId: number;
    wellNumber: number;
    rowLetter?: string | undefined;
    columnNumber: number;
    wellVolume?: number | undefined;
    wellWaterVolume?: number | undefined;
    error?: string | undefined;
    hasError: boolean;
    warning?: string | undefined;
    hasWarning: boolean;
    wellLayerList?: WellLayerDTO[] | undefined;
    dropList?: DropDTO[] | undefined;
    maxWellVolume?: number | undefined;
}

export class WellLayerDTO implements IWellLayerDTO {
    wellId!: number;
    id!: number;
    layerId!: number;
    layer?: LayerDTO | undefined;
    volume!: number;
    waterVolume!: number;
    sourceWellId?: number | undefined;
    waterSource?: string | undefined;
    sourceWellConditionNumber?: string | undefined;
    hasError!: boolean;
    error?: string | undefined;
    hasWarning!: boolean;
    warning?: string | undefined;
    wellLayerIngredientList?: WellLayerIngredientDTO[] | undefined;

    constructor(data?: IWellLayerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.id = _data["id"];
            this.layerId = _data["layerId"];
            this.layer = _data["layer"] ? LayerDTO.fromJS(_data["layer"]) : undefined as any;
            this.volume = _data["volume"];
            this.waterVolume = _data["waterVolume"];
            this.sourceWellId = _data["sourceWellId"];
            this.waterSource = _data["waterSource"];
            this.sourceWellConditionNumber = _data["sourceWellConditionNumber"];
            this.hasError = _data["hasError"];
            this.error = _data["error"];
            this.hasWarning = _data["hasWarning"];
            this.warning = _data["warning"];
            if (Array.isArray(_data["wellLayerIngredientList"])) {
                this.wellLayerIngredientList = [] as any;
                for (let item of _data["wellLayerIngredientList"])
                    this.wellLayerIngredientList!.push(WellLayerIngredientDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WellLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellLayerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["id"] = this.id;
        data["layerId"] = this.layerId;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        data["volume"] = this.volume;
        data["waterVolume"] = this.waterVolume;
        data["sourceWellId"] = this.sourceWellId;
        data["waterSource"] = this.waterSource;
        data["sourceWellConditionNumber"] = this.sourceWellConditionNumber;
        data["hasError"] = this.hasError;
        data["error"] = this.error;
        data["hasWarning"] = this.hasWarning;
        data["warning"] = this.warning;
        if (Array.isArray(this.wellLayerIngredientList)) {
            data["wellLayerIngredientList"] = [];
            for (let item of this.wellLayerIngredientList)
                data["wellLayerIngredientList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWellLayerDTO {
    wellId: number;
    id: number;
    layerId: number;
    layer?: LayerDTO | undefined;
    volume: number;
    waterVolume: number;
    sourceWellId?: number | undefined;
    waterSource?: string | undefined;
    sourceWellConditionNumber?: string | undefined;
    hasError: boolean;
    error?: string | undefined;
    hasWarning: boolean;
    warning?: string | undefined;
    wellLayerIngredientList?: WellLayerIngredientDTO[] | undefined;
}

export class LayerDTO implements ILayerDTO {
    id!: number;
    expId!: number;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    type!: LayerTypeDTO;
    layerState!: LayerStateDTO;
    name?: string | undefined;
    targetDrop?: number | undefined;
    volume!: number;
    volumeBasedAddition?: boolean | undefined;
    dispenseManually?: boolean | undefined;
    startingWellNumber?: number | undefined;
    wellDropVolumeVaryAlong!: number;
    startWellDropVolume!: number;
    stopWellDropVolume!: number;
    dirty!: boolean;
    locked!: boolean;
    overrideLayer!: boolean;
    layerDetail?: LayerDetailsDTO | undefined;

    constructor(data?: ILayerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expId = _data["expId"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.type = _data["type"];
            this.layerState = _data["layerState"];
            this.name = _data["name"];
            this.targetDrop = _data["targetDrop"];
            this.volume = _data["volume"];
            this.volumeBasedAddition = _data["volumeBasedAddition"];
            this.dispenseManually = _data["dispenseManually"];
            this.startingWellNumber = _data["startingWellNumber"];
            this.wellDropVolumeVaryAlong = _data["wellDropVolumeVaryAlong"];
            this.startWellDropVolume = _data["startWellDropVolume"];
            this.stopWellDropVolume = _data["stopWellDropVolume"];
            this.dirty = _data["dirty"];
            this.locked = _data["locked"];
            this.overrideLayer = _data["overrideLayer"];
            this.layerDetail = _data["layerDetail"] ? LayerDetailsDTO.fromJS(_data["layerDetail"]) : undefined as any;
        }
    }

    static fromJS(data: any): LayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LayerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expId"] = this.expId;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["type"] = this.type;
        data["layerState"] = this.layerState;
        data["name"] = this.name;
        data["targetDrop"] = this.targetDrop;
        data["volume"] = this.volume;
        data["volumeBasedAddition"] = this.volumeBasedAddition;
        data["dispenseManually"] = this.dispenseManually;
        data["startingWellNumber"] = this.startingWellNumber;
        data["wellDropVolumeVaryAlong"] = this.wellDropVolumeVaryAlong;
        data["startWellDropVolume"] = this.startWellDropVolume;
        data["stopWellDropVolume"] = this.stopWellDropVolume;
        data["dirty"] = this.dirty;
        data["locked"] = this.locked;
        data["overrideLayer"] = this.overrideLayer;
        data["layerDetail"] = this.layerDetail ? this.layerDetail.toJSON() : undefined as any;
        return data;
    }
}

export interface ILayerDTO {
    id: number;
    expId: number;
    x: number;
    y: number;
    width: number;
    height: number;
    type: LayerTypeDTO;
    layerState: LayerStateDTO;
    name?: string | undefined;
    targetDrop?: number | undefined;
    volume: number;
    volumeBasedAddition?: boolean | undefined;
    dispenseManually?: boolean | undefined;
    startingWellNumber?: number | undefined;
    wellDropVolumeVaryAlong: number;
    startWellDropVolume: number;
    stopWellDropVolume: number;
    dirty: boolean;
    locked: boolean;
    overrideLayer: boolean;
    layerDetail?: LayerDetailsDTO | undefined;
}

export enum LayerTypeDTO {
    Grid = 1,
    Protein = 2,
    ConditionList = 3,
    Random = 4,
    Screen = 5,
    Seed = 6,
    Fragment = 7,
}

export enum LayerStateDTO {
    UnChanged = 1,
    Modified = 2,
    New = 3,
    Deleted = 4,
}

export class LayerDetailsDTO implements ILayerDetailsDTO {
    layerId!: number;

    protected _discriminator: string;

    constructor(data?: ILayerDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "LayerDetailsDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.layerId = _data["layerId"];
        }
    }

    static fromJS(data: any): LayerDetailsDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "GridLayerDTO") {
            let result = new GridLayerDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CustomLayerDTO") {
            let result = new CustomLayerDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RandomLayerDTO") {
            let result = new RandomLayerDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ScreenLayerDTO") {
            let result = new ScreenLayerDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SeedLayerDetailsDTO") {
            let result = new SeedLayerDetailsDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ProteinLayerDTO") {
            let result = new ProteinLayerDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FragmentLayerDTO") {
            let result = new FragmentLayerDTO();
            result.init(data);
            return result;
        }
        let result = new LayerDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["layerId"] = this.layerId;
        return data;
    }
}

export interface ILayerDetailsDTO {
    layerId: number;
}

export class GridLayerDTO extends LayerDetailsDTO implements IGridLayerDTO {
    id!: number;
    gridId!: number;
    subGridNumber!: number;
    grid?: GridDTO | undefined;

    constructor(data?: IGridLayerDTO) {
        super(data);
        this._discriminator = "GridLayerDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.gridId = _data["gridId"];
            this.subGridNumber = _data["subGridNumber"];
            this.grid = _data["grid"] ? GridDTO.fromJS(_data["grid"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GridLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GridLayerDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gridId"] = this.gridId;
        data["subGridNumber"] = this.subGridNumber;
        data["grid"] = this.grid ? this.grid.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGridLayerDTO extends ILayerDetailsDTO {
    id: number;
    gridId: number;
    subGridNumber: number;
    grid?: GridDTO | undefined;
}

export class GridDTO implements IGridDTO {
    id!: number;
    experimentId!: number;
    startWellVolume!: number;
    stopWellVolume!: number;
    wellVolumeVaryAlong!: number;
    gridIngredient?: GridIngredientDTO[] | undefined;

    constructor(data?: IGridDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.startWellVolume = _data["startWellVolume"];
            this.stopWellVolume = _data["stopWellVolume"];
            this.wellVolumeVaryAlong = _data["wellVolumeVaryAlong"];
            if (Array.isArray(_data["gridIngredient"])) {
                this.gridIngredient = [] as any;
                for (let item of _data["gridIngredient"])
                    this.gridIngredient!.push(GridIngredientDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GridDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GridDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["startWellVolume"] = this.startWellVolume;
        data["stopWellVolume"] = this.stopWellVolume;
        data["wellVolumeVaryAlong"] = this.wellVolumeVaryAlong;
        if (Array.isArray(this.gridIngredient)) {
            data["gridIngredient"] = [];
            for (let item of this.gridIngredient)
                data["gridIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGridDTO {
    id: number;
    experimentId: number;
    startWellVolume: number;
    stopWellVolume: number;
    wellVolumeVaryAlong: number;
    gridIngredient?: GridIngredientDTO[] | undefined;
}

export class GridIngredientDTO implements IGridIngredientDTO {
    id!: number;
    gridId!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    startConcentration!: number;
    stopConcentration!: number;
    concentrationVaryAlong!: number;
    startpH?: number | undefined;
    stoppH?: number | undefined;
    pHvaryAlong?: number | undefined;
    concentrationVaryAlongCustom?: ConcentrationVaryAlongCustomDTO | undefined;
    pHVaryAlongCustom?: PhVaryAlongCustomDTO | undefined;

    constructor(data?: IGridIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gridId = _data["gridId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.startConcentration = _data["startConcentration"];
            this.stopConcentration = _data["stopConcentration"];
            this.concentrationVaryAlong = _data["concentrationVaryAlong"];
            this.startpH = _data["startpH"];
            this.stoppH = _data["stoppH"];
            this.pHvaryAlong = _data["pHvaryAlong"];
            this.concentrationVaryAlongCustom = _data["concentrationVaryAlongCustom"] ? ConcentrationVaryAlongCustomDTO.fromJS(_data["concentrationVaryAlongCustom"]) : undefined as any;
            this.pHVaryAlongCustom = _data["pHVaryAlongCustom"] ? PhVaryAlongCustomDTO.fromJS(_data["pHVaryAlongCustom"]) : undefined as any;
        }
    }

    static fromJS(data: any): GridIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GridIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gridId"] = this.gridId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["startConcentration"] = this.startConcentration;
        data["stopConcentration"] = this.stopConcentration;
        data["concentrationVaryAlong"] = this.concentrationVaryAlong;
        data["startpH"] = this.startpH;
        data["stoppH"] = this.stoppH;
        data["pHvaryAlong"] = this.pHvaryAlong;
        data["concentrationVaryAlongCustom"] = this.concentrationVaryAlongCustom ? this.concentrationVaryAlongCustom.toJSON() : undefined as any;
        data["pHVaryAlongCustom"] = this.pHVaryAlongCustom ? this.pHVaryAlongCustom.toJSON() : undefined as any;
        return data;
    }
}

export interface IGridIngredientDTO {
    id: number;
    gridId: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    startConcentration: number;
    stopConcentration: number;
    concentrationVaryAlong: number;
    startpH?: number | undefined;
    stoppH?: number | undefined;
    pHvaryAlong?: number | undefined;
    concentrationVaryAlongCustom?: ConcentrationVaryAlongCustomDTO | undefined;
    pHVaryAlongCustom?: PhVaryAlongCustomDTO | undefined;
}

export class ConcentrationVaryAlongCustomDTO implements IConcentrationVaryAlongCustomDTO {
    id!: number;
    concentrationVaryAlongCustomValues?: number[][] | undefined;

    constructor(data?: IConcentrationVaryAlongCustomDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["concentrationVaryAlongCustomValues"])) {
                this.concentrationVaryAlongCustomValues = [] as any;
                for (let item of _data["concentrationVaryAlongCustomValues"])
                    this.concentrationVaryAlongCustomValues!.push(item);
            }
        }
    }

    static fromJS(data: any): ConcentrationVaryAlongCustomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConcentrationVaryAlongCustomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.concentrationVaryAlongCustomValues)) {
            data["concentrationVaryAlongCustomValues"] = [];
            for (let item of this.concentrationVaryAlongCustomValues)
                data["concentrationVaryAlongCustomValues"].push(item);
        }
        return data;
    }
}

export interface IConcentrationVaryAlongCustomDTO {
    id: number;
    concentrationVaryAlongCustomValues?: number[][] | undefined;
}

export class PhVaryAlongCustomDTO implements IPhVaryAlongCustomDTO {
    id!: number;
    pHVaryAlongCustomValues?: number[][] | undefined;

    constructor(data?: IPhVaryAlongCustomDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["pHVaryAlongCustomValues"])) {
                this.pHVaryAlongCustomValues = [] as any;
                for (let item of _data["pHVaryAlongCustomValues"])
                    this.pHVaryAlongCustomValues!.push(item);
            }
        }
    }

    static fromJS(data: any): PhVaryAlongCustomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PhVaryAlongCustomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.pHVaryAlongCustomValues)) {
            data["pHVaryAlongCustomValues"] = [];
            for (let item of this.pHVaryAlongCustomValues)
                data["pHVaryAlongCustomValues"].push(item);
        }
        return data;
    }
}

export interface IPhVaryAlongCustomDTO {
    id: number;
    pHVaryAlongCustomValues?: number[][] | undefined;
}

export class CustomLayerDTO extends LayerDetailsDTO implements ICustomLayerDTO {
    id!: number;
    experimentId!: number;
    wellVolume!: number;
    condition?: ConditionDTO[] | undefined;

    constructor(data?: ICustomLayerDTO) {
        super(data);
        this._discriminator = "CustomLayerDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.wellVolume = _data["wellVolume"];
            if (Array.isArray(_data["condition"])) {
                this.condition = [] as any;
                for (let item of _data["condition"])
                    this.condition!.push(ConditionDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CustomLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomLayerDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["wellVolume"] = this.wellVolume;
        if (Array.isArray(this.condition)) {
            data["condition"] = [];
            for (let item of this.condition)
                data["condition"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICustomLayerDTO extends ILayerDetailsDTO {
    id: number;
    experimentId: number;
    wellVolume: number;
    condition?: ConditionDTO[] | undefined;
}

export class ConditionDTO implements IConditionDTO {
    id!: number;
    conditionListLayerId!: number;
    conditionNumber!: number;
    conditionIngredient?: ConditionIngredientDTO[] | undefined;
    metadata?: string | undefined;

    constructor(data?: IConditionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conditionListLayerId = _data["conditionListLayerId"];
            this.conditionNumber = _data["conditionNumber"];
            if (Array.isArray(_data["conditionIngredient"])) {
                this.conditionIngredient = [] as any;
                for (let item of _data["conditionIngredient"])
                    this.conditionIngredient!.push(ConditionIngredientDTO.fromJS(item));
            }
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): ConditionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conditionListLayerId"] = this.conditionListLayerId;
        data["conditionNumber"] = this.conditionNumber;
        if (Array.isArray(this.conditionIngredient)) {
            data["conditionIngredient"] = [];
            for (let item of this.conditionIngredient)
                data["conditionIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadata"] = this.metadata;
        return data;
    }
}

export interface IConditionDTO {
    id: number;
    conditionListLayerId: number;
    conditionNumber: number;
    conditionIngredient?: ConditionIngredientDTO[] | undefined;
    metadata?: string | undefined;
}

export class ConditionIngredientDTO implements IConditionIngredientDTO {
    id!: number;
    conditionId!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    concentration!: number;
    pH?: number | undefined;

    constructor(data?: IConditionIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conditionId = _data["conditionId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.concentration = _data["concentration"];
            this.pH = _data["pH"];
        }
    }

    static fromJS(data: any): ConditionIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conditionId"] = this.conditionId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["concentration"] = this.concentration;
        data["pH"] = this.pH;
        return data;
    }
}

export interface IConditionIngredientDTO {
    id: number;
    conditionId: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    concentration: number;
    pH?: number | undefined;
}

export class RandomLayerDTO extends LayerDetailsDTO implements IRandomLayerDTO {
    id!: number;
    experimentId!: number;
    gridSteps!: number;
    wellVolume!: number;
    randomLayerIngredientGroup?: RandomLayerIngredientGroupDTO[] | undefined;
    randomLayerExcludeList?: RandomLayerExcludeListDTO[] | undefined;

    constructor(data?: IRandomLayerDTO) {
        super(data);
        this._discriminator = "RandomLayerDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.gridSteps = _data["gridSteps"];
            this.wellVolume = _data["wellVolume"];
            if (Array.isArray(_data["randomLayerIngredientGroup"])) {
                this.randomLayerIngredientGroup = [] as any;
                for (let item of _data["randomLayerIngredientGroup"])
                    this.randomLayerIngredientGroup!.push(RandomLayerIngredientGroupDTO.fromJS(item));
            }
            if (Array.isArray(_data["randomLayerExcludeList"])) {
                this.randomLayerExcludeList = [] as any;
                for (let item of _data["randomLayerExcludeList"])
                    this.randomLayerExcludeList!.push(RandomLayerExcludeListDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RandomLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayerDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["gridSteps"] = this.gridSteps;
        data["wellVolume"] = this.wellVolume;
        if (Array.isArray(this.randomLayerIngredientGroup)) {
            data["randomLayerIngredientGroup"] = [];
            for (let item of this.randomLayerIngredientGroup)
                data["randomLayerIngredientGroup"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.randomLayerExcludeList)) {
            data["randomLayerExcludeList"] = [];
            for (let item of this.randomLayerExcludeList)
                data["randomLayerExcludeList"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRandomLayerDTO extends ILayerDetailsDTO {
    id: number;
    experimentId: number;
    gridSteps: number;
    wellVolume: number;
    randomLayerIngredientGroup?: RandomLayerIngredientGroupDTO[] | undefined;
    randomLayerExcludeList?: RandomLayerExcludeListDTO[] | undefined;
}

export class RandomLayerIngredientGroupDTO implements IRandomLayerIngredientGroupDTO {
    id!: number;
    name?: string | undefined;
    randomLayerGenerationList?: RandomLayerGenerationListDTO[] | undefined;
    randomLayerGroupIngredient?: RandomLayerGroupIngredientDTO[] | undefined;

    constructor(data?: IRandomLayerIngredientGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["randomLayerGenerationList"])) {
                this.randomLayerGenerationList = [] as any;
                for (let item of _data["randomLayerGenerationList"])
                    this.randomLayerGenerationList!.push(RandomLayerGenerationListDTO.fromJS(item));
            }
            if (Array.isArray(_data["randomLayerGroupIngredient"])) {
                this.randomLayerGroupIngredient = [] as any;
                for (let item of _data["randomLayerGroupIngredient"])
                    this.randomLayerGroupIngredient!.push(RandomLayerGroupIngredientDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RandomLayerIngredientGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayerIngredientGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.randomLayerGenerationList)) {
            data["randomLayerGenerationList"] = [];
            for (let item of this.randomLayerGenerationList)
                data["randomLayerGenerationList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.randomLayerGroupIngredient)) {
            data["randomLayerGroupIngredient"] = [];
            for (let item of this.randomLayerGroupIngredient)
                data["randomLayerGroupIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRandomLayerIngredientGroupDTO {
    id: number;
    name?: string | undefined;
    randomLayerGenerationList?: RandomLayerGenerationListDTO[] | undefined;
    randomLayerGroupIngredient?: RandomLayerGroupIngredientDTO[] | undefined;
}

export class RandomLayerGenerationListDTO implements IRandomLayerGenerationListDTO {
    id!: number;
    randomLayerId!: number;
    randomLayerIngredientGroupId!: number;
    probability!: number;

    constructor(data?: IRandomLayerGenerationListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.randomLayerId = _data["randomLayerId"];
            this.randomLayerIngredientGroupId = _data["randomLayerIngredientGroupId"];
            this.probability = _data["probability"];
        }
    }

    static fromJS(data: any): RandomLayerGenerationListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayerGenerationListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["randomLayerId"] = this.randomLayerId;
        data["randomLayerIngredientGroupId"] = this.randomLayerIngredientGroupId;
        data["probability"] = this.probability;
        return data;
    }
}

export interface IRandomLayerGenerationListDTO {
    id: number;
    randomLayerId: number;
    randomLayerIngredientGroupId: number;
    probability: number;
}

export class RandomLayerGroupIngredientDTO implements IRandomLayerGroupIngredientDTO {
    id!: number;
    randomLayerIngredientGroupId!: number;
    ingredientStockId!: number;
    highPhingredientStockId?: number | undefined;
    ingredientIngredientTypeId!: number;
    lowConcentration!: number;
    highConcentration!: number;
    lowPh?: number | undefined;
    highPh?: number | undefined;
    weight!: number;

    constructor(data?: IRandomLayerGroupIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.randomLayerIngredientGroupId = _data["randomLayerIngredientGroupId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.highPhingredientStockId = _data["highPhingredientStockId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.lowConcentration = _data["lowConcentration"];
            this.highConcentration = _data["highConcentration"];
            this.lowPh = _data["lowPh"];
            this.highPh = _data["highPh"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): RandomLayerGroupIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayerGroupIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["randomLayerIngredientGroupId"] = this.randomLayerIngredientGroupId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["highPhingredientStockId"] = this.highPhingredientStockId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["lowConcentration"] = this.lowConcentration;
        data["highConcentration"] = this.highConcentration;
        data["lowPh"] = this.lowPh;
        data["highPh"] = this.highPh;
        data["weight"] = this.weight;
        return data;
    }
}

export interface IRandomLayerGroupIngredientDTO {
    id: number;
    randomLayerIngredientGroupId: number;
    ingredientStockId: number;
    highPhingredientStockId?: number | undefined;
    ingredientIngredientTypeId: number;
    lowConcentration: number;
    highConcentration: number;
    lowPh?: number | undefined;
    highPh?: number | undefined;
    weight: number;
}

export class RandomLayerExcludeListDTO implements IRandomLayerExcludeListDTO {
    id!: number;
    randomLayerId!: number;
    ingredient1Id!: number;
    ingredient2Id!: number;
    ingredient1?: IngredientDTO | undefined;
    ingredient2?: IngredientDTO | undefined;

    constructor(data?: IRandomLayerExcludeListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.randomLayerId = _data["randomLayerId"];
            this.ingredient1Id = _data["ingredient1Id"];
            this.ingredient2Id = _data["ingredient2Id"];
            this.ingredient1 = _data["ingredient1"] ? IngredientDTO.fromJS(_data["ingredient1"]) : undefined as any;
            this.ingredient2 = _data["ingredient2"] ? IngredientDTO.fromJS(_data["ingredient2"]) : undefined as any;
        }
    }

    static fromJS(data: any): RandomLayerExcludeListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RandomLayerExcludeListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["randomLayerId"] = this.randomLayerId;
        data["ingredient1Id"] = this.ingredient1Id;
        data["ingredient2Id"] = this.ingredient2Id;
        data["ingredient1"] = this.ingredient1 ? this.ingredient1.toJSON() : undefined as any;
        data["ingredient2"] = this.ingredient2 ? this.ingredient2.toJSON() : undefined as any;
        return data;
    }
}

export interface IRandomLayerExcludeListDTO {
    id: number;
    randomLayerId: number;
    ingredient1Id: number;
    ingredient2Id: number;
    ingredient1?: IngredientDTO | undefined;
    ingredient2?: IngredientDTO | undefined;
}

export class IngredientDTO implements IIngredientDTO {
    id!: number;
    longName?: string | undefined;
    shortName?: string | undefined;
    maxStockNumber!: number;
    defaultNonBufferIngredientStockId?: number | undefined;
    defaultBufferIngredientStockId?: number | undefined;
    bufferCalculationTypeId?: number | undefined;
    pKa?: number | undefined;
    exportIngredientAliasId?: number | undefined;
    bufferDataPoint?: BufferDataPointDTO[] | undefined;

    constructor(data?: IIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.longName = _data["longName"];
            this.shortName = _data["shortName"];
            this.maxStockNumber = _data["maxStockNumber"];
            this.defaultNonBufferIngredientStockId = _data["defaultNonBufferIngredientStockId"];
            this.defaultBufferIngredientStockId = _data["defaultBufferIngredientStockId"];
            this.bufferCalculationTypeId = _data["bufferCalculationTypeId"];
            this.pKa = _data["pKa"];
            this.exportIngredientAliasId = _data["exportIngredientAliasId"];
            if (Array.isArray(_data["bufferDataPoint"])) {
                this.bufferDataPoint = [] as any;
                for (let item of _data["bufferDataPoint"])
                    this.bufferDataPoint!.push(BufferDataPointDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["longName"] = this.longName;
        data["shortName"] = this.shortName;
        data["maxStockNumber"] = this.maxStockNumber;
        data["defaultNonBufferIngredientStockId"] = this.defaultNonBufferIngredientStockId;
        data["defaultBufferIngredientStockId"] = this.defaultBufferIngredientStockId;
        data["bufferCalculationTypeId"] = this.bufferCalculationTypeId;
        data["pKa"] = this.pKa;
        data["exportIngredientAliasId"] = this.exportIngredientAliasId;
        if (Array.isArray(this.bufferDataPoint)) {
            data["bufferDataPoint"] = [];
            for (let item of this.bufferDataPoint)
                data["bufferDataPoint"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIngredientDTO {
    id: number;
    longName?: string | undefined;
    shortName?: string | undefined;
    maxStockNumber: number;
    defaultNonBufferIngredientStockId?: number | undefined;
    defaultBufferIngredientStockId?: number | undefined;
    bufferCalculationTypeId?: number | undefined;
    pKa?: number | undefined;
    exportIngredientAliasId?: number | undefined;
    bufferDataPoint?: BufferDataPointDTO[] | undefined;
}

export class BufferDataPointDTO implements IBufferDataPointDTO {
    id!: number;
    ingredientId!: number;
    ph!: number;
    ratio!: number;

    constructor(data?: IBufferDataPointDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientId = _data["ingredientId"];
            this.ph = _data["ph"];
            this.ratio = _data["ratio"];
        }
    }

    static fromJS(data: any): BufferDataPointDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BufferDataPointDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientId"] = this.ingredientId;
        data["ph"] = this.ph;
        data["ratio"] = this.ratio;
        return data;
    }
}

export interface IBufferDataPointDTO {
    id: number;
    ingredientId: number;
    ph: number;
    ratio: number;
}

export class ScreenLayerDTO extends LayerDetailsDTO implements IScreenLayerDTO {
    id!: number;
    experimentId!: number;
    screenLot?: ScreenLotDTO | undefined;
    volume!: number;
    startingWellNumber?: number | undefined;

    constructor(data?: IScreenLayerDTO) {
        super(data);
        this._discriminator = "ScreenLayerDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.screenLot = _data["screenLot"] ? ScreenLotDTO.fromJS(_data["screenLot"]) : undefined as any;
            this.volume = _data["volume"];
            this.startingWellNumber = _data["startingWellNumber"];
        }
    }

    static override fromJS(data: any): ScreenLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenLayerDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["screenLot"] = this.screenLot ? this.screenLot.toJSON() : undefined as any;
        data["volume"] = this.volume;
        data["startingWellNumber"] = this.startingWellNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IScreenLayerDTO extends ILayerDetailsDTO {
    id: number;
    experimentId: number;
    screenLot?: ScreenLotDTO | undefined;
    volume: number;
    startingWellNumber?: number | undefined;
}

export class SeedLayerDetailsDTO extends LayerDetailsDTO implements ISeedLayerDetailsDTO {
    id!: number;
    experimentId?: number | undefined;
    startSeedDropVolume?: number | undefined;
    stopSeedDropVolume?: number | undefined;
    seedDropVolumeVaryAlong?: number | undefined;
    seedId?: number | undefined;
    seedSeedLayerId?: number | undefined;
    seedName?: string | undefined;
    sourcePlateId?: number | undefined;
    sourceWellName?: string | undefined;
    sourceDropNumber?: number | undefined;
    sourceExperimentName?: string | undefined;

    constructor(data?: ISeedLayerDetailsDTO) {
        super(data);
        this._discriminator = "SeedLayerDetailsDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.startSeedDropVolume = _data["startSeedDropVolume"];
            this.stopSeedDropVolume = _data["stopSeedDropVolume"];
            this.seedDropVolumeVaryAlong = _data["seedDropVolumeVaryAlong"];
            this.seedId = _data["seedId"];
            this.seedSeedLayerId = _data["seedSeedLayerId"];
            this.seedName = _data["seedName"];
            this.sourcePlateId = _data["sourcePlateId"];
            this.sourceWellName = _data["sourceWellName"];
            this.sourceDropNumber = _data["sourceDropNumber"];
            this.sourceExperimentName = _data["sourceExperimentName"];
        }
    }

    static override fromJS(data: any): SeedLayerDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeedLayerDetailsDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["startSeedDropVolume"] = this.startSeedDropVolume;
        data["stopSeedDropVolume"] = this.stopSeedDropVolume;
        data["seedDropVolumeVaryAlong"] = this.seedDropVolumeVaryAlong;
        data["seedId"] = this.seedId;
        data["seedSeedLayerId"] = this.seedSeedLayerId;
        data["seedName"] = this.seedName;
        data["sourcePlateId"] = this.sourcePlateId;
        data["sourceWellName"] = this.sourceWellName;
        data["sourceDropNumber"] = this.sourceDropNumber;
        data["sourceExperimentName"] = this.sourceExperimentName;
        super.toJSON(data);
        return data;
    }
}

export interface ISeedLayerDetailsDTO extends ILayerDetailsDTO {
    id: number;
    experimentId?: number | undefined;
    startSeedDropVolume?: number | undefined;
    stopSeedDropVolume?: number | undefined;
    seedDropVolumeVaryAlong?: number | undefined;
    seedId?: number | undefined;
    seedSeedLayerId?: number | undefined;
    seedName?: string | undefined;
    sourcePlateId?: number | undefined;
    sourceWellName?: string | undefined;
    sourceDropNumber?: number | undefined;
    sourceExperimentName?: string | undefined;
}

export class ProteinLayerDTO extends LayerDetailsDTO implements IProteinLayerDTO {
    id!: number;
    experimentId?: number | undefined;
    proteinLayerProteinFormulation?: ProteinLayerProteinFormulationDTO[] | undefined;

    constructor(data?: IProteinLayerDTO) {
        super(data);
        this._discriminator = "ProteinLayerDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            if (Array.isArray(_data["proteinLayerProteinFormulation"])) {
                this.proteinLayerProteinFormulation = [] as any;
                for (let item of _data["proteinLayerProteinFormulation"])
                    this.proteinLayerProteinFormulation!.push(ProteinLayerProteinFormulationDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProteinLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinLayerDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        if (Array.isArray(this.proteinLayerProteinFormulation)) {
            data["proteinLayerProteinFormulation"] = [];
            for (let item of this.proteinLayerProteinFormulation)
                data["proteinLayerProteinFormulation"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProteinLayerDTO extends ILayerDetailsDTO {
    id: number;
    experimentId?: number | undefined;
    proteinLayerProteinFormulation?: ProteinLayerProteinFormulationDTO[] | undefined;
}

export class ProteinLayerProteinFormulationDTO implements IProteinLayerProteinFormulationDTO {
    id!: number;
    proteinLayerId!: number;
    proteinFormulationId!: number;
    startProteinDropVolume!: number;
    stopProteinDropVolume!: number;
    proteinDropVolumeVaryAlong!: number;
    wellDropVolumeVaryAlong!: number;
    startWellDropVolume!: number;
    stopWellDropVolume!: number;
    proteinFormulation?: ProteinFormulationDTO | undefined;

    constructor(data?: IProteinLayerProteinFormulationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proteinLayerId = _data["proteinLayerId"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.startProteinDropVolume = _data["startProteinDropVolume"];
            this.stopProteinDropVolume = _data["stopProteinDropVolume"];
            this.proteinDropVolumeVaryAlong = _data["proteinDropVolumeVaryAlong"];
            this.wellDropVolumeVaryAlong = _data["wellDropVolumeVaryAlong"];
            this.startWellDropVolume = _data["startWellDropVolume"];
            this.stopWellDropVolume = _data["stopWellDropVolume"];
            this.proteinFormulation = _data["proteinFormulation"] ? ProteinFormulationDTO.fromJS(_data["proteinFormulation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProteinLayerProteinFormulationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinLayerProteinFormulationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proteinLayerId"] = this.proteinLayerId;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["startProteinDropVolume"] = this.startProteinDropVolume;
        data["stopProteinDropVolume"] = this.stopProteinDropVolume;
        data["proteinDropVolumeVaryAlong"] = this.proteinDropVolumeVaryAlong;
        data["wellDropVolumeVaryAlong"] = this.wellDropVolumeVaryAlong;
        data["startWellDropVolume"] = this.startWellDropVolume;
        data["stopWellDropVolume"] = this.stopWellDropVolume;
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        return data;
    }
}

export interface IProteinLayerProteinFormulationDTO {
    id: number;
    proteinLayerId: number;
    proteinFormulationId: number;
    startProteinDropVolume: number;
    stopProteinDropVolume: number;
    proteinDropVolumeVaryAlong: number;
    wellDropVolumeVaryAlong: number;
    startWellDropVolume: number;
    stopWellDropVolume: number;
    proteinFormulation?: ProteinFormulationDTO | undefined;
}

export class FragmentLayerDTO extends LayerDetailsDTO implements IFragmentLayerDTO {
    id!: number;
    experimentId!: number;
    startingWellNumber!: number;
    fragmentScreenId!: number;
    volume!: number;
    fragmentScreen?: FragmentScreen | undefined;

    constructor(data?: IFragmentLayerDTO) {
        super(data);
        this._discriminator = "FragmentLayerDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.experimentId = _data["experimentId"];
            this.startingWellNumber = _data["startingWellNumber"];
            this.fragmentScreenId = _data["fragmentScreenId"];
            this.volume = _data["volume"];
            this.fragmentScreen = _data["fragmentScreen"] ? FragmentScreen.fromJS(_data["fragmentScreen"]) : undefined as any;
        }
    }

    static override fromJS(data: any): FragmentLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentLayerDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentId"] = this.experimentId;
        data["startingWellNumber"] = this.startingWellNumber;
        data["fragmentScreenId"] = this.fragmentScreenId;
        data["volume"] = this.volume;
        data["fragmentScreen"] = this.fragmentScreen ? this.fragmentScreen.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IFragmentLayerDTO extends ILayerDetailsDTO {
    id: number;
    experimentId: number;
    startingWellNumber: number;
    fragmentScreenId: number;
    volume: number;
    fragmentScreen?: FragmentScreen | undefined;
}

export class WellLayerIngredientDTO implements IWellLayerIngredientDTO {
    id!: number;
    wellLayerId!: number;
    volume!: number;
    ingredientTypeIsBuffer!: boolean;
    ingredientTypeColorGroupId!: number;
    ingredientTypeId!: number;
    color!: number;
    ingredientTypeName?: string | undefined;
    ingredientName?: string | undefined;
    hexColor?: string | undefined;
    lowPHVolume?: number | undefined;
    highPHVolume?: number | undefined;
    dropLayerId!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    ingredientStock?: IngredientStock | undefined;
    ingredientStockIngredient?: Ingredient | undefined;
    concentration!: number;
    concentrationUnit?: string | undefined;
    preMixedConcentration!: number;
    pH?: number | undefined;
    highPhIngStockId?: number | undefined;
    highPhIngStock?: IngredientStock | undefined;
    highPhIngStockIngredient?: Ingredient | undefined;
    stockConcentration!: number;
    isBuffer!: boolean;
    ingredientIngredientTypeIsBuffer!: boolean;

    constructor(data?: IWellLayerIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellLayerId = _data["wellLayerId"];
            this.volume = _data["volume"];
            this.ingredientTypeIsBuffer = _data["ingredientTypeIsBuffer"];
            this.ingredientTypeColorGroupId = _data["ingredientTypeColorGroupId"];
            this.ingredientTypeId = _data["ingredientTypeId"];
            this.color = _data["color"];
            this.ingredientTypeName = _data["ingredientTypeName"];
            this.ingredientName = _data["ingredientName"];
            this.hexColor = _data["hexColor"];
            this.lowPHVolume = _data["lowPHVolume"];
            this.highPHVolume = _data["highPHVolume"];
            this.dropLayerId = _data["dropLayerId"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.ingredientStock = _data["ingredientStock"] ? IngredientStock.fromJS(_data["ingredientStock"]) : undefined as any;
            this.ingredientStockIngredient = _data["ingredientStockIngredient"] ? Ingredient.fromJS(_data["ingredientStockIngredient"]) : undefined as any;
            this.concentration = _data["concentration"];
            this.concentrationUnit = _data["concentrationUnit"];
            this.preMixedConcentration = _data["preMixedConcentration"];
            this.pH = _data["pH"];
            this.highPhIngStockId = _data["highPhIngStockId"];
            this.highPhIngStock = _data["highPhIngStock"] ? IngredientStock.fromJS(_data["highPhIngStock"]) : undefined as any;
            this.highPhIngStockIngredient = _data["highPhIngStockIngredient"] ? Ingredient.fromJS(_data["highPhIngStockIngredient"]) : undefined as any;
            this.stockConcentration = _data["stockConcentration"];
            this.isBuffer = _data["isBuffer"];
            this.ingredientIngredientTypeIsBuffer = _data["ingredientIngredientTypeIsBuffer"];
        }
    }

    static fromJS(data: any): WellLayerIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellLayerIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellLayerId"] = this.wellLayerId;
        data["volume"] = this.volume;
        data["ingredientTypeIsBuffer"] = this.ingredientTypeIsBuffer;
        data["ingredientTypeColorGroupId"] = this.ingredientTypeColorGroupId;
        data["ingredientTypeId"] = this.ingredientTypeId;
        data["color"] = this.color;
        data["ingredientTypeName"] = this.ingredientTypeName;
        data["ingredientName"] = this.ingredientName;
        data["hexColor"] = this.hexColor;
        data["lowPHVolume"] = this.lowPHVolume;
        data["highPHVolume"] = this.highPHVolume;
        data["dropLayerId"] = this.dropLayerId;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["ingredientStock"] = this.ingredientStock ? this.ingredientStock.toJSON() : undefined as any;
        data["ingredientStockIngredient"] = this.ingredientStockIngredient ? this.ingredientStockIngredient.toJSON() : undefined as any;
        data["concentration"] = this.concentration;
        data["concentrationUnit"] = this.concentrationUnit;
        data["preMixedConcentration"] = this.preMixedConcentration;
        data["pH"] = this.pH;
        data["highPhIngStockId"] = this.highPhIngStockId;
        data["highPhIngStock"] = this.highPhIngStock ? this.highPhIngStock.toJSON() : undefined as any;
        data["highPhIngStockIngredient"] = this.highPhIngStockIngredient ? this.highPhIngStockIngredient.toJSON() : undefined as any;
        data["stockConcentration"] = this.stockConcentration;
        data["isBuffer"] = this.isBuffer;
        data["ingredientIngredientTypeIsBuffer"] = this.ingredientIngredientTypeIsBuffer;
        return data;
    }
}

export interface IWellLayerIngredientDTO {
    id: number;
    wellLayerId: number;
    volume: number;
    ingredientTypeIsBuffer: boolean;
    ingredientTypeColorGroupId: number;
    ingredientTypeId: number;
    color: number;
    ingredientTypeName?: string | undefined;
    ingredientName?: string | undefined;
    hexColor?: string | undefined;
    lowPHVolume?: number | undefined;
    highPHVolume?: number | undefined;
    dropLayerId: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    ingredientStock?: IngredientStock | undefined;
    ingredientStockIngredient?: Ingredient | undefined;
    concentration: number;
    concentrationUnit?: string | undefined;
    preMixedConcentration: number;
    pH?: number | undefined;
    highPhIngStockId?: number | undefined;
    highPhIngStock?: IngredientStock | undefined;
    highPhIngStockIngredient?: Ingredient | undefined;
    stockConcentration: number;
    isBuffer: boolean;
    ingredientIngredientTypeIsBuffer: boolean;
}

export class DropDTO implements IDropDTO {
    wellId?: number | undefined;
    dropId!: number;
    dropNumber!: number;
    proteinFormulationID?: number | undefined;
    proteinFormulationIDs?: number[] | undefined;
    dropWellVolume!: number;
    dropProteinVolume!: number;
    volume?: number | undefined;
    waterVolume?: number | undefined;
    seedIDs?: number[] | undefined;
    dropSeedVolume!: number;
    fragmentScreenId?: number | undefined;
    dropFragmentVolume?: number | undefined;
    importFl?: boolean | undefined;
    isFragmentDrop?: boolean | undefined;
    dropLayerList?: DropLayerDTO[] | undefined;

    constructor(data?: IDropDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellId = _data["wellId"];
            this.dropId = _data["dropId"];
            this.dropNumber = _data["dropNumber"];
            this.proteinFormulationID = _data["proteinFormulationID"];
            if (Array.isArray(_data["proteinFormulationIDs"])) {
                this.proteinFormulationIDs = [] as any;
                for (let item of _data["proteinFormulationIDs"])
                    this.proteinFormulationIDs!.push(item);
            }
            this.dropWellVolume = _data["dropWellVolume"];
            this.dropProteinVolume = _data["dropProteinVolume"];
            this.volume = _data["volume"];
            this.waterVolume = _data["waterVolume"];
            if (Array.isArray(_data["seedIDs"])) {
                this.seedIDs = [] as any;
                for (let item of _data["seedIDs"])
                    this.seedIDs!.push(item);
            }
            this.dropSeedVolume = _data["dropSeedVolume"];
            this.fragmentScreenId = _data["fragmentScreenId"];
            this.dropFragmentVolume = _data["dropFragmentVolume"];
            this.importFl = _data["importFl"];
            this.isFragmentDrop = _data["isFragmentDrop"];
            if (Array.isArray(_data["dropLayerList"])) {
                this.dropLayerList = [] as any;
                for (let item of _data["dropLayerList"])
                    this.dropLayerList!.push(DropLayerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DropDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DropDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellId"] = this.wellId;
        data["dropId"] = this.dropId;
        data["dropNumber"] = this.dropNumber;
        data["proteinFormulationID"] = this.proteinFormulationID;
        if (Array.isArray(this.proteinFormulationIDs)) {
            data["proteinFormulationIDs"] = [];
            for (let item of this.proteinFormulationIDs)
                data["proteinFormulationIDs"].push(item);
        }
        data["dropWellVolume"] = this.dropWellVolume;
        data["dropProteinVolume"] = this.dropProteinVolume;
        data["volume"] = this.volume;
        data["waterVolume"] = this.waterVolume;
        if (Array.isArray(this.seedIDs)) {
            data["seedIDs"] = [];
            for (let item of this.seedIDs)
                data["seedIDs"].push(item);
        }
        data["dropSeedVolume"] = this.dropSeedVolume;
        data["fragmentScreenId"] = this.fragmentScreenId;
        data["dropFragmentVolume"] = this.dropFragmentVolume;
        data["importFl"] = this.importFl;
        data["isFragmentDrop"] = this.isFragmentDrop;
        if (Array.isArray(this.dropLayerList)) {
            data["dropLayerList"] = [];
            for (let item of this.dropLayerList)
                data["dropLayerList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDropDTO {
    wellId?: number | undefined;
    dropId: number;
    dropNumber: number;
    proteinFormulationID?: number | undefined;
    proteinFormulationIDs?: number[] | undefined;
    dropWellVolume: number;
    dropProteinVolume: number;
    volume?: number | undefined;
    waterVolume?: number | undefined;
    seedIDs?: number[] | undefined;
    dropSeedVolume: number;
    fragmentScreenId?: number | undefined;
    dropFragmentVolume?: number | undefined;
    importFl?: boolean | undefined;
    isFragmentDrop?: boolean | undefined;
    dropLayerList?: DropLayerDTO[] | undefined;
}

export class DropLayerDTO implements IDropLayerDTO {
    dropId!: number;
    id!: number;
    layerId!: number;
    layer?: LayerDTO | undefined;
    volume!: number;
    waterVolume!: number;
    sourceWellId?: number | undefined;
    waterSource?: string | undefined;
    dropLayerIngredientList?: WellLayerIngredientDTO[] | undefined;
    dropLayerFragmentList?: DropLayerFragment[] | undefined;
    hasWarning!: boolean;
    warning?: string | undefined;
    hasError!: boolean;
    error?: string | undefined;

    constructor(data?: IDropLayerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dropId = _data["dropId"];
            this.id = _data["id"];
            this.layerId = _data["layerId"];
            this.layer = _data["layer"] ? LayerDTO.fromJS(_data["layer"]) : undefined as any;
            this.volume = _data["volume"];
            this.waterVolume = _data["waterVolume"];
            this.sourceWellId = _data["sourceWellId"];
            this.waterSource = _data["waterSource"];
            if (Array.isArray(_data["dropLayerIngredientList"])) {
                this.dropLayerIngredientList = [] as any;
                for (let item of _data["dropLayerIngredientList"])
                    this.dropLayerIngredientList!.push(WellLayerIngredientDTO.fromJS(item));
            }
            if (Array.isArray(_data["dropLayerFragmentList"])) {
                this.dropLayerFragmentList = [] as any;
                for (let item of _data["dropLayerFragmentList"])
                    this.dropLayerFragmentList!.push(DropLayerFragment.fromJS(item));
            }
            this.hasWarning = _data["hasWarning"];
            this.warning = _data["warning"];
            this.hasError = _data["hasError"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): DropLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DropLayerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dropId"] = this.dropId;
        data["id"] = this.id;
        data["layerId"] = this.layerId;
        data["layer"] = this.layer ? this.layer.toJSON() : undefined as any;
        data["volume"] = this.volume;
        data["waterVolume"] = this.waterVolume;
        data["sourceWellId"] = this.sourceWellId;
        data["waterSource"] = this.waterSource;
        if (Array.isArray(this.dropLayerIngredientList)) {
            data["dropLayerIngredientList"] = [];
            for (let item of this.dropLayerIngredientList)
                data["dropLayerIngredientList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dropLayerFragmentList)) {
            data["dropLayerFragmentList"] = [];
            for (let item of this.dropLayerFragmentList)
                data["dropLayerFragmentList"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasWarning"] = this.hasWarning;
        data["warning"] = this.warning;
        data["hasError"] = this.hasError;
        data["error"] = this.error;
        return data;
    }
}

export interface IDropLayerDTO {
    dropId: number;
    id: number;
    layerId: number;
    layer?: LayerDTO | undefined;
    volume: number;
    waterVolume: number;
    sourceWellId?: number | undefined;
    waterSource?: string | undefined;
    dropLayerIngredientList?: WellLayerIngredientDTO[] | undefined;
    dropLayerFragmentList?: DropLayerFragment[] | undefined;
    hasWarning: boolean;
    warning?: string | undefined;
    hasError: boolean;
    error?: string | undefined;
}

export class DropLayerFragment implements IDropLayerFragment {
    id!: number;
    wellDropLayerId!: number;
    fragmentId!: number;
    source?: string | undefined;
    concentration!: number;
    name?: string | undefined;

    constructor(data?: IDropLayerFragment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDropLayerId = _data["wellDropLayerId"];
            this.fragmentId = _data["fragmentId"];
            this.source = _data["source"];
            this.concentration = _data["concentration"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DropLayerFragment {
        data = typeof data === 'object' ? data : {};
        let result = new DropLayerFragment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDropLayerId"] = this.wellDropLayerId;
        data["fragmentId"] = this.fragmentId;
        data["source"] = this.source;
        data["concentration"] = this.concentration;
        data["name"] = this.name;
        return data;
    }
}

export interface IDropLayerFragment {
    id: number;
    wellDropLayerId: number;
    fragmentId: number;
    source?: string | undefined;
    concentration: number;
    name?: string | undefined;
}

export class ContainerDropDTO implements IContainerDropDTO {
    id!: number;
    containerId!: number;
    dropNumber!: number;
    container?: ContainersDTO | undefined;

    constructor(data?: IContainerDropDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerId = _data["containerId"];
            this.dropNumber = _data["dropNumber"];
            this.container = _data["container"] ? ContainersDTO.fromJS(_data["container"]) : undefined as any;
        }
    }

    static fromJS(data: any): ContainerDropDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerDropDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerId"] = this.containerId;
        data["dropNumber"] = this.dropNumber;
        data["container"] = this.container ? this.container.toJSON() : undefined as any;
        return data;
    }
}

export interface IContainerDropDTO {
    id: number;
    containerId: number;
    dropNumber: number;
    container?: ContainersDTO | undefined;
}

export class ContainersDTO implements IContainersDTO {
    id!: number;
    name?: string | undefined;
    cols!: number;
    rows!: number;
    defaultWellVolume!: number;
    containerDrops?: ContainerDropDTO[] | undefined;
    defaultAdditiveVolume!: number;
    maxWellVolume!: number;
    maxNumDrops!: number;
    defaultDropVolume!: number;
    maxDropVolume!: number;
    defaultSeedVolume?: number | undefined;
    defaultFragmentVolume?: number | undefined;
    type!: number;
    enable?: boolean | undefined;

    constructor(data?: IContainersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cols = _data["cols"];
            this.rows = _data["rows"];
            this.defaultWellVolume = _data["defaultWellVolume"];
            if (Array.isArray(_data["containerDrops"])) {
                this.containerDrops = [] as any;
                for (let item of _data["containerDrops"])
                    this.containerDrops!.push(ContainerDropDTO.fromJS(item));
            }
            this.defaultAdditiveVolume = _data["defaultAdditiveVolume"];
            this.maxWellVolume = _data["maxWellVolume"];
            this.maxNumDrops = _data["maxNumDrops"];
            this.defaultDropVolume = _data["defaultDropVolume"];
            this.maxDropVolume = _data["maxDropVolume"];
            this.defaultSeedVolume = _data["defaultSeedVolume"];
            this.defaultFragmentVolume = _data["defaultFragmentVolume"];
            this.type = _data["type"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): ContainersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContainersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cols"] = this.cols;
        data["rows"] = this.rows;
        data["defaultWellVolume"] = this.defaultWellVolume;
        if (Array.isArray(this.containerDrops)) {
            data["containerDrops"] = [];
            for (let item of this.containerDrops)
                data["containerDrops"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultAdditiveVolume"] = this.defaultAdditiveVolume;
        data["maxWellVolume"] = this.maxWellVolume;
        data["maxNumDrops"] = this.maxNumDrops;
        data["defaultDropVolume"] = this.defaultDropVolume;
        data["maxDropVolume"] = this.maxDropVolume;
        data["defaultSeedVolume"] = this.defaultSeedVolume;
        data["defaultFragmentVolume"] = this.defaultFragmentVolume;
        data["type"] = this.type;
        data["enable"] = this.enable;
        return data;
    }
}

export interface IContainersDTO {
    id: number;
    name?: string | undefined;
    cols: number;
    rows: number;
    defaultWellVolume: number;
    containerDrops?: ContainerDropDTO[] | undefined;
    defaultAdditiveVolume: number;
    maxWellVolume: number;
    maxNumDrops: number;
    defaultDropVolume: number;
    maxDropVolume: number;
    defaultSeedVolume?: number | undefined;
    defaultFragmentVolume?: number | undefined;
    type: number;
    enable?: boolean | undefined;
}

export class ISOWellDropScoreDTO implements IISOWellDropScoreDTO {
    id!: number;
    plateId?: number | undefined;
    wellDropScoreId?: number | undefined;
    isovalue?: number | undefined;

    constructor(data?: IISOWellDropScoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plateId = _data["plateId"];
            this.wellDropScoreId = _data["wellDropScoreId"];
            this.isovalue = _data["isovalue"];
        }
    }

    static fromJS(data: any): ISOWellDropScoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ISOWellDropScoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plateId"] = this.plateId;
        data["wellDropScoreId"] = this.wellDropScoreId;
        data["isovalue"] = this.isovalue;
        return data;
    }
}

export interface IISOWellDropScoreDTO {
    id: number;
    plateId?: number | undefined;
    wellDropScoreId?: number | undefined;
    isovalue?: number | undefined;
}

export class InspectionSetDTO implements IInspectionSetDTO {
    id!: number;
    name?: string | undefined;
    groupedInspections?: InspectionDTO[] | undefined;
    dateImaged?: Date | undefined;

    constructor(data?: IInspectionSetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["groupedInspections"])) {
                this.groupedInspections = [] as any;
                for (let item of _data["groupedInspections"])
                    this.groupedInspections!.push(InspectionDTO.fromJS(item));
            }
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InspectionSetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionSetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.groupedInspections)) {
            data["groupedInspections"] = [];
            for (let item of this.groupedInspections)
                data["groupedInspections"].push(item ? item.toJSON() : undefined as any);
        }
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        return data;
    }
}

export interface IInspectionSetDTO {
    id: number;
    name?: string | undefined;
    groupedInspections?: InspectionDTO[] | undefined;
    dateImaged?: Date | undefined;
}

export class InspectionDTO implements IInspectionDTO {
    id!: number;
    imageBatchId!: number;
    plateId!: number;
    experimentPlateId!: number;
    name?: string | undefined;

    constructor(data?: IInspectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageBatchId = _data["imageBatchId"];
            this.plateId = _data["plateId"];
            this.experimentPlateId = _data["experimentPlateId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InspectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageBatchId"] = this.imageBatchId;
        data["plateId"] = this.plateId;
        data["experimentPlateId"] = this.experimentPlateId;
        data["name"] = this.name;
        return data;
    }
}

export interface IInspectionDTO {
    id: number;
    imageBatchId: number;
    plateId: number;
    experimentPlateId: number;
    name?: string | undefined;
}

export class RegionsDTO implements IRegionsDTO {
    name?: string | undefined;
    id?: string | undefined;
    isDefaultRegion!: boolean;
    drops?: RegionDetailDTO[] | undefined;

    constructor(data?: IRegionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.isDefaultRegion = _data["isDefaultRegion"];
            if (Array.isArray(_data["drops"])) {
                this.drops = [] as any;
                for (let item of _data["drops"])
                    this.drops!.push(RegionDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["isDefaultRegion"] = this.isDefaultRegion;
        if (Array.isArray(this.drops)) {
            data["drops"] = [];
            for (let item of this.drops)
                data["drops"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegionsDTO {
    name?: string | undefined;
    id?: string | undefined;
    isDefaultRegion: boolean;
    drops?: RegionDetailDTO[] | undefined;
}

export class RegionDetailDTO implements IRegionDetailDTO {
    regionName?: string | undefined;
    regionId!: number;
    parentRegionId?: number | undefined;
    plateId!: number;
    dropNumber!: number;
    wellNumber!: number;
    plateNumber!: number;
    regionTypeId?: number | undefined;
    regionTypeName?: string | undefined;

    constructor(data?: IRegionDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionName = _data["regionName"];
            this.regionId = _data["regionId"];
            this.parentRegionId = _data["parentRegionId"];
            this.plateId = _data["plateId"];
            this.dropNumber = _data["dropNumber"];
            this.wellNumber = _data["wellNumber"];
            this.plateNumber = _data["plateNumber"];
            this.regionTypeId = _data["regionTypeId"];
            this.regionTypeName = _data["regionTypeName"];
        }
    }

    static fromJS(data: any): RegionDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionName"] = this.regionName;
        data["regionId"] = this.regionId;
        data["parentRegionId"] = this.parentRegionId;
        data["plateId"] = this.plateId;
        data["dropNumber"] = this.dropNumber;
        data["wellNumber"] = this.wellNumber;
        data["plateNumber"] = this.plateNumber;
        data["regionTypeId"] = this.regionTypeId;
        data["regionTypeName"] = this.regionTypeName;
        return data;
    }
}

export interface IRegionDetailDTO {
    regionName?: string | undefined;
    regionId: number;
    parentRegionId?: number | undefined;
    plateId: number;
    dropNumber: number;
    wellNumber: number;
    plateNumber: number;
    regionTypeId?: number | undefined;
    regionTypeName?: string | undefined;
}

export class DropsDTO implements IDropsDTO {
    name?: string | undefined;
    id!: number;

    constructor(data?: IDropsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DropsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DropsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IDropsDTO {
    name?: string | undefined;
    id: number;
}

export class TuningValuesDTO implements ITuningValuesDTO {
    isAutoLevelingOn!: boolean;
    autoLevelingLowThreshold!: number;
    autoLevelingHighThreshold!: number;
    lowerLevelLimit!: number;
    upperLevelLimit!: number;

    constructor(data?: ITuningValuesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAutoLevelingOn = _data["isAutoLevelingOn"];
            this.autoLevelingLowThreshold = _data["autoLevelingLowThreshold"];
            this.autoLevelingHighThreshold = _data["autoLevelingHighThreshold"];
            this.lowerLevelLimit = _data["lowerLevelLimit"];
            this.upperLevelLimit = _data["upperLevelLimit"];
        }
    }

    static fromJS(data: any): TuningValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TuningValuesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAutoLevelingOn"] = this.isAutoLevelingOn;
        data["autoLevelingLowThreshold"] = this.autoLevelingLowThreshold;
        data["autoLevelingHighThreshold"] = this.autoLevelingHighThreshold;
        data["lowerLevelLimit"] = this.lowerLevelLimit;
        data["upperLevelLimit"] = this.upperLevelLimit;
        return data;
    }
}

export interface ITuningValuesDTO {
    isAutoLevelingOn: boolean;
    autoLevelingLowThreshold: number;
    autoLevelingHighThreshold: number;
    lowerLevelLimit: number;
    upperLevelLimit: number;
}

export class ExperimentTuningValuesDTO extends TuningValuesDTO implements IExperimentTuningValuesDTO {
    id!: number;
    experimentID!: number;
    captureProfileID!: number;

    constructor(data?: IExperimentTuningValuesDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.experimentID = _data["experimentID"];
            this.captureProfileID = _data["captureProfileID"];
        }
    }

    static override fromJS(data: any): ExperimentTuningValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentTuningValuesDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentID"] = this.experimentID;
        data["captureProfileID"] = this.captureProfileID;
        super.toJSON(data);
        return data;
    }
}

export interface IExperimentTuningValuesDTO extends ITuningValuesDTO {
    id: number;
    experimentID: number;
    captureProfileID: number;
}

export class ExperimentSelectedStatesDTO implements IExperimentSelectedStatesDTO {
    dropNumber!: number;
    wellNumber!: number;
    plateNumber!: number;
    plateId!: number;
    regionName?: string | undefined;
    captureProfileId!: number;
    inspectionSetId!: number;

    constructor(data?: IExperimentSelectedStatesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dropNumber = _data["dropNumber"];
            this.wellNumber = _data["wellNumber"];
            this.plateNumber = _data["plateNumber"];
            this.plateId = _data["plateId"];
            this.regionName = _data["regionName"];
            this.captureProfileId = _data["captureProfileId"];
            this.inspectionSetId = _data["inspectionSetId"];
        }
    }

    static fromJS(data: any): ExperimentSelectedStatesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentSelectedStatesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dropNumber"] = this.dropNumber;
        data["wellNumber"] = this.wellNumber;
        data["plateNumber"] = this.plateNumber;
        data["plateId"] = this.plateId;
        data["regionName"] = this.regionName;
        data["captureProfileId"] = this.captureProfileId;
        data["inspectionSetId"] = this.inspectionSetId;
        return data;
    }
}

export interface IExperimentSelectedStatesDTO {
    dropNumber: number;
    wellNumber: number;
    plateNumber: number;
    plateId: number;
    regionName?: string | undefined;
    captureProfileId: number;
    inspectionSetId: number;
}

export class ExperimentInfoDTO implements IExperimentInfoDTO {
    id!: number;
    name?: string | undefined;
    setupTempId!: number;
    incubTempId!: number;
    setupTemperature?: string | undefined;
    incubTemperature?: string | undefined;
    reducingAgent!: number;
    userId!: number;
    userName?: string | undefined;
    containerId!: number;
    plateType?: string | undefined;
    plateRowCount!: number;
    plateColCount!: number;
    seeding!: boolean;
    notes?: string | undefined;
    noteBookPageNum?: string | undefined;
    dateCreated?: string | undefined;
    isDispensed!: boolean;
    hasLayers!: boolean;
    screenLots?: ExperimentScreenLot[] | undefined;
    dispensingProps?: BaseDriverPropertyDTO[] | undefined;
    dateDispensed?: string | undefined;
    dispensingRobotId?: number | undefined;
    proteinInfo?: ProteinAndIngredientsInfoDTO[] | undefined;
    screenInfo?: string[] | undefined;

    constructor(data?: IExperimentInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.setupTempId = _data["setupTempId"];
            this.incubTempId = _data["incubTempId"];
            this.setupTemperature = _data["setupTemperature"];
            this.incubTemperature = _data["incubTemperature"];
            this.reducingAgent = _data["reducingAgent"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.containerId = _data["containerId"];
            this.plateType = _data["plateType"];
            this.plateRowCount = _data["plateRowCount"];
            this.plateColCount = _data["plateColCount"];
            this.seeding = _data["seeding"];
            this.notes = _data["notes"];
            this.noteBookPageNum = _data["noteBookPageNum"];
            this.dateCreated = _data["dateCreated"];
            this.isDispensed = _data["isDispensed"];
            this.hasLayers = _data["hasLayers"];
            if (Array.isArray(_data["screenLots"])) {
                this.screenLots = [] as any;
                for (let item of _data["screenLots"])
                    this.screenLots!.push(ExperimentScreenLot.fromJS(item));
            }
            if (Array.isArray(_data["dispensingProps"])) {
                this.dispensingProps = [] as any;
                for (let item of _data["dispensingProps"])
                    this.dispensingProps!.push(BaseDriverPropertyDTO.fromJS(item));
            }
            this.dateDispensed = _data["dateDispensed"];
            this.dispensingRobotId = _data["dispensingRobotId"];
            if (Array.isArray(_data["proteinInfo"])) {
                this.proteinInfo = [] as any;
                for (let item of _data["proteinInfo"])
                    this.proteinInfo!.push(ProteinAndIngredientsInfoDTO.fromJS(item));
            }
            if (Array.isArray(_data["screenInfo"])) {
                this.screenInfo = [] as any;
                for (let item of _data["screenInfo"])
                    this.screenInfo!.push(item);
            }
        }
    }

    static fromJS(data: any): ExperimentInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["setupTempId"] = this.setupTempId;
        data["incubTempId"] = this.incubTempId;
        data["setupTemperature"] = this.setupTemperature;
        data["incubTemperature"] = this.incubTemperature;
        data["reducingAgent"] = this.reducingAgent;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["containerId"] = this.containerId;
        data["plateType"] = this.plateType;
        data["plateRowCount"] = this.plateRowCount;
        data["plateColCount"] = this.plateColCount;
        data["seeding"] = this.seeding;
        data["notes"] = this.notes;
        data["noteBookPageNum"] = this.noteBookPageNum;
        data["dateCreated"] = this.dateCreated;
        data["isDispensed"] = this.isDispensed;
        data["hasLayers"] = this.hasLayers;
        if (Array.isArray(this.screenLots)) {
            data["screenLots"] = [];
            for (let item of this.screenLots)
                data["screenLots"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dispensingProps)) {
            data["dispensingProps"] = [];
            for (let item of this.dispensingProps)
                data["dispensingProps"].push(item ? item.toJSON() : undefined as any);
        }
        data["dateDispensed"] = this.dateDispensed;
        data["dispensingRobotId"] = this.dispensingRobotId;
        if (Array.isArray(this.proteinInfo)) {
            data["proteinInfo"] = [];
            for (let item of this.proteinInfo)
                data["proteinInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenInfo)) {
            data["screenInfo"] = [];
            for (let item of this.screenInfo)
                data["screenInfo"].push(item);
        }
        return data;
    }
}

export interface IExperimentInfoDTO {
    id: number;
    name?: string | undefined;
    setupTempId: number;
    incubTempId: number;
    setupTemperature?: string | undefined;
    incubTemperature?: string | undefined;
    reducingAgent: number;
    userId: number;
    userName?: string | undefined;
    containerId: number;
    plateType?: string | undefined;
    plateRowCount: number;
    plateColCount: number;
    seeding: boolean;
    notes?: string | undefined;
    noteBookPageNum?: string | undefined;
    dateCreated?: string | undefined;
    isDispensed: boolean;
    hasLayers: boolean;
    screenLots?: ExperimentScreenLot[] | undefined;
    dispensingProps?: BaseDriverPropertyDTO[] | undefined;
    dateDispensed?: string | undefined;
    dispensingRobotId?: number | undefined;
    proteinInfo?: ProteinAndIngredientsInfoDTO[] | undefined;
    screenInfo?: string[] | undefined;
}

export class ExperimentScreenLot implements IExperimentScreenLot {
    id!: number;
    containerId!: number;
    comment?: string | undefined;
    lotNumber!: number;
    dispenseVol!: number;
    currentVol!: number;
    state!: State;

    constructor(data?: IExperimentScreenLot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerId = _data["containerId"];
            this.comment = _data["comment"];
            this.lotNumber = _data["lotNumber"];
            this.dispenseVol = _data["dispenseVol"];
            this.currentVol = _data["currentVol"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ExperimentScreenLot {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentScreenLot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerId"] = this.containerId;
        data["comment"] = this.comment;
        data["lotNumber"] = this.lotNumber;
        data["dispenseVol"] = this.dispenseVol;
        data["currentVol"] = this.currentVol;
        data["state"] = this.state;
        return data;
    }
}

export interface IExperimentScreenLot {
    id: number;
    containerId: number;
    comment?: string | undefined;
    lotNumber: number;
    dispenseVol: number;
    currentVol: number;
    state: State;
}

export enum State {
    UnChanged = 0,
    New = 1,
    Updated = 2,
    Deleted = 3,
}

export class BaseDriverPropertyDTO implements IBaseDriverPropertyDTO {
    property?: BasePropertyDTO | undefined;
    dispensingRobotId!: number;
    dispensingPlateId?: number | undefined;
    dispensingLiquidClassId?: number | undefined;

    constructor(data?: IBaseDriverPropertyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"] ? BasePropertyDTO.fromJS(_data["property"]) : undefined as any;
            this.dispensingRobotId = _data["dispensingRobotId"];
            this.dispensingPlateId = _data["dispensingPlateId"];
            this.dispensingLiquidClassId = _data["dispensingLiquidClassId"];
        }
    }

    static fromJS(data: any): BaseDriverPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseDriverPropertyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property ? this.property.toJSON() : undefined as any;
        data["dispensingRobotId"] = this.dispensingRobotId;
        data["dispensingPlateId"] = this.dispensingPlateId;
        data["dispensingLiquidClassId"] = this.dispensingLiquidClassId;
        return data;
    }
}

export interface IBaseDriverPropertyDTO {
    property?: BasePropertyDTO | undefined;
    dispensingRobotId: number;
    dispensingPlateId?: number | undefined;
    dispensingLiquidClassId?: number | undefined;
}

export class BasePropertyDTO implements IBasePropertyDTO {
    name?: string | undefined;
    displayName?: string | undefined;
    categoryName?: string | undefined;
    key?: SystemPropertyKey | undefined;
    validations?: ValidationAttribute[] | undefined;

    protected _discriminator: string;

    constructor(data?: IBasePropertyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "BasePropertyDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.categoryName = _data["categoryName"];
            this.key = _data["key"] ? SystemPropertyKey.fromJS(_data["key"]) : undefined as any;
            if (Array.isArray(_data["validations"])) {
                this.validations = [] as any;
                for (let item of _data["validations"])
                    this.validations!.push(ValidationAttribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BasePropertyDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "BooleanPropertyDTO") {
            let result = new BooleanPropertyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StringPropertyDTO") {
            let result = new StringPropertyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DBListPropertyDTO") {
            let result = new DBListPropertyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ListPropertyDTO") {
            let result = new ListPropertyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IntPropertyDTO") {
            let result = new IntPropertyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LongPropertyDTO") {
            let result = new LongPropertyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ColorPropertyDTO") {
            let result = new ColorPropertyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DoublePropertyDTO") {
            let result = new DoublePropertyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ListEnumDTO") {
            let result = new ListEnumDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TimePropertyDTO") {
            let result = new TimePropertyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FloatPropertyDTO") {
            let result = new FloatPropertyDTO();
            result.init(data);
            return result;
        }
        let result = new BasePropertyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["categoryName"] = this.categoryName;
        data["key"] = this.key ? this.key.toJSON() : undefined as any;
        if (Array.isArray(this.validations)) {
            data["validations"] = [];
            for (let item of this.validations)
                data["validations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBasePropertyDTO {
    name?: string | undefined;
    displayName?: string | undefined;
    categoryName?: string | undefined;
    key?: SystemPropertyKey | undefined;
    validations?: ValidationAttribute[] | undefined;
}

export abstract class PropertyKey implements IPropertyKey {

    constructor(data?: IPropertyKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PropertyKey {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PropertyKey' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPropertyKey {
}

export class SystemPropertyKey extends PropertyKey implements ISystemPropertyKey {
    foreignTable?: string | undefined;
    foreignID?: number | undefined;
    userID!: number;
    groupID!: number;

    constructor(data?: ISystemPropertyKey) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.foreignTable = _data["foreignTable"];
            this.foreignID = _data["foreignID"];
            this.userID = _data["userID"];
            this.groupID = _data["groupID"];
        }
    }

    static override fromJS(data: any): SystemPropertyKey {
        data = typeof data === 'object' ? data : {};
        let result = new SystemPropertyKey();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foreignTable"] = this.foreignTable;
        data["foreignID"] = this.foreignID;
        data["userID"] = this.userID;
        data["groupID"] = this.groupID;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemPropertyKey extends IPropertyKey {
    foreignTable?: string | undefined;
    foreignID?: number | undefined;
    userID: number;
    groupID: number;
}

export class ValidationAttribute implements IValidationAttribute {
    type!: ValidationType;
    errorMessage?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IValidationAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "ValidationAttribute";
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ValidationAttribute {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "MinValueValidationAttribute") {
            let result = new MinValueValidationAttribute();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MaxValueValidationAttribute") {
            let result = new MaxValueValidationAttribute();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RangeValidationAttribute") {
            let result = new RangeValidationAttribute();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StringLengthValidationAttribute") {
            let result = new StringLengthValidationAttribute();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RegexValidationAttribute") {
            let result = new RegexValidationAttribute();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MaxProductValidationAttribute") {
            let result = new MaxProductValidationAttribute();
            result.init(data);
            return result;
        }
        let result = new ValidationAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["type"] = this.type;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IValidationAttribute {
    type: ValidationType;
    errorMessage?: string | undefined;
}

export enum ValidationType {
    MinValue = 0,
    MaxValue = 1,
    Range = 2,
    Required = 3,
    MinLength = 4,
    MaxLength = 5,
    StringLength = 6,
    RegexPattern = 7,
    MaxProduct = 8,
}

export class MinValueValidationAttribute extends ValidationAttribute implements IMinValueValidationAttribute {
    minValue?: any | undefined;

    constructor(data?: IMinValueValidationAttribute) {
        super(data);
        this._discriminator = "MinValueValidationAttribute";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"];
        }
    }

    static override fromJS(data: any): MinValueValidationAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new MinValueValidationAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue;
        super.toJSON(data);
        return data;
    }
}

export interface IMinValueValidationAttribute extends IValidationAttribute {
    minValue?: any | undefined;
}

export class MaxValueValidationAttribute extends ValidationAttribute implements IMaxValueValidationAttribute {
    maxValue?: any | undefined;

    constructor(data?: IMaxValueValidationAttribute) {
        super(data);
        this._discriminator = "MaxValueValidationAttribute";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.maxValue = _data["maxValue"];
        }
    }

    static override fromJS(data: any): MaxValueValidationAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new MaxValueValidationAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxValue"] = this.maxValue;
        super.toJSON(data);
        return data;
    }
}

export interface IMaxValueValidationAttribute extends IValidationAttribute {
    maxValue?: any | undefined;
}

export class RangeValidationAttribute extends ValidationAttribute implements IRangeValidationAttribute {
    minValue?: any | undefined;
    maxValue?: any | undefined;

    constructor(data?: IRangeValidationAttribute) {
        super(data);
        this._discriminator = "RangeValidationAttribute";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
        }
    }

    static override fromJS(data: any): RangeValidationAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new RangeValidationAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        super.toJSON(data);
        return data;
    }
}

export interface IRangeValidationAttribute extends IValidationAttribute {
    minValue?: any | undefined;
    maxValue?: any | undefined;
}

export class StringLengthValidationAttribute extends ValidationAttribute implements IStringLengthValidationAttribute {
    minLength!: number;
    maxLength!: number;

    constructor(data?: IStringLengthValidationAttribute) {
        super(data);
        this._discriminator = "StringLengthValidationAttribute";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
        }
    }

    static override fromJS(data: any): StringLengthValidationAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StringLengthValidationAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        super.toJSON(data);
        return data;
    }
}

export interface IStringLengthValidationAttribute extends IValidationAttribute {
    minLength: number;
    maxLength: number;
}

export class RegexValidationAttribute extends ValidationAttribute implements IRegexValidationAttribute {
    pattern?: string | undefined;

    constructor(data?: IRegexValidationAttribute) {
        super(data);
        this._discriminator = "RegexValidationAttribute";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pattern = _data["pattern"];
        }
    }

    static override fromJS(data: any): RegexValidationAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new RegexValidationAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pattern"] = this.pattern;
        super.toJSON(data);
        return data;
    }
}

export interface IRegexValidationAttribute extends IValidationAttribute {
    pattern?: string | undefined;
}

export class MaxProductValidationAttribute extends ValidationAttribute implements IMaxProductValidationAttribute {
    operandProperty?: string | undefined;
    maxProduct!: number;

    constructor(data?: IMaxProductValidationAttribute) {
        super(data);
        this._discriminator = "MaxProductValidationAttribute";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.operandProperty = _data["operandProperty"];
            this.maxProduct = _data["maxProduct"];
        }
    }

    static override fromJS(data: any): MaxProductValidationAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new MaxProductValidationAttribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operandProperty"] = this.operandProperty;
        data["maxProduct"] = this.maxProduct;
        super.toJSON(data);
        return data;
    }
}

export interface IMaxProductValidationAttribute extends IValidationAttribute {
    operandProperty?: string | undefined;
    maxProduct: number;
}

export class DBListPropertyDTO extends BasePropertyDTO implements IDBListPropertyDTO {
    value?: ListElementDTO | undefined;
    options?: ListElementDTO[] | undefined;

    constructor(data?: IDBListPropertyDTO) {
        super(data);
        this._discriminator = "DBListPropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ListElementDTO.fromJS(_data["value"]) : undefined as any;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(ListElementDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DBListPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DBListPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDBListPropertyDTO extends IBasePropertyDTO {
    value?: ListElementDTO | undefined;
    options?: ListElementDTO[] | undefined;
}

export class ListElementDTO implements IListElementDTO {
    name?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IListElementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ListElementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ListElementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IListElementDTO {
    name?: string | undefined;
    displayName?: string | undefined;
}

export class ListPropertyDTO extends BasePropertyDTO implements IListPropertyDTO {
    value?: ListElementDTO | undefined;
    options?: ListElementDTO[] | undefined;

    constructor(data?: IListPropertyDTO) {
        super(data);
        this._discriminator = "ListPropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ListElementDTO.fromJS(_data["value"]) : undefined as any;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(ListElementDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ListPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ListPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListPropertyDTO extends IBasePropertyDTO {
    value?: ListElementDTO | undefined;
    options?: ListElementDTO[] | undefined;
}

export class IntPropertyDTO extends BasePropertyDTO implements IIntPropertyDTO {
    value!: number;

    constructor(data?: IIntPropertyDTO) {
        super(data);
        this._discriminator = "IntPropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): IntPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IntPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IIntPropertyDTO extends IBasePropertyDTO {
    value: number;
}

export class LongPropertyDTO extends BasePropertyDTO implements ILongPropertyDTO {
    value!: number;

    constructor(data?: ILongPropertyDTO) {
        super(data);
        this._discriminator = "LongPropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): LongPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LongPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface ILongPropertyDTO extends IBasePropertyDTO {
    value: number;
}

export class ColorPropertyDTO extends BasePropertyDTO implements IColorPropertyDTO {
    value?: string | undefined;

    constructor(data?: IColorPropertyDTO) {
        super(data);
        this._discriminator = "ColorPropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ColorPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ColorPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IColorPropertyDTO extends IBasePropertyDTO {
    value?: string | undefined;
}

export class DoublePropertyDTO extends BasePropertyDTO implements IDoublePropertyDTO {
    value!: number;

    constructor(data?: IDoublePropertyDTO) {
        super(data);
        this._discriminator = "DoublePropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): DoublePropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DoublePropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IDoublePropertyDTO extends IBasePropertyDTO {
    value: number;
}

export class BooleanPropertyDTO extends BasePropertyDTO implements IBooleanPropertyDTO {
    value!: boolean;

    constructor(data?: IBooleanPropertyDTO) {
        super(data);
        this._discriminator = "BooleanPropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BooleanPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IBooleanPropertyDTO extends IBasePropertyDTO {
    value: boolean;
}

export class ListEnumDTO extends BasePropertyDTO implements IListEnumDTO {
    value?: EnumElementDTO | undefined;
    options?: EnumElementDTO[] | undefined;

    constructor(data?: IListEnumDTO) {
        super(data);
        this._discriminator = "ListEnumDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? EnumElementDTO.fromJS(_data["value"]) : undefined as any;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(EnumElementDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ListEnumDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ListEnumDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IListEnumDTO extends IBasePropertyDTO {
    value?: EnumElementDTO | undefined;
    options?: EnumElementDTO[] | undefined;
}

export class EnumElementDTO implements IEnumElementDTO {
    name?: string | undefined;
    id!: number;
    displayName?: string | undefined;

    constructor(data?: IEnumElementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EnumElementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EnumElementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEnumElementDTO {
    name?: string | undefined;
    id: number;
    displayName?: string | undefined;
}

export class StringPropertyDTO extends BasePropertyDTO implements IStringPropertyDTO {
    value?: string | undefined;

    constructor(data?: IStringPropertyDTO) {
        super(data);
        this._discriminator = "StringPropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): StringPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StringPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IStringPropertyDTO extends IBasePropertyDTO {
    value?: string | undefined;
}

export class TimePropertyDTO extends BasePropertyDTO implements ITimePropertyDTO {
    value?: string | undefined;

    constructor(data?: ITimePropertyDTO) {
        super(data);
        this._discriminator = "TimePropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): TimePropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TimePropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface ITimePropertyDTO extends IBasePropertyDTO {
    value?: string | undefined;
}

export class FloatPropertyDTO extends BasePropertyDTO implements IFloatPropertyDTO {
    value!: number;

    constructor(data?: IFloatPropertyDTO) {
        super(data);
        this._discriminator = "FloatPropertyDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): FloatPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FloatPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IFloatPropertyDTO extends IBasePropertyDTO {
    value: number;
}

export class ProteinAndIngredientsInfoDTO implements IProteinAndIngredientsInfoDTO {
    name?: string | undefined;
    volume!: number;
    ingredients?: ProteinIngredientInfoDTO[] | undefined;

    constructor(data?: IProteinAndIngredientsInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.volume = _data["volume"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(ProteinIngredientInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProteinAndIngredientsInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinAndIngredientsInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["volume"] = this.volume;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProteinAndIngredientsInfoDTO {
    name?: string | undefined;
    volume: number;
    ingredients?: ProteinIngredientInfoDTO[] | undefined;
}

export class ProteinIngredientInfoDTO implements IProteinIngredientInfoDTO {
    name?: string | undefined;
    concentration?: number | undefined;

    constructor(data?: IProteinIngredientInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.concentration = _data["concentration"];
        }
    }

    static fromJS(data: any): ProteinIngredientInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinIngredientInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["concentration"] = this.concentration;
        return data;
    }
}

export interface IProteinIngredientInfoDTO {
    name?: string | undefined;
    concentration?: number | undefined;
}

export class ExperimentInfoImagingScheduleDTO implements IExperimentInfoImagingScheduleDTO {
    selectedImagingScheduleId!: number;
    imagingSchedules?: ExperimentImagingScheduleDTO[] | undefined;
    headers?: string[] | undefined;
    imagingScheduleEntries?: ExperimentImagingScheduleEntryDTO[] | undefined;

    constructor(data?: IExperimentInfoImagingScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedImagingScheduleId = _data["selectedImagingScheduleId"];
            if (Array.isArray(_data["imagingSchedules"])) {
                this.imagingSchedules = [] as any;
                for (let item of _data["imagingSchedules"])
                    this.imagingSchedules!.push(ExperimentImagingScheduleDTO.fromJS(item));
            }
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(item);
            }
            if (Array.isArray(_data["imagingScheduleEntries"])) {
                this.imagingScheduleEntries = [] as any;
                for (let item of _data["imagingScheduleEntries"])
                    this.imagingScheduleEntries!.push(ExperimentImagingScheduleEntryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExperimentInfoImagingScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentInfoImagingScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedImagingScheduleId"] = this.selectedImagingScheduleId;
        if (Array.isArray(this.imagingSchedules)) {
            data["imagingSchedules"] = [];
            for (let item of this.imagingSchedules)
                data["imagingSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        if (Array.isArray(this.imagingScheduleEntries)) {
            data["imagingScheduleEntries"] = [];
            for (let item of this.imagingScheduleEntries)
                data["imagingScheduleEntries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExperimentInfoImagingScheduleDTO {
    selectedImagingScheduleId: number;
    imagingSchedules?: ExperimentImagingScheduleDTO[] | undefined;
    headers?: string[] | undefined;
    imagingScheduleEntries?: ExperimentImagingScheduleEntryDTO[] | undefined;
}

export class ExperimentImagingScheduleDTO implements IExperimentImagingScheduleDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IExperimentImagingScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ExperimentImagingScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentImagingScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IExperimentImagingScheduleDTO {
    id: number;
    name?: string | undefined;
}

export class ExperimentImagingScheduleEntryDTO implements IExperimentImagingScheduleEntryDTO {
    id!: number;
    cpName?: string | undefined;
    days!: number;
    hours!: number;
    isSelected!: boolean;
    entryId!: number;

    constructor(data?: IExperimentImagingScheduleEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cpName = _data["cpName"];
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.isSelected = _data["isSelected"];
            this.entryId = _data["entryId"];
        }
    }

    static fromJS(data: any): ExperimentImagingScheduleEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentImagingScheduleEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cpName"] = this.cpName;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["isSelected"] = this.isSelected;
        data["entryId"] = this.entryId;
        return data;
    }
}

export interface IExperimentImagingScheduleEntryDTO {
    id: number;
    cpName?: string | undefined;
    days: number;
    hours: number;
    isSelected: boolean;
    entryId: number;
}

export class ScreenRepairInfoDTO implements IScreenRepairInfoDTO {
    sceenId!: number;
    isScreenRepairRequiredByDefaultLot!: boolean;
    experimentInfo?: { [key: string]: string; } | undefined;
    isOk!: boolean;
    totalLayersUsingScreen!: number;
    isScreenRepairEnabled!: boolean;

    constructor(data?: IScreenRepairInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sceenId = _data["sceenId"];
            this.isScreenRepairRequiredByDefaultLot = _data["isScreenRepairRequiredByDefaultLot"];
            if (_data["experimentInfo"]) {
                this.experimentInfo = {} as any;
                for (let key in _data["experimentInfo"]) {
                    if (_data["experimentInfo"].hasOwnProperty(key))
                        (this.experimentInfo as any)![key] = _data["experimentInfo"][key];
                }
            }
            this.isOk = _data["isOk"];
            this.totalLayersUsingScreen = _data["totalLayersUsingScreen"];
            this.isScreenRepairEnabled = _data["isScreenRepairEnabled"];
        }
    }

    static fromJS(data: any): ScreenRepairInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenRepairInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sceenId"] = this.sceenId;
        data["isScreenRepairRequiredByDefaultLot"] = this.isScreenRepairRequiredByDefaultLot;
        if (this.experimentInfo) {
            data["experimentInfo"] = {};
            for (let key in this.experimentInfo) {
                if (this.experimentInfo.hasOwnProperty(key))
                    (data["experimentInfo"] as any)[key] = (this.experimentInfo as any)[key];
            }
        }
        data["isOk"] = this.isOk;
        data["totalLayersUsingScreen"] = this.totalLayersUsingScreen;
        data["isScreenRepairEnabled"] = this.isScreenRepairEnabled;
        return data;
    }
}

export interface IScreenRepairInfoDTO {
    sceenId: number;
    isScreenRepairRequiredByDefaultLot: boolean;
    experimentInfo?: { [key: string]: string; } | undefined;
    isOk: boolean;
    totalLayersUsingScreen: number;
    isScreenRepairEnabled: boolean;
}

export class ExpListLayerDTO implements IExpListLayerDTO {
    expId!: number;
    layers?: LayerDTO[] | undefined;

    constructor(data?: IExpListLayerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expId = _data["expId"];
            if (Array.isArray(_data["layers"])) {
                this.layers = [] as any;
                for (let item of _data["layers"])
                    this.layers!.push(LayerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpListLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExpListLayerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expId"] = this.expId;
        if (Array.isArray(this.layers)) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExpListLayerDTO {
    expId: number;
    layers?: LayerDTO[] | undefined;
}

export class TreeNodeDTO implements ITreeNodeDTO {
    id!: number;
    name?: string | undefined;
    type?: string | undefined;
    parentId?: number | undefined;
    datePrepared?: string | undefined;
    dateImaged?: Date | undefined;
    sortOrder?: number | undefined;
    accessRightName?: string | undefined;
    hasContainerNode?: boolean | undefined;
    hasChildren?: boolean | undefined;
    allowEdits!: boolean;
    extra?: any | undefined;
    locked?: boolean | undefined;
    hitCount?: number | undefined;
    depth?: number | undefined;
    submenuItems?: TreeNodeDTO[] | undefined;
    accessRights?: TreeNodeAccessRightDTO[] | undefined;

    constructor(data?: ITreeNodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
            this.datePrepared = _data["datePrepared"];
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.sortOrder = _data["sortOrder"];
            this.accessRightName = _data["accessRightName"];
            this.hasContainerNode = _data["hasContainerNode"];
            this.hasChildren = _data["hasChildren"];
            this.allowEdits = _data["allowEdits"];
            this.extra = _data["extra"];
            this.locked = _data["locked"];
            this.hitCount = _data["hitCount"];
            this.depth = _data["depth"];
            if (Array.isArray(_data["submenuItems"])) {
                this.submenuItems = [] as any;
                for (let item of _data["submenuItems"])
                    this.submenuItems!.push(TreeNodeDTO.fromJS(item));
            }
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(TreeNodeAccessRightDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        data["datePrepared"] = this.datePrepared;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["sortOrder"] = this.sortOrder;
        data["accessRightName"] = this.accessRightName;
        data["hasContainerNode"] = this.hasContainerNode;
        data["hasChildren"] = this.hasChildren;
        data["allowEdits"] = this.allowEdits;
        data["extra"] = this.extra;
        data["locked"] = this.locked;
        data["hitCount"] = this.hitCount;
        data["depth"] = this.depth;
        if (Array.isArray(this.submenuItems)) {
            data["submenuItems"] = [];
            for (let item of this.submenuItems)
                data["submenuItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITreeNodeDTO {
    id: number;
    name?: string | undefined;
    type?: string | undefined;
    parentId?: number | undefined;
    datePrepared?: string | undefined;
    dateImaged?: Date | undefined;
    sortOrder?: number | undefined;
    accessRightName?: string | undefined;
    hasContainerNode?: boolean | undefined;
    hasChildren?: boolean | undefined;
    allowEdits: boolean;
    extra?: any | undefined;
    locked?: boolean | undefined;
    hitCount?: number | undefined;
    depth?: number | undefined;
    submenuItems?: TreeNodeDTO[] | undefined;
    accessRights?: TreeNodeAccessRightDTO[] | undefined;
}

export class TreeNodeAccessRightDTO implements ITreeNodeAccessRightDTO {
    nodeId?: number | undefined;
    accessRight?: AccessRightDTO[] | undefined;
    inheritedAccessRight?: AccessRightDTO[] | undefined;
    user?: UserDTO | undefined;
    group?: GroupDTO | undefined;

    constructor(data?: ITreeNodeAccessRightDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeId = _data["nodeId"];
            if (Array.isArray(_data["accessRight"])) {
                this.accessRight = [] as any;
                for (let item of _data["accessRight"])
                    this.accessRight!.push(AccessRightDTO.fromJS(item));
            }
            if (Array.isArray(_data["inheritedAccessRight"])) {
                this.inheritedAccessRight = [] as any;
                for (let item of _data["inheritedAccessRight"])
                    this.inheritedAccessRight!.push(AccessRightDTO.fromJS(item));
            }
            this.user = _data["user"] ? UserDTO.fromJS(_data["user"]) : undefined as any;
            this.group = _data["group"] ? GroupDTO.fromJS(_data["group"]) : undefined as any;
        }
    }

    static fromJS(data: any): TreeNodeAccessRightDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeAccessRightDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        if (Array.isArray(this.accessRight)) {
            data["accessRight"] = [];
            for (let item of this.accessRight)
                data["accessRight"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inheritedAccessRight)) {
            data["inheritedAccessRight"] = [];
            for (let item of this.inheritedAccessRight)
                data["inheritedAccessRight"].push(item ? item.toJSON() : undefined as any);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        return data;
    }
}

export interface ITreeNodeAccessRightDTO {
    nodeId?: number | undefined;
    accessRight?: AccessRightDTO[] | undefined;
    inheritedAccessRight?: AccessRightDTO[] | undefined;
    user?: UserDTO | undefined;
    group?: GroupDTO | undefined;
}

export class AccessRightDTO implements IAccessRightDTO {
    id!: number;
    accessLevel?: number | undefined;
    name?: string | undefined;
    inheritedFrom?: number | undefined;

    constructor(data?: IAccessRightDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessLevel = _data["accessLevel"];
            this.name = _data["name"];
            this.inheritedFrom = _data["inheritedFrom"];
        }
    }

    static fromJS(data: any): AccessRightDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRightDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessLevel"] = this.accessLevel;
        data["name"] = this.name;
        data["inheritedFrom"] = this.inheritedFrom;
        return data;
    }
}

export interface IAccessRightDTO {
    id: number;
    accessLevel?: number | undefined;
    name?: string | undefined;
    inheritedFrom?: number | undefined;
}

export class CreateExperimentDTO implements ICreateExperimentDTO {
    parentTreeNodeId!: number;
    userId!: number;

    constructor(data?: ICreateExperimentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentTreeNodeId = _data["parentTreeNodeId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CreateExperimentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExperimentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentTreeNodeId"] = this.parentTreeNodeId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICreateExperimentDTO {
    parentTreeNodeId: number;
    userId: number;
}

export class SaveDesignCanvasDTO implements ISaveDesignCanvasDTO {
    url?: string | undefined;
    path?: string | undefined;

    constructor(data?: ISaveDesignCanvasDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): SaveDesignCanvasDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDesignCanvasDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["path"] = this.path;
        return data;
    }
}

export interface ISaveDesignCanvasDTO {
    url?: string | undefined;
    path?: string | undefined;
}

export class SaveExperimentResponseDTO implements ISaveExperimentResponseDTO {
    experimentData?: SaveExprimentInfoDTO | undefined;
    alert?: AlertDTO | undefined;

    constructor(data?: ISaveExperimentResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentData = _data["experimentData"] ? SaveExprimentInfoDTO.fromJS(_data["experimentData"]) : undefined as any;
            this.alert = _data["alert"] ? AlertDTO.fromJS(_data["alert"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveExperimentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveExperimentResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentData"] = this.experimentData ? this.experimentData.toJSON() : undefined as any;
        data["alert"] = this.alert ? this.alert.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveExperimentResponseDTO {
    experimentData?: SaveExprimentInfoDTO | undefined;
    alert?: AlertDTO | undefined;
}

export class SaveExprimentInfoDTO implements ISaveExprimentInfoDTO {
    inspections?: InspectionSetsDTO | undefined;
    plates?: PlatesDTO[] | undefined;
    layers?: LayerDTO[] | undefined;
    globalIngredients?: GlobalIngredientsDTO | undefined;
    expInfoResponse?: UpdatedExperimentInfo | undefined;

    constructor(data?: ISaveExprimentInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspections = _data["inspections"] ? InspectionSetsDTO.fromJS(_data["inspections"]) : undefined as any;
            if (Array.isArray(_data["plates"])) {
                this.plates = [] as any;
                for (let item of _data["plates"])
                    this.plates!.push(PlatesDTO.fromJS(item));
            }
            if (Array.isArray(_data["layers"])) {
                this.layers = [] as any;
                for (let item of _data["layers"])
                    this.layers!.push(LayerDTO.fromJS(item));
            }
            this.globalIngredients = _data["globalIngredients"] ? GlobalIngredientsDTO.fromJS(_data["globalIngredients"]) : undefined as any;
            this.expInfoResponse = _data["expInfoResponse"] ? UpdatedExperimentInfo.fromJS(_data["expInfoResponse"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveExprimentInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveExprimentInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspections"] = this.inspections ? this.inspections.toJSON() : undefined as any;
        if (Array.isArray(this.plates)) {
            data["plates"] = [];
            for (let item of this.plates)
                data["plates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.layers)) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalIngredients"] = this.globalIngredients ? this.globalIngredients.toJSON() : undefined as any;
        data["expInfoResponse"] = this.expInfoResponse ? this.expInfoResponse.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveExprimentInfoDTO {
    inspections?: InspectionSetsDTO | undefined;
    plates?: PlatesDTO[] | undefined;
    layers?: LayerDTO[] | undefined;
    globalIngredients?: GlobalIngredientsDTO | undefined;
    expInfoResponse?: UpdatedExperimentInfo | undefined;
}

export class InspectionSetsDTO implements IInspectionSetsDTO {
    sets?: InspectionSetDTO[] | undefined;

    constructor(data?: IInspectionSetsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sets"])) {
                this.sets = [] as any;
                for (let item of _data["sets"])
                    this.sets!.push(InspectionSetDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InspectionSetsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionSetsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sets)) {
            data["sets"] = [];
            for (let item of this.sets)
                data["sets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInspectionSetsDTO {
    sets?: InspectionSetDTO[] | undefined;
}

export class GlobalIngredientsDTO implements IGlobalIngredientsDTO {
    ingredients?: IngredientDTO[] | undefined;
    ingredientStock?: IngredientStockDTO[] | undefined;
    ingredientIngredientType?: IngredientIngredientTypeDTO[] | undefined;
    ingredientType?: IngredientTypeDTO[] | undefined;
    ingredientTypeColor?: IngredientTypeColorDTO[] | undefined;
    favouriteIngredientStocks?: FavouriteIngredientStockDTO[] | undefined;

    constructor(data?: IGlobalIngredientsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(IngredientDTO.fromJS(item));
            }
            if (Array.isArray(_data["ingredientStock"])) {
                this.ingredientStock = [] as any;
                for (let item of _data["ingredientStock"])
                    this.ingredientStock!.push(IngredientStockDTO.fromJS(item));
            }
            if (Array.isArray(_data["ingredientIngredientType"])) {
                this.ingredientIngredientType = [] as any;
                for (let item of _data["ingredientIngredientType"])
                    this.ingredientIngredientType!.push(IngredientIngredientTypeDTO.fromJS(item));
            }
            if (Array.isArray(_data["ingredientType"])) {
                this.ingredientType = [] as any;
                for (let item of _data["ingredientType"])
                    this.ingredientType!.push(IngredientTypeDTO.fromJS(item));
            }
            if (Array.isArray(_data["ingredientTypeColor"])) {
                this.ingredientTypeColor = [] as any;
                for (let item of _data["ingredientTypeColor"])
                    this.ingredientTypeColor!.push(IngredientTypeColorDTO.fromJS(item));
            }
            if (Array.isArray(_data["favouriteIngredientStocks"])) {
                this.favouriteIngredientStocks = [] as any;
                for (let item of _data["favouriteIngredientStocks"])
                    this.favouriteIngredientStocks!.push(FavouriteIngredientStockDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalIngredientsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalIngredientsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredientStock)) {
            data["ingredientStock"] = [];
            for (let item of this.ingredientStock)
                data["ingredientStock"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredientIngredientType)) {
            data["ingredientIngredientType"] = [];
            for (let item of this.ingredientIngredientType)
                data["ingredientIngredientType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredientType)) {
            data["ingredientType"] = [];
            for (let item of this.ingredientType)
                data["ingredientType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredientTypeColor)) {
            data["ingredientTypeColor"] = [];
            for (let item of this.ingredientTypeColor)
                data["ingredientTypeColor"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.favouriteIngredientStocks)) {
            data["favouriteIngredientStocks"] = [];
            for (let item of this.favouriteIngredientStocks)
                data["favouriteIngredientStocks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlobalIngredientsDTO {
    ingredients?: IngredientDTO[] | undefined;
    ingredientStock?: IngredientStockDTO[] | undefined;
    ingredientIngredientType?: IngredientIngredientTypeDTO[] | undefined;
    ingredientType?: IngredientTypeDTO[] | undefined;
    ingredientTypeColor?: IngredientTypeColorDTO[] | undefined;
    favouriteIngredientStocks?: FavouriteIngredientStockDTO[] | undefined;
}

export class IngredientStockDTO implements IIngredientStockDTO {
    id!: number;
    ingredientId!: number;
    stockNumber!: number;
    stockConcentration!: number;
    lowConcentration!: number;
    highConcentration!: number;
    concentrationUnits?: string | undefined;
    stockPh?: number | undefined;
    isBuffer!: boolean;
    isPrepared!: boolean;
    liquidClassId!: number;
    labelPrinted!: boolean;
    dispenseOrder!: number;
    vendorId?: number | undefined;
    vendorPartNumber?: string | undefined;
    vendorName?: string | undefined;
    comments?: string | undefined;
    stockLocation?: string | undefined;
    active?: boolean | undefined;
    localID?: number | undefined;
    vendor?: VendorDTO | undefined;

    constructor(data?: IIngredientStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientId = _data["ingredientId"];
            this.stockNumber = _data["stockNumber"];
            this.stockConcentration = _data["stockConcentration"];
            this.lowConcentration = _data["lowConcentration"];
            this.highConcentration = _data["highConcentration"];
            this.concentrationUnits = _data["concentrationUnits"];
            this.stockPh = _data["stockPh"];
            this.isBuffer = _data["isBuffer"];
            this.isPrepared = _data["isPrepared"];
            this.liquidClassId = _data["liquidClassId"];
            this.labelPrinted = _data["labelPrinted"];
            this.dispenseOrder = _data["dispenseOrder"];
            this.vendorId = _data["vendorId"];
            this.vendorPartNumber = _data["vendorPartNumber"];
            this.vendorName = _data["vendorName"];
            this.comments = _data["comments"];
            this.stockLocation = _data["stockLocation"];
            this.active = _data["active"];
            this.localID = _data["localID"];
            this.vendor = _data["vendor"] ? VendorDTO.fromJS(_data["vendor"]) : undefined as any;
        }
    }

    static fromJS(data: any): IngredientStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientId"] = this.ingredientId;
        data["stockNumber"] = this.stockNumber;
        data["stockConcentration"] = this.stockConcentration;
        data["lowConcentration"] = this.lowConcentration;
        data["highConcentration"] = this.highConcentration;
        data["concentrationUnits"] = this.concentrationUnits;
        data["stockPh"] = this.stockPh;
        data["isBuffer"] = this.isBuffer;
        data["isPrepared"] = this.isPrepared;
        data["liquidClassId"] = this.liquidClassId;
        data["labelPrinted"] = this.labelPrinted;
        data["dispenseOrder"] = this.dispenseOrder;
        data["vendorId"] = this.vendorId;
        data["vendorPartNumber"] = this.vendorPartNumber;
        data["vendorName"] = this.vendorName;
        data["comments"] = this.comments;
        data["stockLocation"] = this.stockLocation;
        data["active"] = this.active;
        data["localID"] = this.localID;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : undefined as any;
        return data;
    }
}

export interface IIngredientStockDTO {
    id: number;
    ingredientId: number;
    stockNumber: number;
    stockConcentration: number;
    lowConcentration: number;
    highConcentration: number;
    concentrationUnits?: string | undefined;
    stockPh?: number | undefined;
    isBuffer: boolean;
    isPrepared: boolean;
    liquidClassId: number;
    labelPrinted: boolean;
    dispenseOrder: number;
    vendorId?: number | undefined;
    vendorPartNumber?: string | undefined;
    vendorName?: string | undefined;
    comments?: string | undefined;
    stockLocation?: string | undefined;
    active?: boolean | undefined;
    localID?: number | undefined;
    vendor?: VendorDTO | undefined;
}

export class VendorDTO implements IVendorDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IVendorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VendorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VendorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVendorDTO {
    id: number;
    name?: string | undefined;
}

export class IngredientIngredientTypeDTO implements IIngredientIngredientTypeDTO {
    id!: number;
    ingredientId!: number;
    ingredientTypeId!: number;

    constructor(data?: IIngredientIngredientTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientId = _data["ingredientId"];
            this.ingredientTypeId = _data["ingredientTypeId"];
        }
    }

    static fromJS(data: any): IngredientIngredientTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientIngredientTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientId"] = this.ingredientId;
        data["ingredientTypeId"] = this.ingredientTypeId;
        return data;
    }
}

export interface IIngredientIngredientTypeDTO {
    id: number;
    ingredientId: number;
    ingredientTypeId: number;
}

export class IngredientTypeDTO implements IIngredientTypeDTO {
    id!: number;
    isBuffer!: boolean;
    name?: string | undefined;
    ingredientTypeColorId?: number | undefined;
    state?: string | undefined;

    constructor(data?: IIngredientTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isBuffer = _data["isBuffer"];
            this.name = _data["name"];
            this.ingredientTypeColorId = _data["ingredientTypeColorId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): IngredientTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBuffer"] = this.isBuffer;
        data["name"] = this.name;
        data["ingredientTypeColorId"] = this.ingredientTypeColorId;
        data["state"] = this.state;
        return data;
    }
}

export interface IIngredientTypeDTO {
    id: number;
    isBuffer: boolean;
    name?: string | undefined;
    ingredientTypeColorId?: number | undefined;
    state?: string | undefined;
}

export class IngredientTypeColorDTO implements IIngredientTypeColorDTO {
    id!: number;
    groupId!: number;
    colorToneSequence!: number;
    color!: number;

    constructor(data?: IIngredientTypeColorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.colorToneSequence = _data["colorToneSequence"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): IngredientTypeColorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTypeColorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["colorToneSequence"] = this.colorToneSequence;
        data["color"] = this.color;
        return data;
    }
}

export interface IIngredientTypeColorDTO {
    id: number;
    groupId: number;
    colorToneSequence: number;
    color: number;
}

export class FavouriteIngredientStockDTO implements IFavouriteIngredientStockDTO {
    id!: number;
    ingredientIngredientTypeId!: number;
    ingredientStockId!: number;
    userId?: number | undefined;
    isFavourite!: boolean;

    constructor(data?: IFavouriteIngredientStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientIngredientTypeId = _data["ingredientIngredientTypeId"];
            this.ingredientStockId = _data["ingredientStockId"];
            this.userId = _data["userId"];
            this.isFavourite = _data["isFavourite"];
        }
    }

    static fromJS(data: any): FavouriteIngredientStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FavouriteIngredientStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientIngredientTypeId"] = this.ingredientIngredientTypeId;
        data["ingredientStockId"] = this.ingredientStockId;
        data["userId"] = this.userId;
        data["isFavourite"] = this.isFavourite;
        return data;
    }
}

export interface IFavouriteIngredientStockDTO {
    id: number;
    ingredientIngredientTypeId: number;
    ingredientStockId: number;
    userId?: number | undefined;
    isFavourite: boolean;
}

export class UpdatedExperimentInfo implements IUpdatedExperimentInfo {
    isTreeNodeNameExist!: boolean;

    constructor(data?: IUpdatedExperimentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTreeNodeNameExist = _data["isTreeNodeNameExist"];
        }
    }

    static fromJS(data: any): UpdatedExperimentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatedExperimentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTreeNodeNameExist"] = this.isTreeNodeNameExist;
        return data;
    }
}

export interface IUpdatedExperimentInfo {
    isTreeNodeNameExist: boolean;
}

export class AlertDTO implements IAlertDTO {
    alertType!: number;
    alertTitle?: string | undefined;
    alertMessage?: string | undefined;

    constructor(data?: IAlertDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertType = _data["alertType"];
            this.alertTitle = _data["alertTitle"];
            this.alertMessage = _data["alertMessage"];
        }
    }

    static fromJS(data: any): AlertDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertType"] = this.alertType;
        data["alertTitle"] = this.alertTitle;
        data["alertMessage"] = this.alertMessage;
        return data;
    }
}

export interface IAlertDTO {
    alertType: number;
    alertTitle?: string | undefined;
    alertMessage?: string | undefined;
}

export class SaveExperimentDTO implements ISaveExperimentDTO {
    expId!: number;
    experimentCanvas?: SaveCanvasItemsDTO | undefined;
    experimentInfo?: ExperimentInfoDTO | undefined;
    imagingSchedule?: SaveImagingScheduleDTO | undefined;
    dispensingProps?: BaseDriverPropertyDTO[] | undefined;
    importIngredients?: ImportIngredientsDTO | undefined;

    constructor(data?: ISaveExperimentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expId = _data["expId"];
            this.experimentCanvas = _data["experimentCanvas"] ? SaveCanvasItemsDTO.fromJS(_data["experimentCanvas"]) : undefined as any;
            this.experimentInfo = _data["experimentInfo"] ? ExperimentInfoDTO.fromJS(_data["experimentInfo"]) : undefined as any;
            this.imagingSchedule = _data["imagingSchedule"] ? SaveImagingScheduleDTO.fromJS(_data["imagingSchedule"]) : undefined as any;
            if (Array.isArray(_data["dispensingProps"])) {
                this.dispensingProps = [] as any;
                for (let item of _data["dispensingProps"])
                    this.dispensingProps!.push(BaseDriverPropertyDTO.fromJS(item));
            }
            this.importIngredients = _data["importIngredients"] ? ImportIngredientsDTO.fromJS(_data["importIngredients"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveExperimentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveExperimentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expId"] = this.expId;
        data["experimentCanvas"] = this.experimentCanvas ? this.experimentCanvas.toJSON() : undefined as any;
        data["experimentInfo"] = this.experimentInfo ? this.experimentInfo.toJSON() : undefined as any;
        data["imagingSchedule"] = this.imagingSchedule ? this.imagingSchedule.toJSON() : undefined as any;
        if (Array.isArray(this.dispensingProps)) {
            data["dispensingProps"] = [];
            for (let item of this.dispensingProps)
                data["dispensingProps"].push(item ? item.toJSON() : undefined as any);
        }
        data["importIngredients"] = this.importIngredients ? this.importIngredients.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveExperimentDTO {
    expId: number;
    experimentCanvas?: SaveCanvasItemsDTO | undefined;
    experimentInfo?: ExperimentInfoDTO | undefined;
    imagingSchedule?: SaveImagingScheduleDTO | undefined;
    dispensingProps?: BaseDriverPropertyDTO[] | undefined;
    importIngredients?: ImportIngredientsDTO | undefined;
}

export class SaveCanvasItemsDTO implements ISaveCanvasItemsDTO {
    layers?: LayerDTO[] | undefined;
    deletedLayers?: LayerDTO[] | undefined;
    plates?: SavePlateDTO[] | undefined;
    plateInfo?: SavePlateInfoDto[] | undefined;
    deletedPlateIds?: number[] | undefined;
    colCount!: number;
    rowCount!: number;

    constructor(data?: ISaveCanvasItemsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["layers"])) {
                this.layers = [] as any;
                for (let item of _data["layers"])
                    this.layers!.push(LayerDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedLayers"])) {
                this.deletedLayers = [] as any;
                for (let item of _data["deletedLayers"])
                    this.deletedLayers!.push(LayerDTO.fromJS(item));
            }
            if (Array.isArray(_data["plates"])) {
                this.plates = [] as any;
                for (let item of _data["plates"])
                    this.plates!.push(SavePlateDTO.fromJS(item));
            }
            if (Array.isArray(_data["plateInfo"])) {
                this.plateInfo = [] as any;
                for (let item of _data["plateInfo"])
                    this.plateInfo!.push(SavePlateInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["deletedPlateIds"])) {
                this.deletedPlateIds = [] as any;
                for (let item of _data["deletedPlateIds"])
                    this.deletedPlateIds!.push(item);
            }
            this.colCount = _data["colCount"];
            this.rowCount = _data["rowCount"];
        }
    }

    static fromJS(data: any): SaveCanvasItemsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCanvasItemsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.layers)) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedLayers)) {
            data["deletedLayers"] = [];
            for (let item of this.deletedLayers)
                data["deletedLayers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plates)) {
            data["plates"] = [];
            for (let item of this.plates)
                data["plates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plateInfo)) {
            data["plateInfo"] = [];
            for (let item of this.plateInfo)
                data["plateInfo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedPlateIds)) {
            data["deletedPlateIds"] = [];
            for (let item of this.deletedPlateIds)
                data["deletedPlateIds"].push(item);
        }
        data["colCount"] = this.colCount;
        data["rowCount"] = this.rowCount;
        return data;
    }
}

export interface ISaveCanvasItemsDTO {
    layers?: LayerDTO[] | undefined;
    deletedLayers?: LayerDTO[] | undefined;
    plates?: SavePlateDTO[] | undefined;
    plateInfo?: SavePlateInfoDto[] | undefined;
    deletedPlateIds?: number[] | undefined;
    colCount: number;
    rowCount: number;
}

export class SavePlateDTO implements ISavePlateDTO {
    ingredients?: PlateIngredientDTO | undefined;
    rowPos!: number;
    colPos!: number;

    constructor(data?: ISavePlateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredients = _data["ingredients"] ? PlateIngredientDTO.fromJS(_data["ingredients"]) : undefined as any;
            this.rowPos = _data["rowPos"];
            this.colPos = _data["colPos"];
        }
    }

    static fromJS(data: any): SavePlateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SavePlateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredients"] = this.ingredients ? this.ingredients.toJSON() : undefined as any;
        data["rowPos"] = this.rowPos;
        data["colPos"] = this.colPos;
        return data;
    }
}

export interface ISavePlateDTO {
    ingredients?: PlateIngredientDTO | undefined;
    rowPos: number;
    colPos: number;
}

export class SavePlateInfoDto implements ISavePlateInfoDto {
    id!: number;
    dispensedDate?: Date | undefined;

    constructor(data?: ISavePlateInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dispensedDate = _data["dispensedDate"] ? new Date(_data["dispensedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SavePlateInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavePlateInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dispensedDate"] = this.dispensedDate ? this.dispensedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISavePlateInfoDto {
    id: number;
    dispensedDate?: Date | undefined;
}

export class SaveImagingScheduleDTO implements ISaveImagingScheduleDTO {
    selectedImagingScheduleId!: number;
    imagingScheduleEntries?: ExperimentImagingScheduleEntryDTO[] | undefined;
    isChoosedCustom!: boolean;

    constructor(data?: ISaveImagingScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedImagingScheduleId = _data["selectedImagingScheduleId"];
            if (Array.isArray(_data["imagingScheduleEntries"])) {
                this.imagingScheduleEntries = [] as any;
                for (let item of _data["imagingScheduleEntries"])
                    this.imagingScheduleEntries!.push(ExperimentImagingScheduleEntryDTO.fromJS(item));
            }
            this.isChoosedCustom = _data["isChoosedCustom"];
        }
    }

    static fromJS(data: any): SaveImagingScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImagingScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedImagingScheduleId"] = this.selectedImagingScheduleId;
        if (Array.isArray(this.imagingScheduleEntries)) {
            data["imagingScheduleEntries"] = [];
            for (let item of this.imagingScheduleEntries)
                data["imagingScheduleEntries"].push(item ? item.toJSON() : undefined as any);
        }
        data["isChoosedCustom"] = this.isChoosedCustom;
        return data;
    }
}

export interface ISaveImagingScheduleDTO {
    selectedImagingScheduleId: number;
    imagingScheduleEntries?: ExperimentImagingScheduleEntryDTO[] | undefined;
    isChoosedCustom: boolean;
}

export class ImportIngredientsDTO implements IImportIngredientsDTO {
    conflictIngredientsList?: IngredientConflictDto[] | undefined;
    nonConflictIngredientsList?: IngredientConflictDto[] | undefined;
    vendorsList?: VendorDTO[] | undefined;
    ingredients?: ExtendedIngredientDTO[] | undefined;

    constructor(data?: IImportIngredientsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conflictIngredientsList"])) {
                this.conflictIngredientsList = [] as any;
                for (let item of _data["conflictIngredientsList"])
                    this.conflictIngredientsList!.push(IngredientConflictDto.fromJS(item));
            }
            if (Array.isArray(_data["nonConflictIngredientsList"])) {
                this.nonConflictIngredientsList = [] as any;
                for (let item of _data["nonConflictIngredientsList"])
                    this.nonConflictIngredientsList!.push(IngredientConflictDto.fromJS(item));
            }
            if (Array.isArray(_data["vendorsList"])) {
                this.vendorsList = [] as any;
                for (let item of _data["vendorsList"])
                    this.vendorsList!.push(VendorDTO.fromJS(item));
            }
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(ExtendedIngredientDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportIngredientsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportIngredientsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conflictIngredientsList)) {
            data["conflictIngredientsList"] = [];
            for (let item of this.conflictIngredientsList)
                data["conflictIngredientsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.nonConflictIngredientsList)) {
            data["nonConflictIngredientsList"] = [];
            for (let item of this.nonConflictIngredientsList)
                data["nonConflictIngredientsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vendorsList)) {
            data["vendorsList"] = [];
            for (let item of this.vendorsList)
                data["vendorsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportIngredientsDTO {
    conflictIngredientsList?: IngredientConflictDto[] | undefined;
    nonConflictIngredientsList?: IngredientConflictDto[] | undefined;
    vendorsList?: VendorDTO[] | undefined;
    ingredients?: ExtendedIngredientDTO[] | undefined;
}

export class IngredientConflictDto implements IIngredientConflictDto {
    temporaryId!: number;
    xmlImportIngredient?: ExtendedIngredientDTO | undefined;
    matchingIngredients?: ExtendedIngredientDTO[] | undefined;
    resolvedIngredient?: ExtendedIngredientDTO | undefined;
    conflictType!: IngredientImportConflictType;
    initialErrorMessage?: string | undefined;
    errorMessage?: string | undefined;
    resolutionType!: ConflictResolutionType;
    hasErrors!: boolean;

    constructor(data?: IIngredientConflictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temporaryId = _data["temporaryId"];
            this.xmlImportIngredient = _data["xmlImportIngredient"] ? ExtendedIngredientDTO.fromJS(_data["xmlImportIngredient"]) : undefined as any;
            if (Array.isArray(_data["matchingIngredients"])) {
                this.matchingIngredients = [] as any;
                for (let item of _data["matchingIngredients"])
                    this.matchingIngredients!.push(ExtendedIngredientDTO.fromJS(item));
            }
            this.resolvedIngredient = _data["resolvedIngredient"] ? ExtendedIngredientDTO.fromJS(_data["resolvedIngredient"]) : undefined as any;
            this.conflictType = _data["conflictType"];
            this.initialErrorMessage = _data["initialErrorMessage"];
            this.errorMessage = _data["errorMessage"];
            this.resolutionType = _data["resolutionType"];
            this.hasErrors = _data["hasErrors"];
        }
    }

    static fromJS(data: any): IngredientConflictDto {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientConflictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temporaryId"] = this.temporaryId;
        data["xmlImportIngredient"] = this.xmlImportIngredient ? this.xmlImportIngredient.toJSON() : undefined as any;
        if (Array.isArray(this.matchingIngredients)) {
            data["matchingIngredients"] = [];
            for (let item of this.matchingIngredients)
                data["matchingIngredients"].push(item ? item.toJSON() : undefined as any);
        }
        data["resolvedIngredient"] = this.resolvedIngredient ? this.resolvedIngredient.toJSON() : undefined as any;
        data["conflictType"] = this.conflictType;
        data["initialErrorMessage"] = this.initialErrorMessage;
        data["errorMessage"] = this.errorMessage;
        data["resolutionType"] = this.resolutionType;
        data["hasErrors"] = this.hasErrors;
        return data;
    }
}

export interface IIngredientConflictDto {
    temporaryId: number;
    xmlImportIngredient?: ExtendedIngredientDTO | undefined;
    matchingIngredients?: ExtendedIngredientDTO[] | undefined;
    resolvedIngredient?: ExtendedIngredientDTO | undefined;
    conflictType: IngredientImportConflictType;
    initialErrorMessage?: string | undefined;
    errorMessage?: string | undefined;
    resolutionType: ConflictResolutionType;
    hasErrors: boolean;
}

export class ExtendedIngredientDTO extends IngredientDTO implements IExtendedIngredientDTO {
    casnumbers?: CasNumberDTO[] | undefined;
    aliases?: IngredientAliasDTO[] | undefined;
    types?: IngredientTypeDTO[] | undefined;
    ingredientIngredientType?: IngredientIngredientTypeDTO[] | undefined;
    ingredientStock?: IngredientStockDTO[] | undefined;
    bufferData?: XMLBufferDataDTO | undefined;
    conditions?: ConditionIngredientDTO[] | undefined;
    conditionIngredients?: ConditionIngredientStockDTO[] | undefined;

    constructor(data?: IExtendedIngredientDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["casnumbers"])) {
                this.casnumbers = [] as any;
                for (let item of _data["casnumbers"])
                    this.casnumbers!.push(CasNumberDTO.fromJS(item));
            }
            if (Array.isArray(_data["aliases"])) {
                this.aliases = [] as any;
                for (let item of _data["aliases"])
                    this.aliases!.push(IngredientAliasDTO.fromJS(item));
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(IngredientTypeDTO.fromJS(item));
            }
            if (Array.isArray(_data["ingredientIngredientType"])) {
                this.ingredientIngredientType = [] as any;
                for (let item of _data["ingredientIngredientType"])
                    this.ingredientIngredientType!.push(IngredientIngredientTypeDTO.fromJS(item));
            }
            if (Array.isArray(_data["ingredientStock"])) {
                this.ingredientStock = [] as any;
                for (let item of _data["ingredientStock"])
                    this.ingredientStock!.push(IngredientStockDTO.fromJS(item));
            }
            this.bufferData = _data["bufferData"] ? XMLBufferDataDTO.fromJS(_data["bufferData"]) : undefined as any;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(ConditionIngredientDTO.fromJS(item));
            }
            if (Array.isArray(_data["conditionIngredients"])) {
                this.conditionIngredients = [] as any;
                for (let item of _data["conditionIngredients"])
                    this.conditionIngredients!.push(ConditionIngredientStockDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ExtendedIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedIngredientDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.casnumbers)) {
            data["casnumbers"] = [];
            for (let item of this.casnumbers)
                data["casnumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aliases)) {
            data["aliases"] = [];
            for (let item of this.aliases)
                data["aliases"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredientIngredientType)) {
            data["ingredientIngredientType"] = [];
            for (let item of this.ingredientIngredientType)
                data["ingredientIngredientType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ingredientStock)) {
            data["ingredientStock"] = [];
            for (let item of this.ingredientStock)
                data["ingredientStock"].push(item ? item.toJSON() : undefined as any);
        }
        data["bufferData"] = this.bufferData ? this.bufferData.toJSON() : undefined as any;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.conditionIngredients)) {
            data["conditionIngredients"] = [];
            for (let item of this.conditionIngredients)
                data["conditionIngredients"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IExtendedIngredientDTO extends IIngredientDTO {
    casnumbers?: CasNumberDTO[] | undefined;
    aliases?: IngredientAliasDTO[] | undefined;
    types?: IngredientTypeDTO[] | undefined;
    ingredientIngredientType?: IngredientIngredientTypeDTO[] | undefined;
    ingredientStock?: IngredientStockDTO[] | undefined;
    bufferData?: XMLBufferDataDTO | undefined;
    conditions?: ConditionIngredientDTO[] | undefined;
    conditionIngredients?: ConditionIngredientStockDTO[] | undefined;
}

export class CasNumberDTO implements ICasNumberDTO {
    id!: number;
    number?: string | undefined;

    constructor(data?: ICasNumberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): CasNumberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CasNumberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        return data;
    }
}

export interface ICasNumberDTO {
    id: number;
    number?: string | undefined;
}

export class IngredientAliasDTO implements IIngredientAliasDTO {
    id!: number;
    ingredientId?: number | undefined;
    name?: string | undefined;

    constructor(data?: IIngredientAliasDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientId = _data["ingredientId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IngredientAliasDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientAliasDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientId"] = this.ingredientId;
        data["name"] = this.name;
        return data;
    }
}

export interface IIngredientAliasDTO {
    id: number;
    ingredientId?: number | undefined;
    name?: string | undefined;
}

export class XMLBufferDataDTO implements IXMLBufferDataDTO {
    titrationTable?: XMLTitrationTableDTO | undefined;
    pKa?: number | undefined;
    bufferCalculationTypeID?: number | undefined;

    constructor(data?: IXMLBufferDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titrationTable = _data["titrationTable"] ? XMLTitrationTableDTO.fromJS(_data["titrationTable"]) : undefined as any;
            this.pKa = _data["pKa"];
            this.bufferCalculationTypeID = _data["bufferCalculationTypeID"];
        }
    }

    static fromJS(data: any): XMLBufferDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XMLBufferDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titrationTable"] = this.titrationTable ? this.titrationTable.toJSON() : undefined as any;
        data["pKa"] = this.pKa;
        data["bufferCalculationTypeID"] = this.bufferCalculationTypeID;
        return data;
    }
}

export interface IXMLBufferDataDTO {
    titrationTable?: XMLTitrationTableDTO | undefined;
    pKa?: number | undefined;
    bufferCalculationTypeID?: number | undefined;
}

export class XMLTitrationTableDTO implements IXMLTitrationTableDTO {
    titrationPoints?: XMLTitrationPointDTO[] | undefined;

    constructor(data?: IXMLTitrationTableDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titrationPoints"])) {
                this.titrationPoints = [] as any;
                for (let item of _data["titrationPoints"])
                    this.titrationPoints!.push(XMLTitrationPointDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): XMLTitrationTableDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XMLTitrationTableDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titrationPoints)) {
            data["titrationPoints"] = [];
            for (let item of this.titrationPoints)
                data["titrationPoints"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IXMLTitrationTableDTO {
    titrationPoints?: XMLTitrationPointDTO[] | undefined;
}

export class XMLTitrationPointDTO implements IXMLTitrationPointDTO {
    pH!: number;
    acidToBaseRatio!: number;

    constructor(data?: IXMLTitrationPointDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pH = _data["pH"];
            this.acidToBaseRatio = _data["acidToBaseRatio"];
        }
    }

    static fromJS(data: any): XMLTitrationPointDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XMLTitrationPointDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pH"] = this.pH;
        data["acidToBaseRatio"] = this.acidToBaseRatio;
        return data;
    }
}

export interface IXMLTitrationPointDTO {
    pH: number;
    acidToBaseRatio: number;
}

export class ConditionIngredientStockDTO extends ProteinFormulationStandardIngredientsDTO implements IConditionIngredientStockDTO {
    conditionNumber!: number;
    conditionId!: number;

    constructor(data?: IConditionIngredientStockDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conditionNumber = _data["conditionNumber"];
            this.conditionId = _data["conditionId"];
        }
    }

    static override fromJS(data: any): ConditionIngredientStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionIngredientStockDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionNumber"] = this.conditionNumber;
        data["conditionId"] = this.conditionId;
        super.toJSON(data);
        return data;
    }
}

export interface IConditionIngredientStockDTO extends IProteinFormulationStandardIngredientsDTO {
    conditionNumber: number;
    conditionId: number;
}

export enum IngredientImportConflictType {
    ExactMatch = 0,
    PartialMatch = 1,
    NoMatch = 2,
}

export enum ConflictResolutionType {
    None = 0,
    UseNew = 1,
    UseSubstitute = 2,
}

export class ResponseWithValueDTOOfNullableLong extends ResponseDTO implements IResponseWithValueDTOOfNullableLong {
    value?: number | undefined;

    constructor(data?: IResponseWithValueDTOOfNullableLong) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfNullableLong {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfNullableLong();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfNullableLong extends IResponseDTO {
    value?: number | undefined;
}

export class SaveNonPersistedExpDTO implements ISaveNonPersistedExpDTO {
    experimentInfo?: ExperimentInfo | undefined;
    paretnTreeNodeId!: number;
    expDto?: ExperimentDTO | undefined;
    layers?: LayerDTO[] | undefined;
    isoScores?: ISOWellDropScoreDTO[] | undefined;
    plateTypeId!: number;
    save!: boolean;
    existingExperimentId?: number | undefined;

    constructor(data?: ISaveNonPersistedExpDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentInfo = _data["experimentInfo"] ? ExperimentInfo.fromJS(_data["experimentInfo"]) : undefined as any;
            this.paretnTreeNodeId = _data["paretnTreeNodeId"];
            this.expDto = _data["expDto"] ? ExperimentDTO.fromJS(_data["expDto"]) : undefined as any;
            if (Array.isArray(_data["layers"])) {
                this.layers = [] as any;
                for (let item of _data["layers"])
                    this.layers!.push(LayerDTO.fromJS(item));
            }
            if (Array.isArray(_data["isoScores"])) {
                this.isoScores = [] as any;
                for (let item of _data["isoScores"])
                    this.isoScores!.push(ISOWellDropScoreDTO.fromJS(item));
            }
            this.plateTypeId = _data["plateTypeId"];
            this.save = _data["save"];
            this.existingExperimentId = _data["existingExperimentId"];
        }
    }

    static fromJS(data: any): SaveNonPersistedExpDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNonPersistedExpDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentInfo"] = this.experimentInfo ? this.experimentInfo.toJSON() : undefined as any;
        data["paretnTreeNodeId"] = this.paretnTreeNodeId;
        data["expDto"] = this.expDto ? this.expDto.toJSON() : undefined as any;
        if (Array.isArray(this.layers)) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isoScores)) {
            data["isoScores"] = [];
            for (let item of this.isoScores)
                data["isoScores"].push(item ? item.toJSON() : undefined as any);
        }
        data["plateTypeId"] = this.plateTypeId;
        data["save"] = this.save;
        data["existingExperimentId"] = this.existingExperimentId;
        return data;
    }
}

export interface ISaveNonPersistedExpDTO {
    experimentInfo?: ExperimentInfo | undefined;
    paretnTreeNodeId: number;
    expDto?: ExperimentDTO | undefined;
    layers?: LayerDTO[] | undefined;
    isoScores?: ISOWellDropScoreDTO[] | undefined;
    plateTypeId: number;
    save: boolean;
    existingExperimentId?: number | undefined;
}

export class CreateDefaultExpDTO implements ICreateDefaultExpDTO {
    paretnTreeNodeId!: number;
    plateTypeId!: number;
    plateRows!: number;
    plateCols!: number;

    constructor(data?: ICreateDefaultExpDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paretnTreeNodeId = _data["paretnTreeNodeId"];
            this.plateTypeId = _data["plateTypeId"];
            this.plateRows = _data["plateRows"];
            this.plateCols = _data["plateCols"];
        }
    }

    static fromJS(data: any): CreateDefaultExpDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDefaultExpDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paretnTreeNodeId"] = this.paretnTreeNodeId;
        data["plateTypeId"] = this.plateTypeId;
        data["plateRows"] = this.plateRows;
        data["plateCols"] = this.plateCols;
        return data;
    }
}

export interface ICreateDefaultExpDTO {
    paretnTreeNodeId: number;
    plateTypeId: number;
    plateRows: number;
    plateCols: number;
}

export class XMLScreenDataDTO implements IXMLScreenDataDTO {
    conditions?: XMLScreenConditionDTO[] | undefined;
    ingredients?: { [key: string]: XMLIngredientDTO; } | undefined;

    constructor(data?: IXMLScreenDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(XMLScreenConditionDTO.fromJS(item));
            }
            if (_data["ingredients"]) {
                this.ingredients = {} as any;
                for (let key in _data["ingredients"]) {
                    if (_data["ingredients"].hasOwnProperty(key))
                        (this.ingredients as any)![key] = _data["ingredients"][key] ? XMLIngredientDTO.fromJS(_data["ingredients"][key]) : new XMLIngredientDTO();
                }
            }
        }
    }

    static fromJS(data: any): XMLScreenDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XMLScreenDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.ingredients) {
            data["ingredients"] = {};
            for (let key in this.ingredients) {
                if (this.ingredients.hasOwnProperty(key))
                    (data["ingredients"] as any)[key] = this.ingredients[key] ? this.ingredients[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IXMLScreenDataDTO {
    conditions?: XMLScreenConditionDTO[] | undefined;
    ingredients?: { [key: string]: XMLIngredientDTO; } | undefined;
}

export class XMLScreenConditionDTO implements IXMLScreenConditionDTO {
    ingredients?: XMLScreenConditionIngredientDTO[] | undefined;
    metadata?: string | undefined;

    constructor(data?: IXMLScreenConditionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(XMLScreenConditionIngredientDTO.fromJS(item));
            }
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): XMLScreenConditionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XMLScreenConditionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadata"] = this.metadata;
        return data;
    }
}

export interface IXMLScreenConditionDTO {
    ingredients?: XMLScreenConditionIngredientDTO[] | undefined;
    metadata?: string | undefined;
}

export class XMLScreenConditionIngredientDTO implements IXMLScreenConditionIngredientDTO {
    stockLocalID!: number;
    highPHStockLocalID?: number | undefined;
    concentration!: number;
    type?: string | undefined;
    pH?: number | undefined;
    stock?: IngredientStockDTO | undefined;
    highPhStock?: IngredientStockDTO | undefined;

    constructor(data?: IXMLScreenConditionIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockLocalID = _data["stockLocalID"];
            this.highPHStockLocalID = _data["highPHStockLocalID"];
            this.concentration = _data["concentration"];
            this.type = _data["type"];
            this.pH = _data["pH"];
            this.stock = _data["stock"] ? IngredientStockDTO.fromJS(_data["stock"]) : undefined as any;
            this.highPhStock = _data["highPhStock"] ? IngredientStockDTO.fromJS(_data["highPhStock"]) : undefined as any;
        }
    }

    static fromJS(data: any): XMLScreenConditionIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XMLScreenConditionIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockLocalID"] = this.stockLocalID;
        data["highPHStockLocalID"] = this.highPHStockLocalID;
        data["concentration"] = this.concentration;
        data["type"] = this.type;
        data["pH"] = this.pH;
        data["stock"] = this.stock ? this.stock.toJSON() : undefined as any;
        data["highPhStock"] = this.highPhStock ? this.highPhStock.toJSON() : undefined as any;
        return data;
    }
}

export interface IXMLScreenConditionIngredientDTO {
    stockLocalID: number;
    highPHStockLocalID?: number | undefined;
    concentration: number;
    type?: string | undefined;
    pH?: number | undefined;
    stock?: IngredientStockDTO | undefined;
    highPhStock?: IngredientStockDTO | undefined;
}

export class XMLIngredientDTO implements IXMLIngredientDTO {
    id!: number;
    bufferCalculationTypeID?: number | undefined;
    pKa?: number | undefined;
    longName?: string | undefined;
    shortName?: string | undefined;
    stocks?: XMLIngredientStockDTO[] | undefined;
    aliases?: string[] | undefined;
    casNumbers?: string[] | undefined;
    types?: string[] | undefined;
    bufferData?: XMLBufferDataDTO | undefined;
    bufferDataPoints?: BufferDataPointDTO[] | undefined;

    constructor(data?: IXMLIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bufferCalculationTypeID = _data["bufferCalculationTypeID"];
            this.pKa = _data["pKa"];
            this.longName = _data["longName"];
            this.shortName = _data["shortName"];
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks!.push(XMLIngredientStockDTO.fromJS(item));
            }
            if (Array.isArray(_data["aliases"])) {
                this.aliases = [] as any;
                for (let item of _data["aliases"])
                    this.aliases!.push(item);
            }
            if (Array.isArray(_data["casNumbers"])) {
                this.casNumbers = [] as any;
                for (let item of _data["casNumbers"])
                    this.casNumbers!.push(item);
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.bufferData = _data["bufferData"] ? XMLBufferDataDTO.fromJS(_data["bufferData"]) : undefined as any;
            if (Array.isArray(_data["bufferDataPoints"])) {
                this.bufferDataPoints = [] as any;
                for (let item of _data["bufferDataPoints"])
                    this.bufferDataPoints!.push(BufferDataPointDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): XMLIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XMLIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bufferCalculationTypeID"] = this.bufferCalculationTypeID;
        data["pKa"] = this.pKa;
        data["longName"] = this.longName;
        data["shortName"] = this.shortName;
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aliases)) {
            data["aliases"] = [];
            for (let item of this.aliases)
                data["aliases"].push(item);
        }
        if (Array.isArray(this.casNumbers)) {
            data["casNumbers"] = [];
            for (let item of this.casNumbers)
                data["casNumbers"].push(item);
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["bufferData"] = this.bufferData ? this.bufferData.toJSON() : undefined as any;
        if (Array.isArray(this.bufferDataPoints)) {
            data["bufferDataPoints"] = [];
            for (let item of this.bufferDataPoints)
                data["bufferDataPoints"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IXMLIngredientDTO {
    id: number;
    bufferCalculationTypeID?: number | undefined;
    pKa?: number | undefined;
    longName?: string | undefined;
    shortName?: string | undefined;
    stocks?: XMLIngredientStockDTO[] | undefined;
    aliases?: string[] | undefined;
    casNumbers?: string[] | undefined;
    types?: string[] | undefined;
    bufferData?: XMLBufferDataDTO | undefined;
    bufferDataPoints?: BufferDataPointDTO[] | undefined;
}

export class XMLIngredientStockDTO implements IXMLIngredientStockDTO {
    id!: number;
    stockConcentration!: number;
    lowConcentration!: number;
    highConcentration!: number;
    concentrationUnits?: string | undefined;
    isBuffer!: boolean;
    vendorPartNumber?: string | undefined;
    comments?: string | undefined;
    vendorName?: string | undefined;
    localID!: number;
    ingredientID!: number;
    stockPh?: number | undefined;

    constructor(data?: IXMLIngredientStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stockConcentration = _data["stockConcentration"];
            this.lowConcentration = _data["lowConcentration"];
            this.highConcentration = _data["highConcentration"];
            this.concentrationUnits = _data["concentrationUnits"];
            this.isBuffer = _data["isBuffer"];
            this.vendorPartNumber = _data["vendorPartNumber"];
            this.comments = _data["comments"];
            this.vendorName = _data["vendorName"];
            this.localID = _data["localID"];
            this.ingredientID = _data["ingredientID"];
            this.stockPh = _data["stockPh"];
        }
    }

    static fromJS(data: any): XMLIngredientStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XMLIngredientStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockConcentration"] = this.stockConcentration;
        data["lowConcentration"] = this.lowConcentration;
        data["highConcentration"] = this.highConcentration;
        data["concentrationUnits"] = this.concentrationUnits;
        data["isBuffer"] = this.isBuffer;
        data["vendorPartNumber"] = this.vendorPartNumber;
        data["comments"] = this.comments;
        data["vendorName"] = this.vendorName;
        data["localID"] = this.localID;
        data["ingredientID"] = this.ingredientID;
        data["stockPh"] = this.stockPh;
        return data;
    }
}

export interface IXMLIngredientStockDTO {
    id: number;
    stockConcentration: number;
    lowConcentration: number;
    highConcentration: number;
    concentrationUnits?: string | undefined;
    isBuffer: boolean;
    vendorPartNumber?: string | undefined;
    comments?: string | undefined;
    vendorName?: string | undefined;
    localID: number;
    ingredientID: number;
    stockPh?: number | undefined;
}

export class FileResultDto implements IFileResultDto {
    success!: boolean;
    message?: string | undefined;
    fileData?: string | undefined;

    constructor(data?: IFileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.fileData = _data["fileData"];
        }
    }

    static fromJS(data: any): FileResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["fileData"] = this.fileData;
        return data;
    }
}

export interface IFileResultDto {
    success: boolean;
    message?: string | undefined;
    fileData?: string | undefined;
}

export class SetupTemperatureDTO implements ISetupTemperatureDTO {
    id!: number;
    temperature?: string | undefined;
    ischilled!: boolean;
    entityState!: EntityStateDTO;

    constructor(data?: ISetupTemperatureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.temperature = _data["temperature"];
            this.ischilled = _data["ischilled"];
            this.entityState = _data["entityState"];
        }
    }

    static fromJS(data: any): SetupTemperatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetupTemperatureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["temperature"] = this.temperature;
        data["ischilled"] = this.ischilled;
        data["entityState"] = this.entityState;
        return data;
    }
}

export interface ISetupTemperatureDTO {
    id: number;
    temperature?: string | undefined;
    ischilled: boolean;
    entityState: EntityStateDTO;
}

export enum EntityStateDTO {
    UnChanged = 1,
    Modified = 2,
    New = 3,
    Deleted = 4,
}

export enum TemperatureType {
    Setup = 0,
    Incubation = 1,
}

export class IncubationTemperatureDTO implements IIncubationTemperatureDTO {
    id!: number;
    temperature?: string | undefined;
    entityState!: EntityStateDTO;

    constructor(data?: IIncubationTemperatureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.temperature = _data["temperature"];
            this.entityState = _data["entityState"];
        }
    }

    static fromJS(data: any): IncubationTemperatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncubationTemperatureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["temperature"] = this.temperature;
        data["entityState"] = this.entityState;
        return data;
    }
}

export interface IIncubationTemperatureDTO {
    id: number;
    temperature?: string | undefined;
    entityState: EntityStateDTO;
}

export class XmlScreenImportResultDto implements IXmlScreenImportResultDto {
    screenConditions?: ConditionDTO[] | undefined;
    importedIngredients?: ImportIngredientsDTO | undefined;
    hasUnusedIngredientStocks!: boolean;
    shouldUseUnusedIngredientStocks?: boolean | undefined;

    constructor(data?: IXmlScreenImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["screenConditions"])) {
                this.screenConditions = [] as any;
                for (let item of _data["screenConditions"])
                    this.screenConditions!.push(ConditionDTO.fromJS(item));
            }
            this.importedIngredients = _data["importedIngredients"] ? ImportIngredientsDTO.fromJS(_data["importedIngredients"]) : undefined as any;
            this.hasUnusedIngredientStocks = _data["hasUnusedIngredientStocks"];
            this.shouldUseUnusedIngredientStocks = _data["shouldUseUnusedIngredientStocks"];
        }
    }

    static fromJS(data: any): XmlScreenImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new XmlScreenImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.screenConditions)) {
            data["screenConditions"] = [];
            for (let item of this.screenConditions)
                data["screenConditions"].push(item ? item.toJSON() : undefined as any);
        }
        data["importedIngredients"] = this.importedIngredients ? this.importedIngredients.toJSON() : undefined as any;
        data["hasUnusedIngredientStocks"] = this.hasUnusedIngredientStocks;
        data["shouldUseUnusedIngredientStocks"] = this.shouldUseUnusedIngredientStocks;
        return data;
    }
}

export interface IXmlScreenImportResultDto {
    screenConditions?: ConditionDTO[] | undefined;
    importedIngredients?: ImportIngredientsDTO | undefined;
    hasUnusedIngredientStocks: boolean;
    shouldUseUnusedIngredientStocks?: boolean | undefined;
}

export class CapturePropertyDTO implements ICapturePropertyDTO {
    results?: CapturePropertyResult[] | undefined;
    category?: string | undefined;

    constructor(data?: ICapturePropertyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CapturePropertyResult.fromJS(item));
            }
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): CapturePropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CapturePropertyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["category"] = this.category;
        return data;
    }
}

export interface ICapturePropertyDTO {
    results?: CapturePropertyResult[] | undefined;
    category?: string | undefined;
}

export class CapturePropertyResult implements ICapturePropertyResult {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: ICapturePropertyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CapturePropertyResult {
        data = typeof data === 'object' ? data : {};
        let result = new CapturePropertyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ICapturePropertyResult {
    name?: string | undefined;
    value?: string | undefined;
}

export class PlateAtImagerResponseDTO implements IPlateAtImagerResponseDTO {
    plateId!: number;
    barcode?: string | undefined;
    isPlateAtImager!: boolean;

    constructor(data?: IPlateAtImagerResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.barcode = _data["barcode"];
            this.isPlateAtImager = _data["isPlateAtImager"];
        }
    }

    static fromJS(data: any): PlateAtImagerResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateAtImagerResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["barcode"] = this.barcode;
        data["isPlateAtImager"] = this.isPlateAtImager;
        return data;
    }
}

export interface IPlateAtImagerResponseDTO {
    plateId: number;
    barcode?: string | undefined;
    isPlateAtImager: boolean;
}

export class AllPlatesScoreDTO implements IAllPlatesScoreDTO {
    allScores?: { [key: string]: ScoresOfWellDropsDTO[][]; } | undefined;

    constructor(data?: IAllPlatesScoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["allScores"]) {
                this.allScores = {} as any;
                for (let key in _data["allScores"]) {
                    if (_data["allScores"].hasOwnProperty(key))
                        (this.allScores as any)![key] = _data["allScores"][key] !== undefined ? _data["allScores"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): AllPlatesScoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AllPlatesScoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allScores) {
            data["allScores"] = {};
            for (let key in this.allScores) {
                if (this.allScores.hasOwnProperty(key))
                    (data["allScores"] as any)[key] = (this.allScores as any)[key];
            }
        }
        return data;
    }
}

export interface IAllPlatesScoreDTO {
    allScores?: { [key: string]: ScoresOfWellDropsDTO[][]; } | undefined;
}

export class ScreenRepairUpdateExpInfo implements IScreenRepairUpdateExpInfo {
    invalidExperimentInfo?: { [key: string]: string; } | undefined;

    constructor(data?: IScreenRepairUpdateExpInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["invalidExperimentInfo"]) {
                this.invalidExperimentInfo = {} as any;
                for (let key in _data["invalidExperimentInfo"]) {
                    if (_data["invalidExperimentInfo"].hasOwnProperty(key))
                        (this.invalidExperimentInfo as any)![key] = _data["invalidExperimentInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): ScreenRepairUpdateExpInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenRepairUpdateExpInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.invalidExperimentInfo) {
            data["invalidExperimentInfo"] = {};
            for (let key in this.invalidExperimentInfo) {
                if (this.invalidExperimentInfo.hasOwnProperty(key))
                    (data["invalidExperimentInfo"] as any)[key] = (this.invalidExperimentInfo as any)[key];
            }
        }
        return data;
    }
}

export interface IScreenRepairUpdateExpInfo {
    invalidExperimentInfo?: { [key: string]: string; } | undefined;
}

export class BulkSaveImagingScheduleDTO implements IBulkSaveImagingScheduleDTO {
    experimentId!: number;
    imagingSchedule?: SaveImagingScheduleDTO | undefined;

    constructor(data?: IBulkSaveImagingScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.imagingSchedule = _data["imagingSchedule"] ? SaveImagingScheduleDTO.fromJS(_data["imagingSchedule"]) : undefined as any;
        }
    }

    static fromJS(data: any): BulkSaveImagingScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BulkSaveImagingScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["imagingSchedule"] = this.imagingSchedule ? this.imagingSchedule.toJSON() : undefined as any;
        return data;
    }
}

export interface IBulkSaveImagingScheduleDTO {
    experimentId: number;
    imagingSchedule?: SaveImagingScheduleDTO | undefined;
}

export class FragmentScreenViewItemsDTO implements IFragmentScreenViewItemsDTO {
    fragmentScreenView?: FragmentScreenViewDTO[] | undefined;
    fragmentNodeName?: string | undefined;
    fragmentNodeId!: number;
    parentId!: number;
    fragmentScreenInUseExperiments?: string[] | undefined;
    accessRightName?: string | undefined;

    constructor(data?: IFragmentScreenViewItemsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fragmentScreenView"])) {
                this.fragmentScreenView = [] as any;
                for (let item of _data["fragmentScreenView"])
                    this.fragmentScreenView!.push(FragmentScreenViewDTO.fromJS(item));
            }
            this.fragmentNodeName = _data["fragmentNodeName"];
            this.fragmentNodeId = _data["fragmentNodeId"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["fragmentScreenInUseExperiments"])) {
                this.fragmentScreenInUseExperiments = [] as any;
                for (let item of _data["fragmentScreenInUseExperiments"])
                    this.fragmentScreenInUseExperiments!.push(item);
            }
            this.accessRightName = _data["accessRightName"];
        }
    }

    static fromJS(data: any): FragmentScreenViewItemsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentScreenViewItemsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fragmentScreenView)) {
            data["fragmentScreenView"] = [];
            for (let item of this.fragmentScreenView)
                data["fragmentScreenView"].push(item ? item.toJSON() : undefined as any);
        }
        data["fragmentNodeName"] = this.fragmentNodeName;
        data["fragmentNodeId"] = this.fragmentNodeId;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.fragmentScreenInUseExperiments)) {
            data["fragmentScreenInUseExperiments"] = [];
            for (let item of this.fragmentScreenInUseExperiments)
                data["fragmentScreenInUseExperiments"].push(item);
        }
        data["accessRightName"] = this.accessRightName;
        return data;
    }
}

export interface IFragmentScreenViewItemsDTO {
    fragmentScreenView?: FragmentScreenViewDTO[] | undefined;
    fragmentNodeName?: string | undefined;
    fragmentNodeId: number;
    parentId: number;
    fragmentScreenInUseExperiments?: string[] | undefined;
    accessRightName?: string | undefined;
}

export class FragmentScreenViewDTO implements IFragmentScreenViewDTO {
    conditionNumber!: number;
    fragmentID!: number;
    fragmentFragmentScreenId!: number;
    fragmentName?: string | undefined;
    size!: number;
    workingConcentration!: number;
    notes?: string | undefined;
    isDirty!: boolean;
    fragmentScreenId!: number;

    constructor(data?: IFragmentScreenViewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionNumber = _data["conditionNumber"];
            this.fragmentID = _data["fragmentID"];
            this.fragmentFragmentScreenId = _data["fragmentFragmentScreenId"];
            this.fragmentName = _data["fragmentName"];
            this.size = _data["size"];
            this.workingConcentration = _data["workingConcentration"];
            this.notes = _data["notes"];
            this.isDirty = _data["isDirty"];
            this.fragmentScreenId = _data["fragmentScreenId"];
        }
    }

    static fromJS(data: any): FragmentScreenViewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentScreenViewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionNumber"] = this.conditionNumber;
        data["fragmentID"] = this.fragmentID;
        data["fragmentFragmentScreenId"] = this.fragmentFragmentScreenId;
        data["fragmentName"] = this.fragmentName;
        data["size"] = this.size;
        data["workingConcentration"] = this.workingConcentration;
        data["notes"] = this.notes;
        data["isDirty"] = this.isDirty;
        data["fragmentScreenId"] = this.fragmentScreenId;
        return data;
    }
}

export interface IFragmentScreenViewDTO {
    conditionNumber: number;
    fragmentID: number;
    fragmentFragmentScreenId: number;
    fragmentName?: string | undefined;
    size: number;
    workingConcentration: number;
    notes?: string | undefined;
    isDirty: boolean;
    fragmentScreenId: number;
}

export class FragmentScreenDTO implements IFragmentScreenDTO {
    id!: number;
    treeNodeID!: number;
    parentId!: number;

    constructor(data?: IFragmentScreenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeID = _data["treeNodeID"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FragmentScreenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentScreenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeID"] = this.treeNodeID;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFragmentScreenDTO {
    id: number;
    treeNodeID: number;
    parentId: number;
}

export class SaveFragmentScreenViewResultDTO implements ISaveFragmentScreenViewResultDTO {
    tasksList?: FragmentScreenViewDTO[] | undefined;
    fragmentResponseDTO?: FragmentResponseDTO | undefined;

    constructor(data?: ISaveFragmentScreenViewResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tasksList"])) {
                this.tasksList = [] as any;
                for (let item of _data["tasksList"])
                    this.tasksList!.push(FragmentScreenViewDTO.fromJS(item));
            }
            this.fragmentResponseDTO = _data["fragmentResponseDTO"] ? FragmentResponseDTO.fromJS(_data["fragmentResponseDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveFragmentScreenViewResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFragmentScreenViewResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasksList)) {
            data["tasksList"] = [];
            for (let item of this.tasksList)
                data["tasksList"].push(item ? item.toJSON() : undefined as any);
        }
        data["fragmentResponseDTO"] = this.fragmentResponseDTO ? this.fragmentResponseDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveFragmentScreenViewResultDTO {
    tasksList?: FragmentScreenViewDTO[] | undefined;
    fragmentResponseDTO?: FragmentResponseDTO | undefined;
}

export class FragmentResponseDTO implements IFragmentResponseDTO {
    isNameAlreadyExists!: boolean;
    isFragmentScreenInUse!: boolean;

    constructor(data?: IFragmentResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isNameAlreadyExists = _data["isNameAlreadyExists"];
            this.isFragmentScreenInUse = _data["isFragmentScreenInUse"];
        }
    }

    static fromJS(data: any): FragmentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNameAlreadyExists"] = this.isNameAlreadyExists;
        data["isFragmentScreenInUse"] = this.isFragmentScreenInUse;
        return data;
    }
}

export interface IFragmentResponseDTO {
    isNameAlreadyExists: boolean;
    isFragmentScreenInUse: boolean;
}

export class SaveFragmentScreenViewDTO implements ISaveFragmentScreenViewDTO {
    tasksList?: FragmentScreenViewDTO[] | undefined;
    deletedActionsIds?: number[] | undefined;
    fragmentNodeName?: string | undefined;
    fragmentNodeId!: number;
    isNameDirty!: boolean;
    parentNodeId!: number;

    constructor(data?: ISaveFragmentScreenViewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tasksList"])) {
                this.tasksList = [] as any;
                for (let item of _data["tasksList"])
                    this.tasksList!.push(FragmentScreenViewDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedActionsIds"])) {
                this.deletedActionsIds = [] as any;
                for (let item of _data["deletedActionsIds"])
                    this.deletedActionsIds!.push(item);
            }
            this.fragmentNodeName = _data["fragmentNodeName"];
            this.fragmentNodeId = _data["fragmentNodeId"];
            this.isNameDirty = _data["isNameDirty"];
            this.parentNodeId = _data["parentNodeId"];
        }
    }

    static fromJS(data: any): SaveFragmentScreenViewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFragmentScreenViewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasksList)) {
            data["tasksList"] = [];
            for (let item of this.tasksList)
                data["tasksList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedActionsIds)) {
            data["deletedActionsIds"] = [];
            for (let item of this.deletedActionsIds)
                data["deletedActionsIds"].push(item);
        }
        data["fragmentNodeName"] = this.fragmentNodeName;
        data["fragmentNodeId"] = this.fragmentNodeId;
        data["isNameDirty"] = this.isNameDirty;
        data["parentNodeId"] = this.parentNodeId;
        return data;
    }
}

export interface ISaveFragmentScreenViewDTO {
    tasksList?: FragmentScreenViewDTO[] | undefined;
    deletedActionsIds?: number[] | undefined;
    fragmentNodeName?: string | undefined;
    fragmentNodeId: number;
    isNameDirty: boolean;
    parentNodeId: number;
}

export class FragmentScreenTreeNodeInfoDTO implements IFragmentScreenTreeNodeInfoDTO {
    totalConditions!: number;
    userName?: string | undefined;
    dateCreated?: string | undefined;

    constructor(data?: IFragmentScreenTreeNodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalConditions = _data["totalConditions"];
            this.userName = _data["userName"];
            this.dateCreated = _data["dateCreated"];
        }
    }

    static fromJS(data: any): FragmentScreenTreeNodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentScreenTreeNodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalConditions"] = this.totalConditions;
        data["userName"] = this.userName;
        data["dateCreated"] = this.dateCreated;
        return data;
    }
}

export interface IFragmentScreenTreeNodeInfoDTO {
    totalConditions: number;
    userName?: string | undefined;
    dateCreated?: string | undefined;
}

export class FragmentFragmentScreenDTO implements IFragmentFragmentScreenDTO {
    fragmentId!: number;
    fragmentScreenId!: number;

    constructor(data?: IFragmentFragmentScreenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fragmentId = _data["fragmentId"];
            this.fragmentScreenId = _data["fragmentScreenId"];
        }
    }

    static fromJS(data: any): FragmentFragmentScreenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentFragmentScreenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fragmentId"] = this.fragmentId;
        data["fragmentScreenId"] = this.fragmentScreenId;
        return data;
    }
}

export interface IFragmentFragmentScreenDTO {
    fragmentId: number;
    fragmentScreenId: number;
}

export class GeneralSetupDTO implements IGeneralSetupDTO {
    upsertScoreGroups?: ScoresGroupsDTO[] | undefined;
    deletedScoreGroups?: ScoresGroupsDTO[] | undefined;
    upsertScores?: ScoreDefinitionDTO[] | undefined;
    deletedScores?: ScoreDefinitionDTO[] | undefined;
    upsertSetupTemperature?: SetupTemperatureDTO[] | undefined;
    deletedSetupTemperature?: SetupTemperatureDTO[] | undefined;
    upsertIncubationTemperature?: IncubationTemperatureDTO[] | undefined;
    deletedIncubationTemperature?: IncubationTemperatureDTO[] | undefined;
    deletedImageStores?: ImageStoreDTO[] | undefined;
    upsertImageStores?: ImageStoreDTO[] | undefined;
    sendStatisticsOptionStatus!: boolean;

    constructor(data?: IGeneralSetupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["upsertScoreGroups"])) {
                this.upsertScoreGroups = [] as any;
                for (let item of _data["upsertScoreGroups"])
                    this.upsertScoreGroups!.push(ScoresGroupsDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedScoreGroups"])) {
                this.deletedScoreGroups = [] as any;
                for (let item of _data["deletedScoreGroups"])
                    this.deletedScoreGroups!.push(ScoresGroupsDTO.fromJS(item));
            }
            if (Array.isArray(_data["upsertScores"])) {
                this.upsertScores = [] as any;
                for (let item of _data["upsertScores"])
                    this.upsertScores!.push(ScoreDefinitionDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedScores"])) {
                this.deletedScores = [] as any;
                for (let item of _data["deletedScores"])
                    this.deletedScores!.push(ScoreDefinitionDTO.fromJS(item));
            }
            if (Array.isArray(_data["upsertSetupTemperature"])) {
                this.upsertSetupTemperature = [] as any;
                for (let item of _data["upsertSetupTemperature"])
                    this.upsertSetupTemperature!.push(SetupTemperatureDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedSetupTemperature"])) {
                this.deletedSetupTemperature = [] as any;
                for (let item of _data["deletedSetupTemperature"])
                    this.deletedSetupTemperature!.push(SetupTemperatureDTO.fromJS(item));
            }
            if (Array.isArray(_data["upsertIncubationTemperature"])) {
                this.upsertIncubationTemperature = [] as any;
                for (let item of _data["upsertIncubationTemperature"])
                    this.upsertIncubationTemperature!.push(IncubationTemperatureDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedIncubationTemperature"])) {
                this.deletedIncubationTemperature = [] as any;
                for (let item of _data["deletedIncubationTemperature"])
                    this.deletedIncubationTemperature!.push(IncubationTemperatureDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedImageStores"])) {
                this.deletedImageStores = [] as any;
                for (let item of _data["deletedImageStores"])
                    this.deletedImageStores!.push(ImageStoreDTO.fromJS(item));
            }
            if (Array.isArray(_data["upsertImageStores"])) {
                this.upsertImageStores = [] as any;
                for (let item of _data["upsertImageStores"])
                    this.upsertImageStores!.push(ImageStoreDTO.fromJS(item));
            }
            this.sendStatisticsOptionStatus = _data["sendStatisticsOptionStatus"];
        }
    }

    static fromJS(data: any): GeneralSetupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSetupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.upsertScoreGroups)) {
            data["upsertScoreGroups"] = [];
            for (let item of this.upsertScoreGroups)
                data["upsertScoreGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedScoreGroups)) {
            data["deletedScoreGroups"] = [];
            for (let item of this.deletedScoreGroups)
                data["deletedScoreGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.upsertScores)) {
            data["upsertScores"] = [];
            for (let item of this.upsertScores)
                data["upsertScores"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedScores)) {
            data["deletedScores"] = [];
            for (let item of this.deletedScores)
                data["deletedScores"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.upsertSetupTemperature)) {
            data["upsertSetupTemperature"] = [];
            for (let item of this.upsertSetupTemperature)
                data["upsertSetupTemperature"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedSetupTemperature)) {
            data["deletedSetupTemperature"] = [];
            for (let item of this.deletedSetupTemperature)
                data["deletedSetupTemperature"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.upsertIncubationTemperature)) {
            data["upsertIncubationTemperature"] = [];
            for (let item of this.upsertIncubationTemperature)
                data["upsertIncubationTemperature"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedIncubationTemperature)) {
            data["deletedIncubationTemperature"] = [];
            for (let item of this.deletedIncubationTemperature)
                data["deletedIncubationTemperature"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedImageStores)) {
            data["deletedImageStores"] = [];
            for (let item of this.deletedImageStores)
                data["deletedImageStores"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.upsertImageStores)) {
            data["upsertImageStores"] = [];
            for (let item of this.upsertImageStores)
                data["upsertImageStores"].push(item ? item.toJSON() : undefined as any);
        }
        data["sendStatisticsOptionStatus"] = this.sendStatisticsOptionStatus;
        return data;
    }
}

export interface IGeneralSetupDTO {
    upsertScoreGroups?: ScoresGroupsDTO[] | undefined;
    deletedScoreGroups?: ScoresGroupsDTO[] | undefined;
    upsertScores?: ScoreDefinitionDTO[] | undefined;
    deletedScores?: ScoreDefinitionDTO[] | undefined;
    upsertSetupTemperature?: SetupTemperatureDTO[] | undefined;
    deletedSetupTemperature?: SetupTemperatureDTO[] | undefined;
    upsertIncubationTemperature?: IncubationTemperatureDTO[] | undefined;
    deletedIncubationTemperature?: IncubationTemperatureDTO[] | undefined;
    deletedImageStores?: ImageStoreDTO[] | undefined;
    upsertImageStores?: ImageStoreDTO[] | undefined;
    sendStatisticsOptionStatus: boolean;
}

export class ScoresGroupsDTO implements IScoresGroupsDTO {
    isAutoScore!: boolean;
    scoreGroupsId!: number;
    name?: string | undefined;
    isInherit?: boolean | undefined;
    orderNumber!: number;
    hit!: boolean;
    unit?: string | undefined;
    scoreGroupType?: number | undefined;
    entityState!: EntityStateDTO;

    constructor(data?: IScoresGroupsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAutoScore = _data["isAutoScore"];
            this.scoreGroupsId = _data["scoreGroupsId"];
            this.name = _data["name"];
            this.isInherit = _data["isInherit"];
            this.orderNumber = _data["orderNumber"];
            this.hit = _data["hit"];
            this.unit = _data["unit"];
            this.scoreGroupType = _data["scoreGroupType"];
            this.entityState = _data["entityState"];
        }
    }

    static fromJS(data: any): ScoresGroupsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScoresGroupsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAutoScore"] = this.isAutoScore;
        data["scoreGroupsId"] = this.scoreGroupsId;
        data["name"] = this.name;
        data["isInherit"] = this.isInherit;
        data["orderNumber"] = this.orderNumber;
        data["hit"] = this.hit;
        data["unit"] = this.unit;
        data["scoreGroupType"] = this.scoreGroupType;
        data["entityState"] = this.entityState;
        return data;
    }
}

export interface IScoresGroupsDTO {
    isAutoScore: boolean;
    scoreGroupsId: number;
    name?: string | undefined;
    isInherit?: boolean | undefined;
    orderNumber: number;
    hit: boolean;
    unit?: string | undefined;
    scoreGroupType?: number | undefined;
    entityState: EntityStateDTO;
}

export class ScoreDefinitionDTO implements IScoreDefinitionDTO {
    value!: number;
    wellDropScoreId!: number;
    hotKey?: string | undefined;
    color!: string;
    wellDropScoreGroupId!: number;
    scoreName?: string | undefined;
    scoreGroupName?: string | undefined;
    orderNumber!: number;
    isAutoScore!: boolean;
    isoValue?: number | undefined;
    autoScoreType?: number | undefined;
    hit!: boolean;
    entityState!: EntityStateDTO;

    constructor(data?: IScoreDefinitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.wellDropScoreId = _data["wellDropScoreId"];
            this.hotKey = _data["hotKey"];
            this.color = _data["color"];
            this.wellDropScoreGroupId = _data["wellDropScoreGroupId"];
            this.scoreName = _data["scoreName"];
            this.scoreGroupName = _data["scoreGroupName"];
            this.orderNumber = _data["orderNumber"];
            this.isAutoScore = _data["isAutoScore"];
            this.isoValue = _data["isoValue"];
            this.autoScoreType = _data["autoScoreType"];
            this.hit = _data["hit"];
            this.entityState = _data["entityState"];
        }
    }

    static fromJS(data: any): ScoreDefinitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreDefinitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["wellDropScoreId"] = this.wellDropScoreId;
        data["hotKey"] = this.hotKey;
        data["color"] = this.color;
        data["wellDropScoreGroupId"] = this.wellDropScoreGroupId;
        data["scoreName"] = this.scoreName;
        data["scoreGroupName"] = this.scoreGroupName;
        data["orderNumber"] = this.orderNumber;
        data["isAutoScore"] = this.isAutoScore;
        data["isoValue"] = this.isoValue;
        data["autoScoreType"] = this.autoScoreType;
        data["hit"] = this.hit;
        data["entityState"] = this.entityState;
        return data;
    }
}

export interface IScoreDefinitionDTO {
    value: number;
    wellDropScoreId: number;
    hotKey?: string | undefined;
    color: string;
    wellDropScoreGroupId: number;
    scoreName?: string | undefined;
    scoreGroupName?: string | undefined;
    orderNumber: number;
    isAutoScore: boolean;
    isoValue?: number | undefined;
    autoScoreType?: number | undefined;
    hit: boolean;
    entityState: EntityStateDTO;
}

export class ImageStoreDTO implements IImageStoreDTO {
    id!: number;
    name?: string | undefined;
    basePath?: string | undefined;
    layout?: string | undefined;
    imageStoreLayoutID!: number;
    codec!: number;
    diskSize!: number;
    availableSize!: number;
    entityState!: EntityStateDTO;
    isDefault!: boolean;

    constructor(data?: IImageStoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.basePath = _data["basePath"];
            this.layout = _data["layout"];
            this.imageStoreLayoutID = _data["imageStoreLayoutID"];
            this.codec = _data["codec"];
            this.diskSize = _data["diskSize"];
            this.availableSize = _data["availableSize"];
            this.entityState = _data["entityState"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): ImageStoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageStoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["basePath"] = this.basePath;
        data["layout"] = this.layout;
        data["imageStoreLayoutID"] = this.imageStoreLayoutID;
        data["codec"] = this.codec;
        data["diskSize"] = this.diskSize;
        data["availableSize"] = this.availableSize;
        data["entityState"] = this.entityState;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IImageStoreDTO {
    id: number;
    name?: string | undefined;
    basePath?: string | undefined;
    layout?: string | undefined;
    imageStoreLayoutID: number;
    codec: number;
    diskSize: number;
    availableSize: number;
    entityState: EntityStateDTO;
    isDefault: boolean;
}

export class ImageStoreLayoutDTO implements IImageStoreLayoutDTO {
    id!: number;
    name?: string | undefined;
    imageCodec!: number;

    constructor(data?: IImageStoreLayoutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageCodec = _data["imageCodec"];
        }
    }

    static fromJS(data: any): ImageStoreLayoutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageStoreLayoutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageCodec"] = this.imageCodec;
        return data;
    }
}

export interface IImageStoreLayoutDTO {
    id: number;
    name?: string | undefined;
    imageCodec: number;
}

export class GlobalDataVersionDTO implements IGlobalDataVersionDTO {
    usersVersion!: number;
    containersVersion!: number;
    favouriteIngredientStocksVersion!: number;
    ingredientIngredientTypeVersion!: number;
    ingredientStockVersion!: number;
    ingredientTypeVersion!: number;
    ingredientTypeColorVersion!: number;
    ingredientsVersion!: number;
    scoreDefnVersion!: number;
    incubationTempsVersion!: number;
    setupTempsVersion!: number;
    captureProfileTuningValuesVersion!: number;
    seedListVersion!: number;
    screenListVersion!: number;
    proteinFormulationListVersion!: number;
    licenseEditionVersion!: number;
    allScoresGroupsVersion!: number;
    manualScoreGroupsVersion!: number;

    constructor(data?: IGlobalDataVersionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usersVersion = _data["usersVersion"];
            this.containersVersion = _data["containersVersion"];
            this.favouriteIngredientStocksVersion = _data["favouriteIngredientStocksVersion"];
            this.ingredientIngredientTypeVersion = _data["ingredientIngredientTypeVersion"];
            this.ingredientStockVersion = _data["ingredientStockVersion"];
            this.ingredientTypeVersion = _data["ingredientTypeVersion"];
            this.ingredientTypeColorVersion = _data["ingredientTypeColorVersion"];
            this.ingredientsVersion = _data["ingredientsVersion"];
            this.scoreDefnVersion = _data["scoreDefnVersion"];
            this.incubationTempsVersion = _data["incubationTempsVersion"];
            this.setupTempsVersion = _data["setupTempsVersion"];
            this.captureProfileTuningValuesVersion = _data["captureProfileTuningValuesVersion"];
            this.seedListVersion = _data["seedListVersion"];
            this.screenListVersion = _data["screenListVersion"];
            this.proteinFormulationListVersion = _data["proteinFormulationListVersion"];
            this.licenseEditionVersion = _data["licenseEditionVersion"];
            this.allScoresGroupsVersion = _data["allScoresGroupsVersion"];
            this.manualScoreGroupsVersion = _data["manualScoreGroupsVersion"];
        }
    }

    static fromJS(data: any): GlobalDataVersionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalDataVersionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usersVersion"] = this.usersVersion;
        data["containersVersion"] = this.containersVersion;
        data["favouriteIngredientStocksVersion"] = this.favouriteIngredientStocksVersion;
        data["ingredientIngredientTypeVersion"] = this.ingredientIngredientTypeVersion;
        data["ingredientStockVersion"] = this.ingredientStockVersion;
        data["ingredientTypeVersion"] = this.ingredientTypeVersion;
        data["ingredientTypeColorVersion"] = this.ingredientTypeColorVersion;
        data["ingredientsVersion"] = this.ingredientsVersion;
        data["scoreDefnVersion"] = this.scoreDefnVersion;
        data["incubationTempsVersion"] = this.incubationTempsVersion;
        data["setupTempsVersion"] = this.setupTempsVersion;
        data["captureProfileTuningValuesVersion"] = this.captureProfileTuningValuesVersion;
        data["seedListVersion"] = this.seedListVersion;
        data["screenListVersion"] = this.screenListVersion;
        data["proteinFormulationListVersion"] = this.proteinFormulationListVersion;
        data["licenseEditionVersion"] = this.licenseEditionVersion;
        data["allScoresGroupsVersion"] = this.allScoresGroupsVersion;
        data["manualScoreGroupsVersion"] = this.manualScoreGroupsVersion;
        return data;
    }
}

export interface IGlobalDataVersionDTO {
    usersVersion: number;
    containersVersion: number;
    favouriteIngredientStocksVersion: number;
    ingredientIngredientTypeVersion: number;
    ingredientStockVersion: number;
    ingredientTypeVersion: number;
    ingredientTypeColorVersion: number;
    ingredientsVersion: number;
    scoreDefnVersion: number;
    incubationTempsVersion: number;
    setupTempsVersion: number;
    captureProfileTuningValuesVersion: number;
    seedListVersion: number;
    screenListVersion: number;
    proteinFormulationListVersion: number;
    licenseEditionVersion: number;
    allScoresGroupsVersion: number;
    manualScoreGroupsVersion: number;
}

export class PreferenesDTO implements IPreferenesDTO {
    baseProperties?: BasePropertyDTO[] | undefined;
    preferenceType?: string | undefined;

    constructor(data?: IPreferenesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["baseProperties"])) {
                this.baseProperties = [] as any;
                for (let item of _data["baseProperties"])
                    this.baseProperties!.push(BasePropertyDTO.fromJS(item));
            }
            this.preferenceType = _data["preferenceType"];
        }
    }

    static fromJS(data: any): PreferenesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PreferenesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.baseProperties)) {
            data["baseProperties"] = [];
            for (let item of this.baseProperties)
                data["baseProperties"].push(item ? item.toJSON() : undefined as any);
        }
        data["preferenceType"] = this.preferenceType;
        return data;
    }
}

export interface IPreferenesDTO {
    baseProperties?: BasePropertyDTO[] | undefined;
    preferenceType?: string | undefined;
}

export class ExperimentDispensingPropertiesDTO implements IExperimentDispensingPropertiesDTO {
    robots?: DispensingRobotDTO[] | undefined;
    properties?: { [key: string]: BasePropertyDTO[]; } | undefined;

    constructor(data?: IExperimentDispensingPropertiesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["robots"])) {
                this.robots = [] as any;
                for (let item of _data["robots"])
                    this.robots!.push(DispensingRobotDTO.fromJS(item));
            }
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (this.properties as any)![key] = _data["properties"][key] ? _data["properties"][key].map((i: any) => BasePropertyDTO.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ExperimentDispensingPropertiesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentDispensingPropertiesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.robots)) {
            data["robots"] = [];
            for (let item of this.robots)
                data["robots"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = (this.properties as any)[key];
            }
        }
        return data;
    }
}

export interface IExperimentDispensingPropertiesDTO {
    robots?: DispensingRobotDTO[] | undefined;
    properties?: { [key: string]: BasePropertyDTO[]; } | undefined;
}

export class DispensingRobotDTO implements IDispensingRobotDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IDispensingRobotDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DispensingRobotDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DispensingRobotDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDispensingRobotDTO {
    id: number;
    name?: string | undefined;
}

export class DispensingPropertiesDTO implements IDispensingPropertiesDTO {
    robots?: DispensingRobotDTO[] | undefined;
    generalProperties?: { [key: string]: BasePropertyDTO[]; } | undefined;
    plateProperties?: { [key: string]: { [key: string]: BasePropertyDTO[]; }; } | undefined;
    liquidClassProperties?: { [key: string]: { [key: string]: BasePropertyDTO[]; }; } | undefined;
    plates?: DispensingPropertiesEntityInfoDTO[] | undefined;
    liquidClasses?: DispensingPropertiesEntityInfoDTO[] | undefined;

    constructor(data?: IDispensingPropertiesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["robots"])) {
                this.robots = [] as any;
                for (let item of _data["robots"])
                    this.robots!.push(DispensingRobotDTO.fromJS(item));
            }
            if (_data["generalProperties"]) {
                this.generalProperties = {} as any;
                for (let key in _data["generalProperties"]) {
                    if (_data["generalProperties"].hasOwnProperty(key))
                        (this.generalProperties as any)![key] = _data["generalProperties"][key] ? _data["generalProperties"][key].map((i: any) => BasePropertyDTO.fromJS(i)) : [];
                }
            }
            if (_data["plateProperties"]) {
                this.plateProperties = {} as any;
                for (let key in _data["plateProperties"]) {
                    if (_data["plateProperties"].hasOwnProperty(key))
                        (this.plateProperties as any)![key] = _data["plateProperties"][key] !== undefined ? _data["plateProperties"][key] : {};
                }
            }
            if (_data["liquidClassProperties"]) {
                this.liquidClassProperties = {} as any;
                for (let key in _data["liquidClassProperties"]) {
                    if (_data["liquidClassProperties"].hasOwnProperty(key))
                        (this.liquidClassProperties as any)![key] = _data["liquidClassProperties"][key] !== undefined ? _data["liquidClassProperties"][key] : {};
                }
            }
            if (Array.isArray(_data["plates"])) {
                this.plates = [] as any;
                for (let item of _data["plates"])
                    this.plates!.push(DispensingPropertiesEntityInfoDTO.fromJS(item));
            }
            if (Array.isArray(_data["liquidClasses"])) {
                this.liquidClasses = [] as any;
                for (let item of _data["liquidClasses"])
                    this.liquidClasses!.push(DispensingPropertiesEntityInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DispensingPropertiesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DispensingPropertiesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.robots)) {
            data["robots"] = [];
            for (let item of this.robots)
                data["robots"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.generalProperties) {
            data["generalProperties"] = {};
            for (let key in this.generalProperties) {
                if (this.generalProperties.hasOwnProperty(key))
                    (data["generalProperties"] as any)[key] = (this.generalProperties as any)[key];
            }
        }
        if (this.plateProperties) {
            data["plateProperties"] = {};
            for (let key in this.plateProperties) {
                if (this.plateProperties.hasOwnProperty(key))
                    (data["plateProperties"] as any)[key] = (this.plateProperties as any)[key];
            }
        }
        if (this.liquidClassProperties) {
            data["liquidClassProperties"] = {};
            for (let key in this.liquidClassProperties) {
                if (this.liquidClassProperties.hasOwnProperty(key))
                    (data["liquidClassProperties"] as any)[key] = (this.liquidClassProperties as any)[key];
            }
        }
        if (Array.isArray(this.plates)) {
            data["plates"] = [];
            for (let item of this.plates)
                data["plates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.liquidClasses)) {
            data["liquidClasses"] = [];
            for (let item of this.liquidClasses)
                data["liquidClasses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDispensingPropertiesDTO {
    robots?: DispensingRobotDTO[] | undefined;
    generalProperties?: { [key: string]: BasePropertyDTO[]; } | undefined;
    plateProperties?: { [key: string]: { [key: string]: BasePropertyDTO[]; }; } | undefined;
    liquidClassProperties?: { [key: string]: { [key: string]: BasePropertyDTO[]; }; } | undefined;
    plates?: DispensingPropertiesEntityInfoDTO[] | undefined;
    liquidClasses?: DispensingPropertiesEntityInfoDTO[] | undefined;
}

export class DispensingPropertiesEntityInfoDTO implements IDispensingPropertiesEntityInfoDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IDispensingPropertiesEntityInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DispensingPropertiesEntityInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DispensingPropertiesEntityInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDispensingPropertiesEntityInfoDTO {
    id: number;
    name?: string | undefined;
}

export class AppInfoDTO implements IAppInfoDTO {
    version?: string | undefined;
    buildDate?: string | undefined;
    companyName?: string | undefined;
    supportPhone?: string | undefined;
    supportEmail?: string | undefined;
    copyRight?: string | undefined;

    constructor(data?: IAppInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.buildDate = _data["buildDate"];
            this.companyName = _data["companyName"];
            this.supportPhone = _data["supportPhone"];
            this.supportEmail = _data["supportEmail"];
            this.copyRight = _data["copyRight"];
        }
    }

    static fromJS(data: any): AppInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["buildDate"] = this.buildDate;
        data["companyName"] = this.companyName;
        data["supportPhone"] = this.supportPhone;
        data["supportEmail"] = this.supportEmail;
        data["copyRight"] = this.copyRight;
        return data;
    }
}

export interface IAppInfoDTO {
    version?: string | undefined;
    buildDate?: string | undefined;
    companyName?: string | undefined;
    supportPhone?: string | undefined;
    supportEmail?: string | undefined;
    copyRight?: string | undefined;
}

export class ExpGlobalDataDTO implements IExpGlobalDataDTO {
    scoreDefn?: ScoreDefinitionDTO[] | undefined;
    allScoresGroups?: ScoresGroupsDTO[] | undefined;
    manualScoreGroups?: ScoresGroupsDTO[] | undefined;
    incubationTemps?: IncubationTemperatureDTO[] | undefined;
    setupTemps?: SetupTemperatureDTO[] | undefined;
    users?: UsersDTO[] | undefined;
    containers?: ContainersDTO[] | undefined;
    ingredientData?: GlobalIngredientsDTO | undefined;
    captureProfileTuningValues?: CaptureProfileTuningValuesDTO[] | undefined;
    seedList?: SeedingDTO[] | undefined;
    proteinFormulationList?: ProteinFormulationDTO[] | undefined;
    screenList?: ScreenDTO[] | undefined;
    licenseEdition?: string | undefined;

    constructor(data?: IExpGlobalDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scoreDefn"])) {
                this.scoreDefn = [] as any;
                for (let item of _data["scoreDefn"])
                    this.scoreDefn!.push(ScoreDefinitionDTO.fromJS(item));
            }
            if (Array.isArray(_data["allScoresGroups"])) {
                this.allScoresGroups = [] as any;
                for (let item of _data["allScoresGroups"])
                    this.allScoresGroups!.push(ScoresGroupsDTO.fromJS(item));
            }
            if (Array.isArray(_data["manualScoreGroups"])) {
                this.manualScoreGroups = [] as any;
                for (let item of _data["manualScoreGroups"])
                    this.manualScoreGroups!.push(ScoresGroupsDTO.fromJS(item));
            }
            if (Array.isArray(_data["incubationTemps"])) {
                this.incubationTemps = [] as any;
                for (let item of _data["incubationTemps"])
                    this.incubationTemps!.push(IncubationTemperatureDTO.fromJS(item));
            }
            if (Array.isArray(_data["setupTemps"])) {
                this.setupTemps = [] as any;
                for (let item of _data["setupTemps"])
                    this.setupTemps!.push(SetupTemperatureDTO.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersDTO.fromJS(item));
            }
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(ContainersDTO.fromJS(item));
            }
            this.ingredientData = _data["ingredientData"] ? GlobalIngredientsDTO.fromJS(_data["ingredientData"]) : undefined as any;
            if (Array.isArray(_data["captureProfileTuningValues"])) {
                this.captureProfileTuningValues = [] as any;
                for (let item of _data["captureProfileTuningValues"])
                    this.captureProfileTuningValues!.push(CaptureProfileTuningValuesDTO.fromJS(item));
            }
            if (Array.isArray(_data["seedList"])) {
                this.seedList = [] as any;
                for (let item of _data["seedList"])
                    this.seedList!.push(SeedingDTO.fromJS(item));
            }
            if (Array.isArray(_data["proteinFormulationList"])) {
                this.proteinFormulationList = [] as any;
                for (let item of _data["proteinFormulationList"])
                    this.proteinFormulationList!.push(ProteinFormulationDTO.fromJS(item));
            }
            if (Array.isArray(_data["screenList"])) {
                this.screenList = [] as any;
                for (let item of _data["screenList"])
                    this.screenList!.push(ScreenDTO.fromJS(item));
            }
            this.licenseEdition = _data["licenseEdition"];
        }
    }

    static fromJS(data: any): ExpGlobalDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExpGlobalDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scoreDefn)) {
            data["scoreDefn"] = [];
            for (let item of this.scoreDefn)
                data["scoreDefn"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allScoresGroups)) {
            data["allScoresGroups"] = [];
            for (let item of this.allScoresGroups)
                data["allScoresGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.manualScoreGroups)) {
            data["manualScoreGroups"] = [];
            for (let item of this.manualScoreGroups)
                data["manualScoreGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.incubationTemps)) {
            data["incubationTemps"] = [];
            for (let item of this.incubationTemps)
                data["incubationTemps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.setupTemps)) {
            data["setupTemps"] = [];
            for (let item of this.setupTemps)
                data["setupTemps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item ? item.toJSON() : undefined as any);
        }
        data["ingredientData"] = this.ingredientData ? this.ingredientData.toJSON() : undefined as any;
        if (Array.isArray(this.captureProfileTuningValues)) {
            data["captureProfileTuningValues"] = [];
            for (let item of this.captureProfileTuningValues)
                data["captureProfileTuningValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.seedList)) {
            data["seedList"] = [];
            for (let item of this.seedList)
                data["seedList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinFormulationList)) {
            data["proteinFormulationList"] = [];
            for (let item of this.proteinFormulationList)
                data["proteinFormulationList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenList)) {
            data["screenList"] = [];
            for (let item of this.screenList)
                data["screenList"].push(item ? item.toJSON() : undefined as any);
        }
        data["licenseEdition"] = this.licenseEdition;
        return data;
    }
}

export interface IExpGlobalDataDTO {
    scoreDefn?: ScoreDefinitionDTO[] | undefined;
    allScoresGroups?: ScoresGroupsDTO[] | undefined;
    manualScoreGroups?: ScoresGroupsDTO[] | undefined;
    incubationTemps?: IncubationTemperatureDTO[] | undefined;
    setupTemps?: SetupTemperatureDTO[] | undefined;
    users?: UsersDTO[] | undefined;
    containers?: ContainersDTO[] | undefined;
    ingredientData?: GlobalIngredientsDTO | undefined;
    captureProfileTuningValues?: CaptureProfileTuningValuesDTO[] | undefined;
    seedList?: SeedingDTO[] | undefined;
    proteinFormulationList?: ProteinFormulationDTO[] | undefined;
    screenList?: ScreenDTO[] | undefined;
    licenseEdition?: string | undefined;
}

export class UsersDTO implements IUsersDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IUsersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UsersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUsersDTO {
    id: number;
    name?: string | undefined;
}

export class CaptureProfileTuningValuesDTO extends TuningValuesDTO implements ICaptureProfileTuningValuesDTO {
    id!: number;
    captureProfileID!: number;
    isFrap?: boolean | undefined;

    constructor(data?: ICaptureProfileTuningValuesDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.captureProfileID = _data["captureProfileID"];
            this.isFrap = _data["isFrap"];
        }
    }

    static override fromJS(data: any): CaptureProfileTuningValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProfileTuningValuesDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureProfileID"] = this.captureProfileID;
        data["isFrap"] = this.isFrap;
        super.toJSON(data);
        return data;
    }
}

export interface ICaptureProfileTuningValuesDTO extends ITuningValuesDTO {
    id: number;
    captureProfileID: number;
    isFrap?: boolean | undefined;
}

export class SeedingDTO implements ISeedingDTO {
    id!: number;
    name?: string | undefined;
    plateId?: number | undefined;
    wellDropId?: number | undefined;
    proteinFormulationId?: number | undefined;
    wellSolutionWellId?: number | undefined;
    notes?: string | undefined;
    treeNodeId?: number | undefined;

    constructor(data?: ISeedingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.plateId = _data["plateId"];
            this.wellDropId = _data["wellDropId"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.wellSolutionWellId = _data["wellSolutionWellId"];
            this.notes = _data["notes"];
            this.treeNodeId = _data["treeNodeId"];
        }
    }

    static fromJS(data: any): SeedingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeedingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["plateId"] = this.plateId;
        data["wellDropId"] = this.wellDropId;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["wellSolutionWellId"] = this.wellSolutionWellId;
        data["notes"] = this.notes;
        data["treeNodeId"] = this.treeNodeId;
        return data;
    }
}

export interface ISeedingDTO {
    id: number;
    name?: string | undefined;
    plateId?: number | undefined;
    wellDropId?: number | undefined;
    proteinFormulationId?: number | undefined;
    wellSolutionWellId?: number | undefined;
    notes?: string | undefined;
    treeNodeId?: number | undefined;
}

export class ScreenDTO implements IScreenDTO {
    id!: number;
    userId!: number;
    name?: string | undefined;
    screenLot?: ScreenLotDTO[] | undefined;

    constructor(data?: IScreenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            if (Array.isArray(_data["screenLot"])) {
                this.screenLot = [] as any;
                for (let item of _data["screenLot"])
                    this.screenLot!.push(ScreenLotDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScreenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        if (Array.isArray(this.screenLot)) {
            data["screenLot"] = [];
            for (let item of this.screenLot)
                data["screenLot"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScreenDTO {
    id: number;
    userId: number;
    name?: string | undefined;
    screenLot?: ScreenLotDTO[] | undefined;
}

export class GlobalDataComparisonRequestDTO implements IGlobalDataComparisonRequestDTO {
    comparisonResult?: GlobalDataComparisonResultDTO | undefined;

    constructor(data?: IGlobalDataComparisonRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comparisonResult = _data["comparisonResult"] ? GlobalDataComparisonResultDTO.fromJS(_data["comparisonResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): GlobalDataComparisonRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalDataComparisonRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comparisonResult"] = this.comparisonResult ? this.comparisonResult.toJSON() : undefined as any;
        return data;
    }
}

export interface IGlobalDataComparisonRequestDTO {
    comparisonResult?: GlobalDataComparisonResultDTO | undefined;
}

export class GlobalDataComparisonResultDTO implements IGlobalDataComparisonResultDTO {
    usersVersionMatch!: boolean;
    containersVersionMatch!: boolean;
    favouriteIngredientStocksVersionMatch!: boolean;
    ingredientIngredientTypeVersionMatch!: boolean;
    ingredientStockVersionMatch!: boolean;
    ingredientTypeVersionMatch!: boolean;
    ingredientTypeColorVersionMatch!: boolean;
    ingredientsVersionMatch!: boolean;
    scoreDefnVersionMatch!: boolean;
    incubationTempsVersionMatch!: boolean;
    setupTempsVersionMatch!: boolean;
    captureProfileTuningValuesVersionMatch!: boolean;
    seedListVersionMatch!: boolean;
    screenListVersionMatch!: boolean;
    proteinFormulationListVersionMatch!: boolean;
    licenseEditionVersionMatch!: boolean;
    allScoresGroupsVersionMatch!: boolean;
    manualScoreGroupsVersionMatch!: boolean;

    constructor(data?: IGlobalDataComparisonResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usersVersionMatch = _data["usersVersionMatch"];
            this.containersVersionMatch = _data["containersVersionMatch"];
            this.favouriteIngredientStocksVersionMatch = _data["favouriteIngredientStocksVersionMatch"];
            this.ingredientIngredientTypeVersionMatch = _data["ingredientIngredientTypeVersionMatch"];
            this.ingredientStockVersionMatch = _data["ingredientStockVersionMatch"];
            this.ingredientTypeVersionMatch = _data["ingredientTypeVersionMatch"];
            this.ingredientTypeColorVersionMatch = _data["ingredientTypeColorVersionMatch"];
            this.ingredientsVersionMatch = _data["ingredientsVersionMatch"];
            this.scoreDefnVersionMatch = _data["scoreDefnVersionMatch"];
            this.incubationTempsVersionMatch = _data["incubationTempsVersionMatch"];
            this.setupTempsVersionMatch = _data["setupTempsVersionMatch"];
            this.captureProfileTuningValuesVersionMatch = _data["captureProfileTuningValuesVersionMatch"];
            this.seedListVersionMatch = _data["seedListVersionMatch"];
            this.screenListVersionMatch = _data["screenListVersionMatch"];
            this.proteinFormulationListVersionMatch = _data["proteinFormulationListVersionMatch"];
            this.licenseEditionVersionMatch = _data["licenseEditionVersionMatch"];
            this.allScoresGroupsVersionMatch = _data["allScoresGroupsVersionMatch"];
            this.manualScoreGroupsVersionMatch = _data["manualScoreGroupsVersionMatch"];
        }
    }

    static fromJS(data: any): GlobalDataComparisonResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalDataComparisonResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usersVersionMatch"] = this.usersVersionMatch;
        data["containersVersionMatch"] = this.containersVersionMatch;
        data["favouriteIngredientStocksVersionMatch"] = this.favouriteIngredientStocksVersionMatch;
        data["ingredientIngredientTypeVersionMatch"] = this.ingredientIngredientTypeVersionMatch;
        data["ingredientStockVersionMatch"] = this.ingredientStockVersionMatch;
        data["ingredientTypeVersionMatch"] = this.ingredientTypeVersionMatch;
        data["ingredientTypeColorVersionMatch"] = this.ingredientTypeColorVersionMatch;
        data["ingredientsVersionMatch"] = this.ingredientsVersionMatch;
        data["scoreDefnVersionMatch"] = this.scoreDefnVersionMatch;
        data["incubationTempsVersionMatch"] = this.incubationTempsVersionMatch;
        data["setupTempsVersionMatch"] = this.setupTempsVersionMatch;
        data["captureProfileTuningValuesVersionMatch"] = this.captureProfileTuningValuesVersionMatch;
        data["seedListVersionMatch"] = this.seedListVersionMatch;
        data["screenListVersionMatch"] = this.screenListVersionMatch;
        data["proteinFormulationListVersionMatch"] = this.proteinFormulationListVersionMatch;
        data["licenseEditionVersionMatch"] = this.licenseEditionVersionMatch;
        data["allScoresGroupsVersionMatch"] = this.allScoresGroupsVersionMatch;
        data["manualScoreGroupsVersionMatch"] = this.manualScoreGroupsVersionMatch;
        return data;
    }
}

export interface IGlobalDataComparisonResultDTO {
    usersVersionMatch: boolean;
    containersVersionMatch: boolean;
    favouriteIngredientStocksVersionMatch: boolean;
    ingredientIngredientTypeVersionMatch: boolean;
    ingredientStockVersionMatch: boolean;
    ingredientTypeVersionMatch: boolean;
    ingredientTypeColorVersionMatch: boolean;
    ingredientsVersionMatch: boolean;
    scoreDefnVersionMatch: boolean;
    incubationTempsVersionMatch: boolean;
    setupTempsVersionMatch: boolean;
    captureProfileTuningValuesVersionMatch: boolean;
    seedListVersionMatch: boolean;
    screenListVersionMatch: boolean;
    proteinFormulationListVersionMatch: boolean;
    licenseEditionVersionMatch: boolean;
    allScoresGroupsVersionMatch: boolean;
    manualScoreGroupsVersionMatch: boolean;
}

export class ImageManagementTaskDTO implements IImageManagementTaskDTO {
    id!: number;
    taskName?: string | undefined;
    treeNodeId?: number | undefined;
    errorBehaviour?: number | undefined;
    isBackground!: boolean;
    lastExecutionTime?: Date | undefined;
    imageManagementActionList?: ImageManagementActionDTO[] | undefined;
    parentId!: number;
    isDirty!: boolean;
    isNameUpdated!: boolean;
    isDuplicate!: boolean;
    isPreview!: boolean;
    explorerNodeIds?: number[] | undefined;
    allowEdits?: number | undefined;

    constructor(data?: IImageManagementTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.treeNodeId = _data["treeNodeId"];
            this.errorBehaviour = _data["errorBehaviour"];
            this.isBackground = _data["isBackground"];
            this.lastExecutionTime = _data["lastExecutionTime"] ? new Date(_data["lastExecutionTime"].toString()) : undefined as any;
            if (Array.isArray(_data["imageManagementActionList"])) {
                this.imageManagementActionList = [] as any;
                for (let item of _data["imageManagementActionList"])
                    this.imageManagementActionList!.push(ImageManagementActionDTO.fromJS(item));
            }
            this.parentId = _data["parentId"];
            this.isDirty = _data["isDirty"];
            this.isNameUpdated = _data["isNameUpdated"];
            this.isDuplicate = _data["isDuplicate"];
            this.isPreview = _data["isPreview"];
            if (Array.isArray(_data["explorerNodeIds"])) {
                this.explorerNodeIds = [] as any;
                for (let item of _data["explorerNodeIds"])
                    this.explorerNodeIds!.push(item);
            }
            this.allowEdits = _data["allowEdits"];
        }
    }

    static fromJS(data: any): ImageManagementTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageManagementTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["treeNodeId"] = this.treeNodeId;
        data["errorBehaviour"] = this.errorBehaviour;
        data["isBackground"] = this.isBackground;
        data["lastExecutionTime"] = this.lastExecutionTime ? this.lastExecutionTime.toISOString() : undefined as any;
        if (Array.isArray(this.imageManagementActionList)) {
            data["imageManagementActionList"] = [];
            for (let item of this.imageManagementActionList)
                data["imageManagementActionList"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentId"] = this.parentId;
        data["isDirty"] = this.isDirty;
        data["isNameUpdated"] = this.isNameUpdated;
        data["isDuplicate"] = this.isDuplicate;
        data["isPreview"] = this.isPreview;
        if (Array.isArray(this.explorerNodeIds)) {
            data["explorerNodeIds"] = [];
            for (let item of this.explorerNodeIds)
                data["explorerNodeIds"].push(item);
        }
        data["allowEdits"] = this.allowEdits;
        return data;
    }
}

export interface IImageManagementTaskDTO {
    id: number;
    taskName?: string | undefined;
    treeNodeId?: number | undefined;
    errorBehaviour?: number | undefined;
    isBackground: boolean;
    lastExecutionTime?: Date | undefined;
    imageManagementActionList?: ImageManagementActionDTO[] | undefined;
    parentId: number;
    isDirty: boolean;
    isNameUpdated: boolean;
    isDuplicate: boolean;
    isPreview: boolean;
    explorerNodeIds?: number[] | undefined;
    allowEdits?: number | undefined;
}

export class ImageManagementActionDTO implements IImageManagementActionDTO {
    id!: number;
    imageManagementId!: number;
    rootSearchConstraintTreeNodeId!: number;
    actionType!: number;
    sourceImageStoreId!: number;
    targetImageStoreId?: number | undefined;
    verify!: boolean;
    excludeFirstInspection!: boolean;
    excludeLastInspection!: boolean;
    isExecuting!: boolean;
    minImageAge?: number | undefined;
    isDirty!: boolean;
    isConstraintDirty!: boolean;
    constraints?: SearchConstraintRootDTO | undefined;

    constructor(data?: IImageManagementActionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageManagementId = _data["imageManagementId"];
            this.rootSearchConstraintTreeNodeId = _data["rootSearchConstraintTreeNodeId"];
            this.actionType = _data["actionType"];
            this.sourceImageStoreId = _data["sourceImageStoreId"];
            this.targetImageStoreId = _data["targetImageStoreId"];
            this.verify = _data["verify"];
            this.excludeFirstInspection = _data["excludeFirstInspection"];
            this.excludeLastInspection = _data["excludeLastInspection"];
            this.isExecuting = _data["isExecuting"];
            this.minImageAge = _data["minImageAge"];
            this.isDirty = _data["isDirty"];
            this.isConstraintDirty = _data["isConstraintDirty"];
            this.constraints = _data["constraints"] ? SearchConstraintRootDTO.fromJS(_data["constraints"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImageManagementActionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageManagementActionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageManagementId"] = this.imageManagementId;
        data["rootSearchConstraintTreeNodeId"] = this.rootSearchConstraintTreeNodeId;
        data["actionType"] = this.actionType;
        data["sourceImageStoreId"] = this.sourceImageStoreId;
        data["targetImageStoreId"] = this.targetImageStoreId;
        data["verify"] = this.verify;
        data["excludeFirstInspection"] = this.excludeFirstInspection;
        data["excludeLastInspection"] = this.excludeLastInspection;
        data["isExecuting"] = this.isExecuting;
        data["minImageAge"] = this.minImageAge;
        data["isDirty"] = this.isDirty;
        data["isConstraintDirty"] = this.isConstraintDirty;
        data["constraints"] = this.constraints ? this.constraints.toJSON() : undefined as any;
        return data;
    }
}

export interface IImageManagementActionDTO {
    id: number;
    imageManagementId: number;
    rootSearchConstraintTreeNodeId: number;
    actionType: number;
    sourceImageStoreId: number;
    targetImageStoreId?: number | undefined;
    verify: boolean;
    excludeFirstInspection: boolean;
    excludeLastInspection: boolean;
    isExecuting: boolean;
    minImageAge?: number | undefined;
    isDirty: boolean;
    isConstraintDirty: boolean;
    constraints?: SearchConstraintRootDTO | undefined;
}

export class SearchConstraintRootDTO implements ISearchConstraintRootDTO {
    rules?: SearchConstraintDTO[] | undefined;
    combinator!: SearchCombinator;
    not!: boolean;

    constructor(data?: ISearchConstraintRootDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(SearchConstraintDTO.fromJS(item));
            }
            this.combinator = _data["combinator"];
            this.not = _data["not"];
        }
    }

    static fromJS(data: any): SearchConstraintRootDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchConstraintRootDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : undefined as any);
        }
        data["combinator"] = this.combinator;
        data["not"] = this.not;
        return data;
    }
}

export interface ISearchConstraintRootDTO {
    rules?: SearchConstraintDTO[] | undefined;
    combinator: SearchCombinator;
    not: boolean;
}

export class SearchConstraintDTO implements ISearchConstraintDTO {
    id?: string | undefined;
    field!: number;
    value?: string | undefined;
    operator?: string | undefined;
    rules?: SearchConstraintDTO[] | undefined;
    combinator?: SearchCombinator | undefined;
    isDropdown!: boolean;

    constructor(data?: ISearchConstraintDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.field = _data["field"];
            this.value = _data["value"];
            this.operator = _data["operator"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(SearchConstraintDTO.fromJS(item));
            }
            this.combinator = _data["combinator"];
            this.isDropdown = _data["isDropdown"];
        }
    }

    static fromJS(data: any): SearchConstraintDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchConstraintDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["field"] = this.field;
        data["value"] = this.value;
        data["operator"] = this.operator;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : undefined as any);
        }
        data["combinator"] = this.combinator;
        data["isDropdown"] = this.isDropdown;
        return data;
    }
}

export interface ISearchConstraintDTO {
    id?: string | undefined;
    field: number;
    value?: string | undefined;
    operator?: string | undefined;
    rules?: SearchConstraintDTO[] | undefined;
    combinator?: SearchCombinator | undefined;
    isDropdown: boolean;
}

export enum SearchCombinator {
    And = "And",
    Or = "Or",
    Not = "Not",
    Constraint = "Constraint",
}

export class SaveImageTaskDTO implements ISaveImageTaskDTO {
    task?: ImageManagementTaskDTO | undefined;
    deletedActionIds?: number[] | undefined;

    constructor(data?: ISaveImageTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.task = _data["task"] ? ImageManagementTaskDTO.fromJS(_data["task"]) : undefined as any;
            if (Array.isArray(_data["deletedActionIds"])) {
                this.deletedActionIds = [] as any;
                for (let item of _data["deletedActionIds"])
                    this.deletedActionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveImageTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImageTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["task"] = this.task ? this.task.toJSON() : undefined as any;
        if (Array.isArray(this.deletedActionIds)) {
            data["deletedActionIds"] = [];
            for (let item of this.deletedActionIds)
                data["deletedActionIds"].push(item);
        }
        return data;
    }
}

export interface ISaveImageTaskDTO {
    task?: ImageManagementTaskDTO | undefined;
    deletedActionIds?: number[] | undefined;
}

export class ImageManagementResultDTO implements IImageManagementResultDTO {
    rowNumber!: number;
    action?: string | undefined;
    actionStatus?: string | undefined;
    actionStatusId!: number;
    plateId!: number;
    imageId!: number;
    experimentUserName?: string | undefined;
    experimentName?: string | undefined;
    plateNumber!: number;
    wellNumber!: number;
    dropNumber!: number;
    regionId!: number;
    regionName?: string | undefined;
    captureResultId!: number;
    captureResultImageBatchId!: number;
    captureResultDateImaged?: string | undefined;
    wellDropScoreName?: string | undefined;
    imageTypeLongName?: string | undefined;
    imageTypeIndex!: number;
    imagePixelSize!: number;
    imageFileSize!: number;
    imageStoreName?: string | undefined;
    imageStoreBasePath?: string | undefined;
    fileSize!: number;
    treeNodeId!: number;
    actionId!: number;

    constructor(data?: IImageManagementResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.action = _data["action"];
            this.actionStatus = _data["actionStatus"];
            this.actionStatusId = _data["actionStatusId"];
            this.plateId = _data["plateId"];
            this.imageId = _data["imageId"];
            this.experimentUserName = _data["experimentUserName"];
            this.experimentName = _data["experimentName"];
            this.plateNumber = _data["plateNumber"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.captureResultId = _data["captureResultId"];
            this.captureResultImageBatchId = _data["captureResultImageBatchId"];
            this.captureResultDateImaged = _data["captureResultDateImaged"];
            this.wellDropScoreName = _data["wellDropScoreName"];
            this.imageTypeLongName = _data["imageTypeLongName"];
            this.imageTypeIndex = _data["imageTypeIndex"];
            this.imagePixelSize = _data["imagePixelSize"];
            this.imageFileSize = _data["imageFileSize"];
            this.imageStoreName = _data["imageStoreName"];
            this.imageStoreBasePath = _data["imageStoreBasePath"];
            this.fileSize = _data["fileSize"];
            this.treeNodeId = _data["treeNodeId"];
            this.actionId = _data["actionId"];
        }
    }

    static fromJS(data: any): ImageManagementResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageManagementResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["action"] = this.action;
        data["actionStatus"] = this.actionStatus;
        data["actionStatusId"] = this.actionStatusId;
        data["plateId"] = this.plateId;
        data["imageId"] = this.imageId;
        data["experimentUserName"] = this.experimentUserName;
        data["experimentName"] = this.experimentName;
        data["plateNumber"] = this.plateNumber;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["captureResultId"] = this.captureResultId;
        data["captureResultImageBatchId"] = this.captureResultImageBatchId;
        data["captureResultDateImaged"] = this.captureResultDateImaged;
        data["wellDropScoreName"] = this.wellDropScoreName;
        data["imageTypeLongName"] = this.imageTypeLongName;
        data["imageTypeIndex"] = this.imageTypeIndex;
        data["imagePixelSize"] = this.imagePixelSize;
        data["imageFileSize"] = this.imageFileSize;
        data["imageStoreName"] = this.imageStoreName;
        data["imageStoreBasePath"] = this.imageStoreBasePath;
        data["fileSize"] = this.fileSize;
        data["treeNodeId"] = this.treeNodeId;
        data["actionId"] = this.actionId;
        return data;
    }
}

export interface IImageManagementResultDTO {
    rowNumber: number;
    action?: string | undefined;
    actionStatus?: string | undefined;
    actionStatusId: number;
    plateId: number;
    imageId: number;
    experimentUserName?: string | undefined;
    experimentName?: string | undefined;
    plateNumber: number;
    wellNumber: number;
    dropNumber: number;
    regionId: number;
    regionName?: string | undefined;
    captureResultId: number;
    captureResultImageBatchId: number;
    captureResultDateImaged?: string | undefined;
    wellDropScoreName?: string | undefined;
    imageTypeLongName?: string | undefined;
    imageTypeIndex: number;
    imagePixelSize: number;
    imageFileSize: number;
    imageStoreName?: string | undefined;
    imageStoreBasePath?: string | undefined;
    fileSize: number;
    treeNodeId: number;
    actionId: number;
}

export class ImageNowCommandDTO implements IImageNowCommandDTO {
    selectedPlateId!: number;
    selectedPlateIds?: number[] | undefined;
    selectedDropIds?: number[] | undefined;
    selectedExperimentIds?: number[] | undefined;
    selectedExperimentId!: number;
    selectedRegionName?: string | undefined;
    imagingLevel?: string | undefined;
    imagingSubLevels?: string[] | undefined;
    captureProfileIds?: number[] | undefined;

    constructor(data?: IImageNowCommandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedPlateId = _data["selectedPlateId"];
            if (Array.isArray(_data["selectedPlateIds"])) {
                this.selectedPlateIds = [] as any;
                for (let item of _data["selectedPlateIds"])
                    this.selectedPlateIds!.push(item);
            }
            if (Array.isArray(_data["selectedDropIds"])) {
                this.selectedDropIds = [] as any;
                for (let item of _data["selectedDropIds"])
                    this.selectedDropIds!.push(item);
            }
            if (Array.isArray(_data["selectedExperimentIds"])) {
                this.selectedExperimentIds = [] as any;
                for (let item of _data["selectedExperimentIds"])
                    this.selectedExperimentIds!.push(item);
            }
            this.selectedExperimentId = _data["selectedExperimentId"];
            this.selectedRegionName = _data["selectedRegionName"];
            this.imagingLevel = _data["imagingLevel"];
            if (Array.isArray(_data["imagingSubLevels"])) {
                this.imagingSubLevels = [] as any;
                for (let item of _data["imagingSubLevels"])
                    this.imagingSubLevels!.push(item);
            }
            if (Array.isArray(_data["captureProfileIds"])) {
                this.captureProfileIds = [] as any;
                for (let item of _data["captureProfileIds"])
                    this.captureProfileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ImageNowCommandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageNowCommandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedPlateId"] = this.selectedPlateId;
        if (Array.isArray(this.selectedPlateIds)) {
            data["selectedPlateIds"] = [];
            for (let item of this.selectedPlateIds)
                data["selectedPlateIds"].push(item);
        }
        if (Array.isArray(this.selectedDropIds)) {
            data["selectedDropIds"] = [];
            for (let item of this.selectedDropIds)
                data["selectedDropIds"].push(item);
        }
        if (Array.isArray(this.selectedExperimentIds)) {
            data["selectedExperimentIds"] = [];
            for (let item of this.selectedExperimentIds)
                data["selectedExperimentIds"].push(item);
        }
        data["selectedExperimentId"] = this.selectedExperimentId;
        data["selectedRegionName"] = this.selectedRegionName;
        data["imagingLevel"] = this.imagingLevel;
        if (Array.isArray(this.imagingSubLevels)) {
            data["imagingSubLevels"] = [];
            for (let item of this.imagingSubLevels)
                data["imagingSubLevels"].push(item);
        }
        if (Array.isArray(this.captureProfileIds)) {
            data["captureProfileIds"] = [];
            for (let item of this.captureProfileIds)
                data["captureProfileIds"].push(item);
        }
        return data;
    }
}

export interface IImageNowCommandDTO {
    selectedPlateId: number;
    selectedPlateIds?: number[] | undefined;
    selectedDropIds?: number[] | undefined;
    selectedExperimentIds?: number[] | undefined;
    selectedExperimentId: number;
    selectedRegionName?: string | undefined;
    imagingLevel?: string | undefined;
    imagingSubLevels?: string[] | undefined;
    captureProfileIds?: number[] | undefined;
}

export class ImagingScheduleDTO implements IImagingScheduleDTO {
    dateToImaged!: Date;
    dateImaged?: Date | undefined;
    state!: number;
    source!: number;

    constructor(data?: IImagingScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateToImaged = _data["dateToImaged"] ? new Date(_data["dateToImaged"].toString()) : undefined as any;
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.state = _data["state"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ImagingScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateToImaged"] = this.dateToImaged ? this.dateToImaged.toISOString() : undefined as any;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["state"] = this.state;
        data["source"] = this.source;
        return data;
    }
}

export interface IImagingScheduleDTO {
    dateToImaged: Date;
    dateImaged?: Date | undefined;
    state: number;
    source: number;
}

export class ImageFocusLevelDTO implements IImageFocusLevelDTO {
    imageId!: number;
    imageTypeId!: number;
    image?: string | undefined;
    imageTitle?: string | undefined;
    isBestFocusLevel!: boolean;
    imageTypeIndex!: number;
    pixelSize?: number | undefined;
    imageTypeShortName?: string | undefined;

    constructor(data?: IImageFocusLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.imageTypeId = _data["imageTypeId"];
            this.image = _data["image"];
            this.imageTitle = _data["imageTitle"];
            this.isBestFocusLevel = _data["isBestFocusLevel"];
            this.imageTypeIndex = _data["imageTypeIndex"];
            this.pixelSize = _data["pixelSize"];
            this.imageTypeShortName = _data["imageTypeShortName"];
        }
    }

    static fromJS(data: any): ImageFocusLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageFocusLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["imageTypeId"] = this.imageTypeId;
        data["image"] = this.image;
        data["imageTitle"] = this.imageTitle;
        data["isBestFocusLevel"] = this.isBestFocusLevel;
        data["imageTypeIndex"] = this.imageTypeIndex;
        data["pixelSize"] = this.pixelSize;
        data["imageTypeShortName"] = this.imageTypeShortName;
        return data;
    }
}

export interface IImageFocusLevelDTO {
    imageId: number;
    imageTypeId: number;
    image?: string | undefined;
    imageTitle?: string | undefined;
    isBestFocusLevel: boolean;
    imageTypeIndex: number;
    pixelSize?: number | undefined;
    imageTypeShortName?: string | undefined;
}

export class SetBestFocusLevelImageRequestDTO implements ISetBestFocusLevelImageRequestDTO {
    previousBestSelectedImageId!: number;
    selectedImageId!: number;

    constructor(data?: ISetBestFocusLevelImageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousBestSelectedImageId = _data["previousBestSelectedImageId"];
            this.selectedImageId = _data["selectedImageId"];
        }
    }

    static fromJS(data: any): SetBestFocusLevelImageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetBestFocusLevelImageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousBestSelectedImageId"] = this.previousBestSelectedImageId;
        data["selectedImageId"] = this.selectedImageId;
        return data;
    }
}

export interface ISetBestFocusLevelImageRequestDTO {
    previousBestSelectedImageId: number;
    selectedImageId: number;
}

export class ImagerQuotaDTO implements IImagerQuotaDTO {
    id!: number;
    robotId!: number;
    name?: string | undefined;
    isDirty!: boolean;
    imagerGroups?: ImagerGroupsDTO[] | undefined;

    constructor(data?: IImagerQuotaDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.robotId = _data["robotId"];
            this.name = _data["name"];
            this.isDirty = _data["isDirty"];
            if (Array.isArray(_data["imagerGroups"])) {
                this.imagerGroups = [] as any;
                for (let item of _data["imagerGroups"])
                    this.imagerGroups!.push(ImagerGroupsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImagerQuotaDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagerQuotaDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["robotId"] = this.robotId;
        data["name"] = this.name;
        data["isDirty"] = this.isDirty;
        if (Array.isArray(this.imagerGroups)) {
            data["imagerGroups"] = [];
            for (let item of this.imagerGroups)
                data["imagerGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImagerQuotaDTO {
    id: number;
    robotId: number;
    name?: string | undefined;
    isDirty: boolean;
    imagerGroups?: ImagerGroupsDTO[] | undefined;
}

export class ImagerGroupsDTO implements IImagerGroupsDTO {
    id!: number;
    groupId!: number;
    groupName?: string | undefined;
    imagerId!: number;
    plateQuota!: number;
    usedPlateQuota!: number;
    isDirty!: boolean;

    constructor(data?: IImagerGroupsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.imagerId = _data["imagerId"];
            this.plateQuota = _data["plateQuota"];
            this.usedPlateQuota = _data["usedPlateQuota"];
            this.isDirty = _data["isDirty"];
        }
    }

    static fromJS(data: any): ImagerGroupsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagerGroupsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["imagerId"] = this.imagerId;
        data["plateQuota"] = this.plateQuota;
        data["usedPlateQuota"] = this.usedPlateQuota;
        data["isDirty"] = this.isDirty;
        return data;
    }
}

export interface IImagerGroupsDTO {
    id: number;
    groupId: number;
    groupName?: string | undefined;
    imagerId: number;
    plateQuota: number;
    usedPlateQuota: number;
    isDirty: boolean;
}

export class CompositeImageWithDrawingDTO implements ICompositeImageWithDrawingDTO {
    plateId!: number;
    experimentId!: number;
    captureProfileId!: number;
    dropNumber!: number;
    imageBatchId!: number;
    compositeImage?: string | undefined;
    plateBarName?: string | undefined;

    constructor(data?: ICompositeImageWithDrawingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.experimentId = _data["experimentId"];
            this.captureProfileId = _data["captureProfileId"];
            this.dropNumber = _data["dropNumber"];
            this.imageBatchId = _data["imageBatchId"];
            this.compositeImage = _data["compositeImage"];
            this.plateBarName = _data["plateBarName"];
        }
    }

    static fromJS(data: any): CompositeImageWithDrawingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CompositeImageWithDrawingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["experimentId"] = this.experimentId;
        data["captureProfileId"] = this.captureProfileId;
        data["dropNumber"] = this.dropNumber;
        data["imageBatchId"] = this.imageBatchId;
        data["compositeImage"] = this.compositeImage;
        data["plateBarName"] = this.plateBarName;
        return data;
    }
}

export interface ICompositeImageWithDrawingDTO {
    plateId: number;
    experimentId: number;
    captureProfileId: number;
    dropNumber: number;
    imageBatchId: number;
    compositeImage?: string | undefined;
    plateBarName?: string | undefined;
}

export class ExperimentReportCompositeImageDTO implements IExperimentReportCompositeImageDTO {
    experimentId!: number;
    captureProfiles?: number[] | undefined;

    constructor(data?: IExperimentReportCompositeImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            if (Array.isArray(_data["captureProfiles"])) {
                this.captureProfiles = [] as any;
                for (let item of _data["captureProfiles"])
                    this.captureProfiles!.push(item);
            }
        }
    }

    static fromJS(data: any): ExperimentReportCompositeImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentReportCompositeImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        if (Array.isArray(this.captureProfiles)) {
            data["captureProfiles"] = [];
            for (let item of this.captureProfiles)
                data["captureProfiles"].push(item);
        }
        return data;
    }
}

export interface IExperimentReportCompositeImageDTO {
    experimentId: number;
    captureProfiles?: number[] | undefined;
}

export class ImagingSchedulesDTO implements IImagingSchedulesDTO {
    id!: number;
    name?: string | undefined;
    enable!: boolean;
    imagingScheduleEntry?: ImagingSchedulesEntryDTO[] | undefined;

    constructor(data?: IImagingSchedulesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enable = _data["enable"];
            if (Array.isArray(_data["imagingScheduleEntry"])) {
                this.imagingScheduleEntry = [] as any;
                for (let item of _data["imagingScheduleEntry"])
                    this.imagingScheduleEntry!.push(ImagingSchedulesEntryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImagingSchedulesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingSchedulesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enable"] = this.enable;
        if (Array.isArray(this.imagingScheduleEntry)) {
            data["imagingScheduleEntry"] = [];
            for (let item of this.imagingScheduleEntry)
                data["imagingScheduleEntry"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImagingSchedulesDTO {
    id: number;
    name?: string | undefined;
    enable: boolean;
    imagingScheduleEntry?: ImagingSchedulesEntryDTO[] | undefined;
}

export class ImagingSchedulesEntryDTO implements IImagingSchedulesEntryDTO {
    id!: number;
    days!: number;
    hours!: number;
    notify!: boolean;
    priority!: number;
    imagingScheduleEntryCaptureProfile?: ImagingScheduleEntryCaptureProfile[] | undefined;

    constructor(data?: IImagingSchedulesEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.notify = _data["notify"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["imagingScheduleEntryCaptureProfile"])) {
                this.imagingScheduleEntryCaptureProfile = [] as any;
                for (let item of _data["imagingScheduleEntryCaptureProfile"])
                    this.imagingScheduleEntryCaptureProfile!.push(ImagingScheduleEntryCaptureProfile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImagingSchedulesEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingSchedulesEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["notify"] = this.notify;
        data["priority"] = this.priority;
        if (Array.isArray(this.imagingScheduleEntryCaptureProfile)) {
            data["imagingScheduleEntryCaptureProfile"] = [];
            for (let item of this.imagingScheduleEntryCaptureProfile)
                data["imagingScheduleEntryCaptureProfile"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImagingSchedulesEntryDTO {
    id: number;
    days: number;
    hours: number;
    notify: boolean;
    priority: number;
    imagingScheduleEntryCaptureProfile?: ImagingScheduleEntryCaptureProfile[] | undefined;
}

export class SaveImagingSchedulesDTO implements ISaveImagingSchedulesDTO {
    imagingSchedules?: ImagingSchedulesDTO[] | undefined;
    deletedData?: ImagingSchedulesDeletedDataDTO | undefined;

    constructor(data?: ISaveImagingSchedulesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imagingSchedules"])) {
                this.imagingSchedules = [] as any;
                for (let item of _data["imagingSchedules"])
                    this.imagingSchedules!.push(ImagingSchedulesDTO.fromJS(item));
            }
            this.deletedData = _data["deletedData"] ? ImagingSchedulesDeletedDataDTO.fromJS(_data["deletedData"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveImagingSchedulesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImagingSchedulesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imagingSchedules)) {
            data["imagingSchedules"] = [];
            for (let item of this.imagingSchedules)
                data["imagingSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        data["deletedData"] = this.deletedData ? this.deletedData.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveImagingSchedulesDTO {
    imagingSchedules?: ImagingSchedulesDTO[] | undefined;
    deletedData?: ImagingSchedulesDeletedDataDTO | undefined;
}

export class ImagingSchedulesDeletedDataDTO implements IImagingSchedulesDeletedDataDTO {
    imagingScheduleIds?: number[] | undefined;
    imagingScheduleEntryIds?: number[] | undefined;
    imagingScheduleEntryCaptureProfileIds?: number[] | undefined;
    imagingTaskClearedFromToImageIds?: number[] | undefined;
    imagingTaskClearedFromToScoreIds?: number[] | undefined;

    constructor(data?: IImagingSchedulesDeletedDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imagingScheduleIds"])) {
                this.imagingScheduleIds = [] as any;
                for (let item of _data["imagingScheduleIds"])
                    this.imagingScheduleIds!.push(item);
            }
            if (Array.isArray(_data["imagingScheduleEntryIds"])) {
                this.imagingScheduleEntryIds = [] as any;
                for (let item of _data["imagingScheduleEntryIds"])
                    this.imagingScheduleEntryIds!.push(item);
            }
            if (Array.isArray(_data["imagingScheduleEntryCaptureProfileIds"])) {
                this.imagingScheduleEntryCaptureProfileIds = [] as any;
                for (let item of _data["imagingScheduleEntryCaptureProfileIds"])
                    this.imagingScheduleEntryCaptureProfileIds!.push(item);
            }
            if (Array.isArray(_data["imagingTaskClearedFromToImageIds"])) {
                this.imagingTaskClearedFromToImageIds = [] as any;
                for (let item of _data["imagingTaskClearedFromToImageIds"])
                    this.imagingTaskClearedFromToImageIds!.push(item);
            }
            if (Array.isArray(_data["imagingTaskClearedFromToScoreIds"])) {
                this.imagingTaskClearedFromToScoreIds = [] as any;
                for (let item of _data["imagingTaskClearedFromToScoreIds"])
                    this.imagingTaskClearedFromToScoreIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ImagingSchedulesDeletedDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingSchedulesDeletedDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imagingScheduleIds)) {
            data["imagingScheduleIds"] = [];
            for (let item of this.imagingScheduleIds)
                data["imagingScheduleIds"].push(item);
        }
        if (Array.isArray(this.imagingScheduleEntryIds)) {
            data["imagingScheduleEntryIds"] = [];
            for (let item of this.imagingScheduleEntryIds)
                data["imagingScheduleEntryIds"].push(item);
        }
        if (Array.isArray(this.imagingScheduleEntryCaptureProfileIds)) {
            data["imagingScheduleEntryCaptureProfileIds"] = [];
            for (let item of this.imagingScheduleEntryCaptureProfileIds)
                data["imagingScheduleEntryCaptureProfileIds"].push(item);
        }
        if (Array.isArray(this.imagingTaskClearedFromToImageIds)) {
            data["imagingTaskClearedFromToImageIds"] = [];
            for (let item of this.imagingTaskClearedFromToImageIds)
                data["imagingTaskClearedFromToImageIds"].push(item);
        }
        if (Array.isArray(this.imagingTaskClearedFromToScoreIds)) {
            data["imagingTaskClearedFromToScoreIds"] = [];
            for (let item of this.imagingTaskClearedFromToScoreIds)
                data["imagingTaskClearedFromToScoreIds"].push(item);
        }
        return data;
    }
}

export interface IImagingSchedulesDeletedDataDTO {
    imagingScheduleIds?: number[] | undefined;
    imagingScheduleEntryIds?: number[] | undefined;
    imagingScheduleEntryCaptureProfileIds?: number[] | undefined;
    imagingTaskClearedFromToImageIds?: number[] | undefined;
    imagingTaskClearedFromToScoreIds?: number[] | undefined;
}

export class PlatesToImageDTO implements IPlatesToImageDTO {
    id!: number;
    dateToImage!: Date;
    user?: string | undefined;
    experimentName?: string | undefined;
    plateNumber!: number;
    experimentId!: number;

    constructor(data?: IPlatesToImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateToImage = _data["dateToImage"] ? new Date(_data["dateToImage"].toString()) : undefined as any;
            this.user = _data["user"];
            this.experimentName = _data["experimentName"];
            this.plateNumber = _data["plateNumber"];
            this.experimentId = _data["experimentId"];
        }
    }

    static fromJS(data: any): PlatesToImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlatesToImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateToImage"] = this.dateToImage ? this.dateToImage.toISOString() : undefined as any;
        data["user"] = this.user;
        data["experimentName"] = this.experimentName;
        data["plateNumber"] = this.plateNumber;
        data["experimentId"] = this.experimentId;
        return data;
    }
}

export interface IPlatesToImageDTO {
    id: number;
    dateToImage: Date;
    user?: string | undefined;
    experimentName?: string | undefined;
    plateNumber: number;
    experimentId: number;
}

export class PlateInspectionsToScoreDTO implements IPlateInspectionsToScoreDTO {
    id!: number;
    dateImaged!: Date;
    user?: string | undefined;
    experimentName?: string | undefined;
    plateNumber!: number;
    experimentId!: number;

    constructor(data?: IPlateInspectionsToScoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.user = _data["user"];
            this.experimentName = _data["experimentName"];
            this.plateNumber = _data["plateNumber"];
            this.experimentId = _data["experimentId"];
        }
    }

    static fromJS(data: any): PlateInspectionsToScoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateInspectionsToScoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["user"] = this.user;
        data["experimentName"] = this.experimentName;
        data["plateNumber"] = this.plateNumber;
        data["experimentId"] = this.experimentId;
        return data;
    }
}

export interface IPlateInspectionsToScoreDTO {
    id: number;
    dateImaged: Date;
    user?: string | undefined;
    experimentName?: string | undefined;
    plateNumber: number;
    experimentId: number;
}

export class Robot implements IRobot {
    id!: number;
    name?: string | undefined;
    robotJson?: string | undefined;
    frapConfigJson?: string | undefined;

    constructor(data?: IRobot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.robotJson = _data["robotJson"];
            this.frapConfigJson = _data["frapConfigJson"];
        }
    }

    static fromJS(data: any): Robot {
        data = typeof data === 'object' ? data : {};
        let result = new Robot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["robotJson"] = this.robotJson;
        data["frapConfigJson"] = this.frapConfigJson;
        return data;
    }
}

export interface IRobot {
    id: number;
    name?: string | undefined;
    robotJson?: string | undefined;
    frapConfigJson?: string | undefined;
}

export class PlateIngredientAndDrawingDTO implements IPlateIngredientAndDrawingDTO {
    ingredients?: PlateIngredientDTO | undefined;
    drawingsIdentifier?: AnnotationsDTO | undefined;
    plateId!: number;

    constructor(data?: IPlateIngredientAndDrawingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredients = _data["ingredients"] ? PlateIngredientDTO.fromJS(_data["ingredients"]) : undefined as any;
            this.drawingsIdentifier = _data["drawingsIdentifier"] ? AnnotationsDTO.fromJS(_data["drawingsIdentifier"]) : undefined as any;
            this.plateId = _data["plateId"];
        }
    }

    static fromJS(data: any): PlateIngredientAndDrawingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateIngredientAndDrawingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredients"] = this.ingredients ? this.ingredients.toJSON() : undefined as any;
        data["drawingsIdentifier"] = this.drawingsIdentifier ? this.drawingsIdentifier.toJSON() : undefined as any;
        data["plateId"] = this.plateId;
        return data;
    }
}

export interface IPlateIngredientAndDrawingDTO {
    ingredients?: PlateIngredientDTO | undefined;
    drawingsIdentifier?: AnnotationsDTO | undefined;
    plateId: number;
}

export class AnnotationsDTO implements IAnnotationsDTO {
    plateScribblesDetail?: PlateScribbleDTO | undefined;
    plateScores?: ScoresOfWellDropsDTO[][] | undefined;
    plateROI?: WellDrawingDetailDTO[] | undefined;
    plateAnnotations?: WellDrawingDetailDTO[] | undefined;
    plateDropRegions?: PlateDropRegions[] | undefined;
    plateHistograms?: HistogramDropRegions[] | undefined;
    plateCrystalIdentifiers?: PlateCrystalIdentifiers[] | undefined;

    constructor(data?: IAnnotationsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateScribblesDetail = _data["plateScribblesDetail"] ? PlateScribbleDTO.fromJS(_data["plateScribblesDetail"]) : undefined as any;
            if (Array.isArray(_data["plateScores"])) {
                this.plateScores = [] as any;
                for (let item of _data["plateScores"])
                    this.plateScores!.push(item);
            }
            if (Array.isArray(_data["plateROI"])) {
                this.plateROI = [] as any;
                for (let item of _data["plateROI"])
                    this.plateROI!.push(WellDrawingDetailDTO.fromJS(item));
            }
            if (Array.isArray(_data["plateAnnotations"])) {
                this.plateAnnotations = [] as any;
                for (let item of _data["plateAnnotations"])
                    this.plateAnnotations!.push(WellDrawingDetailDTO.fromJS(item));
            }
            if (Array.isArray(_data["plateDropRegions"])) {
                this.plateDropRegions = [] as any;
                for (let item of _data["plateDropRegions"])
                    this.plateDropRegions!.push(PlateDropRegions.fromJS(item));
            }
            if (Array.isArray(_data["plateHistograms"])) {
                this.plateHistograms = [] as any;
                for (let item of _data["plateHistograms"])
                    this.plateHistograms!.push(HistogramDropRegions.fromJS(item));
            }
            if (Array.isArray(_data["plateCrystalIdentifiers"])) {
                this.plateCrystalIdentifiers = [] as any;
                for (let item of _data["plateCrystalIdentifiers"])
                    this.plateCrystalIdentifiers!.push(PlateCrystalIdentifiers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnnotationsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AnnotationsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateScribblesDetail"] = this.plateScribblesDetail ? this.plateScribblesDetail.toJSON() : undefined as any;
        if (Array.isArray(this.plateScores)) {
            data["plateScores"] = [];
            for (let item of this.plateScores)
                data["plateScores"].push(item);
        }
        if (Array.isArray(this.plateROI)) {
            data["plateROI"] = [];
            for (let item of this.plateROI)
                data["plateROI"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plateAnnotations)) {
            data["plateAnnotations"] = [];
            for (let item of this.plateAnnotations)
                data["plateAnnotations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plateDropRegions)) {
            data["plateDropRegions"] = [];
            for (let item of this.plateDropRegions)
                data["plateDropRegions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plateHistograms)) {
            data["plateHistograms"] = [];
            for (let item of this.plateHistograms)
                data["plateHistograms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.plateCrystalIdentifiers)) {
            data["plateCrystalIdentifiers"] = [];
            for (let item of this.plateCrystalIdentifiers)
                data["plateCrystalIdentifiers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAnnotationsDTO {
    plateScribblesDetail?: PlateScribbleDTO | undefined;
    plateScores?: ScoresOfWellDropsDTO[][] | undefined;
    plateROI?: WellDrawingDetailDTO[] | undefined;
    plateAnnotations?: WellDrawingDetailDTO[] | undefined;
    plateDropRegions?: PlateDropRegions[] | undefined;
    plateHistograms?: HistogramDropRegions[] | undefined;
    plateCrystalIdentifiers?: PlateCrystalIdentifiers[] | undefined;
}

export class PlateScribbleDTO implements IPlateScribbleDTO {
    plateScribbles?: ScribblesDataDTO[] | undefined;
    wellNumsContainingScribbles?: WellAndDropNumberDTO[] | undefined;

    constructor(data?: IPlateScribbleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plateScribbles"])) {
                this.plateScribbles = [] as any;
                for (let item of _data["plateScribbles"])
                    this.plateScribbles!.push(ScribblesDataDTO.fromJS(item));
            }
            if (Array.isArray(_data["wellNumsContainingScribbles"])) {
                this.wellNumsContainingScribbles = [] as any;
                for (let item of _data["wellNumsContainingScribbles"])
                    this.wellNumsContainingScribbles!.push(WellAndDropNumberDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlateScribbleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateScribbleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plateScribbles)) {
            data["plateScribbles"] = [];
            for (let item of this.plateScribbles)
                data["plateScribbles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellNumsContainingScribbles)) {
            data["wellNumsContainingScribbles"] = [];
            for (let item of this.wellNumsContainingScribbles)
                data["wellNumsContainingScribbles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPlateScribbleDTO {
    plateScribbles?: ScribblesDataDTO[] | undefined;
    wellNumsContainingScribbles?: WellAndDropNumberDTO[] | undefined;
}

export class ScribblesDataDTO implements IScribblesDataDTO {
    scribbleStartPointsXYofWell?: ScribblePointDTO | undefined;
    regionScribblePointsArray?: number[] | undefined;
    xWidthyHeightCaptureResult?: CaptureProfileResultDTO | undefined;

    constructor(data?: IScribblesDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scribbleStartPointsXYofWell = _data["scribbleStartPointsXYofWell"] ? ScribblePointDTO.fromJS(_data["scribbleStartPointsXYofWell"]) : undefined as any;
            if (Array.isArray(_data["regionScribblePointsArray"])) {
                this.regionScribblePointsArray = [] as any;
                for (let item of _data["regionScribblePointsArray"])
                    this.regionScribblePointsArray!.push(item);
            }
            this.xWidthyHeightCaptureResult = _data["xWidthyHeightCaptureResult"] ? CaptureProfileResultDTO.fromJS(_data["xWidthyHeightCaptureResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScribblesDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScribblesDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scribbleStartPointsXYofWell"] = this.scribbleStartPointsXYofWell ? this.scribbleStartPointsXYofWell.toJSON() : undefined as any;
        if (Array.isArray(this.regionScribblePointsArray)) {
            data["regionScribblePointsArray"] = [];
            for (let item of this.regionScribblePointsArray)
                data["regionScribblePointsArray"].push(item);
        }
        data["xWidthyHeightCaptureResult"] = this.xWidthyHeightCaptureResult ? this.xWidthyHeightCaptureResult.toJSON() : undefined as any;
        return data;
    }
}

export interface IScribblesDataDTO {
    scribbleStartPointsXYofWell?: ScribblePointDTO | undefined;
    regionScribblePointsArray?: number[] | undefined;
    xWidthyHeightCaptureResult?: CaptureProfileResultDTO | undefined;
}

export class ScribbleDrawingDTO implements IScribbleDrawingDTO {
    id!: number;
    xOffSet?: number | undefined;
    yOffSet?: number | undefined;
    xWidth?: number | undefined;
    yHeight?: number | undefined;
    text?: string | undefined;
    color!: string;
    drawingType!: number;
    expanded?: boolean | undefined;
    fontStyle?: string | undefined;

    constructor(data?: IScribbleDrawingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.xOffSet = _data["xOffSet"];
            this.yOffSet = _data["yOffSet"];
            this.xWidth = _data["xWidth"];
            this.yHeight = _data["yHeight"];
            this.text = _data["text"];
            this.color = _data["color"];
            this.drawingType = _data["drawingType"];
            this.expanded = _data["expanded"];
            this.fontStyle = _data["fontStyle"];
        }
    }

    static fromJS(data: any): ScribbleDrawingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScribbleDrawingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["xOffSet"] = this.xOffSet;
        data["yOffSet"] = this.yOffSet;
        data["xWidth"] = this.xWidth;
        data["yHeight"] = this.yHeight;
        data["text"] = this.text;
        data["color"] = this.color;
        data["drawingType"] = this.drawingType;
        data["expanded"] = this.expanded;
        data["fontStyle"] = this.fontStyle;
        return data;
    }
}

export interface IScribbleDrawingDTO {
    id: number;
    xOffSet?: number | undefined;
    yOffSet?: number | undefined;
    xWidth?: number | undefined;
    yHeight?: number | undefined;
    text?: string | undefined;
    color: string;
    drawingType: number;
    expanded?: boolean | undefined;
    fontStyle?: string | undefined;
}

export class ScribblePointDTO extends ScribbleDrawingDTO implements IScribblePointDTO {
    regionId!: number;
    wellNumber!: number;
    dropNumber!: number;

    constructor(data?: IScribblePointDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.regionId = _data["regionId"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
        }
    }

    static override fromJS(data: any): ScribblePointDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScribblePointDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IScribblePointDTO extends IScribbleDrawingDTO {
    regionId: number;
    wellNumber: number;
    dropNumber: number;
}

export class CaptureProfileResultDTO implements ICaptureProfileResultDTO {
    xWidth?: number | undefined;
    yHeight?: number | undefined;
    regionId?: number | undefined;
    pixelSize?: number | undefined;
    imageStoreBasePath?: string | undefined;
    captureProfileId!: number;
    imageBatchId!: number;

    constructor(data?: ICaptureProfileResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xWidth = _data["xWidth"];
            this.yHeight = _data["yHeight"];
            this.regionId = _data["regionId"];
            this.pixelSize = _data["pixelSize"];
            this.imageStoreBasePath = _data["imageStoreBasePath"];
            this.captureProfileId = _data["captureProfileId"];
            this.imageBatchId = _data["imageBatchId"];
        }
    }

    static fromJS(data: any): CaptureProfileResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProfileResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xWidth"] = this.xWidth;
        data["yHeight"] = this.yHeight;
        data["regionId"] = this.regionId;
        data["pixelSize"] = this.pixelSize;
        data["imageStoreBasePath"] = this.imageStoreBasePath;
        data["captureProfileId"] = this.captureProfileId;
        data["imageBatchId"] = this.imageBatchId;
        return data;
    }
}

export interface ICaptureProfileResultDTO {
    xWidth?: number | undefined;
    yHeight?: number | undefined;
    regionId?: number | undefined;
    pixelSize?: number | undefined;
    imageStoreBasePath?: string | undefined;
    captureProfileId: number;
    imageBatchId: number;
}

export class WellAndDropNumberDTO implements IWellAndDropNumberDTO {
    wellNum!: number;
    dropNum!: number;

    constructor(data?: IWellAndDropNumberDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellNum = _data["wellNum"];
            this.dropNum = _data["dropNum"];
        }
    }

    static fromJS(data: any): WellAndDropNumberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellAndDropNumberDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellNum"] = this.wellNum;
        data["dropNum"] = this.dropNum;
        return data;
    }
}

export interface IWellAndDropNumberDTO {
    wellNum: number;
    dropNum: number;
}

export class WellDrawingDetailDTO implements IWellDrawingDetailDTO {
    wellNumber!: number;
    dropNumber!: number;

    constructor(data?: IWellDrawingDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
        }
    }

    static fromJS(data: any): WellDrawingDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellDrawingDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        return data;
    }
}

export interface IWellDrawingDetailDTO {
    wellNumber: number;
    dropNumber: number;
}

export class PlateDropRegions implements IPlateDropRegions {
    plateId!: number;
    dropNumber!: number;
    wellNumber!: number;
    regionId!: number;
    regionName?: string | undefined;
    imagingEnabled!: boolean;
    parentRegionId?: number | undefined;
    cpId!: number;

    constructor(data?: IPlateDropRegions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.dropNumber = _data["dropNumber"];
            this.wellNumber = _data["wellNumber"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.imagingEnabled = _data["imagingEnabled"];
            this.parentRegionId = _data["parentRegionId"];
            this.cpId = _data["cpId"];
        }
    }

    static fromJS(data: any): PlateDropRegions {
        data = typeof data === 'object' ? data : {};
        let result = new PlateDropRegions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["dropNumber"] = this.dropNumber;
        data["wellNumber"] = this.wellNumber;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["imagingEnabled"] = this.imagingEnabled;
        data["parentRegionId"] = this.parentRegionId;
        data["cpId"] = this.cpId;
        return data;
    }
}

export interface IPlateDropRegions {
    plateId: number;
    dropNumber: number;
    wellNumber: number;
    regionId: number;
    regionName?: string | undefined;
    imagingEnabled: boolean;
    parentRegionId?: number | undefined;
    cpId: number;
}

export class HistogramDropRegions implements IHistogramDropRegions {
    wellNumber!: number;
    plateId!: number;
    cpId!: number;
    dropNumber!: number;
    regionName?: string | undefined;
    imageBatchId!: number;

    constructor(data?: IHistogramDropRegions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellNumber = _data["wellNumber"];
            this.plateId = _data["plateId"];
            this.cpId = _data["cpId"];
            this.dropNumber = _data["dropNumber"];
            this.regionName = _data["regionName"];
            this.imageBatchId = _data["imageBatchId"];
        }
    }

    static fromJS(data: any): HistogramDropRegions {
        data = typeof data === 'object' ? data : {};
        let result = new HistogramDropRegions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellNumber"] = this.wellNumber;
        data["plateId"] = this.plateId;
        data["cpId"] = this.cpId;
        data["dropNumber"] = this.dropNumber;
        data["regionName"] = this.regionName;
        data["imageBatchId"] = this.imageBatchId;
        return data;
    }
}

export interface IHistogramDropRegions {
    wellNumber: number;
    plateId: number;
    cpId: number;
    dropNumber: number;
    regionName?: string | undefined;
    imageBatchId: number;
}

export class PlateCrystalIdentifiers implements IPlateCrystalIdentifiers {
    plateId!: number;
    dropNumber!: number;
    wellNumber!: number;
    regionId!: number;
    regionName?: string | undefined;
    imageBatchId!: number;
    cpId!: number;

    constructor(data?: IPlateCrystalIdentifiers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.dropNumber = _data["dropNumber"];
            this.wellNumber = _data["wellNumber"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.imageBatchId = _data["imageBatchId"];
            this.cpId = _data["cpId"];
        }
    }

    static fromJS(data: any): PlateCrystalIdentifiers {
        data = typeof data === 'object' ? data : {};
        let result = new PlateCrystalIdentifiers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["dropNumber"] = this.dropNumber;
        data["wellNumber"] = this.wellNumber;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["imageBatchId"] = this.imageBatchId;
        data["cpId"] = this.cpId;
        return data;
    }
}

export interface IPlateCrystalIdentifiers {
    plateId: number;
    dropNumber: number;
    wellNumber: number;
    regionId: number;
    regionName?: string | undefined;
    imageBatchId: number;
    cpId: number;
}

export class PlateIngredientAndDrawingRequestDTO implements IPlateIngredientAndDrawingRequestDTO {
    plateIDs?: number[] | undefined;
    regionName?: string | undefined;
    cpID!: number;

    constructor(data?: IPlateIngredientAndDrawingRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plateIDs"])) {
                this.plateIDs = [] as any;
                for (let item of _data["plateIDs"])
                    this.plateIDs!.push(item);
            }
            this.regionName = _data["regionName"];
            this.cpID = _data["cpID"];
        }
    }

    static fromJS(data: any): PlateIngredientAndDrawingRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateIngredientAndDrawingRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plateIDs)) {
            data["plateIDs"] = [];
            for (let item of this.plateIDs)
                data["plateIDs"].push(item);
        }
        data["regionName"] = this.regionName;
        data["cpID"] = this.cpID;
        return data;
    }
}

export interface IPlateIngredientAndDrawingRequestDTO {
    plateIDs?: number[] | undefined;
    regionName?: string | undefined;
    cpID: number;
}

export class SeedNodeInfoDTO implements ISeedNodeInfoDTO {
    id!: number;
    ownerName?: string | undefined;
    expName?: string | undefined;
    wellPlace?: string | undefined;
    useWellSolution?: string | undefined;
    dateCreated?: string | undefined;
    stabalizingIngredients?: StabalizingIngredientsDTO[] | undefined;

    constructor(data?: ISeedNodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerName = _data["ownerName"];
            this.expName = _data["expName"];
            this.wellPlace = _data["wellPlace"];
            this.useWellSolution = _data["useWellSolution"];
            this.dateCreated = _data["dateCreated"];
            if (Array.isArray(_data["stabalizingIngredients"])) {
                this.stabalizingIngredients = [] as any;
                for (let item of _data["stabalizingIngredients"])
                    this.stabalizingIngredients!.push(StabalizingIngredientsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeedNodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeedNodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerName"] = this.ownerName;
        data["expName"] = this.expName;
        data["wellPlace"] = this.wellPlace;
        data["useWellSolution"] = this.useWellSolution;
        data["dateCreated"] = this.dateCreated;
        if (Array.isArray(this.stabalizingIngredients)) {
            data["stabalizingIngredients"] = [];
            for (let item of this.stabalizingIngredients)
                data["stabalizingIngredients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISeedNodeInfoDTO {
    id: number;
    ownerName?: string | undefined;
    expName?: string | undefined;
    wellPlace?: string | undefined;
    useWellSolution?: string | undefined;
    dateCreated?: string | undefined;
    stabalizingIngredients?: StabalizingIngredientsDTO[] | undefined;
}

export class StabalizingIngredientsDTO implements IStabalizingIngredientsDTO {
    type?: string | undefined;
    name?: string | undefined;
    concentration!: number;
    concentrationUnit?: string | undefined;

    constructor(data?: IStabalizingIngredientsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.concentration = _data["concentration"];
            this.concentrationUnit = _data["concentrationUnit"];
        }
    }

    static fromJS(data: any): StabalizingIngredientsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StabalizingIngredientsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["concentration"] = this.concentration;
        data["concentrationUnit"] = this.concentrationUnit;
        return data;
    }
}

export interface IStabalizingIngredientsDTO {
    type?: string | undefined;
    name?: string | undefined;
    concentration: number;
    concentrationUnit?: string | undefined;
}

export class LiquidClassDTO implements ILiquidClassDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: ILiquidClassDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LiquidClassDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LiquidClassDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILiquidClassDTO {
    id: number;
    name?: string | undefined;
}

export class ProteinFormulationIngredientTypeDTO implements IProteinFormulationIngredientTypeDTO {
    id!: number;
    name?: string | undefined;
    ingTypeState!: PFStateDTO;

    constructor(data?: IProteinFormulationIngredientTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ingTypeState = _data["ingTypeState"];
        }
    }

    static fromJS(data: any): ProteinFormulationIngredientTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationIngredientTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ingTypeState"] = this.ingTypeState;
        return data;
    }
}

export interface IProteinFormulationIngredientTypeDTO {
    id: number;
    name?: string | undefined;
    ingTypeState: PFStateDTO;
}

export class IngredientTypeModalDTO implements IIngredientTypeModalDTO {
    ingredientTypes?: IngredientTypeDTO[] | undefined;
    deletedIngTypes?: IngredientTypeDTO[] | undefined;

    constructor(data?: IIngredientTypeModalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ingredientTypes"])) {
                this.ingredientTypes = [] as any;
                for (let item of _data["ingredientTypes"])
                    this.ingredientTypes!.push(IngredientTypeDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedIngTypes"])) {
                this.deletedIngTypes = [] as any;
                for (let item of _data["deletedIngTypes"])
                    this.deletedIngTypes!.push(IngredientTypeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IngredientTypeModalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTypeModalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ingredientTypes)) {
            data["ingredientTypes"] = [];
            for (let item of this.ingredientTypes)
                data["ingredientTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedIngTypes)) {
            data["deletedIngTypes"] = [];
            for (let item of this.deletedIngTypes)
                data["deletedIngTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIngredientTypeModalDTO {
    ingredientTypes?: IngredientTypeDTO[] | undefined;
    deletedIngTypes?: IngredientTypeDTO[] | undefined;
}

export class IngredientDocumentDTO implements IIngredientDocumentDTO {
    info?: IngredientDocInfo | undefined;
    bufferDataPoint?: IngredientDocBufferDataPoint[] | undefined;
    casnumbers?: IngredientDocCasNumberDTO[] | undefined;
    aliases?: IngredientDocAliasDTO[] | undefined;
    types?: IngredientTypeDTO[] | undefined;
    stocks?: IngredientDocStockDTO[] | undefined;

    constructor(data?: IIngredientDocumentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] ? IngredientDocInfo.fromJS(_data["info"]) : undefined as any;
            if (Array.isArray(_data["bufferDataPoint"])) {
                this.bufferDataPoint = [] as any;
                for (let item of _data["bufferDataPoint"])
                    this.bufferDataPoint!.push(IngredientDocBufferDataPoint.fromJS(item));
            }
            if (Array.isArray(_data["casnumbers"])) {
                this.casnumbers = [] as any;
                for (let item of _data["casnumbers"])
                    this.casnumbers!.push(IngredientDocCasNumberDTO.fromJS(item));
            }
            if (Array.isArray(_data["aliases"])) {
                this.aliases = [] as any;
                for (let item of _data["aliases"])
                    this.aliases!.push(IngredientDocAliasDTO.fromJS(item));
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(IngredientTypeDTO.fromJS(item));
            }
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks!.push(IngredientDocStockDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IngredientDocumentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDocumentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info ? this.info.toJSON() : undefined as any;
        if (Array.isArray(this.bufferDataPoint)) {
            data["bufferDataPoint"] = [];
            for (let item of this.bufferDataPoint)
                data["bufferDataPoint"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.casnumbers)) {
            data["casnumbers"] = [];
            for (let item of this.casnumbers)
                data["casnumbers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aliases)) {
            data["aliases"] = [];
            for (let item of this.aliases)
                data["aliases"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIngredientDocumentDTO {
    info?: IngredientDocInfo | undefined;
    bufferDataPoint?: IngredientDocBufferDataPoint[] | undefined;
    casnumbers?: IngredientDocCasNumberDTO[] | undefined;
    aliases?: IngredientDocAliasDTO[] | undefined;
    types?: IngredientTypeDTO[] | undefined;
    stocks?: IngredientDocStockDTO[] | undefined;
}

export class IngredientDocInfo implements IIngredientDocInfo {
    id!: number;
    longName?: string | undefined;
    shortName?: string | undefined;
    defaultNonBufferIngredientStockId?: number | undefined;
    defaultBufferIngredientStockId?: number | undefined;
    bufferCalculationTypeId?: number | undefined;
    pKa?: number | undefined;
    maxStockNumber!: number;
    state!: State;
    isUsed!: boolean;

    constructor(data?: IIngredientDocInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.longName = _data["longName"];
            this.shortName = _data["shortName"];
            this.defaultNonBufferIngredientStockId = _data["defaultNonBufferIngredientStockId"];
            this.defaultBufferIngredientStockId = _data["defaultBufferIngredientStockId"];
            this.bufferCalculationTypeId = _data["bufferCalculationTypeId"];
            this.pKa = _data["pKa"];
            this.maxStockNumber = _data["maxStockNumber"];
            this.state = _data["state"];
            this.isUsed = _data["isUsed"];
        }
    }

    static fromJS(data: any): IngredientDocInfo {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDocInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["longName"] = this.longName;
        data["shortName"] = this.shortName;
        data["defaultNonBufferIngredientStockId"] = this.defaultNonBufferIngredientStockId;
        data["defaultBufferIngredientStockId"] = this.defaultBufferIngredientStockId;
        data["bufferCalculationTypeId"] = this.bufferCalculationTypeId;
        data["pKa"] = this.pKa;
        data["maxStockNumber"] = this.maxStockNumber;
        data["state"] = this.state;
        data["isUsed"] = this.isUsed;
        return data;
    }
}

export interface IIngredientDocInfo {
    id: number;
    longName?: string | undefined;
    shortName?: string | undefined;
    defaultNonBufferIngredientStockId?: number | undefined;
    defaultBufferIngredientStockId?: number | undefined;
    bufferCalculationTypeId?: number | undefined;
    pKa?: number | undefined;
    maxStockNumber: number;
    state: State;
    isUsed: boolean;
}

export class IngredientDocBufferDataPoint extends BufferDataPointDTO implements IIngredientDocBufferDataPoint {
    state!: State;

    constructor(data?: IIngredientDocBufferDataPoint) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.state = _data["state"];
        }
    }

    static override fromJS(data: any): IngredientDocBufferDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDocBufferDataPoint();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface IIngredientDocBufferDataPoint extends IBufferDataPointDTO {
    state: State;
}

export class IngredientDocCasNumberDTO extends CasNumberDTO implements IIngredientDocCasNumberDTO {
    state!: State;

    constructor(data?: IIngredientDocCasNumberDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.state = _data["state"];
        }
    }

    static override fromJS(data: any): IngredientDocCasNumberDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDocCasNumberDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface IIngredientDocCasNumberDTO extends ICasNumberDTO {
    state: State;
}

export class IngredientDocAliasDTO extends IngredientAliasDTO implements IIngredientDocAliasDTO {
    state!: State;

    constructor(data?: IIngredientDocAliasDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.state = _data["state"];
        }
    }

    static override fromJS(data: any): IngredientDocAliasDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDocAliasDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface IIngredientDocAliasDTO extends IIngredientAliasDTO {
    state: State;
}

export class IngredientDocStockDTO extends IngredientStockDTO implements IIngredientDocStockDTO {
    state!: State;
    isUsed!: boolean;

    constructor(data?: IIngredientDocStockDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.state = _data["state"];
            this.isUsed = _data["isUsed"];
        }
    }

    static override fromJS(data: any): IngredientDocStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDocStockDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["isUsed"] = this.isUsed;
        super.toJSON(data);
        return data;
    }
}

export interface IIngredientDocStockDTO extends IIngredientStockDTO {
    state: State;
    isUsed: boolean;
}

export class IngredientTableRow implements IIngredientTableRow {
    concUnit?: string | undefined;
    defaultBufferIngredientStockId?: number | undefined;
    defaultNonBufferIngredientStockId?: number | undefined;
    defaultStockNumber?: number | undefined;
    highConc?: string | undefined;
    id!: number;
    isBuffer!: boolean;
    liquidClassName?: string | undefined;
    liquidClassId?: number | undefined;
    lowConc?: number | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    stockConc?: string | undefined;
    stockId?: number | undefined;
    stockMaxPh?: number | undefined;
    stockMinPh?: number | undefined;
    type?: string | undefined;

    constructor(data?: IIngredientTableRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.concUnit = _data["concUnit"];
            this.defaultBufferIngredientStockId = _data["defaultBufferIngredientStockId"];
            this.defaultNonBufferIngredientStockId = _data["defaultNonBufferIngredientStockId"];
            this.defaultStockNumber = _data["defaultStockNumber"];
            this.highConc = _data["highConc"];
            this.id = _data["id"];
            this.isBuffer = _data["isBuffer"];
            this.liquidClassName = _data["liquidClassName"];
            this.liquidClassId = _data["liquidClassId"];
            this.lowConc = _data["lowConc"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.stockConc = _data["stockConc"];
            this.stockId = _data["stockId"];
            this.stockMaxPh = _data["stockMaxPh"];
            this.stockMinPh = _data["stockMinPh"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): IngredientTableRow {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientTableRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["concUnit"] = this.concUnit;
        data["defaultBufferIngredientStockId"] = this.defaultBufferIngredientStockId;
        data["defaultNonBufferIngredientStockId"] = this.defaultNonBufferIngredientStockId;
        data["defaultStockNumber"] = this.defaultStockNumber;
        data["highConc"] = this.highConc;
        data["id"] = this.id;
        data["isBuffer"] = this.isBuffer;
        data["liquidClassName"] = this.liquidClassName;
        data["liquidClassId"] = this.liquidClassId;
        data["lowConc"] = this.lowConc;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["stockConc"] = this.stockConc;
        data["stockId"] = this.stockId;
        data["stockMaxPh"] = this.stockMaxPh;
        data["stockMinPh"] = this.stockMinPh;
        data["type"] = this.type;
        return data;
    }
}

export interface IIngredientTableRow {
    concUnit?: string | undefined;
    defaultBufferIngredientStockId?: number | undefined;
    defaultNonBufferIngredientStockId?: number | undefined;
    defaultStockNumber?: number | undefined;
    highConc?: string | undefined;
    id: number;
    isBuffer: boolean;
    liquidClassName?: string | undefined;
    liquidClassId?: number | undefined;
    lowConc?: number | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    stockConc?: string | undefined;
    stockId?: number | undefined;
    stockMaxPh?: number | undefined;
    stockMinPh?: number | undefined;
    type?: string | undefined;
}

export class MergeIngredientDTO implements IMergeIngredientDTO {
    excludedIngredientId!: number;
    ingredient?: ExtendedIngredientDTO | undefined;
    isStockAlreadyMatched!: boolean;
    excludedStockIds?: number[] | undefined;
    mergedAndDeletedStockIds?: { [key: string]: number; } | undefined;

    constructor(data?: IMergeIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.excludedIngredientId = _data["excludedIngredientId"];
            this.ingredient = _data["ingredient"] ? ExtendedIngredientDTO.fromJS(_data["ingredient"]) : undefined as any;
            this.isStockAlreadyMatched = _data["isStockAlreadyMatched"];
            if (Array.isArray(_data["excludedStockIds"])) {
                this.excludedStockIds = [] as any;
                for (let item of _data["excludedStockIds"])
                    this.excludedStockIds!.push(item);
            }
            if (_data["mergedAndDeletedStockIds"]) {
                this.mergedAndDeletedStockIds = {} as any;
                for (let key in _data["mergedAndDeletedStockIds"]) {
                    if (_data["mergedAndDeletedStockIds"].hasOwnProperty(key))
                        (this.mergedAndDeletedStockIds as any)![key] = _data["mergedAndDeletedStockIds"][key];
                }
            }
        }
    }

    static fromJS(data: any): MergeIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MergeIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["excludedIngredientId"] = this.excludedIngredientId;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        data["isStockAlreadyMatched"] = this.isStockAlreadyMatched;
        if (Array.isArray(this.excludedStockIds)) {
            data["excludedStockIds"] = [];
            for (let item of this.excludedStockIds)
                data["excludedStockIds"].push(item);
        }
        if (this.mergedAndDeletedStockIds) {
            data["mergedAndDeletedStockIds"] = {};
            for (let key in this.mergedAndDeletedStockIds) {
                if (this.mergedAndDeletedStockIds.hasOwnProperty(key))
                    (data["mergedAndDeletedStockIds"] as any)[key] = (this.mergedAndDeletedStockIds as any)[key];
            }
        }
        return data;
    }
}

export interface IMergeIngredientDTO {
    excludedIngredientId: number;
    ingredient?: ExtendedIngredientDTO | undefined;
    isStockAlreadyMatched: boolean;
    excludedStockIds?: number[] | undefined;
    mergedAndDeletedStockIds?: { [key: string]: number; } | undefined;
}

export class ResponseWithValueDTOOfInteger extends ResponseDTO implements IResponseWithValueDTOOfInteger {
    value!: number;

    constructor(data?: IResponseWithValueDTOOfInteger) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfInteger();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfInteger extends IResponseDTO {
    value: number;
}

export class SaveIngredientDocDTO implements ISaveIngredientDocDTO {
    ingredient?: IngredientDocumentDTO | undefined;
    deletedData?: IngredientDocDeletedData | undefined;
    mergedAndDeletedStockIds?: { [key: string]: number; } | undefined;

    constructor(data?: ISaveIngredientDocDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredient = _data["ingredient"] ? IngredientDocumentDTO.fromJS(_data["ingredient"]) : undefined as any;
            this.deletedData = _data["deletedData"] ? IngredientDocDeletedData.fromJS(_data["deletedData"]) : undefined as any;
            if (_data["mergedAndDeletedStockIds"]) {
                this.mergedAndDeletedStockIds = {} as any;
                for (let key in _data["mergedAndDeletedStockIds"]) {
                    if (_data["mergedAndDeletedStockIds"].hasOwnProperty(key))
                        (this.mergedAndDeletedStockIds as any)![key] = _data["mergedAndDeletedStockIds"][key];
                }
            }
        }
    }

    static fromJS(data: any): SaveIngredientDocDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveIngredientDocDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : undefined as any;
        data["deletedData"] = this.deletedData ? this.deletedData.toJSON() : undefined as any;
        if (this.mergedAndDeletedStockIds) {
            data["mergedAndDeletedStockIds"] = {};
            for (let key in this.mergedAndDeletedStockIds) {
                if (this.mergedAndDeletedStockIds.hasOwnProperty(key))
                    (data["mergedAndDeletedStockIds"] as any)[key] = (this.mergedAndDeletedStockIds as any)[key];
            }
        }
        return data;
    }
}

export interface ISaveIngredientDocDTO {
    ingredient?: IngredientDocumentDTO | undefined;
    deletedData?: IngredientDocDeletedData | undefined;
    mergedAndDeletedStockIds?: { [key: string]: number; } | undefined;
}

export class IngredientDocDeletedData implements IIngredientDocDeletedData {
    types?: number[] | undefined;
    aliases?: number[] | undefined;
    casNumbers?: number[] | undefined;
    stocks?: number[] | undefined;
    bufferDataPoints?: number[] | undefined;

    constructor(data?: IIngredientDocDeletedData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            if (Array.isArray(_data["aliases"])) {
                this.aliases = [] as any;
                for (let item of _data["aliases"])
                    this.aliases!.push(item);
            }
            if (Array.isArray(_data["casNumbers"])) {
                this.casNumbers = [] as any;
                for (let item of _data["casNumbers"])
                    this.casNumbers!.push(item);
            }
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks!.push(item);
            }
            if (Array.isArray(_data["bufferDataPoints"])) {
                this.bufferDataPoints = [] as any;
                for (let item of _data["bufferDataPoints"])
                    this.bufferDataPoints!.push(item);
            }
        }
    }

    static fromJS(data: any): IngredientDocDeletedData {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDocDeletedData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        if (Array.isArray(this.aliases)) {
            data["aliases"] = [];
            for (let item of this.aliases)
                data["aliases"].push(item);
        }
        if (Array.isArray(this.casNumbers)) {
            data["casNumbers"] = [];
            for (let item of this.casNumbers)
                data["casNumbers"].push(item);
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item);
        }
        if (Array.isArray(this.bufferDataPoints)) {
            data["bufferDataPoints"] = [];
            for (let item of this.bufferDataPoints)
                data["bufferDataPoints"].push(item);
        }
        return data;
    }
}

export interface IIngredientDocDeletedData {
    types?: number[] | undefined;
    aliases?: number[] | undefined;
    casNumbers?: number[] | undefined;
    stocks?: number[] | undefined;
    bufferDataPoints?: number[] | undefined;
}

export class DeleteIngredientResponse implements IDeleteIngredientResponse {
    allIngsDeleted!: boolean;
    isIngredientTableUpdateRequired!: boolean;

    constructor(data?: IDeleteIngredientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allIngsDeleted = _data["allIngsDeleted"];
            this.isIngredientTableUpdateRequired = _data["isIngredientTableUpdateRequired"];
        }
    }

    static fromJS(data: any): DeleteIngredientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteIngredientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allIngsDeleted"] = this.allIngsDeleted;
        data["isIngredientTableUpdateRequired"] = this.isIngredientTableUpdateRequired;
        return data;
    }
}

export interface IDeleteIngredientResponse {
    allIngsDeleted: boolean;
    isIngredientTableUpdateRequired: boolean;
}

export class NavigatorMapDTO implements INavigatorMapDTO {
    profileList?: ProfileDTO[] | undefined;
    inspectionSetList?: InspectionSetDTO[] | undefined;
    drciList?: DRCIDTO[] | undefined;

    constructor(data?: INavigatorMapDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profileList"])) {
                this.profileList = [] as any;
                for (let item of _data["profileList"])
                    this.profileList!.push(ProfileDTO.fromJS(item));
            }
            if (Array.isArray(_data["inspectionSetList"])) {
                this.inspectionSetList = [] as any;
                for (let item of _data["inspectionSetList"])
                    this.inspectionSetList!.push(InspectionSetDTO.fromJS(item));
            }
            if (Array.isArray(_data["drciList"])) {
                this.drciList = [] as any;
                for (let item of _data["drciList"])
                    this.drciList!.push(DRCIDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NavigatorMapDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NavigatorMapDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profileList)) {
            data["profileList"] = [];
            for (let item of this.profileList)
                data["profileList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionSetList)) {
            data["inspectionSetList"] = [];
            for (let item of this.inspectionSetList)
                data["inspectionSetList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.drciList)) {
            data["drciList"] = [];
            for (let item of this.drciList)
                data["drciList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INavigatorMapDTO {
    profileList?: ProfileDTO[] | undefined;
    inspectionSetList?: InspectionSetDTO[] | undefined;
    drciList?: DRCIDTO[] | undefined;
}

export class DRCIDTO implements IDRCIDTO {
    drc?: DRCDTO | undefined;
    inspectedWells?: InspectedWellDTO[] | undefined;

    constructor(data?: IDRCIDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.drc = _data["drc"] ? DRCDTO.fromJS(_data["drc"]) : undefined as any;
            if (Array.isArray(_data["inspectedWells"])) {
                this.inspectedWells = [] as any;
                for (let item of _data["inspectedWells"])
                    this.inspectedWells!.push(InspectedWellDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DRCIDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DRCIDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["drc"] = this.drc ? this.drc.toJSON() : undefined as any;
        if (Array.isArray(this.inspectedWells)) {
            data["inspectedWells"] = [];
            for (let item of this.inspectedWells)
                data["inspectedWells"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDRCIDTO {
    drc?: DRCDTO | undefined;
    inspectedWells?: InspectedWellDTO[] | undefined;
}

export class DRCDTO implements IDRCDTO {
    id!: number;
    dropNumber!: number;
    regionName?: string | undefined;
    cpId?: number | undefined;

    constructor(data?: IDRCDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dropNumber = _data["dropNumber"];
            this.regionName = _data["regionName"];
            this.cpId = _data["cpId"];
        }
    }

    static fromJS(data: any): DRCDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DRCDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dropNumber"] = this.dropNumber;
        data["regionName"] = this.regionName;
        data["cpId"] = this.cpId;
        return data;
    }
}

export interface IDRCDTO {
    id: number;
    dropNumber: number;
    regionName?: string | undefined;
    cpId?: number | undefined;
}

export class InspectedWellDTO implements IInspectedWellDTO {
    inspectionId!: number;
    wells?: PlateWellDTO[] | undefined;

    constructor(data?: IInspectedWellDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionId = _data["inspectionId"];
            if (Array.isArray(_data["wells"])) {
                this.wells = [] as any;
                for (let item of _data["wells"])
                    this.wells!.push(PlateWellDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InspectedWellDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InspectedWellDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        if (Array.isArray(this.wells)) {
            data["wells"] = [];
            for (let item of this.wells)
                data["wells"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInspectedWellDTO {
    inspectionId: number;
    wells?: PlateWellDTO[] | undefined;
}

export class PlateWellDTO implements IPlateWellDTO {
    plateId!: number;
    wellNumber!: number;

    constructor(data?: IPlateWellDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.wellNumber = _data["wellNumber"];
        }
    }

    static fromJS(data: any): PlateWellDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateWellDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["wellNumber"] = this.wellNumber;
        return data;
    }
}

export interface IPlateWellDTO {
    plateId: number;
    wellNumber: number;
}

export class BaseNavigatorInspectionDTO implements IBaseNavigatorInspectionDTO {
    image?: string | undefined;
    imageName?: string | undefined;
    dateImaged?: string | undefined;
    name?: string | undefined;

    constructor(data?: IBaseNavigatorInspectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.imageName = _data["imageName"];
            this.dateImaged = _data["dateImaged"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BaseNavigatorInspectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseNavigatorInspectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["imageName"] = this.imageName;
        data["dateImaged"] = this.dateImaged;
        data["name"] = this.name;
        return data;
    }
}

export interface IBaseNavigatorInspectionDTO {
    image?: string | undefined;
    imageName?: string | undefined;
    dateImaged?: string | undefined;
    name?: string | undefined;
}

export class NavigatorInspectionDTO extends BaseNavigatorInspectionDTO implements INavigatorInspectionDTO {
    batchId!: number;

    constructor(data?: INavigatorInspectionDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.batchId = _data["batchId"];
        }
    }

    static override fromJS(data: any): NavigatorInspectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NavigatorInspectionDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        super.toJSON(data);
        return data;
    }
}

export interface INavigatorInspectionDTO extends IBaseNavigatorInspectionDTO {
    batchId: number;
}

export class NavigatorRegionImageSettingInspectionDTO extends BaseNavigatorInspectionDTO implements INavigatorRegionImageSettingInspectionDTO {
    cpId!: number;

    constructor(data?: INavigatorRegionImageSettingInspectionDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cpId = _data["cpId"];
        }
    }

    static override fromJS(data: any): NavigatorRegionImageSettingInspectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NavigatorRegionImageSettingInspectionDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpId"] = this.cpId;
        super.toJSON(data);
        return data;
    }
}

export interface INavigatorRegionImageSettingInspectionDTO extends IBaseNavigatorInspectionDTO {
    cpId: number;
}

export class NavigatorDropInspectionDTO extends NavigatorRegionImageSettingInspectionDTO implements INavigatorDropInspectionDTO {
    dropNumber!: number;

    constructor(data?: INavigatorDropInspectionDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dropNumber = _data["dropNumber"];
        }
    }

    static override fromJS(data: any): NavigatorDropInspectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NavigatorDropInspectionDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dropNumber"] = this.dropNumber;
        super.toJSON(data);
        return data;
    }
}

export interface INavigatorDropInspectionDTO extends INavigatorRegionImageSettingInspectionDTO {
    dropNumber: number;
}

export class InspectionSetGroupDTO implements IInspectionSetGroupDTO {
    id!: number;
    experimentPlateId!: number;
    imageBatchId!: number;
    plateId!: number;
    name?: string | undefined;

    constructor(data?: IInspectionSetGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.experimentPlateId = _data["experimentPlateId"];
            this.imageBatchId = _data["imageBatchId"];
            this.plateId = _data["plateId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InspectionSetGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionSetGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["experimentPlateId"] = this.experimentPlateId;
        data["imageBatchId"] = this.imageBatchId;
        data["plateId"] = this.plateId;
        data["name"] = this.name;
        return data;
    }
}

export interface IInspectionSetGroupDTO {
    id: number;
    experimentPlateId: number;
    imageBatchId: number;
    plateId: number;
    name?: string | undefined;
}

export class NavigatorImagesResponseDTO implements INavigatorImagesResponseDTO {
    navigatorInspections?: NavigatorInspectionDTO[] | undefined;
    navigatorImagingSettings?: NavigatorRegionImageSettingInspectionDTO[] | undefined;
    navigatorRegions?: NavigatorRegionImageSettingInspectionDTO[] | undefined;
    navigatorDrop?: NavigatorDropInspectionDTO[] | undefined;

    constructor(data?: INavigatorImagesResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["navigatorInspections"])) {
                this.navigatorInspections = [] as any;
                for (let item of _data["navigatorInspections"])
                    this.navigatorInspections!.push(NavigatorInspectionDTO.fromJS(item));
            }
            if (Array.isArray(_data["navigatorImagingSettings"])) {
                this.navigatorImagingSettings = [] as any;
                for (let item of _data["navigatorImagingSettings"])
                    this.navigatorImagingSettings!.push(NavigatorRegionImageSettingInspectionDTO.fromJS(item));
            }
            if (Array.isArray(_data["navigatorRegions"])) {
                this.navigatorRegions = [] as any;
                for (let item of _data["navigatorRegions"])
                    this.navigatorRegions!.push(NavigatorRegionImageSettingInspectionDTO.fromJS(item));
            }
            if (Array.isArray(_data["navigatorDrop"])) {
                this.navigatorDrop = [] as any;
                for (let item of _data["navigatorDrop"])
                    this.navigatorDrop!.push(NavigatorDropInspectionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NavigatorImagesResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NavigatorImagesResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.navigatorInspections)) {
            data["navigatorInspections"] = [];
            for (let item of this.navigatorInspections)
                data["navigatorInspections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.navigatorImagingSettings)) {
            data["navigatorImagingSettings"] = [];
            for (let item of this.navigatorImagingSettings)
                data["navigatorImagingSettings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.navigatorRegions)) {
            data["navigatorRegions"] = [];
            for (let item of this.navigatorRegions)
                data["navigatorRegions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.navigatorDrop)) {
            data["navigatorDrop"] = [];
            for (let item of this.navigatorDrop)
                data["navigatorDrop"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INavigatorImagesResponseDTO {
    navigatorInspections?: NavigatorInspectionDTO[] | undefined;
    navigatorImagingSettings?: NavigatorRegionImageSettingInspectionDTO[] | undefined;
    navigatorRegions?: NavigatorRegionImageSettingInspectionDTO[] | undefined;
    navigatorDrop?: NavigatorDropInspectionDTO[] | undefined;
}

export class LicenseRequestInfo implements ILicenseRequestInfo {
    subject?: string | undefined;
    mailTo?: string | undefined;
    licenseRequest?: string | undefined;

    constructor(data?: ILicenseRequestInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.mailTo = _data["mailTo"];
            this.licenseRequest = _data["licenseRequest"];
        }
    }

    static fromJS(data: any): LicenseRequestInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseRequestInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["mailTo"] = this.mailTo;
        data["licenseRequest"] = this.licenseRequest;
        return data;
    }
}

export interface ILicenseRequestInfo {
    subject?: string | undefined;
    mailTo?: string | undefined;
    licenseRequest?: string | undefined;
}

export class LicenseDetailDTO implements ILicenseDetailDTO {
    licenseIndex!: number;
    licensedToName?: string | undefined;
    licensedToEmail?: string | undefined;
    clientId?: string | undefined;
    expiryDate?: string | undefined;
    licType?: string | undefined;
    licProduct?: LicensedProduct | undefined;
    licFeatures?: string[] | undefined;
    seats?: SeatDTO[] | undefined;
    concurrentSessionList?: ConcurrentSessionDTO[] | undefined;
    isActive!: boolean;
    maxSessionsAllowed!: number;
    title?: string | undefined;
    isAutoCheckUpdateEnabled!: boolean;
    edition?: string | undefined;

    constructor(data?: ILicenseDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseIndex = _data["licenseIndex"];
            this.licensedToName = _data["licensedToName"];
            this.licensedToEmail = _data["licensedToEmail"];
            this.clientId = _data["clientId"];
            this.expiryDate = _data["expiryDate"];
            this.licType = _data["licType"];
            this.licProduct = _data["licProduct"] ? LicensedProduct.fromJS(_data["licProduct"]) : undefined as any;
            if (Array.isArray(_data["licFeatures"])) {
                this.licFeatures = [] as any;
                for (let item of _data["licFeatures"])
                    this.licFeatures!.push(item);
            }
            if (Array.isArray(_data["seats"])) {
                this.seats = [] as any;
                for (let item of _data["seats"])
                    this.seats!.push(SeatDTO.fromJS(item));
            }
            if (Array.isArray(_data["concurrentSessionList"])) {
                this.concurrentSessionList = [] as any;
                for (let item of _data["concurrentSessionList"])
                    this.concurrentSessionList!.push(ConcurrentSessionDTO.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.maxSessionsAllowed = _data["maxSessionsAllowed"];
            this.title = _data["title"];
            this.isAutoCheckUpdateEnabled = _data["isAutoCheckUpdateEnabled"];
            this.edition = _data["edition"];
        }
    }

    static fromJS(data: any): LicenseDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseIndex"] = this.licenseIndex;
        data["licensedToName"] = this.licensedToName;
        data["licensedToEmail"] = this.licensedToEmail;
        data["clientId"] = this.clientId;
        data["expiryDate"] = this.expiryDate;
        data["licType"] = this.licType;
        data["licProduct"] = this.licProduct ? this.licProduct.toJSON() : undefined as any;
        if (Array.isArray(this.licFeatures)) {
            data["licFeatures"] = [];
            for (let item of this.licFeatures)
                data["licFeatures"].push(item);
        }
        if (Array.isArray(this.seats)) {
            data["seats"] = [];
            for (let item of this.seats)
                data["seats"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.concurrentSessionList)) {
            data["concurrentSessionList"] = [];
            for (let item of this.concurrentSessionList)
                data["concurrentSessionList"].push(item ? item.toJSON() : undefined as any);
        }
        data["isActive"] = this.isActive;
        data["maxSessionsAllowed"] = this.maxSessionsAllowed;
        data["title"] = this.title;
        data["isAutoCheckUpdateEnabled"] = this.isAutoCheckUpdateEnabled;
        data["edition"] = this.edition;
        return data;
    }
}

export interface ILicenseDetailDTO {
    licenseIndex: number;
    licensedToName?: string | undefined;
    licensedToEmail?: string | undefined;
    clientId?: string | undefined;
    expiryDate?: string | undefined;
    licType?: string | undefined;
    licProduct?: LicensedProduct | undefined;
    licFeatures?: string[] | undefined;
    seats?: SeatDTO[] | undefined;
    concurrentSessionList?: ConcurrentSessionDTO[] | undefined;
    isActive: boolean;
    maxSessionsAllowed: number;
    title?: string | undefined;
    isAutoCheckUpdateEnabled: boolean;
    edition?: string | undefined;
}

export class Product implements IProduct {
    name?: string | undefined;
    buildDate?: string | undefined;
    uniqueIdentifier?: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.buildDate = _data["buildDate"];
            this.uniqueIdentifier = _data["uniqueIdentifier"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["buildDate"] = this.buildDate;
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        return data;
    }
}

export interface IProduct {
    name?: string | undefined;
    buildDate?: string | undefined;
    uniqueIdentifier?: string | undefined;
}

export class LicensedProduct extends Product implements ILicensedProduct {
    expiry!: Date;
    edition?: string | undefined;
    title?: string | undefined;

    constructor(data?: ILicensedProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.expiry = _data["expiry"] ? new Date(_data["expiry"].toString()) : undefined as any;
            this.edition = _data["edition"];
            this.title = _data["title"];
        }
    }

    static override fromJS(data: any): LicensedProduct {
        data = typeof data === 'object' ? data : {};
        let result = new LicensedProduct();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiry"] = this.expiry ? this.expiry.toISOString() : undefined as any;
        data["edition"] = this.edition;
        data["title"] = this.title;
        super.toJSON(data);
        return data;
    }
}

export interface ILicensedProduct extends IProduct {
    expiry: Date;
    edition?: string | undefined;
    title?: string | undefined;
}

export class SeatDTO implements ISeatDTO {
    computerName?: string | undefined;
    userComputerName?: string | undefined;
    uniqueIdentifier?: string | undefined;
    isRegistered!: boolean;
    lastRegistered!: Date;

    constructor(data?: ISeatDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.computerName = _data["computerName"];
            this.userComputerName = _data["userComputerName"];
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.isRegistered = _data["isRegistered"];
            this.lastRegistered = _data["lastRegistered"] ? new Date(_data["lastRegistered"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SeatDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeatDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["computerName"] = this.computerName;
        data["userComputerName"] = this.userComputerName;
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["isRegistered"] = this.isRegistered;
        data["lastRegistered"] = this.lastRegistered ? this.lastRegistered.toISOString() : undefined as any;
        return data;
    }
}

export interface ISeatDTO {
    computerName?: string | undefined;
    userComputerName?: string | undefined;
    uniqueIdentifier?: string | undefined;
    isRegistered: boolean;
    lastRegistered: Date;
}

export class ConcurrentSessionDTO implements IConcurrentSessionDTO {
    sessionName?: string | undefined;
    sessionStartTime!: Date;
    userName?: string | undefined;
    platform?: string | undefined;
    isLoggedUser!: boolean;

    constructor(data?: IConcurrentSessionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionName = _data["sessionName"];
            this.sessionStartTime = _data["sessionStartTime"] ? new Date(_data["sessionStartTime"].toString()) : undefined as any;
            this.userName = _data["userName"];
            this.platform = _data["platform"];
            this.isLoggedUser = _data["isLoggedUser"];
        }
    }

    static fromJS(data: any): ConcurrentSessionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ConcurrentSessionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionName"] = this.sessionName;
        data["sessionStartTime"] = this.sessionStartTime ? this.sessionStartTime.toISOString() : undefined as any;
        data["userName"] = this.userName;
        data["platform"] = this.platform;
        data["isLoggedUser"] = this.isLoggedUser;
        return data;
    }
}

export interface IConcurrentSessionDTO {
    sessionName?: string | undefined;
    sessionStartTime: Date;
    userName?: string | undefined;
    platform?: string | undefined;
    isLoggedUser: boolean;
}

export class ProductEditionDTO implements IProductEditionDTO {
    edition?: string | undefined;

    constructor(data?: IProductEditionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"];
        }
    }

    static fromJS(data: any): ProductEditionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductEditionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition;
        return data;
    }
}

export interface IProductEditionDTO {
    edition?: string | undefined;
}

export class ChallengeDto implements IChallengeDto {
    challengeId?: string | undefined;
    nonce?: string | undefined;
    expiresAtUtc!: Date;

    constructor(data?: IChallengeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.challengeId = _data["challengeId"];
            this.nonce = _data["nonce"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? new Date(_data["expiresAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ChallengeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["challengeId"] = this.challengeId;
        data["nonce"] = this.nonce;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IChallengeDto {
    challengeId?: string | undefined;
    nonce?: string | undefined;
    expiresAtUtc: Date;
}

export class LicenseValidatorPublicKey implements ILicenseValidatorPublicKey {
    machineName?: string | undefined;
    keyId?: string | undefined;
    bytes?: string | undefined;
    boundAtUtc!: Date;

    constructor(data?: ILicenseValidatorPublicKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineName = _data["machineName"];
            this.keyId = _data["keyId"];
            this.bytes = _data["bytes"];
            this.boundAtUtc = _data["boundAtUtc"] ? new Date(_data["boundAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LicenseValidatorPublicKey {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseValidatorPublicKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineName"] = this.machineName;
        data["keyId"] = this.keyId;
        data["bytes"] = this.bytes;
        data["boundAtUtc"] = this.boundAtUtc ? this.boundAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface ILicenseValidatorPublicKey {
    machineName?: string | undefined;
    keyId?: string | undefined;
    bytes?: string | undefined;
    boundAtUtc: Date;
}

export class VerifyChallengeResponse implements IVerifyChallengeResponse {
    isValid!: boolean;
    machineName?: string | undefined;
    message?: string | undefined;

    constructor(data?: IVerifyChallengeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.machineName = _data["machineName"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): VerifyChallengeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyChallengeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["machineName"] = this.machineName;
        data["message"] = this.message;
        return data;
    }
}

export interface IVerifyChallengeResponse {
    isValid: boolean;
    machineName?: string | undefined;
    message?: string | undefined;
}

export class SignedChallengeDTO implements ISignedChallengeDTO {
    challengeId?: string | undefined;
    machineName?: string | undefined;
    issuedAtUtc!: Date;
    keyId?: string | undefined;
    signature?: string | undefined;

    constructor(data?: ISignedChallengeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.challengeId = _data["challengeId"];
            this.machineName = _data["machineName"];
            this.issuedAtUtc = _data["issuedAtUtc"] ? new Date(_data["issuedAtUtc"].toString()) : undefined as any;
            this.keyId = _data["keyId"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SignedChallengeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SignedChallengeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["challengeId"] = this.challengeId;
        data["machineName"] = this.machineName;
        data["issuedAtUtc"] = this.issuedAtUtc ? this.issuedAtUtc.toISOString() : undefined as any;
        data["keyId"] = this.keyId;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISignedChallengeDTO {
    challengeId?: string | undefined;
    machineName?: string | undefined;
    issuedAtUtc: Date;
    keyId?: string | undefined;
    signature?: string | undefined;
}

export class SendToMarcoDetailDTO implements ISendToMarcoDetailDTO {
    imageBatchId!: number;
    plateId!: number;
    dropNumber!: number;
    overwriteUnsentDisputedScores!: boolean;

    constructor(data?: ISendToMarcoDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageBatchId = _data["imageBatchId"];
            this.plateId = _data["plateId"];
            this.dropNumber = _data["dropNumber"];
            this.overwriteUnsentDisputedScores = _data["overwriteUnsentDisputedScores"];
        }
    }

    static fromJS(data: any): SendToMarcoDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendToMarcoDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageBatchId"] = this.imageBatchId;
        data["plateId"] = this.plateId;
        data["dropNumber"] = this.dropNumber;
        data["overwriteUnsentDisputedScores"] = this.overwriteUnsentDisputedScores;
        return data;
    }
}

export interface ISendToMarcoDetailDTO {
    imageBatchId: number;
    plateId: number;
    dropNumber: number;
    overwriteUnsentDisputedScores: boolean;
}

export class SendAllPlatesToMarcoDetailDTO implements ISendAllPlatesToMarcoDetailDTO {
    treeNodeId!: number;

    constructor(data?: ISendAllPlatesToMarcoDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNodeId = _data["treeNodeId"];
        }
    }

    static fromJS(data: any): SendAllPlatesToMarcoDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendAllPlatesToMarcoDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNodeId"] = this.treeNodeId;
        return data;
    }
}

export interface ISendAllPlatesToMarcoDetailDTO {
    treeNodeId: number;
}

export class SendforTrainingRequestDetailDTO implements ISendforTrainingRequestDetailDTO {
    inspectionID!: number;

    constructor(data?: ISendforTrainingRequestDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectionID = _data["inspectionID"];
        }
    }

    static fromJS(data: any): SendforTrainingRequestDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendforTrainingRequestDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionID"] = this.inspectionID;
        return data;
    }
}

export interface ISendforTrainingRequestDetailDTO {
    inspectionID: number;
}

export class ScoreDTO implements IScoreDTO {
    imageBatchWellDropScoreID!: number;
    dropToScoreID?: number | undefined;
    scoreGroupName?: string | undefined;
    scoreName?: string | undefined;

    constructor(data?: IScoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageBatchWellDropScoreID = _data["imageBatchWellDropScoreID"];
            this.dropToScoreID = _data["dropToScoreID"];
            this.scoreGroupName = _data["scoreGroupName"];
            this.scoreName = _data["scoreName"];
        }
    }

    static fromJS(data: any): ScoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageBatchWellDropScoreID"] = this.imageBatchWellDropScoreID;
        data["dropToScoreID"] = this.dropToScoreID;
        data["scoreGroupName"] = this.scoreGroupName;
        data["scoreName"] = this.scoreName;
        return data;
    }
}

export interface IScoreDTO {
    imageBatchWellDropScoreID: number;
    dropToScoreID?: number | undefined;
    scoreGroupName?: string | undefined;
    scoreName?: string | undefined;
}

export class SendDisputedScoreDetailDTO implements ISendDisputedScoreDetailDTO {
    disputedScoresIds?: DisputedScoresIds[] | undefined;
    recomendedScore!: number;
    disputeReason?: string | undefined;

    constructor(data?: ISendDisputedScoreDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["disputedScoresIds"])) {
                this.disputedScoresIds = [] as any;
                for (let item of _data["disputedScoresIds"])
                    this.disputedScoresIds!.push(DisputedScoresIds.fromJS(item));
            }
            this.recomendedScore = _data["recomendedScore"];
            this.disputeReason = _data["disputeReason"];
        }
    }

    static fromJS(data: any): SendDisputedScoreDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendDisputedScoreDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.disputedScoresIds)) {
            data["disputedScoresIds"] = [];
            for (let item of this.disputedScoresIds)
                data["disputedScoresIds"].push(item ? item.toJSON() : undefined as any);
        }
        data["recomendedScore"] = this.recomendedScore;
        data["disputeReason"] = this.disputeReason;
        return data;
    }
}

export interface ISendDisputedScoreDetailDTO {
    disputedScoresIds?: DisputedScoresIds[] | undefined;
    recomendedScore: number;
    disputeReason?: string | undefined;
}

export class DisputedScoresIds implements IDisputedScoresIds {
    imageBatchWellDropScoreID!: number;
    dropToScoreID?: number | undefined;

    constructor(data?: IDisputedScoresIds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageBatchWellDropScoreID = _data["imageBatchWellDropScoreID"];
            this.dropToScoreID = _data["dropToScoreID"];
        }
    }

    static fromJS(data: any): DisputedScoresIds {
        data = typeof data === 'object' ? data : {};
        let result = new DisputedScoresIds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageBatchWellDropScoreID"] = this.imageBatchWellDropScoreID;
        data["dropToScoreID"] = this.dropToScoreID;
        return data;
    }
}

export interface IDisputedScoresIds {
    imageBatchWellDropScoreID: number;
    dropToScoreID?: number | undefined;
}

export class IgnoreAutoScoreDetailDTO implements IIgnoreAutoScoreDetailDTO {
    imageBatchId!: number;
    plateId!: number;
    wellNumber!: number;
    dropNumber!: number;
    isAutoScoreIgnored!: boolean;

    constructor(data?: IIgnoreAutoScoreDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageBatchId = _data["imageBatchId"];
            this.plateId = _data["plateId"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.isAutoScoreIgnored = _data["isAutoScoreIgnored"];
        }
    }

    static fromJS(data: any): IgnoreAutoScoreDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IgnoreAutoScoreDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageBatchId"] = this.imageBatchId;
        data["plateId"] = this.plateId;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["isAutoScoreIgnored"] = this.isAutoScoreIgnored;
        return data;
    }
}

export interface IIgnoreAutoScoreDetailDTO {
    imageBatchId: number;
    plateId: number;
    wellNumber: number;
    dropNumber: number;
    isAutoScoreIgnored: boolean;
}

export class MarcoScoreInfo implements IMarcoScoreInfo {
    model?: string | undefined;
    fasaScore?: string | undefined;
    scoreDetails?: { [key: string]: string; } | undefined;
    morphologyDetails?: { [key: string]: string; } | undefined;
    ultravioletDetails?: { [key: string]: string; } | undefined;

    constructor(data?: IMarcoScoreInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"];
            this.fasaScore = _data["fasaScore"];
            if (_data["scoreDetails"]) {
                this.scoreDetails = {} as any;
                for (let key in _data["scoreDetails"]) {
                    if (_data["scoreDetails"].hasOwnProperty(key))
                        (this.scoreDetails as any)![key] = _data["scoreDetails"][key];
                }
            }
            if (_data["morphologyDetails"]) {
                this.morphologyDetails = {} as any;
                for (let key in _data["morphologyDetails"]) {
                    if (_data["morphologyDetails"].hasOwnProperty(key))
                        (this.morphologyDetails as any)![key] = _data["morphologyDetails"][key];
                }
            }
            if (_data["ultravioletDetails"]) {
                this.ultravioletDetails = {} as any;
                for (let key in _data["ultravioletDetails"]) {
                    if (_data["ultravioletDetails"].hasOwnProperty(key))
                        (this.ultravioletDetails as any)![key] = _data["ultravioletDetails"][key];
                }
            }
        }
    }

    static fromJS(data: any): MarcoScoreInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MarcoScoreInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        data["fasaScore"] = this.fasaScore;
        if (this.scoreDetails) {
            data["scoreDetails"] = {};
            for (let key in this.scoreDetails) {
                if (this.scoreDetails.hasOwnProperty(key))
                    (data["scoreDetails"] as any)[key] = (this.scoreDetails as any)[key];
            }
        }
        if (this.morphologyDetails) {
            data["morphologyDetails"] = {};
            for (let key in this.morphologyDetails) {
                if (this.morphologyDetails.hasOwnProperty(key))
                    (data["morphologyDetails"] as any)[key] = (this.morphologyDetails as any)[key];
            }
        }
        if (this.ultravioletDetails) {
            data["ultravioletDetails"] = {};
            for (let key in this.ultravioletDetails) {
                if (this.ultravioletDetails.hasOwnProperty(key))
                    (data["ultravioletDetails"] as any)[key] = (this.ultravioletDetails as any)[key];
            }
        }
        return data;
    }
}

export interface IMarcoScoreInfo {
    model?: string | undefined;
    fasaScore?: string | undefined;
    scoreDetails?: { [key: string]: string; } | undefined;
    morphologyDetails?: { [key: string]: string; } | undefined;
    ultravioletDetails?: { [key: string]: string; } | undefined;
}

export class MarcoPlateInfoDto implements IMarcoPlateInfoDto {
    isValidType!: boolean;
    plateType?: string | undefined;
    plateId!: number;

    constructor(data?: IMarcoPlateInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValidType = _data["isValidType"];
            this.plateType = _data["plateType"];
            this.plateId = _data["plateId"];
        }
    }

    static fromJS(data: any): MarcoPlateInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarcoPlateInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValidType"] = this.isValidType;
        data["plateType"] = this.plateType;
        data["plateId"] = this.plateId;
        return data;
    }
}

export interface IMarcoPlateInfoDto {
    isValidType: boolean;
    plateType?: string | undefined;
    plateId: number;
}

export class MarcoStatusDTO implements IMarcoStatusDTO {
    marcoServer?: string | undefined;
    marcoStatus?: string | undefined;
    marcoModel?: string | undefined;
    marcoServerName?: string | undefined;
    unScoredImageCount!: number;

    constructor(data?: IMarcoStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marcoServer = _data["marcoServer"];
            this.marcoStatus = _data["marcoStatus"];
            this.marcoModel = _data["marcoModel"];
            this.marcoServerName = _data["marcoServerName"];
            this.unScoredImageCount = _data["unScoredImageCount"];
        }
    }

    static fromJS(data: any): MarcoStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MarcoStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marcoServer"] = this.marcoServer;
        data["marcoStatus"] = this.marcoStatus;
        data["marcoModel"] = this.marcoModel;
        data["marcoServerName"] = this.marcoServerName;
        data["unScoredImageCount"] = this.unScoredImageCount;
        return data;
    }
}

export interface IMarcoStatusDTO {
    marcoServer?: string | undefined;
    marcoStatus?: string | undefined;
    marcoModel?: string | undefined;
    marcoServerName?: string | undefined;
    unScoredImageCount: number;
}

export class MarcoTrainingAndImprovementStatusDTO implements IMarcoTrainingAndImprovementStatusDTO {
    autoCollectRetrainingImages!: boolean;
    collectRetrainingImages!: boolean;

    constructor(data?: IMarcoTrainingAndImprovementStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoCollectRetrainingImages = _data["autoCollectRetrainingImages"];
            this.collectRetrainingImages = _data["collectRetrainingImages"];
        }
    }

    static fromJS(data: any): MarcoTrainingAndImprovementStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MarcoTrainingAndImprovementStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoCollectRetrainingImages"] = this.autoCollectRetrainingImages;
        data["collectRetrainingImages"] = this.collectRetrainingImages;
        return data;
    }
}

export interface IMarcoTrainingAndImprovementStatusDTO {
    autoCollectRetrainingImages: boolean;
    collectRetrainingImages: boolean;
}

export class EmailDTO implements IEmailDTO {
    subject?: string | undefined;
    message?: string | undefined;
    attachmentPaths?: string[] | undefined;

    constructor(data?: IEmailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.message = _data["message"];
            if (Array.isArray(_data["attachmentPaths"])) {
                this.attachmentPaths = [] as any;
                for (let item of _data["attachmentPaths"])
                    this.attachmentPaths!.push(item);
            }
        }
    }

    static fromJS(data: any): EmailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["message"] = this.message;
        if (Array.isArray(this.attachmentPaths)) {
            data["attachmentPaths"] = [];
            for (let item of this.attachmentPaths)
                data["attachmentPaths"].push(item);
        }
        return data;
    }
}

export interface IEmailDTO {
    subject?: string | undefined;
    message?: string | undefined;
    attachmentPaths?: string[] | undefined;
}

export class AppDBVersionDTO implements IAppDBVersionDTO {
    dbVersion?: string | undefined;
    appVersion?: string | undefined;
    versionCheckEnabled!: boolean;

    constructor(data?: IAppDBVersionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dbVersion = _data["dbVersion"];
            this.appVersion = _data["appVersion"];
            this.versionCheckEnabled = _data["versionCheckEnabled"];
        }
    }

    static fromJS(data: any): AppDBVersionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppDBVersionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dbVersion"] = this.dbVersion;
        data["appVersion"] = this.appVersion;
        data["versionCheckEnabled"] = this.versionCheckEnabled;
        return data;
    }
}

export interface IAppDBVersionDTO {
    dbVersion?: string | undefined;
    appVersion?: string | undefined;
    versionCheckEnabled: boolean;
}

export class OrphanImagesResultDTO implements IOrphanImagesResultDTO {
    path?: string | undefined;
    plateId!: number;
    creationDate?: string | undefined;
    folderSize!: number;
    sourceFolderPath?: string | undefined;

    constructor(data?: IOrphanImagesResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            this.plateId = _data["plateId"];
            this.creationDate = _data["creationDate"];
            this.folderSize = _data["folderSize"];
            this.sourceFolderPath = _data["sourceFolderPath"];
        }
    }

    static fromJS(data: any): OrphanImagesResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrphanImagesResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["plateId"] = this.plateId;
        data["creationDate"] = this.creationDate;
        data["folderSize"] = this.folderSize;
        data["sourceFolderPath"] = this.sourceFolderPath;
        return data;
    }
}

export interface IOrphanImagesResultDTO {
    path?: string | undefined;
    plateId: number;
    creationDate?: string | undefined;
    folderSize: number;
    sourceFolderPath?: string | undefined;
}

export class PlateInfoDTO implements IPlateInfoDTO {
    id!: number;
    name?: string | undefined;
    dispensed?: string | undefined;
    imaged?: string | undefined;
    expName?: string | undefined;
    plateNumber!: number;
    barcode?: string | undefined;
    robotName?: string | undefined;
    plateState?: number | undefined;
    seeds?: PlateSeedInfoDTO[] | undefined;
    hasSeedLayer!: boolean;
    isExpired!: boolean;
    wellState!: EPlateWellStates;

    constructor(data?: IPlateInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dispensed = _data["dispensed"];
            this.imaged = _data["imaged"];
            this.expName = _data["expName"];
            this.plateNumber = _data["plateNumber"];
            this.barcode = _data["barcode"];
            this.robotName = _data["robotName"];
            this.plateState = _data["plateState"];
            if (Array.isArray(_data["seeds"])) {
                this.seeds = [] as any;
                for (let item of _data["seeds"])
                    this.seeds!.push(PlateSeedInfoDTO.fromJS(item));
            }
            this.hasSeedLayer = _data["hasSeedLayer"];
            this.isExpired = _data["isExpired"];
            this.wellState = _data["wellState"];
        }
    }

    static fromJS(data: any): PlateInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dispensed"] = this.dispensed;
        data["imaged"] = this.imaged;
        data["expName"] = this.expName;
        data["plateNumber"] = this.plateNumber;
        data["barcode"] = this.barcode;
        data["robotName"] = this.robotName;
        data["plateState"] = this.plateState;
        if (Array.isArray(this.seeds)) {
            data["seeds"] = [];
            for (let item of this.seeds)
                data["seeds"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasSeedLayer"] = this.hasSeedLayer;
        data["isExpired"] = this.isExpired;
        data["wellState"] = this.wellState;
        return data;
    }
}

export interface IPlateInfoDTO {
    id: number;
    name?: string | undefined;
    dispensed?: string | undefined;
    imaged?: string | undefined;
    expName?: string | undefined;
    plateNumber: number;
    barcode?: string | undefined;
    robotName?: string | undefined;
    plateState?: number | undefined;
    seeds?: PlateSeedInfoDTO[] | undefined;
    hasSeedLayer: boolean;
    isExpired: boolean;
    wellState: EPlateWellStates;
}

export class PlateSeedInfoDTO implements IPlateSeedInfoDTO {
    name?: string | undefined;
    dateCreated?: Date | undefined;
    dropNumber!: number;
    wellName?: string | undefined;

    constructor(data?: IPlateSeedInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dropNumber = _data["dropNumber"];
            this.wellName = _data["wellName"];
        }
    }

    static fromJS(data: any): PlateSeedInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateSeedInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dropNumber"] = this.dropNumber;
        data["wellName"] = this.wellName;
        return data;
    }
}

export interface IPlateSeedInfoDTO {
    name?: string | undefined;
    dateCreated?: Date | undefined;
    dropNumber: number;
    wellName?: string | undefined;
}

export enum EPlateWellStates {
    Designed = 0,
    Dispensed = 1,
    Imaged = 2,
    Hits = 3,
    Harvested = 4,
}

export class ScreenBasicInfoDTO implements IScreenBasicInfoDTO {
    id!: number;
    lotNumberList?: number[] | undefined;
    totalConditions!: number;

    constructor(data?: IScreenBasicInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["lotNumberList"])) {
                this.lotNumberList = [] as any;
                for (let item of _data["lotNumberList"])
                    this.lotNumberList!.push(item);
            }
            this.totalConditions = _data["totalConditions"];
        }
    }

    static fromJS(data: any): ScreenBasicInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenBasicInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.lotNumberList)) {
            data["lotNumberList"] = [];
            for (let item of this.lotNumberList)
                data["lotNumberList"].push(item);
        }
        data["totalConditions"] = this.totalConditions;
        return data;
    }
}

export interface IScreenBasicInfoDTO {
    id: number;
    lotNumberList?: number[] | undefined;
    totalConditions: number;
}

export class TileDTO implements ITileDTO {
    tileFileStr?: string | undefined;

    constructor(data?: ITileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tileFileStr = _data["tileFileStr"];
        }
    }

    static fromJS(data: any): TileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tileFileStr"] = this.tileFileStr;
        return data;
    }
}

export interface ITileDTO {
    tileFileStr?: string | undefined;
}

export class PlateAnnotationDTO implements IPlateAnnotationDTO {
    cpId!: number;
    pid!: number;
    width!: number;
    regionName?: string | undefined;

    constructor(data?: IPlateAnnotationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cpId = _data["cpId"];
            this.pid = _data["pid"];
            this.width = _data["width"];
            this.regionName = _data["regionName"];
        }
    }

    static fromJS(data: any): PlateAnnotationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateAnnotationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpId"] = this.cpId;
        data["pid"] = this.pid;
        data["width"] = this.width;
        data["regionName"] = this.regionName;
        return data;
    }
}

export interface IPlateAnnotationDTO {
    cpId: number;
    pid: number;
    width: number;
    regionName?: string | undefined;
}

export class ScoreRequestDTO implements IScoreRequestDTO {
    plateID!: number;
    batchID!: number;
    wellNumber!: number;
    wellDropId!: number;
    wellDropScoreId!: number;
    wellDropScoreGroupId!: number;
    dropNumber!: number;
    isDeleteScore!: boolean;

    constructor(data?: IScoreRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            this.batchID = _data["batchID"];
            this.wellNumber = _data["wellNumber"];
            this.wellDropId = _data["wellDropId"];
            this.wellDropScoreId = _data["wellDropScoreId"];
            this.wellDropScoreGroupId = _data["wellDropScoreGroupId"];
            this.dropNumber = _data["dropNumber"];
            this.isDeleteScore = _data["isDeleteScore"];
        }
    }

    static fromJS(data: any): ScoreRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        data["batchID"] = this.batchID;
        data["wellNumber"] = this.wellNumber;
        data["wellDropId"] = this.wellDropId;
        data["wellDropScoreId"] = this.wellDropScoreId;
        data["wellDropScoreGroupId"] = this.wellDropScoreGroupId;
        data["dropNumber"] = this.dropNumber;
        data["isDeleteScore"] = this.isDeleteScore;
        return data;
    }
}

export interface IScoreRequestDTO {
    plateID: number;
    batchID: number;
    wellNumber: number;
    wellDropId: number;
    wellDropScoreId: number;
    wellDropScoreGroupId: number;
    dropNumber: number;
    isDeleteScore: boolean;
}

export class PlateTypeDTO implements IPlateTypeDTO {
    dropVolume!: number;
    volume!: number;
    id!: number;
    name?: string | undefined;
    enabledDropNumbers?: number[] | undefined;
    totalDrops!: number;
    totalWells!: number;

    constructor(data?: IPlateTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dropVolume = _data["dropVolume"];
            this.volume = _data["volume"];
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["enabledDropNumbers"])) {
                this.enabledDropNumbers = [] as any;
                for (let item of _data["enabledDropNumbers"])
                    this.enabledDropNumbers!.push(item);
            }
            this.totalDrops = _data["totalDrops"];
            this.totalWells = _data["totalWells"];
        }
    }

    static fromJS(data: any): PlateTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dropVolume"] = this.dropVolume;
        data["volume"] = this.volume;
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.enabledDropNumbers)) {
            data["enabledDropNumbers"] = [];
            for (let item of this.enabledDropNumbers)
                data["enabledDropNumbers"].push(item);
        }
        data["totalDrops"] = this.totalDrops;
        data["totalWells"] = this.totalWells;
        return data;
    }
}

export interface IPlateTypeDTO {
    dropVolume: number;
    volume: number;
    id: number;
    name?: string | undefined;
    enabledDropNumbers?: number[] | undefined;
    totalDrops: number;
    totalWells: number;
}

export class ISOPrevExpInfo implements IISOPrevExpInfo {
    expId!: number;
    expName?: string | undefined;

    constructor(data?: IISOPrevExpInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expId = _data["expId"];
            this.expName = _data["expName"];
        }
    }

    static fromJS(data: any): ISOPrevExpInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ISOPrevExpInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expId"] = this.expId;
        data["expName"] = this.expName;
        return data;
    }
}

export interface IISOPrevExpInfo {
    expId: number;
    expName?: string | undefined;
}

export class PlateBasicInfoDTO implements IPlateBasicInfoDTO {
    plateId!: number;
    barcode?: string | undefined;
    expId!: number;
    setupTemp!: number;
    expPreparationDate!: Date;

    constructor(data?: IPlateBasicInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.barcode = _data["barcode"];
            this.expId = _data["expId"];
            this.setupTemp = _data["setupTemp"];
            this.expPreparationDate = _data["expPreparationDate"] ? new Date(_data["expPreparationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PlateBasicInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateBasicInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["barcode"] = this.barcode;
        data["expId"] = this.expId;
        data["setupTemp"] = this.setupTemp;
        data["expPreparationDate"] = this.expPreparationDate ? this.expPreparationDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPlateBasicInfoDTO {
    plateId: number;
    barcode?: string | undefined;
    expId: number;
    setupTemp: number;
    expPreparationDate: Date;
}

export class PlatesImagingTaskDTO implements IPlatesImagingTaskDTO {
    plateId!: number;
    imagingEnabled!: boolean;

    constructor(data?: IPlatesImagingTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.imagingEnabled = _data["imagingEnabled"];
        }
    }

    static fromJS(data: any): PlatesImagingTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlatesImagingTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["imagingEnabled"] = this.imagingEnabled;
        return data;
    }
}

export interface IPlatesImagingTaskDTO {
    plateId: number;
    imagingEnabled: boolean;
}

export class PlateDrawingIdentifierDTO implements IPlateDrawingIdentifierDTO {
    drawingsIdentifier?: AnnotationsDTO | undefined;
    plateId!: number;

    constructor(data?: IPlateDrawingIdentifierDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.drawingsIdentifier = _data["drawingsIdentifier"] ? AnnotationsDTO.fromJS(_data["drawingsIdentifier"]) : undefined as any;
            this.plateId = _data["plateId"];
        }
    }

    static fromJS(data: any): PlateDrawingIdentifierDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateDrawingIdentifierDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["drawingsIdentifier"] = this.drawingsIdentifier ? this.drawingsIdentifier.toJSON() : undefined as any;
        data["plateId"] = this.plateId;
        return data;
    }
}

export interface IPlateDrawingIdentifierDTO {
    drawingsIdentifier?: AnnotationsDTO | undefined;
    plateId: number;
}

export class PlateBarcode implements IPlateBarcode {
    barcode?: string | undefined;

    constructor(data?: IPlateBarcode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): PlateBarcode {
        data = typeof data === 'object' ? data : {};
        let result = new PlateBarcode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        return data;
    }
}

export interface IPlateBarcode {
    barcode?: string | undefined;
}

export class EditBarcodesBatchRequest implements IEditBarcodesBatchRequest {
    barcodes?: PlateBarcodeEditDTO[] | undefined;

    constructor(data?: IEditBarcodesBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["barcodes"])) {
                this.barcodes = [] as any;
                for (let item of _data["barcodes"])
                    this.barcodes!.push(PlateBarcodeEditDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditBarcodesBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditBarcodesBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.barcodes)) {
            data["barcodes"] = [];
            for (let item of this.barcodes)
                data["barcodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEditBarcodesBatchRequest {
    barcodes?: PlateBarcodeEditDTO[] | undefined;
}

export class PlateBarcodeEditDTO implements IPlateBarcodeEditDTO {
    plateId!: number;
    barcode?: string | undefined;

    constructor(data?: IPlateBarcodeEditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): PlateBarcodeEditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateBarcodeEditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["barcode"] = this.barcode;
        return data;
    }
}

export interface IPlateBarcodeEditDTO {
    plateId: number;
    barcode?: string | undefined;
}

export class RequiredStockDTO implements IRequiredStockDTO {
    id!: number;
    stockNumber!: number;
    name?: string | undefined;
    concentrationUnits?: string | undefined;
    stockConcentration!: number;
    vendorPartNumber?: string | undefined;
    volume!: number;

    constructor(data?: IRequiredStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stockNumber = _data["stockNumber"];
            this.name = _data["name"];
            this.concentrationUnits = _data["concentrationUnits"];
            this.stockConcentration = _data["stockConcentration"];
            this.vendorPartNumber = _data["vendorPartNumber"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): RequiredStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockNumber"] = this.stockNumber;
        data["name"] = this.name;
        data["concentrationUnits"] = this.concentrationUnits;
        data["stockConcentration"] = this.stockConcentration;
        data["vendorPartNumber"] = this.vendorPartNumber;
        data["volume"] = this.volume;
        return data;
    }
}

export interface IRequiredStockDTO {
    id: number;
    stockNumber: number;
    name?: string | undefined;
    concentrationUnits?: string | undefined;
    stockConcentration: number;
    vendorPartNumber?: string | undefined;
    volume: number;
}

export class BarcodeLayoutAndDataWrapper implements IBarcodeLayoutAndDataWrapper {
    barcodeLayouts?: BarcodeLayout[] | undefined;
    barcodeDataList?: BarcodeData[] | undefined;

    constructor(data?: IBarcodeLayoutAndDataWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["barcodeLayouts"])) {
                this.barcodeLayouts = [] as any;
                for (let item of _data["barcodeLayouts"])
                    this.barcodeLayouts!.push(BarcodeLayout.fromJS(item));
            }
            if (Array.isArray(_data["barcodeDataList"])) {
                this.barcodeDataList = [] as any;
                for (let item of _data["barcodeDataList"])
                    this.barcodeDataList!.push(BarcodeData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BarcodeLayoutAndDataWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeLayoutAndDataWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.barcodeLayouts)) {
            data["barcodeLayouts"] = [];
            for (let item of this.barcodeLayouts)
                data["barcodeLayouts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.barcodeDataList)) {
            data["barcodeDataList"] = [];
            for (let item of this.barcodeDataList)
                data["barcodeDataList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBarcodeLayoutAndDataWrapper {
    barcodeLayouts?: BarcodeLayout[] | undefined;
    barcodeDataList?: BarcodeData[] | undefined;
}

export class BarcodeLayout implements IBarcodeLayout {
    barcodeCommand?: string | undefined;
    displayBarcodeText!: boolean;
    numCopies!: number;
    horizontalTextOffset!: number;
    horizontalBarcodeOffset!: number;
    barcodeTextHorizontalOffset!: number;
    barcodeTextVerticalOffset!: number;

    constructor(data?: IBarcodeLayout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcodeCommand = _data["barcodeCommand"];
            this.displayBarcodeText = _data["displayBarcodeText"];
            this.numCopies = _data["numCopies"];
            this.horizontalTextOffset = _data["horizontalTextOffset"];
            this.horizontalBarcodeOffset = _data["horizontalBarcodeOffset"];
            this.barcodeTextHorizontalOffset = _data["barcodeTextHorizontalOffset"];
            this.barcodeTextVerticalOffset = _data["barcodeTextVerticalOffset"];
        }
    }

    static fromJS(data: any): BarcodeLayout {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcodeCommand"] = this.barcodeCommand;
        data["displayBarcodeText"] = this.displayBarcodeText;
        data["numCopies"] = this.numCopies;
        data["horizontalTextOffset"] = this.horizontalTextOffset;
        data["horizontalBarcodeOffset"] = this.horizontalBarcodeOffset;
        data["barcodeTextHorizontalOffset"] = this.barcodeTextHorizontalOffset;
        data["barcodeTextVerticalOffset"] = this.barcodeTextVerticalOffset;
        return data;
    }
}

export interface IBarcodeLayout {
    barcodeCommand?: string | undefined;
    displayBarcodeText: boolean;
    numCopies: number;
    horizontalTextOffset: number;
    horizontalBarcodeOffset: number;
    barcodeTextHorizontalOffset: number;
    barcodeTextVerticalOffset: number;
}

export class BarcodeData implements IBarcodeData {
    barcodeString?: string | undefined;
    labelTexts?: string[][] | undefined;
    plateLabelTruncationNotice?: string | undefined;

    constructor(data?: IBarcodeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcodeString = _data["barcodeString"];
            if (Array.isArray(_data["labelTexts"])) {
                this.labelTexts = [] as any;
                for (let item of _data["labelTexts"])
                    this.labelTexts!.push(item);
            }
            this.plateLabelTruncationNotice = _data["plateLabelTruncationNotice"];
        }
    }

    static fromJS(data: any): BarcodeData {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcodeString"] = this.barcodeString;
        if (Array.isArray(this.labelTexts)) {
            data["labelTexts"] = [];
            for (let item of this.labelTexts)
                data["labelTexts"].push(item);
        }
        data["plateLabelTruncationNotice"] = this.plateLabelTruncationNotice;
        return data;
    }
}

export interface IBarcodeData {
    barcodeString?: string | undefined;
    labelTexts?: string[][] | undefined;
    plateLabelTruncationNotice?: string | undefined;
}

export class LabelPrinterSettings implements ILabelPrinterSettings {
    lablePrinterProperty?: string | undefined;
    printerDriverType?: string | undefined;
    printerName?: string | undefined;
    formFeedCount!: number;

    constructor(data?: ILabelPrinterSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lablePrinterProperty = _data["lablePrinterProperty"];
            this.printerDriverType = _data["printerDriverType"];
            this.printerName = _data["printerName"];
            this.formFeedCount = _data["formFeedCount"];
        }
    }

    static fromJS(data: any): LabelPrinterSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LabelPrinterSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lablePrinterProperty"] = this.lablePrinterProperty;
        data["printerDriverType"] = this.printerDriverType;
        data["printerName"] = this.printerName;
        data["formFeedCount"] = this.formFeedCount;
        return data;
    }
}

export interface ILabelPrinterSettings {
    lablePrinterProperty?: string | undefined;
    printerDriverType?: string | undefined;
    printerName?: string | undefined;
    formFeedCount: number;
}

export class PrintBarcodeApiResponse implements IPrintBarcodeApiResponse {
    value?: string | undefined;
    infoMessage?: string | undefined;

    constructor(data?: IPrintBarcodeApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.infoMessage = _data["infoMessage"];
        }
    }

    static fromJS(data: any): PrintBarcodeApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrintBarcodeApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["infoMessage"] = this.infoMessage;
        return data;
    }
}

export interface IPrintBarcodeApiResponse {
    value?: string | undefined;
    infoMessage?: string | undefined;
}

export class PFDocDataDTO implements IPFDocDataDTO {
    proteinFormulation?: PFDocProteinFormulationDTO | undefined;
    dropDownsData?: PFDocDropDownsDataDTO | undefined;
    ingredientsData?: GlobalIngredientsDTO | undefined;
    nodeInfo?: PFProtienFormulationNodeInfoDTO | undefined;

    constructor(data?: IPFDocDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proteinFormulation = _data["proteinFormulation"] ? PFDocProteinFormulationDTO.fromJS(_data["proteinFormulation"]) : undefined as any;
            this.dropDownsData = _data["dropDownsData"] ? PFDocDropDownsDataDTO.fromJS(_data["dropDownsData"]) : undefined as any;
            this.ingredientsData = _data["ingredientsData"] ? GlobalIngredientsDTO.fromJS(_data["ingredientsData"]) : undefined as any;
            this.nodeInfo = _data["nodeInfo"] ? PFProtienFormulationNodeInfoDTO.fromJS(_data["nodeInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): PFDocDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        data["dropDownsData"] = this.dropDownsData ? this.dropDownsData.toJSON() : undefined as any;
        data["ingredientsData"] = this.ingredientsData ? this.ingredientsData.toJSON() : undefined as any;
        data["nodeInfo"] = this.nodeInfo ? this.nodeInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IPFDocDataDTO {
    proteinFormulation?: PFDocProteinFormulationDTO | undefined;
    dropDownsData?: PFDocDropDownsDataDTO | undefined;
    ingredientsData?: GlobalIngredientsDTO | undefined;
    nodeInfo?: PFProtienFormulationNodeInfoDTO | undefined;
}

export class PFDocDropDownsDataDTO implements IPFDocDropDownsDataDTO {
    pfIngTypes?: ProteinFormulationIngredientTypeDTO[] | undefined;
    liquidClasses?: LiquidClassDTO[] | undefined;

    constructor(data?: IPFDocDropDownsDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pfIngTypes"])) {
                this.pfIngTypes = [] as any;
                for (let item of _data["pfIngTypes"])
                    this.pfIngTypes!.push(ProteinFormulationIngredientTypeDTO.fromJS(item));
            }
            if (Array.isArray(_data["liquidClasses"])) {
                this.liquidClasses = [] as any;
                for (let item of _data["liquidClasses"])
                    this.liquidClasses!.push(LiquidClassDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PFDocDropDownsDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocDropDownsDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pfIngTypes)) {
            data["pfIngTypes"] = [];
            for (let item of this.pfIngTypes)
                data["pfIngTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.liquidClasses)) {
            data["liquidClasses"] = [];
            for (let item of this.liquidClasses)
                data["liquidClasses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPFDocDropDownsDataDTO {
    pfIngTypes?: ProteinFormulationIngredientTypeDTO[] | undefined;
    liquidClasses?: LiquidClassDTO[] | undefined;
}

export class PFProtienFormulationNodeInfoDTO implements IPFProtienFormulationNodeInfoDTO {
    dateCreated?: string | undefined;
    ownerName?: string | undefined;
    info?: string | undefined;
    proteinFormulationIngredient?: PFProtienFormulationIngredientInfoDTO[] | undefined;

    constructor(data?: IPFProtienFormulationNodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"];
            this.ownerName = _data["ownerName"];
            this.info = _data["info"];
            if (Array.isArray(_data["proteinFormulationIngredient"])) {
                this.proteinFormulationIngredient = [] as any;
                for (let item of _data["proteinFormulationIngredient"])
                    this.proteinFormulationIngredient!.push(PFProtienFormulationIngredientInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PFProtienFormulationNodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFProtienFormulationNodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated;
        data["ownerName"] = this.ownerName;
        data["info"] = this.info;
        if (Array.isArray(this.proteinFormulationIngredient)) {
            data["proteinFormulationIngredient"] = [];
            for (let item of this.proteinFormulationIngredient)
                data["proteinFormulationIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPFProtienFormulationNodeInfoDTO {
    dateCreated?: string | undefined;
    ownerName?: string | undefined;
    info?: string | undefined;
    proteinFormulationIngredient?: PFProtienFormulationIngredientInfoDTO[] | undefined;
}

export class PFProtienFormulationIngredientInfoDTO implements IPFProtienFormulationIngredientInfoDTO {
    id!: number;
    ingredientName?: string | undefined;
    protienType?: string | undefined;
    concMgml?: number | undefined;
    concMm?: number | undefined;

    constructor(data?: IPFProtienFormulationIngredientInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientName = _data["ingredientName"];
            this.protienType = _data["protienType"];
            this.concMgml = _data["concMgml"];
            this.concMm = _data["concMm"];
        }
    }

    static fromJS(data: any): PFProtienFormulationIngredientInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFProtienFormulationIngredientInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientName"] = this.ingredientName;
        data["protienType"] = this.protienType;
        data["concMgml"] = this.concMgml;
        data["concMm"] = this.concMm;
        return data;
    }
}

export interface IPFProtienFormulationIngredientInfoDTO {
    id: number;
    ingredientName?: string | undefined;
    protienType?: string | undefined;
    concMgml?: number | undefined;
    concMm?: number | undefined;
}

export class PFDocSaveResult implements IPFDocSaveResult {
    error!: boolean;
    errorMessage?: string | undefined;
    data?: PFDocProteinFormulationDTO | undefined;

    constructor(data?: IPFDocSaveResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"];
            this.data = _data["data"] ? PFDocProteinFormulationDTO.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): PFDocSaveResult {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocSaveResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IPFDocSaveResult {
    error: boolean;
    errorMessage?: string | undefined;
    data?: PFDocProteinFormulationDTO | undefined;
}

export class PFDocSaveProteinFormulationDTO implements IPFDocSaveProteinFormulationDTO {
    proteinFormulation?: PFDocProteinFormulationDTO | undefined;
    deletedPFIngs?: PFDocProteinFormulationIngredientsDTO[] | undefined;
    deletedStIngs?: PFDocStandardIngredientsDTO[] | undefined;
    parentNodeId!: number;
    deletedAttachments?: PFDocAttachmentDTO[] | undefined;

    constructor(data?: IPFDocSaveProteinFormulationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proteinFormulation = _data["proteinFormulation"] ? PFDocProteinFormulationDTO.fromJS(_data["proteinFormulation"]) : undefined as any;
            if (Array.isArray(_data["deletedPFIngs"])) {
                this.deletedPFIngs = [] as any;
                for (let item of _data["deletedPFIngs"])
                    this.deletedPFIngs!.push(PFDocProteinFormulationIngredientsDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedStIngs"])) {
                this.deletedStIngs = [] as any;
                for (let item of _data["deletedStIngs"])
                    this.deletedStIngs!.push(PFDocStandardIngredientsDTO.fromJS(item));
            }
            this.parentNodeId = _data["parentNodeId"];
            if (Array.isArray(_data["deletedAttachments"])) {
                this.deletedAttachments = [] as any;
                for (let item of _data["deletedAttachments"])
                    this.deletedAttachments!.push(PFDocAttachmentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PFDocSaveProteinFormulationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocSaveProteinFormulationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proteinFormulation"] = this.proteinFormulation ? this.proteinFormulation.toJSON() : undefined as any;
        if (Array.isArray(this.deletedPFIngs)) {
            data["deletedPFIngs"] = [];
            for (let item of this.deletedPFIngs)
                data["deletedPFIngs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedStIngs)) {
            data["deletedStIngs"] = [];
            for (let item of this.deletedStIngs)
                data["deletedStIngs"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentNodeId"] = this.parentNodeId;
        if (Array.isArray(this.deletedAttachments)) {
            data["deletedAttachments"] = [];
            for (let item of this.deletedAttachments)
                data["deletedAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPFDocSaveProteinFormulationDTO {
    proteinFormulation?: PFDocProteinFormulationDTO | undefined;
    deletedPFIngs?: PFDocProteinFormulationIngredientsDTO[] | undefined;
    deletedStIngs?: PFDocStandardIngredientsDTO[] | undefined;
    parentNodeId: number;
    deletedAttachments?: PFDocAttachmentDTO[] | undefined;
}

export class SavePFIngTypesResult implements ISavePFIngTypesResult {
    ingTypes?: ProteinFormulationIngredientTypeDTO[] | undefined;
    success!: boolean;
    error?: string | undefined;

    constructor(data?: ISavePFIngTypesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ingTypes"])) {
                this.ingTypes = [] as any;
                for (let item of _data["ingTypes"])
                    this.ingTypes!.push(ProteinFormulationIngredientTypeDTO.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): SavePFIngTypesResult {
        data = typeof data === 'object' ? data : {};
        let result = new SavePFIngTypesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ingTypes)) {
            data["ingTypes"] = [];
            for (let item of this.ingTypes)
                data["ingTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface ISavePFIngTypesResult {
    ingTypes?: ProteinFormulationIngredientTypeDTO[] | undefined;
    success: boolean;
    error?: string | undefined;
}

export class PFDocSaveIngredientTypesDTO implements IPFDocSaveIngredientTypesDTO {
    ingredientTypes?: ProteinFormulationIngredientTypeDTO[] | undefined;
    deletedIngredientTypes?: ProteinFormulationIngredientTypeDTO[] | undefined;

    constructor(data?: IPFDocSaveIngredientTypesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ingredientTypes"])) {
                this.ingredientTypes = [] as any;
                for (let item of _data["ingredientTypes"])
                    this.ingredientTypes!.push(ProteinFormulationIngredientTypeDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedIngredientTypes"])) {
                this.deletedIngredientTypes = [] as any;
                for (let item of _data["deletedIngredientTypes"])
                    this.deletedIngredientTypes!.push(ProteinFormulationIngredientTypeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PFDocSaveIngredientTypesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocSaveIngredientTypesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ingredientTypes)) {
            data["ingredientTypes"] = [];
            for (let item of this.ingredientTypes)
                data["ingredientTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedIngredientTypes)) {
            data["deletedIngredientTypes"] = [];
            for (let item of this.deletedIngredientTypes)
                data["deletedIngredientTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPFDocSaveIngredientTypesDTO {
    ingredientTypes?: ProteinFormulationIngredientTypeDTO[] | undefined;
    deletedIngredientTypes?: ProteinFormulationIngredientTypeDTO[] | undefined;
}

export class PFDocProteinFormulationInfoDTO implements IPFDocProteinFormulationInfoDTO {
    id!: number;
    proteinLotId?: string | undefined;
    treeNodeId!: number;
    volume?: number | undefined;
    pfName?: string | undefined;
    storageTemperature?: number | undefined;
    pclass?: string | undefined;
    extinctionCoefficient?: string | undefined;
    notes?: string | undefined;
    notebookPageNo?: string | undefined;
    datePrepared!: Date;
    liquidClass?: string | undefined;

    constructor(data?: IPFDocProteinFormulationInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proteinLotId = _data["proteinLotId"];
            this.treeNodeId = _data["treeNodeId"];
            this.volume = _data["volume"];
            this.pfName = _data["pfName"];
            this.storageTemperature = _data["storageTemperature"];
            this.pclass = _data["pclass"];
            this.extinctionCoefficient = _data["extinctionCoefficient"];
            this.notes = _data["notes"];
            this.notebookPageNo = _data["notebookPageNo"];
            this.datePrepared = _data["datePrepared"] ? new Date(_data["datePrepared"].toString()) : undefined as any;
            this.liquidClass = _data["liquidClass"];
        }
    }

    static fromJS(data: any): PFDocProteinFormulationInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PFDocProteinFormulationInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proteinLotId"] = this.proteinLotId;
        data["treeNodeId"] = this.treeNodeId;
        data["volume"] = this.volume;
        data["pfName"] = this.pfName;
        data["storageTemperature"] = this.storageTemperature;
        data["pclass"] = this.pclass;
        data["extinctionCoefficient"] = this.extinctionCoefficient;
        data["notes"] = this.notes;
        data["notebookPageNo"] = this.notebookPageNo;
        data["datePrepared"] = this.datePrepared ? this.datePrepared.toISOString() : undefined as any;
        data["liquidClass"] = this.liquidClass;
        return data;
    }
}

export interface IPFDocProteinFormulationInfoDTO {
    id: number;
    proteinLotId?: string | undefined;
    treeNodeId: number;
    volume?: number | undefined;
    pfName?: string | undefined;
    storageTemperature?: number | undefined;
    pclass?: string | undefined;
    extinctionCoefficient?: string | undefined;
    notes?: string | undefined;
    notebookPageNo?: string | undefined;
    datePrepared: Date;
    liquidClass?: string | undefined;
}

export class ProteinFormulationBasicInfoDTO implements IProteinFormulationBasicInfoDTO {
    pfName?: string | undefined;
    pfId!: number;
    pfIngredientName?: string | undefined;

    constructor(data?: IProteinFormulationBasicInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pfName = _data["pfName"];
            this.pfId = _data["pfId"];
            this.pfIngredientName = _data["pfIngredientName"];
        }
    }

    static fromJS(data: any): ProteinFormulationBasicInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationBasicInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pfName"] = this.pfName;
        data["pfId"] = this.pfId;
        data["pfIngredientName"] = this.pfIngredientName;
        return data;
    }
}

export interface IProteinFormulationBasicInfoDTO {
    pfName?: string | undefined;
    pfId: number;
    pfIngredientName?: string | undefined;
}

export class ProteinFormulationDetailInfoDTO implements IProteinFormulationDetailInfoDTO {
    id!: number;
    proteinLotId?: string | undefined;
    treeNodeId!: number;
    volume?: number | undefined;
    pfName?: string | undefined;
    storageTemperature?: number | undefined;
    pclass?: string | undefined;
    extinctionCoefficient?: string | undefined;
    notes?: string | undefined;
    notebookPageNo?: string | undefined;
    datePrepared!: Date;
    liquidClass?: string | undefined;
    proteinFormulationIngredient?: ProteinFormulationIngredient[] | undefined;
    proteinFormulationStandardIngredient?: ProteinFormulationStandardIngredient[] | undefined;

    constructor(data?: IProteinFormulationDetailInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proteinLotId = _data["proteinLotId"];
            this.treeNodeId = _data["treeNodeId"];
            this.volume = _data["volume"];
            this.pfName = _data["pfName"];
            this.storageTemperature = _data["storageTemperature"];
            this.pclass = _data["pclass"];
            this.extinctionCoefficient = _data["extinctionCoefficient"];
            this.notes = _data["notes"];
            this.notebookPageNo = _data["notebookPageNo"];
            this.datePrepared = _data["datePrepared"] ? new Date(_data["datePrepared"].toString()) : undefined as any;
            this.liquidClass = _data["liquidClass"];
            if (Array.isArray(_data["proteinFormulationIngredient"])) {
                this.proteinFormulationIngredient = [] as any;
                for (let item of _data["proteinFormulationIngredient"])
                    this.proteinFormulationIngredient!.push(ProteinFormulationIngredient.fromJS(item));
            }
            if (Array.isArray(_data["proteinFormulationStandardIngredient"])) {
                this.proteinFormulationStandardIngredient = [] as any;
                for (let item of _data["proteinFormulationStandardIngredient"])
                    this.proteinFormulationStandardIngredient!.push(ProteinFormulationStandardIngredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProteinFormulationDetailInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationDetailInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proteinLotId"] = this.proteinLotId;
        data["treeNodeId"] = this.treeNodeId;
        data["volume"] = this.volume;
        data["pfName"] = this.pfName;
        data["storageTemperature"] = this.storageTemperature;
        data["pclass"] = this.pclass;
        data["extinctionCoefficient"] = this.extinctionCoefficient;
        data["notes"] = this.notes;
        data["notebookPageNo"] = this.notebookPageNo;
        data["datePrepared"] = this.datePrepared ? this.datePrepared.toISOString() : undefined as any;
        data["liquidClass"] = this.liquidClass;
        if (Array.isArray(this.proteinFormulationIngredient)) {
            data["proteinFormulationIngredient"] = [];
            for (let item of this.proteinFormulationIngredient)
                data["proteinFormulationIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinFormulationStandardIngredient)) {
            data["proteinFormulationStandardIngredient"] = [];
            for (let item of this.proteinFormulationStandardIngredient)
                data["proteinFormulationStandardIngredient"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProteinFormulationDetailInfoDTO {
    id: number;
    proteinLotId?: string | undefined;
    treeNodeId: number;
    volume?: number | undefined;
    pfName?: string | undefined;
    storageTemperature?: number | undefined;
    pclass?: string | undefined;
    extinctionCoefficient?: string | undefined;
    notes?: string | undefined;
    notebookPageNo?: string | undefined;
    datePrepared: Date;
    liquidClass?: string | undefined;
    proteinFormulationIngredient?: ProteinFormulationIngredient[] | undefined;
    proteinFormulationStandardIngredient?: ProteinFormulationStandardIngredient[] | undefined;
}

export class ProteinFormulationVariantDTO implements IProteinFormulationVariantDTO {
    parentProteinFormulationId!: number;
    parentProteinFormulationTreeNodeId!: number;
    proteinFormulationVariantIngredients?: ProteinFormulationVariantIngredientDTO[] | undefined;
    deletedProteinFormulationVariantIngredients?: ProteinFormulationVariantIngredientDTO[] | undefined;

    constructor(data?: IProteinFormulationVariantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentProteinFormulationId = _data["parentProteinFormulationId"];
            this.parentProteinFormulationTreeNodeId = _data["parentProteinFormulationTreeNodeId"];
            if (Array.isArray(_data["proteinFormulationVariantIngredients"])) {
                this.proteinFormulationVariantIngredients = [] as any;
                for (let item of _data["proteinFormulationVariantIngredients"])
                    this.proteinFormulationVariantIngredients!.push(ProteinFormulationVariantIngredientDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedProteinFormulationVariantIngredients"])) {
                this.deletedProteinFormulationVariantIngredients = [] as any;
                for (let item of _data["deletedProteinFormulationVariantIngredients"])
                    this.deletedProteinFormulationVariantIngredients!.push(ProteinFormulationVariantIngredientDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProteinFormulationVariantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationVariantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentProteinFormulationId"] = this.parentProteinFormulationId;
        data["parentProteinFormulationTreeNodeId"] = this.parentProteinFormulationTreeNodeId;
        if (Array.isArray(this.proteinFormulationVariantIngredients)) {
            data["proteinFormulationVariantIngredients"] = [];
            for (let item of this.proteinFormulationVariantIngredients)
                data["proteinFormulationVariantIngredients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedProteinFormulationVariantIngredients)) {
            data["deletedProteinFormulationVariantIngredients"] = [];
            for (let item of this.deletedProteinFormulationVariantIngredients)
                data["deletedProteinFormulationVariantIngredients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProteinFormulationVariantDTO {
    parentProteinFormulationId: number;
    parentProteinFormulationTreeNodeId: number;
    proteinFormulationVariantIngredients?: ProteinFormulationVariantIngredientDTO[] | undefined;
    deletedProteinFormulationVariantIngredients?: ProteinFormulationVariantIngredientDTO[] | undefined;
}

export class ProteinFormulationVariantIngredientDTO implements IProteinFormulationVariantIngredientDTO {
    id!: number;
    userId?: string | undefined;
    name?: string | undefined;
    lot?: string | undefined;
    type!: number;
    molecularWeight?: number | undefined;
    concentrationmgmL?: number | undefined;
    concentrationmM?: number | undefined;
    concentrationPercent?: number | undefined;
    pH?: number | undefined;

    constructor(data?: IProteinFormulationVariantIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.lot = _data["lot"];
            this.type = _data["type"];
            this.molecularWeight = _data["molecularWeight"];
            this.concentrationmgmL = _data["concentrationmgmL"];
            this.concentrationmM = _data["concentrationmM"];
            this.concentrationPercent = _data["concentrationPercent"];
            this.pH = _data["pH"];
        }
    }

    static fromJS(data: any): ProteinFormulationVariantIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationVariantIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["lot"] = this.lot;
        data["type"] = this.type;
        data["molecularWeight"] = this.molecularWeight;
        data["concentrationmgmL"] = this.concentrationmgmL;
        data["concentrationmM"] = this.concentrationmM;
        data["concentrationPercent"] = this.concentrationPercent;
        data["pH"] = this.pH;
        return data;
    }
}

export interface IProteinFormulationVariantIngredientDTO {
    id: number;
    userId?: string | undefined;
    name?: string | undefined;
    lot?: string | undefined;
    type: number;
    molecularWeight?: number | undefined;
    concentrationmgmL?: number | undefined;
    concentrationmM?: number | undefined;
    concentrationPercent?: number | undefined;
    pH?: number | undefined;
}

export class PuckDTO implements IPuckDTO {
    id!: number;
    name?: string | undefined;
    barcode?: string | undefined;
    puckTypeId!: number;
    puckType?: PuckTypev4 | undefined;
    pinCount!: number;
    inUse!: boolean;
    enable?: boolean | undefined;

    constructor(data?: IPuckDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.barcode = _data["barcode"];
            this.puckTypeId = _data["puckTypeId"];
            this.puckType = _data["puckType"] ? PuckTypev4.fromJS(_data["puckType"]) : undefined as any;
            this.pinCount = _data["pinCount"];
            this.inUse = _data["inUse"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): PuckDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PuckDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["barcode"] = this.barcode;
        data["puckTypeId"] = this.puckTypeId;
        data["puckType"] = this.puckType ? this.puckType.toJSON() : undefined as any;
        data["pinCount"] = this.pinCount;
        data["inUse"] = this.inUse;
        data["enable"] = this.enable;
        return data;
    }
}

export interface IPuckDTO {
    id: number;
    name?: string | undefined;
    barcode?: string | undefined;
    puckTypeId: number;
    puckType?: PuckTypev4 | undefined;
    pinCount: number;
    inUse: boolean;
    enable?: boolean | undefined;
}

export class SavePuckDTO implements ISavePuckDTO {
    puckDtoList?: Puckv4[] | undefined;
    deletedIds?: number[] | undefined;

    constructor(data?: ISavePuckDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["puckDtoList"])) {
                this.puckDtoList = [] as any;
                for (let item of _data["puckDtoList"])
                    this.puckDtoList!.push(Puckv4.fromJS(item));
            }
            if (Array.isArray(_data["deletedIds"])) {
                this.deletedIds = [] as any;
                for (let item of _data["deletedIds"])
                    this.deletedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SavePuckDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SavePuckDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.puckDtoList)) {
            data["puckDtoList"] = [];
            for (let item of this.puckDtoList)
                data["puckDtoList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedIds)) {
            data["deletedIds"] = [];
            for (let item of this.deletedIds)
                data["deletedIds"].push(item);
        }
        return data;
    }
}

export interface ISavePuckDTO {
    puckDtoList?: Puckv4[] | undefined;
    deletedIds?: number[] | undefined;
}

export class RecentDocumentReq implements IRecentDocumentReq {
    documentId!: number;

    constructor(data?: IRecentDocumentReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): RecentDocumentReq {
        data = typeof data === 'object' ? data : {};
        let result = new RecentDocumentReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IRecentDocumentReq {
    documentId: number;
}

export class RecycleBinViewDTO implements IRecycleBinViewDTO {
    name?: string | undefined;
    originalLocation?: string | undefined;
    dateDeleted?: string | undefined;
    type?: string | undefined;
    id!: number;
    parentId?: number | undefined;
    treeNodeId!: number;
    extra?: any | undefined;

    constructor(data?: IRecycleBinViewDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.originalLocation = _data["originalLocation"];
            this.dateDeleted = _data["dateDeleted"];
            this.type = _data["type"];
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.treeNodeId = _data["treeNodeId"];
            this.extra = _data["extra"];
        }
    }

    static fromJS(data: any): RecycleBinViewDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecycleBinViewDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["originalLocation"] = this.originalLocation;
        data["dateDeleted"] = this.dateDeleted;
        data["type"] = this.type;
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["treeNodeId"] = this.treeNodeId;
        data["extra"] = this.extra;
        return data;
    }
}

export interface IRecycleBinViewDTO {
    name?: string | undefined;
    originalLocation?: string | undefined;
    dateDeleted?: string | undefined;
    type?: string | undefined;
    id: number;
    parentId?: number | undefined;
    treeNodeId: number;
    extra?: any | undefined;
}

export class RestoreResponseDTO implements IRestoreResponseDTO {
    warnings?: string[] | undefined;
    errors?: string[] | undefined;
    restoredParentIds?: number[] | undefined;

    constructor(data?: IRestoreResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["restoredParentIds"])) {
                this.restoredParentIds = [] as any;
                for (let item of _data["restoredParentIds"])
                    this.restoredParentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RestoreResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.restoredParentIds)) {
            data["restoredParentIds"] = [];
            for (let item of this.restoredParentIds)
                data["restoredParentIds"].push(item);
        }
        return data;
    }
}

export interface IRestoreResponseDTO {
    warnings?: string[] | undefined;
    errors?: string[] | undefined;
    restoredParentIds?: number[] | undefined;
}

export class NameIdTuple implements INameIdTuple {
    id!: number;
    name?: string | undefined;
    imageCount?: number | undefined;

    constructor(data?: INameIdTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageCount = _data["imageCount"];
        }
    }

    static fromJS(data: any): NameIdTuple {
        data = typeof data === 'object' ? data : {};
        let result = new NameIdTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageCount"] = this.imageCount;
        return data;
    }
}

export interface INameIdTuple {
    id: number;
    name?: string | undefined;
    imageCount?: number | undefined;
}

export class SaveDropAutoScoreDTO implements ISaveDropAutoScoreDTO {
    wellDropId!: number;
    imageBatchId!: number;
    captureProfileId!: number;
    regionId!: number;
    imageType?: AutoScoreImageTypeDTO | undefined;
    imageClass?: string | undefined;

    constructor(data?: ISaveDropAutoScoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellDropId = _data["wellDropId"];
            this.imageBatchId = _data["imageBatchId"];
            this.captureProfileId = _data["captureProfileId"];
            this.regionId = _data["regionId"];
            this.imageType = _data["imageType"] ? AutoScoreImageTypeDTO.fromJS(_data["imageType"]) : undefined as any;
            this.imageClass = _data["imageClass"];
        }
    }

    static fromJS(data: any): SaveDropAutoScoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDropAutoScoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellDropId"] = this.wellDropId;
        data["imageBatchId"] = this.imageBatchId;
        data["captureProfileId"] = this.captureProfileId;
        data["regionId"] = this.regionId;
        data["imageType"] = this.imageType ? this.imageType.toJSON() : undefined as any;
        data["imageClass"] = this.imageClass;
        return data;
    }
}

export interface ISaveDropAutoScoreDTO {
    wellDropId: number;
    imageBatchId: number;
    captureProfileId: number;
    regionId: number;
    imageType?: AutoScoreImageTypeDTO | undefined;
    imageClass?: string | undefined;
}

export class AutoScoreImageTypeDTO implements IAutoScoreImageTypeDTO {
    id!: number;
    name?: string | undefined;
    lightPath!: number;
    photoSensor?: number | undefined;

    constructor(data?: IAutoScoreImageTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.lightPath = _data["lightPath"];
            this.photoSensor = _data["photoSensor"];
        }
    }

    static fromJS(data: any): AutoScoreImageTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutoScoreImageTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["lightPath"] = this.lightPath;
        data["photoSensor"] = this.photoSensor;
        return data;
    }
}

export interface IAutoScoreImageTypeDTO {
    id: number;
    name?: string | undefined;
    lightPath: number;
    photoSensor?: number | undefined;
}

export class CreateScreenDTO implements ICreateScreenDTO {
    parentTreeNodeId!: number;

    constructor(data?: ICreateScreenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentTreeNodeId = _data["parentTreeNodeId"];
        }
    }

    static fromJS(data: any): CreateScreenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScreenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentTreeNodeId"] = this.parentTreeNodeId;
        return data;
    }
}

export interface ICreateScreenDTO {
    parentTreeNodeId: number;
}

export class CreateNewTreeNodeDTO implements ICreateNewTreeNodeDTO {
    id!: number;
    parentId!: number;
    expId?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    isAlreadyExist?: boolean | undefined;

    constructor(data?: ICreateNewTreeNodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.expId = _data["expId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.isAlreadyExist = _data["isAlreadyExist"];
        }
    }

    static fromJS(data: any): CreateNewTreeNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewTreeNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["expId"] = this.expId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isAlreadyExist"] = this.isAlreadyExist;
        return data;
    }
}

export interface ICreateNewTreeNodeDTO {
    id: number;
    parentId: number;
    expId?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    isAlreadyExist?: boolean | undefined;
}

export class RotateScreenDTO implements IRotateScreenDTO {
    treeNodeId!: number;
    treeNodeParentId!: number;

    constructor(data?: IRotateScreenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNodeId = _data["treeNodeId"];
            this.treeNodeParentId = _data["treeNodeParentId"];
        }
    }

    static fromJS(data: any): RotateScreenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RotateScreenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNodeId"] = this.treeNodeId;
        data["treeNodeParentId"] = this.treeNodeParentId;
        return data;
    }
}

export interface IRotateScreenDTO {
    treeNodeId: number;
    treeNodeParentId: number;
}

export class ScreenDetailsInfoDTO implements IScreenDetailsInfoDTO {
    screenNodeId!: number;
    screenName?: string | undefined;
    screenPlateId!: number;
    screenPlateBarcode?: string | undefined;

    constructor(data?: IScreenDetailsInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screenNodeId = _data["screenNodeId"];
            this.screenName = _data["screenName"];
            this.screenPlateId = _data["screenPlateId"];
            this.screenPlateBarcode = _data["screenPlateBarcode"];
        }
    }

    static fromJS(data: any): ScreenDetailsInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenDetailsInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["screenNodeId"] = this.screenNodeId;
        data["screenName"] = this.screenName;
        data["screenPlateId"] = this.screenPlateId;
        data["screenPlateBarcode"] = this.screenPlateBarcode;
        return data;
    }
}

export interface IScreenDetailsInfoDTO {
    screenNodeId: number;
    screenName?: string | undefined;
    screenPlateId: number;
    screenPlateBarcode?: string | undefined;
}

export class ScreenNodeInfoDTO implements IScreenNodeInfoDTO {
    lotName?: string | undefined;
    lotComment?: string | undefined;
    plateId!: number;
    plateNumber!: number;
    barcode?: string | undefined;
    plates?: PlateInfoDTO[] | undefined;

    constructor(data?: IScreenNodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lotName = _data["lotName"];
            this.lotComment = _data["lotComment"];
            this.plateId = _data["plateId"];
            this.plateNumber = _data["plateNumber"];
            this.barcode = _data["barcode"];
            if (Array.isArray(_data["plates"])) {
                this.plates = [] as any;
                for (let item of _data["plates"])
                    this.plates!.push(PlateInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScreenNodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenNodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotName"] = this.lotName;
        data["lotComment"] = this.lotComment;
        data["plateId"] = this.plateId;
        data["plateNumber"] = this.plateNumber;
        data["barcode"] = this.barcode;
        if (Array.isArray(this.plates)) {
            data["plates"] = [];
            for (let item of this.plates)
                data["plates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScreenNodeInfoDTO {
    lotName?: string | undefined;
    lotComment?: string | undefined;
    plateId: number;
    plateNumber: number;
    barcode?: string | undefined;
    plates?: PlateInfoDTO[] | undefined;
}

export class FragmentScreenNodeInfoDTO implements IFragmentScreenNodeInfoDTO {
    conditionNumber!: number;
    fragmentId!: number;
    fragmentName?: string | undefined;
    size!: number;
    workingConc?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IFragmentScreenNodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionNumber = _data["conditionNumber"];
            this.fragmentId = _data["fragmentId"];
            this.fragmentName = _data["fragmentName"];
            this.size = _data["size"];
            this.workingConc = _data["workingConc"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): FragmentScreenNodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentScreenNodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionNumber"] = this.conditionNumber;
        data["fragmentId"] = this.fragmentId;
        data["fragmentName"] = this.fragmentName;
        data["size"] = this.size;
        data["workingConc"] = this.workingConc;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IFragmentScreenNodeInfoDTO {
    conditionNumber: number;
    fragmentId: number;
    fragmentName?: string | undefined;
    size: number;
    workingConc?: string | undefined;
    notes?: string | undefined;
}

export class ScreenExperimentTemplateDTO implements IScreenExperimentTemplateDTO {
    name?: string | undefined;
    experimentNamePrefix?: string | undefined;
    experimentNameSuffix?: string | undefined;
    experimentNameFormatString?: string | undefined;
    screens?: ScreenInfoDTO[] | undefined;
    proteinDetails?: ProteinDetailDTO[] | undefined;
    dropsInfo?: DropInfoDTO[] | undefined;
    setupTempratureId!: number;
    canAddDropToContainer!: boolean;
    incubationTempratureID!: number;
    incubationTempratureIDs?: number[] | undefined;
    owner?: OwnerInfoDTO | undefined;
    experimentPlateContainerInfo?: PlateTypeDTO | undefined;
    imagingScheduleInfo?: ImagingScheduleInfoDTO | undefined;

    constructor(data?: IScreenExperimentTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.experimentNamePrefix = _data["experimentNamePrefix"];
            this.experimentNameSuffix = _data["experimentNameSuffix"];
            this.experimentNameFormatString = _data["experimentNameFormatString"];
            if (Array.isArray(_data["screens"])) {
                this.screens = [] as any;
                for (let item of _data["screens"])
                    this.screens!.push(ScreenInfoDTO.fromJS(item));
            }
            if (Array.isArray(_data["proteinDetails"])) {
                this.proteinDetails = [] as any;
                for (let item of _data["proteinDetails"])
                    this.proteinDetails!.push(ProteinDetailDTO.fromJS(item));
            }
            if (Array.isArray(_data["dropsInfo"])) {
                this.dropsInfo = [] as any;
                for (let item of _data["dropsInfo"])
                    this.dropsInfo!.push(DropInfoDTO.fromJS(item));
            }
            this.setupTempratureId = _data["setupTempratureId"];
            this.canAddDropToContainer = _data["canAddDropToContainer"];
            this.incubationTempratureID = _data["incubationTempratureID"];
            if (Array.isArray(_data["incubationTempratureIDs"])) {
                this.incubationTempratureIDs = [] as any;
                for (let item of _data["incubationTempratureIDs"])
                    this.incubationTempratureIDs!.push(item);
            }
            this.owner = _data["owner"] ? OwnerInfoDTO.fromJS(_data["owner"]) : undefined as any;
            this.experimentPlateContainerInfo = _data["experimentPlateContainerInfo"] ? PlateTypeDTO.fromJS(_data["experimentPlateContainerInfo"]) : undefined as any;
            this.imagingScheduleInfo = _data["imagingScheduleInfo"] ? ImagingScheduleInfoDTO.fromJS(_data["imagingScheduleInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScreenExperimentTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenExperimentTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["experimentNamePrefix"] = this.experimentNamePrefix;
        data["experimentNameSuffix"] = this.experimentNameSuffix;
        data["experimentNameFormatString"] = this.experimentNameFormatString;
        if (Array.isArray(this.screens)) {
            data["screens"] = [];
            for (let item of this.screens)
                data["screens"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinDetails)) {
            data["proteinDetails"] = [];
            for (let item of this.proteinDetails)
                data["proteinDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dropsInfo)) {
            data["dropsInfo"] = [];
            for (let item of this.dropsInfo)
                data["dropsInfo"].push(item ? item.toJSON() : undefined as any);
        }
        data["setupTempratureId"] = this.setupTempratureId;
        data["canAddDropToContainer"] = this.canAddDropToContainer;
        data["incubationTempratureID"] = this.incubationTempratureID;
        if (Array.isArray(this.incubationTempratureIDs)) {
            data["incubationTempratureIDs"] = [];
            for (let item of this.incubationTempratureIDs)
                data["incubationTempratureIDs"].push(item);
        }
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["experimentPlateContainerInfo"] = this.experimentPlateContainerInfo ? this.experimentPlateContainerInfo.toJSON() : undefined as any;
        data["imagingScheduleInfo"] = this.imagingScheduleInfo ? this.imagingScheduleInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IScreenExperimentTemplateDTO {
    name?: string | undefined;
    experimentNamePrefix?: string | undefined;
    experimentNameSuffix?: string | undefined;
    experimentNameFormatString?: string | undefined;
    screens?: ScreenInfoDTO[] | undefined;
    proteinDetails?: ProteinDetailDTO[] | undefined;
    dropsInfo?: DropInfoDTO[] | undefined;
    setupTempratureId: number;
    canAddDropToContainer: boolean;
    incubationTempratureID: number;
    incubationTempratureIDs?: number[] | undefined;
    owner?: OwnerInfoDTO | undefined;
    experimentPlateContainerInfo?: PlateTypeDTO | undefined;
    imagingScheduleInfo?: ImagingScheduleInfoDTO | undefined;
}

export class ProteinDetailDTO implements IProteinDetailDTO {
    proteinVolume!: number;
    dropVolume!: number;
    dropNumber!: number;

    constructor(data?: IProteinDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proteinVolume = _data["proteinVolume"];
            this.dropVolume = _data["dropVolume"];
            this.dropNumber = _data["dropNumber"];
        }
    }

    static fromJS(data: any): ProteinDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proteinVolume"] = this.proteinVolume;
        data["dropVolume"] = this.dropVolume;
        data["dropNumber"] = this.dropNumber;
        return data;
    }
}

export interface IProteinDetailDTO {
    proteinVolume: number;
    dropVolume: number;
    dropNumber: number;
}

export class DropInfoDTO implements IDropInfoDTO {
    id!: number;
    name?: string | undefined;
    dropVolume!: number;
    dropNumber!: number;
    proteinInfo?: ProteinBaseInfoDTO | undefined;

    constructor(data?: IDropInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dropVolume = _data["dropVolume"];
            this.dropNumber = _data["dropNumber"];
            this.proteinInfo = _data["proteinInfo"] ? ProteinBaseInfoDTO.fromJS(_data["proteinInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): DropInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DropInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dropVolume"] = this.dropVolume;
        data["dropNumber"] = this.dropNumber;
        data["proteinInfo"] = this.proteinInfo ? this.proteinInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IDropInfoDTO {
    id: number;
    name?: string | undefined;
    dropVolume: number;
    dropNumber: number;
    proteinInfo?: ProteinBaseInfoDTO | undefined;
}

export class ProteinBaseInfoDTO implements IProteinBaseInfoDTO {
    id!: number;
    name?: string | undefined;
    volume!: number;

    constructor(data?: IProteinBaseInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): ProteinBaseInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinBaseInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["volume"] = this.volume;
        return data;
    }
}

export interface IProteinBaseInfoDTO {
    id: number;
    name?: string | undefined;
    volume: number;
}

export class OwnerInfoDTO implements IOwnerInfoDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IOwnerInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OwnerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IOwnerInfoDTO {
    id: number;
    name?: string | undefined;
}

export class ImagingScheduleInfoDTO implements IImagingScheduleInfoDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IImagingScheduleInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ImagingScheduleInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingScheduleInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IImagingScheduleInfoDTO {
    id: number;
    name?: string | undefined;
}

export class ObjectNameInfo implements IObjectNameInfo {
    name!: string;

    constructor(data?: IObjectNameInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ObjectNameInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectNameInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IObjectNameInfo {
    name: string;
}

export class ScreenExperimentTemplate extends ObjectNameInfo implements IScreenExperimentTemplate {
    _Screens!: ScreenInfo[];
    dropProteins!: DropInfo[];
    proteinDetails!: ProteinDetail[];
    canAddDropToContainer!: boolean;
    _SetupTempratureID!: number;
    _IncubationTempratureID!: number;
    _IncubationTemperatureIDs!: number[];
    ownerInfo!: OwnerInfo;
    _ExperimentPlateContainerInfo!: PlateContainerInfo;
    _ImagingScheduleInfo!: ImagingScheduleInfo;
    experimentNamePrefix!: string;
    experimentNameSuffix!: string;
    experimentNameFormatString!: string;

    constructor(data?: IScreenExperimentTemplate) {
        super(data);
        if (!data) {
            this._Screens = [];
            this.dropProteins = [];
            this.proteinDetails = [];
            this._IncubationTemperatureIDs = [];
            this.ownerInfo = new OwnerInfo();
            this._ExperimentPlateContainerInfo = new PlateContainerInfo();
            this._ImagingScheduleInfo = new ImagingScheduleInfo();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["_Screens"])) {
                this._Screens = [] as any;
                for (let item of _data["_Screens"])
                    this._Screens!.push(ScreenInfo.fromJS(item));
            }
            if (Array.isArray(_data["dropProteins"])) {
                this.dropProteins = [] as any;
                for (let item of _data["dropProteins"])
                    this.dropProteins!.push(DropInfo.fromJS(item));
            }
            if (Array.isArray(_data["proteinDetails"])) {
                this.proteinDetails = [] as any;
                for (let item of _data["proteinDetails"])
                    this.proteinDetails!.push(ProteinDetail.fromJS(item));
            }
            this.canAddDropToContainer = _data["canAddDropToContainer"];
            this._SetupTempratureID = _data["_SetupTempratureID"];
            this._IncubationTempratureID = _data["_IncubationTempratureID"];
            if (Array.isArray(_data["_IncubationTemperatureIDs"])) {
                this._IncubationTemperatureIDs = [] as any;
                for (let item of _data["_IncubationTemperatureIDs"])
                    this._IncubationTemperatureIDs!.push(item);
            }
            this.ownerInfo = _data["ownerInfo"] ? OwnerInfo.fromJS(_data["ownerInfo"]) : new OwnerInfo();
            this._ExperimentPlateContainerInfo = _data["_ExperimentPlateContainerInfo"] ? PlateContainerInfo.fromJS(_data["_ExperimentPlateContainerInfo"]) : new PlateContainerInfo();
            this._ImagingScheduleInfo = _data["_ImagingScheduleInfo"] ? ImagingScheduleInfo.fromJS(_data["_ImagingScheduleInfo"]) : new ImagingScheduleInfo();
            this.experimentNamePrefix = _data["experimentNamePrefix"];
            this.experimentNameSuffix = _data["experimentNameSuffix"];
            this.experimentNameFormatString = _data["experimentNameFormatString"];
        }
    }

    static override fromJS(data: any): ScreenExperimentTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenExperimentTemplate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this._Screens)) {
            data["_Screens"] = [];
            for (let item of this._Screens)
                data["_Screens"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dropProteins)) {
            data["dropProteins"] = [];
            for (let item of this.dropProteins)
                data["dropProteins"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.proteinDetails)) {
            data["proteinDetails"] = [];
            for (let item of this.proteinDetails)
                data["proteinDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["canAddDropToContainer"] = this.canAddDropToContainer;
        data["_SetupTempratureID"] = this._SetupTempratureID;
        data["_IncubationTempratureID"] = this._IncubationTempratureID;
        if (Array.isArray(this._IncubationTemperatureIDs)) {
            data["_IncubationTemperatureIDs"] = [];
            for (let item of this._IncubationTemperatureIDs)
                data["_IncubationTemperatureIDs"].push(item);
        }
        data["ownerInfo"] = this.ownerInfo ? this.ownerInfo.toJSON() : undefined as any;
        data["_ExperimentPlateContainerInfo"] = this._ExperimentPlateContainerInfo ? this._ExperimentPlateContainerInfo.toJSON() : undefined as any;
        data["_ImagingScheduleInfo"] = this._ImagingScheduleInfo ? this._ImagingScheduleInfo.toJSON() : undefined as any;
        data["experimentNamePrefix"] = this.experimentNamePrefix;
        data["experimentNameSuffix"] = this.experimentNameSuffix;
        data["experimentNameFormatString"] = this.experimentNameFormatString;
        super.toJSON(data);
        return data;
    }
}

export interface IScreenExperimentTemplate extends IObjectNameInfo {
    _Screens: ScreenInfo[];
    dropProteins: DropInfo[];
    proteinDetails: ProteinDetail[];
    canAddDropToContainer: boolean;
    _SetupTempratureID: number;
    _IncubationTempratureID: number;
    _IncubationTemperatureIDs: number[];
    ownerInfo: OwnerInfo;
    _ExperimentPlateContainerInfo: PlateContainerInfo;
    _ImagingScheduleInfo: ImagingScheduleInfo;
    experimentNamePrefix: string;
    experimentNameSuffix: string;
    experimentNameFormatString: string;
}

export class ObjectInfo extends ObjectNameInfo implements IObjectInfo {
    id!: number;

    constructor(data?: IObjectInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): ObjectInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IObjectInfo extends IObjectNameInfo {
    id: number;
}

export class ScreenInfo extends ObjectInfo implements IScreenInfo {
    screenLotID!: number;
    screenLotRows!: ScreenLotInfoDTO[];
    layerVolume!: number;

    constructor(data?: IScreenInfo) {
        super(data);
        if (!data) {
            this.screenLotRows = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.screenLotID = _data["screenLotID"];
            if (Array.isArray(_data["screenLotRows"])) {
                this.screenLotRows = [] as any;
                for (let item of _data["screenLotRows"])
                    this.screenLotRows!.push(ScreenLotInfoDTO.fromJS(item));
            }
            this.layerVolume = _data["layerVolume"];
        }
    }

    static override fromJS(data: any): ScreenInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["screenLotID"] = this.screenLotID;
        if (Array.isArray(this.screenLotRows)) {
            data["screenLotRows"] = [];
            for (let item of this.screenLotRows)
                data["screenLotRows"].push(item ? item.toJSON() : undefined as any);
        }
        data["layerVolume"] = this.layerVolume;
        super.toJSON(data);
        return data;
    }
}

export interface IScreenInfo extends IObjectInfo {
    screenLotID: number;
    screenLotRows: ScreenLotInfoDTO[];
    layerVolume: number;
}

export class DropInfo implements IDropInfo {
    dropVolume!: number;
    dropNumber!: number;
    proteinInfo!: ProteinInfo;

    constructor(data?: IDropInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.proteinInfo = new ProteinInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dropVolume = _data["dropVolume"];
            this.dropNumber = _data["dropNumber"];
            this.proteinInfo = _data["proteinInfo"] ? ProteinInfo.fromJS(_data["proteinInfo"]) : new ProteinInfo();
        }
    }

    static fromJS(data: any): DropInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DropInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dropVolume"] = this.dropVolume;
        data["dropNumber"] = this.dropNumber;
        data["proteinInfo"] = this.proteinInfo ? this.proteinInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IDropInfo {
    dropVolume: number;
    dropNumber: number;
    proteinInfo: ProteinInfo;
}

export class VolumatricObjectInfo extends ObjectInfo implements IVolumatricObjectInfo {
    volume!: number;

    constructor(data?: IVolumatricObjectInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.volume = _data["volume"];
        }
    }

    static override fromJS(data: any): VolumatricObjectInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VolumatricObjectInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volume"] = this.volume;
        super.toJSON(data);
        return data;
    }
}

export interface IVolumatricObjectInfo extends IObjectInfo {
    volume: number;
}

export class ProteinInfo extends VolumatricObjectInfo implements IProteinInfo {

    constructor(data?: IProteinInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProteinInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProteinInfo extends IVolumatricObjectInfo {
}

export class ProteinDetail implements IProteinDetail {
    proteinVolume!: number;
    dropVolume!: number;
    dropNumber!: number;

    constructor(data?: IProteinDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proteinVolume = _data["proteinVolume"];
            this.dropVolume = _data["dropVolume"];
            this.dropNumber = _data["dropNumber"];
        }
    }

    static fromJS(data: any): ProteinDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proteinVolume"] = this.proteinVolume;
        data["dropVolume"] = this.dropVolume;
        data["dropNumber"] = this.dropNumber;
        return data;
    }
}

export interface IProteinDetail {
    proteinVolume: number;
    dropVolume: number;
    dropNumber: number;
}

export class OwnerInfo extends ObjectInfo implements IOwnerInfo {

    constructor(data?: IOwnerInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OwnerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOwnerInfo extends IObjectInfo {
}

export class PlateContainerInfo extends VolumatricObjectInfo implements IPlateContainerInfo {
    dropVolume!: number;
    enabledDropNumbers!: number[];
    totalDrops!: number;

    constructor(data?: IPlateContainerInfo) {
        super(data);
        if (!data) {
            this.enabledDropNumbers = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dropVolume = _data["dropVolume"];
            if (Array.isArray(_data["enabledDropNumbers"])) {
                this.enabledDropNumbers = [] as any;
                for (let item of _data["enabledDropNumbers"])
                    this.enabledDropNumbers!.push(item);
            }
            this.totalDrops = _data["totalDrops"];
        }
    }

    static override fromJS(data: any): PlateContainerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PlateContainerInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dropVolume"] = this.dropVolume;
        if (Array.isArray(this.enabledDropNumbers)) {
            data["enabledDropNumbers"] = [];
            for (let item of this.enabledDropNumbers)
                data["enabledDropNumbers"].push(item);
        }
        data["totalDrops"] = this.totalDrops;
        super.toJSON(data);
        return data;
    }
}

export interface IPlateContainerInfo extends IVolumatricObjectInfo {
    dropVolume: number;
    enabledDropNumbers: number[];
    totalDrops: number;
}

export class ImagingScheduleInfo extends ObjectInfo implements IImagingScheduleInfo {

    constructor(data?: IImagingScheduleInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ImagingScheduleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingScheduleInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IImagingScheduleInfo extends IObjectInfo {
}

export class SaveScreenExpTemplateDTO implements ISaveScreenExpTemplateDTO {
    fileName?: string | undefined;
    screenExperimentTemplate?: ScreenExperimentTemplateDTO | undefined;

    constructor(data?: ISaveScreenExpTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.screenExperimentTemplate = _data["screenExperimentTemplate"] ? ScreenExperimentTemplateDTO.fromJS(_data["screenExperimentTemplate"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveScreenExpTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveScreenExpTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["screenExperimentTemplate"] = this.screenExperimentTemplate ? this.screenExperimentTemplate.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveScreenExpTemplateDTO {
    fileName?: string | undefined;
    screenExperimentTemplate?: ScreenExperimentTemplateDTO | undefined;
}

export class ResponseWithValueDTOOfExperimentDTO extends ResponseDTO implements IResponseWithValueDTOOfExperimentDTO {
    value?: ExperimentDTO | undefined;

    constructor(data?: IResponseWithValueDTOOfExperimentDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ExperimentDTO.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfExperimentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfExperimentDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfExperimentDTO extends IResponseDTO {
    value?: ExperimentDTO | undefined;
}

export class UpdateWizardTemplateDTO implements IUpdateWizardTemplateDTO {
    oldFileName?: string | undefined;
    newFileName?: string | undefined;

    constructor(data?: IUpdateWizardTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldFileName = _data["oldFileName"];
            this.newFileName = _data["newFileName"];
        }
    }

    static fromJS(data: any): UpdateWizardTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWizardTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldFileName"] = this.oldFileName;
        data["newFileName"] = this.newFileName;
        return data;
    }
}

export interface IUpdateWizardTemplateDTO {
    oldFileName?: string | undefined;
    newFileName?: string | undefined;
}

export class SearchResultsDTO implements ISearchResultsDTO {
    treeNodeId!: number;
    containerNodeid!: number;
    type?: string | undefined;
    plateId?: string | undefined;
    experimentId?: string | undefined;
    projectName?: string | undefined;
    fileName?: string | undefined;
    plateName?: string | undefined;
    owner?: string | undefined;
    barcode?: string | undefined;
    datePrepared?: string | undefined;
    synchrotronTripInfo?: SearchResultSynchrotronTripInfoDTO | undefined;
    experimentInfo?: SearchResultExperimentInfoDTO | undefined;
    fragmentScreenInfo?: SearchResultFragmentScreenInfoDTO | undefined;
    searchAnalysisInfo?: SearchResultSearchAnalysisInfoDTO | undefined;

    constructor(data?: ISearchResultsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNodeId = _data["treeNodeId"];
            this.containerNodeid = _data["containerNodeid"];
            this.type = _data["type"];
            this.plateId = _data["plateId"];
            this.experimentId = _data["experimentId"];
            this.projectName = _data["projectName"];
            this.fileName = _data["fileName"];
            this.plateName = _data["plateName"];
            this.owner = _data["owner"];
            this.barcode = _data["barcode"];
            this.datePrepared = _data["datePrepared"];
            this.synchrotronTripInfo = _data["synchrotronTripInfo"] ? SearchResultSynchrotronTripInfoDTO.fromJS(_data["synchrotronTripInfo"]) : undefined as any;
            this.experimentInfo = _data["experimentInfo"] ? SearchResultExperimentInfoDTO.fromJS(_data["experimentInfo"]) : undefined as any;
            this.fragmentScreenInfo = _data["fragmentScreenInfo"] ? SearchResultFragmentScreenInfoDTO.fromJS(_data["fragmentScreenInfo"]) : undefined as any;
            this.searchAnalysisInfo = _data["searchAnalysisInfo"] ? SearchResultSearchAnalysisInfoDTO.fromJS(_data["searchAnalysisInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): SearchResultsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNodeId"] = this.treeNodeId;
        data["containerNodeid"] = this.containerNodeid;
        data["type"] = this.type;
        data["plateId"] = this.plateId;
        data["experimentId"] = this.experimentId;
        data["projectName"] = this.projectName;
        data["fileName"] = this.fileName;
        data["plateName"] = this.plateName;
        data["owner"] = this.owner;
        data["barcode"] = this.barcode;
        data["datePrepared"] = this.datePrepared;
        data["synchrotronTripInfo"] = this.synchrotronTripInfo ? this.synchrotronTripInfo.toJSON() : undefined as any;
        data["experimentInfo"] = this.experimentInfo ? this.experimentInfo.toJSON() : undefined as any;
        data["fragmentScreenInfo"] = this.fragmentScreenInfo ? this.fragmentScreenInfo.toJSON() : undefined as any;
        data["searchAnalysisInfo"] = this.searchAnalysisInfo ? this.searchAnalysisInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface ISearchResultsDTO {
    treeNodeId: number;
    containerNodeid: number;
    type?: string | undefined;
    plateId?: string | undefined;
    experimentId?: string | undefined;
    projectName?: string | undefined;
    fileName?: string | undefined;
    plateName?: string | undefined;
    owner?: string | undefined;
    barcode?: string | undefined;
    datePrepared?: string | undefined;
    synchrotronTripInfo?: SearchResultSynchrotronTripInfoDTO | undefined;
    experimentInfo?: SearchResultExperimentInfoDTO | undefined;
    fragmentScreenInfo?: SearchResultFragmentScreenInfoDTO | undefined;
    searchAnalysisInfo?: SearchResultSearchAnalysisInfoDTO | undefined;
}

export class SearchResultSynchrotronTripInfoDTO implements ISearchResultSynchrotronTripInfoDTO {
    id!: number;
    status?: string | undefined;

    constructor(data?: ISearchResultSynchrotronTripInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SearchResultSynchrotronTripInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultSynchrotronTripInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface ISearchResultSynchrotronTripInfoDTO {
    id: number;
    status?: string | undefined;
}

export class SearchResultExperimentInfoDTO implements ISearchResultExperimentInfoDTO {
    plates?: PlateInfoDTO[] | undefined;
    state?: string | undefined;

    constructor(data?: ISearchResultExperimentInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plates"])) {
                this.plates = [] as any;
                for (let item of _data["plates"])
                    this.plates!.push(PlateInfoDTO.fromJS(item));
            }
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): SearchResultExperimentInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultExperimentInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plates)) {
            data["plates"] = [];
            for (let item of this.plates)
                data["plates"].push(item ? item.toJSON() : undefined as any);
        }
        data["state"] = this.state;
        return data;
    }
}

export interface ISearchResultExperimentInfoDTO {
    plates?: PlateInfoDTO[] | undefined;
    state?: string | undefined;
}

export class SearchResultFragmentScreenInfoDTO implements ISearchResultFragmentScreenInfoDTO {
    id!: number;

    constructor(data?: ISearchResultFragmentScreenInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SearchResultFragmentScreenInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultFragmentScreenInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISearchResultFragmentScreenInfoDTO {
    id: number;
}

export class SearchResultSearchAnalysisInfoDTO implements ISearchResultSearchAnalysisInfoDTO {
    id!: number;

    constructor(data?: ISearchResultSearchAnalysisInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SearchResultSearchAnalysisInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultSearchAnalysisInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISearchResultSearchAnalysisInfoDTO {
    id: number;
}

export class SearchDetailDTO implements ISearchDetailDTO {
    searchQuery?: string | undefined;
    fileName?: string | undefined;
    searchTarget?: SearchItemsTarget[] | undefined;
    ownerId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    locationTreeNodeIds?: number[] | undefined;
    searchLimit?: number | undefined;

    constructor(data?: ISearchDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchQuery = _data["searchQuery"];
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["searchTarget"])) {
                this.searchTarget = [] as any;
                for (let item of _data["searchTarget"])
                    this.searchTarget!.push(item);
            }
            this.ownerId = _data["ownerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined as any;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined as any;
            if (Array.isArray(_data["locationTreeNodeIds"])) {
                this.locationTreeNodeIds = [] as any;
                for (let item of _data["locationTreeNodeIds"])
                    this.locationTreeNodeIds!.push(item);
            }
            this.searchLimit = _data["searchLimit"];
        }
    }

    static fromJS(data: any): SearchDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchQuery"] = this.searchQuery;
        data["fileName"] = this.fileName;
        if (Array.isArray(this.searchTarget)) {
            data["searchTarget"] = [];
            for (let item of this.searchTarget)
                data["searchTarget"].push(item);
        }
        data["ownerId"] = this.ownerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined as any;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined as any;
        if (Array.isArray(this.locationTreeNodeIds)) {
            data["locationTreeNodeIds"] = [];
            for (let item of this.locationTreeNodeIds)
                data["locationTreeNodeIds"].push(item);
        }
        data["searchLimit"] = this.searchLimit;
        return data;
    }
}

export interface ISearchDetailDTO {
    searchQuery?: string | undefined;
    fileName?: string | undefined;
    searchTarget?: SearchItemsTarget[] | undefined;
    ownerId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    locationTreeNodeIds?: number[] | undefined;
    searchLimit?: number | undefined;
}

export enum SearchItemsTarget {
    ProjectNFolder = 0,
    Experiment = 1,
    Screen = 2,
    Protein = 3,
    Seed = 4,
    FragmentScreen = 5,
    SynchrotronTripv4 = 6,
    SearchAndFilter = 7,
}

export class RecentSearchDTO implements IRecentSearchDTO {
    searchDate!: Date;
    searchDetail?: SearchDetailDTO | undefined;
    id!: number;

    constructor(data?: IRecentSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchDate = _data["searchDate"] ? new Date(_data["searchDate"].toString()) : undefined as any;
            this.searchDetail = _data["searchDetail"] ? SearchDetailDTO.fromJS(_data["searchDetail"]) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RecentSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecentSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchDate"] = this.searchDate ? this.searchDate.toISOString() : undefined as any;
        data["searchDetail"] = this.searchDetail ? this.searchDetail.toJSON() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IRecentSearchDTO {
    searchDate: Date;
    searchDetail?: SearchDetailDTO | undefined;
    id: number;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class SearchTargetDTO implements ISearchTargetDTO {
    id!: number;
    name?: string | undefined;
    searchFields?: SearchFieldDTO[] | undefined;
    newSearchTarget!: boolean;
    isVisible!: boolean;

    constructor(data?: ISearchTargetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(SearchFieldDTO.fromJS(item));
            }
            this.newSearchTarget = _data["newSearchTarget"];
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): SearchTargetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTargetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["newSearchTarget"] = this.newSearchTarget;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface ISearchTargetDTO {
    id: number;
    name?: string | undefined;
    searchFields?: SearchFieldDTO[] | undefined;
    newSearchTarget: boolean;
    isVisible: boolean;
}

export class SearchFieldDTO implements ISearchFieldDTO {
    id!: number;
    name?: string | undefined;
    displayName?: string | undefined;
    tableName?: string | undefined;
    fieldAndTableDisplayName?: string | undefined;
    mandatory?: boolean | undefined;
    isDefault?: boolean | undefined;
    status?: number | undefined;
    fieldClass?: string | undefined;

    constructor(data?: ISearchFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.tableName = _data["tableName"];
            this.fieldAndTableDisplayName = _data["fieldAndTableDisplayName"];
            this.mandatory = _data["mandatory"];
            this.isDefault = _data["isDefault"];
            this.status = _data["status"];
            this.fieldClass = _data["fieldClass"];
        }
    }

    static fromJS(data: any): SearchFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["tableName"] = this.tableName;
        data["fieldAndTableDisplayName"] = this.fieldAndTableDisplayName;
        data["mandatory"] = this.mandatory;
        data["isDefault"] = this.isDefault;
        data["status"] = this.status;
        data["fieldClass"] = this.fieldClass;
        return data;
    }
}

export interface ISearchFieldDTO {
    id: number;
    name?: string | undefined;
    displayName?: string | undefined;
    tableName?: string | undefined;
    fieldAndTableDisplayName?: string | undefined;
    mandatory?: boolean | undefined;
    isDefault?: boolean | undefined;
    status?: number | undefined;
    fieldClass?: string | undefined;
}

export class SearchDTO implements ISearchDTO {
    id!: number;
    node?: SearchNodeDTO | undefined;
    searchTargetId!: number;
    constraints?: SearchConstraintRootDTO | undefined;
    displayFields?: SearchDisplayFieldDTO[] | undefined;
    searchPathTreeNodeIds?: number[] | undefined;
    rootTreeNodeId?: number | undefined;
    selectDistinct!: boolean;
    filters?: FilterDTO[] | undefined;
    selectedChartId?: number | undefined;
    accessRightName?: string | undefined;
    hasIndependentConstraints!: boolean;

    constructor(data?: ISearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.node = _data["node"] ? SearchNodeDTO.fromJS(_data["node"]) : undefined as any;
            this.searchTargetId = _data["searchTargetId"];
            this.constraints = _data["constraints"] ? SearchConstraintRootDTO.fromJS(_data["constraints"]) : undefined as any;
            if (Array.isArray(_data["displayFields"])) {
                this.displayFields = [] as any;
                for (let item of _data["displayFields"])
                    this.displayFields!.push(SearchDisplayFieldDTO.fromJS(item));
            }
            if (Array.isArray(_data["searchPathTreeNodeIds"])) {
                this.searchPathTreeNodeIds = [] as any;
                for (let item of _data["searchPathTreeNodeIds"])
                    this.searchPathTreeNodeIds!.push(item);
            }
            this.rootTreeNodeId = _data["rootTreeNodeId"];
            this.selectDistinct = _data["selectDistinct"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterDTO.fromJS(item));
            }
            this.selectedChartId = _data["selectedChartId"];
            this.accessRightName = _data["accessRightName"];
            this.hasIndependentConstraints = _data["hasIndependentConstraints"];
        }
    }

    static fromJS(data: any): SearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["node"] = this.node ? this.node.toJSON() : undefined as any;
        data["searchTargetId"] = this.searchTargetId;
        data["constraints"] = this.constraints ? this.constraints.toJSON() : undefined as any;
        if (Array.isArray(this.displayFields)) {
            data["displayFields"] = [];
            for (let item of this.displayFields)
                data["displayFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchPathTreeNodeIds)) {
            data["searchPathTreeNodeIds"] = [];
            for (let item of this.searchPathTreeNodeIds)
                data["searchPathTreeNodeIds"].push(item);
        }
        data["rootTreeNodeId"] = this.rootTreeNodeId;
        data["selectDistinct"] = this.selectDistinct;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        data["selectedChartId"] = this.selectedChartId;
        data["accessRightName"] = this.accessRightName;
        data["hasIndependentConstraints"] = this.hasIndependentConstraints;
        return data;
    }
}

export interface ISearchDTO {
    id: number;
    node?: SearchNodeDTO | undefined;
    searchTargetId: number;
    constraints?: SearchConstraintRootDTO | undefined;
    displayFields?: SearchDisplayFieldDTO[] | undefined;
    searchPathTreeNodeIds?: number[] | undefined;
    rootTreeNodeId?: number | undefined;
    selectDistinct: boolean;
    filters?: FilterDTO[] | undefined;
    selectedChartId?: number | undefined;
    accessRightName?: string | undefined;
    hasIndependentConstraints: boolean;
}

export class SearchNodeDTO implements ISearchNodeDTO {
    id?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    parentId?: number | undefined;
    allowEdits!: boolean;

    constructor(data?: ISearchNodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
            this.allowEdits = _data["allowEdits"];
        }
    }

    static fromJS(data: any): SearchNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        data["allowEdits"] = this.allowEdits;
        return data;
    }
}

export interface ISearchNodeDTO {
    id?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    parentId?: number | undefined;
    allowEdits: boolean;
}

export class SearchDisplayFieldDTO implements ISearchDisplayFieldDTO {
    id!: number;
    searchFieldId!: number;
    status!: SearchDisplayFieldStatus;
    columnHeader?: string | undefined;
    displayOrder!: number;

    constructor(data?: ISearchDisplayFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchFieldId = _data["searchFieldId"];
            this.status = _data["status"];
            this.columnHeader = _data["columnHeader"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): SearchDisplayFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDisplayFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchFieldId"] = this.searchFieldId;
        data["status"] = this.status;
        data["columnHeader"] = this.columnHeader;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ISearchDisplayFieldDTO {
    id: number;
    searchFieldId: number;
    status: SearchDisplayFieldStatus;
    columnHeader?: string | undefined;
    displayOrder: number;
}

export enum SearchDisplayFieldStatus {
    Display = 0,
    HiddenForIDs = 1,
    NotDisplay = 2,
}

export class FilterDTO implements IFilterDTO {
    id!: number;
    searchId!: number;
    searchFieldId!: number;
    values?: FilterValueDTO[] | undefined;

    constructor(data?: IFilterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchId = _data["searchId"];
            this.searchFieldId = _data["searchFieldId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(FilterValueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchId"] = this.searchId;
        data["searchFieldId"] = this.searchFieldId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterDTO {
    id: number;
    searchId: number;
    searchFieldId: number;
    values?: FilterValueDTO[] | undefined;
}

export class FilterValueDTO implements IFilterValueDTO {
    id!: number;
    filterId!: number;
    value?: string | undefined;

    constructor(data?: IFilterValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filterId = _data["filterId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FilterValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FilterValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filterId"] = this.filterId;
        data["value"] = this.value;
        return data;
    }
}

export interface IFilterValueDTO {
    id: number;
    filterId: number;
    value?: string | undefined;
}

export class SearchResultDTO implements ISearchResultDTO {
    searchRows?: { [key: string]: any; }[] | undefined;

    constructor(data?: ISearchResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchRows"])) {
                this.searchRows = [] as any;
                for (let item of _data["searchRows"])
                    this.searchRows!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchRows)) {
            data["searchRows"] = [];
            for (let item of this.searchRows)
                data["searchRows"].push(item);
        }
        return data;
    }
}

export interface ISearchResultDTO {
    searchRows?: { [key: string]: any; }[] | undefined;
}

export class SearchRequestDTO extends SearchDTO implements ISearchRequestDTO {
    pagination!: Pagination;
    selectedHitScoreIds?: number[] | undefined;
    countOnly!: boolean;

    constructor(data?: ISearchRequestDTO) {
        super(data);
        if (!data) {
            this.pagination = new Pagination();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : new Pagination();
            if (Array.isArray(_data["selectedHitScoreIds"])) {
                this.selectedHitScoreIds = [] as any;
                for (let item of _data["selectedHitScoreIds"])
                    this.selectedHitScoreIds!.push(item);
            }
            this.countOnly = _data["countOnly"];
        }
    }

    static override fromJS(data: any): SearchRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequestDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        if (Array.isArray(this.selectedHitScoreIds)) {
            data["selectedHitScoreIds"] = [];
            for (let item of this.selectedHitScoreIds)
                data["selectedHitScoreIds"].push(item);
        }
        data["countOnly"] = this.countOnly;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchRequestDTO extends ISearchDTO {
    pagination: Pagination;
    selectedHitScoreIds?: number[] | undefined;
    countOnly: boolean;
}

export class Pagination implements IPagination {
    page!: number;
    perPage!: number;

    constructor(data?: IPagination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.perPage = _data["perPage"];
        }
    }

    static fromJS(data: any): Pagination {
        data = typeof data === 'object' ? data : {};
        let result = new Pagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["perPage"] = this.perPage;
        return data;
    }
}

export interface IPagination {
    page: number;
    perPage: number;
}

export class ParentTreeNodeModel implements IParentTreeNodeModel {
    parentTreeNodeId!: number;
    defaultSearchPathId?: number | undefined;

    constructor(data?: IParentTreeNodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentTreeNodeId = _data["parentTreeNodeId"];
            this.defaultSearchPathId = _data["defaultSearchPathId"];
        }
    }

    static fromJS(data: any): ParentTreeNodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParentTreeNodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentTreeNodeId"] = this.parentTreeNodeId;
        data["defaultSearchPathId"] = this.defaultSearchPathId;
        return data;
    }
}

export interface IParentTreeNodeModel {
    parentTreeNodeId: number;
    defaultSearchPathId?: number | undefined;
}

export abstract class SearchFieldTypeDTO implements ISearchFieldTypeDTO {

    protected _discriminator: string;

    constructor(data?: ISearchFieldTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "SearchFieldTypeDTO";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SearchFieldTypeDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "IntegerSearchFieldDTO") {
            let result = new IntegerSearchFieldDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StringSearchFieldDTO") {
            let result = new StringSearchFieldDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RegionTypeSearchFieldDTO") {
            let result = new RegionTypeSearchFieldDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateSearchFieldDTO") {
            let result = new DateSearchFieldDTO();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'SearchFieldTypeDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        return data;
    }
}

export interface ISearchFieldTypeDTO {
}

export class IntegerSearchFieldDTO extends SearchFieldTypeDTO implements IIntegerSearchFieldDTO {
    values?: number[] | undefined;

    constructor(data?: IIntegerSearchFieldDTO) {
        super(data);
        this._discriminator = "IntegerSearchFieldDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static override fromJS(data: any): IntegerSearchFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IntegerSearchFieldDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIntegerSearchFieldDTO extends ISearchFieldTypeDTO {
    values?: number[] | undefined;
}

export class StringSearchFieldDTO extends SearchFieldTypeDTO implements IStringSearchFieldDTO {
    values?: string[] | undefined;

    constructor(data?: IStringSearchFieldDTO) {
        super(data);
        this._discriminator = "StringSearchFieldDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static override fromJS(data: any): StringSearchFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StringSearchFieldDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStringSearchFieldDTO extends ISearchFieldTypeDTO {
    values?: string[] | undefined;
}

export class RegionTypeSearchFieldDTO extends SearchFieldTypeDTO implements IRegionTypeSearchFieldDTO {
    values?: number[] | undefined;

    constructor(data?: IRegionTypeSearchFieldDTO) {
        super(data);
        this._discriminator = "RegionTypeSearchFieldDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static override fromJS(data: any): RegionTypeSearchFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionTypeSearchFieldDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRegionTypeSearchFieldDTO extends ISearchFieldTypeDTO {
    values?: number[] | undefined;
}

export class DateSearchFieldDTO extends SearchFieldTypeDTO implements IDateSearchFieldDTO {
    values?: Date[] | undefined;

    constructor(data?: IDateSearchFieldDTO) {
        super(data);
        this._discriminator = "DateSearchFieldDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(new Date(item));
            }
        }
    }

    static override fromJS(data: any): DateSearchFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DateSearchFieldDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toISOString());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDateSearchFieldDTO extends ISearchFieldTypeDTO {
    values?: Date[] | undefined;
}

export class FilterOptionsRequestDTO extends SearchDTO implements IFilterOptionsRequestDTO {
    selectedHitScoreIds?: number[] | undefined;
    searchFieldId!: number;

    constructor(data?: IFilterOptionsRequestDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["selectedHitScoreIds"])) {
                this.selectedHitScoreIds = [] as any;
                for (let item of _data["selectedHitScoreIds"])
                    this.selectedHitScoreIds!.push(item);
            }
            this.searchFieldId = _data["searchFieldId"];
        }
    }

    static override fromJS(data: any): FilterOptionsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOptionsRequestDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedHitScoreIds)) {
            data["selectedHitScoreIds"] = [];
            for (let item of this.selectedHitScoreIds)
                data["selectedHitScoreIds"].push(item);
        }
        data["searchFieldId"] = this.searchFieldId;
        super.toJSON(data);
        return data;
    }
}

export interface IFilterOptionsRequestDTO extends ISearchDTO {
    selectedHitScoreIds?: number[] | undefined;
    searchFieldId: number;
}

export class ChartDataRequestDTO extends SearchDTO implements IChartDataRequestDTO {
    selectedHitScoreIds?: number[] | undefined;
    chartId!: number;

    constructor(data?: IChartDataRequestDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["selectedHitScoreIds"])) {
                this.selectedHitScoreIds = [] as any;
                for (let item of _data["selectedHitScoreIds"])
                    this.selectedHitScoreIds!.push(item);
            }
            this.chartId = _data["chartId"];
        }
    }

    static override fromJS(data: any): ChartDataRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataRequestDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedHitScoreIds)) {
            data["selectedHitScoreIds"] = [];
            for (let item of this.selectedHitScoreIds)
                data["selectedHitScoreIds"].push(item);
        }
        data["chartId"] = this.chartId;
        super.toJSON(data);
        return data;
    }
}

export interface IChartDataRequestDTO extends ISearchDTO {
    selectedHitScoreIds?: number[] | undefined;
    chartId: number;
}

export class ChartDTO implements IChartDTO {
    id!: number;
    title?: string | undefined;
    xaxis?: string | undefined;
    yaxis?: string | undefined;
    series?: string | undefined;
    defaultChartType?: string | undefined;
    chartRequiredField?: ChartRequiredFieldDTO[] | undefined;

    constructor(data?: IChartDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.xaxis = _data["xaxis"];
            this.yaxis = _data["yaxis"];
            this.series = _data["series"];
            this.defaultChartType = _data["defaultChartType"];
            if (Array.isArray(_data["chartRequiredField"])) {
                this.chartRequiredField = [] as any;
                for (let item of _data["chartRequiredField"])
                    this.chartRequiredField!.push(ChartRequiredFieldDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChartDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["xaxis"] = this.xaxis;
        data["yaxis"] = this.yaxis;
        data["series"] = this.series;
        data["defaultChartType"] = this.defaultChartType;
        if (Array.isArray(this.chartRequiredField)) {
            data["chartRequiredField"] = [];
            for (let item of this.chartRequiredField)
                data["chartRequiredField"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChartDTO {
    id: number;
    title?: string | undefined;
    xaxis?: string | undefined;
    yaxis?: string | undefined;
    series?: string | undefined;
    defaultChartType?: string | undefined;
    chartRequiredField?: ChartRequiredFieldDTO[] | undefined;
}

export class ChartRequiredFieldDTO implements IChartRequiredFieldDTO {
    chartId!: number;
    searchFieldId!: number;

    constructor(data?: IChartRequiredFieldDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chartId = _data["chartId"];
            this.searchFieldId = _data["searchFieldId"];
        }
    }

    static fromJS(data: any): ChartRequiredFieldDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChartRequiredFieldDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chartId"] = this.chartId;
        data["searchFieldId"] = this.searchFieldId;
        return data;
    }
}

export interface IChartRequiredFieldDTO {
    chartId: number;
    searchFieldId: number;
}

export class SeedDTO implements ISeedDTO {
    id!: number;
    treeNodeId!: number;
    name?: string | undefined;
    dateCreated?: Date | undefined;
    plateId?: number | undefined;
    wellDropId!: number;
    proteinFormulationId?: number | undefined;
    wellSolutionWellId?: number | undefined;
    seedSolutionIngredientList?: SeedSolutionIngredientsDTO[] | undefined;
    notes?: string | undefined;
    seedWellDTOs?: SeedWellDTO[] | undefined;
    treeNode?: TreeNode | undefined;
    wellDropNumber!: number;
    wellList?: string | undefined;
    proteinFormulationDTO?: PFDocProteinFormulationDTO | undefined;
    selectedWells?: Well[] | undefined;
    latestInspectionId!: number;
    captureProfileId?: number | undefined;
    accessRightName?: string | undefined;

    constructor(data?: ISeedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.treeNodeId = _data["treeNodeId"];
            this.name = _data["name"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.plateId = _data["plateId"];
            this.wellDropId = _data["wellDropId"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.wellSolutionWellId = _data["wellSolutionWellId"];
            if (Array.isArray(_data["seedSolutionIngredientList"])) {
                this.seedSolutionIngredientList = [] as any;
                for (let item of _data["seedSolutionIngredientList"])
                    this.seedSolutionIngredientList!.push(SeedSolutionIngredientsDTO.fromJS(item));
            }
            this.notes = _data["notes"];
            if (Array.isArray(_data["seedWellDTOs"])) {
                this.seedWellDTOs = [] as any;
                for (let item of _data["seedWellDTOs"])
                    this.seedWellDTOs!.push(SeedWellDTO.fromJS(item));
            }
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            this.wellDropNumber = _data["wellDropNumber"];
            this.wellList = _data["wellList"];
            this.proteinFormulationDTO = _data["proteinFormulationDTO"] ? PFDocProteinFormulationDTO.fromJS(_data["proteinFormulationDTO"]) : undefined as any;
            if (Array.isArray(_data["selectedWells"])) {
                this.selectedWells = [] as any;
                for (let item of _data["selectedWells"])
                    this.selectedWells!.push(Well.fromJS(item));
            }
            this.latestInspectionId = _data["latestInspectionId"];
            this.captureProfileId = _data["captureProfileId"];
            this.accessRightName = _data["accessRightName"];
        }
    }

    static fromJS(data: any): SeedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["treeNodeId"] = this.treeNodeId;
        data["name"] = this.name;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["plateId"] = this.plateId;
        data["wellDropId"] = this.wellDropId;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["wellSolutionWellId"] = this.wellSolutionWellId;
        if (Array.isArray(this.seedSolutionIngredientList)) {
            data["seedSolutionIngredientList"] = [];
            for (let item of this.seedSolutionIngredientList)
                data["seedSolutionIngredientList"].push(item ? item.toJSON() : undefined as any);
        }
        data["notes"] = this.notes;
        if (Array.isArray(this.seedWellDTOs)) {
            data["seedWellDTOs"] = [];
            for (let item of this.seedWellDTOs)
                data["seedWellDTOs"].push(item ? item.toJSON() : undefined as any);
        }
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        data["wellDropNumber"] = this.wellDropNumber;
        data["wellList"] = this.wellList;
        data["proteinFormulationDTO"] = this.proteinFormulationDTO ? this.proteinFormulationDTO.toJSON() : undefined as any;
        if (Array.isArray(this.selectedWells)) {
            data["selectedWells"] = [];
            for (let item of this.selectedWells)
                data["selectedWells"].push(item ? item.toJSON() : undefined as any);
        }
        data["latestInspectionId"] = this.latestInspectionId;
        data["captureProfileId"] = this.captureProfileId;
        data["accessRightName"] = this.accessRightName;
        return data;
    }
}

export interface ISeedDTO {
    id: number;
    treeNodeId: number;
    name?: string | undefined;
    dateCreated?: Date | undefined;
    plateId?: number | undefined;
    wellDropId: number;
    proteinFormulationId?: number | undefined;
    wellSolutionWellId?: number | undefined;
    seedSolutionIngredientList?: SeedSolutionIngredientsDTO[] | undefined;
    notes?: string | undefined;
    seedWellDTOs?: SeedWellDTO[] | undefined;
    treeNode?: TreeNode | undefined;
    wellDropNumber: number;
    wellList?: string | undefined;
    proteinFormulationDTO?: PFDocProteinFormulationDTO | undefined;
    selectedWells?: Well[] | undefined;
    latestInspectionId: number;
    captureProfileId?: number | undefined;
    accessRightName?: string | undefined;
}

export class SeedSolutionIngredientsDTO implements ISeedSolutionIngredientsDTO {
    seedId!: number;
    type?: string | undefined;
    name?: string | undefined;
    concentration?: number | undefined;
    concentrationUnit?: string | undefined;

    constructor(data?: ISeedSolutionIngredientsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedId = _data["seedId"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.concentration = _data["concentration"];
            this.concentrationUnit = _data["concentrationUnit"];
        }
    }

    static fromJS(data: any): SeedSolutionIngredientsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeedSolutionIngredientsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedId"] = this.seedId;
        data["type"] = this.type;
        data["name"] = this.name;
        data["concentration"] = this.concentration;
        data["concentrationUnit"] = this.concentrationUnit;
        return data;
    }
}

export interface ISeedSolutionIngredientsDTO {
    seedId: number;
    type?: string | undefined;
    name?: string | undefined;
    concentration?: number | undefined;
    concentrationUnit?: string | undefined;
}

export class SeedWellDTO implements ISeedWellDTO {
    seedID?: number | undefined;
    wellId?: number | undefined;
    wellNumber!: number;
    wellDropRegionId!: number;

    constructor(data?: ISeedWellDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedID = _data["seedID"];
            this.wellId = _data["wellId"];
            this.wellNumber = _data["wellNumber"];
            this.wellDropRegionId = _data["wellDropRegionId"];
        }
    }

    static fromJS(data: any): SeedWellDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeedWellDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedID"] = this.seedID;
        data["wellId"] = this.wellId;
        data["wellNumber"] = this.wellNumber;
        data["wellDropRegionId"] = this.wellDropRegionId;
        return data;
    }
}

export interface ISeedWellDTO {
    seedID?: number | undefined;
    wellId?: number | undefined;
    wellNumber: number;
    wellDropRegionId: number;
}

export class SeedInfoDTO implements ISeedInfoDTO {
    seedName?: string | undefined;
    sourceWellRow?: string | undefined;
    sourceWellNames?: string[] | undefined;
    sourceExperimentName?: string | undefined;
    sourcePlateId?: number | undefined;
    seedId!: number;
    sourceDropNumber!: number;
    sourceWellColumn!: number;

    constructor(data?: ISeedInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seedName = _data["seedName"];
            this.sourceWellRow = _data["sourceWellRow"];
            if (Array.isArray(_data["sourceWellNames"])) {
                this.sourceWellNames = [] as any;
                for (let item of _data["sourceWellNames"])
                    this.sourceWellNames!.push(item);
            }
            this.sourceExperimentName = _data["sourceExperimentName"];
            this.sourcePlateId = _data["sourcePlateId"];
            this.seedId = _data["seedId"];
            this.sourceDropNumber = _data["sourceDropNumber"];
            this.sourceWellColumn = _data["sourceWellColumn"];
        }
    }

    static fromJS(data: any): SeedInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeedInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedName"] = this.seedName;
        data["sourceWellRow"] = this.sourceWellRow;
        if (Array.isArray(this.sourceWellNames)) {
            data["sourceWellNames"] = [];
            for (let item of this.sourceWellNames)
                data["sourceWellNames"].push(item);
        }
        data["sourceExperimentName"] = this.sourceExperimentName;
        data["sourcePlateId"] = this.sourcePlateId;
        data["seedId"] = this.seedId;
        data["sourceDropNumber"] = this.sourceDropNumber;
        data["sourceWellColumn"] = this.sourceWellColumn;
        return data;
    }
}

export interface ISeedInfoDTO {
    seedName?: string | undefined;
    sourceWellRow?: string | undefined;
    sourceWellNames?: string[] | undefined;
    sourceExperimentName?: string | undefined;
    sourcePlateId?: number | undefined;
    seedId: number;
    sourceDropNumber: number;
    sourceWellColumn: number;
}

export class SoakingDTO implements ISoakingDTO {
    id!: number;
    ingredient?: string | undefined;
    conc!: number;
    concUnit?: string | undefined;
    time!: number;
    timeUnit!: string;
    textInfo?: string | undefined;
    userId!: number;

    constructor(data?: ISoakingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredient = _data["ingredient"];
            this.conc = _data["conc"];
            this.concUnit = _data["concUnit"];
            this.time = _data["time"];
            this.timeUnit = _data["timeUnit"];
            this.textInfo = _data["textInfo"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): SoakingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SoakingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredient"] = this.ingredient;
        data["conc"] = this.conc;
        data["concUnit"] = this.concUnit;
        data["time"] = this.time;
        data["timeUnit"] = this.timeUnit;
        data["textInfo"] = this.textInfo;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ISoakingDTO {
    id: number;
    ingredient?: string | undefined;
    conc: number;
    concUnit?: string | undefined;
    time: number;
    timeUnit: string;
    textInfo?: string | undefined;
    userId: number;
}

export class CrystalSoakingDTO implements ICrystalSoakingDTO {
    id!: number;
    crystalId!: number;
    soakingId!: number;

    constructor(data?: ICrystalSoakingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crystalId = _data["crystalId"];
            this.soakingId = _data["soakingId"];
        }
    }

    static fromJS(data: any): CrystalSoakingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrystalSoakingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crystalId"] = this.crystalId;
        data["soakingId"] = this.soakingId;
        return data;
    }
}

export interface ICrystalSoakingDTO {
    id: number;
    crystalId: number;
    soakingId: number;
}

export class StorageInfoTaskDTO implements IStorageInfoTaskDTO {
    id?: string | undefined;
    taskName?: string | undefined;
    treeNodeIds?: number[] | undefined;

    constructor(data?: IStorageInfoTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            if (Array.isArray(_data["treeNodeIds"])) {
                this.treeNodeIds = [] as any;
                for (let item of _data["treeNodeIds"])
                    this.treeNodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): StorageInfoTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StorageInfoTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        if (Array.isArray(this.treeNodeIds)) {
            data["treeNodeIds"] = [];
            for (let item of this.treeNodeIds)
                data["treeNodeIds"].push(item);
        }
        return data;
    }
}

export interface IStorageInfoTaskDTO {
    id?: string | undefined;
    taskName?: string | undefined;
    treeNodeIds?: number[] | undefined;
}

export class DataBaseSizeDTO implements IDataBaseSizeDTO {
    totalDbSize?: string | undefined;

    constructor(data?: IDataBaseSizeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalDbSize = _data["totalDbSize"];
        }
    }

    static fromJS(data: any): DataBaseSizeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DataBaseSizeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalDbSize"] = this.totalDbSize;
        return data;
    }
}

export interface IDataBaseSizeDTO {
    totalDbSize?: string | undefined;
}

export class DatabaseSizeAlertDTO implements IDatabaseSizeAlertDTO {
    isExpressEdition!: boolean;
    databaseSizeMB!: number;
    maxSizeMB!: number;
    usagePercentage!: number;
    isNearLimit!: boolean;

    constructor(data?: IDatabaseSizeAlertDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isExpressEdition = _data["isExpressEdition"];
            this.databaseSizeMB = _data["databaseSizeMB"];
            this.maxSizeMB = _data["maxSizeMB"];
            this.usagePercentage = _data["usagePercentage"];
            this.isNearLimit = _data["isNearLimit"];
        }
    }

    static fromJS(data: any): DatabaseSizeAlertDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseSizeAlertDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExpressEdition"] = this.isExpressEdition;
        data["databaseSizeMB"] = this.databaseSizeMB;
        data["maxSizeMB"] = this.maxSizeMB;
        data["usagePercentage"] = this.usagePercentage;
        data["isNearLimit"] = this.isNearLimit;
        return data;
    }
}

export interface IDatabaseSizeAlertDTO {
    isExpressEdition: boolean;
    databaseSizeMB: number;
    maxSizeMB: number;
    usagePercentage: number;
    isNearLimit: boolean;
}

export class SynchTripDTO implements ISynchTripDTO {
    id!: number;
    dataCollectionDate!: Date;
    beamLine?: string | undefined;
    detectorType?: string | undefined;
    contactPerson?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    treeNodeId!: number;
    parentTreeNodeId!: number;
    synchTripName?: string | undefined;
    ownerUserId!: number;
    status!: number;
    assignedCrystals?: CrystalDTO[] | undefined;
    accessRightName?: string | undefined;

    constructor(data?: ISynchTripDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataCollectionDate = _data["dataCollectionDate"] ? new Date(_data["dataCollectionDate"].toString()) : undefined as any;
            this.beamLine = _data["beamLine"];
            this.detectorType = _data["detectorType"];
            this.contactPerson = _data["contactPerson"];
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
            this.treeNodeId = _data["treeNodeId"];
            this.parentTreeNodeId = _data["parentTreeNodeId"];
            this.synchTripName = _data["synchTripName"];
            this.ownerUserId = _data["ownerUserId"];
            this.status = _data["status"];
            if (Array.isArray(_data["assignedCrystals"])) {
                this.assignedCrystals = [] as any;
                for (let item of _data["assignedCrystals"])
                    this.assignedCrystals!.push(CrystalDTO.fromJS(item));
            }
            this.accessRightName = _data["accessRightName"];
        }
    }

    static fromJS(data: any): SynchTripDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataCollectionDate"] = this.dataCollectionDate ? this.dataCollectionDate.toISOString() : undefined as any;
        data["beamLine"] = this.beamLine;
        data["detectorType"] = this.detectorType;
        data["contactPerson"] = this.contactPerson;
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        data["treeNodeId"] = this.treeNodeId;
        data["parentTreeNodeId"] = this.parentTreeNodeId;
        data["synchTripName"] = this.synchTripName;
        data["ownerUserId"] = this.ownerUserId;
        data["status"] = this.status;
        if (Array.isArray(this.assignedCrystals)) {
            data["assignedCrystals"] = [];
            for (let item of this.assignedCrystals)
                data["assignedCrystals"].push(item ? item.toJSON() : undefined as any);
        }
        data["accessRightName"] = this.accessRightName;
        return data;
    }
}

export interface ISynchTripDTO {
    id: number;
    dataCollectionDate: Date;
    beamLine?: string | undefined;
    detectorType?: string | undefined;
    contactPerson?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    treeNodeId: number;
    parentTreeNodeId: number;
    synchTripName?: string | undefined;
    ownerUserId: number;
    status: number;
    assignedCrystals?: CrystalDTO[] | undefined;
    accessRightName?: string | undefined;
}

export class SynchTripsNodeInfoDTO implements ISynchTripsNodeInfoDTO {
    totalTrips!: number;
    upcomingTrips!: number;
    pastTrips!: number;

    constructor(data?: ISynchTripsNodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTrips = _data["totalTrips"];
            this.upcomingTrips = _data["upcomingTrips"];
            this.pastTrips = _data["pastTrips"];
        }
    }

    static fromJS(data: any): SynchTripsNodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripsNodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTrips"] = this.totalTrips;
        data["upcomingTrips"] = this.upcomingTrips;
        data["pastTrips"] = this.pastTrips;
        return data;
    }
}

export interface ISynchTripsNodeInfoDTO {
    totalTrips: number;
    upcomingTrips: number;
    pastTrips: number;
}

export class SynchTripExportDTO implements ISynchTripExportDTO {
    synchTripId!: number;
    crystalIds?: number[] | undefined;

    constructor(data?: ISynchTripExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.synchTripId = _data["synchTripId"];
            if (Array.isArray(_data["crystalIds"])) {
                this.crystalIds = [] as any;
                for (let item of _data["crystalIds"])
                    this.crystalIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SynchTripExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["synchTripId"] = this.synchTripId;
        if (Array.isArray(this.crystalIds)) {
            data["crystalIds"] = [];
            for (let item of this.crystalIds)
                data["crystalIds"].push(item);
        }
        return data;
    }
}

export interface ISynchTripExportDTO {
    synchTripId: number;
    crystalIds?: number[] | undefined;
}

export class SynchTripResultExportDTO implements ISynchTripResultExportDTO {
    crystalId!: number;
    crystalName?: string | undefined;
    puckBarcode?: string | undefined;
    puckPinPostion?: number | undefined;
    synchTripId!: number;
    synchTripName?: string | undefined;
    dateFrozen?: string | undefined;
    crystalNameInternal?: string | undefined;
    symm?: string | undefined;
    xtalRun?: string | undefined;
    resoLow?: string | undefined;
    hiShells?: string | undefined;
    cellA?: string | undefined;
    cellB?: string | undefined;
    cellC?: string | undefined;
    cellAlpha?: string | undefined;
    cellBeta?: string | undefined;
    cellGamma?: string | undefined;
    raddamRFree?: string | undefined;
    e21?: string | undefined;
    compEll?: string | undefined;
    compSph?: string | undefined;
    rMeas?: string | undefined;
    foFC?: string | undefined;
    multiplicity?: string | undefined;
    cc12?: string | undefined;
    iSigma?: string | undefined;
    refinementProgram?: string | undefined;
    resultNotes?: string | undefined;
    resultStatus?: string | undefined;

    constructor(data?: ISynchTripResultExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crystalId = _data["crystalId"];
            this.crystalName = _data["crystalName"];
            this.puckBarcode = _data["puckBarcode"];
            this.puckPinPostion = _data["puckPinPostion"];
            this.synchTripId = _data["synchTripId"];
            this.synchTripName = _data["synchTripName"];
            this.dateFrozen = _data["dateFrozen"];
            this.crystalNameInternal = _data["crystalNameInternal"];
            this.symm = _data["symm"];
            this.xtalRun = _data["xtalRun"];
            this.resoLow = _data["resoLow"];
            this.hiShells = _data["hiShells"];
            this.cellA = _data["cellA"];
            this.cellB = _data["cellB"];
            this.cellC = _data["cellC"];
            this.cellAlpha = _data["cellAlpha"];
            this.cellBeta = _data["cellBeta"];
            this.cellGamma = _data["cellGamma"];
            this.raddamRFree = _data["raddamRFree"];
            this.e21 = _data["e21"];
            this.compEll = _data["compEll"];
            this.compSph = _data["compSph"];
            this.rMeas = _data["rMeas"];
            this.foFC = _data["foFC"];
            this.multiplicity = _data["multiplicity"];
            this.cc12 = _data["cc12"];
            this.iSigma = _data["iSigma"];
            this.refinementProgram = _data["refinementProgram"];
            this.resultNotes = _data["resultNotes"];
            this.resultStatus = _data["resultStatus"];
        }
    }

    static fromJS(data: any): SynchTripResultExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripResultExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crystalId"] = this.crystalId;
        data["crystalName"] = this.crystalName;
        data["puckBarcode"] = this.puckBarcode;
        data["puckPinPostion"] = this.puckPinPostion;
        data["synchTripId"] = this.synchTripId;
        data["synchTripName"] = this.synchTripName;
        data["dateFrozen"] = this.dateFrozen;
        data["crystalNameInternal"] = this.crystalNameInternal;
        data["symm"] = this.symm;
        data["xtalRun"] = this.xtalRun;
        data["resoLow"] = this.resoLow;
        data["hiShells"] = this.hiShells;
        data["cellA"] = this.cellA;
        data["cellB"] = this.cellB;
        data["cellC"] = this.cellC;
        data["cellAlpha"] = this.cellAlpha;
        data["cellBeta"] = this.cellBeta;
        data["cellGamma"] = this.cellGamma;
        data["raddamRFree"] = this.raddamRFree;
        data["e21"] = this.e21;
        data["compEll"] = this.compEll;
        data["compSph"] = this.compSph;
        data["rMeas"] = this.rMeas;
        data["foFC"] = this.foFC;
        data["multiplicity"] = this.multiplicity;
        data["cc12"] = this.cc12;
        data["iSigma"] = this.iSigma;
        data["refinementProgram"] = this.refinementProgram;
        data["resultNotes"] = this.resultNotes;
        data["resultStatus"] = this.resultStatus;
        return data;
    }
}

export interface ISynchTripResultExportDTO {
    crystalId: number;
    crystalName?: string | undefined;
    puckBarcode?: string | undefined;
    puckPinPostion?: number | undefined;
    synchTripId: number;
    synchTripName?: string | undefined;
    dateFrozen?: string | undefined;
    crystalNameInternal?: string | undefined;
    symm?: string | undefined;
    xtalRun?: string | undefined;
    resoLow?: string | undefined;
    hiShells?: string | undefined;
    cellA?: string | undefined;
    cellB?: string | undefined;
    cellC?: string | undefined;
    cellAlpha?: string | undefined;
    cellBeta?: string | undefined;
    cellGamma?: string | undefined;
    raddamRFree?: string | undefined;
    e21?: string | undefined;
    compEll?: string | undefined;
    compSph?: string | undefined;
    rMeas?: string | undefined;
    foFC?: string | undefined;
    multiplicity?: string | undefined;
    cc12?: string | undefined;
    iSigma?: string | undefined;
    refinementProgram?: string | undefined;
    resultNotes?: string | undefined;
    resultStatus?: string | undefined;
}

export class SynchTripImportDTO implements ISynchTripImportDTO {
    crystalName?: string | undefined;
    crystalId!: number;
    puckName?: string | undefined;
    puckType?: string | undefined;
    puckBarcode?: string | undefined;
    puckPinPosition!: number;
    dewarId!: number;
    dewarName?: string | undefined;
    synchTripName?: string | undefined;
    synchTripId!: number;
    crystalTripId!: number;
    puckDewarId!: number;
    errorMessage?: string | undefined;
    puckId!: number;
    dataCollectionDate?: Date | undefined;

    constructor(data?: ISynchTripImportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crystalName = _data["crystalName"];
            this.crystalId = _data["crystalId"];
            this.puckName = _data["puckName"];
            this.puckType = _data["puckType"];
            this.puckBarcode = _data["puckBarcode"];
            this.puckPinPosition = _data["puckPinPosition"];
            this.dewarId = _data["dewarId"];
            this.dewarName = _data["dewarName"];
            this.synchTripName = _data["synchTripName"];
            this.synchTripId = _data["synchTripId"];
            this.crystalTripId = _data["crystalTripId"];
            this.puckDewarId = _data["puckDewarId"];
            this.errorMessage = _data["errorMessage"];
            this.puckId = _data["puckId"];
            this.dataCollectionDate = _data["dataCollectionDate"] ? new Date(_data["dataCollectionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SynchTripImportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripImportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crystalName"] = this.crystalName;
        data["crystalId"] = this.crystalId;
        data["puckName"] = this.puckName;
        data["puckType"] = this.puckType;
        data["puckBarcode"] = this.puckBarcode;
        data["puckPinPosition"] = this.puckPinPosition;
        data["dewarId"] = this.dewarId;
        data["dewarName"] = this.dewarName;
        data["synchTripName"] = this.synchTripName;
        data["synchTripId"] = this.synchTripId;
        data["crystalTripId"] = this.crystalTripId;
        data["puckDewarId"] = this.puckDewarId;
        data["errorMessage"] = this.errorMessage;
        data["puckId"] = this.puckId;
        data["dataCollectionDate"] = this.dataCollectionDate ? this.dataCollectionDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISynchTripImportDTO {
    crystalName?: string | undefined;
    crystalId: number;
    puckName?: string | undefined;
    puckType?: string | undefined;
    puckBarcode?: string | undefined;
    puckPinPosition: number;
    dewarId: number;
    dewarName?: string | undefined;
    synchTripName?: string | undefined;
    synchTripId: number;
    crystalTripId: number;
    puckDewarId: number;
    errorMessage?: string | undefined;
    puckId: number;
    dataCollectionDate?: Date | undefined;
}

export class SynchTripImportPayload implements ISynchTripImportPayload {
    tripId!: number;
    importData?: SynchTripImportDTO[] | undefined;

    constructor(data?: ISynchTripImportPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripId = _data["tripId"];
            if (Array.isArray(_data["importData"])) {
                this.importData = [] as any;
                for (let item of _data["importData"])
                    this.importData!.push(SynchTripImportDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SynchTripImportPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripImportPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripId"] = this.tripId;
        if (Array.isArray(this.importData)) {
            data["importData"] = [];
            for (let item of this.importData)
                data["importData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISynchTripImportPayload {
    tripId: number;
    importData?: SynchTripImportDTO[] | undefined;
}

export class SynchTripResultImportDTO implements ISynchTripResultImportDTO {
    id!: number;
    crystalId!: number;
    crystalName?: string | undefined;
    puckBarcode?: string | undefined;
    puckPinPostion?: number | undefined;
    synchTripId!: number;
    synchTripName?: string | undefined;
    dateFrozen?: string | undefined;
    crystalNameInternal?: string | undefined;
    symm?: string | undefined;
    xtalRun?: string | undefined;
    resoLow?: string | undefined;
    hiShells?: string | undefined;
    cellA?: string | undefined;
    cellB?: string | undefined;
    cellC?: string | undefined;
    cellAlpha?: string | undefined;
    cellBeta?: string | undefined;
    cellGamma?: string | undefined;
    raddamRFree?: string | undefined;
    e21?: string | undefined;
    compEll?: string | undefined;
    compSph?: string | undefined;
    rMeas?: string | undefined;
    foFC?: string | undefined;
    multiplicity?: string | undefined;
    cc12?: string | undefined;
    iSigma?: string | undefined;
    refinementProgram?: string | undefined;
    resultNotes?: string | undefined;
    resultStatus?: string | undefined;
    isDataInvalid!: boolean;
    validationMessage?: string | undefined;
    crystalTripId!: number;

    constructor(data?: ISynchTripResultImportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crystalId = _data["crystalId"];
            this.crystalName = _data["crystalName"];
            this.puckBarcode = _data["puckBarcode"];
            this.puckPinPostion = _data["puckPinPostion"];
            this.synchTripId = _data["synchTripId"];
            this.synchTripName = _data["synchTripName"];
            this.dateFrozen = _data["dateFrozen"];
            this.crystalNameInternal = _data["crystalNameInternal"];
            this.symm = _data["symm"];
            this.xtalRun = _data["xtalRun"];
            this.resoLow = _data["resoLow"];
            this.hiShells = _data["hiShells"];
            this.cellA = _data["cellA"];
            this.cellB = _data["cellB"];
            this.cellC = _data["cellC"];
            this.cellAlpha = _data["cellAlpha"];
            this.cellBeta = _data["cellBeta"];
            this.cellGamma = _data["cellGamma"];
            this.raddamRFree = _data["raddamRFree"];
            this.e21 = _data["e21"];
            this.compEll = _data["compEll"];
            this.compSph = _data["compSph"];
            this.rMeas = _data["rMeas"];
            this.foFC = _data["foFC"];
            this.multiplicity = _data["multiplicity"];
            this.cc12 = _data["cc12"];
            this.iSigma = _data["iSigma"];
            this.refinementProgram = _data["refinementProgram"];
            this.resultNotes = _data["resultNotes"];
            this.resultStatus = _data["resultStatus"];
            this.isDataInvalid = _data["isDataInvalid"];
            this.validationMessage = _data["validationMessage"];
            this.crystalTripId = _data["crystalTripId"];
        }
    }

    static fromJS(data: any): SynchTripResultImportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripResultImportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crystalId"] = this.crystalId;
        data["crystalName"] = this.crystalName;
        data["puckBarcode"] = this.puckBarcode;
        data["puckPinPostion"] = this.puckPinPostion;
        data["synchTripId"] = this.synchTripId;
        data["synchTripName"] = this.synchTripName;
        data["dateFrozen"] = this.dateFrozen;
        data["crystalNameInternal"] = this.crystalNameInternal;
        data["symm"] = this.symm;
        data["xtalRun"] = this.xtalRun;
        data["resoLow"] = this.resoLow;
        data["hiShells"] = this.hiShells;
        data["cellA"] = this.cellA;
        data["cellB"] = this.cellB;
        data["cellC"] = this.cellC;
        data["cellAlpha"] = this.cellAlpha;
        data["cellBeta"] = this.cellBeta;
        data["cellGamma"] = this.cellGamma;
        data["raddamRFree"] = this.raddamRFree;
        data["e21"] = this.e21;
        data["compEll"] = this.compEll;
        data["compSph"] = this.compSph;
        data["rMeas"] = this.rMeas;
        data["foFC"] = this.foFC;
        data["multiplicity"] = this.multiplicity;
        data["cc12"] = this.cc12;
        data["iSigma"] = this.iSigma;
        data["refinementProgram"] = this.refinementProgram;
        data["resultNotes"] = this.resultNotes;
        data["resultStatus"] = this.resultStatus;
        data["isDataInvalid"] = this.isDataInvalid;
        data["validationMessage"] = this.validationMessage;
        data["crystalTripId"] = this.crystalTripId;
        return data;
    }
}

export interface ISynchTripResultImportDTO {
    id: number;
    crystalId: number;
    crystalName?: string | undefined;
    puckBarcode?: string | undefined;
    puckPinPostion?: number | undefined;
    synchTripId: number;
    synchTripName?: string | undefined;
    dateFrozen?: string | undefined;
    crystalNameInternal?: string | undefined;
    symm?: string | undefined;
    xtalRun?: string | undefined;
    resoLow?: string | undefined;
    hiShells?: string | undefined;
    cellA?: string | undefined;
    cellB?: string | undefined;
    cellC?: string | undefined;
    cellAlpha?: string | undefined;
    cellBeta?: string | undefined;
    cellGamma?: string | undefined;
    raddamRFree?: string | undefined;
    e21?: string | undefined;
    compEll?: string | undefined;
    compSph?: string | undefined;
    rMeas?: string | undefined;
    foFC?: string | undefined;
    multiplicity?: string | undefined;
    cc12?: string | undefined;
    iSigma?: string | undefined;
    refinementProgram?: string | undefined;
    resultNotes?: string | undefined;
    resultStatus?: string | undefined;
    isDataInvalid: boolean;
    validationMessage?: string | undefined;
    crystalTripId: number;
}

export class SynchTripsExpReportDTO implements ISynchTripsExpReportDTO {
    expId!: number;
    synchTripIds?: number[] | undefined;

    constructor(data?: ISynchTripsExpReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expId = _data["expId"];
            if (Array.isArray(_data["synchTripIds"])) {
                this.synchTripIds = [] as any;
                for (let item of _data["synchTripIds"])
                    this.synchTripIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SynchTripsExpReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SynchTripsExpReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expId"] = this.expId;
        if (Array.isArray(this.synchTripIds)) {
            data["synchTripIds"] = [];
            for (let item of this.synchTripIds)
                data["synchTripIds"].push(item);
        }
        return data;
    }
}

export interface ISynchTripsExpReportDTO {
    expId: number;
    synchTripIds?: number[] | undefined;
}

export class ExperimentReportJobStartRequestDTO implements IExperimentReportJobStartRequestDTO {
    jobId?: string | undefined;
    experimentIds?: number[] | undefined;
    captureProfileIds?: number[] | undefined;
    projectInfo!: boolean;
    requiredStocks!: boolean;
    wellIngredients!: boolean;
    designReport!: boolean;
    customLayer!: boolean;
    randomLayer!: boolean;
    gridLayer!: boolean;
    proteinLayer!: boolean;
    screenLayer!: boolean;
    screenDetail!: boolean;
    experiment!: boolean;
    imaging!: boolean;
    plates!: boolean;
    dropImages!: boolean;
    fileName?: string | undefined;
    saveReport!: boolean;

    constructor(data?: IExperimentReportJobStartRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            if (Array.isArray(_data["experimentIds"])) {
                this.experimentIds = [] as any;
                for (let item of _data["experimentIds"])
                    this.experimentIds!.push(item);
            }
            if (Array.isArray(_data["captureProfileIds"])) {
                this.captureProfileIds = [] as any;
                for (let item of _data["captureProfileIds"])
                    this.captureProfileIds!.push(item);
            }
            this.projectInfo = _data["projectInfo"];
            this.requiredStocks = _data["requiredStocks"];
            this.wellIngredients = _data["wellIngredients"];
            this.designReport = _data["designReport"];
            this.customLayer = _data["customLayer"];
            this.randomLayer = _data["randomLayer"];
            this.gridLayer = _data["gridLayer"];
            this.proteinLayer = _data["proteinLayer"];
            this.screenLayer = _data["screenLayer"];
            this.screenDetail = _data["screenDetail"];
            this.experiment = _data["experiment"];
            this.imaging = _data["imaging"];
            this.plates = _data["plates"];
            this.dropImages = _data["dropImages"];
            this.fileName = _data["fileName"];
            this.saveReport = _data["saveReport"];
        }
    }

    static fromJS(data: any): ExperimentReportJobStartRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentReportJobStartRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        if (Array.isArray(this.experimentIds)) {
            data["experimentIds"] = [];
            for (let item of this.experimentIds)
                data["experimentIds"].push(item);
        }
        if (Array.isArray(this.captureProfileIds)) {
            data["captureProfileIds"] = [];
            for (let item of this.captureProfileIds)
                data["captureProfileIds"].push(item);
        }
        data["projectInfo"] = this.projectInfo;
        data["requiredStocks"] = this.requiredStocks;
        data["wellIngredients"] = this.wellIngredients;
        data["designReport"] = this.designReport;
        data["customLayer"] = this.customLayer;
        data["randomLayer"] = this.randomLayer;
        data["gridLayer"] = this.gridLayer;
        data["proteinLayer"] = this.proteinLayer;
        data["screenLayer"] = this.screenLayer;
        data["screenDetail"] = this.screenDetail;
        data["experiment"] = this.experiment;
        data["imaging"] = this.imaging;
        data["plates"] = this.plates;
        data["dropImages"] = this.dropImages;
        data["fileName"] = this.fileName;
        data["saveReport"] = this.saveReport;
        return data;
    }
}

export interface IExperimentReportJobStartRequestDTO {
    jobId?: string | undefined;
    experimentIds?: number[] | undefined;
    captureProfileIds?: number[] | undefined;
    projectInfo: boolean;
    requiredStocks: boolean;
    wellIngredients: boolean;
    designReport: boolean;
    customLayer: boolean;
    randomLayer: boolean;
    gridLayer: boolean;
    proteinLayer: boolean;
    screenLayer: boolean;
    screenDetail: boolean;
    experiment: boolean;
    imaging: boolean;
    plates: boolean;
    dropImages: boolean;
    fileName?: string | undefined;
    saveReport: boolean;
}

export class SystemTaskResponseDTO implements ISystemTaskResponseDTO {
    success!: boolean;
    message?: string | undefined;
    result?: SystemTaskResultDTO | undefined;

    constructor(data?: ISystemTaskResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.result = _data["result"] ? SystemTaskResultDTO.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): SystemTaskResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemTaskResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface ISystemTaskResponseDTO {
    success: boolean;
    message?: string | undefined;
    result?: SystemTaskResultDTO | undefined;
}

export class SystemTaskResultDTO implements ISystemTaskResultDTO {

    protected _discriminator: string;

    constructor(data?: ISystemTaskResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "SystemTaskResultDTO";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SystemTaskResultDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DeleteFolderTaskResponseDTO") {
            let result = new DeleteFolderTaskResponseDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PasteFolderTaskResponseDTO") {
            let result = new PasteFolderTaskResponseDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SaveImageTaskResponseDTO") {
            let result = new SaveImageTaskResponseDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DeleteExperimentsResponseDTO") {
            let result = new DeleteExperimentsResponseDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DeleteResponseDTO") {
            let result = new DeleteResponseDTO();
            result.init(data);
            return result;
        }
        let result = new SystemTaskResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        return data;
    }
}

export interface ISystemTaskResultDTO {
}

export class DeleteFolderTaskResponseDTO extends SystemTaskResultDTO implements IDeleteFolderTaskResponseDTO {
    parentId!: number;
    deletedNodes?: NameIdTuple[] | undefined;
    unDeletedNodes?: TreeNodeExtenededResponseMessageDTO[] | undefined;

    constructor(data?: IDeleteFolderTaskResponseDTO) {
        super(data);
        this._discriminator = "DeleteFolderTaskResponseDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["deletedNodes"])) {
                this.deletedNodes = [] as any;
                for (let item of _data["deletedNodes"])
                    this.deletedNodes!.push(NameIdTuple.fromJS(item));
            }
            if (Array.isArray(_data["unDeletedNodes"])) {
                this.unDeletedNodes = [] as any;
                for (let item of _data["unDeletedNodes"])
                    this.unDeletedNodes!.push(TreeNodeExtenededResponseMessageDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeleteFolderTaskResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFolderTaskResponseDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        if (Array.isArray(this.deletedNodes)) {
            data["deletedNodes"] = [];
            for (let item of this.deletedNodes)
                data["deletedNodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unDeletedNodes)) {
            data["unDeletedNodes"] = [];
            for (let item of this.unDeletedNodes)
                data["unDeletedNodes"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteFolderTaskResponseDTO extends ISystemTaskResultDTO {
    parentId: number;
    deletedNodes?: NameIdTuple[] | undefined;
    unDeletedNodes?: TreeNodeExtenededResponseMessageDTO[] | undefined;
}

export class TreeNodeExtenededResponseMessageDTO extends TreeNodeDTO implements ITreeNodeExtenededResponseMessageDTO {
    responseMessage?: string | undefined;

    constructor(data?: ITreeNodeExtenededResponseMessageDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.responseMessage = _data["responseMessage"];
        }
    }

    static override fromJS(data: any): TreeNodeExtenededResponseMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeExtenededResponseMessageDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        super.toJSON(data);
        return data;
    }
}

export interface ITreeNodeExtenededResponseMessageDTO extends ITreeNodeDTO {
    responseMessage?: string | undefined;
}

export class PasteFolderTaskResponseDTO extends SystemTaskResultDTO implements IPasteFolderTaskResponseDTO {
    pasteResponse?: PasteResponseDTO | undefined;

    constructor(data?: IPasteFolderTaskResponseDTO) {
        super(data);
        this._discriminator = "PasteFolderTaskResponseDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pasteResponse = _data["pasteResponse"] ? PasteResponseDTO.fromJS(_data["pasteResponse"]) : undefined as any;
        }
    }

    static override fromJS(data: any): PasteFolderTaskResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PasteFolderTaskResponseDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pasteResponse"] = this.pasteResponse ? this.pasteResponse.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPasteFolderTaskResponseDTO extends ISystemTaskResultDTO {
    pasteResponse?: PasteResponseDTO | undefined;
}

export class PasteResponseDTO implements IPasteResponseDTO {
    pastedNodes?: TreeNode[] | undefined;
    unableToPasteNodes?: NodePasteErrorDTO[] | undefined;

    constructor(data?: IPasteResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pastedNodes"])) {
                this.pastedNodes = [] as any;
                for (let item of _data["pastedNodes"])
                    this.pastedNodes!.push(TreeNode.fromJS(item));
            }
            if (Array.isArray(_data["unableToPasteNodes"])) {
                this.unableToPasteNodes = [] as any;
                for (let item of _data["unableToPasteNodes"])
                    this.unableToPasteNodes!.push(NodePasteErrorDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PasteResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PasteResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pastedNodes)) {
            data["pastedNodes"] = [];
            for (let item of this.pastedNodes)
                data["pastedNodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unableToPasteNodes)) {
            data["unableToPasteNodes"] = [];
            for (let item of this.unableToPasteNodes)
                data["unableToPasteNodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPasteResponseDTO {
    pastedNodes?: TreeNode[] | undefined;
    unableToPasteNodes?: NodePasteErrorDTO[] | undefined;
}

export class NodePasteErrorDTO implements INodePasteErrorDTO {
    treeNode?: TreeNode | undefined;
    reason?: string | undefined;

    constructor(data?: INodePasteErrorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNode = _data["treeNode"] ? TreeNode.fromJS(_data["treeNode"]) : undefined as any;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): NodePasteErrorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NodePasteErrorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNode"] = this.treeNode ? this.treeNode.toJSON() : undefined as any;
        data["reason"] = this.reason;
        return data;
    }
}

export interface INodePasteErrorDTO {
    treeNode?: TreeNode | undefined;
    reason?: string | undefined;
}

export class SaveImageTaskResponseDTO extends SystemTaskResultDTO implements ISaveImageTaskResponseDTO {
    saveImageResponseDTO?: SaveImageResponseDTO | undefined;

    constructor(data?: ISaveImageTaskResponseDTO) {
        super(data);
        this._discriminator = "SaveImageTaskResponseDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.saveImageResponseDTO = _data["saveImageResponseDTO"] ? SaveImageResponseDTO.fromJS(_data["saveImageResponseDTO"]) : undefined as any;
        }
    }

    static override fromJS(data: any): SaveImageTaskResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImageTaskResponseDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saveImageResponseDTO"] = this.saveImageResponseDTO ? this.saveImageResponseDTO.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveImageTaskResponseDTO extends ISystemTaskResultDTO {
    saveImageResponseDTO?: SaveImageResponseDTO | undefined;
}

export class SaveImageResponseDTO implements ISaveImageResponseDTO {
    isGeneratedFiles!: boolean;
    fileName?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: ISaveImageResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGeneratedFiles = _data["isGeneratedFiles"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): SaveImageResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImageResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGeneratedFiles"] = this.isGeneratedFiles;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface ISaveImageResponseDTO {
    isGeneratedFiles: boolean;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export class DeleteExperimentsResponseDTO extends SystemTaskResultDTO implements IDeleteExperimentsResponseDTO {
    treeNodeId?: number[] | undefined;
    unDeletedNodes?: TreeNodeDTO[] | undefined;

    constructor(data?: IDeleteExperimentsResponseDTO) {
        super(data);
        this._discriminator = "DeleteExperimentsResponseDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["treeNodeId"])) {
                this.treeNodeId = [] as any;
                for (let item of _data["treeNodeId"])
                    this.treeNodeId!.push(item);
            }
            if (Array.isArray(_data["unDeletedNodes"])) {
                this.unDeletedNodes = [] as any;
                for (let item of _data["unDeletedNodes"])
                    this.unDeletedNodes!.push(TreeNodeDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeleteExperimentsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteExperimentsResponseDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.treeNodeId)) {
            data["treeNodeId"] = [];
            for (let item of this.treeNodeId)
                data["treeNodeId"].push(item);
        }
        if (Array.isArray(this.unDeletedNodes)) {
            data["unDeletedNodes"] = [];
            for (let item of this.unDeletedNodes)
                data["unDeletedNodes"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteExperimentsResponseDTO extends ISystemTaskResultDTO {
    treeNodeId?: number[] | undefined;
    unDeletedNodes?: TreeNodeDTO[] | undefined;
}

export class DeleteResponseDTO extends SystemTaskResultDTO implements IDeleteResponseDTO {
    deleteResponse?: DeleteFolderTaskResponseDTO[] | undefined;

    constructor(data?: IDeleteResponseDTO) {
        super(data);
        this._discriminator = "DeleteResponseDTO";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["deleteResponse"])) {
                this.deleteResponse = [] as any;
                for (let item of _data["deleteResponse"])
                    this.deleteResponse!.push(DeleteFolderTaskResponseDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DeleteResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteResponseDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deleteResponse)) {
            data["deleteResponse"] = [];
            for (let item of this.deleteResponse)
                data["deleteResponse"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDeleteResponseDTO extends ISystemTaskResultDTO {
    deleteResponse?: DeleteFolderTaskResponseDTO[] | undefined;
}

export class SystemTaskDTO implements ISystemTaskDTO {
    id!: number;

    constructor(data?: ISystemTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SystemTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISystemTaskDTO {
    id: number;
}

export class PasteFolderTaskDTO extends SystemTaskDTO implements IPasteFolderTaskDTO {
    treeNodeIdsToPaste?: number[] | undefined;
    targetId!: number;
    operationType!: PasteOperationType;

    constructor(data?: IPasteFolderTaskDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["treeNodeIdsToPaste"])) {
                this.treeNodeIdsToPaste = [] as any;
                for (let item of _data["treeNodeIdsToPaste"])
                    this.treeNodeIdsToPaste!.push(item);
            }
            this.targetId = _data["targetId"];
            this.operationType = _data["operationType"];
        }
    }

    static override fromJS(data: any): PasteFolderTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PasteFolderTaskDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.treeNodeIdsToPaste)) {
            data["treeNodeIdsToPaste"] = [];
            for (let item of this.treeNodeIdsToPaste)
                data["treeNodeIdsToPaste"].push(item);
        }
        data["targetId"] = this.targetId;
        data["operationType"] = this.operationType;
        super.toJSON(data);
        return data;
    }
}

export interface IPasteFolderTaskDTO extends ISystemTaskDTO {
    treeNodeIdsToPaste?: number[] | undefined;
    targetId: number;
    operationType: PasteOperationType;
}

export enum PasteOperationType {
    Cut = 0,
    Copy = 1,
}

export class SaveImageTaskRequestDTO extends SystemTaskDTO implements ISaveImageTaskRequestDTO {
    saveImageRequestDTO?: SaveImageRequestDTO | undefined;
    destination?: ISaveImageDestination | undefined;

    constructor(data?: ISaveImageTaskRequestDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.saveImageRequestDTO = _data["saveImageRequestDTO"] ? SaveImageRequestDTO.fromJS(_data["saveImageRequestDTO"]) : undefined as any;
            this.destination = _data["destination"] ? ISaveImageDestination.fromJS(_data["destination"]) : undefined as any;
        }
    }

    static override fromJS(data: any): SaveImageTaskRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImageTaskRequestDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saveImageRequestDTO"] = this.saveImageRequestDTO ? this.saveImageRequestDTO.toJSON() : undefined as any;
        data["destination"] = this.destination ? this.destination.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISaveImageTaskRequestDTO extends ISystemTaskDTO {
    saveImageRequestDTO?: SaveImageRequestDTO | undefined;
    destination?: ISaveImageDestination | undefined;
}

export class SaveImageRequestDTO implements ISaveImageRequestDTO {
    wellDetails?: WellDetailsState[] | undefined;
    inspectionSetDTOs?: InspectionSetDTO[] | undefined;
    selectedCaptureProfileIds?: number[] | undefined;
    saveAllDrops!: boolean;
    saveAllRegions!: boolean;
    saveAllInspections!: boolean;
    saveAllFocusLevels!: boolean;
    saveAllWellDropScores!: boolean;
    saveAnnotations!: boolean;
    saveScaleBar?: boolean | undefined;
    saveCurrentZoom?: boolean | undefined;
    saveIngredientInfo!: boolean;
    useBestFocusLevelImages?: boolean | undefined;
    imageZoomDto?: ImageZoomDTO | undefined;

    constructor(data?: ISaveImageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wellDetails"])) {
                this.wellDetails = [] as any;
                for (let item of _data["wellDetails"])
                    this.wellDetails!.push(WellDetailsState.fromJS(item));
            }
            if (Array.isArray(_data["inspectionSetDTOs"])) {
                this.inspectionSetDTOs = [] as any;
                for (let item of _data["inspectionSetDTOs"])
                    this.inspectionSetDTOs!.push(InspectionSetDTO.fromJS(item));
            }
            if (Array.isArray(_data["selectedCaptureProfileIds"])) {
                this.selectedCaptureProfileIds = [] as any;
                for (let item of _data["selectedCaptureProfileIds"])
                    this.selectedCaptureProfileIds!.push(item);
            }
            this.saveAllDrops = _data["saveAllDrops"];
            this.saveAllRegions = _data["saveAllRegions"];
            this.saveAllInspections = _data["saveAllInspections"];
            this.saveAllFocusLevels = _data["saveAllFocusLevels"];
            this.saveAllWellDropScores = _data["saveAllWellDropScores"];
            this.saveAnnotations = _data["saveAnnotations"];
            this.saveScaleBar = _data["saveScaleBar"];
            this.saveCurrentZoom = _data["saveCurrentZoom"];
            this.saveIngredientInfo = _data["saveIngredientInfo"];
            this.useBestFocusLevelImages = _data["useBestFocusLevelImages"];
            this.imageZoomDto = _data["imageZoomDto"] ? ImageZoomDTO.fromJS(_data["imageZoomDto"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveImageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wellDetails)) {
            data["wellDetails"] = [];
            for (let item of this.wellDetails)
                data["wellDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inspectionSetDTOs)) {
            data["inspectionSetDTOs"] = [];
            for (let item of this.inspectionSetDTOs)
                data["inspectionSetDTOs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.selectedCaptureProfileIds)) {
            data["selectedCaptureProfileIds"] = [];
            for (let item of this.selectedCaptureProfileIds)
                data["selectedCaptureProfileIds"].push(item);
        }
        data["saveAllDrops"] = this.saveAllDrops;
        data["saveAllRegions"] = this.saveAllRegions;
        data["saveAllInspections"] = this.saveAllInspections;
        data["saveAllFocusLevels"] = this.saveAllFocusLevels;
        data["saveAllWellDropScores"] = this.saveAllWellDropScores;
        data["saveAnnotations"] = this.saveAnnotations;
        data["saveScaleBar"] = this.saveScaleBar;
        data["saveCurrentZoom"] = this.saveCurrentZoom;
        data["saveIngredientInfo"] = this.saveIngredientInfo;
        data["useBestFocusLevelImages"] = this.useBestFocusLevelImages;
        data["imageZoomDto"] = this.imageZoomDto ? this.imageZoomDto.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveImageRequestDTO {
    wellDetails?: WellDetailsState[] | undefined;
    inspectionSetDTOs?: InspectionSetDTO[] | undefined;
    selectedCaptureProfileIds?: number[] | undefined;
    saveAllDrops: boolean;
    saveAllRegions: boolean;
    saveAllInspections: boolean;
    saveAllFocusLevels: boolean;
    saveAllWellDropScores: boolean;
    saveAnnotations: boolean;
    saveScaleBar?: boolean | undefined;
    saveCurrentZoom?: boolean | undefined;
    saveIngredientInfo: boolean;
    useBestFocusLevelImages?: boolean | undefined;
    imageZoomDto?: ImageZoomDTO | undefined;
}

export class WellDetailsState implements IWellDetailsState {
    cpID!: number;
    wellNum!: number;
    dropNumber!: number;
    plateID!: number;
    regionName?: string | undefined;
    imageBatchId!: number;
    regionID!: number;
    path?: string | undefined;
    fileName?: string | undefined;
    wellName?: string | undefined;
    useCurrentZoom?: boolean | undefined;
    saveAnnotations?: boolean | undefined;
    drawingDTO?: WellDrawingDTO | undefined;
    tuningValuesDTO?: TuningValuesDTO | undefined;
    cpWidthHeight?: CaptureProfileWidthHeight | undefined;
    captureResultProperties?: CaptureResultProperty[] | undefined;

    constructor(data?: IWellDetailsState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cpID = _data["cpID"];
            this.wellNum = _data["wellNum"];
            this.dropNumber = _data["dropNumber"];
            this.plateID = _data["plateID"];
            this.regionName = _data["regionName"];
            this.imageBatchId = _data["imageBatchId"];
            this.regionID = _data["regionID"];
            this.path = _data["path"];
            this.fileName = _data["fileName"];
            this.wellName = _data["wellName"];
            this.useCurrentZoom = _data["useCurrentZoom"];
            this.saveAnnotations = _data["saveAnnotations"];
            this.drawingDTO = _data["drawingDTO"] ? WellDrawingDTO.fromJS(_data["drawingDTO"]) : undefined as any;
            this.tuningValuesDTO = _data["tuningValuesDTO"] ? TuningValuesDTO.fromJS(_data["tuningValuesDTO"]) : undefined as any;
            this.cpWidthHeight = _data["cpWidthHeight"] ? CaptureProfileWidthHeight.fromJS(_data["cpWidthHeight"]) : undefined as any;
            if (Array.isArray(_data["captureResultProperties"])) {
                this.captureResultProperties = [] as any;
                for (let item of _data["captureResultProperties"])
                    this.captureResultProperties!.push(CaptureResultProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WellDetailsState {
        data = typeof data === 'object' ? data : {};
        let result = new WellDetailsState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpID"] = this.cpID;
        data["wellNum"] = this.wellNum;
        data["dropNumber"] = this.dropNumber;
        data["plateID"] = this.plateID;
        data["regionName"] = this.regionName;
        data["imageBatchId"] = this.imageBatchId;
        data["regionID"] = this.regionID;
        data["path"] = this.path;
        data["fileName"] = this.fileName;
        data["wellName"] = this.wellName;
        data["useCurrentZoom"] = this.useCurrentZoom;
        data["saveAnnotations"] = this.saveAnnotations;
        data["drawingDTO"] = this.drawingDTO ? this.drawingDTO.toJSON() : undefined as any;
        data["tuningValuesDTO"] = this.tuningValuesDTO ? this.tuningValuesDTO.toJSON() : undefined as any;
        data["cpWidthHeight"] = this.cpWidthHeight ? this.cpWidthHeight.toJSON() : undefined as any;
        if (Array.isArray(this.captureResultProperties)) {
            data["captureResultProperties"] = [];
            for (let item of this.captureResultProperties)
                data["captureResultProperties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWellDetailsState {
    cpID: number;
    wellNum: number;
    dropNumber: number;
    plateID: number;
    regionName?: string | undefined;
    imageBatchId: number;
    regionID: number;
    path?: string | undefined;
    fileName?: string | undefined;
    wellName?: string | undefined;
    useCurrentZoom?: boolean | undefined;
    saveAnnotations?: boolean | undefined;
    drawingDTO?: WellDrawingDTO | undefined;
    tuningValuesDTO?: TuningValuesDTO | undefined;
    cpWidthHeight?: CaptureProfileWidthHeight | undefined;
    captureResultProperties?: CaptureResultProperty[] | undefined;
}

export class WellDrawingDTO implements IWellDrawingDTO {
    scoresOfWellDrops?: ScoresOfWellDropsDTO[] | undefined;
    allScribblePointofWell?: ScribblesDataDTO[] | undefined;
    roiList?: ROIDTO[] | undefined;
    rulerList?: RegionRulerDTO[] | undefined;
    pointsList?: RegionPointDTO[] | undefined;
    annotationsList?: RegionAnnotationDTO[] | undefined;
    captureResultTuningValuesDto?: CaptureResultTuningValuesDTO | undefined;
    imagingEnabled!: boolean;
    lightPathList?: LightPathDTO[] | undefined;
    crystalsList?: CrystalDTO[] | undefined;
    dropNumber?: number | undefined;
    regionDropLocation?: RegionDropLocationDTO | undefined;

    constructor(data?: IWellDrawingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scoresOfWellDrops"])) {
                this.scoresOfWellDrops = [] as any;
                for (let item of _data["scoresOfWellDrops"])
                    this.scoresOfWellDrops!.push(ScoresOfWellDropsDTO.fromJS(item));
            }
            if (Array.isArray(_data["allScribblePointofWell"])) {
                this.allScribblePointofWell = [] as any;
                for (let item of _data["allScribblePointofWell"])
                    this.allScribblePointofWell!.push(ScribblesDataDTO.fromJS(item));
            }
            if (Array.isArray(_data["roiList"])) {
                this.roiList = [] as any;
                for (let item of _data["roiList"])
                    this.roiList!.push(ROIDTO.fromJS(item));
            }
            if (Array.isArray(_data["rulerList"])) {
                this.rulerList = [] as any;
                for (let item of _data["rulerList"])
                    this.rulerList!.push(RegionRulerDTO.fromJS(item));
            }
            if (Array.isArray(_data["pointsList"])) {
                this.pointsList = [] as any;
                for (let item of _data["pointsList"])
                    this.pointsList!.push(RegionPointDTO.fromJS(item));
            }
            if (Array.isArray(_data["annotationsList"])) {
                this.annotationsList = [] as any;
                for (let item of _data["annotationsList"])
                    this.annotationsList!.push(RegionAnnotationDTO.fromJS(item));
            }
            this.captureResultTuningValuesDto = _data["captureResultTuningValuesDto"] ? CaptureResultTuningValuesDTO.fromJS(_data["captureResultTuningValuesDto"]) : undefined as any;
            this.imagingEnabled = _data["imagingEnabled"];
            if (Array.isArray(_data["lightPathList"])) {
                this.lightPathList = [] as any;
                for (let item of _data["lightPathList"])
                    this.lightPathList!.push(LightPathDTO.fromJS(item));
            }
            if (Array.isArray(_data["crystalsList"])) {
                this.crystalsList = [] as any;
                for (let item of _data["crystalsList"])
                    this.crystalsList!.push(CrystalDTO.fromJS(item));
            }
            this.dropNumber = _data["dropNumber"];
            this.regionDropLocation = _data["regionDropLocation"] ? RegionDropLocationDTO.fromJS(_data["regionDropLocation"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellDrawingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellDrawingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scoresOfWellDrops)) {
            data["scoresOfWellDrops"] = [];
            for (let item of this.scoresOfWellDrops)
                data["scoresOfWellDrops"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allScribblePointofWell)) {
            data["allScribblePointofWell"] = [];
            for (let item of this.allScribblePointofWell)
                data["allScribblePointofWell"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roiList)) {
            data["roiList"] = [];
            for (let item of this.roiList)
                data["roiList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rulerList)) {
            data["rulerList"] = [];
            for (let item of this.rulerList)
                data["rulerList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pointsList)) {
            data["pointsList"] = [];
            for (let item of this.pointsList)
                data["pointsList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.annotationsList)) {
            data["annotationsList"] = [];
            for (let item of this.annotationsList)
                data["annotationsList"].push(item ? item.toJSON() : undefined as any);
        }
        data["captureResultTuningValuesDto"] = this.captureResultTuningValuesDto ? this.captureResultTuningValuesDto.toJSON() : undefined as any;
        data["imagingEnabled"] = this.imagingEnabled;
        if (Array.isArray(this.lightPathList)) {
            data["lightPathList"] = [];
            for (let item of this.lightPathList)
                data["lightPathList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crystalsList)) {
            data["crystalsList"] = [];
            for (let item of this.crystalsList)
                data["crystalsList"].push(item ? item.toJSON() : undefined as any);
        }
        data["dropNumber"] = this.dropNumber;
        data["regionDropLocation"] = this.regionDropLocation ? this.regionDropLocation.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellDrawingDTO {
    scoresOfWellDrops?: ScoresOfWellDropsDTO[] | undefined;
    allScribblePointofWell?: ScribblesDataDTO[] | undefined;
    roiList?: ROIDTO[] | undefined;
    rulerList?: RegionRulerDTO[] | undefined;
    pointsList?: RegionPointDTO[] | undefined;
    annotationsList?: RegionAnnotationDTO[] | undefined;
    captureResultTuningValuesDto?: CaptureResultTuningValuesDTO | undefined;
    imagingEnabled: boolean;
    lightPathList?: LightPathDTO[] | undefined;
    crystalsList?: CrystalDTO[] | undefined;
    dropNumber?: number | undefined;
    regionDropLocation?: RegionDropLocationDTO | undefined;
}

export class ROIDTO implements IROIDTO {
    id!: number;
    regionName?: string | undefined;
    xCenterOffSet?: number | undefined;
    yCenterOffSet?: number | undefined;
    zHeight?: number | undefined;
    xWidth?: number | undefined;
    yHeight?: number | undefined;
    imagingEnabled!: boolean;
    dropNumber?: number | undefined;
    regionId?: number | undefined;
    locked?: boolean | undefined;

    constructor(data?: IROIDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regionName = _data["regionName"];
            this.xCenterOffSet = _data["xCenterOffSet"];
            this.yCenterOffSet = _data["yCenterOffSet"];
            this.zHeight = _data["zHeight"];
            this.xWidth = _data["xWidth"];
            this.yHeight = _data["yHeight"];
            this.imagingEnabled = _data["imagingEnabled"];
            this.dropNumber = _data["dropNumber"];
            this.regionId = _data["regionId"];
            this.locked = _data["locked"];
        }
    }

    static fromJS(data: any): ROIDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ROIDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regionName"] = this.regionName;
        data["xCenterOffSet"] = this.xCenterOffSet;
        data["yCenterOffSet"] = this.yCenterOffSet;
        data["zHeight"] = this.zHeight;
        data["xWidth"] = this.xWidth;
        data["yHeight"] = this.yHeight;
        data["imagingEnabled"] = this.imagingEnabled;
        data["dropNumber"] = this.dropNumber;
        data["regionId"] = this.regionId;
        data["locked"] = this.locked;
        return data;
    }
}

export interface IROIDTO {
    id: number;
    regionName?: string | undefined;
    xCenterOffSet?: number | undefined;
    yCenterOffSet?: number | undefined;
    zHeight?: number | undefined;
    xWidth?: number | undefined;
    yHeight?: number | undefined;
    imagingEnabled: boolean;
    dropNumber?: number | undefined;
    regionId?: number | undefined;
    locked?: boolean | undefined;
}

export class RegionRulerDTO implements IRegionRulerDTO {
    regionId?: number | undefined;
    id!: number;
    color!: string;
    x1!: number;
    y1!: number;
    x2!: number;
    y2!: number;

    constructor(data?: IRegionRulerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.id = _data["id"];
            this.color = _data["color"];
            this.x1 = _data["x1"];
            this.y1 = _data["y1"];
            this.x2 = _data["x2"];
            this.y2 = _data["y2"];
        }
    }

    static fromJS(data: any): RegionRulerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionRulerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["id"] = this.id;
        data["color"] = this.color;
        data["x1"] = this.x1;
        data["y1"] = this.y1;
        data["x2"] = this.x2;
        data["y2"] = this.y2;
        return data;
    }
}

export interface IRegionRulerDTO {
    regionId?: number | undefined;
    id: number;
    color: string;
    x1: number;
    y1: number;
    x2: number;
    y2: number;
}

export class RegionPointDTO implements IRegionPointDTO {
    regionId?: number | undefined;
    id!: number;
    x!: number;
    y!: number;
    name?: string | undefined;
    color!: string;

    constructor(data?: IRegionPointDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.id = _data["id"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.name = _data["name"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): RegionPointDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionPointDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["id"] = this.id;
        data["x"] = this.x;
        data["y"] = this.y;
        data["name"] = this.name;
        data["color"] = this.color;
        return data;
    }
}

export interface IRegionPointDTO {
    regionId?: number | undefined;
    id: number;
    x: number;
    y: number;
    name?: string | undefined;
    color: string;
}

export class RegionAnnotationDTO implements IRegionAnnotationDTO {
    regionId?: number | undefined;
    id!: number;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    text?: string | undefined;
    expanded!: boolean;
    bgColor!: string;
    color!: string;
    fontFamily?: string | undefined;
    size!: number;
    fontStyle?: string | undefined;
    textDecoration?: string | undefined;

    constructor(data?: IRegionAnnotationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionId = _data["regionId"];
            this.id = _data["id"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.text = _data["text"];
            this.expanded = _data["expanded"];
            this.bgColor = _data["bgColor"];
            this.color = _data["color"];
            this.fontFamily = _data["fontFamily"];
            this.size = _data["size"];
            this.fontStyle = _data["fontStyle"];
            this.textDecoration = _data["textDecoration"];
        }
    }

    static fromJS(data: any): RegionAnnotationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionAnnotationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["id"] = this.id;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["text"] = this.text;
        data["expanded"] = this.expanded;
        data["bgColor"] = this.bgColor;
        data["color"] = this.color;
        data["fontFamily"] = this.fontFamily;
        data["size"] = this.size;
        data["fontStyle"] = this.fontStyle;
        data["textDecoration"] = this.textDecoration;
        return data;
    }
}

export interface IRegionAnnotationDTO {
    regionId?: number | undefined;
    id: number;
    x: number;
    y: number;
    width: number;
    height: number;
    text?: string | undefined;
    expanded: boolean;
    bgColor: string;
    color: string;
    fontFamily?: string | undefined;
    size: number;
    fontStyle?: string | undefined;
    textDecoration?: string | undefined;
}

export class CaptureResultTuningValuesDTO extends TuningValuesDTO implements ICaptureResultTuningValuesDTO {
    id!: number;
    captureResultID!: number;
    regionID!: number;
    imageBatchId?: number | undefined;
    cpId?: number | undefined;

    constructor(data?: ICaptureResultTuningValuesDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.captureResultID = _data["captureResultID"];
            this.regionID = _data["regionID"];
            this.imageBatchId = _data["imageBatchId"];
            this.cpId = _data["cpId"];
        }
    }

    static override fromJS(data: any): CaptureResultTuningValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureResultTuningValuesDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["captureResultID"] = this.captureResultID;
        data["regionID"] = this.regionID;
        data["imageBatchId"] = this.imageBatchId;
        data["cpId"] = this.cpId;
        super.toJSON(data);
        return data;
    }
}

export interface ICaptureResultTuningValuesDTO extends ITuningValuesDTO {
    id: number;
    captureResultID: number;
    regionID: number;
    imageBatchId?: number | undefined;
    cpId?: number | undefined;
}

export class LightPathDTO implements ILightPathDTO {
    rectangleF!: RectangleF;
    id?: string | undefined;
    name?: string | undefined;
    minFOVSize?: FOVSizeDTO | undefined;
    maxFOVSize?: FOVSizeDTO | undefined;
    isDiscrete!: boolean;
    sizeFactorList?: number[] | undefined;
    validSizeList?: FOVSizeDTO[] | undefined;
    opticsType?: string | undefined;
    color!: string;
    area!: number;
    maxArea!: number;

    constructor(data?: ILightPathDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.rectangleF = new RectangleF();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rectangleF = _data["rectangleF"] ? RectangleF.fromJS(_data["rectangleF"]) : new RectangleF();
            this.id = _data["id"];
            this.name = _data["name"];
            this.minFOVSize = _data["minFOVSize"] ? FOVSizeDTO.fromJS(_data["minFOVSize"]) : undefined as any;
            this.maxFOVSize = _data["maxFOVSize"] ? FOVSizeDTO.fromJS(_data["maxFOVSize"]) : undefined as any;
            this.isDiscrete = _data["isDiscrete"];
            if (Array.isArray(_data["sizeFactorList"])) {
                this.sizeFactorList = [] as any;
                for (let item of _data["sizeFactorList"])
                    this.sizeFactorList!.push(item);
            }
            if (Array.isArray(_data["validSizeList"])) {
                this.validSizeList = [] as any;
                for (let item of _data["validSizeList"])
                    this.validSizeList!.push(FOVSizeDTO.fromJS(item));
            }
            this.opticsType = _data["opticsType"];
            this.color = _data["color"];
            this.area = _data["area"];
            this.maxArea = _data["maxArea"];
        }
    }

    static fromJS(data: any): LightPathDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LightPathDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rectangleF"] = this.rectangleF ? this.rectangleF.toJSON() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["minFOVSize"] = this.minFOVSize ? this.minFOVSize.toJSON() : undefined as any;
        data["maxFOVSize"] = this.maxFOVSize ? this.maxFOVSize.toJSON() : undefined as any;
        data["isDiscrete"] = this.isDiscrete;
        if (Array.isArray(this.sizeFactorList)) {
            data["sizeFactorList"] = [];
            for (let item of this.sizeFactorList)
                data["sizeFactorList"].push(item);
        }
        if (Array.isArray(this.validSizeList)) {
            data["validSizeList"] = [];
            for (let item of this.validSizeList)
                data["validSizeList"].push(item ? item.toJSON() : undefined as any);
        }
        data["opticsType"] = this.opticsType;
        data["color"] = this.color;
        data["area"] = this.area;
        data["maxArea"] = this.maxArea;
        return data;
    }
}

export interface ILightPathDTO {
    rectangleF: RectangleF;
    id?: string | undefined;
    name?: string | undefined;
    minFOVSize?: FOVSizeDTO | undefined;
    maxFOVSize?: FOVSizeDTO | undefined;
    isDiscrete: boolean;
    sizeFactorList?: number[] | undefined;
    validSizeList?: FOVSizeDTO[] | undefined;
    opticsType?: string | undefined;
    color: string;
    area: number;
    maxArea: number;
}

export class RectangleF implements IRectangleF {
    location!: PointF;
    size!: string;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    left!: number;
    top!: number;
    right!: number;
    bottom!: number;
    isEmpty!: boolean;

    constructor(data?: IRectangleF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.location = new PointF();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? PointF.fromJS(_data["location"]) : new PointF();
            this.size = _data["size"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.left = _data["left"];
            this.top = _data["top"];
            this.right = _data["right"];
            this.bottom = _data["bottom"];
            this.isEmpty = _data["isEmpty"];
        }
    }

    static fromJS(data: any): RectangleF {
        data = typeof data === 'object' ? data : {};
        let result = new RectangleF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["size"] = this.size;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["left"] = this.left;
        data["top"] = this.top;
        data["right"] = this.right;
        data["bottom"] = this.bottom;
        data["isEmpty"] = this.isEmpty;
        return data;
    }
}

export interface IRectangleF {
    location: PointF;
    size: string;
    x: number;
    y: number;
    width: number;
    height: number;
    left: number;
    top: number;
    right: number;
    bottom: number;
    isEmpty: boolean;
}

export class PointF implements IPointF {
    isEmpty!: boolean;
    x!: number;
    y!: number;

    constructor(data?: IPointF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmpty = _data["isEmpty"];
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): PointF {
        data = typeof data === 'object' ? data : {};
        let result = new PointF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmpty"] = this.isEmpty;
        data["x"] = this.x;
        data["y"] = this.y;
        return data;
    }
}

export interface IPointF {
    isEmpty: boolean;
    x: number;
    y: number;
}

export class FOVSizeDTO implements IFOVSizeDTO {
    width!: number;
    height!: number;

    constructor(data?: IFOVSizeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): FOVSizeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FOVSizeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IFOVSizeDTO {
    width: number;
    height: number;
}

export class RegionDropLocationDTO implements IRegionDropLocationDTO {
    pid?: number | undefined;
    wellNumber?: number | undefined;
    dropNumber?: number | undefined;
    regionId?: number | undefined;
    parentRegionId?: number | undefined;
    regionName?: string | undefined;
    xcenterOffset?: number | undefined;
    ycenterOffset?: number | undefined;
    xwidth?: number | undefined;
    yheight?: number | undefined;

    constructor(data?: IRegionDropLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["pid"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.regionId = _data["regionId"];
            this.parentRegionId = _data["parentRegionId"];
            this.regionName = _data["regionName"];
            this.xcenterOffset = _data["xcenterOffset"];
            this.ycenterOffset = _data["ycenterOffset"];
            this.xwidth = _data["xwidth"];
            this.yheight = _data["yheight"];
        }
    }

    static fromJS(data: any): RegionDropLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDropLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pid"] = this.pid;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["regionId"] = this.regionId;
        data["parentRegionId"] = this.parentRegionId;
        data["regionName"] = this.regionName;
        data["xcenterOffset"] = this.xcenterOffset;
        data["ycenterOffset"] = this.ycenterOffset;
        data["xwidth"] = this.xwidth;
        data["yheight"] = this.yheight;
        return data;
    }
}

export interface IRegionDropLocationDTO {
    pid?: number | undefined;
    wellNumber?: number | undefined;
    dropNumber?: number | undefined;
    regionId?: number | undefined;
    parentRegionId?: number | undefined;
    regionName?: string | undefined;
    xcenterOffset?: number | undefined;
    ycenterOffset?: number | undefined;
    xwidth?: number | undefined;
    yheight?: number | undefined;
}

export class CaptureProfileWidthHeight implements ICaptureProfileWidthHeight {
    xWidth!: number;
    yHeight!: number;
    pixelSize!: number;
    regionId?: number | undefined;

    constructor(data?: ICaptureProfileWidthHeight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xWidth = _data["xWidth"];
            this.yHeight = _data["yHeight"];
            this.pixelSize = _data["pixelSize"];
            this.regionId = _data["regionId"];
        }
    }

    static fromJS(data: any): CaptureProfileWidthHeight {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProfileWidthHeight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xWidth"] = this.xWidth;
        data["yHeight"] = this.yHeight;
        data["pixelSize"] = this.pixelSize;
        data["regionId"] = this.regionId;
        return data;
    }
}

export interface ICaptureProfileWidthHeight {
    xWidth: number;
    yHeight: number;
    pixelSize: number;
    regionId?: number | undefined;
}

export class ImageZoomDTO implements IImageZoomDTO {
    scale!: number;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    outputWidth!: number;
    outputHeight!: number;

    constructor(data?: IImageZoomDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scale = _data["scale"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.outputWidth = _data["outputWidth"];
            this.outputHeight = _data["outputHeight"];
        }
    }

    static fromJS(data: any): ImageZoomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageZoomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scale"] = this.scale;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["outputWidth"] = this.outputWidth;
        data["outputHeight"] = this.outputHeight;
        return data;
    }
}

export interface IImageZoomDTO {
    scale: number;
    x: number;
    y: number;
    width: number;
    height: number;
    outputWidth: number;
    outputHeight: number;
}

export abstract class ISaveImageDestination implements IISaveImageDestination {
    outputStream?: Stream | undefined;

    constructor(data?: IISaveImageDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outputStream = _data["outputStream"] ? Stream.fromJS(_data["outputStream"]) : undefined as any;
        }
    }

    static fromJS(data: any): ISaveImageDestination {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ISaveImageDestination' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outputStream"] = this.outputStream ? this.outputStream.toJSON() : undefined as any;
        return data;
    }
}

export interface IISaveImageDestination {
    outputStream?: Stream | undefined;
}

export abstract class MarshalByRefObject implements IMarshalByRefObject {

    constructor(data?: IMarshalByRefObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MarshalByRefObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MarshalByRefObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMarshalByRefObject {
}

export abstract class Stream extends MarshalByRefObject implements IStream {
    canTimeout!: boolean;
    readTimeout!: number;
    writeTimeout!: number;

    constructor(data?: IStream) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canTimeout = _data["canTimeout"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static override fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        super.toJSON(data);
        return data;
    }
}

export interface IStream extends IMarshalByRefObject {
    canTimeout: boolean;
    readTimeout: number;
    writeTimeout: number;
}

export class TreeNodeListDTO implements ITreeNodeListDTO {
    treeNodes?: TreeNodeDTO[] | undefined;

    constructor(data?: ITreeNodeListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["treeNodes"])) {
                this.treeNodes = [] as any;
                for (let item of _data["treeNodes"])
                    this.treeNodes!.push(TreeNodeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeNodeListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.treeNodes)) {
            data["treeNodes"] = [];
            for (let item of this.treeNodes)
                data["treeNodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITreeNodeListDTO {
    treeNodes?: TreeNodeDTO[] | undefined;
}

export class FragmentScreenInfoDTO implements IFragmentScreenInfoDTO {
    treeNodeId!: number;
    treeNodeParentId!: number;
    treeNodeType?: string | undefined;
    fragmentScreenName?: string | undefined;
    fragmentScreenList?: FragmentScreen[] | undefined;

    constructor(data?: IFragmentScreenInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNodeId = _data["treeNodeId"];
            this.treeNodeParentId = _data["treeNodeParentId"];
            this.treeNodeType = _data["treeNodeType"];
            this.fragmentScreenName = _data["fragmentScreenName"];
            if (Array.isArray(_data["fragmentScreenList"])) {
                this.fragmentScreenList = [] as any;
                for (let item of _data["fragmentScreenList"])
                    this.fragmentScreenList!.push(FragmentScreen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FragmentScreenInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FragmentScreenInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNodeId"] = this.treeNodeId;
        data["treeNodeParentId"] = this.treeNodeParentId;
        data["treeNodeType"] = this.treeNodeType;
        data["fragmentScreenName"] = this.fragmentScreenName;
        if (Array.isArray(this.fragmentScreenList)) {
            data["fragmentScreenList"] = [];
            for (let item of this.fragmentScreenList)
                data["fragmentScreenList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFragmentScreenInfoDTO {
    treeNodeId: number;
    treeNodeParentId: number;
    treeNodeType?: string | undefined;
    fragmentScreenName?: string | undefined;
    fragmentScreenList?: FragmentScreen[] | undefined;
}

export class ResponseWithValueDTOOfListOfProteinInfoDTO extends ResponseDTO implements IResponseWithValueDTOOfListOfProteinInfoDTO {
    value?: ProteinInfoDTO[] | undefined;

    constructor(data?: IResponseWithValueDTOOfListOfProteinInfoDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProteinInfoDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResponseWithValueDTOOfListOfProteinInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseWithValueDTOOfListOfProteinInfoDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResponseWithValueDTOOfListOfProteinInfoDTO extends IResponseDTO {
    value?: ProteinInfoDTO[] | undefined;
}

export class UsersTempImagingSchedulesDTO implements IUsersTempImagingSchedulesDTO {
    users?: UsersDTO[] | undefined;
    temps?: IncubationTempDTO[] | undefined;
    imagingSchedules?: ExperimentInfoImagingScheduleDTO | undefined;

    constructor(data?: IUsersTempImagingSchedulesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersDTO.fromJS(item));
            }
            if (Array.isArray(_data["temps"])) {
                this.temps = [] as any;
                for (let item of _data["temps"])
                    this.temps!.push(IncubationTempDTO.fromJS(item));
            }
            this.imagingSchedules = _data["imagingSchedules"] ? ExperimentInfoImagingScheduleDTO.fromJS(_data["imagingSchedules"]) : undefined as any;
        }
    }

    static fromJS(data: any): UsersTempImagingSchedulesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UsersTempImagingSchedulesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.temps)) {
            data["temps"] = [];
            for (let item of this.temps)
                data["temps"].push(item ? item.toJSON() : undefined as any);
        }
        data["imagingSchedules"] = this.imagingSchedules ? this.imagingSchedules.toJSON() : undefined as any;
        return data;
    }
}

export interface IUsersTempImagingSchedulesDTO {
    users?: UsersDTO[] | undefined;
    temps?: IncubationTempDTO[] | undefined;
    imagingSchedules?: ExperimentInfoImagingScheduleDTO | undefined;
}

export class IncubationTempDTO implements IIncubationTempDTO {
    id!: number;
    name!: number;

    constructor(data?: IIncubationTempDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IncubationTempDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncubationTempDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIncubationTempDTO {
    id: number;
    name: number;
}

export class TreeNodeNameDTO implements ITreeNodeNameDTO {
    name?: string | undefined;

    constructor(data?: ITreeNodeNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TreeNodeNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ITreeNodeNameDTO {
    name?: string | undefined;
}

export class ProjectInfoDTO implements IProjectInfoDTO {
    id!: number;
    ownerUserId!: number;
    defaultImagingScheduleId!: number;
    name?: string | undefined;
    dateCreated!: Date;
    owner?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IProjectInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerUserId = _data["ownerUserId"];
            this.defaultImagingScheduleId = _data["defaultImagingScheduleId"];
            this.name = _data["name"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.owner = _data["owner"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ProjectInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerUserId"] = this.ownerUserId;
        data["defaultImagingScheduleId"] = this.defaultImagingScheduleId;
        data["name"] = this.name;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["owner"] = this.owner;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IProjectInfoDTO {
    id: number;
    ownerUserId: number;
    defaultImagingScheduleId: number;
    name?: string | undefined;
    dateCreated: Date;
    owner?: string | undefined;
    notes?: string | undefined;
}

export class HitReportDataDTO implements IHitReportDataDTO {
    ingredientsData?: HitReportIngredientDTO[] | undefined;
    dropsData?: HitDropsDTO[] | undefined;
    screenNames?: string[] | undefined;

    constructor(data?: IHitReportDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ingredientsData"])) {
                this.ingredientsData = [] as any;
                for (let item of _data["ingredientsData"])
                    this.ingredientsData!.push(HitReportIngredientDTO.fromJS(item));
            }
            if (Array.isArray(_data["dropsData"])) {
                this.dropsData = [] as any;
                for (let item of _data["dropsData"])
                    this.dropsData!.push(HitDropsDTO.fromJS(item));
            }
            if (Array.isArray(_data["screenNames"])) {
                this.screenNames = [] as any;
                for (let item of _data["screenNames"])
                    this.screenNames!.push(item);
            }
        }
    }

    static fromJS(data: any): HitReportDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HitReportDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ingredientsData)) {
            data["ingredientsData"] = [];
            for (let item of this.ingredientsData)
                data["ingredientsData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dropsData)) {
            data["dropsData"] = [];
            for (let item of this.dropsData)
                data["dropsData"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.screenNames)) {
            data["screenNames"] = [];
            for (let item of this.screenNames)
                data["screenNames"].push(item);
        }
        return data;
    }
}

export interface IHitReportDataDTO {
    ingredientsData?: HitReportIngredientDTO[] | undefined;
    dropsData?: HitDropsDTO[] | undefined;
    screenNames?: string[] | undefined;
}

export class HitReportIngredientDTO implements IHitReportIngredientDTO {
    id!: number;
    wellDrop!: number;
    name?: string | undefined;
    ingredientCount!: number;
    lowConcentration!: number;
    highConcentration!: number;
    isBuffer!: boolean;
    lowPh?: number | undefined;
    highPh?: number | undefined;
    concentrationUnits?: string | undefined;

    constructor(data?: IHitReportIngredientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wellDrop = _data["wellDrop"];
            this.name = _data["name"];
            this.ingredientCount = _data["ingredientCount"];
            this.lowConcentration = _data["lowConcentration"];
            this.highConcentration = _data["highConcentration"];
            this.isBuffer = _data["isBuffer"];
            this.lowPh = _data["lowPh"];
            this.highPh = _data["highPh"];
            this.concentrationUnits = _data["concentrationUnits"];
        }
    }

    static fromJS(data: any): HitReportIngredientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HitReportIngredientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wellDrop"] = this.wellDrop;
        data["name"] = this.name;
        data["ingredientCount"] = this.ingredientCount;
        data["lowConcentration"] = this.lowConcentration;
        data["highConcentration"] = this.highConcentration;
        data["isBuffer"] = this.isBuffer;
        data["lowPh"] = this.lowPh;
        data["highPh"] = this.highPh;
        data["concentrationUnits"] = this.concentrationUnits;
        return data;
    }
}

export interface IHitReportIngredientDTO {
    id: number;
    wellDrop: number;
    name?: string | undefined;
    ingredientCount: number;
    lowConcentration: number;
    highConcentration: number;
    isBuffer: boolean;
    lowPh?: number | undefined;
    highPh?: number | undefined;
    concentrationUnits?: string | undefined;
}

export class HitDropsDTO implements IHitDropsDTO {
    experimentId!: number;
    expName?: string | undefined;
    dateImaged?: Date | undefined;
    plateId!: number;
    plateBarcode?: string | undefined;
    wellId!: number;
    wellNumber!: number;
    wellName?: string | undefined;
    wellDropId!: number;
    wellDropScoreName?: string | undefined;
    wellDropScoreGroupName?: string | undefined;
    dropNumber!: number;
    captureProfileId!: number;
    captureProfileName?: string | undefined;
    inspectionId!: number;
    scoreType!: number;
    regionId!: number;
    region?: string | undefined;
    imageData?: string | undefined;
    imageExt?: string | undefined;
    wellIngs?: string[] | undefined;
    proteinName?: string | undefined;
    dropVolume?: number | undefined;
    sampleVolume?: number | undefined;
    isAutoScoreIgnored!: boolean;

    constructor(data?: IHitDropsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.expName = _data["expName"];
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.plateId = _data["plateId"];
            this.plateBarcode = _data["plateBarcode"];
            this.wellId = _data["wellId"];
            this.wellNumber = _data["wellNumber"];
            this.wellName = _data["wellName"];
            this.wellDropId = _data["wellDropId"];
            this.wellDropScoreName = _data["wellDropScoreName"];
            this.wellDropScoreGroupName = _data["wellDropScoreGroupName"];
            this.dropNumber = _data["dropNumber"];
            this.captureProfileId = _data["captureProfileId"];
            this.captureProfileName = _data["captureProfileName"];
            this.inspectionId = _data["inspectionId"];
            this.scoreType = _data["scoreType"];
            this.regionId = _data["regionId"];
            this.region = _data["region"];
            this.imageData = _data["imageData"];
            this.imageExt = _data["imageExt"];
            if (Array.isArray(_data["wellIngs"])) {
                this.wellIngs = [] as any;
                for (let item of _data["wellIngs"])
                    this.wellIngs!.push(item);
            }
            this.proteinName = _data["proteinName"];
            this.dropVolume = _data["dropVolume"];
            this.sampleVolume = _data["sampleVolume"];
            this.isAutoScoreIgnored = _data["isAutoScoreIgnored"];
        }
    }

    static fromJS(data: any): HitDropsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HitDropsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["expName"] = this.expName;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["plateId"] = this.plateId;
        data["plateBarcode"] = this.plateBarcode;
        data["wellId"] = this.wellId;
        data["wellNumber"] = this.wellNumber;
        data["wellName"] = this.wellName;
        data["wellDropId"] = this.wellDropId;
        data["wellDropScoreName"] = this.wellDropScoreName;
        data["wellDropScoreGroupName"] = this.wellDropScoreGroupName;
        data["dropNumber"] = this.dropNumber;
        data["captureProfileId"] = this.captureProfileId;
        data["captureProfileName"] = this.captureProfileName;
        data["inspectionId"] = this.inspectionId;
        data["scoreType"] = this.scoreType;
        data["regionId"] = this.regionId;
        data["region"] = this.region;
        data["imageData"] = this.imageData;
        data["imageExt"] = this.imageExt;
        if (Array.isArray(this.wellIngs)) {
            data["wellIngs"] = [];
            for (let item of this.wellIngs)
                data["wellIngs"].push(item);
        }
        data["proteinName"] = this.proteinName;
        data["dropVolume"] = this.dropVolume;
        data["sampleVolume"] = this.sampleVolume;
        data["isAutoScoreIgnored"] = this.isAutoScoreIgnored;
        return data;
    }
}

export interface IHitDropsDTO {
    experimentId: number;
    expName?: string | undefined;
    dateImaged?: Date | undefined;
    plateId: number;
    plateBarcode?: string | undefined;
    wellId: number;
    wellNumber: number;
    wellName?: string | undefined;
    wellDropId: number;
    wellDropScoreName?: string | undefined;
    wellDropScoreGroupName?: string | undefined;
    dropNumber: number;
    captureProfileId: number;
    captureProfileName?: string | undefined;
    inspectionId: number;
    scoreType: number;
    regionId: number;
    region?: string | undefined;
    imageData?: string | undefined;
    imageExt?: string | undefined;
    wellIngs?: string[] | undefined;
    proteinName?: string | undefined;
    dropVolume?: number | undefined;
    sampleVolume?: number | undefined;
    isAutoScoreIgnored: boolean;
}

export class HitsReportDataRequestDTO implements IHitsReportDataRequestDTO {
    nodeIds?: number[] | undefined;
    dropNumbers?: number[] | undefined;
    captureProfiles?: number[] | undefined;
    scoreGroupIds?: number[] | undefined;
    wellDropScoreIds?: number[] | undefined;
    latestOnly!: boolean;
    uvHitsOnly!: boolean;
    plateIds?: number[] | undefined;
    plateFilterExperimentId?: number | undefined;

    constructor(data?: IHitsReportDataRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nodeIds"])) {
                this.nodeIds = [] as any;
                for (let item of _data["nodeIds"])
                    this.nodeIds!.push(item);
            }
            if (Array.isArray(_data["dropNumbers"])) {
                this.dropNumbers = [] as any;
                for (let item of _data["dropNumbers"])
                    this.dropNumbers!.push(item);
            }
            if (Array.isArray(_data["captureProfiles"])) {
                this.captureProfiles = [] as any;
                for (let item of _data["captureProfiles"])
                    this.captureProfiles!.push(item);
            }
            if (Array.isArray(_data["scoreGroupIds"])) {
                this.scoreGroupIds = [] as any;
                for (let item of _data["scoreGroupIds"])
                    this.scoreGroupIds!.push(item);
            }
            if (Array.isArray(_data["wellDropScoreIds"])) {
                this.wellDropScoreIds = [] as any;
                for (let item of _data["wellDropScoreIds"])
                    this.wellDropScoreIds!.push(item);
            }
            this.latestOnly = _data["latestOnly"];
            this.uvHitsOnly = _data["uvHitsOnly"];
            if (Array.isArray(_data["plateIds"])) {
                this.plateIds = [] as any;
                for (let item of _data["plateIds"])
                    this.plateIds!.push(item);
            }
            this.plateFilterExperimentId = _data["plateFilterExperimentId"];
        }
    }

    static fromJS(data: any): HitsReportDataRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HitsReportDataRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nodeIds)) {
            data["nodeIds"] = [];
            for (let item of this.nodeIds)
                data["nodeIds"].push(item);
        }
        if (Array.isArray(this.dropNumbers)) {
            data["dropNumbers"] = [];
            for (let item of this.dropNumbers)
                data["dropNumbers"].push(item);
        }
        if (Array.isArray(this.captureProfiles)) {
            data["captureProfiles"] = [];
            for (let item of this.captureProfiles)
                data["captureProfiles"].push(item);
        }
        if (Array.isArray(this.scoreGroupIds)) {
            data["scoreGroupIds"] = [];
            for (let item of this.scoreGroupIds)
                data["scoreGroupIds"].push(item);
        }
        if (Array.isArray(this.wellDropScoreIds)) {
            data["wellDropScoreIds"] = [];
            for (let item of this.wellDropScoreIds)
                data["wellDropScoreIds"].push(item);
        }
        data["latestOnly"] = this.latestOnly;
        data["uvHitsOnly"] = this.uvHitsOnly;
        if (Array.isArray(this.plateIds)) {
            data["plateIds"] = [];
            for (let item of this.plateIds)
                data["plateIds"].push(item);
        }
        data["plateFilterExperimentId"] = this.plateFilterExperimentId;
        return data;
    }
}

export interface IHitsReportDataRequestDTO {
    nodeIds?: number[] | undefined;
    dropNumbers?: number[] | undefined;
    captureProfiles?: number[] | undefined;
    scoreGroupIds?: number[] | undefined;
    wellDropScoreIds?: number[] | undefined;
    latestOnly: boolean;
    uvHitsOnly: boolean;
    plateIds?: number[] | undefined;
    plateFilterExperimentId?: number | undefined;
}

export class RenameNodeRequestDTO implements IRenameNodeRequestDTO {
    treeNodeId!: number;
    newName?: string | undefined;

    constructor(data?: IRenameNodeRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNodeId = _data["treeNodeId"];
            this.newName = _data["newName"];
        }
    }

    static fromJS(data: any): RenameNodeRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RenameNodeRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNodeId"] = this.treeNodeId;
        data["newName"] = this.newName;
        return data;
    }
}

export interface IRenameNodeRequestDTO {
    treeNodeId: number;
    newName?: string | undefined;
}

export class TreeNodeAccessRightRequestDTO implements ITreeNodeAccessRightRequestDTO {
    withAccessRights?: TreeNodeAccessRightDTO[] | undefined;
    usersWithoutAccess?: UserDTO[] | undefined;
    groupsWithoutAccess?: GroupDTO[] | undefined;

    constructor(data?: ITreeNodeAccessRightRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["withAccessRights"])) {
                this.withAccessRights = [] as any;
                for (let item of _data["withAccessRights"])
                    this.withAccessRights!.push(TreeNodeAccessRightDTO.fromJS(item));
            }
            if (Array.isArray(_data["usersWithoutAccess"])) {
                this.usersWithoutAccess = [] as any;
                for (let item of _data["usersWithoutAccess"])
                    this.usersWithoutAccess!.push(UserDTO.fromJS(item));
            }
            if (Array.isArray(_data["groupsWithoutAccess"])) {
                this.groupsWithoutAccess = [] as any;
                for (let item of _data["groupsWithoutAccess"])
                    this.groupsWithoutAccess!.push(GroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeNodeAccessRightRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeAccessRightRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.withAccessRights)) {
            data["withAccessRights"] = [];
            for (let item of this.withAccessRights)
                data["withAccessRights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.usersWithoutAccess)) {
            data["usersWithoutAccess"] = [];
            for (let item of this.usersWithoutAccess)
                data["usersWithoutAccess"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groupsWithoutAccess)) {
            data["groupsWithoutAccess"] = [];
            for (let item of this.groupsWithoutAccess)
                data["groupsWithoutAccess"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITreeNodeAccessRightRequestDTO {
    withAccessRights?: TreeNodeAccessRightDTO[] | undefined;
    usersWithoutAccess?: UserDTO[] | undefined;
    groupsWithoutAccess?: GroupDTO[] | undefined;
}

export class ProjectNodeInfoDTO implements IProjectNodeInfoDTO {
    node?: ProjectInfoDTO | undefined;
    treeNodeId!: number;
    users?: UsersDTO[] | undefined;
    imagingSchedules?: ExperimentImagingScheduleDTO[] | undefined;

    constructor(data?: IProjectNodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.node = _data["node"] ? ProjectInfoDTO.fromJS(_data["node"]) : undefined as any;
            this.treeNodeId = _data["treeNodeId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersDTO.fromJS(item));
            }
            if (Array.isArray(_data["imagingSchedules"])) {
                this.imagingSchedules = [] as any;
                for (let item of _data["imagingSchedules"])
                    this.imagingSchedules!.push(ExperimentImagingScheduleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectNodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectNodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["node"] = this.node ? this.node.toJSON() : undefined as any;
        data["treeNodeId"] = this.treeNodeId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagingSchedules)) {
            data["imagingSchedules"] = [];
            for (let item of this.imagingSchedules)
                data["imagingSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectNodeInfoDTO {
    node?: ProjectInfoDTO | undefined;
    treeNodeId: number;
    users?: UsersDTO[] | undefined;
    imagingSchedules?: ExperimentImagingScheduleDTO[] | undefined;
}

export class NodeChildsCountDTO implements INodeChildsCountDTO {
    folderCount!: number;
    projectsCount!: number;
    experimentCount!: number;
    screensCount!: number;
    proteinsCount!: number;
    seedsCount!: number;
    fragmentScreensCount!: number;
    searchesCount!: number;

    constructor(data?: INodeChildsCountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderCount = _data["folderCount"];
            this.projectsCount = _data["projectsCount"];
            this.experimentCount = _data["experimentCount"];
            this.screensCount = _data["screensCount"];
            this.proteinsCount = _data["proteinsCount"];
            this.seedsCount = _data["seedsCount"];
            this.fragmentScreensCount = _data["fragmentScreensCount"];
            this.searchesCount = _data["searchesCount"];
        }
    }

    static fromJS(data: any): NodeChildsCountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NodeChildsCountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderCount"] = this.folderCount;
        data["projectsCount"] = this.projectsCount;
        data["experimentCount"] = this.experimentCount;
        data["screensCount"] = this.screensCount;
        data["proteinsCount"] = this.proteinsCount;
        data["seedsCount"] = this.seedsCount;
        data["fragmentScreensCount"] = this.fragmentScreensCount;
        data["searchesCount"] = this.searchesCount;
        return data;
    }
}

export interface INodeChildsCountDTO {
    folderCount: number;
    projectsCount: number;
    experimentCount: number;
    screensCount: number;
    proteinsCount: number;
    seedsCount: number;
    fragmentScreensCount: number;
    searchesCount: number;
}

export class ProjectCrystalDTO implements IProjectCrystalDTO {
    name?: string | undefined;
    experimentName?: string | undefined;
    proteinName?: string | undefined;
    synchotronTrip?: string | undefined;
    dataCollected!: boolean;
    resolution?: string | undefined;
    structure?: string | undefined;
    dateFrozen!: Date;
    soaking!: number;

    constructor(data?: IProjectCrystalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.experimentName = _data["experimentName"];
            this.proteinName = _data["proteinName"];
            this.synchotronTrip = _data["synchotronTrip"];
            this.dataCollected = _data["dataCollected"];
            this.resolution = _data["resolution"];
            this.structure = _data["structure"];
            this.dateFrozen = _data["dateFrozen"] ? new Date(_data["dateFrozen"].toString()) : undefined as any;
            this.soaking = _data["soaking"];
        }
    }

    static fromJS(data: any): ProjectCrystalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCrystalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["experimentName"] = this.experimentName;
        data["proteinName"] = this.proteinName;
        data["synchotronTrip"] = this.synchotronTrip;
        data["dataCollected"] = this.dataCollected;
        data["resolution"] = this.resolution;
        data["structure"] = this.structure;
        data["dateFrozen"] = this.dateFrozen ? this.dateFrozen.toISOString() : undefined as any;
        data["soaking"] = this.soaking;
        return data;
    }
}

export interface IProjectCrystalDTO {
    name?: string | undefined;
    experimentName?: string | undefined;
    proteinName?: string | undefined;
    synchotronTrip?: string | undefined;
    dataCollected: boolean;
    resolution?: string | undefined;
    structure?: string | undefined;
    dateFrozen: Date;
    soaking: number;
}

export class UnlockNodeRequestDTO implements IUnlockNodeRequestDTO {
    treeNodeId!: number;

    constructor(data?: IUnlockNodeRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.treeNodeId = _data["treeNodeId"];
        }
    }

    static fromJS(data: any): UnlockNodeRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnlockNodeRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["treeNodeId"] = this.treeNodeId;
        return data;
    }
}

export interface IUnlockNodeRequestDTO {
    treeNodeId: number;
}

export class AnalyzeTreeNodeDTO implements IAnalyzeTreeNodeDTO {
    searchesNodes?: TreeNodeDTO[] | undefined;
    projectsNodes?: TreeNodeDTO[] | undefined;

    constructor(data?: IAnalyzeTreeNodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchesNodes"])) {
                this.searchesNodes = [] as any;
                for (let item of _data["searchesNodes"])
                    this.searchesNodes!.push(TreeNodeDTO.fromJS(item));
            }
            if (Array.isArray(_data["projectsNodes"])) {
                this.projectsNodes = [] as any;
                for (let item of _data["projectsNodes"])
                    this.projectsNodes!.push(TreeNodeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalyzeTreeNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyzeTreeNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchesNodes)) {
            data["searchesNodes"] = [];
            for (let item of this.searchesNodes)
                data["searchesNodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectsNodes)) {
            data["projectsNodes"] = [];
            for (let item of this.projectsNodes)
                data["projectsNodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAnalyzeTreeNodeDTO {
    searchesNodes?: TreeNodeDTO[] | undefined;
    projectsNodes?: TreeNodeDTO[] | undefined;
}

export class DeleteTreeNodesRequest implements IDeleteTreeNodesRequest {
    treeNodeId?: number[] | undefined;

    constructor(data?: IDeleteTreeNodesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["treeNodeId"])) {
                this.treeNodeId = [] as any;
                for (let item of _data["treeNodeId"])
                    this.treeNodeId!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteTreeNodesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTreeNodesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.treeNodeId)) {
            data["treeNodeId"] = [];
            for (let item of this.treeNodeId)
                data["treeNodeId"].push(item);
        }
        return data;
    }
}

export interface IDeleteTreeNodesRequest {
    treeNodeId?: number[] | undefined;
}

export class SearchNodeInfoDTO implements ISearchNodeInfoDTO {
    paths?: string[] | undefined;
    targetName?: string | undefined;

    constructor(data?: ISearchNodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paths"])) {
                this.paths = [] as any;
                for (let item of _data["paths"])
                    this.paths!.push(item);
            }
            this.targetName = _data["targetName"];
        }
    }

    static fromJS(data: any): SearchNodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paths)) {
            data["paths"] = [];
            for (let item of this.paths)
                data["paths"].push(item);
        }
        data["targetName"] = this.targetName;
        return data;
    }
}

export interface ISearchNodeInfoDTO {
    paths?: string[] | undefined;
    targetName?: string | undefined;
}

export class EagerLoadTreeNodeDTO extends TreeNodeDTO implements IEagerLoadTreeNodeDTO {
    state?: TreeState | undefined;
    children?: EagerLoadTreeNodeDTO[] | undefined;

    constructor(data?: IEagerLoadTreeNodeDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.state = _data["state"] ? TreeState.fromJS(_data["state"]) : undefined as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(EagerLoadTreeNodeDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EagerLoadTreeNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EagerLoadTreeNodeDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEagerLoadTreeNodeDTO extends ITreeNodeDTO {
    state?: TreeState | undefined;
    children?: EagerLoadTreeNodeDTO[] | undefined;
}

export class TreeState implements ITreeState {
    expanded!: boolean;

    constructor(data?: ITreeState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expanded = _data["expanded"];
        }
    }

    static fromJS(data: any): TreeState {
        data = typeof data === 'object' ? data : {};
        let result = new TreeState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expanded"] = this.expanded;
        return data;
    }
}

export interface ITreeState {
    expanded: boolean;
}

export class UsageStatDTO implements IUsageStatDTO {
    feature?: string | undefined;

    constructor(data?: IUsageStatDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feature = _data["feature"];
        }
    }

    static fromJS(data: any): UsageStatDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UsageStatDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feature"] = this.feature;
        return data;
    }
}

export interface IUsageStatDTO {
    feature?: string | undefined;
}

export class UserGroupDetailDTO implements IUserGroupDetailDTO {
    groups?: GroupDTO[] | undefined;
    users?: UserDTO[] | undefined;

    constructor(data?: IUserGroupDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupDTO.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserGroupDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserGroupDetailDTO {
    groups?: GroupDTO[] | undefined;
    users?: UserDTO[] | undefined;
}

export class WellImageDTO implements IWellImageDTO {
    wellImage?: string | undefined;
    width!: number;
    height!: number;
    isImageAvailable!: boolean;
    pixelSize?: number | undefined;
    bestFlImageName?: string | undefined;
    bflLongName?: string | undefined;
    isFrap!: boolean;
    bflImageTypeIndex?: number | undefined;
    wellNumber!: number;
    cpId!: number;
    imageStoreId?: number | undefined;
    imageTypeShortName?: string | undefined;
    captureResultTuningValuesDto?: CaptureResultTuningValuesDTO | undefined;
    key?: string | undefined;
    captureResultProperties?: CaptureResultProperty[] | undefined;
    isAnnotated!: boolean;
    isZoomed!: boolean;

    constructor(data?: IWellImageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellImage = _data["wellImage"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.isImageAvailable = _data["isImageAvailable"];
            this.pixelSize = _data["pixelSize"];
            this.bestFlImageName = _data["bestFlImageName"];
            this.bflLongName = _data["bflLongName"];
            this.isFrap = _data["isFrap"];
            this.bflImageTypeIndex = _data["bflImageTypeIndex"];
            this.wellNumber = _data["wellNumber"];
            this.cpId = _data["cpId"];
            this.imageStoreId = _data["imageStoreId"];
            this.imageTypeShortName = _data["imageTypeShortName"];
            this.captureResultTuningValuesDto = _data["captureResultTuningValuesDto"] ? CaptureResultTuningValuesDTO.fromJS(_data["captureResultTuningValuesDto"]) : undefined as any;
            this.key = _data["key"];
            if (Array.isArray(_data["captureResultProperties"])) {
                this.captureResultProperties = [] as any;
                for (let item of _data["captureResultProperties"])
                    this.captureResultProperties!.push(CaptureResultProperty.fromJS(item));
            }
            this.isAnnotated = _data["isAnnotated"];
            this.isZoomed = _data["isZoomed"];
        }
    }

    static fromJS(data: any): WellImageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellImageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellImage"] = this.wellImage;
        data["width"] = this.width;
        data["height"] = this.height;
        data["isImageAvailable"] = this.isImageAvailable;
        data["pixelSize"] = this.pixelSize;
        data["bestFlImageName"] = this.bestFlImageName;
        data["bflLongName"] = this.bflLongName;
        data["isFrap"] = this.isFrap;
        data["bflImageTypeIndex"] = this.bflImageTypeIndex;
        data["wellNumber"] = this.wellNumber;
        data["cpId"] = this.cpId;
        data["imageStoreId"] = this.imageStoreId;
        data["imageTypeShortName"] = this.imageTypeShortName;
        data["captureResultTuningValuesDto"] = this.captureResultTuningValuesDto ? this.captureResultTuningValuesDto.toJSON() : undefined as any;
        data["key"] = this.key;
        if (Array.isArray(this.captureResultProperties)) {
            data["captureResultProperties"] = [];
            for (let item of this.captureResultProperties)
                data["captureResultProperties"].push(item ? item.toJSON() : undefined as any);
        }
        data["isAnnotated"] = this.isAnnotated;
        data["isZoomed"] = this.isZoomed;
        return data;
    }
}

export interface IWellImageDTO {
    wellImage?: string | undefined;
    width: number;
    height: number;
    isImageAvailable: boolean;
    pixelSize?: number | undefined;
    bestFlImageName?: string | undefined;
    bflLongName?: string | undefined;
    isFrap: boolean;
    bflImageTypeIndex?: number | undefined;
    wellNumber: number;
    cpId: number;
    imageStoreId?: number | undefined;
    imageTypeShortName?: string | undefined;
    captureResultTuningValuesDto?: CaptureResultTuningValuesDTO | undefined;
    key?: string | undefined;
    captureResultProperties?: CaptureResultProperty[] | undefined;
    isAnnotated: boolean;
    isZoomed: boolean;
}

export class WellImageDetailsDTO implements IWellImageDetailsDTO {
    plateId!: number;
    wellNumber!: number;
    batchId!: number;
    dropNumber!: number;
    cpId!: number;
    regionId!: number;
    bestFocusImageRequired!: boolean;
    thumbnailImageType?: string | undefined;
    imageTypeShortName?: string | undefined;
    regionName?: string | undefined;
    imageStoreId?: number | undefined;
    bflImageTypeIndex?: number | undefined;

    constructor(data?: IWellImageDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.wellNumber = _data["wellNumber"];
            this.batchId = _data["batchId"];
            this.dropNumber = _data["dropNumber"];
            this.cpId = _data["cpId"];
            this.regionId = _data["regionId"];
            this.bestFocusImageRequired = _data["bestFocusImageRequired"];
            this.thumbnailImageType = _data["thumbnailImageType"];
            this.imageTypeShortName = _data["imageTypeShortName"];
            this.regionName = _data["regionName"];
            this.imageStoreId = _data["imageStoreId"];
            this.bflImageTypeIndex = _data["bflImageTypeIndex"];
        }
    }

    static fromJS(data: any): WellImageDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellImageDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["wellNumber"] = this.wellNumber;
        data["batchId"] = this.batchId;
        data["dropNumber"] = this.dropNumber;
        data["cpId"] = this.cpId;
        data["regionId"] = this.regionId;
        data["bestFocusImageRequired"] = this.bestFocusImageRequired;
        data["thumbnailImageType"] = this.thumbnailImageType;
        data["imageTypeShortName"] = this.imageTypeShortName;
        data["regionName"] = this.regionName;
        data["imageStoreId"] = this.imageStoreId;
        data["bflImageTypeIndex"] = this.bflImageTypeIndex;
        return data;
    }
}

export interface IWellImageDetailsDTO {
    plateId: number;
    wellNumber: number;
    batchId: number;
    dropNumber: number;
    cpId: number;
    regionId: number;
    bestFocusImageRequired: boolean;
    thumbnailImageType?: string | undefined;
    imageTypeShortName?: string | undefined;
    regionName?: string | undefined;
    imageStoreId?: number | undefined;
    bflImageTypeIndex?: number | undefined;
}

export class WellImageParams implements IWellImageParams {
    pid!: number;
    wellNumber!: number;
    batchId!: number;
    dropNumber!: number;
    cpID!: number;
    regionID!: number;
    thumbnailImageType?: string | undefined;
    key?: string | undefined;

    constructor(data?: IWellImageParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["pid"];
            this.wellNumber = _data["wellNumber"];
            this.batchId = _data["batchId"];
            this.dropNumber = _data["dropNumber"];
            this.cpID = _data["cpID"];
            this.regionID = _data["regionID"];
            this.thumbnailImageType = _data["thumbnailImageType"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): WellImageParams {
        data = typeof data === 'object' ? data : {};
        let result = new WellImageParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pid"] = this.pid;
        data["wellNumber"] = this.wellNumber;
        data["batchId"] = this.batchId;
        data["dropNumber"] = this.dropNumber;
        data["cpID"] = this.cpID;
        data["regionID"] = this.regionID;
        data["thumbnailImageType"] = this.thumbnailImageType;
        data["key"] = this.key;
        return data;
    }
}

export interface IWellImageParams {
    pid: number;
    wellNumber: number;
    batchId: number;
    dropNumber: number;
    cpID: number;
    regionID: number;
    thumbnailImageType?: string | undefined;
    key?: string | undefined;
}

export class WellHitImageRequestDTO implements IWellHitImageRequestDTO {
    pid!: number;
    wellNumber!: number;
    batchId!: number;
    dropNumber!: number;
    cpIdList?: number[] | undefined;
    regionName?: string | undefined;
    regionId!: number;
    width!: number;
    height!: number;
    bestFocusImageRequired!: boolean;
    thumbnailImageType?: string | undefined;

    constructor(data?: IWellHitImageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["pid"];
            this.wellNumber = _data["wellNumber"];
            this.batchId = _data["batchId"];
            this.dropNumber = _data["dropNumber"];
            if (Array.isArray(_data["cpIdList"])) {
                this.cpIdList = [] as any;
                for (let item of _data["cpIdList"])
                    this.cpIdList!.push(item);
            }
            this.regionName = _data["regionName"];
            this.regionId = _data["regionId"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.bestFocusImageRequired = _data["bestFocusImageRequired"];
            this.thumbnailImageType = _data["thumbnailImageType"];
        }
    }

    static fromJS(data: any): WellHitImageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellHitImageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pid"] = this.pid;
        data["wellNumber"] = this.wellNumber;
        data["batchId"] = this.batchId;
        data["dropNumber"] = this.dropNumber;
        if (Array.isArray(this.cpIdList)) {
            data["cpIdList"] = [];
            for (let item of this.cpIdList)
                data["cpIdList"].push(item);
        }
        data["regionName"] = this.regionName;
        data["regionId"] = this.regionId;
        data["width"] = this.width;
        data["height"] = this.height;
        data["bestFocusImageRequired"] = this.bestFocusImageRequired;
        data["thumbnailImageType"] = this.thumbnailImageType;
        return data;
    }
}

export interface IWellHitImageRequestDTO {
    pid: number;
    wellNumber: number;
    batchId: number;
    dropNumber: number;
    cpIdList?: number[] | undefined;
    regionName?: string | undefined;
    regionId: number;
    width: number;
    height: number;
    bestFocusImageRequired: boolean;
    thumbnailImageType?: string | undefined;
}

export class ReportImageRequestDTO implements IReportImageRequestDTO {
    saveImageRequestDTO?: SaveImageRequestDTO | undefined;
    reportType?: string | undefined;

    constructor(data?: IReportImageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saveImageRequestDTO = _data["saveImageRequestDTO"] ? SaveImageRequestDTO.fromJS(_data["saveImageRequestDTO"]) : undefined as any;
            this.reportType = _data["reportType"];
        }
    }

    static fromJS(data: any): ReportImageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReportImageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saveImageRequestDTO"] = this.saveImageRequestDTO ? this.saveImageRequestDTO.toJSON() : undefined as any;
        data["reportType"] = this.reportType;
        return data;
    }
}

export interface IReportImageRequestDTO {
    saveImageRequestDTO?: SaveImageRequestDTO | undefined;
    reportType?: string | undefined;
}

export class RegionDrawingDTO implements IRegionDrawingDTO {
    type!: number;
    pid!: number;
    wellNumber!: number;
    cpId!: number;
    batchId!: number;
    dropNum!: number;
    regionName?: string | undefined;
    points?: number[] | undefined;
    fontFamily?: string | undefined;
    fontSize?: number | undefined;
    textDecoration?: string | undefined;
    fontStyle?: string | undefined;
    text?: string | undefined;
    color?: string | undefined;

    constructor(data?: IRegionDrawingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.pid = _data["pid"];
            this.wellNumber = _data["wellNumber"];
            this.cpId = _data["cpId"];
            this.batchId = _data["batchId"];
            this.dropNum = _data["dropNum"];
            this.regionName = _data["regionName"];
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(item);
            }
            this.fontFamily = _data["fontFamily"];
            this.fontSize = _data["fontSize"];
            this.textDecoration = _data["textDecoration"];
            this.fontStyle = _data["fontStyle"];
            this.text = _data["text"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): RegionDrawingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDrawingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["pid"] = this.pid;
        data["wellNumber"] = this.wellNumber;
        data["cpId"] = this.cpId;
        data["batchId"] = this.batchId;
        data["dropNum"] = this.dropNum;
        data["regionName"] = this.regionName;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item);
        }
        data["fontFamily"] = this.fontFamily;
        data["fontSize"] = this.fontSize;
        data["textDecoration"] = this.textDecoration;
        data["fontStyle"] = this.fontStyle;
        data["text"] = this.text;
        data["color"] = this.color;
        return data;
    }
}

export interface IRegionDrawingDTO {
    type: number;
    pid: number;
    wellNumber: number;
    cpId: number;
    batchId: number;
    dropNum: number;
    regionName?: string | undefined;
    points?: number[] | undefined;
    fontFamily?: string | undefined;
    fontSize?: number | undefined;
    textDecoration?: string | undefined;
    fontStyle?: string | undefined;
    text?: string | undefined;
    color?: string | undefined;
}

export class PlateScribbleResponseDTO implements IPlateScribbleResponseDTO {
    allScribbles?: PlateScribbleDTO | undefined;
    drawingId!: number;

    constructor(data?: IPlateScribbleResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allScribbles = _data["allScribbles"] ? PlateScribbleDTO.fromJS(_data["allScribbles"]) : undefined as any;
            this.drawingId = _data["drawingId"];
        }
    }

    static fromJS(data: any): PlateScribbleResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateScribbleResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allScribbles"] = this.allScribbles ? this.allScribbles.toJSON() : undefined as any;
        data["drawingId"] = this.drawingId;
        return data;
    }
}

export interface IPlateScribbleResponseDTO {
    allScribbles?: PlateScribbleDTO | undefined;
    drawingId: number;
}

export class DeleteScribbleDTO implements IDeleteScribbleDTO {
    id!: number;
    type!: number;

    constructor(data?: IDeleteScribbleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DeleteScribbleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteScribbleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IDeleteScribbleDTO {
    id: number;
    type: number;
}

export class WellSelectionDTO implements IWellSelectionDTO {
    plateId!: number;
    wellNumber!: number;
    dropNumber!: number;

    constructor(data?: IWellSelectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
        }
    }

    static fromJS(data: any): WellSelectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellSelectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        return data;
    }
}

export interface IWellSelectionDTO {
    plateId: number;
    wellNumber: number;
    dropNumber: number;
}

export class CSVExportRequestDTO implements ICSVExportRequestDTO {
    experimentId!: number;
    dropTab!: boolean;
    plateId?: number | undefined;
    wellNumber?: number | undefined;
    dropNumber?: number | undefined;
    regionId?: number | undefined;
    exportType!: EPoiExportType;
    plateIds?: number[] | undefined;

    constructor(data?: ICSVExportRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.dropTab = _data["dropTab"];
            this.plateId = _data["plateId"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.regionId = _data["regionId"];
            this.exportType = _data["exportType"];
            if (Array.isArray(_data["plateIds"])) {
                this.plateIds = [] as any;
                for (let item of _data["plateIds"])
                    this.plateIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CSVExportRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CSVExportRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["dropTab"] = this.dropTab;
        data["plateId"] = this.plateId;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["regionId"] = this.regionId;
        data["exportType"] = this.exportType;
        if (Array.isArray(this.plateIds)) {
            data["plateIds"] = [];
            for (let item of this.plateIds)
                data["plateIds"].push(item);
        }
        return data;
    }
}

export interface ICSVExportRequestDTO {
    experimentId: number;
    dropTab: boolean;
    plateId?: number | undefined;
    wellNumber?: number | undefined;
    dropNumber?: number | undefined;
    regionId?: number | undefined;
    exportType: EPoiExportType;
    plateIds?: number[] | undefined;
}

export enum EPoiExportType {
    Default = 0,
    CrystalShifter = 1,
    EchoRobot = 2,
    SoakDB = 3,
}

export class WellImagingDetails implements IWellImagingDetails {
    regionName?: string | undefined;
    cpName?: string | undefined;
    inspectionName?: string | undefined;

    constructor(data?: IWellImagingDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionName = _data["regionName"];
            this.cpName = _data["cpName"];
            this.inspectionName = _data["inspectionName"];
        }
    }

    static fromJS(data: any): WellImagingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WellImagingDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionName"] = this.regionName;
        data["cpName"] = this.cpName;
        data["inspectionName"] = this.inspectionName;
        return data;
    }
}

export interface IWellImagingDetails {
    regionName?: string | undefined;
    cpName?: string | undefined;
    inspectionName?: string | undefined;
}

export class WellDropImportFlDTO implements IWellDropImportFlDTO {
    plateId!: number;
    wellNumber!: number;
    dropNumber!: number;
    importFl!: boolean;

    constructor(data?: IWellDropImportFlDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.importFl = _data["importFl"];
        }
    }

    static fromJS(data: any): WellDropImportFlDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellDropImportFlDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["importFl"] = this.importFl;
        return data;
    }
}

export interface IWellDropImportFlDTO {
    plateId: number;
    wellNumber: number;
    dropNumber: number;
    importFl: boolean;
}

export class WellImageScoreDTO implements IWellImageScoreDTO {
    plateId!: number;
    experimentPlateId!: number;
    experimentId!: number;
    wellId!: number;
    wellNumber!: number;
    dropNumber!: number;
    wellDropScoreId!: number;
    imageBatchId!: number;
    autoScoreValue!: number;
    wellDropId!: number;
    regionId!: number;
    image?: WellImageDTO | undefined;
    cpid!: number;

    constructor(data?: IWellImageScoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateId = _data["plateId"];
            this.experimentPlateId = _data["experimentPlateId"];
            this.experimentId = _data["experimentId"];
            this.wellId = _data["wellId"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.wellDropScoreId = _data["wellDropScoreId"];
            this.imageBatchId = _data["imageBatchId"];
            this.autoScoreValue = _data["autoScoreValue"];
            this.wellDropId = _data["wellDropId"];
            this.regionId = _data["regionId"];
            this.image = _data["image"] ? WellImageDTO.fromJS(_data["image"]) : undefined as any;
            this.cpid = _data["cpid"];
        }
    }

    static fromJS(data: any): WellImageScoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellImageScoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateId"] = this.plateId;
        data["experimentPlateId"] = this.experimentPlateId;
        data["experimentId"] = this.experimentId;
        data["wellId"] = this.wellId;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["wellDropScoreId"] = this.wellDropScoreId;
        data["imageBatchId"] = this.imageBatchId;
        data["autoScoreValue"] = this.autoScoreValue;
        data["wellDropId"] = this.wellDropId;
        data["regionId"] = this.regionId;
        data["image"] = this.image ? this.image.toJSON() : undefined as any;
        data["cpid"] = this.cpid;
        return data;
    }
}

export interface IWellImageScoreDTO {
    plateId: number;
    experimentPlateId: number;
    experimentId: number;
    wellId: number;
    wellNumber: number;
    dropNumber: number;
    wellDropScoreId: number;
    imageBatchId: number;
    autoScoreValue: number;
    wellDropId: number;
    regionId: number;
    image?: WellImageDTO | undefined;
    cpid: number;
}

export class Result implements IResult {
    resultCode!: EResultCode;
    description!: string;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCode = _data["resultCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCode"] = this.resultCode;
        data["description"] = this.description;
        return data;
    }
}

export interface IResult {
    resultCode: EResultCode;
    description: string;
}

export class ResultWithValueOfString extends Result implements IResultWithValueOfString {
    value?: string | undefined;

    constructor(data?: IResultWithValueOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResultWithValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfString extends IResult {
    value?: string | undefined;
}

export enum EResultCode {
    UNKNOWN = 0,
    OK = 1,
    WARNING = 100,
    FAIL = 200,
    FILE_NOT_FOUND = 404,
    ERROR = 500,
}

export class MarkAsDispensedRequestDto implements IMarkAsDispensedRequestDto {
    barcode?: string | undefined;

    constructor(data?: IMarkAsDispensedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): MarkAsDispensedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAsDispensedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        return data;
    }
}

export interface IMarkAsDispensedRequestDto {
    barcode?: string | undefined;
}

export class UpdateVolumeRequestDto implements IUpdateVolumeRequestDto {
    barcode?: string | undefined;
    volume!: number;

    constructor(data?: IUpdateVolumeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): UpdateVolumeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVolumeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["volume"] = this.volume;
        return data;
    }
}

export interface IUpdateVolumeRequestDto {
    barcode?: string | undefined;
    volume: number;
}

export class DispensingRobotMessageRequestDto implements IDispensingRobotMessageRequestDto {
    level!: ELevel;
    timeStamp!: Date;
    message!: string;

    constructor(data?: IDispensingRobotMessageRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : undefined as any;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DispensingRobotMessageRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DispensingRobotMessageRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : undefined as any;
        data["message"] = this.message;
        return data;
    }
}

export interface IDispensingRobotMessageRequestDto {
    level: ELevel;
    timeStamp: Date;
    message: string;
}

export enum ELevel {
    Info = 0,
    Warning = 1,
    Error = 2,
}

export class SaveCaptureResultRequestDto implements ISaveCaptureResultRequestDto {
    processingInfo!: ProcessingInfoDto;
    captureInfo!: CaptureInfoDto;

    constructor(data?: ISaveCaptureResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.processingInfo = new ProcessingInfoDto();
            this.captureInfo = new CaptureInfoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingInfo = _data["processingInfo"] ? ProcessingInfoDto.fromJS(_data["processingInfo"]) : new ProcessingInfoDto();
            this.captureInfo = _data["captureInfo"] ? CaptureInfoDto.fromJS(_data["captureInfo"]) : new CaptureInfoDto();
        }
    }

    static fromJS(data: any): SaveCaptureResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCaptureResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingInfo"] = this.processingInfo ? this.processingInfo.toJSON() : undefined as any;
        data["captureInfo"] = this.captureInfo ? this.captureInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveCaptureResultRequestDto {
    processingInfo: ProcessingInfoDto;
    captureInfo: CaptureInfoDto;
}

export class ProcessingInfoDto implements IProcessingInfoDto {
    plateID!: number;
    imagingID!: number;
    profileID!: number;
    wellNumber!: number;
    dropNumber!: number;
    regionTypeId!: number;
    regionID!: number;

    constructor(data?: IProcessingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            this.imagingID = _data["imagingID"];
            this.profileID = _data["profileID"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.regionTypeId = _data["regionTypeId"];
            this.regionID = _data["regionID"];
        }
    }

    static fromJS(data: any): ProcessingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        data["imagingID"] = this.imagingID;
        data["profileID"] = this.profileID;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["regionTypeId"] = this.regionTypeId;
        data["regionID"] = this.regionID;
        return data;
    }
}

export interface IProcessingInfoDto {
    plateID: number;
    imagingID: number;
    profileID: number;
    wellNumber: number;
    dropNumber: number;
    regionTypeId: number;
    regionID: number;
}

export class CaptureInfoDto implements ICaptureInfoDto {
    location!: ImageRectDTO;
    focalPoints?: FocalPointDto[] | undefined;
    properties!: PropertyDTO[];

    constructor(data?: ICaptureInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.location = new ImageRectDTO();
            this.properties = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? ImageRectDTO.fromJS(_data["location"]) : new ImageRectDTO();
            if (Array.isArray(_data["focalPoints"])) {
                this.focalPoints = [] as any;
                for (let item of _data["focalPoints"])
                    this.focalPoints!.push(FocalPointDto.fromJS(item));
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaptureInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        if (Array.isArray(this.focalPoints)) {
            data["focalPoints"] = [];
            for (let item of this.focalPoints)
                data["focalPoints"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICaptureInfoDto {
    location: ImageRectDTO;
    focalPoints?: FocalPointDto[] | undefined;
    properties: PropertyDTO[];
}

export class ImageRectDTO implements IImageRectDTO {
    x!: number;
    y!: number;
    z!: number;
    width!: number;
    height!: number;

    constructor(data?: IImageRectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): ImageRectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageRectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IImageRectDTO {
    x: number;
    y: number;
    z: number;
    width: number;
    height: number;
}

export class FocalPointDto implements IFocalPointDto {
    z!: number;
    focus!: number;

    constructor(data?: IFocalPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.z = _data["z"];
            this.focus = _data["focus"];
        }
    }

    static fromJS(data: any): FocalPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new FocalPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["z"] = this.z;
        data["focus"] = this.focus;
        return data;
    }
}

export interface IFocalPointDto {
    z: number;
    focus: number;
}

export class PropertyDTO implements IPropertyDTO {
    id!: number;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IPropertyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IPropertyDTO {
    id: number;
    name?: string | undefined;
    value?: string | undefined;
}

export enum EImageType {
    FocusLevel = 0,
    ExtendedFocus = 1,
    BestFocus = 2,
    DropLocation = 3,
    Thumbnail = 4,
}

export enum EImageFormat {
    UNKNOWN = 0,
    JPG = 1,
    PNG = 2,
    TIFF = 3,
    GIF = 4,
    BMP = 5,
    WEBP = 6,
    ICO = 7,
}

export class ResultWithValueOfImageSaveInfoDto extends Result implements IResultWithValueOfImageSaveInfoDto {
    value?: ImageSaveInfoDto | undefined;

    constructor(data?: IResultWithValueOfImageSaveInfoDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ImageSaveInfoDto.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultWithValueOfImageSaveInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfImageSaveInfoDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfImageSaveInfoDto extends IResult {
    value?: ImageSaveInfoDto | undefined;
}

export class ImageSaveInfoDto implements IImageSaveInfoDto {
    thumbnail?: ThumbnailSaveInfoDto | undefined;
    scale!: number;
    imageFormat!: EImageFormat;
    quality!: number;
    useLosslessCompression!: boolean;

    constructor(data?: IImageSaveInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thumbnail = _data["thumbnail"] ? ThumbnailSaveInfoDto.fromJS(_data["thumbnail"]) : undefined as any;
            this.scale = _data["scale"];
            this.imageFormat = _data["imageFormat"];
            this.quality = _data["quality"];
            this.useLosslessCompression = _data["useLosslessCompression"];
        }
    }

    static fromJS(data: any): ImageSaveInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageSaveInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : undefined as any;
        data["scale"] = this.scale;
        data["imageFormat"] = this.imageFormat;
        data["quality"] = this.quality;
        data["useLosslessCompression"] = this.useLosslessCompression;
        return data;
    }
}

export interface IImageSaveInfoDto {
    thumbnail?: ThumbnailSaveInfoDto | undefined;
    scale: number;
    imageFormat: EImageFormat;
    quality: number;
    useLosslessCompression: boolean;
}

export class ThumbnailSaveInfoDto implements IThumbnailSaveInfoDto {
    maxWidth!: number;
    maxHeight!: number;
    quality!: number;
    imageFormat!: EImageFormat;

    constructor(data?: IThumbnailSaveInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxWidth = _data["maxWidth"];
            this.maxHeight = _data["maxHeight"];
            this.quality = _data["quality"];
            this.imageFormat = _data["imageFormat"];
        }
    }

    static fromJS(data: any): ThumbnailSaveInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThumbnailSaveInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxWidth"] = this.maxWidth;
        data["maxHeight"] = this.maxHeight;
        data["quality"] = this.quality;
        data["imageFormat"] = this.imageFormat;
        return data;
    }
}

export interface IThumbnailSaveInfoDto {
    maxWidth: number;
    maxHeight: number;
    quality: number;
    imageFormat: EImageFormat;
}

export class SetAutoScoreImageDataAndClassRequestDto implements ISetAutoScoreImageDataAndClassRequestDto {
    processingInfo!: ProcessingInfoDto;
    autoScoreImageData!: AutoScoreImageDataRipDto;
    imageType!: EImageType;
    imageClass!: EAutoScoreImageClass;

    constructor(data?: ISetAutoScoreImageDataAndClassRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.processingInfo = new ProcessingInfoDto();
            this.autoScoreImageData = new AutoScoreImageDataRipDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingInfo = _data["processingInfo"] ? ProcessingInfoDto.fromJS(_data["processingInfo"]) : new ProcessingInfoDto();
            this.autoScoreImageData = _data["autoScoreImageData"] ? AutoScoreImageDataRipDto.fromJS(_data["autoScoreImageData"]) : new AutoScoreImageDataRipDto();
            this.imageType = _data["imageType"];
            this.imageClass = _data["imageClass"];
        }
    }

    static fromJS(data: any): SetAutoScoreImageDataAndClassRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetAutoScoreImageDataAndClassRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingInfo"] = this.processingInfo ? this.processingInfo.toJSON() : undefined as any;
        data["autoScoreImageData"] = this.autoScoreImageData ? this.autoScoreImageData.toJSON() : undefined as any;
        data["imageType"] = this.imageType;
        data["imageClass"] = this.imageClass;
        return data;
    }
}

export interface ISetAutoScoreImageDataAndClassRequestDto {
    processingInfo: ProcessingInfoDto;
    autoScoreImageData: AutoScoreImageDataRipDto;
    imageType: EImageType;
    imageClass: EAutoScoreImageClass;
}

export class AutoScoreImageDataRipDto implements IAutoScoreImageDataRipDto {
    imageData!: { [key: string]: number; };
    imageDataVersion?: VersionDto | undefined;
    imageType!: string;

    constructor(data?: IAutoScoreImageDataRipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.imageData = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["imageData"]) {
                this.imageData = {} as any;
                for (let key in _data["imageData"]) {
                    if (_data["imageData"].hasOwnProperty(key))
                        (this.imageData as any)![key] = _data["imageData"][key];
                }
            }
            this.imageDataVersion = _data["imageDataVersion"] ? VersionDto.fromJS(_data["imageDataVersion"]) : undefined as any;
            this.imageType = _data["imageType"];
        }
    }

    static fromJS(data: any): AutoScoreImageDataRipDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutoScoreImageDataRipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.imageData) {
            data["imageData"] = {};
            for (let key in this.imageData) {
                if (this.imageData.hasOwnProperty(key))
                    (data["imageData"] as any)[key] = (this.imageData as any)[key];
            }
        }
        data["imageDataVersion"] = this.imageDataVersion ? this.imageDataVersion.toJSON() : undefined as any;
        data["imageType"] = this.imageType;
        return data;
    }
}

export interface IAutoScoreImageDataRipDto {
    imageData: { [key: string]: number; };
    imageDataVersion?: VersionDto | undefined;
    imageType: string;
}

export class VersionDto implements IVersionDto {
    major!: number;
    minor!: number;
    build!: number;
    revision!: number;

    constructor(data?: IVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.build = _data["build"];
            this.revision = _data["revision"];
        }
    }

    static fromJS(data: any): VersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["build"] = this.build;
        data["revision"] = this.revision;
        return data;
    }
}

export interface IVersionDto {
    major: number;
    minor: number;
    build: number;
    revision: number;
}

export enum EAutoScoreImageClass {
    NegativeHit = 0,
    PositiveHit = 1,
    Unknown = -1,
}

export class ResultWithValueOfStorageInfoDto extends Result implements IResultWithValueOfStorageInfoDto {
    value?: StorageInfoDto | undefined;

    constructor(data?: IResultWithValueOfStorageInfoDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? StorageInfoDto.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultWithValueOfStorageInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfStorageInfoDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfStorageInfoDto extends IResult {
    value?: StorageInfoDto | undefined;
}

export class StorageInfoDto implements IStorageInfoDto {
    storagePath?: string | undefined;
    freeSpace!: number;
    maxSpace!: number;

    constructor(data?: IStorageInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storagePath = _data["storagePath"];
            this.freeSpace = _data["freeSpace"];
            this.maxSpace = _data["maxSpace"];
        }
    }

    static fromJS(data: any): StorageInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storagePath"] = this.storagePath;
        data["freeSpace"] = this.freeSpace;
        data["maxSpace"] = this.maxSpace;
        return data;
    }
}

export interface IStorageInfoDto {
    storagePath?: string | undefined;
    freeSpace: number;
    maxSpace: number;
}

export class SaveFrapImageDataPointsRequestDto implements ISaveFrapImageDataPointsRequestDto {
    processingInfo!: ProcessingInfoDto;
    dataPoints!: FrapDataPointDto[];

    constructor(data?: ISaveFrapImageDataPointsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.processingInfo = new ProcessingInfoDto();
            this.dataPoints = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingInfo = _data["processingInfo"] ? ProcessingInfoDto.fromJS(_data["processingInfo"]) : new ProcessingInfoDto();
            if (Array.isArray(_data["dataPoints"])) {
                this.dataPoints = [] as any;
                for (let item of _data["dataPoints"])
                    this.dataPoints!.push(FrapDataPointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveFrapImageDataPointsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFrapImageDataPointsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingInfo"] = this.processingInfo ? this.processingInfo.toJSON() : undefined as any;
        if (Array.isArray(this.dataPoints)) {
            data["dataPoints"] = [];
            for (let item of this.dataPoints)
                data["dataPoints"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveFrapImageDataPointsRequestDto {
    processingInfo: ProcessingInfoDto;
    dataPoints: FrapDataPointDto[];
}

export class FrapDataPointDto implements IFrapDataPointDto {
    time!: number;
    value!: number;

    constructor(data?: IFrapDataPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FrapDataPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrapDataPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        data["value"] = this.value;
        return data;
    }
}

export interface IFrapDataPointDto {
    time: number;
    value: number;
}

export class SaveImageRequestDto implements ISaveImageRequestDto {
    processingInfo?: ProcessingInfoDto | undefined;
    imageType!: EImageType;
    imageWidth!: number;
    imageFormat!: EImageFormat;
    imageTypeIndex!: number;
    location!: ImageRectDTO;
    useCheckSum!: boolean;

    constructor(data?: ISaveImageRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.location = new ImageRectDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingInfo = _data["processingInfo"] ? ProcessingInfoDto.fromJS(_data["processingInfo"]) : undefined as any;
            this.imageType = _data["imageType"];
            this.imageWidth = _data["imageWidth"];
            this.imageFormat = _data["imageFormat"];
            this.imageTypeIndex = _data["imageTypeIndex"];
            this.location = _data["location"] ? ImageRectDTO.fromJS(_data["location"]) : new ImageRectDTO();
            this.useCheckSum = _data["useCheckSum"];
        }
    }

    static fromJS(data: any): SaveImageRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveImageRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingInfo"] = this.processingInfo ? this.processingInfo.toJSON() : undefined as any;
        data["imageType"] = this.imageType;
        data["imageWidth"] = this.imageWidth;
        data["imageFormat"] = this.imageFormat;
        data["imageTypeIndex"] = this.imageTypeIndex;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["useCheckSum"] = this.useCheckSum;
        return data;
    }
}

export interface ISaveImageRequestDto {
    processingInfo?: ProcessingInfoDto | undefined;
    imageType: EImageType;
    imageWidth: number;
    imageFormat: EImageFormat;
    imageTypeIndex: number;
    location: ImageRectDTO;
    useCheckSum: boolean;
}

export enum ELightPath {
    Visible = 0,
    Ultraviolet = 1,
    Sonicc = 2,
    Frap = 3,
    Fluorescence = 4,
    Disabled = -1,
}

export class ResultWithValueOfLong extends Result implements IResultWithValueOfLong {
    value!: number;

    constructor(data?: IResultWithValueOfLong) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResultWithValueOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfLong();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfLong extends IResult {
    value: number;
}

export class ResultWithValueOfPlateWithScheduleUpdateDto extends Result implements IResultWithValueOfPlateWithScheduleUpdateDto {
    value?: PlateWithScheduleUpdateDto | undefined;

    constructor(data?: IResultWithValueOfPlateWithScheduleUpdateDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? PlateWithScheduleUpdateDto.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultWithValueOfPlateWithScheduleUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfPlateWithScheduleUpdateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfPlateWithScheduleUpdateDto extends IResult {
    value?: PlateWithScheduleUpdateDto | undefined;
}

export class PlateWithScheduleUpdateDto implements IPlateWithScheduleUpdateDto {
    plateIDs!: number[];
    lastExperimentPlateEventId!: number;

    constructor(data?: IPlateWithScheduleUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.plateIDs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plateIDs"])) {
                this.plateIDs = [] as any;
                for (let item of _data["plateIDs"])
                    this.plateIDs!.push(item);
            }
            this.lastExperimentPlateEventId = _data["lastExperimentPlateEventId"];
        }
    }

    static fromJS(data: any): PlateWithScheduleUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlateWithScheduleUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plateIDs)) {
            data["plateIDs"] = [];
            for (let item of this.plateIDs)
                data["plateIDs"].push(item);
        }
        data["lastExperimentPlateEventId"] = this.lastExperimentPlateEventId;
        return data;
    }
}

export interface IPlateWithScheduleUpdateDto {
    plateIDs: number[];
    lastExperimentPlateEventId: number;
}

export class ResultWithValueOfInteger extends Result implements IResultWithValueOfInteger {
    value!: number;

    constructor(data?: IResultWithValueOfInteger) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResultWithValueOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfInteger();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfInteger extends IResult {
    value: number;
}

export class ImagingPlateRequestDTO implements IImagingPlateRequestDTO {
    plateID!: number;
    dateToImage!: Date;
    dateImaged!: Date;
    isScheduled!: boolean;

    constructor(data?: IImagingPlateRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            this.dateToImage = _data["dateToImage"] ? new Date(_data["dateToImage"].toString()) : undefined as any;
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.isScheduled = _data["isScheduled"];
        }
    }

    static fromJS(data: any): ImagingPlateRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingPlateRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        data["dateToImage"] = this.dateToImage ? this.dateToImage.toISOString() : undefined as any;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["isScheduled"] = this.isScheduled;
        return data;
    }
}

export interface IImagingPlateRequestDTO {
    plateID: number;
    dateToImage: Date;
    dateImaged: Date;
    isScheduled: boolean;
}

export class ResultWithValueOfListOfRiImagingTaskDto extends Result implements IResultWithValueOfListOfRiImagingTaskDto {
    value?: RiImagingTaskDto[] | undefined;

    constructor(data?: IResultWithValueOfListOfRiImagingTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(RiImagingTaskDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfRiImagingTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfRiImagingTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfRiImagingTaskDto extends IResult {
    value?: RiImagingTaskDto[] | undefined;
}

export class RiImagingTaskDto implements IRiImagingTaskDto {
    id!: number;
    dateToImage!: Date;
    priority!: number;
    state!: ERiImagingTaskState;
    dateImaged?: Date | undefined;
    inQueue!: boolean;
    source!: number;
    imagingScheduleEntryId?: number | undefined;

    constructor(data?: IRiImagingTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateToImage = _data["dateToImage"] ? new Date(_data["dateToImage"].toString()) : undefined as any;
            this.priority = _data["priority"];
            this.state = _data["state"];
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.inQueue = _data["inQueue"];
            this.source = _data["source"];
            this.imagingScheduleEntryId = _data["imagingScheduleEntryId"];
        }
    }

    static fromJS(data: any): RiImagingTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new RiImagingTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateToImage"] = this.dateToImage ? this.dateToImage.toISOString() : undefined as any;
        data["priority"] = this.priority;
        data["state"] = this.state;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["inQueue"] = this.inQueue;
        data["source"] = this.source;
        data["imagingScheduleEntryId"] = this.imagingScheduleEntryId;
        return data;
    }
}

export interface IRiImagingTaskDto {
    id: number;
    dateToImage: Date;
    priority: number;
    state: ERiImagingTaskState;
    dateImaged?: Date | undefined;
    inQueue: boolean;
    source: number;
    imagingScheduleEntryId?: number | undefined;
}

export enum ERiImagingTaskState {
    NotCompleted = 1,
    Skipped = 2,
    Pending = 3,
    Queued = 4,
    Imaging = 5,
    Completed = 6,
    Cancelled = 7,
    ForceComplete = 8,
}

export class ResultWithValueOfListOfRiImagingTaskByPlateIdDto extends Result implements IResultWithValueOfListOfRiImagingTaskByPlateIdDto {
    value?: RiImagingTaskByPlateIdDto[] | undefined;

    constructor(data?: IResultWithValueOfListOfRiImagingTaskByPlateIdDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(RiImagingTaskByPlateIdDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfRiImagingTaskByPlateIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfRiImagingTaskByPlateIdDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfRiImagingTaskByPlateIdDto extends IResult {
    value?: RiImagingTaskByPlateIdDto[] | undefined;
}

export class RiImagingTaskByPlateIdDto implements IRiImagingTaskByPlateIdDto {
    plateID!: number;
    imagingTasks?: RiImagingTaskDto[] | undefined;

    constructor(data?: IRiImagingTaskByPlateIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            if (Array.isArray(_data["imagingTasks"])) {
                this.imagingTasks = [] as any;
                for (let item of _data["imagingTasks"])
                    this.imagingTasks!.push(RiImagingTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RiImagingTaskByPlateIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new RiImagingTaskByPlateIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        if (Array.isArray(this.imagingTasks)) {
            data["imagingTasks"] = [];
            for (let item of this.imagingTasks)
                data["imagingTasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRiImagingTaskByPlateIdDto {
    plateID: number;
    imagingTasks?: RiImagingTaskDto[] | undefined;
}

export class GetImagingTasksByPlateIdsRequestDto implements IGetImagingTasksByPlateIdsRequestDto {
    plateIds?: number[] | undefined;

    constructor(data?: IGetImagingTasksByPlateIdsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plateIds"])) {
                this.plateIds = [] as any;
                for (let item of _data["plateIds"])
                    this.plateIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetImagingTasksByPlateIdsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetImagingTasksByPlateIdsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plateIds)) {
            data["plateIds"] = [];
            for (let item of this.plateIds)
                data["plateIds"].push(item);
        }
        return data;
    }
}

export interface IGetImagingTasksByPlateIdsRequestDto {
    plateIds?: number[] | undefined;
}

export class ImagePlateCancelledRequestDto implements IImagePlateCancelledRequestDto {
    imageBatchId!: number;

    constructor(data?: IImagePlateCancelledRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageBatchId = _data["imageBatchId"];
        }
    }

    static fromJS(data: any): ImagePlateCancelledRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImagePlateCancelledRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageBatchId"] = this.imageBatchId;
        return data;
    }
}

export interface IImagePlateCancelledRequestDto {
    imageBatchId: number;
}

export class ImagePlateCompletedRequestDto implements IImagePlateCompletedRequestDto {
    imageBatchId!: number;
    plateId!: number;

    constructor(data?: IImagePlateCompletedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageBatchId = _data["imageBatchId"];
            this.plateId = _data["plateId"];
        }
    }

    static fromJS(data: any): ImagePlateCompletedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImagePlateCompletedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageBatchId"] = this.imageBatchId;
        data["plateId"] = this.plateId;
        return data;
    }
}

export interface IImagePlateCompletedRequestDto {
    imageBatchId: number;
    plateId: number;
}

export class SkippedImagingRequestDto implements ISkippedImagingRequestDto {
    plateID!: number;
    dateToImage!: Date;
    robotId!: number;

    constructor(data?: ISkippedImagingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            this.dateToImage = _data["dateToImage"] ? new Date(_data["dateToImage"].toString()) : undefined as any;
            this.robotId = _data["robotId"];
        }
    }

    static fromJS(data: any): SkippedImagingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkippedImagingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        data["dateToImage"] = this.dateToImage ? this.dateToImage.toISOString() : undefined as any;
        data["robotId"] = this.robotId;
        return data;
    }
}

export interface ISkippedImagingRequestDto {
    plateID: number;
    dateToImage: Date;
    robotId: number;
}

export class UpdatedPriorityRequestDto implements IUpdatedPriorityRequestDto {
    plateID!: number;
    dateToImage!: Date;
    priority!: number;
    robotId!: number;

    constructor(data?: IUpdatedPriorityRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            this.dateToImage = _data["dateToImage"] ? new Date(_data["dateToImage"].toString()) : undefined as any;
            this.priority = _data["priority"];
            this.robotId = _data["robotId"];
        }
    }

    static fromJS(data: any): UpdatedPriorityRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatedPriorityRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        data["dateToImage"] = this.dateToImage ? this.dateToImage.toISOString() : undefined as any;
        data["priority"] = this.priority;
        data["robotId"] = this.robotId;
        return data;
    }
}

export interface IUpdatedPriorityRequestDto {
    plateID: number;
    dateToImage: Date;
    priority: number;
    robotId: number;
}

export class ResultWithValueOfBoolean extends Result implements IResultWithValueOfBoolean {
    value!: boolean;

    constructor(data?: IResultWithValueOfBoolean) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResultWithValueOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfBoolean();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfBoolean extends IResult {
    value: boolean;
}

export class ResultWithValueOfListOfImagingTaskDTO extends Result implements IResultWithValueOfListOfImagingTaskDTO {
    value?: ImagingTaskDTO[] | undefined;

    constructor(data?: IResultWithValueOfListOfImagingTaskDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ImagingTaskDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfImagingTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfImagingTaskDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfImagingTaskDTO extends IResult {
    value?: ImagingTaskDTO[] | undefined;
}

export class ImagingTaskDTO implements IImagingTaskDTO {
    dateToImage!: Date;
    priority!: number;
    state!: number;
    dateImaged?: Date | undefined;
    inQueue!: boolean;

    constructor(data?: IImagingTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateToImage = _data["dateToImage"] ? new Date(_data["dateToImage"].toString()) : undefined as any;
            this.priority = _data["priority"];
            this.state = _data["state"];
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.inQueue = _data["inQueue"];
        }
    }

    static fromJS(data: any): ImagingTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateToImage"] = this.dateToImage ? this.dateToImage.toISOString() : undefined as any;
        data["priority"] = this.priority;
        data["state"] = this.state;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["inQueue"] = this.inQueue;
        return data;
    }
}

export interface IImagingTaskDTO {
    dateToImage: Date;
    priority: number;
    state: number;
    dateImaged?: Date | undefined;
    inQueue: boolean;
}

export class ResultWithValueOfListOfSetupTemperatureDTO extends Result implements IResultWithValueOfListOfSetupTemperatureDTO {
    value?: SetupTemperatureDTO[] | undefined;

    constructor(data?: IResultWithValueOfListOfSetupTemperatureDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(SetupTemperatureDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfSetupTemperatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfSetupTemperatureDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfSetupTemperatureDTO extends IResult {
    value?: SetupTemperatureDTO[] | undefined;
}

export class ResultWithValueOfListOfString extends Result implements IResultWithValueOfListOfString {
    value?: string[] | undefined;

    constructor(data?: IResultWithValueOfListOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfString extends IResult {
    value?: string[] | undefined;
}

export class ResultWithValueOfListOfELightPath extends Result implements IResultWithValueOfListOfELightPath {
    value?: ELightPath[] | undefined;

    constructor(data?: IResultWithValueOfListOfELightPath) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfELightPath {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfELightPath();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfELightPath extends IResult {
    value?: ELightPath[] | undefined;
}

export abstract class IResultOfListOfString implements IIResultOfListOfString {
    value?: string[] | undefined;

    constructor(data?: IIResultOfListOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): IResultOfListOfString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IResultOfListOfString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IIResultOfListOfString {
    value?: string[] | undefined;
}

export abstract class IResultOfListOfELightPath implements IIResultOfListOfELightPath {
    value?: ELightPath[] | undefined;

    constructor(data?: IIResultOfListOfELightPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): IResultOfListOfELightPath {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IResultOfListOfELightPath' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IIResultOfListOfELightPath {
    value?: ELightPath[] | undefined;
}

export abstract class IResultOfCapturePointListDTO implements IIResultOfCapturePointListDTO {
    value?: CapturePointListDTO | undefined;

    constructor(data?: IIResultOfCapturePointListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? CapturePointListDTO.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): IResultOfCapturePointListDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IResultOfCapturePointListDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IIResultOfCapturePointListDTO {
    value?: CapturePointListDTO | undefined;
}

export class CapturePointListDTO implements ICapturePointListDTO {
    plateCaptureProfile?: any | undefined;
    dropLocationProfile?: any | undefined;
    capturePoints?: CapturePointDTO[] | undefined;

    constructor(data?: ICapturePointListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateCaptureProfile = _data["plateCaptureProfile"];
            this.dropLocationProfile = _data["dropLocationProfile"];
            if (Array.isArray(_data["capturePoints"])) {
                this.capturePoints = [] as any;
                for (let item of _data["capturePoints"])
                    this.capturePoints!.push(CapturePointDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CapturePointListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CapturePointListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateCaptureProfile"] = this.plateCaptureProfile;
        data["dropLocationProfile"] = this.dropLocationProfile;
        if (Array.isArray(this.capturePoints)) {
            data["capturePoints"] = [];
            for (let item of this.capturePoints)
                data["capturePoints"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICapturePointListDTO {
    plateCaptureProfile?: any | undefined;
    dropLocationProfile?: any | undefined;
    capturePoints?: CapturePointDTO[] | undefined;
}

export class CapturePointDTO implements ICapturePointDTO {
    regionID!: number;
    regionType!: number;
    wellDropID!: number;
    wellNumber!: number;
    dropNumber!: number;
    location?: ImageRectDTO | undefined;
    parent?: CapturePointDTO | undefined;
    captureProfiles?: CaptureProfileDTO2[] | undefined;

    constructor(data?: ICapturePointDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionID = _data["regionID"];
            this.regionType = _data["regionType"];
            this.wellDropID = _data["wellDropID"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.location = _data["location"] ? ImageRectDTO.fromJS(_data["location"]) : undefined as any;
            this.parent = _data["parent"] ? CapturePointDTO.fromJS(_data["parent"]) : undefined as any;
            if (Array.isArray(_data["captureProfiles"])) {
                this.captureProfiles = [] as any;
                for (let item of _data["captureProfiles"])
                    this.captureProfiles!.push(CaptureProfileDTO2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CapturePointDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CapturePointDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionID"] = this.regionID;
        data["regionType"] = this.regionType;
        data["wellDropID"] = this.wellDropID;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        if (Array.isArray(this.captureProfiles)) {
            data["captureProfiles"] = [];
            for (let item of this.captureProfiles)
                data["captureProfiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICapturePointDTO {
    regionID: number;
    regionType: number;
    wellDropID: number;
    wellNumber: number;
    dropNumber: number;
    location?: ImageRectDTO | undefined;
    parent?: CapturePointDTO | undefined;
    captureProfiles?: CaptureProfileDTO2[] | undefined;
}

export class CaptureProfileDTO2 implements ICaptureProfileDTO2 {
    profileID!: number;
    properties?: PropertyDTO[] | undefined;

    constructor(data?: ICaptureProfileDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileID = _data["profileID"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaptureProfileDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new CaptureProfileDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileID"] = this.profileID;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICaptureProfileDTO2 {
    profileID: number;
    properties?: PropertyDTO[] | undefined;
}

export class ResultWithValueOfCapturePointListDTO extends Result implements IResultWithValueOfCapturePointListDTO {
    value?: CapturePointListDTO | undefined;

    constructor(data?: IResultWithValueOfCapturePointListDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? CapturePointListDTO.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultWithValueOfCapturePointListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfCapturePointListDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfCapturePointListDTO extends IResult {
    value?: CapturePointListDTO | undefined;
}

export abstract class IResultOfInteger implements IIResultOfInteger {
    value!: number;

    constructor(data?: IIResultOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): IResultOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IResultOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IIResultOfInteger {
    value: number;
}

export class UpdateCaptureProfileRequestDTO implements IUpdateCaptureProfileRequestDTO {
    robotID!: number;
    captureProfile!: CaptureProfileDTO2;

    constructor(data?: IUpdateCaptureProfileRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.captureProfile = new CaptureProfileDTO2();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robotID = _data["robotID"];
            this.captureProfile = _data["captureProfile"] ? CaptureProfileDTO2.fromJS(_data["captureProfile"]) : new CaptureProfileDTO2();
        }
    }

    static fromJS(data: any): UpdateCaptureProfileRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaptureProfileRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robotID"] = this.robotID;
        data["captureProfile"] = this.captureProfile ? this.captureProfile.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateCaptureProfileRequestDTO {
    robotID: number;
    captureProfile: CaptureProfileDTO2;
}

export class ResultWithValueOfListOfPlateCapturePropertyValuesDto extends Result implements IResultWithValueOfListOfPlateCapturePropertyValuesDto {
    value?: PlateCapturePropertyValuesDto[] | undefined;

    constructor(data?: IResultWithValueOfListOfPlateCapturePropertyValuesDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(PlateCapturePropertyValuesDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfPlateCapturePropertyValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfPlateCapturePropertyValuesDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfPlateCapturePropertyValuesDto extends IResult {
    value?: PlateCapturePropertyValuesDto[] | undefined;
}

export class PlateCapturePropertyValuesDto implements IPlateCapturePropertyValuesDto {
    plateID?: string | undefined;
    capturePropertyValues?: string[] | undefined;
    capturePropertyValuesDto?: string[] | undefined;

    constructor(data?: IPlateCapturePropertyValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            if (Array.isArray(_data["capturePropertyValues"])) {
                this.capturePropertyValues = [] as any;
                for (let item of _data["capturePropertyValues"])
                    this.capturePropertyValues!.push(item);
            }
            if (Array.isArray(_data["capturePropertyValuesDto"])) {
                this.capturePropertyValuesDto = [] as any;
                for (let item of _data["capturePropertyValuesDto"])
                    this.capturePropertyValuesDto!.push(item);
            }
        }
    }

    static fromJS(data: any): PlateCapturePropertyValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlateCapturePropertyValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        if (Array.isArray(this.capturePropertyValues)) {
            data["capturePropertyValues"] = [];
            for (let item of this.capturePropertyValues)
                data["capturePropertyValues"].push(item);
        }
        if (Array.isArray(this.capturePropertyValuesDto)) {
            data["capturePropertyValuesDto"] = [];
            for (let item of this.capturePropertyValuesDto)
                data["capturePropertyValuesDto"].push(item);
        }
        return data;
    }
}

export interface IPlateCapturePropertyValuesDto {
    plateID?: string | undefined;
    capturePropertyValues?: string[] | undefined;
    capturePropertyValuesDto?: string[] | undefined;
}

export class PlateScheduleInfoDto implements IPlateScheduleInfoDto {
    plateID?: string | undefined;
    scheduled!: boolean;
    dateToImage!: Date;
    dateImaged!: Date;
    propertyName?: string | undefined;
    distinct!: boolean;

    constructor(data?: IPlateScheduleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            this.scheduled = _data["scheduled"];
            this.dateToImage = _data["dateToImage"] ? new Date(_data["dateToImage"].toString()) : undefined as any;
            this.dateImaged = _data["dateImaged"] ? new Date(_data["dateImaged"].toString()) : undefined as any;
            this.propertyName = _data["propertyName"];
            this.distinct = _data["distinct"];
        }
    }

    static fromJS(data: any): PlateScheduleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlateScheduleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        data["scheduled"] = this.scheduled;
        data["dateToImage"] = this.dateToImage ? this.dateToImage.toISOString() : undefined as any;
        data["dateImaged"] = this.dateImaged ? this.dateImaged.toISOString() : undefined as any;
        data["propertyName"] = this.propertyName;
        data["distinct"] = this.distinct;
        return data;
    }
}

export interface IPlateScheduleInfoDto {
    plateID?: string | undefined;
    scheduled: boolean;
    dateToImage: Date;
    dateImaged: Date;
    propertyName?: string | undefined;
    distinct: boolean;
}

export class ResultWithValueOfPropertyDTO extends Result implements IResultWithValueOfPropertyDTO {
    value?: PropertyDTO | undefined;

    constructor(data?: IResultWithValueOfPropertyDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? PropertyDTO.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultWithValueOfPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfPropertyDTO extends IResult {
    value?: PropertyDTO | undefined;
}

export class ResultWithValueOfListOfPropertyDTO extends Result implements IResultWithValueOfListOfPropertyDTO {
    value?: PropertyDTO[] | undefined;

    constructor(data?: IResultWithValueOfListOfPropertyDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(PropertyDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfPropertyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfPropertyDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfPropertyDTO extends IResult {
    value?: PropertyDTO[] | undefined;
}

export class ResultWithValueOfCaptureProfileDTO extends Result implements IResultWithValueOfCaptureProfileDTO {
    value?: CaptureProfileDTO2 | undefined;

    constructor(data?: IResultWithValueOfCaptureProfileDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? CaptureProfileDTO2.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultWithValueOfCaptureProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfCaptureProfileDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfCaptureProfileDTO extends IResult {
    value?: CaptureProfileDTO2 | undefined;
}

export class GetCaptureProfilesByFilterRequestDTO implements IGetCaptureProfilesByFilterRequestDTO {
    robotID!: number;
    properties!: PropertyDTO[];

    constructor(data?: IGetCaptureProfilesByFilterRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.properties = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robotID = _data["robotID"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCaptureProfilesByFilterRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaptureProfilesByFilterRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robotID"] = this.robotID;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCaptureProfilesByFilterRequestDTO {
    robotID: number;
    properties: PropertyDTO[];
}

export class ClearDropLocationOverrideRequestDto implements IClearDropLocationOverrideRequestDto {
    plateIds!: number[];

    constructor(data?: IClearDropLocationOverrideRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.plateIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plateIds"])) {
                this.plateIds = [] as any;
                for (let item of _data["plateIds"])
                    this.plateIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ClearDropLocationOverrideRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClearDropLocationOverrideRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plateIds)) {
            data["plateIds"] = [];
            for (let item of this.plateIds)
                data["plateIds"].push(item);
        }
        return data;
    }
}

export interface IClearDropLocationOverrideRequestDto {
    plateIds: number[];
}

export class ClearDropLocationOverrideByPlateWellDropRequestDTO implements IClearDropLocationOverrideByPlateWellDropRequestDTO {
    plateID!: number;
    wellNumber!: number;
    dropNumber!: number;

    constructor(data?: IClearDropLocationOverrideByPlateWellDropRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
        }
    }

    static fromJS(data: any): ClearDropLocationOverrideByPlateWellDropRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClearDropLocationOverrideByPlateWellDropRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        return data;
    }
}

export interface IClearDropLocationOverrideByPlateWellDropRequestDTO {
    plateID: number;
    wellNumber: number;
    dropNumber: number;
}

export class MarkDoneRequestDTO implements IMarkDoneRequestDTO {
    plateID!: number;
    imageBatchID!: number;
    wellNumber!: number;
    dropNumber!: number;

    constructor(data?: IMarkDoneRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            this.imageBatchID = _data["imageBatchID"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
        }
    }

    static fromJS(data: any): MarkDoneRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MarkDoneRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        data["imageBatchID"] = this.imageBatchID;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        return data;
    }
}

export interface IMarkDoneRequestDTO {
    plateID: number;
    imageBatchID: number;
    wellNumber: number;
    dropNumber: number;
}

export class MailSendingStatusRequestDTO implements IMailSendingStatusRequestDTO {
    barcode!: string;
    plateEventTypeID!: number;
    eventDate!: Date;

    constructor(data?: IMailSendingStatusRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.plateEventTypeID = _data["plateEventTypeID"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MailSendingStatusRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MailSendingStatusRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["plateEventTypeID"] = this.plateEventTypeID;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IMailSendingStatusRequestDTO {
    barcode: string;
    plateEventTypeID: number;
    eventDate: Date;
}

export class ResultWithValueOfListOfGroupDTO extends Result implements IResultWithValueOfListOfGroupDTO {
    value?: GroupDTO[] | undefined;

    constructor(data?: IResultWithValueOfListOfGroupDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(GroupDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfGroupDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfGroupDTO extends IResult {
    value?: GroupDTO[] | undefined;
}

export class ResultWithValueOfListOfUserGroupDTO extends Result implements IResultWithValueOfListOfUserGroupDTO {
    value?: UserGroupDTO[] | undefined;

    constructor(data?: IResultWithValueOfListOfUserGroupDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(UserGroupDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfUserGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfUserGroupDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfUserGroupDTO extends IResult {
    value?: UserGroupDTO[] | undefined;
}

export class UserGroupDTO implements IUserGroupDTO {
    name?: string | undefined;
    plateQuota!: number;
    isPrimaryGroup!: boolean;

    constructor(data?: IUserGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.plateQuota = _data["plateQuota"];
            this.isPrimaryGroup = _data["isPrimaryGroup"];
        }
    }

    static fromJS(data: any): UserGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["plateQuota"] = this.plateQuota;
        data["isPrimaryGroup"] = this.isPrimaryGroup;
        return data;
    }
}

export interface IUserGroupDTO {
    name?: string | undefined;
    plateQuota: number;
    isPrimaryGroup: boolean;
}

export class ResultWithValueOfListOfImageNowDTO extends Result implements IResultWithValueOfListOfImageNowDTO {
    value?: ImageNowDTO[] | undefined;

    constructor(data?: IResultWithValueOfListOfImageNowDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ImageNowDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfImageNowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfImageNowDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfImageNowDTO extends IResult {
    value?: ImageNowDTO[] | undefined;
}

export class ImageNowDTO implements IImageNowDTO {
    imagingTaskId!: number;
    barcode?: string | undefined;
    imagingTask?: ImagingTaskDTO | undefined;

    constructor(data?: IImageNowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imagingTaskId = _data["imagingTaskId"];
            this.barcode = _data["barcode"];
            this.imagingTask = _data["imagingTask"] ? ImagingTaskDTO.fromJS(_data["imagingTask"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImageNowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImageNowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imagingTaskId"] = this.imagingTaskId;
        data["barcode"] = this.barcode;
        data["imagingTask"] = this.imagingTask ? this.imagingTask.toJSON() : undefined as any;
        return data;
    }
}

export interface IImageNowDTO {
    imagingTaskId: number;
    barcode?: string | undefined;
    imagingTask?: ImagingTaskDTO | undefined;
}

export class ResultWithValueOfListOfImageNowBarcodeDto extends Result implements IResultWithValueOfListOfImageNowBarcodeDto {
    value?: ImageNowBarcodeDto[] | undefined;

    constructor(data?: IResultWithValueOfListOfImageNowBarcodeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ImageNowBarcodeDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfImageNowBarcodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfImageNowBarcodeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfImageNowBarcodeDto extends IResult {
    value?: ImageNowBarcodeDto[] | undefined;
}

export class ImageNowBarcodeDto implements IImageNowBarcodeDto {
    imagingTaskId!: number;
    barcode?: string | undefined;

    constructor(data?: IImageNowBarcodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imagingTaskId = _data["imagingTaskId"];
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): ImageNowBarcodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageNowBarcodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imagingTaskId"] = this.imagingTaskId;
        data["barcode"] = this.barcode;
        return data;
    }
}

export interface IImageNowBarcodeDto {
    imagingTaskId: number;
    barcode?: string | undefined;
}

export class ImageNowTasksHandledRequestDto implements IImageNowTasksHandledRequestDto {
    taskIDs!: number[];

    constructor(data?: IImageNowTasksHandledRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.taskIDs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taskIDs"])) {
                this.taskIDs = [] as any;
                for (let item of _data["taskIDs"])
                    this.taskIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): ImageNowTasksHandledRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageNowTasksHandledRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIDs)) {
            data["taskIDs"] = [];
            for (let item of this.taskIDs)
                data["taskIDs"].push(item);
        }
        return data;
    }
}

export interface IImageNowTasksHandledRequestDto {
    taskIDs: number[];
}

export class ResultWithValueOfWellDropDTO extends Result implements IResultWithValueOfWellDropDTO {
    value?: WellDropDTO | undefined;

    constructor(data?: IResultWithValueOfWellDropDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? WellDropDTO.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultWithValueOfWellDropDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfWellDropDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfWellDropDTO extends IResult {
    value?: WellDropDTO | undefined;
}

export class WellDropDTO implements IWellDropDTO {
    wellNumber!: number;
    dropNumber!: number;

    constructor(data?: IWellDropDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
        }
    }

    static fromJS(data: any): WellDropDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellDropDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        return data;
    }
}

export interface IWellDropDTO {
    wellNumber: number;
    dropNumber: number;
}

export class SetDefaultCompositeThresholdRequestDTO implements ISetDefaultCompositeThresholdRequestDTO {
    robotID!: number;
    imageTypeID!: number;
    value!: number;

    constructor(data?: ISetDefaultCompositeThresholdRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robotID = _data["robotID"];
            this.imageTypeID = _data["imageTypeID"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SetDefaultCompositeThresholdRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultCompositeThresholdRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robotID"] = this.robotID;
        data["imageTypeID"] = this.imageTypeID;
        data["value"] = this.value;
        return data;
    }
}

export interface ISetDefaultCompositeThresholdRequestDTO {
    robotID: number;
    imageTypeID: number;
    value: number;
}

export class SetRobotRequestDTO implements ISetRobotRequestDTO {
    robotID!: number;
    name!: string;

    constructor(data?: ISetRobotRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robotID = _data["robotID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetRobotRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetRobotRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robotID"] = this.robotID;
        data["name"] = this.name;
        return data;
    }
}

export interface ISetRobotRequestDTO {
    robotID: number;
    name: string;
}

export class SetOriginalDefaultCompositeThresholdRequestDTO implements ISetOriginalDefaultCompositeThresholdRequestDTO {
    imageTypeID!: number;
    value!: number;

    constructor(data?: ISetOriginalDefaultCompositeThresholdRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageTypeID = _data["imageTypeID"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SetOriginalDefaultCompositeThresholdRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetOriginalDefaultCompositeThresholdRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageTypeID"] = this.imageTypeID;
        data["value"] = this.value;
        return data;
    }
}

export interface ISetOriginalDefaultCompositeThresholdRequestDTO {
    imageTypeID: number;
    value: number;
}

export class ResultWithValueOfDouble extends Result implements IResultWithValueOfDouble {
    value!: number;

    constructor(data?: IResultWithValueOfDouble) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResultWithValueOfDouble {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfDouble();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfDouble extends IResult {
    value: number;
}

export class ResultWithValueOfSingle extends Result implements IResultWithValueOfSingle {
    value!: number;

    constructor(data?: IResultWithValueOfSingle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResultWithValueOfSingle {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfSingle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfSingle extends IResult {
    value: number;
}

export class ResultWithValueOfEAutoScoreImageClass extends Result implements IResultWithValueOfEAutoScoreImageClass {
    value!: EAutoScoreImageClass2;

    constructor(data?: IResultWithValueOfEAutoScoreImageClass) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ResultWithValueOfEAutoScoreImageClass {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfEAutoScoreImageClass();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfEAutoScoreImageClass extends IResult {
    value: EAutoScoreImageClass2;
}

export enum EAutoScoreImageClass2 {
    NegativeHit = 0,
    PositiveHit = 1,
    Unknown = -1,
}

export class AutoScoreImageDataDTO implements IAutoScoreImageDataDTO {
    imageData!: { [key: string]: number; };
    imageType!: AutoScoreImageTypeDTO;
    imageSize!: string;
    imageSizeObj?: ImageSize | undefined;
    pixelSizeInMicrons!: number;
    imageDataVersion!: string;
    compositeThreshold!: number;

    constructor(data?: IAutoScoreImageDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.imageData = {};
            this.imageType = new AutoScoreImageTypeDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["imageData"]) {
                this.imageData = {} as any;
                for (let key in _data["imageData"]) {
                    if (_data["imageData"].hasOwnProperty(key))
                        (this.imageData as any)![key] = _data["imageData"][key];
                }
            }
            this.imageType = _data["imageType"] ? AutoScoreImageTypeDTO.fromJS(_data["imageType"]) : new AutoScoreImageTypeDTO();
            this.imageSize = _data["imageSize"];
            this.imageSizeObj = _data["imageSizeObj"] ? ImageSize.fromJS(_data["imageSizeObj"]) : undefined as any;
            this.pixelSizeInMicrons = _data["pixelSizeInMicrons"];
            this.imageDataVersion = _data["imageDataVersion"];
            this.compositeThreshold = _data["compositeThreshold"];
        }
    }

    static fromJS(data: any): AutoScoreImageDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AutoScoreImageDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.imageData) {
            data["imageData"] = {};
            for (let key in this.imageData) {
                if (this.imageData.hasOwnProperty(key))
                    (data["imageData"] as any)[key] = (this.imageData as any)[key];
            }
        }
        data["imageType"] = this.imageType ? this.imageType.toJSON() : undefined as any;
        data["imageSize"] = this.imageSize;
        data["imageSizeObj"] = this.imageSizeObj ? this.imageSizeObj.toJSON() : undefined as any;
        data["pixelSizeInMicrons"] = this.pixelSizeInMicrons;
        data["imageDataVersion"] = this.imageDataVersion;
        data["compositeThreshold"] = this.compositeThreshold;
        return data;
    }
}

export interface IAutoScoreImageDataDTO {
    imageData: { [key: string]: number; };
    imageType: AutoScoreImageTypeDTO;
    imageSize: string;
    imageSizeObj?: ImageSize | undefined;
    pixelSizeInMicrons: number;
    imageDataVersion: string;
    compositeThreshold: number;
}

export class ImageSize implements IImageSize {
    imgSize!: string;
    width!: number;
    height!: number;

    constructor(data?: IImageSize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imgSize = _data["imgSize"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): ImageSize {
        data = typeof data === 'object' ? data : {};
        let result = new ImageSize();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imgSize"] = this.imgSize;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IImageSize {
    imgSize: string;
    width: number;
    height: number;
}

export class ResultWithValueOfListOfAutoScoreImageTypeDTO extends Result implements IResultWithValueOfListOfAutoScoreImageTypeDTO {
    value?: AutoScoreImageTypeDTO[] | undefined;

    constructor(data?: IResultWithValueOfListOfAutoScoreImageTypeDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AutoScoreImageTypeDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfAutoScoreImageTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfAutoScoreImageTypeDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfAutoScoreImageTypeDTO extends IResult {
    value?: AutoScoreImageTypeDTO[] | undefined;
}

export class ImagingSettingDefinitionDTO implements IImagingSettingDefinitionDTO {
    robotID!: number;
    robotJson?: string | undefined;

    constructor(data?: IImagingSettingDefinitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robotID = _data["robotID"];
            this.robotJson = _data["robotJson"];
        }
    }

    static fromJS(data: any): ImagingSettingDefinitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingSettingDefinitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robotID"] = this.robotID;
        data["robotJson"] = this.robotJson;
        return data;
    }
}

export interface IImagingSettingDefinitionDTO {
    robotID: number;
    robotJson?: string | undefined;
}

export class FrapConfigDto implements IFrapConfigDto {
    robotID!: number;
    frapConfigJson!: string;

    constructor(data?: IFrapConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robotID = _data["robotID"];
            this.frapConfigJson = _data["frapConfigJson"];
        }
    }

    static fromJS(data: any): FrapConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrapConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robotID"] = this.robotID;
        data["frapConfigJson"] = this.frapConfigJson;
        return data;
    }
}

export interface IFrapConfigDto {
    robotID: number;
    frapConfigJson: string;
}

export class SetPlateStateAtImagerRequestDTO implements ISetPlateStateAtImagerRequestDTO {
    robotID!: number;
    barcode!: string;
    isAtImager!: boolean;

    constructor(data?: ISetPlateStateAtImagerRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robotID = _data["robotID"];
            this.barcode = _data["barcode"];
            this.isAtImager = _data["isAtImager"];
        }
    }

    static fromJS(data: any): SetPlateStateAtImagerRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPlateStateAtImagerRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robotID"] = this.robotID;
        data["barcode"] = this.barcode;
        data["isAtImager"] = this.isAtImager;
        return data;
    }
}

export interface ISetPlateStateAtImagerRequestDTO {
    robotID: number;
    barcode: string;
    isAtImager: boolean;
}

export class SetPlatesRequestDTO implements ISetPlatesRequestDTO {
    robotID!: number;
    plates!: PlateDTO[];

    constructor(data?: ISetPlatesRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.plates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.robotID = _data["robotID"];
            if (Array.isArray(_data["plates"])) {
                this.plates = [] as any;
                for (let item of _data["plates"])
                    this.plates!.push(PlateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetPlatesRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetPlatesRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["robotID"] = this.robotID;
        if (Array.isArray(this.plates)) {
            data["plates"] = [];
            for (let item of this.plates)
                data["plates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISetPlatesRequestDTO {
    robotID: number;
    plates: PlateDTO[];
}

export class PlateDTO implements IPlateDTO {
    barcode!: string;
    isAtImager!: boolean;

    constructor(data?: IPlateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.isAtImager = _data["isAtImager"];
        }
    }

    static fromJS(data: any): PlateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["isAtImager"] = this.isAtImager;
        return data;
    }
}

export interface IPlateDTO {
    barcode: string;
    isAtImager: boolean;
}

export class ResultWithValueOfListOfPlateTypeDTO extends Result implements IResultWithValueOfListOfPlateTypeDTO {
    value?: PlateTypeDTO2[] | undefined;

    constructor(data?: IResultWithValueOfListOfPlateTypeDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(PlateTypeDTO2.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfPlateTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfPlateTypeDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfPlateTypeDTO extends IResult {
    value?: PlateTypeDTO2[] | undefined;
}

export class PlateTypeDTO2 implements IPlateTypeDTO2 {
    id!: number;
    name?: string | undefined;
    numRows!: number;
    numColumns!: number;
    numDrops!: number;

    constructor(data?: IPlateTypeDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numRows = _data["numRows"];
            this.numColumns = _data["numColumns"];
            this.numDrops = _data["numDrops"];
        }
    }

    static fromJS(data: any): PlateTypeDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new PlateTypeDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numRows"] = this.numRows;
        data["numColumns"] = this.numColumns;
        data["numDrops"] = this.numDrops;
        return data;
    }
}

export interface IPlateTypeDTO2 {
    id: number;
    name?: string | undefined;
    numRows: number;
    numColumns: number;
    numDrops: number;
}

export class ResultWithValueOfPlateTypeDTO extends Result implements IResultWithValueOfPlateTypeDTO {
    value?: PlateTypeDTO2 | undefined;

    constructor(data?: IResultWithValueOfPlateTypeDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? PlateTypeDTO2.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultWithValueOfPlateTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfPlateTypeDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfPlateTypeDTO extends IResult {
    value?: PlateTypeDTO2 | undefined;
}

export class ResultWithValueOfPlateInfoDTO extends Result implements IResultWithValueOfPlateInfoDTO {
    value?: PlateInfoDTO2 | undefined;

    constructor(data?: IResultWithValueOfPlateInfoDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? PlateInfoDTO2.fromJS(_data["value"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ResultWithValueOfPlateInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfPlateInfoDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfPlateInfoDTO extends IResult {
    value?: PlateInfoDTO2 | undefined;
}

export class PlateInfoDTO2 implements IPlateInfoDTO2 {
    projectName?: string | undefined;
    experimentName?: string | undefined;
    userName?: string | undefined;
    plateNumber!: number;
    plateTypeID!: number;
    userEmail?: string | undefined;
    dateDispensed?: Date | undefined;

    constructor(data?: IPlateInfoDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.experimentName = _data["experimentName"];
            this.userName = _data["userName"];
            this.plateNumber = _data["plateNumber"];
            this.plateTypeID = _data["plateTypeID"];
            this.userEmail = _data["userEmail"];
            this.dateDispensed = _data["dateDispensed"] ? new Date(_data["dateDispensed"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PlateInfoDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new PlateInfoDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["experimentName"] = this.experimentName;
        data["userName"] = this.userName;
        data["plateNumber"] = this.plateNumber;
        data["plateTypeID"] = this.plateTypeID;
        data["userEmail"] = this.userEmail;
        data["dateDispensed"] = this.dateDispensed ? this.dateDispensed.toISOString() : undefined as any;
        return data;
    }
}

export interface IPlateInfoDTO2 {
    projectName?: string | undefined;
    experimentName?: string | undefined;
    userName?: string | undefined;
    plateNumber: number;
    plateTypeID: number;
    userEmail?: string | undefined;
    dateDispensed?: Date | undefined;
}

export class ResultWithValueOfListOfPlateInfoDTO extends Result implements IResultWithValueOfListOfPlateInfoDTO {
    value?: PlateInfoDTO2[] | undefined;

    constructor(data?: IResultWithValueOfListOfPlateInfoDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(PlateInfoDTO2.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfPlateInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfPlateInfoDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfPlateInfoDTO extends IResult {
    value?: PlateInfoDTO2[] | undefined;
}

export class ResultWithValueOfListOfLong extends Result implements IResultWithValueOfListOfLong {
    value?: number[] | undefined;

    constructor(data?: IResultWithValueOfListOfLong) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfLong();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfLong extends IResult {
    value?: number[] | undefined;
}

export class ResultWithValueOfListOfIncubationTemperatureDTO extends Result implements IResultWithValueOfListOfIncubationTemperatureDTO {
    value?: IncubationTemperatureDTO2[] | undefined;

    constructor(data?: IResultWithValueOfListOfIncubationTemperatureDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(IncubationTemperatureDTO2.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfIncubationTemperatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfIncubationTemperatureDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfIncubationTemperatureDTO extends IResult {
    value?: IncubationTemperatureDTO2[] | undefined;
}

export class IncubationTemperatureDTO2 implements IIncubationTemperatureDTO2 {
    id!: number;
    temperature!: number;

    constructor(data?: IIncubationTemperatureDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.temperature = _data["temperature"];
        }
    }

    static fromJS(data: any): IncubationTemperatureDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new IncubationTemperatureDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["temperature"] = this.temperature;
        return data;
    }
}

export interface IIncubationTemperatureDTO2 {
    id: number;
    temperature: number;
}

export class CreateExperimentRequestDTO implements ICreateExperimentRequestDTO {
    projectName!: string;
    folderName!: string;
    experimentName!: string;
    incubationTemperatureID!: number;
    setupTemperatureID!: number;
    containerId!: number;
    selectedDropsWells!: { [key: string]: number[]; };

    constructor(data?: ICreateExperimentRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.selectedDropsWells = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.folderName = _data["folderName"];
            this.experimentName = _data["experimentName"];
            this.incubationTemperatureID = _data["incubationTemperatureID"];
            this.setupTemperatureID = _data["setupTemperatureID"];
            this.containerId = _data["containerId"];
            if (_data["selectedDropsWells"]) {
                this.selectedDropsWells = {} as any;
                for (let key in _data["selectedDropsWells"]) {
                    if (_data["selectedDropsWells"].hasOwnProperty(key))
                        (this.selectedDropsWells as any)![key] = _data["selectedDropsWells"][key] !== undefined ? _data["selectedDropsWells"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): CreateExperimentRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExperimentRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["folderName"] = this.folderName;
        data["experimentName"] = this.experimentName;
        data["incubationTemperatureID"] = this.incubationTemperatureID;
        data["setupTemperatureID"] = this.setupTemperatureID;
        data["containerId"] = this.containerId;
        if (this.selectedDropsWells) {
            data["selectedDropsWells"] = {};
            for (let key in this.selectedDropsWells) {
                if (this.selectedDropsWells.hasOwnProperty(key))
                    (data["selectedDropsWells"] as any)[key] = (this.selectedDropsWells as any)[key];
            }
        }
        return data;
    }
}

export interface ICreateExperimentRequestDTO {
    projectName: string;
    folderName: string;
    experimentName: string;
    incubationTemperatureID: number;
    setupTemperatureID: number;
    containerId: number;
    selectedDropsWells: { [key: string]: number[]; };
}

export class ResultWithValueOfListOfScoreGroupDTO extends Result implements IResultWithValueOfListOfScoreGroupDTO {
    value?: ScoreGroupDTO[] | undefined;

    constructor(data?: IResultWithValueOfListOfScoreGroupDTO) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ScoreGroupDTO.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfScoreGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfScoreGroupDTO();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfScoreGroupDTO extends IResult {
    value?: ScoreGroupDTO[] | undefined;
}

export class ScoreGroupDTO implements IScoreGroupDTO {
    id!: number;
    name?: string | undefined;

    constructor(data?: IScoreGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ScoreGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IScoreGroupDTO {
    id: number;
    name?: string | undefined;
}

export class ResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle extends Result implements IResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle {
    value?: KeyValuePairOfAutoScoreImageTypeDTOAndSingle[] | undefined;

    constructor(data?: IResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(KeyValuePairOfAutoScoreImageTypeDTOAndSingle.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfKeyValuePairOfAutoScoreImageTypeDTOAndSingle extends IResult {
    value?: KeyValuePairOfAutoScoreImageTypeDTOAndSingle[] | undefined;
}

export class KeyValuePairOfAutoScoreImageTypeDTOAndSingle implements IKeyValuePairOfAutoScoreImageTypeDTOAndSingle {
    key?: AutoScoreImageTypeDTO | undefined;
    value!: number;

    constructor(data?: IKeyValuePairOfAutoScoreImageTypeDTOAndSingle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? AutoScoreImageTypeDTO.fromJS(_data["key"]) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfAutoScoreImageTypeDTOAndSingle {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfAutoScoreImageTypeDTOAndSingle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : undefined as any;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfAutoScoreImageTypeDTOAndSingle {
    key?: AutoScoreImageTypeDTO | undefined;
    value: number;
}

export class GetAutoScoreCompositeThresholdRequestDTO implements IGetAutoScoreCompositeThresholdRequestDTO {
    imageBatchID!: number;
    defaultCompositeThresholds!: KeyValuePairOfAutoScoreImageTypeDTOAndSingle[];

    constructor(data?: IGetAutoScoreCompositeThresholdRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.defaultCompositeThresholds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageBatchID = _data["imageBatchID"];
            if (Array.isArray(_data["defaultCompositeThresholds"])) {
                this.defaultCompositeThresholds = [] as any;
                for (let item of _data["defaultCompositeThresholds"])
                    this.defaultCompositeThresholds!.push(KeyValuePairOfAutoScoreImageTypeDTOAndSingle.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAutoScoreCompositeThresholdRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAutoScoreCompositeThresholdRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageBatchID"] = this.imageBatchID;
        if (Array.isArray(this.defaultCompositeThresholds)) {
            data["defaultCompositeThresholds"] = [];
            for (let item of this.defaultCompositeThresholds)
                data["defaultCompositeThresholds"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAutoScoreCompositeThresholdRequestDTO {
    imageBatchID: number;
    defaultCompositeThresholds: KeyValuePairOfAutoScoreImageTypeDTOAndSingle[];
}

export class SetScoreRequestDTO implements ISetScoreRequestDTO {
    plateID!: number;
    imageBatchID!: number;
    captureProfileID?: number | undefined;
    wellNumber!: number;
    dropNumber!: number;
    scoreGroupID!: number;
    scoreValue!: number;

    constructor(data?: ISetScoreRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plateID = _data["plateID"];
            this.imageBatchID = _data["imageBatchID"];
            this.captureProfileID = _data["captureProfileID"];
            this.wellNumber = _data["wellNumber"];
            this.dropNumber = _data["dropNumber"];
            this.scoreGroupID = _data["scoreGroupID"];
            this.scoreValue = _data["scoreValue"];
        }
    }

    static fromJS(data: any): SetScoreRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetScoreRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plateID"] = this.plateID;
        data["imageBatchID"] = this.imageBatchID;
        data["captureProfileID"] = this.captureProfileID;
        data["wellNumber"] = this.wellNumber;
        data["dropNumber"] = this.dropNumber;
        data["scoreGroupID"] = this.scoreGroupID;
        data["scoreValue"] = this.scoreValue;
        return data;
    }
}

export interface ISetScoreRequestDTO {
    plateID: number;
    imageBatchID: number;
    captureProfileID?: number | undefined;
    wellNumber: number;
    dropNumber: number;
    scoreGroupID: number;
    scoreValue: number;
}

export abstract class IResult implements IIResult {
    resultCode!: EResultCode;
    description!: string;

    constructor(data?: IIResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCode = _data["resultCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IResult {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCode"] = this.resultCode;
        data["description"] = this.description;
        return data;
    }
}

export interface IIResult {
    resultCode: EResultCode;
    description: string;
}

export class MarkAsDispensedRequestDto2 implements IMarkAsDispensedRequestDto2 {
    barcode?: string | undefined;

    constructor(data?: IMarkAsDispensedRequestDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): MarkAsDispensedRequestDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAsDispensedRequestDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        return data;
    }
}

export interface IMarkAsDispensedRequestDto2 {
    barcode?: string | undefined;
}

export class ResultWithValueOfListOfListOfString extends Result implements IResultWithValueOfListOfListOfString {
    value?: string[][] | undefined;

    constructor(data?: IResultWithValueOfListOfListOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static override fromJS(data: any): ResultWithValueOfListOfListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithValueOfListOfListOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultWithValueOfListOfListOfString extends IResult {
    value?: string[][] | undefined;
}

export class PaginatedIngredientStocksDTO implements IPaginatedIngredientStocksDTO {
    ingredients?: IngredientStocksDTO[] | undefined;
    totalData!: number;

    constructor(data?: IPaginatedIngredientStocksDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(IngredientStocksDTO.fromJS(item));
            }
            this.totalData = _data["totalData"];
        }
    }

    static fromJS(data: any): PaginatedIngredientStocksDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedIngredientStocksDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalData"] = this.totalData;
        return data;
    }
}

export interface IPaginatedIngredientStocksDTO {
    ingredients?: IngredientStocksDTO[] | undefined;
    totalData: number;
}

export class IngredientStocksDTO implements IIngredientStocksDTO {
    stockLocalId!: number;
    types?: string[] | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    aliases?: string[] | undefined;
    defaultLowConcentration!: number;
    defaultHighConcentration!: number;
    pH?: number | undefined;
    units?: string | undefined;
    casNumber?: string | undefined;

    constructor(data?: IIngredientStocksDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockLocalId = _data["stockLocalId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            if (Array.isArray(_data["aliases"])) {
                this.aliases = [] as any;
                for (let item of _data["aliases"])
                    this.aliases!.push(item);
            }
            this.defaultLowConcentration = _data["defaultLowConcentration"];
            this.defaultHighConcentration = _data["defaultHighConcentration"];
            this.pH = _data["pH"];
            this.units = _data["units"];
            this.casNumber = _data["casNumber"];
        }
    }

    static fromJS(data: any): IngredientStocksDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientStocksDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockLocalId"] = this.stockLocalId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        if (Array.isArray(this.aliases)) {
            data["aliases"] = [];
            for (let item of this.aliases)
                data["aliases"].push(item);
        }
        data["defaultLowConcentration"] = this.defaultLowConcentration;
        data["defaultHighConcentration"] = this.defaultHighConcentration;
        data["pH"] = this.pH;
        data["units"] = this.units;
        data["casNumber"] = this.casNumber;
        return data;
    }
}

export interface IIngredientStocksDTO {
    stockLocalId: number;
    types?: string[] | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    aliases?: string[] | undefined;
    defaultLowConcentration: number;
    defaultHighConcentration: number;
    pH?: number | undefined;
    units?: string | undefined;
    casNumber?: string | undefined;
}

export class PaginatedProteinFormulationsDTO implements IPaginatedProteinFormulationsDTO {
    proteinFormulations?: ProteinFormulationDTO2[] | undefined;
    totalData!: number;

    constructor(data?: IPaginatedProteinFormulationsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["proteinFormulations"])) {
                this.proteinFormulations = [] as any;
                for (let item of _data["proteinFormulations"])
                    this.proteinFormulations!.push(ProteinFormulationDTO2.fromJS(item));
            }
            this.totalData = _data["totalData"];
        }
    }

    static fromJS(data: any): PaginatedProteinFormulationsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedProteinFormulationsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.proteinFormulations)) {
            data["proteinFormulations"] = [];
            for (let item of this.proteinFormulations)
                data["proteinFormulations"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalData"] = this.totalData;
        return data;
    }
}

export interface IPaginatedProteinFormulationsDTO {
    proteinFormulations?: ProteinFormulationDTO2[] | undefined;
    totalData: number;
}

export class ProteinFormulationDTO2 implements IProteinFormulationDTO2 {
    proteinFormulationId!: number;
    proteinFormulationName?: string | undefined;
    proteinFormulationInfo?: ProteinFormulationInfoDTO2 | undefined;

    constructor(data?: IProteinFormulationDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.proteinFormulationName = _data["proteinFormulationName"];
            this.proteinFormulationInfo = _data["proteinFormulationInfo"] ? ProteinFormulationInfoDTO2.fromJS(_data["proteinFormulationInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProteinFormulationDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["proteinFormulationName"] = this.proteinFormulationName;
        data["proteinFormulationInfo"] = this.proteinFormulationInfo ? this.proteinFormulationInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IProteinFormulationDTO2 {
    proteinFormulationId: number;
    proteinFormulationName?: string | undefined;
    proteinFormulationInfo?: ProteinFormulationInfoDTO2 | undefined;
}

export class ProteinFormulationInfoDTO2 implements IProteinFormulationInfoDTO2 {
    datePrepared!: Date;
    class?: string | undefined;
    liquidClass?: string | undefined;
    proteinLotId?: string | undefined;
    extinctionCoefficient?: string | undefined;
    notebookPageNo?: string | undefined;
    notes?: string | undefined;
    volume?: number | undefined;
    storageTemperature?: number | undefined;

    constructor(data?: IProteinFormulationInfoDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datePrepared = _data["datePrepared"] ? new Date(_data["datePrepared"].toString()) : undefined as any;
            this.class = _data["class"];
            this.liquidClass = _data["liquidClass"];
            this.proteinLotId = _data["proteinLotId"];
            this.extinctionCoefficient = _data["extinctionCoefficient"];
            this.notebookPageNo = _data["notebookPageNo"];
            this.notes = _data["notes"];
            this.volume = _data["volume"];
            this.storageTemperature = _data["storageTemperature"];
        }
    }

    static fromJS(data: any): ProteinFormulationInfoDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProteinFormulationInfoDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datePrepared"] = this.datePrepared ? this.datePrepared.toISOString() : undefined as any;
        data["class"] = this.class;
        data["liquidClass"] = this.liquidClass;
        data["proteinLotId"] = this.proteinLotId;
        data["extinctionCoefficient"] = this.extinctionCoefficient;
        data["notebookPageNo"] = this.notebookPageNo;
        data["notes"] = this.notes;
        data["volume"] = this.volume;
        data["storageTemperature"] = this.storageTemperature;
        return data;
    }
}

export interface IProteinFormulationInfoDTO2 {
    datePrepared: Date;
    class?: string | undefined;
    liquidClass?: string | undefined;
    proteinLotId?: string | undefined;
    extinctionCoefficient?: string | undefined;
    notebookPageNo?: string | undefined;
    notes?: string | undefined;
    volume?: number | undefined;
    storageTemperature?: number | undefined;
}

export class PaginatedDropDetailsDTO implements IPaginatedDropDetailsDTO {
    dropDetails?: DropDetailsDTO[] | undefined;
    totalData!: number;

    constructor(data?: IPaginatedDropDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dropDetails"])) {
                this.dropDetails = [] as any;
                for (let item of _data["dropDetails"])
                    this.dropDetails!.push(DropDetailsDTO.fromJS(item));
            }
            this.totalData = _data["totalData"];
        }
    }

    static fromJS(data: any): PaginatedDropDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedDropDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dropDetails)) {
            data["dropDetails"] = [];
            for (let item of this.dropDetails)
                data["dropDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalData"] = this.totalData;
        return data;
    }
}

export interface IPaginatedDropDetailsDTO {
    dropDetails?: DropDetailsDTO[] | undefined;
    totalData: number;
}

export class DropDetailsDTO implements IDropDetailsDTO {
    dropId!: number;
    proteinFormulationId!: number;
    experimentId!: number;
    metadata?: string | undefined;
    imagingResult?: ImagingResultDTO[] | undefined;
    cocktail?: CocktailDTO[] | undefined;

    constructor(data?: IDropDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dropId = _data["dropId"];
            this.proteinFormulationId = _data["proteinFormulationId"];
            this.experimentId = _data["experimentId"];
            this.metadata = _data["metadata"];
            if (Array.isArray(_data["imagingResult"])) {
                this.imagingResult = [] as any;
                for (let item of _data["imagingResult"])
                    this.imagingResult!.push(ImagingResultDTO.fromJS(item));
            }
            if (Array.isArray(_data["cocktail"])) {
                this.cocktail = [] as any;
                for (let item of _data["cocktail"])
                    this.cocktail!.push(CocktailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DropDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DropDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dropId"] = this.dropId;
        data["proteinFormulationId"] = this.proteinFormulationId;
        data["experimentId"] = this.experimentId;
        data["metadata"] = this.metadata;
        if (Array.isArray(this.imagingResult)) {
            data["imagingResult"] = [];
            for (let item of this.imagingResult)
                data["imagingResult"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.cocktail)) {
            data["cocktail"] = [];
            for (let item of this.cocktail)
                data["cocktail"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDropDetailsDTO {
    dropId: number;
    proteinFormulationId: number;
    experimentId: number;
    metadata?: string | undefined;
    imagingResult?: ImagingResultDTO[] | undefined;
    cocktail?: CocktailDTO[] | undefined;
}

export class ImagingResultDTO implements IImagingResultDTO {
    timestamp?: string | undefined;
    autoScore!: number;
    autoScoreClass?: string | undefined;
    manualScore?: string | undefined;
    autoScoreModel?: string | undefined;

    constructor(data?: IImagingResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
            this.autoScore = _data["autoScore"];
            this.autoScoreClass = _data["autoScoreClass"];
            this.manualScore = _data["manualScore"];
            this.autoScoreModel = _data["autoScoreModel"];
        }
    }

    static fromJS(data: any): ImagingResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImagingResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        data["autoScore"] = this.autoScore;
        data["autoScoreClass"] = this.autoScoreClass;
        data["manualScore"] = this.manualScore;
        data["autoScoreModel"] = this.autoScoreModel;
        return data;
    }
}

export interface IImagingResultDTO {
    timestamp?: string | undefined;
    autoScore: number;
    autoScoreClass?: string | undefined;
    manualScore?: string | undefined;
    autoScoreModel?: string | undefined;
}

export class CocktailDTO implements ICocktailDTO {
    stockLocalId!: number;
    ingredientType?: string | undefined;
    ingredientName?: string | undefined;
    ingredientConcentration!: number;
    ingredientConcentrationUnit?: string | undefined;
    volume!: number;
    volumeUnit?: string | undefined;
    ph?: number | undefined;
    pka?: number | undefined;

    constructor(data?: ICocktailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockLocalId = _data["stockLocalId"];
            this.ingredientType = _data["ingredientType"];
            this.ingredientName = _data["ingredientName"];
            this.ingredientConcentration = _data["ingredientConcentration"];
            this.ingredientConcentrationUnit = _data["ingredientConcentrationUnit"];
            this.volume = _data["volume"];
            this.volumeUnit = _data["volumeUnit"];
            this.ph = _data["ph"];
            this.pka = _data["pka"];
        }
    }

    static fromJS(data: any): CocktailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CocktailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockLocalId"] = this.stockLocalId;
        data["ingredientType"] = this.ingredientType;
        data["ingredientName"] = this.ingredientName;
        data["ingredientConcentration"] = this.ingredientConcentration;
        data["ingredientConcentrationUnit"] = this.ingredientConcentrationUnit;
        data["volume"] = this.volume;
        data["volumeUnit"] = this.volumeUnit;
        data["ph"] = this.ph;
        data["pka"] = this.pka;
        return data;
    }
}

export interface ICocktailDTO {
    stockLocalId: number;
    ingredientType?: string | undefined;
    ingredientName?: string | undefined;
    ingredientConcentration: number;
    ingredientConcentrationUnit?: string | undefined;
    volume: number;
    volumeUnit?: string | undefined;
    ph?: number | undefined;
    pka?: number | undefined;
}

export class PaginatedExperimentInfoDTO implements IPaginatedExperimentInfoDTO {
    experiments?: ExperimentInfoDTO2[] | undefined;
    totalData!: number;

    constructor(data?: IPaginatedExperimentInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["experiments"])) {
                this.experiments = [] as any;
                for (let item of _data["experiments"])
                    this.experiments!.push(ExperimentInfoDTO2.fromJS(item));
            }
            this.totalData = _data["totalData"];
        }
    }

    static fromJS(data: any): PaginatedExperimentInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedExperimentInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.experiments)) {
            data["experiments"] = [];
            for (let item of this.experiments)
                data["experiments"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalData"] = this.totalData;
        return data;
    }
}

export interface IPaginatedExperimentInfoDTO {
    experiments?: ExperimentInfoDTO2[] | undefined;
    totalData: number;
}

export class ExperimentInfoDTO2 implements IExperimentInfoDTO2 {
    experimentId!: number;
    name?: string | undefined;
    path?: string | undefined;
    creationDate?: string | undefined;

    constructor(data?: IExperimentInfoDTO2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.creationDate = _data["creationDate"];
        }
    }

    static fromJS(data: any): ExperimentInfoDTO2 {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentInfoDTO2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["name"] = this.name;
        data["path"] = this.path;
        data["creationDate"] = this.creationDate;
        return data;
    }
}

export interface IExperimentInfoDTO2 {
    experimentId: number;
    name?: string | undefined;
    path?: string | undefined;
    creationDate?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}